(function ()
{
    'use strict';

    angular
        .module('app.settings.service.servicePack',
        [
            // 3rd Party Dependencies
            'datatables'
        ]
    )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {


        $stateProvider.state('app.settings.service.servicePack', {
            url    : '/servicePack'
        }).state('app.settings.service.servicePack.list', {
            url    : '/list',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/settings/service/servicePack/list.html',
                    controller : 'ServicePackController as vm'
                }
            }
        }).state('app.settings.service.servicePack.new', {
            url    : '/new',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/settings/service/servicePack/servicePack.html',
                    controller : 'ServicePackController as vm'
                }
            }
        }).state('app.settings.service.servicePack.edit', {
            url    : '/edit/:servicePackId',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/settings/service/servicePack/servicePack.html',
                    controller : 'ServicePackController as vm'
                }
            }

        });



        // Api
        //msApiProvider.register('tables.employees100', ['app/data/tables/employees100.json']);
    }

})();
(function () {
    'use strict';

    angular
        .module('app.settings.service.servicePack')
        .controller('ServicePackController', ServicePackController);

    /** @ngInject */
    function ServicePackController($state, $scope, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder, api,
        DTDefaultOptions, $translate, $mdDialog, $mdToast) {
        var vm = this;

        //check if is edit, insert or nothing
        var currentState = $state.current.name;
        //vm.saveServicePack = saveServicePack;



        //Initialize
        switch (currentState) {
            //lista de pacotes
            case "app.settings.service.servicePack.list":
                vm.showTable = false;
                vm.editServicePack = editServicePack;
                vm.removeServicePack = removeServicePack;
                              

                api.getServicePacks.save({},
                    function (response) {


                        vm.priceTables = response.d; 

                        setTimeout(function () {
                            vm.showTable = true;
                            $scope.$apply();
                        }, 200)

                    },
                    function (error) {
                        console.log(error);
                    });

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({ autoWidth: false })
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable": "Nenhum registro disponível",
                        "sInfo": "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty": "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered": "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix": "",
                        "sInfoThousands": ",",
                        "sLengthMenu": "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing": "Processando...",
                        "sSearch": "Busca:",
                        "sZeroRecords": "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst": "Primeiro",
                            "sLast": "Ultimo",
                            "sNext": "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending": ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });

                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                break;


            case "app.settings.service.servicePack.new":
                vm.saveServicePack = saveServicePack;
                vm.isServiceChecked = isServiceChecked;

                api.serviceServices.save({

                }, function (response) {
                    vm.services = response.d.services;
                    vm.serviceRows = {};
                    for (var i = 0; i < vm.services.length; i++) {
                        vm.serviceRows[vm.services[i]._id] = {};
                        vm.serviceRows[vm.services[i]._id].serviceId = vm.services[i]._id;  
                        vm.serviceRows[vm.services[i]._id].quantity = 1;
                        vm.serviceRows[vm.services[i]._id].comissionPrice = 0;
                        vm.serviceRows[vm.services[i]._id].enabled = false;
                    }

                })
                break;
            case "app.settings.service.servicePack.edit":
                vm.saveServicePack = saveServicePack;
                vm.isServiceChecked = isServiceChecked;

                api.getServicePack.save({
                    servicePackId: $state.params.servicePackId

                },
                    function (response) {
                        
                        vm.priceTable = response.d;  
                        console.log(response);  
                        if ("undefined" === typeof response.d.services) vm.servicesFromPack = []; //caso de um pacote sem serviço                  
                        else vm.servicesFromPack = response.d.services;

                        //dicionário pra acelerar as comparações seguintes
                        vm.dctServicesFromPack = [];
                        for (var i = 0; i <  vm.servicesFromPack.length; i++) {
                             vm.dctServicesFromPack[ vm.servicesFromPack[i].serviceId] =  vm.servicesFromPack[i];
                        }


                        api.serviceServices.save({

                        },
                            function (responseServices) {

                                vm.services = responseServices.d.services;
                                vm.serviceRows = {};
                                for (var i = 0; i < vm.services.length; i++) {

                                    //se o serviço está no pacote
                                    if ( vm.dctServicesFromPack[vm.services[i]._id] !== undefined) {

                                        vm.serviceRows[vm.services[i]._id] = {};
                                        vm.serviceRows[vm.services[i]._id].serviceId = vm.services[i]._id;  
                                        vm.serviceRows[vm.services[i]._id].quantity =  vm.dctServicesFromPack[vm.services[i]._id].quantity;
                                        vm.serviceRows[vm.services[i]._id].comissionPrice =  vm.dctServicesFromPack[vm.services[i]._id].comissionPrice;
                                        vm.serviceRows[vm.services[i]._id].enabled = true;

                                    }
                                    else {
                                        vm.serviceRows[vm.services[i]._id] = {};  
                                        vm.serviceRows[vm.services[i]._id].serviceId = vm.services[i]._id;                                     
                                        vm.serviceRows[vm.services[i]._id].quantity = 1;
                                        vm.serviceRows[vm.services[i]._id].comissionPrice = 0;
                                        vm.serviceRows[vm.services[i]._id].enabled = false;
                                    }


                                }

                            },
                            function (error) {
                                console.log(error);
                            })

                    },
                    function (error) {
                        console.log(error);
                    })


                break;
        }

        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({}, last);
        $scope.getToastPosition = function () {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function (pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };

        function sanitizePosition() {
            var current = $scope.toastPosition;
            if (current.bottom && last.top) current.top = false;
            if (current.top && last.bottom) current.bottom = false;
            if (current.right && last.left) current.left = false;
            if (current.left && last.right) current.right = false;
            last = angular.extend({}, current);
        }
        ///END TOAST

        // functions
        function saveServicePack() {

            vm.selectedServices = [];
                        
            for (var i = 0; i < vm.services.length; i++)
            {
                
                if (vm.serviceRows[vm.services[i]._id].enabled)
                {                    
                    vm.selectedServices.push(vm.serviceRows[vm.services[i]._id]);
                }
            }
            
            api.saveServicePack.save({
                _id: vm.priceTable._id,
                name: vm.priceTable.name,
                price: vm.priceTable.price,
                cashPrice: vm.priceTable.cashPrice,
                services: vm.selectedServices
            },
                function (response) {
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.SERVICE.SERVICE_PACK.TOAST.SAVE.SUCCESS"))
                            .position(pinTo)
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.go('app.settings.service.servicePack.list');
                    }, 1000);

                },
                function (error) {
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.SERVICE.SERVICE_PACK.TOAST.SAVE.ERROR"))
                            .position(pinTo)
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.go('app.settings.service.servicePack.list');
                    }, 1000);
                });
        }

        function editServicePack(servicePackId) {            
            $state.go('app.settings.service.servicePack.edit', { 'servicePackId': servicePackId });
        }

        function removeServicePack(servicePackId) {


            var confirm = $mdDialog.confirm()
                .title($translate.instant("SETTINGS.SERVICE.SERVICE_PACK.DIALOG.REMOVE.TITLE"))
                .textContent($translate.instant("SETTINGS.SERVICE.SERVICE_PACK.DIALOG.REMOVE.SUBTITLE"))
                .ariaLabel('Remove')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok($translate.instant("GENERAL.DIALOG.OK"))
                .cancel($translate.instant("GENERAL.DIALOG.CANCEL"));
            $mdDialog.show(confirm).then(function () {
                api.removeServicePack.save({
                    servicePackId: servicePackId
                },
                    function (response) {
                        if (response.s == 200) {
                            var pinTo = $scope.getToastPosition();
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent($translate.instant("SETTINGS.SERVICE.SERVICE_PACK.TOAST.REMOVE.SUCCESS"))
                                    .position(pinTo)
                                    .hideDelay(2000)
                            );
                            //redirect
                            setTimeout(function () {
                                $state.reload();
                            }, 1000);
                        } else {
                            var pinTo = $scope.getToastPosition();
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent($translate.instant("SETTINGS.SERVICE.SERVICE_PACK.TOAST.REMOVE.ERROR"))
                                    .position(pinTo)
                                    .hideDelay(2000)
                            );

                        }

                    },
                    function (error) {
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.SERVICE.PRICE_TABLE.TOAST.REMOVE.ERROR"))
                                .position(pinTo)
                                .hideDelay(1000)
                        );

                        //redirect
                        setTimeout(function () {
                            $state.reload();
                        }, 1000);

                    });
            });




        }

        //verifica se há alguma checkbox marcada
        function isServiceChecked()
        {
            if (typeof vm.services === 'undefined') return;
            for (var i = 0; i < vm.services.length; i++)
            {
               
                if (vm.serviceRows[vm.services[i]._id].enabled)
                {                                  
                    return false;
                }
            }
            
            return true;
        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.service.priceTable',
        [
            // 3rd Party Dependencies
            'datatables'
        ]
    )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {


        $stateProvider.state('app.settings.service.priceTable', {
            url    : '/priceTable'
        }).state('app.settings.service.priceTable.list', {
            url    : '/list',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/settings/service/priceTable/list.html',
                    controller : 'PriceTableController as vm'
                }
            }
        }).state('app.settings.service.priceTable.new', {
            url    : '/new',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/settings/service/priceTable/priceTable.html',
                    controller : 'PriceTableController as vm'
                }
            }
        }).state('app.settings.service.priceTable.edit', {
            url    : '/edit/:priceTableId',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/settings/service/priceTable/priceTable.html',
                    controller : 'PriceTableController as vm'
                }
            }
        });



        // Api
        //msApiProvider.register('tables.employees100', ['app/data/tables/employees100.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.service.priceTable')
        .controller('PriceTableController', PriceTableController);

    /** @ngInject */
    function PriceTableController($state, $scope,DTOptionsBuilder,DTColumnBuilder,DTColumnDefBuilder, api,
                                    DTDefaultOptions, $translate, $mdDialog, $mdToast)
    {
        var vm = this;

        //check if is edit, insert or nothing
        var currentState = $state.current.name;
        vm.savePriceTable = savePriceTable;


        //Initialize
        switch (currentState) {
            case "app.settings.service.priceTable.list":
                vm.showTable = false;
                vm.editPriceTable = editPriceTable;
                vm.duplicatePriceTable = duplicatePriceTable;

                api.priceTables.save({},
                    function(response){


                        vm.priceTables = response.d;

                        setTimeout(function(){
                            vm.showTable = true;
                            $scope.$apply();
                        },200)

                    },
                    function(error){
                        console.log(error);
                    });

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({autoWidth : false})
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable":     "Nenhum registro disponível",
                        "sInfo":           "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty":      "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered":   "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix":    "",
                        "sInfoThousands":  ",",
                        "sLengthMenu":     "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing":     "Processando...",
                        "sSearch":         "Busca:",
                        "sZeroRecords":    "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst":    "Primeiro",
                            "sLast":     "Ultimo",
                            "sNext":     "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending":  ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });
                //vm.dtColumnDefs = [
                //    DTColumnDefBuilder.newColumnDef(0).notSortable()
                //];
                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                break;
            case "app.settings.service.priceTable.new":
                vm.priceTable = {};
                vm.priceTable.types = [];
                vm.priceTable.types.push({"value":"PARTNER","text":"Parceria"})
                vm.priceTable.types.push({"value":"OFFER","text":"Promoções"})
                vm.priceTable.type = "PARTNER";

                api.serviceServices.save({

                }, function(response){
                    vm.services = response.d.services;
                    vm.serviceRows = {};
                    for(var i=0; i < vm.services.length; i++){
                        vm.serviceRows[vm.services[i]._id] = {};
                        vm.serviceRows[vm.services[i]._id].price = 0;
                        vm.serviceRows[vm.services[i]._id].cashPrice = 0;
                        vm.serviceRows[vm.services[i]._id].comissionPrice = 0;
                        vm.serviceRows[vm.services[i]._id].serviceId = vm.services[i]._id;
                        vm.serviceRows[vm.services[i]._id].serviceName = vm.services[i].name;
                    }

                })
                break;
            case "app.settings.service.priceTable.edit":
                vm.savePriceTable = savePriceTable;
                api.priceTable.save({
                        priceTableId:$state.params.priceTableId
                    },
                    function(response){
                        vm.priceTable = response.d;
                        vm.services = response.d.services;
                        vm.serviceRows = {};

                        console.log(vm.priceTable);

                        vm.priceTable.types = [];
                        if (vm.priceTable.isDefault){
                            vm.priceTable.types.push({"value":"DEFAULT","text":"Padrao"})
                        }

                        vm.priceTable.types.push({"value":"PARTNER","text":"Parceria"})
                        vm.priceTable.types.push({"value":"OFFER","text":"Promoções"})


                        api.serviceServices.save({

                            },
                            function(response){
                                vm.services = response.d.services;

                                for(var i=0; i < vm.services.length; i++) {

                                    vm.serviceRows[vm.services[i]._id] = {};
                                    vm.serviceRows[vm.services[i]._id].serviceId = vm.services[i]._id;
                                    vm.serviceRows[vm.services[i]._id].serviceName = vm.services[i].name;
                                    vm.serviceRows[vm.services[i]._id].price = 0;
                                    vm.serviceRows[vm.services[i]._id].cashPrice = 0;
                                    vm.serviceRows[vm.services[i]._id].comissionPrice = 0;

                                    for (var j = 0; j < vm.priceTable.items.length; j++) {
                                        if (vm.services[i]._id == vm.priceTable.items[j].serviceId) {
                                            vm.serviceRows[vm.services[i]._id].price = vm.priceTable.items[j].price;
                                            vm.serviceRows[vm.services[i]._id].cashPrice = vm.priceTable.items[j].cashPrice;
                                            vm.serviceRows[vm.services[i]._id].comissionPrice = vm.priceTable.items[j].comissionPrice;

                                            break;
                                        }
                                    }

                                }

                            },
                        function(error){
                            console.log(error);
                        })

                    },
                    function(error){
                        console.log(error);
                    })


                break;
        }

        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({},last);
        $scope.getToastPosition = function() {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function(pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if ( current.bottom && last.top ) current.top = false;
            if ( current.top && last.bottom ) current.bottom = false;
            if ( current.right && last.left ) current.left = false;
            if ( current.left && last.right ) current.right = false;
            last = angular.extend({},current);
        }
        ///END TOAST

        // functions
        function savePriceTable() {
            api.savePriceTable.save({
                    _id: vm.priceTable._id,
                    name: vm.priceTable.name,
                    items: vm.serviceRows
                },
                function(response) {
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.SERVICE.PRICE_TABLE.TOAST.SAVE.SUCCESS"))
                            .position(pinTo)
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.go('app.settings.service.priceTable.list');
                    }, 1000);

                },
                function(error) {
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.SERVICE.PRICE_TABLE.TOAST.SAVE.ERROR"))
                            .position(pinTo)
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.go('app.settings.service.priceTable.list');
                    }, 1000);
                });
        }

        vm.removePriceTable = function(priceTableId) {
            var confirm = $mdDialog.confirm()
                .title($translate.instant("SETTINGS.SERVICE.PRICE_TABLE.DIALOG.REMOVE.TITLE"))
                .textContent($translate.instant("SETTINGS.SERVICE.PRICE_TABLE.DIALOG.REMOVE.SUBTITLE"))
                .ariaLabel('Remove')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok($translate.instant("GENERAL.DIALOG.OK"))
                .cancel($translate.instant("GENERAL.DIALOG.CANCEL"));
            $mdDialog.show(confirm).then(function() {
                api.removePriceTable.save({
                        priceTableId: priceTableId
                    },
                    function(response){
                        if (response.s ==200){
                            var pinTo = $scope.getToastPosition();
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent($translate.instant("SETTINGS.SERVICE.PRICE_TABLE.TOAST.REMOVE.SUCCESS"))
                                    .position(pinTo )
                                    .hideDelay(2000)
                            );
                            //redirect
                            setTimeout(function(){
                                $state.reload();
                            }, 1000);
                        } else {
                            var pinTo = $scope.getToastPosition();
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent($translate.instant("SETTINGS.SERVICE.PRICE_TABLE.TOAST.REMOVE.ERROR"))
                                    .position(pinTo )
                                    .hideDelay(2000)
                            );

                        }

                    },
                    function(error){
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.SERVICE.PRICE_TABLE.TOAST.REMOVE.ERROR"))
                                .position(pinTo )
                                .hideDelay(1000)
                        );

                        //redirect
                        setTimeout(function(){
                            $state.reload();
                        }, 1000);

                    });
            });
        };

        function duplicatePriceTable(priceTableId,name) {
            api.duplicatePriceTable.save({
                    name:name,
                    priceTableId: priceTableId
                },
                function (response) {
                    if (response.s == 200) {
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.SERVICE.PRICE_TABLE.TOAST.COPY.SUCCESS"))
                                .position(pinTo)
                                .hideDelay(2000)
                        );
                        //redirect
                        setTimeout(function () {
                            $state.reload();
                        }, 1000);
                    } else {
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.SERVICE.PRICE_TABLE.TOAST.COPY.ERROR"))
                                .position(pinTo)
                                .hideDelay(2000)
                        );

                    }

                },
                function (error) {
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.SERVICE.PRICE_TABLE.TOAST.REMOVE.ERROR"))
                            .position(pinTo)
                            .hideDelay(1000)
                    );

                    //redirect
                    setTimeout(function () {
                        $state.reload();
                    }, 1000);

                });

        };

        function editPriceTable(priceTableId){
            $state.go('app.settings.service.priceTable.edit',{'priceTableId':priceTableId});
        }
        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.service.service',
            [
                // 3rd Party Dependencies
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {


        $stateProvider.state('app.settings.service.service', {
            url    : '/service'
        }).state('app.settings.service.service.list', {
            url    : '/list',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/settings/service/service/list.html',
                    controller : 'ServiceController as vm'
                }
            }
        }).state('app.settings.service.service.new', {
            url    : '/new/:wizard',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/settings/service/service/service.html',
                    controller : 'ServiceController as vm'
                }
            }
        }).state('app.settings.service.service.edit', {
            url    : '/edit/:serviceId',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/settings/service/service/service.html',
                    controller : 'ServiceController as vm'
                }
            }
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.service.service')
        .controller('ServiceController', ServiceController);

    /** @ngInject */
    function ServiceController($state, $scope,DTOptionsBuilder,DTColumnBuilder,api,
                               DTDefaultOptions, $translate, $mdDialog, $mdToast)
    {
        var vm = this;

        //check if is edit, insert or nothing
        var currentState = $state.current.name;

        //Initialize
        switch (currentState) {
            case "app.settings.service.service.list":
                vm.showTable = false;
                vm.editService = editService;
                vm.duplicateService = duplicateService;

                api.serviceServices.save({},
                    function(response){
                        var arTemp = response.d.services;
                        for(var i=0; i < arTemp.length; i++){
                            switch (arTemp[i].time){
                                case 15 :
                                    arTemp[i].timeStr = '15 minutos';
                                    break;
                                case 30 :
                                    arTemp[i].timeStr = '30 minutos';
                                    break;
                                case 45 :
                                    arTemp[i].timeStr = '45 minutos';
                                    break;
                                case 60 :
                                    arTemp[i].timeStr = '1 hora';
                                    break;
                                case 75 :
                                    arTemp[i].timeStr = '1 hora e 15 minutos';
                                    break;
                                case 90 :
                                    arTemp[i].timeStr = '1 hora e 30 minutos';
                                    break;
                                case 105 :
                                    arTemp[i].timeStr = '1 hora e 45 minutos';
                                    break;
                                case 120 :
                                    arTemp[i].timeStr = '2 horas';
                                    break;
                                case 135 :
                                    arTemp[i].timeStr = '2 horas e 15 minutos';
                                    break;
                                case 150 :
                                    arTemp[i].timeStr = '2 horas e 30 minutos';
                                    break;
                                case 165 :
                                    arTemp[i].timeStr = '2 horas e 45 minutos';
                                    break;
                                case 180 :
                                    arTemp[i].timeStr = '3 horas';
                                    break;
                                case 195 :
                                    arTemp[i].timeStr = '3 horas e 15 minutos';
                                    break;
                                case 210 :
                                    arTemp[i].timeStr = '3 horas e 30 minutos';
                                    break;
                                case 225 :
                                    arTemp[i].timeStr = '3 horas e 45 minutos';
                                    break;
                                case 240 :
                                    arTemp[i].timeStr = '4 horas';
                                    break;
                            }
                        }
                        vm.services = arTemp;
                        setTimeout(function(){
                            vm.showTable = true;
                            $scope.$apply();
                        },200)

                    },
                    function(error){
                        console.log(error);
                    });

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({autoWidth : false})
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable":     "Nenhum registro disponível",
                        "sInfo":           "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty":      "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered":   "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix":    "",
                        "sInfoThousands":  ",",
                        "sLengthMenu":     "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing":     "Processando...",
                        "sSearch":         "Busca:",
                        "sZeroRecords":    "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst":    "Primeiro",
                            "sLast":     "Ultimo",
                            "sNext":     "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending":  ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });

                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                break;
            case "app.settings.service.service.new":
                vm.saveService = saveService;
                vm.wizard = $state.params.wizard;
                vm.newCategory = newCategory;

                loadCategories(function(data){
                    vm.categories = data;
                });
                vm.service = {
                    order : 1,
                    showAtStylePlace : true,
                    price : 0,
                    cashPrice : 0,
                    comission : 0,
                    comissionPrice : 0,
                    internalPrice : 0,
                    costInsumo : 0,
                    time : 30,
                    vendamais : 'MAO',
                    return : 30,
                    loyaltyPointsEarned : 0
                }
                break;
            case "app.settings.service.service.edit":
                vm.saveService = saveService;
                loadCategories(function(data){
                    vm.categories = data;
                });
                loadService($state.params.serviceId, function(data){
                    vm.service = data;
                    if (data.enableOnMobile){
                        vm.service.showAtMobile = true;
                    } else {
                        vm.service.showAtMobile = false;
                    }
                    //console.log(data);

                })

                break;
        }

        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({},last);
        $scope.getToastPosition = function() {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function(pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if ( current.bottom && last.top ) current.top = false;
            if ( current.top && last.bottom ) current.bottom = false;
            if ( current.right && last.left ) current.left = false;
            if ( current.left && last.right ) current.right = false;
            last = angular.extend({},current);
        }
        ///END TOAST

        // Methods
        function loadCategories(callback){
            api.serviceCategories.save({},
                function(response){
                    callback(response.d);
                },
                function(error){
                    console.log(error);
                });
        }

        function loadService(serviceId, callback){
            api.serviceService.save({serviceId : serviceId},
                function(response){

                    callback(response.d);
                },
                function(error){
                    console.log(error);
                });
        }

        function saveService() {

            api.saveService.save({
                    serviceId: vm.service._id,
                    name: vm.service.name,
                    price: vm.service.price,
                    comissionPrice : vm.service.comissionPrice,
                    duration: parseInt(vm.service.duration),
                    cashPrice: vm.service.cashPrice,
                    order:vm.service.order,
                    'return':vm.service.return,
                    enableOnScheduleAPI : vm.service.showAtMobile,
                    mobileServiceName : vm.service.mobileServiceName,
                    fastCode : vm.service.fastCode,
                    loyaltyPoints: vm.service.loyaltyPoints,
                    loyaltyPointsEarned: vm.service.loyaltyPointsEarned,
                    categoryId:vm.service.categoryId,
                    vendaMais:vm.service.vendaMais,
                    costInsumo : vm.service.costInsumo
                },
                function(response){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.SERVICE.SERVICE.TOAST.SAVE.SUCCESS"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );

                    if (currentState == 'app.settings.service.service.new'){
                        //show form to add another
                        var confirm = $mdDialog.confirm()
                            .title('Confirmação')
                            .textContent('Deseja salvar outro serviço?')
                            .ariaLabel('Confirmação')
                            .clickOutsideToClose(true)
                            .multiple(true)
                            .ok('Sim')
                            .cancel('Não');
                        $mdDialog.show(confirm).then(function() {
                            $state.reload();
                        }, function() {
                            if (vm.wizard){
                                $state.go('app.wizard');
                            } else {
                                $state.go('app.settings.service.service.list');
                            }

                        });
                    } else {
                        if (vm.wizard){
                            $state.go('app.wizard');
                        } else {
                            $state.go('app.settings.service.service.list');
                        }
                    }




                },
                function(error){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.SERVICE.SERVICE.TOAST.SAVE.ERROR"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function(){
                        $state.go('app.settings.service.service.list');
                    }, 1000);
                });

        }

        vm.removeService = function(serviceId) {
            var confirm = $mdDialog.confirm()
                .title($translate.instant("SETTINGS.SERVICE.SERVICE.DIALOG.REMOVE.TITLE"))
                .textContent($translate.instant("SETTINGS.SERVICE.SERVICE.DIALOG.REMOVE.SUBTITLE"))
                .ariaLabel('Remove')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok($translate.instant("GENERAL.DIALOG.OK"))
                .cancel($translate.instant("GENERAL.DIALOG.CANCEL"));
            $mdDialog.show(confirm).then(function() {
                api.removeService.save({
                        serviceId: serviceId
                    },
                    function(response){
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.SERVICE.SERVICE.TOAST.REMOVE.SUCCESS"))
                                .position(pinTo )
                                .hideDelay(2000)
                        );
                        //redirect
                        setTimeout(function(){
                            $state.reload();
                        }, 1000);
                    },
                    function(error){
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.SERVICE.SERVICE.TOAST.REMOVE.ERROR"))
                                .position(pinTo )
                                .hideDelay(1000)
                        );

                        //redirect
                        setTimeout(function(){
                            $state.reload();
                        }, 1000);

                    });
            });
        };

        function newCategory(){
            $mdDialog.show({
                controller: 'CategoryController',
                controllerAs : 'vm',
                templateUrl: 'app/main/settings/service/category/categoryDialog.html',
                clickOutsideToClose:true,
                multiple:true,
                escapeToClose : true
            })
                .then(function(answer) {
                    loadCategories(function(data){
                        console.log(data);
                        vm.categories = data;
                    })
                }, function() {

                });
        }

        function editService(serviceId){
            $state.go('app.settings.service.service.edit',{serviceId : serviceId})
        }

        function duplicateService(serviceId){
            api.duplicateService.save({
                    serviceId: serviceId
                },
                function(response){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.SERVICE.SERVICE.TOAST.DUPLICATE.SUCCESS"))
                            .position(pinTo )
                            .hideDelay(2000)
                    );
                    //redirect
                    setTimeout(function(){
                        $state.reload();
                    }, 1000);
                },
                function(error){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.SERVICE.SERVICE.TOAST.DUPLICATE.ERROR"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );

                    //redirect
                    setTimeout(function(){
                        $state.reload();
                    }, 1000);

                });
        }
        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.product.category',
        [
            // 3rd Party Dependencies
            'datatables'
        ]
    )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {


        $stateProvider.state('app.settings.product.category', {
            url    : '/category'
        }).state('app.settings.product.category.list', {
            url    : '/list',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/settings/product/category/list.html',
                    controller : 'ProductCategoryController as vm'
                }
            }
        }).state('app.settings.product.category.new', {
            url    : '/new',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/settings/product/category/category.html',
                    controller : 'ProductCategoryController as vm'
                }
            }
        }).state('app.settings.product.category.edit', {
            url    : '/edit/:categoryId',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/settings/product/category/category.html',
                    controller : 'ProductCategoryController as vm'
                }
            }
        });


    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.product.category')
        .controller('ProductCategoryController', ProductCategoryController);

    /** @ngInject */
    function ProductCategoryController($state, $scope,DTOptionsBuilder,DTColumnBuilder,DTColumnDefBuilder, api,
                                    DTDefaultOptions, $translate, $mdDialog, $mdToast)
    {
        var vm = this;

        //check if is edit, insert or nothing
        var currentState = $state.current.name;

        //Initialize
        switch (currentState) {
            case "app.settings.product.category.list":
                vm.showTable = false;
                vm.editCategory = editCategory;

                api.productCategories.save({},
                    function(response){
                        var arCategories = [];
                        for(var i=0 ; i < response.d.length; i++){
                            var obj = response.d[i];
                            if (i == 0){
                                obj.first = true;
                            } else {
                                obj.first = false;
                            }
                            if (i == response.d.length-1){
                                obj.last = true;
                            } else {
                                obj.last = false;
                            }
                            arCategories.push(obj);
                        }

                        vm.categories = arCategories;

                        setTimeout(function(){
                            vm.showTable = true;
                            $scope.$apply();
                        },200)

                    },
                    function(error){
                        console.log(error);
                    });

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({autoWidth : false})
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable":     "Nenhum registro disponível",
                        "sInfo":           "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty":      "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered":   "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix":    "",
                        "sInfoThousands":  ",",
                        "sLengthMenu":     "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing":     "Processando...",
                        "sSearch":         "Busca:",
                        "sZeroRecords":    "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst":    "Primeiro",
                            "sLast":     "Ultimo",
                            "sNext":     "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending":  ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });

                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                break;
            case "app.settings.product.category.new":
                vm.category = {order : 50};
                vm.saveCategory = saveCategory;
                break;
            case "app.settings.product.category.edit":
                vm.saveCategory = saveCategory;
                api.productCategory.save({categoryId:$state.params.categoryId},
                    function(response){
                        vm.category = response.d;
                    },
                    function(error){
                        console.log(error);
                    });

                break;
        }

        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({},last);
        $scope.getToastPosition = function() {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function(pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if ( current.bottom && last.top ) current.top = false;
            if ( current.top && last.bottom ) current.bottom = false;
            if ( current.right && last.left ) current.left = false;
            if ( current.left && last.right ) current.right = false;
            last = angular.extend({},current);
        }
        ///END TOAST

        // functions
        function saveCategory() {
            api.saveProductCategory.save({
                    _id: vm.category._id,
                    name: vm.category.name
                },
                function(response){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.PRODUCT.CATEGORY.TOAST.SAVE.SUCCESS"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function(){
                        $state.go('app.settings.product.category.list');
                    }, 1000);
                },
                function(error){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.PRODUCT.CATEGORY.TOAST.SAVE.ERROR"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function(){
                        $state.go('app.settings.product.category.list');
                    }, 1000);
                });

        }

        vm.removeCategory = function(categoryId) {
            var confirm = $mdDialog.confirm()
                .title($translate.instant("SETTINGS.PRODUCT.CATEGORY.DIALOG.REMOVE.TITLE"))
                .textContent($translate.instant("SETTINGS.PRODUCT.CATEGORY.DIALOG.REMOVE.SUBTITLE"))
                .ariaLabel('Remove')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok($translate.instant("GENERAL.DIALOG.OK"))
                .cancel($translate.instant("GENERAL.DIALOG.CANCEL"));
            $mdDialog.show(confirm).then(function() {
                api.removeProductCategory.save({
                        categoryId: categoryId
                    },
                    function(response){
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.PRODUCT.CATEGORY.TOAST.REMOVE.SUCCESS"))
                                .position(pinTo )
                                .hideDelay(2000)
                        );
                        //redirect
                        setTimeout(function(){
                            $state.reload();
                        }, 1000);
                    },
                    function(error){
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.PRODUCT.CATEGORY.TOAST.REMOVE.ERROR"))
                                .position(pinTo )
                                .hideDelay(1000)
                        );

                        //redirect
                        setTimeout(function(){
                            $state.reload();
                        }, 1000);

                    });
            });
        };

        function editCategory(categoryId){
            $state.go('app.settings.product.category.edit',{'categoryId':categoryId});
        }
        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.service.category',
        [
            // 3rd Party Dependencies
            'datatables'
        ]
    )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {


        $stateProvider.state('app.settings.service.category', {
            url    : '/category'
        }).state('app.settings.service.category.list', {
            url    : '/list',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/settings/service/category/list.html',
                    controller : 'CategoryController as vm'
                }
            }
        }).state('app.settings.service.category.new', {
            url    : '/new',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/settings/service/category/category.html',
                    controller : 'CategoryController as vm'
                }
            }
        }).state('app.settings.service.category.edit', {
            url    : '/edit/:categoryId',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/settings/service/category/category.html',
                    controller : 'CategoryController as vm'
                }
            }
        });



        // Api
        //msApiProvider.register('tables.employees100', ['app/data/tables/employees100.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.service.category')
        .controller('CategoryController', CategoryController);

    /** @ngInject */
    function CategoryController($state, $scope,DTOptionsBuilder,DTColumnBuilder,DTColumnDefBuilder, api,
                                    DTDefaultOptions, $translate, $mdDialog, $mdToast)
    {
        var vm = this;

        //check if is edit, insert or nothing
        var currentState = $state.current.name;
        vm.saveCategory = saveCategory;
        vm.closeDialog = closeDialog;

        //Initialize
        switch (currentState) {
            case "app.settings.service.category.list":
                vm.showTable = false;
                vm.editCategory = editCategory;

                api.serviceCategories.save({},
                    function(response){
                        var arCategories = [];
                        for(var i=0 ; i < response.d.length; i++){
                            var obj = response.d[i];
                            if (i == 0){
                                obj.first = true;
                            } else {
                                obj.first = false;
                            }
                            if (i == response.d.length-1){
                                obj.last = true;
                            } else {
                                obj.last = false;
                            }
                            arCategories.push(obj);
                        }

                        vm.categories = arCategories;

                        setTimeout(function(){
                            vm.showTable = true;
                            $scope.$apply();
                        },200)

                    },
                    function(error){
                        console.log(error);
                    });

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({autoWidth : false})
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable":     "Nenhum registro disponível",
                        "sInfo":           "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty":      "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered":   "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix":    "",
                        "sInfoThousands":  ",",
                        "sLengthMenu":     "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing":     "Processando...",
                        "sSearch":         "Busca:",
                        "sZeroRecords":    "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst":    "Primeiro",
                            "sLast":     "Ultimo",
                            "sNext":     "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending":  ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });
                //vm.dtColumnDefs = [
                //    DTColumnDefBuilder.newColumnDef(0).notSortable()
                //];
                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                break;
            case "app.settings.service.category.new":
                vm.category = {order : 50, fixedCost : 0};

                break;
            case "app.settings.service.category.edit":
                vm.saveCategory = saveCategory;
                api.serviceCategory.save({categoryId:$state.params.categoryId},
                    function(response){
                        vm.category = response.d;
                    },
                    function(error){
                        console.log(error);
                    });

                break;
        }

        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({},last);
        $scope.getToastPosition = function() {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function(pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if ( current.bottom && last.top ) current.top = false;
            if ( current.top && last.bottom ) current.bottom = false;
            if ( current.right && last.left ) current.left = false;
            if ( current.left && last.right ) current.right = false;
            last = angular.extend({},current);
        }
        ///END TOAST

        // functions
        function saveCategory(close) {
            api.saveCategory.save({
                    _id: vm.category._id,
                    name: vm.category.name,
                    fixedCost : vm.category.fixedCost
                },
                function(response){
                    if (close){
                        $mdDialog.hide();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.SERVICE.CATEGORY.TOAST.SAVE.SUCCESS"))
                                .hideDelay(1000)
                        );
                        //redirect
                        setTimeout(function(){
                            $state.go('app.settings.service.category.list');
                        }, 1000);
                    }

                },
                function(error){
                    if (close){
                        $mdDialog.hide();
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.SERVICE.CATEGORY.TOAST.SAVE.ERROR"))
                                .hideDelay(1000)
                        );
                        //redirect
                        setTimeout(function(){
                            $state.go('app.settings.service.category.list');
                        }, 1000);
                    }

                });

        }

        vm.removeCategory = function(categoryId) {
            var confirm = $mdDialog.confirm()
                .title($translate.instant("SETTINGS.SERVICE.CATEGORY.DIALOG.REMOVE.TITLE"))
                .textContent($translate.instant("SETTINGS.SERVICE.CATEGORY.DIALOG.REMOVE.SUBTITLE"))
                .ariaLabel('Remove')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok($translate.instant("GENERAL.DIALOG.OK"))
                .cancel($translate.instant("GENERAL.DIALOG.CANCEL"));
            $mdDialog.show(confirm).then(function() {
                api.removeCategory.save({
                        categoryId: categoryId
                    },
                    function(response){
                        if (response.s ==200){
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent($translate.instant("SETTINGS.SERVICE.CATEGORY.TOAST.REMOVE.SUCCESS"))
                                    .hideDelay(2000)
                            );
                            //redirect
                            setTimeout(function(){
                                $state.reload();
                            }, 1000);
                        } else {
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent($translate.instant("SETTINGS.SERVICE.CATEGORY.TOAST.REMOVE.ERROR"))
                                    .hideDelay(2000)
                            );

                        }

                    },
                    function(error){
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.SERVICE.CATEGORY.TOAST.REMOVE.ERROR"))
                                .hideDelay(1000)
                        );

                        //redirect
                        setTimeout(function(){
                            $state.reload();
                        }, 1000);

                    });
            });
        };

        function closeDialog(){
            $mdDialog.cancel();
        }


        function editCategory(categoryId){
            $state.go('app.settings.service.category.edit',{'categoryId':categoryId});
        }
        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.product', ['app.settings.product.product', 'app.settings.product.category'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        //State
        $stateProvider
            .state('app.settings.product', {
                url    : '/product'
            });

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.product')
        .controller('ProductController', ProductController);

    /** @ngInject */
    function ProductController($state, $scope,DTOptionsBuilder,DTColumnBuilder,api,
                                    DTDefaultOptions, $translate, $mdDialog, $mdToast)
    {
        var vm = this;

        //check if is edit, insert or nothing
        var currentState = $state.current.name;

        //Initialize
        switch (currentState) {
            case "app.settings.product.product.list":
                vm.showTable = false;
                vm.editProduct = editProduct;

                api.productCategories.save({},
                    function(response){
                        var categories = response.d;
                        api.products.save({},
                            function(response){
                                var arTemp = [];

                                for(var i =0; i < response.d.length; i++){
                                    var obj = response.d[i];
                                    for(var j=0 ; j < categories.length; j++){
                                        if (categories[j]._id == obj.categoryId){
                                            obj.category = categories[j];
                                            break;
                                        }
                                    }
                                    arTemp.push(obj);

                                }

                                vm.products = arTemp;
                                setTimeout(function(){
                                    vm.showTable = true;
                                    $scope.$apply();
                                },200)

                            },
                            function(error){
                                console.log(error);
                            });
                    },
                    function(err){

                    }
                )


                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({autoWidth : false})
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable":     "Nenhum registro disponível",
                        "sInfo":           "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty":      "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered":   "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix":    "",
                        "sInfoThousands":  ",",
                        "sLengthMenu":     "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing":     "Processando...",
                        "sSearch":         "Busca:",
                        "sZeroRecords":    "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst":    "Primeiro",
                            "sLast":     "Ultimo",
                            "sNext":     "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending":  ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });

                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                break;
            case "app.settings.product.product.new":
                vm.saveProduct = saveProduct;

                vm.product = {
                    order : 50,
                    price : 0,
                    cost : 0,
                    minQty : 0,
                    maxQty : 0,
                    comission : 0
                }

                loadProductCategories(function(data){
                    vm.categories = data;
                })


                break;
            case "app.settings.product.product.edit":
                vm.saveProduct = saveProduct;

                loadProductCategories(function(data){
                    vm.categories = data;
                })

                loadProduct($state.params.productId, function(data){
                    vm.product = data;
                })

                break;
        }

        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({},last);
        $scope.getToastPosition = function() {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function(pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if ( current.bottom && last.top ) current.top = false;
            if ( current.top && last.bottom ) current.bottom = false;
            if ( current.right && last.left ) current.left = false;
            if ( current.left && last.right ) current.right = false;
            last = angular.extend({},current);
        }
        ///END TOAST

        // Methods


        function loadProduct(productId, callback){
            api.product.save({productId : productId},
                function(response){
                    callback(response.d);
                },
                function(error){
                    console.log(error);
                });
        }


        function loadProductCategories(callback){
            api.productCategories.save({},
                function(response){
                    callback(response.d);
                },
                function(error){
                    console.log(error);
                });
        }

        function saveProduct() {
            api.saveProduct.save({
                    productId: vm.product._id,
                    name: vm.product.name,
                    price: vm.product.price,
                    cost: vm.product.cost,
                    minQty: vm.product.minQty,
                    maxQty: vm.product.maxQty,
                    barCode : '',
                    comission : vm.product.comission,
                    comissionPrice : vm.product.comissionPrice,
                    cashPrice : vm.product.cashPrice,
                    categoryId:vm.product.categoryId
                },
                function(response){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.PRODUCT.PRODUCT.TOAST.SAVE.SUCCESS"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function(){
                        $state.go('app.settings.product.product.list');
                    }, 1000);
                },
                function(error){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.PRODUCT.PRODUCT.TOAST.SAVE.ERROR"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function(){
                        $state.go('app.settings.product.product.list');
                    }, 1000);
                });

        }

        vm.removeProduct = function(productId) {
            var confirm = $mdDialog.confirm()
                .title($translate.instant("SETTINGS.PRODUCT.PRODUCT.DIALOG.REMOVE.TITLE"))
                .textContent($translate.instant("SETTINGS.PRODUCT.PRODUCT.DIALOG.REMOVE.SUBTITLE"))
                .ariaLabel('Remove')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok($translate.instant("GENERAL.DIALOG.OK"))
                .cancel($translate.instant("GENERAL.DIALOG.CANCEL"));
            $mdDialog.show(confirm).then(function() {
                api.removeProduct.save({
                        productId: productId
                    },
                    function(response){
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.PRODUCT.PRODUCT.TOAST.REMOVE.SUCCESS"))
                                .position(pinTo )
                                .hideDelay(2000)
                        );
                        //redirect
                        setTimeout(function(){
                            $state.reload();
                        }, 1000);
                    },
                    function(error){
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.PRODUCT.PRODUCT.TOAST.REMOVE.ERROR"))
                                .position(pinTo )
                                .hideDelay(1000)
                        );

                        //redirect
                        setTimeout(function(){
                            $state.reload();
                        }, 1000);

                    });
            });
        };

        function editProduct(productId){
            $state.go('app.settings.product.product.edit',{productId : productId})
        }
        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.finance.category', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {

        $stateProvider
            .state('app.settings.finance.category', {
                url    : '/category'
            })
            .state('app.settings.finance.category.list', {
                url    : '/list',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/settings/finance/category/list.html',
                        controller : 'FinanceCategoryController as vm'
                    }
                }
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.finance.category')
        .controller('FinanceCategoryController', FinanceCategoryController);

    /** @ngInject */
    function FinanceCategoryController($state, $scope,DTOptionsBuilder,DTColumnBuilder,DTColumnDefBuilder, api,
                                    DTDefaultOptions, $translate, $mdDialog, $mdToast, $rootScope)
    {
        var vm = this;

        //check if is edit, insert or nothing
        var currentState = $state.current.name;

        //Initialize
        switch (currentState) {
            case "app.settings.finance.category.list":
                vm.showTable = false;
                //vm.removeUser = removeUser;
                //vm.editUser = editUser;

                api.financialCategories.save({},
                    function(response){

                        //console.log(response.d);

                        vm.categories = response.d;

                        setTimeout(function(){
                            vm.showTable = true;
                            $scope.$apply();
                        },200)

                    },
                    function(error){
                        console.log(error);
                    });

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({autoWidth : false})
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable":     "Nenhum registro disponível",
                        "sInfo":           "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty":      "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered":   "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix":    "",
                        "sInfoThousands":  ",",
                        "sLengthMenu":     "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing":     "Processando...",
                        "sSearch":         "Busca:",
                        "sZeroRecords":    "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst":    "Primeiro",
                            "sLast":     "Ultimo",
                            "sNext":     "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending":  ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });
                //vm.dtColumnDefs = [
                //    DTColumnDefBuilder.newColumnDef(0).notSortable()
                //];
                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                break;

        }

        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({},last);
        $scope.getToastPosition = function() {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function(pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if ( current.bottom && last.top ) current.top = false;
            if ( current.top && last.bottom ) current.bottom = false;
            if ( current.right && last.left ) current.left = false;
            if ( current.left && last.right ) current.right = false;
            last = angular.extend({},current);
        }
        ///END TOAST

        // functions

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.finance.partner', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {


        $stateProvider
            .state('app.settings.finance.partner', {
                url    : '/partner'
            })
            .state('app.settings.finance.partner.list', {
                url    : '/list',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/settings/finance/partner/list.html',
                        controller : 'PartnerController as vm'
                    }
                }
            })
            .state('app.settings.finance.partner.new', {
                url    : '/new',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/settings/finance/partner/partner.html',
                        controller : 'PartnerController as vm'
                    }
                }
            })
            .state('app.settings.finance.partner.edit', {
                url    : '/edit/:partnerId',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/settings/finance/partner/partner.html',
                        controller : 'PartnerController as vm'
                    }
                }
            });

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.finance.partner')
        .controller('PartnerController', PartnerController);

    /** @ngInject */
    function PartnerController($state, $scope,DTOptionsBuilder,DTColumnBuilder,DTColumnDefBuilder, api,
                                    DTDefaultOptions, $translate, $mdDialog, $mdToast, $rootScope)
    {
        var vm = this;

        //check if is edit, insert or nothing
        var currentState = $state.current.name;



        //Initialize
        switch (currentState) {
            case "app.settings.finance.partner.list":
                vm.showTable = false;
                vm.removePartner = removePartner;
                vm.editPartner = editPartner;

                api.partners.save({},
                    function (response) {

                        vm.showTable = true;

                        vm.partners = response.d;

                        if (vm.partners.length > 1) {
                            vm.allowRemove = true;
                        } else {
                            vm.allowRemove = false;
                        }


                        setTimeout(function () {
                            vm.showTable = true;
                            $scope.$apply();
                        }, 200)

                    },
                    function (error) {
                        console.log(error);
                    });

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({autoWidth: false})
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable": "Nenhum registro disponível",
                        "sInfo": "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty": "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered": "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix": "",
                        "sInfoThousands": ",",
                        "sLengthMenu": "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing": "Processando...",
                        "sSearch": "Busca:",
                        "sZeroRecords": "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst": "Primeiro",
                            "sLast": "Ultimo",
                            "sNext": "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending": ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });
                //vm.dtColumnDefs = [
                //    DTColumnDefBuilder.newColumnDef(0).notSortable()
                //];
                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                break;
            case "app.settings.finance.partner.new":
                vm.savePartner = savePartner;
                vm.partner = {};
                vm.partner.name = "";
                vm.partner.cpf = "";
                vm.partnerId = null;

                break;
            case "app.settings.finance.partner.edit":
                vm.savePartner = savePartner;
                vm.partnerId = $state.params.partnerId;

                api.partner.save({
                        partnerId: vm.partnerId
                    },
                    function (response) {

                        vm.partner = {};
                        vm.partner.name = response.d.PART_TX_NAME;
                        vm.partner.cpf = response.d.PART_TX_CPF;

                    },
                    function (error) {
                        console.log(error);
                    });


                break;

        }

        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({},last);
        $scope.getToastPosition = function() {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function(pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if ( current.bottom && last.top ) current.top = false;
            if ( current.top && last.bottom ) current.bottom = false;
            if ( current.right && last.left ) current.left = false;
            if ( current.left && last.right ) current.right = false;
            last = angular.extend({},current);
        }
        ///END TOAST

        // functions
        function removePartner(partnerId){
            var confirm = $mdDialog.confirm()
                .title("Deseja excluir o sócio?")
                .ariaLabel('Remove')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok($translate.instant("GENERAL.DIALOG.OK"))
                .cancel($translate.instant("GENERAL.DIALOG.CANCEL"));
            $mdDialog.show(confirm).then(function() {
                api.removePartner.save({
                        partnerId: partnerId
                    },
                    function(response){
                        if (response.s ==200){
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent("Sócio removido com sucesso")
                                    .hideDelay(2000)
                            );
                            //redirect
                            setTimeout(function(){
                                $state.reload();
                            }, 1000);
                        } else {
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent("Erro ao remover sócio.")
                                    .hideDelay(2000)
                            );

                        }

                    },
                    function(error){
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Erro ao remover sócio.")
                                .hideDelay(2000)
                        );


                        //redirect
                        setTimeout(function(){
                            $state.reload();
                        }, 1000);

                    });
            });
        }

        function editPartner(partnerId) {
            $state.go('app.settings.finance.partner.edit',{'partnerId':partnerId});
        }

        function savePartner() {

            api.savePartner.save({
                    partnerId : vm.partnerId,
                    partnerCpf : vm.partner.cpf,
                    name : vm.partner.name
                },
                function(response) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Sócio cadastrado com sucesso.")
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.go('app.settings.finance.partner.list');
                    }, 1000);


                },
                function(error) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Erro ao salvar sócio")
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.go('app.settings.finance.partner.list');
                    }, 1000);

                });

        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.finance.supplier', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {

        $stateProvider
            .state('app.settings.finance.supplier', {
                url    : '/supplier'
            })
            .state('app.settings.finance.supplier.list', {
                url    : '/list',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/settings/finance/supplier/list.html',
                        controller : 'SupplierController as vm'
                    }
                }
            })
            .state('app.settings.finance.supplier.new', {
                url    : '/new',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/settings/finance/supplier/supplier.html',
                        controller : 'SupplierController as vm'
                    }
                }
            })
            .state('app.settings.finance.supplier.edit', {
                url    : '/edit/:supplierId',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/settings/finance/supplier/supplier.html',
                        controller : 'SupplierController as vm'
                    }
                }
            });

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.finance.supplier')
        .controller('SupplierController', SupplierController);

    /** @ngInject */
    function SupplierController($state, $scope,DTOptionsBuilder,DTColumnBuilder,DTColumnDefBuilder, api,
                                    DTDefaultOptions, $translate, $mdDialog, $mdToast, $rootScope)
    {
        var vm = this;

        //check if is edit, insert or nothing
        var currentState = $state.current.name;



        //Initialize
        switch (currentState) {
            case "app.settings.finance.supplier.list":
                vm.showTable = false;
                vm.removeSupplier = removeSupplier;
                vm.editSupplier = editSupplier;

                api.suppliers.save({},
                    function (response) {


                        vm.showTable = true;

                        vm.suppliers = response.d;


                        if (vm.suppliers.length > 1) {
                            vm.allowRemove = true;
                        } else {
                            vm.allowRemove = false;
                        }


                        setTimeout(function () {
                            vm.showTable = true;
                            $scope.$apply();
                        }, 200)

                    },
                    function (error) {
                        console.log(error);
                    });

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({autoWidth: false})
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable": "Nenhum registro disponível",
                        "sInfo": "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty": "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered": "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix": "",
                        "sInfoThousands": ",",
                        "sLengthMenu": "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing": "Processando...",
                        "sSearch": "Busca:",
                        "sZeroRecords": "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst": "Primeiro",
                            "sLast": "Ultimo",
                            "sNext": "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending": ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });
                //vm.dtColumnDefs = [
                //    DTColumnDefBuilder.newColumnDef(0).notSortable()
                //];
                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                break;
            case "app.settings.finance.supplier.new":
                vm.saveSupplier = saveSupplier;
                vm.supplier = {};
                vm.supplier.name = "";
                vm.supplier.cnpj = "";
                vm.supplierId = null;

                break;
            case "app.settings.finance.supplier.edit":
                vm.saveSupplier = saveSupplier;
                vm.supplierId = $state.params.supplierId;

                api.supplier.save({
                        supplierId: vm.supplierId
                    },
                    function (response) {

                        vm.supplier = {};
                        vm.supplier.name = response.d.SUPP_TX_NAME;
                        vm.supplier.cnpj = response.d.SUPP_TX_CNPJ;

                    },
                    function (error) {
                        console.log(error);
                    });


                break;

        }

        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({},last);
        $scope.getToastPosition = function() {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function(pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if ( current.bottom && last.top ) current.top = false;
            if ( current.top && last.bottom ) current.bottom = false;
            if ( current.right && last.left ) current.left = false;
            if ( current.left && last.right ) current.right = false;
            last = angular.extend({},current);
        }
        ///END TOAST

        // functions
        function removeSupplier(supplierId){
            var confirm = $mdDialog.confirm()
                .title("Deseja excluir o fornecedor?")
                .ariaLabel('Remove')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok($translate.instant("GENERAL.DIALOG.OK"))
                .cancel($translate.instant("GENERAL.DIALOG.CANCEL"));
            $mdDialog.show(confirm).then(function() {
                api.removeSupplier.save({
                        supplierId: supplierId
                    },
                    function(response){
                        if (response.s ==200){
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent("Fornecedor removido com sucesso")
                                    .hideDelay(2000)
                            );
                            //redirect
                            setTimeout(function(){
                                $state.reload();
                            }, 1000);
                        } else {
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent("Erro ao remover fornecedor.")
                                    .hideDelay(2000)
                            );

                        }

                    },
                    function(error){
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Erro ao remover fornecedor.")
                                .hideDelay(2000)
                        );


                        //redirect
                        setTimeout(function(){
                            $state.reload();
                        }, 1000);

                    });
            });
        }

        function editSupplier(supplierId) {
            $state.go('app.settings.finance.supplier.edit',{'supplierId':supplierId});
        }

        function saveSupplier() {

            api.saveSupplier.save({
                    supplierId : vm.supplierId,
                    cnpj : vm.supplier.cnpj,
                    name : vm.supplier.name
                },
                function(response) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Fornecedor cadastrado com sucesso.")
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.go('app.settings.finance.supplier.list');
                    }, 1000);


                },
                function(error) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Erro ao salvar fornecedor")
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.go('app.settings.finance.supplier.list');
                    }, 1000);

                });

        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.finance.card', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {

        $stateProvider
            .state('app.settings.finance.card', {
                url    : '/card'
            })
            .state('app.settings.finance.card.list', {
                url    : '/list',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/settings/finance/card/list.html',
                        controller : 'CardController as vm'
                    }
                }
            })
            .state('app.settings.finance.card.edit', {
                url    : '/edit/:cardId',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/settings/finance/card/card.html',
                        controller : 'CardController as vm'
                    }
                }
            }).state('app.settings.finance.card.new', {
            url    : '/new',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/settings/finance/card/card.html',
                    controller : 'CardController as vm'
                }
            }
        });

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.finance.card')
        .controller('CardController', CardController);

    /** @ngInject */
    function CardController($state, $scope,DTOptionsBuilder,DTColumnBuilder,DTColumnDefBuilder, api,
                                    DTDefaultOptions, $translate, $mdDialog, $mdToast, $rootScope)
    {
        var vm = this;

        //check if is edit, insert or nothing
        var currentState = $state.current.name;

        //Initialize
        switch (currentState) {
            case "app.settings.finance.card.list":
                vm.showTable = false;
                vm.editCard = editCard;


                api.cards.save({},
                    function(response){

                        vm.cards = response.d;

                        setTimeout(function(){
                            vm.showTable = true;
                            $scope.$apply();
                        },200)

                    },
                    function(error){
                        console.log(error);
                    });

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({autoWidth : false})
                    .withDOM('<"top">rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable":     "Nenhum registro disponível",
                        "sInfo":           "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty":      "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered":   "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix":    "",
                        "sInfoThousands":  ",",
                        "sLengthMenu":     "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing":     "Processando...",
                        "sSearch":         "Busca:",
                        "sZeroRecords":    "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst":    "Primeiro",
                            "sLast":     "Ultimo",
                            "sNext":     "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending":  ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });
                //vm.dtColumnDefs = [
                //    DTColumnDefBuilder.newColumnDef(0).notSortable()
                //];
                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                break;

            case "app.settings.finance.card.edit":
                vm.saveCard = saveCard;
                vm.cardId = $state.params.cardId;

                api.bandeiras.save({
                }, function(response){
                    vm.bandeiras = response.d
                },
                function(error) {
                    console.log(error);
                });
                api.adquirentes2.save({

                }, function(response){
                    vm.adquirentes = response.d;
                }, function(error){
                    console.log(error);
                })

                api.bankAccounts.save({},
                    function(response){
                        vm.bankAccounts = response.d;

                        api.card.save({
                                cardId : vm.cardId
                            },
                            function(response){

                            console.log(response.d);

                                vm.card = {};
                                vm.card.bankAccountId = response.d.BAAC_CD_BANK_ACCOUNT;

                                if (response.d.PDVA_BL_ACTIVE == 1){
                                    vm.card.active = true;
                                } else {
                                    vm.card.active = false;
                                }

                                vm.card.adquirenteId = response.d.ADQU_CD_ADQUIRENTE;
                                vm.card.name = response.d.ADQU_TX_NAME;
                                vm.card.bandeiraId = response.d.BAND_CD_BANDEIRA;
                                vm.card.txCredito = response.d.PDVA_NR_CREDIT_TAX;
                                vm.card.txDebito = response.d.PDVA_NR_DEBIT_TAX;
                                vm.card.diasCredito = response.d.PDVA_NR_CREDIT_TIME;
                                vm.card.diasDebito = response.d.PDVA_NR_DEBIT_TIME;

                                if (vm.card.adquirenteId == 8){
                                    vm.allowEdit = false;
                                } else {
                                    vm.allowEdit = true;
                                }
                            },
                            function(error){
                                console.log(error);
                            });
                    },
                    function(error){
                        console.log(error);
                    });



                break;
            case "app.settings.finance.card.new":
                vm.saveCard = saveCard;
                vm.card = {};
                vm.card.txCredito = 0.01;
                vm.card.diasCredito = 0;
                vm.card.txDebito = 0.01;
                vm.card.diasDebito = 0;
                vm.card.active = true;

                api.bandeiras.save({


                    }, function(response){
                        vm.bandeiras = response.d
                        vm.card.bandeiraId = vm.bandeiras[0].BAND_CD_BANDEIRA
                    },
                    function(error) {
                        console.log(error);
                    });
                api.adquirentes2.save({

                }, function(response){
                    vm.adquirentes = response.d;


                    vm.card.adquirenteId = vm.adquirentes[0].ADQU_CD_ADQUIRENTE;
                }, function(error){
                    console.log(error);
                })

                api.bankAccounts.save({},
                    function(response){
                        vm.bankAccounts = response.d;
                        vm.card.bankAccountId = vm.bankAccounts[0].BAAC_CD_BANK_ACCOUNT
                    },
                    function(error){
                        console.log(error);
                    });



                break;

        }

        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({},last);
        $scope.getToastPosition = function() {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function(pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if ( current.bottom && last.top ) current.top = false;
            if ( current.top && last.bottom ) current.bottom = false;
            if ( current.right && last.left ) current.left = false;
            if ( current.left && last.right ) current.right = false;
            last = angular.extend({},current);
        }
        ///END TOAST

        // functions
        function editCard(cardId){
            $state.go('app.settings.finance.card.edit',{'cardId':cardId});
        }

        function saveCard(){
            api.saveCard.save({
                    bankAccountId : vm.card.bankAccountId,
                    credTax : vm.card.txCredito,
                    debTax : vm.card.txDebito,
                    debTime : vm.card.diasDebito,
                    bandeiraId : vm.card.bandeiraId,
                    credTime : vm.card.diasCredito,
                    active : vm.card.active,
                    adquirenteId : vm.card.adquirenteId,
                    cardId  :vm.cardId
                },
                function(response) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Cartão alterado com sucesso.")
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.go('app.settings.finance.card.list');
                    }, 1000);


                },
                function(error) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Erro ao salvar card")
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.go('app.settings.finance.card.list');
                    }, 1000);

                });
        }
    }



})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.finance.bankaccount', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {




        //State
        $stateProvider
            .state('app.settings.finance.bankaccount', {
                url    : '/bankaccount'
            })
            .state('app.settings.finance.bankaccount.list', {
            url    : '/list',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/settings/finance/bankaccount/list.html',
                    controller : 'BankAccountController as vm'
                }
            }
        })
            .state('app.settings.finance.bankaccount.new', {
            url    : '/new',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/settings/finance/bankaccount/bankaccount.html',
                    controller : 'BankAccountController as vm'
                }
            }
        })
            .state('app.settings.finance.bankaccount.edit', {
                url    : '/edit/:bankAccountId',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/settings/finance/bankaccount/bankaccount.html',
                        controller : 'BankAccountController as vm'
                    }
                }
            });

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.finance.bankaccount')
        .controller('BankAccountController', BankAccountController);

    /** @ngInject */
    function BankAccountController($state, $scope,DTOptionsBuilder,DTColumnBuilder,DTColumnDefBuilder, api,
                                    DTDefaultOptions, $translate, $mdDialog, $mdToast, $rootScope)
    {
        var vm = this;

        //check if is edit, insert or nothing
        var currentState = $state.current.name;

        //Initialize
        switch (currentState) {
            case "app.settings.finance.bankaccount.list":
                vm.showTable = false;
                vm.removeBankAccount = removeBankAccount;
                vm.editBankAccount = editBankAccount;

                api.bankAccounts.save({},
                    function(response){

                    vm.allowEdit = false;
                    if (response.d.length > 2){
                        vm.allowEdit = true;
                    } else {
                        vm.allowEdit = false;
                    }

                    vm.bankAccounts = response.d;

                        setTimeout(function(){
                            vm.showTable = true;
                            $scope.$apply();
                        },200)

                    },
                    function(error){
                        console.log(error);
                    });

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({autoWidth : false})
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable":     "Nenhum registro disponível",
                        "sInfo":           "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty":      "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered":   "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix":    "",
                        "sInfoThousands":  ",",
                        "sLengthMenu":     "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing":     "Processando...",
                        "sSearch":         "Busca:",
                        "sZeroRecords":    "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst":    "Primeiro",
                            "sLast":     "Ultimo",
                            "sNext":     "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending":  ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });
                //vm.dtColumnDefs = [
                //    DTColumnDefBuilder.newColumnDef(0).notSortable()
                //];
                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                break;

            case "app.settings.finance.bankaccount.new":
                vm.saveBankAccount = saveBankAccount;
                vm.bankaccount = {};
                vm.bankaccount.bankId = 1;
                vm.bankaccount.balance = 0;
                vm.bankaccountId = null;
                vm.allowEdit = true;

                api.banks.save({},
                    function(response){
                        vm.banks = [];
                        for(var i=0 ; i < response.d.length; i++){
                            if (response.d[i].BANK_CD_BANK > 0){
                                vm.banks.push(response.d[i]);
                            }
                        }
                    },
                    function(error){
                        console.log(error);
                    });

                break;
            case "app.settings.finance.bankaccount.edit":
                vm.saveBankAccount = saveBankAccount;
                vm.bankaccountId = $state.params.bankAccountId;

                api.banks.save({},
                    function(response){
                        vm.banks = response.d;

                        api.bankAccount.save({
                            bankAccountId : vm.bankaccountId
                            },
                            function(response){

                                vm.bankaccount = {};
                                vm.bankaccount.bankId = response.d.BANK_CD_BANK;
                                vm.bankaccount.agencia = response.d.BAAC_TX_AGENCIA;
                                vm.bankaccount.digitoAgencia = response.d.BAAC_TX_DIGITO_AGENCIA;
                                vm.bankaccount.contaCorrente = response.d.BAAC_TX_CONTA;
                                vm.bankaccount.digitoContaCorrente = response.d.BAAC_TX_DIGITO_CONTA;
                                vm.bankaccount.balance = response.d.BAAC_NR_INITIAL_BALANCE;

                                if (vm.bankaccount.bankId == 0){
                                    vm.allowEdit = false;
                                } else {
                                    vm.allowEdit = true;
                                }
                            },
                            function(error){
                                console.log(error);
                            });
                    },
                    function(error){
                        console.log(error);
                    });



                break;

        }

        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({},last);
        $scope.getToastPosition = function() {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function(pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if ( current.bottom && last.top ) current.top = false;
            if ( current.top && last.bottom ) current.bottom = false;
            if ( current.right && last.left ) current.left = false;
            if ( current.left && last.right ) current.right = false;
            last = angular.extend({},current);
        }
        ///END TOAST

        // functions

        function removeBankAccount(bankAccountId){
            var confirm = $mdDialog.confirm()
                .title("Deseja excluir a conta bancária?")
                .ariaLabel('Remove')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok($translate.instant("GENERAL.DIALOG.OK"))
                .cancel($translate.instant("GENERAL.DIALOG.CANCEL"));
            $mdDialog.show(confirm).then(function() {
                api.removeBankAccount.save({
                        bankAccountId: bankAccountId
                    },
                    function(response){
                        if (response.s ==200){
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent("Conta bancária removida com sucesso")
                                    .hideDelay(2000)
                            );
                            //redirect
                            setTimeout(function(){
                                $state.reload();
                            }, 1000);
                        } else {
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent("Erro ao remover conta bancária.")
                                    .hideDelay(2000)
                            );

                        }

                    },
                    function(error){
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Erro ao remover conta bancária.")
                                .hideDelay(2000)
                        );


                        //redirect
                        setTimeout(function(){
                            $state.reload();
                        }, 1000);

                    });
            });
        }

        function editBankAccount(bankAccountId) {
            $state.go('app.settings.finance.bankaccount.edit',{'bankAccountId':bankAccountId});
        }

        function saveBankAccount() {


            api.saveBankAccount.save({
                    bankAccountId : vm.bankaccountId,
                    bankId : vm.bankaccount.bankId,
                    agencia : vm.bankaccount.agencia,
                    digitoAgencia : vm.bankaccount.digitoAgencia,
                    contaCorrente : vm.bankaccount.contaCorrente,
                    digitoContaCorrente : vm.bankaccount.digitoContaCorrente,
                    balance : vm.bankaccount.balance

                },
                function(response) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Conta bancária cadastrada com sucesso.")
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.go('app.settings.finance.bankaccount.list');
                    }, 1000);


                },
                function(error) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Erro ao salvar conta bancária")
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.go('app.settings.finance.bankaccount.list');
                    }, 1000);

                });

        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.content.about', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider
            .state('app.settings.content.about', {
                url: '/about/:wizard',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/settings/content/about/about.html',
                        controller: 'ContentAboutController as vm'
                    }
                }
            })
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.content.about')
        .controller('ContentAboutController', ContentAboutController);

    /** @ngInject */
    function ContentAboutController($scope, $state, $mdDialog, $translate, api, $mdToast, $rootScope)
    {
        var vm = this;

        vm.saveApp = saveApp;

        //check if is edit, insert or nothing
        var currentState = $state.current.name;

        api.pdv.save({
            },
            function(response){
                var obj = response.d;
                vm.name = obj.name;
                vm.address = obj.address;
                vm.instagram = obj.instagram;
                vm.facebook = obj.facebook;
                vm.telephone1 = obj.telephone1;
                vm.telephone2 = obj.telephone2;
                vm.about = obj.about;

            },
            function(error){
                console.log(error);
            });



        function saveApp(){

            api.pdvSaveAbout.save({
                name : vm.name,
                address : vm.address,
                instagram : vm.instagram,
                facebook : vm.facebook,
                telephone1 : vm.telephone1 ,
                telephone2 : vm.telephone2 ,
                about:vm.about

            },
                function(response){
                    //Succes
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.CONTENT.ABOUT.TOAST.SAVE.SUCCESS"))
                            .hideDelay(1000)
                    );

                    if ($state.params.wizard){
                        $state.go('app.wizard');
                    }


                },
                function(error){
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.CONTENT.ABOUT.TOAST.SAVE.ERROR"))
                            .hideDelay(1000)
                    );
                });



        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.marketing.content.location', ['uiGmapgoogle-maps'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, uiGmapGoogleMapApiProvider) {

        //Google maps
        uiGmapGoogleMapApiProvider.configure({
            key: 'AIzaSyBvXlLeB8MZYU-teK1jDPGWPA_9BOwkBLM',
            v: '3.21', //defaults to latest 3.X anyhow
            libraries: 'drawing'
        });

        $stateProvider
            .state('app.marketing.content.location', {
                url: '/location',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/marketing/content/location/location.html',
                        controller: 'ContentLocationController as vm'
                    }
                }
            })
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.marketing.content.location')
        .controller('ContentLocationController', ContentLocationController);

    /** @ngInject */
    function ContentLocationController($scope, $translate, api, $mdToast, uiGmapGoogleMapApi, uiGmapIsReady)
    {
        var vm = this;

        vm.saveLocation = saveLocation;

        api.pdv.save({
            },
            function(response){
                var obj = response.d;
                vm.latitude = obj.latitude;
                vm.longitude = obj.longitude;
                vm.map = {};
                vm.map.markers = [];
                if ( (vm.latitude == 0) && (vm.longitude == 0) ){
                    vm.zoom = 2;
                } else{
                    vm.zoom = 17;
                }


                //set gogle maps
                uiGmapGoogleMapApi.then(function (maps)
                {
                    vm.map = {
                        center: {
                            latitude : vm.latitude,
                            longitude: vm.longitude
                        },
                        zoom  : vm.zoom,
                        pan: 1,
                        control: {},
                        events: {
                            click: function (map, eventName, originalEventArgs) {
                                var e = originalEventArgs[0];
                                var lat = e.latLng.lat(),lon = e.latLng.lng();
                                var marker = {
                                    id: Date.now(),
                                    coords: {
                                        latitude: lat,
                                        longitude: lon
                                    }
                                };

                                vm.latitude = lat;
                                vm.longitude = lon;

                                vm.map.marker = marker;

                                $scope.$apply();
                            }

                        }
                    };

                    vm.map.marker = {};
                    vm.map.marker.coords = {
                        latitude: vm.latitude,
                        longitude: vm.longitude
                    }
                    vm.map.marker.id = "1";

                });
            },
            function(error){
                console.log(error);
            });



        function saveLocation(){

            api.pdvSaveLocation.save({
                latitude : vm.latitude,
                longitude : vm.longitude
            },
                function(response){
                    //Succes
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.CONTENT.ABOUT.TOAST.SAVE.SUCCESS"))
                            .hideDelay(1000)
                    );

                    $state.reload();

                },
                function(error){
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.CONTENT.ABOUT.TOAST.SAVE.ERROR"))
                            .hideDelay(1000)
                    );
                });



        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.settings.account.user',
        [
            // 3rd Party Dependencies
            'datatables'
        ]
    )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {


        $stateProvider.state('app.settings.account.user', {
            url    : '/user'
        }).state('app.settings.account.user.list', {
            url    : '/list',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/settings/account/user/list.html',
                    controller : 'UserController as vm'
                }
            }
        }).state('app.settings.account.user.new', {
            url    : '/new',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/settings/account/user/user.html',
                    controller : 'UserController as vm'
                }
            }
        }).state('app.settings.account.user.invite', {
            url    : '/invite',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/settings/account/user/inviteUser.html',
                    controller : 'UserController as vm'
                }
            }
        }).state('app.settings.account.user.edit', {
            url    : '/edit/:userId',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/settings/account/user/editUser.html',
                    controller : 'UserController as vm'
                }
            }
        }).state('app.settings.account.user.changeMyInfo', {
            url    : '/changeMyInfo',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/settings/account/user/changeMyInfo.html',
                    controller : 'UserController as vm'
                }
            }
        });


    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.account.user')
        .controller('UserController', UserController);

    /** @ngInject */
    function UserController($state, $scope,DTOptionsBuilder,DTColumnBuilder,DTColumnDefBuilder, api,
                                    DTDefaultOptions, $translate, $mdDialog, $mdToast, $rootScope)
    {
        var vm = this;

        //check if is edit, insert or nothing
        var currentState = $state.current.name;



        vm.userExist = true;

        //Initialize
        switch (currentState) {
            case "app.settings.account.user.list":
                vm.showTable = false;
                vm.removeUser = removeUser;
                vm.editUser = editUser;

                api.users.save({},
                    function(response){
                        var arTemp =  response.d;

                        for(var i=0; i < arTemp.length;i++){
                            arTemp[i].typeStr = $translate.instant('GENERAL.USERTYPES.' + arTemp[i].type)
                        }
                        vm.users = arTemp;

                        setTimeout(function(){
                            vm.showTable = true;
                            $scope.$apply();
                        },200)

                    },
                    function(error){
                        console.log(error);
                    });

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({autoWidth : false})
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable":     "Nenhum registro disponível",
                        "sInfo":           "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty":      "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered":   "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix":    "",
                        "sInfoThousands":  ",",
                        "sLengthMenu":     "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing":     "Processando...",
                        "sSearch":         "Busca:",
                        "sZeroRecords":    "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst":    "Primeiro",
                            "sLast":     "Ultimo",
                            "sNext":     "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending":  ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });
                //vm.dtColumnDefs = [
                //    DTColumnDefBuilder.newColumnDef(0).notSortable()
                //];
                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                break;
            case "app.settings.account.user.new":
                vm.user = {password: ''};
                vm.saveUser = saveUser;
                vm.checkUserName = checkUserName;
                api.serviceProfessionals.save({
                    },
                    function(response){
                        vm.professionals = response.d;
                    },
                    function(error){
                        console.log(error);
                    });

                break;
            case "app.settings.account.user.edit":
                vm.saveUser = saveEditUser;
                api.serviceProfessionals.save({
                    },
                    function(response){
                        vm.professionals = response.d;
                    },
                    function(error){
                        console.log(error);
                    });
                api.user.save({userId:$state.params.userId},
                    function(response){
                        vm.user = response.d;
                    },
                    function(error){
                        console.log(error);
                    });

                break;
            case "app.settings.account.user.changeMyInfo":
                vm.changeMyInfo = changeMyInfo;
                vm.user = {};
                vm.user.name = $rootScope.userName;

                break;
        }

        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({},last);
        $scope.getToastPosition = function() {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function(pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if ( current.bottom && last.top ) current.top = false;
            if ( current.top && last.bottom ) current.bottom = false;
            if ( current.right && last.left ) current.left = false;
            if ( current.left && last.right ) current.right = false;
            last = angular.extend({},current);
        }
        ///END TOAST

        // functions
        function changeMyInfo(){
            api.changeMyInfo.save(
                {
                    name : vm.user.name,
                    password:vm.user.password
                },
                function(response){
                    //toast and transfer
                    if (response.s == 200){
                        $rootScope.userName = vm.user.name;
                        $rootScope.changeUserName(vm.user.name);

                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.ACCOUNT.CHANGEPASSWORD.TOAST.SAVE.SUCCESS"))
                                .hideDelay(1000)
                        );


                        //redirect
                        setTimeout(function(){
                            $state.go('app.settings.account.user.list');
                        }, 1000);

                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.ACCOUNT.CHANGEPASSWORD.TOAST.SAVE.ERROR"))
                                .hideDelay(1000)
                        );
                    }
                },
                function(error){
                    console.log(error);
                });
        }

        function checkUserName(){
            api.userByLogin.save({login:vm.user.login},
                function(response){

                    if (response.d != null){
                        vm.saveUser = saveEditUser;
                        vm.user._id = response.d.userId
                        vm.user.name = response.d.userName;
                    } else {
                        vm.userExist = false;
                    }
                },
                function(error){
                    console.log(error);
                });
        }

        function saveUser() {

            api.signup2.save({
                    id: vm.user._id,
                    email: vm.user.login,
                    password : vm.user.password,
                    type : vm.user.type,
                    accessCode : vm.user.accessCode,
                    name : vm.user.name,
                    professionalId : vm.user.professionalId
                },
                function(response){

                    if (response.s == 200){
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.ACCOUNT.USER.TOAST.SAVE.SUCCESS"))
                                .hideDelay(1000)
                        );


                        //redirect
                        setTimeout(function(){
                            $state.go('app.settings.account.user.list');
                        }, 1000);

                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.ACCOUNT.USER.TOAST.SAVE.ERROR_WRONGEMAIL"))
                                .hideDelay(1000)
                        );
                    }

                },
                function(error){
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.ACCOUNT.USER.TOAST.SAVE.ERROR"))
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function(){
                        $state.go('app.settings.account.user.list');
                    }, 1000);
                });

        }

        function saveEditUser() {

            api.editUserPDVRelation.save({
                    userId: vm.user._id,
                    email: vm.user.login,
                    password : vm.user.password,
                    type : vm.user.type,
                    accessCode : vm.user.accessCode,
                    name : vm.user.name,
                    professionalId : vm.user.professionalId
                },
                function(response){
                    if (response.s == 200){
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.ACCOUNT.USER.TOAST.SAVE.SUCCESS"))
                                .hideDelay(1000)
                        );


                        //redirect
                        setTimeout(function(){
                            $state.go('app.settings.account.user.list');
                        }, 1000);

                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.ACCOUNT.USER.TOAST.SAVE.ERROR_WRONGEMAIL"))
                                .hideDelay(1000)
                        );
                    }

                },
                function(error){
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.ACCOUNT.USER.TOAST.SAVE.ERROR"))
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function(){
                        $state.go('app.settings.account.user.list');
                    }, 1000);
                });

        }

        function editUser(userId){
            $state.go('app.settings.account.user.edit', {userId:userId});
        }

        function removeUser (userId) {
            var confirm = $mdDialog.confirm()
                .title($translate.instant("SETTINGS.ACCOUNT.USER.DIALOG.REMOVE.TITLE"))
                .textContent($translate.instant("SETTINGS.ACCOUNT.USER.DIALOG.REMOVE.SUBTITLE"))
                .ariaLabel('Remove')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok($translate.instant("GENERAL.DIALOG.OK"))
                .cancel($translate.instant("GENERAL.DIALOG.CANCEL"));
            $mdDialog.show(confirm).then(function() {
                api.removeUserPDVRelation.save({
                        userId: userId
                    },
                    function(response){
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.ACCOUNT.USER.TOAST.REMOVE.SUCCESS"))
                                .hideDelay(2000)
                        );
                        //redirect
                        setTimeout(function(){
                            $state.reload();
                        }, 1000);
                    },
                    function(error){
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.ACCOUNT.USER.TOAST.REMOVE.ERROR"))
                                .hideDelay(1000)
                        );

                        //redirect
                        setTimeout(function(){
                            $state.reload();
                        }, 1000);

                    });
            });
        };
        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.content.photo', ['ngFileUpload'])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider
            .state('app.settings.content.photo', {
                url: '/photo'
            })
            .state('app.settings.content.photo.list', {
                url: '/list',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/settings/content/photo/list.html',
                        controller: 'ContentPhotoController as vm'
                    }
                }
            })
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.content.photo')
        .controller('ContentPhotoController', ContentPhotoController);

    /** @ngInject */
    function ContentPhotoController($scope, $state, $mdDialog, $translate, api, $mdToast, Upload)
    {
        var vm = this;

        vm.removePhoto = removePhoto;

        var currentState = $state.current.name;

        //se for uma lista deve carregar photos anteriores
        if (currentState == 'app.settings.content.photo.list'){
            api.pdv.save({
                },
                function(response){
                    vm.photos = response.d.slideImages;
                    var deleteTranslated = $translate.instant('')

                    var html = "<table style='width: 100%'>";
                    var tmp = 0;

                    for(var i=0; i < vm.photos.length; i++){
                        if(tmp == 0){
                            html = html + "<tr>"
                        }

                        html = html + "<td style='padding:20px'>"
                        html = html + "<img style='width:200px;height:100px' src='" +  vm.photos[i]  + "'><br>";
                        html = html + '<md-button ng-click="vm.removePhoto(\'' + vm.photos[i] + '\')" aria-label="Trash" class="md-raised md-warn gp-mini" ><md-tooltip aria-label="Pencil">{{ "GENERAL.HINTS.TRASH" | translate }}</md-tooltip><i class="icon-trash" layout="center"></i></md-button>';
                        html = html + "</td>"

                        if(tmp == 5){
                            html = html + "</tr>"
                            tmp = 0;
                        } else {
                            tmp = tmp + 1;
                        }
                    }

                    html = html + "</table>";

                    vm.html = html;


                },
                function(error){
                    console.log(error);
                });

            $scope.$watch('vm.image', function(oldData, newData){
                if (vm.image != undefined){
                    Upload.base64DataUrl(vm.image).then(function (imageData) {
                        var obj = {};
                        obj.image = imageData;

                        api.pdvSavePhoto.save({
                                image: imageData
                            },
                            function (response) {
                                //Succes
                                $mdToast.show(
                                    $mdToast.simple()
                                        .textContent($translate.instant("MARKETING.CONTENT.PHOTOS.TOAST.SAVE.SUCCESS"))
                                        .hideDelay(2000)
                                );
                                //redirect
                                setTimeout(function(){
                                    $state.reload();
                                }, 1000);

                            },
                            function (error) {
                                //Succes
                                $mdToast.show(
                                    $mdToast.simple()
                                        .textContent($translate.instant("MARKETING.CONTENT.PHOTOS.TOAST.SAVE.SUCCESS"))
                                        .hideDelay(2000)
                                );
                                //redirect
                                setTimeout(function(){
                                    $state.reload();
                                }, 1000);
                            });


                    });
                }

            })

        }

        function removePhoto(imageURL) {

            api.pdvRemovePhoto.save({
                    imageURL: imageURL
                },
                function (response) {
                    //Succes
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.CONTENT.PHOTOS.TOAST.REMOVE.SUCCESS"))
                            .hideDelay(1000)
                    );

                    //redirect
                    setTimeout(function(){
                        $state.reload();
                    }, 1000);

                },
                function (error) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.CONTENT.PHOTOS.TOAST.REMOVE.ERROR"))
                            .hideDelay(1000)
                    );

                    //redirect
                    setTimeout(function(){
                        $state.reload();
                    }, 1000);
                });

        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.settings.account.businessinfo', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {



        //State
        $stateProvider
            .state('app.settings.account.businessinfo', {
                url    : '/businessinfo'
            }).state('app.settings.account.businessinfo.businesshours', {
                url    : '/businesshours',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/settings/account/businessinfo/businesshours.html',
                        controller : 'BusinessInfoController as vm'
                    }
                }
            });

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.account.businessinfo')
        .controller('BusinessInfoController', BusinessInfoController);

    /** @ngInject */
    function BusinessInfoController($state, $scope,api,$translate, $mdDialog, $mdToast)
    {
        var vm = this;

        //check if is edit, insert or nothing
        var currentState = $state.current.name;

        //Initialize
        switch (currentState) {
            case "app.settings.account.businessinfo.businesshours":
                vm.saveBusinessHours = saveBusinessHours;
                vm.timetable = [];
                for(var i=0 ;i < 1440; i = i + 30){
                    var obj = {};
                    obj.value = i;
                    var hour = "";
                    hour = parseInt(i/60);
                    if (hour < 10){
                        hour = "0" + hour;
                    }
                    var minutes = "";
                    minutes = i - (parseInt(i/60)*60);
                    if (minutes < 10){
                        minutes = "0" + minutes;
                    }

                    obj.text = hour + ":" + minutes;

                    vm.timetable.push(obj);
                }

                api.businessHours.save({},
                    function(response){
                        console.log(response.d);
                        var obj = response.d;

                        vm.businessinfo.openMonday = obj.openMonday;
                        vm.businessinfo.openTuesday = obj.openTuesday;
                        vm.businessinfo.openWednesday = obj.openWednesday;
                        vm.businessinfo.openThursday = obj.openThursday;
                        vm.businessinfo.openFriday = obj.openFriday;
                        vm.businessinfo.openSaturday = obj.openSaturday;
                        vm.businessinfo.openSunday = obj.openSunday;

                        vm.businessinfo.openTimeMonday = obj.openTimeMonday;
                        vm.businessinfo.openTimeTuesday = obj.openTimeTuesday;
                        vm.businessinfo.openTimeWednesday = obj.openTimeWednesday;
                        vm.businessinfo.openTimeThursday = obj.openTimeThursday;
                        vm.businessinfo.openTimeFriday = obj.openTimeFriday;
                        vm.businessinfo.openTimeSaturday = obj.openTimeSaturday;
                        vm.businessinfo.openTimeSunday = obj.openTimeSunday;

                        vm.businessinfo.closeTimeMonday = obj.closeTimeMonday;
                        vm.businessinfo.closeTimeTuesday = obj.closeTimeTuesday;
                        vm.businessinfo.closeTimeWednesday = obj.closeTimeWednesday;
                        vm.businessinfo.closeTimeThursday = obj.closeTimeThursday;
                        vm.businessinfo.closeTimeFriday = obj.closeTimeFriday;
                        vm.businessinfo.closeTimeSaturday = obj.closeTimeSaturday;
                        vm.businessinfo.closeTimeSunday = obj.closeTimeSunday;


                    },
                    function(error){
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.ACCOUNT.BUSINESSINFORMATION.BUSINESSHOURS.TOAST.SAVE.ERROR"))
                                .position(pinTo )
                                .hideDelay(1000)
                        );

                    });


                vm.businessinfo = {
                    closeTimeMonday : 0,
                    openTimeMonday : 0,
                    closeTimeTuesday : 0,
                    openTimeTuesday : 0,
                    closeTimeWednesday : 0,
                    openTimeWednesday : 0,
                    closeTimeThursday : 0,
                    openTimeThursday : 0,
                    closeTimeFriday : 0,
                    openTimeFriday : 0,
                    closeTimeSaturday : 0,
                    openTimeSaturday : 0,
                    closeTimeSunday : 0,
                    openTimeSunday : 0,
                    openMonday : 'OPEN',
                    openTuesday : 'OPEN',
                    openWednesday : 'OPEN',
                    openThursday : 'OPEN',
                    openFriday : 'OPEN',
                    openSaturday : 'OPEN',
                    openSunday : 'OPEN'

                }

                break;

        }

        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({},last);
        $scope.getToastPosition = function() {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function(pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if ( current.bottom && last.top ) current.top = false;
            if ( current.top && last.bottom ) current.bottom = false;
            if ( current.right && last.left ) current.left = false;
            if ( current.left && last.right ) current.right = false;
            last = angular.extend({},current);
        }
        ///END TOAST

        // Methods

        function saveBusinessHours(){
            api.saveBusinessHours.save({
                openMonday : vm.businessinfo.openMonday,
                openTuesday : vm.businessinfo.openTuesday,
                openWednesday : vm.businessinfo.openWednesday,
                openThursday : vm.businessinfo.openThursday,
                openFriday : vm.businessinfo.openFriday,
                openSaturday : vm.businessinfo.openSaturday,
                openSunday : vm.businessinfo.openSunday,
                openTimeMonday : vm.businessinfo.openTimeMonday,
                openTimeTuesday : vm.businessinfo.openTimeTuesday,
                openTimeWednesday : vm.businessinfo.openTimeWednesday,
                openTimeThursday : vm.businessinfo.openTimeThursday,
                openTimeFriday : vm.businessinfo.openTimeFriday,
                openTimeSaturday : vm.businessinfo.openTimeSaturday,
                openTimeSunday : vm.businessinfo.openTimeSunday,
                closeTimeMonday : vm.businessinfo.closeTimeMonday,
                closeTimeTuesday : vm.businessinfo.closeTimeTuesday,
                closeTimeWednesday : vm.businessinfo.closeTimeWednesday,
                closeTimeThursday : vm.businessinfo.closeTimeThursday,
                closeTimeFriday : vm.businessinfo.closeTimeFriday,
                closeTimeSaturday : vm.businessinfo.closeTimeSaturday,
                closeTimeSunday : vm.businessinfo.closeTimeSunday
                },
                function(response){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.ACCOUNT.BUSINESSINFORMATION.BUSINESSHOURS.TOAST.SAVE.SUCCESS"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );

                },
                function(error){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.ACCOUNT.BUSINESSINFORMATION.BUSINESSHOURS.TOAST.SAVE.ERROR"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );

                });

        }

        function saveGeneral() {
            api.saveGeneral.save({
                    serviceId: vm.service._id,
                    name: vm.service.name,
                    price: vm.service.price,
                    duration: parseInt(vm.service.duration),
                    order:vm.service.order,
                    return:vm.service.return,
                    showPriceAtStylePlace : vm.service.showPriceAtStylePlace,
                    categoryId:vm.service.categoryId
                },
                function(response){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.SERVICE.SERVICE.TOAST.SAVE.SUCCESS"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function(){
                        $state.go('app.settings.service.service.list');
                    }, 1000);
                },
                function(error){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.SERVICE.SERVICE.TOAST.SAVE.ERROR"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function(){
                        $state.go('app.settings.service.service.list');
                    }, 1000);
                });

        }

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.marketing.content.photo', ['ngFileUpload'])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider
            .state('app.marketing.content.photo', {
                url: '/photo'
            })
            .state('app.marketing.content.photo.list', {
                url: '/list',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/marketing/content/photo/list.html',
                        controller: 'ContentPhotoController as vm'
                    }
                }
            })
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.marketing.content.photo')
        .controller('ContentPhotoController', ContentPhotoController);

    /** @ngInject */
    function ContentPhotoController($scope, $state, $mdDialog, $translate, api, $mdToast, Upload)
    {
        var vm = this;

        vm.removePhoto = removePhoto;

        var currentState = $state.current.name;

        //se for uma lista deve carregar photos anteriores
        if (currentState == 'app.marketing.content.photo.list'){
            api.pdv.save({
                },
                function(response){
                    vm.photos = response.d.slideImages;
                    var deleteTranslated = $translate.instant('')

                    var html = "<table style='width: 100%'>";
                    var tmp = 0;

                    for(var i=0; i < vm.photos.length; i++){
                        if(tmp == 0){
                            html = html + "<tr>"
                        }

                        html = html + "<td style='padding:20px'>"
                        html = html + "<img style='width:200px;height:100px' src='" +  vm.photos[i]  + "'><br>";
                        html = html + '<md-button ng-click="vm.removePhoto(\'' + vm.photos[i] + '\')" aria-label="Trash" class="md-raised md-warn gp-mini" ><md-tooltip aria-label="Pencil">{{ "GENERAL.HINTS.TRASH" | translate }}</md-tooltip><i class="icon-trash" layout="center"></i></md-button>';
                        html = html + "</td>"

                        if(tmp == 5){
                            html = html + "</tr>"
                            tmp = 0;
                        } else {
                            tmp = tmp + 1;
                        }
                    }

                    html = html + "</table>";

                    vm.html = html;


                },
                function(error){
                    console.log(error);
                });

            $scope.$watch('vm.image', function(oldData, newData){
                if (vm.image != undefined){
                    Upload.base64DataUrl(vm.image).then(function (imageData) {
                        var obj = {};
                        obj.image = imageData;

                        api.pdvSavePhoto.save({
                                image: imageData
                            },
                            function (response) {
                                //Succes
                                $mdToast.show(
                                    $mdToast.simple()
                                        .textContent($translate.instant("MARKETING.CONTENT.PHOTOS.TOAST.SAVE.SUCCESS"))
                                        .hideDelay(2000)
                                );
                                //redirect
                                setTimeout(function(){
                                    $state.reload();
                                }, 1000);

                            },
                            function (error) {
                                //Succes
                                $mdToast.show(
                                    $mdToast.simple()
                                        .textContent($translate.instant("MARKETING.CONTENT.PHOTOS.TOAST.SAVE.SUCCESS"))
                                        .hideDelay(2000)
                                );
                                //redirect
                                setTimeout(function(){
                                    $state.reload();
                                }, 1000);
                            });


                    });
                }

            })

        }

        function removePhoto(imageURL) {

            api.pdvRemovePhoto.save({
                    imageURL: imageURL
                },
                function (response) {
                    //Succes
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.CONTENT.PHOTOS.TOAST.REMOVE.SUCCESS"))
                            .hideDelay(1000)
                    );

                    //redirect
                    setTimeout(function(){
                        $state.reload();
                    }, 1000);

                },
                function (error) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.CONTENT.PHOTOS.TOAST.REMOVE.ERROR"))
                            .hideDelay(1000)
                    );

                    //redirect
                    setTimeout(function(){
                        $state.reload();
                    }, 1000);
                });

        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.marketing.content.location')
        .controller('ContentLocationController', ContentLocationController);

    /** @ngInject */
    function ContentLocationController($scope, $translate, api, $mdToast, uiGmapGoogleMapApi, uiGmapIsReady)
    {
        var vm = this;

        vm.saveLocation = saveLocation;

        api.pdv.save({
            },
            function(response){
                var obj = response.d;
                vm.latitude = obj.latitude;
                vm.longitude = obj.longitude;
                vm.map = {};
                vm.map.markers = [];
                if ( (vm.latitude == 0) && (vm.longitude == 0) ){
                    vm.zoom = 2;
                } else{
                    vm.zoom = 17;
                }


                //set gogle maps
                uiGmapGoogleMapApi.then(function (maps)
                {
                    vm.map = {
                        center: {
                            latitude : vm.latitude,
                            longitude: vm.longitude
                        },
                        zoom  : vm.zoom,
                        pan: 1,
                        control: {},
                        events: {
                            click: function (map, eventName, originalEventArgs) {
                                var e = originalEventArgs[0];
                                var lat = e.latLng.lat(),lon = e.latLng.lng();
                                var marker = {
                                    id: Date.now(),
                                    coords: {
                                        latitude: lat,
                                        longitude: lon
                                    }
                                };

                                vm.latitude = lat;
                                vm.longitude = lon;

                                vm.map.marker = marker;

                                $scope.$apply();
                            }

                        }
                    };

                    vm.map.marker = {};
                    vm.map.marker.coords = {
                        latitude: vm.latitude,
                        longitude: vm.longitude
                    }
                    vm.map.marker.id = "1";

                });
            },
            function(error){
                console.log(error);
            });



        function saveLocation(){

            api.pdvSaveLocation.save({
                latitude : vm.latitude,
                longitude : vm.longitude
            },
                function(response){
                    //Succes
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.CONTENT.ABOUT.TOAST.SAVE.SUCCESS"))
                            .hideDelay(1000)
                    );

                    $state.reload();

                },
                function(error){
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.CONTENT.ABOUT.TOAST.SAVE.ERROR"))
                            .hideDelay(1000)
                    );
                });



        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.marketing.content.about', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider
            .state('app.marketing.content.about', {
                url: '/about/:wizard',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/marketing/content/about/about.html',
                        controller: 'ContentAboutController as vm'
                    }
                }
            })
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.marketing.content.about')
        .controller('ContentAboutController', ContentAboutController);

    /** @ngInject */
    function ContentAboutController($scope, $state, $mdDialog, $translate, api, $mdToast, $rootScope)
    {
        var vm = this;

        vm.saveApp = saveApp;

        //check if is edit, insert or nothing
        var currentState = $state.current.name;

        api.pdv.save({
            },
            function(response){
                var obj = response.d;
                vm.name = obj.name;
                vm.address = obj.address;
                vm.instagram = obj.instagram;
                vm.facebook = obj.facebook;
                vm.telephone1 = obj.telephone1;
                vm.telephone2 = obj.telephone2;
                vm.about = obj.about;

            },
            function(error){
                console.log(error);
            });



        function saveApp(){

            api.pdvSaveAbout.save({
                name : vm.name,
                address : vm.address,
                instagram : vm.instagram,
                facebook : vm.facebook,
                telephone1 : vm.telephone1 ,
                telephone2 : vm.telephone2 ,
                about:vm.about

            },
                function(response){
                    //Succes
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.CONTENT.ABOUT.TOAST.SAVE.SUCCESS"))
                            .hideDelay(1000)
                    );

                    if ($state.params.wizard){
                        $state.go('app.wizard');
                    }


                },
                function(error){
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.CONTENT.ABOUT.TOAST.SAVE.ERROR"))
                            .hideDelay(1000)
                    );
                });



        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.subscription.price-table', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.subscription.price-table', {
            url  : '/subscription/price-table',
            views: {
                'content@app': {
                    templateUrl: 'app/main/subscription/price-table/price-tables.html',
                    controller : 'PriceTablesController as vm'
                }
            }
        }).state('app.subscription.congratulations', {
            url  : '/subscription/congratulations',
            views: {
                'content@app': {
                    templateUrl: 'app/main/subscription/price-table/congratulations.html',
                    controller : 'PriceTablesController as vm'
                }
            }
        })
        ;
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.subscription.price-table')
        .controller('PriceTablesController', PriceTablesController);

    /** @ngInject */
    function PriceTablesController($state,$window,api,$rootScope,$mdToast)
    {
        // Data
        var vm = this;
        vm.disableSubscriptionButton = false;

        // Methods
        vm.buyMensal = function(){

            vm.disableSubscriptionButton = true;
            api.newSubscription.save({
                    pdvId : $rootScope.pdvId,
                    planId : 21,
                    expirationDate : new Date(new moment()).valueOf()
                },
                function (response) {
                    
                    $rootScope.paymentLink = response.d;

                    //$state.go('app.subscription.congratulations')
                    $window.location = response.d;

                });

        }
        vm.buySemestral = function(){

            vm.disableSubscriptionButton = true;
            api.newSubscription.save({
                    pdvId : $rootScope.pdvId,
                    planId : 20,
                    expirationDate : new Date(new moment()).valueOf()
                },
                function (response) {

                    $rootScope.paymentLink = response.d;
                    
                   // $state.go('app.subscription.congratulations')
                   $window.location = response.d;

                });

        }



        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.subscription.extras', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.subscription.extras', {
            url  : '/subscription/extras',
            views: {
                'content@app': {
                    templateUrl: 'app/main/subscription/extras/extras.html',
                    controller : 'ExtrasController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.subscription.extras')
        .controller('ExtrasController', ExtrasController);

    /** @ngInject */
    function ExtrasController($state,$window,api)
    {
        // Data
        var vm = this;

        // Methods
        vm.buy200 = function(){
            $window.open('http://mpago.la/f1Tx', '_blank');
        }

        vm.buy500 = function(){
            $window.open('http://mpago.la/GP6q', '_blank');
        }

        vm.buy1000 = function(){
            $window.open('http://mpago.la/XjZ9', '_blank');
        }

        api.quota.save({
            },
            function(response){
                vm.SMSQuota = response.d.sms;
            },
            function(error){
                vm.SMSQuota = 0;
            });



        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.schedule', ['fixed.table.header',  'datatables.fixedcolumns', 'datatables.fixedheader',
        'ngMaterialDatePicker'])
        .config(config)
        .directive('compile', ['$compile', function ($compile) {
            return function(scope, element, attrs) {
                var ensureCompileRunsOnce = scope.$watch(
                    function(scope) {
                        // watch the 'compile' expression for changes
                        return scope.$eval(attrs.compile);
                    },
                    function(value) {
                        // when the 'compile' expression changes
                        // assign it into the current DOM
                        element.html(value);

                        // compile the new DOM and link it to the current
                        // scope.
                        // NOTE: we only compile .childNodes so that
                        // we don't get into infinite loop compiling ourselves
                        $compile(element.contents())(scope);

                        // Use Angular's un-watch feature to ensure compilation only happens once.
                        //ensureCompileRunsOnce();
                    }
                );
            };
        }]);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.schedule', {
                url    : '/schedule'
            })
            .state('app.schedule.byprofessional', {
                url    : '/professional',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/schedule/byprofessional.html',
                        controller : 'ScheduleByProfessionalController as vm'
                    }
                },
                bodyClass: 'calendar'
            })
            .state('app.schedule.byprofessional2', {
                url    : '/professional2',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/schedule/byprofessional2.html',
                        controller : 'ScheduleByProfessionalController2 as vm'
                    }
                },
                bodyClass: 'calendar'
            })
            .state('app.schedule.bycategory', {
                url    : '/category',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/schedule/bycategory.html',
                        controller : 'ScheduleController as vm'
                    }
                }
            }).state('app.schedule.pendingschedules', {
                url    : '/pendingschedules',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/schedule/listPendingSchedule.html',
                        controller : 'ScheduleController as vm'
                    }
                }
            });



    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.schedule')
        .controller('NewScheduleController', NewScheduleController);

    /** @ngInject */
    function NewScheduleController($q, api, $mdDialog, $mdToast, $translate, $scope, customer,
                                   whenTime, professional, whenDate, $state, id, $mdConstant,
                                   DTOptionsBuilder, $rootScope)
    {
        var vm = this;
        vm.getCustomerHistory = getCustomerHistory;
        vm.closeDialog = closeDialog;
        vm.newServiceRequest = newServiceRequest;
        vm.clickToNewServiceRequest  =clickToNewServiceRequest;
        vm.timetable = [];
        vm.isSaving = false;
        vm.scheduleCellStyle = scheduleCellStyle;

        vm.statusCell = function(i,j){
            if ((vm.schedule!=undefined) && (vm.schedule[j] != undefined) && (vm.schedule[j][i] != undefined)){
                return true;
            } else {
                return false;
            }

        }
        vm.disableScroll = false;
        vm.lastSelectedRow = 0;
        vm.lasSelectedCol = 0;
        vm.selectCell = function(i,professional) {
            if ((professional!= null) &&((vm.lastSelectedRow != i) || (vm.lastSelectedCol != professional._id))){
                vm.whenTime = i + "";
                vm.serviceSchedule.professional = professional
                vm.disableScroll = true;

                if ((vm.schedule!=undefined) && (vm.schedule[professional._id] != undefined) && (vm.schedule[professional._id][i] != undefined)){
                    var lastElement = document.getElementById('row_' + vm.lastSelectedRow + '_col_' + vm.lastSelectedCol);
                    if (lastElement != null){
                        lastElement.style.backgroundColor = '';
                    }

                    vm.lastSelectedRow = 0;
                    vm.lastSelectedCol = 0;
                } else {
                    document.getElementById('row_' + i + '_col_' + professional._id).style.backgroundColor = 'Orange';

                    var lastElement = document.getElementById('row_' + vm.lastSelectedRow + '_col_' + vm.lastSelectedCol);
                    if (lastElement != null){
                        lastElement.style.backgroundColor = '';
                    }

                    vm.lastSelectedRow = i;
                    vm.lastSelectedCol = professional._id;
                }

            }

        }

        /*var pdvConfObj = $window.localStorage['pdvConfiguration'];
        var pdvConfiguration = {};

        if (pdvConfObj != undefined){
            pdvConfiguration = JSON.parse(pdvConfObj);
        } else {
            pdvConfiguration = {
                requestPasswordSchedule : false,
                requestPasswordCheckout : false
            }
        }*/
        var pdvConfiguration = $rootScope.pdvConfiguration;
        console.log(pdvConfiguration);



        vm.checkCustomer = function(){

            //Bloquear popup
            return;

            if ((vm.customerSearchText.length > 0) && (vm.serviceSchedule.customer == null)){
                var confirm = $mdDialog.confirm()
                    .title('Confirmação')
                    .textContent('Cliente não é válido, deseja inseri-lo?')
                    .ariaLabel('Confirmacao')
                    .targetEvent(null)
                    .clickOutsideToClose(true)
                    .multiple(true)
                    .ok('Sim')
                    .cancel('Não');
                $mdDialog.show(confirm).then(function() {
                    vm.newCustomer();
                }, function() {

                });
            }

            //checar se customer é valido
        }


        if (id != null){
            vm.isReschedule = true;
        } else {
            vm.isReschedule = false;
        }
        vm.serviceSchedule = {
            "aquisitionChannel":"T"
        };
        if (professional != undefined){
            vm.serviceSchedule.professional = professional;
        }

        vm.timeDisabled = false;

        vm.submitNewSchedule = function(ev){
            event.stopPropagation();
            if (ev.keyCode == 13){

                //vm.timeDisabled = true;
                //verificar se estado do agendamento é valido
                if ( ( vm.serviceSchedule.customer != undefined ) &&
                    (vm.serviceSchedule.service != undefined)    &&
                    (vm.serviceSchedule.professional != undefined)){
                    // Appending dialog to document.body to cover sidenav in docs app
                    vm.openConfirmationDialog(false);
                }
            }

        }

        vm.openConfirmationDialog = function(checkin, ev){
            var confirm = $mdDialog.confirm()
                .title('Confirmação')
                .textContent('Deseja confirmar o agendamento?')
                .ariaLabel('Confirmacao')
                .targetEvent(ev)
                .clickOutsideToClose(true)
                .multiple(true)
                .ok('Sim')
                .cancel('Não');
            $mdDialog.show(confirm).then(function() {
                newServiceRequest(checkin);
            }, function() {

            });
        }


        vm.newCustomer = newCustomer;

        if (whenDate == undefined){
            //console.log('ffff');
            var whenMomentDate = new moment();
            var dt = new moment({
                year: whenMomentDate.year(),
                month:whenMomentDate.month(),
                date:whenMomentDate.date()
            })
            vm.whenDate = dt.valueOf() + "";

        } else {
            //console.log(whenDate.valueOf());
            var whenMomentDate = new moment(whenDate.valueOf());
            var dt = new moment({
                year: whenMomentDate.year(),
                month:whenMomentDate.month(),
                date:whenMomentDate.date()
            })
            vm.whenDate = dt.valueOf() + "";

            //console.log(vm.whenDate);
        }

        vm.loadoptions = loadoptions;
        vm.serviceOptions = [];
        vm.customerDisabled = false;



        //loading timetable
        for(var i=480; i < 1320; i = i + 15){
            var hour = parseInt(i/60);
            if (hour < 10){
                hour = "0" + hour;
            }

            var minute = i - (hour * 60);

            if (minute < 10){
                minute = "0" + minute;
            }

            var obj = {
                time : i,
                timeStr : hour + ":" + minute,
                monday : true,
                tuesday : true,
                wednesday : true,
                thursday : true,
                friday : true,
                saturday : true,
                sunday : true,
            }
            vm.timetable.push(obj);
        }
        if (whenTime != undefined){
            vm.whenTime = whenTime + "";
        } else {
            vm.whenTime = (8 * 60) + "";
        }



        if (customer != undefined){
            vm.serviceSchedule.customer = customer;
        }


        ///customer autocomplete
        vm.customerNameSearchText = ""
        vm.customerSearchTextChange = customerSearchTextChange;
        vm.customerSearchItems = [];
        function customerSearchTextChange(search) {

            var deferred = $q.defer();
            api.customersSearch.save({
                    searchName : search
                },
                function(response){
                    deferred.resolve( response.d );
                },
                function(error){
                    console.log(error);
                });

            return deferred.promise;

        }

        ///service autocomplete
        vm.serviceSearchText = ""
        vm.serviceSearchTextChange = serviceSearchTextChange;
        vm.serviceSearchItems = [];
        function serviceSearchTextChange(search) {
            var deferred = $q.defer();
            api.serviceServicesSearch.save({
                    search : search
                },
                function(response){
                    deferred.resolve( response.d );
                },
                function(error){
                    console.log(error);
                });

            return deferred.promise;

        }

        ///professional autocomplete
        vm.professionalSearchText = ""
        vm.professionalSearchTextChange = professionalSearchTextChange;
        vm.professionalSearchItems = [];
        function professionalSearchTextChange(search) {
            var deferred = $q.defer();
            api.serviceProfessionalSearch.save({
                    search : search
                },
                function(response){
                    deferred.resolve( response.d );
                },
                function(error){
                    console.log(error);
                });
            return deferred.promise;
        }

        //translates
        vm.floatinglabel = {
            customer : $translate.instant("SCHEDULE.FIELDS.CUSTOMER"),
            service : $translate.instant("SCHEDULE.FIELDS.SERVICE"),
            professional : $translate.instant("SCHEDULE.FIELDS.PROFESSIONAL")
        }

        function closeDialog(){
            $mdDialog.cancel();
        }

        vm.datetable = [];
        for(var i=0; i < 360; i++){
            var obj = {};
            var date = new moment();
            var dt = new moment({
                year: date.year(),
                month:date.month(),
                date:date.date()
            }).add(i, 'd');
            obj.value = dt.valueOf() + "";
            //console.log(obj.value);
            obj.dateStr = dt.format('DD-MM-YYYY (ddd)');
            vm.datetable.push(obj);
        }


        //check if its reschedule
        if(id != undefined){
            vm.customerDisabled = true;
            api.serviceRequest.save({
                    requestId:id
                },
                function(response){

                    console.log(response);

                    vm.serviceSchedule.customer = response.d.extra.customer;
                    vm.serviceSchedule.service = response.d.extra.service;
                    vm.serviceSchedule.professional = response.d.extra.professional;
                    vm.serviceSchedule.aquisitionChannel = response.d.aquisitionChannel;
                    var mWhen = new moment(response.d.when);
                    var mWhenDate = new moment({
                        year : mWhen.year(),
                        month : mWhen.month(),
                        date : mWhen.date()
                    })
                    var mWhenTime = (mWhen.valueOf() - mWhenDate.valueOf())/60000;
                    vm.whenDate = new Date(mWhenDate.valueOf()).valueOf() + "";
                    vm.whenTime = mWhenTime + "";
                    //vm.whenDate.focus();

                },
                function(error){
                    console.log(error);
                });
        }


        //////LOAD OPTIONS
        ///whatchers
        $scope.$watch('vm.serviceSchedule.service', function(newValue, oldValue) {
            if (newValue != undefined){
                api.scheduleByPDV.save({
                        date : vm.whenDate
                    },
                    function(response){
                        vm.schedule = response.d;

                    }, function(error){
                        console.log(error);
                    });
                api.professionalsByService.save({
                        serviceId : newValue._id
                    },
                    function(response){
                        vm.professionals = response.d;
                    },
                    function(error){
                        console.log(error);
                    });



            }
        });
        $scope.$watch('vm.serviceSchedule.professional', function(newValue, oldValue) {
            if (newValue != undefined){

            }
        });
        $scope.$watch('vm.whenDate', function(newValue, oldValue) {
            if (newValue != undefined){
                var lastElement = document.getElementById('row_' + vm.lastSelectedRow + '_col_' + vm.lastSelectedCol);
                if (lastElement != null){
                    lastElement.style.backgroundColor = '';
                }
                vm.lastSelectedRow = 0;
                vm.lastSelectedCol = 0;

                api.scheduleByPDV.save({
                        date : vm.whenDate
                    },
                    function(response){
                        vm.schedule = response.d;

                    }, function(error){
                        console.log(error);
                    });
            }
        });
        $scope.$watch('vm.whenTime', function(newValue, oldValue) {
            if (newValue != undefined){

                if (!vm.disableScroll){
                    var elem = document.getElementById("row_" + newValue);
                    if (elem != null){
                        elem.scrollIntoView(true);

                        if (vm.serviceSchedule.professional!= null){

                            //so pinta se nao estiver bloqueado
                            if ((vm.schedule!=undefined) && (vm.schedule[vm.serviceSchedule.professional._id] != undefined) && (vm.schedule[vm.serviceSchedule.professional._id][newValue] != undefined)){
                                var lastElement = document.getElementById('row_' + vm.lastSelectedRow + '_col_' + vm.lastSelectedCol);
                                if (lastElement != null){
                                    lastElement.style.backgroundColor = '';
                                }

                                vm.lastSelectedRow = 0;
                                vm.lastSelectedCol = 0;
                            } else {
                                document.getElementById('row_' + newValue + '_col_' + vm.serviceSchedule.professional._id).style.background = 'Orange';

                                var lastElement = document.getElementById('row_' + vm.lastSelectedRow + '_col_' + vm.lastSelectedCol);
                                if (lastElement != null){
                                    lastElement.style.backgroundColor = '';
                                }

                                vm.lastSelectedRow = newValue;
                                vm.lastSelectedCol = vm.serviceSchedule.professional._id;
                            }


                        }

                    }
                } else {
                    vm.disableScroll = false;
                }


            }
        });
        $scope.$watch('vm.serviceSchedule.customer', function(newValue, oldValue) {
            if (newValue != undefined){
                getCustomerHistory();
            }
        });

        function loadoptions() {

            return;

            if (vm.serviceSchedule.service == undefined) return;
            if (vm.serviceSchedule.professional == undefined) return;

            //resgatando a data desejada
            var whenDateMoment = new moment(vm.whenDate.valueOf());
            var whenDate = new moment({
                year:whenDateMoment.year(),
                month:whenDateMoment.month(),
                date:whenDateMoment.date()
            });
            var whenTime = vm.whenTime * 60 * 1000;
            var when = whenDate.valueOf() + whenTime;
            var whenMoment = new moment(when);
            vm.serviceOptions = [];

            //pegando a primeira opção sendo o que o cliente pediu
            var requestOne = {};
            requestOne.id = vm.serviceOptions.length+1;
            requestOne.professional = vm.serviceSchedule.professional;
            requestOne.service = vm.serviceSchedule.service;
            requestOne.when = when;
            requestOne.caption = requestOne.service.name + ' com ' + requestOne.professional.name + ' em ' + whenMoment.format("DD/MM") +  ' as ' + whenMoment.format("HH:mm");

            vm.serviceOptions.push(requestOne);
            //TODO: verificar se esse horario esta disopnivel ou nao


            //resgatar todos os profissionais livres na categotia e no horário
            api.scheduleByCategory.save({
                    date : vm.whenDate.valueOf()
                },
                function(response){
                    if (response.d.schedule[parseInt(vm.whenTime)] != undefined){
                        for(var i=0; i < response.d.schedule[parseInt(vm.whenTime)].data[vm.serviceSchedule.service.categoryId].data.length; i++){

                            var request = {};
                            request.id = vm.serviceOptions.length+1;
                            request.professional = response.d.schedule[parseInt(vm.whenTime)].data[vm.serviceSchedule.service.categoryId].data[i];
                            request.service = vm.serviceSchedule.service;
                            request.when = when;
                            request.caption = request.service.name + ' com ' + request.professional.name + ' em ' + whenMoment.format("DD/MM") +  ' as ' + whenMoment.format("HH:mm");

                            if (request.professional._id != vm.serviceSchedule.professional._id){
                                vm.serviceOptions.push(request);
                            }


                        }
                    }
                },
                function(error){
                    console.log(error);
                });

            api.scheduleByPDV.save({
                    date : vm.whenDate.valueOf()
                },
                function(response){
                    var scheduleData  = response.d;
                    console.log(scheduleData[vm.serviceSchedule.professional._id]);
                    var arTemp = [];
                    for(var i = 480; i <= 1400; i = i + 15){
                        if (scheduleData[vm.serviceSchedule.professional._id][i] == undefined){
                            //esta livre
                            arTemp.push(i);
                        }
                    }
                    for(var i = 0; i <  arTemp.length; i++){
                        if (Math.abs(arTemp[i] - vm.whenTime) < 2 * 60){
                            var request = {};
                            request.id = vm.serviceOptions.length+1;
                            request.professional = vm.serviceSchedule.professional;
                            request.service = vm.serviceSchedule.service;
                            var whenTime = arTemp[i] * 60 * 1000;
                            var when = whenDate.valueOf() + whenTime;
                            var whenMoment = new moment(when);
                            request.when = when;
                            request.caption = request.service.name + ' com ' + request.professional.name + ' em ' + whenMoment.format("DD/MM") +  ' as ' + whenMoment.format("HH:mm");

                            if (vm.whenTime != arTemp[i]){
                                vm.serviceOptions.push(request);
                            }
                        }
                    }

                }, function(error){
                    console.log(error);
                })


        }


        function getCustomerHistory(){
            api.customerHistory.save({
                    customerId:vm.serviceSchedule.customer._id
                },
                function(response){
                    var arSales = response.d;
                    vm.customerHistory = [];

                    console.log(arSales);
                    for(var i=0 ; i< arSales.length; i++){
                        for(var j=0; j < arSales[i].items.length; j++){
                            arSales[i].items[j].checkoutDate = arSales[i].checkoutDate;
                            vm.customerHistory.push(arSales[i].items[j]);
                        }
                    }



                },
                function(error){
                    console.log(error);
                });
        }



        //////NEW SCHEDULE
        function clickToNewServiceRequest(checkin){

            console.log(pdvConfiguration);

            if (pdvConfiguration.requestPasswordCheckout) {
                $mdDialog.show({
                    template: [
                        '<md-dialog md-theme="{{ dialog.theme || dialog.defaultTheme }}" aria-label="{{ dialog.ariaLabel }}" ng-class="dialog.css">',
                        '  <md-dialog-content class="md-dialog-content" role="document" tabIndex="-1">',
                        '    <h2 class="md-title">{{ dialog.title }}</h2>',
                        '    <div class="md-dialog-content-body">',
                        '      <p>Informe a sua senha</p>',
                        '    </div>',
                        '    <md-input-container md-no-float class="md-prompt-input-container">',
                        '      <input type=password ng-keypress="dialog.keypress($event)" md-autofocus ng-model="dialog.result" ' +
                        '             placeholder="{{::dialog.placeholder}}">',
                        '    </md-input-container>',
                        '  </md-dialog-content>',
                        '  <md-dialog-actions>',
                        '    <md-button ng-click="dialog.abort()" class="md-primary md-cancel-button">',
                        '      {{ dialog.cancel }}',
                        '    </md-button>',
                        '    <md-button ng-click="dialog.hide()" class="md-primary md-confirm-button" >',
                        '      {{ dialog.ok }}',
                        '    </md-button>',
                        '  </md-dialog-actions>',
                        '</md-dialog>'
                    ].join('').replace(/\s\s+/g, ''),
                    multiple: true,
                    controller: function mdDialogCtrl() {
                        this.title = "Confirmação";
                        this.placeholder = "Senha";
                        this.ok = 'Confirmar';
                        this.cancel = 'Cancelar';
                        this.mdTextContent = "Informe sua senha";

                        this.hide = function () {
                            $mdDialog.hide(this.result);
                        };
                        this.abort = function () {
                            $mdDialog.cancel();
                        };
                        this.keypress = function ($event) {
                            if ($event.keyCode === $mdConstant.KEY_CODE.ENTER) {
                                $mdDialog.hide(this.result);
                            }
                        };
                    },
                    controllerAs: 'dialog',
                    bindToController: true,

                })
                    .then(function (result) {
                        //console.log(result);
                        //check password
                        api.checkPassword.save({
                                password: result
                            },
                            function (response) {
                                if (response.d) {
                                    $mdDialog.hide();
                                    newServiceRequest(checkin);
                                } else {
                                    $mdToast.show(
                                        $mdToast.simple()
                                            .textContent($translate.instant("AUTH.WRONG_PASSWORD"))
                                            .hideDelay(1000)
                                    );

                                }

                            },
                            function (error) {


                            });
                    }, function () {
                        $mdDialog.cancel();
                    });

            } else {
                newServiceRequest(checkin);
            }
        }
        function newServiceRequest(checkin){

            vm.isSaving = true;
            var whenDateMoment = new moment(parseFloat(vm.whenDate));
            var whenDate = new moment({
                year:whenDateMoment.year(),
                month:whenDateMoment.month(),
                date:whenDateMoment.date()
            });
            var whenTime = vm.whenTime * 60 * 1000;
            var when = whenDate.valueOf() + whenTime;

            if (id == undefined){
                api.saveSchedule.save({
                        checkin : checkin,
                        customerId : vm.serviceSchedule.customer._id,
                        customerName : vm.serviceSchedule.customer.name,
                        customerEmail : vm.serviceSchedule.customer.name,
                        customerTelephone : vm.serviceSchedule.customer.telephone,
                        serviceId : vm.serviceSchedule.service._id,
                        serviceName : vm.serviceSchedule.service.name,
                        serviceDuration : vm.serviceSchedule.service.duration,
                        serviceValue : vm.serviceSchedule.service.price,
                        preference : vm.serviceSchedule.chkPreference,
                        when : when,
                        //firstVisit : vm.serviceSchedule.service.firstVisit,
                        serviceProfessionalId : vm.serviceSchedule.professional._id,
                        serviceProfessionalName : vm.serviceSchedule.professional.name,
                        aquisitionChannel : vm.serviceSchedule.aquisitionChannel
                    },
                    function(response){

                        if (response.s != 200){
                            //show toast
                            var pinTo = $scope.getToastPosition();
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent($translate.instant("SCHEDULE.TOAST.SAVE.ERROR_PROFESSIONAL_NOT_ENABLED"))
                                    .hideDelay(10000)
                            );
                            vm.isSaving = false;
                            return;
                        }

                        //show toast
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SCHEDULE.TOAST.SAVE.SUCCESS"))
                                .position(pinTo )
                                .hideDelay(1000)
                        );

                        //check for another insert
                        var confirm = $mdDialog.confirm()
                            .title('Deseja agendar outro serviço?')
                            .textContent('')
                            .ariaLabel('Lucky day')
                            .multiple(true)
                            .clickOutsideToClose(true)
                            .parent(angular.element(document.body))
                            .ok('Sim')
                            .cancel('Não');
                        $mdDialog.show(confirm).then(function() {
                            vm.serviceSchedule.service = null;
                            vm.serviceSchedule.professional = null;
                            vm.isSaving = false;
                            document.querySelector('#service-input').focus();
                        }, function() {
                            //dismiss
                            closeDialog();
                        });





                    },
                    function(error){
                        console.log(error);
                    });
            } else {
                api.updateSchedule.save({
                        requestId  :id,
                        serviceId : vm.serviceSchedule.service._id,
                        serviceName : vm.serviceSchedule.service.name,
                        serviceDuration : vm.serviceSchedule.service.duration,
                        serviceValue : vm.serviceSchedule.service.price,
                        when : when,
                        serviceProfessionalId : vm.serviceSchedule.professional._id,
                        serviceProfessionalName : vm.serviceSchedule.professional.name
                    },
                    function(response){
                        //show toast

                        if (response.s != 200){
                            //show toast
                            var pinTo = $scope.getToastPosition();
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent($translate.instant("SCHEDULE.TOAST.SAVE.ERROR_PROFESSIONAL_NOT_ENABLED"))
                                    .hideDelay(10000)
                            );
                            vm.isSaving = false;
                            return;
                        }

                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SCHEDULE.TOAST.SAVE.SUCCESS"))
                                .position(pinTo )
                                .hideDelay(1000)
                        );

                        //dismiss
                        closeDialog();
                    },
                    function(error){
                        console.log(error);
                    });
            }


        }

        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({},last);
        $scope.getToastPosition = function() {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function(pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if ( current.bottom && last.top ) current.top = false;
            if ( current.top && last.bottom ) current.bottom = false;
            if ( current.right && last.left ) current.left = false;
            if ( current.left && last.right ) current.right = false;
            last = angular.extend({},current);
        }
        ///END TOAST


        function newCustomer(){
            $mdDialog.show({
                controller: 'CustomerController',
                controllerAs : 'vm',
                templateUrl: 'app/main/customer/customerDialog.html',
                clickOutsideToClose:true,
                multiple:true,
                escapeToClose : true,
                locals: {
                    customerName: vm.customerSearchText
                },
            })
                .then(function(answer) {
                    vm.serviceSchedule.customer = answer;
                    document.querySelector('#service-input').focus();
                }, function() {

                });
        }


    }

    function scheduleCellStyle(time, professionalId){
        return "green";
    }



})();

(function ()
{
    'use strict';

    angular
        .module('app.settings.general', [
            ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        //State
        $stateProvider
            .state('app.settings.general', {
                url    : '/general',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/settings/general/general.html',
                        controller : 'GeneralConfigurationController as vm'
                    }
                }
            });

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.general')
        .controller('GeneralConfigurationController', GeneralConfigurationController);

    /** @ngInject */
    function GeneralConfigurationController($q, api, $mdDialog, $mdToast, $translate, $scope,
                                            $state, DTOptionsBuilder, DTDefaultOptions,
                                            $rootScope)
    {
        var vm = this;

        //load info
        api.generalConfiguration.save({
            },
            function(response){
                if(response.d == undefined){
                    vm.configuration = {
                        requestPasswordSchedule : false,
                        requestPasswordCheckout : false,
                        allowNewSaleWithoutCashier : true,
                        requestPasswordBlock : false,
                        allowScheduleByProfessional : false,
                        allowCustomerEditByProfessional : false,
                        transferServiceFromScheduleToSale : true,
                        whoPaysAuxiliar : 'PROFESSIONAL',
                        allowProfessionalCheckin : true,
                        allowUndoProfessionalCheckin : true,
                        allowProfessionalCancelSchedule : true,
                        allowUndoProfessionalReschedule : true,
                        allowProfessionalSendReminderSMS : true,
                        allowRecepcionistAddService:true,
                        allowRecepcionistAddProduct:true,
                        allowRecepcionistSeeComandaFechada : false,
                        allowRecepcionistCreditCustomer : false,
                        allowRecepcionistDeleteCustomer : true,
                        allowRecepcionistDeleteSale : true,
                        showCanceled : false,
                        showNoShow : false,
                        sendReminderEmail : false,
                        sendReminderEmail2 : false,
                        sendReminderSMS : false,
                        dddCode : '',
                        showTelephoneToProfessionals:true,
                        allowRecepcionistOpenComandaAntiga : false,
                        allowRecepcionistOpenComandaCaixaFechado:false,
                        allowNewSaleWithDebt : false,
                        taxes : 0,
                        fixedCost : 0,
                        notification : {
                        }
                    }

                } else {

                    vm.configuration = {};

                    if (response.d.allowProfessionalSendReminderSMS == 1){
                        vm.configuration.allowProfessionalSendReminderSMS = true;
                    } else {
                        vm.configuration.allowProfessionalSendReminderSMS = false;
                        vm.configuration.allowProfessionalSendReminderSMS = false;
                    }
                    if (response.d.allowUndoProfessionalReschedule == 1){
                        vm.configuration.allowUndoProfessionalReschedule = true;
                    } else {
                        vm.configuration.allowUndoProfessionalReschedule = false;
                    }
                    if (response.d.allowProfessionalCancelSchedule == 1){
                        vm.configuration.allowProfessionalCancelSchedule = true;
                    } else {
                        vm.configuration.allowProfessionalCancelSchedule = false;
                    }
                    if (response.d.allowUndoProfessionalCheckin == 1){
                        vm.configuration.allowUndoProfessionalCheckin = true;
                    } else {
                        vm.configuration.allowUndoProfessionalCheckin = false;
                    }
                    if (response.d.allowProfessionalCheckin == 1){
                        vm.configuration.allowProfessionalCheckin = true;
                    } else {
                        vm.configuration.allowProfessionalCheckin = false;
                    }
                    if (response.d.requestPasswordSchedule == 1){
                        vm.configuration.requestPasswordSchedule = true;
                    } else {
                        vm.configuration.requestPasswordSchedule = false;
                    }
                    if (response.d.requestPasswordCheckout == 1){
                        vm.configuration.requestPasswordCheckout = true;
                    } else {
                        vm.configuration.requestPasswordCheckout = false;
                    }
                    if (response.d.allowNewSaleWithoutCashier == 1){
                        vm.configuration.allowNewSaleWithoutCashier = true;
                    } else {
                        vm.configuration.allowNewSaleWithoutCashier = false;
                    }

                    if (response.d.allowScheduleByProfessional == 1){
                        vm.configuration.allowScheduleByProfessional = true;
                    } else {
                        vm.configuration.allowScheduleByProfessional = false;
                    }
                    if (response.d.allowCustomerEditByProfessional == 1){
                        vm.configuration.allowCustomerEditByProfessional = true;
                    } else {
                        vm.configuration.allowCustomerEditByProfessional = false;
                    }
                    if (response.d.transferServiceFromScheduleToSale == 1){
                        vm.configuration.transferServiceFromScheduleToSale = true;
                    } else {
                        vm.configuration.transferServiceFromScheduleToSale = false;
                    }
                    if (response.d.allowNewSaleWithDebt == 1){
                        vm.configuration.allowNewSaleWithDebt = true;
                    } else {
                        vm.configuration.allowNewSaleWithDebt = false;
                    }



                    if (response.d.requestPasswordBlock == 1){
                        vm.configuration.requestPasswordBlock = true;
                    } else {
                        vm.configuration.requestPasswordBlock = false;
                    }
                    if (response.d.showCanceled == 1){
                        vm.configuration.showCanceled = true;
                    } else {
                        vm.configuration.showCanceled = false;
                    }
                    if (response.d.showNoShow == 1){
                        vm.configuration.showNoShow = true;
                    } else {
                        vm.configuration.showNoShow = false;
                    }

                    if (response.d.sendReminderEmail == 1){
                        vm.configuration.sendReminderEmail = true;
                    } else {
                        vm.configuration.sendReminderEmail = false;
                    }
                    if (response.d.sendReminderEmail2 == 1){
                        vm.configuration.sendReminderEmail2 = true;
                    } else {
                        vm.configuration.sendReminderEmail2 = false;
                    }
                    if (response.d.sendReminderSMS == 1){
                        vm.configuration.sendReminderSMS = true;
                    } else {
                        vm.configuration.sendReminderSMS = false;
                    }
                    vm.configuration.notification = response.d.notification;
                    vm.configuration.whoPaysAuxiliar = response.d.whoPaysAuxiliar;
                    vm.configuration.dddCode = response.d.dddCode;
                    vm.configuration.countryCode = response.d.countryCode;
                    vm.configuration.taxes = response.d.taxes;
                    vm.configuration.fixedCost = response.d.fixedCost;


                    if (response.d.showTelephoneToProfessionals == 1) {
                        vm.configuration.showTelephoneToProfessionals = true;
                    } else {
                        vm.configuration.showTelephoneToProfessionals = false;
                    }


                    if (response.d.defaultCustomerSMS == 1) {
                        vm.configuration.defaultCustomerSMS = true;
                    } else {
                        vm.configuration.defaultCustomerSMS = false;
                    }
                    if (response.d.defaultCustomerEmail == 1) {
                        vm.configuration.defaultCustomerEmail = true;
                    } else {
                        vm.configuration.defaultCustomerEmail = false;
                    }

                    if (response.d.allowRecepcionistAddService == 1) {
                        vm.configuration.allowRecepcionistAddService = true;
                    } else {
                        vm.configuration.allowRecepcionistAddService = false;
                    }
                    if (response.d.allowRecepcionistAddProduct == 1) {
                        vm.configuration.allowRecepcionistAddProduct = true;
                    } else {
                        vm.configuration.allowRecepcionistAddProduct = false;
                    }

                    if (response.d.allowRecepcionistCreditCustomer == 1) {
                        vm.configuration.allowRecepcionistCreditCustomer = true;
                    } else {
                        vm.configuration.allowRecepcionistCreditCustomer = false;
                    }

                    if (response.d.allowRecepcionistSeeComandaFechada == 1) {
                        vm.configuration.allowRecepcionistSeeComandaFechada = true;
                    } else {
                        vm.configuration.allowRecepcionistSeeComandaFechada = false;
                    }

                    if (response.d.allowRecepcionistDeleteCustomer == 1) {
                        vm.configuration.allowRecepcionistDeleteCustomer = true;
                    } else {
                        vm.configuration.allowRecepcionistDeleteCustomer = false;
                    }

                    if (response.d.allowRecepcionistDeleteSale == 1) {
                        vm.configuration.allowRecepcionistDeleteSale = true;
                    } else {
                        vm.configuration.allowRecepcionistDeleteSale = false;
                    }

                    if (response.d.allowRecepcionistOpenComandaAntiga == 1) {
                        vm.configuration.allowRecepcionistOpenComandaAntiga = true;
                    } else {
                        vm.configuration.allowRecepcionistOpenComandaAntiga = false;
                    }

                    if (response.d.allowRecepcionistOpenComandaCaixaFechado == 1) {
                        vm.configuration.allowRecepcionistOpenComandaCaixaFechado = true;
                    } else {
                        vm.configuration.allowRecepcionistOpenComandaCaixaFechado = false;
                    }



                    //console.log(vm.configuration);

                }

            },
            function(error){
                console.log(error);
            });

        vm.saveConfiguration = function(){
            api.saveGeneralConfiguration.save({
                    configuration : vm.configuration
                },
                function(response){
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.GENERAL.TOAST.SAVE.SUCCESS"))
                            .hideDelay(2000)
                    );

                    $rootScope.pdvConfiguration = response.d;

                },
                function(error){
                    console.log(error);
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.GENERAL.TOAST.SAVE.ERROR"))
                            .hideDelay(2000)
                    );
                });
        }

        ////====================================================

        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({},last);
        $scope.getToastPosition = function() {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function(pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if ( current.bottom && last.top ) current.top = false;
            if ( current.top && last.bottom ) current.bottom = false;
            if ( current.right && last.left ) current.left = false;
            if ( current.left && last.right ) current.right = false;
            last = angular.extend({},current);
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.sales.servicePack',
        [
            // 3rd Party Dependencies
            'datatables'
        ]
    )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {


        $stateProvider.state('app.sales.servicePack', {
            url    : '/servicePack'
        }).state('app.sales.servicePack.list', {
            url    : '/list',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/sales/servicePack/list.html',
                    controller : 'SaleServicePackController as vm'
                }
            }
        }).state('app.sales.servicePack.new', {
            url    : '/sell',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/sales/servicePack/servicePack.html',
                    controller : 'SaleServicePackController as vm'
                }
            }

        });

    }

})();
(function () {
    'use strict';

    angular
        .module('app.sales.servicePack')
        .controller('SaleServicePackController', SaleServicePackController);

    /** @ngInject */
    function SaleServicePackController($q, $state, $scope, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder, api,
        DTDefaultOptions, $translate, $mdDialog, $mdToast, $rootScope) {
        var vm = this;
        //check if is edit, insert or nothing
        var currentState = $state.current.name;


        vm.showPdvLocation = false;
        vm.pdvLocations = $rootScope.pdvLocations;
        if (vm.pdvLocations.length > 1){
            vm.showPdvLocation = true;
            vm.pdvLocation = vm.pdvLocations[0].locationId;
        }



        //Initialize
        switch (currentState) {

            case "app.sales.servicePack.list":
                vm.showTable = false;
                vm.removeServicePack = removeServicePack;

                api.getServicePackSales.save({},
                    function (response) {

                        vm.priceTables = response.d;
                        
                        setTimeout(function () {
                            vm.showTable = true;
                            $scope.$apply();
                        }, 200)

                    },
                    function (error) {
                        console.log(error);
                    });

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({ autoWidth: false })
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable": "Nenhum registro disponível",
                        "sInfo": "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty": "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered": "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix": "",
                        "sInfoThousands": ",",
                        "sLengthMenu": "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing": "Processando...",
                        "sSearch": "Busca:",
                        "sZeroRecords": "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst": "Primeiro",
                            "sLast": "Ultimo",
                            "sNext": "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending": ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });

                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                break;



            case "app.sales.servicePack.new":
                
                vm.sale = {};                
                vm.saveAndClose = saveAndClose;                
                vm.customerSearchTextChange = customerSearchTextChange;
                              
                 api.getServicePacks.save({},
                    function (response) {

                        vm.servicePacks = response.d; 
                        vm.selectedPackName = vm.servicePacks[0].name; //pro select não mostrar um opção em branco

                    },
                    function (error) {
                        console.log(error);
                    });



                break;
        }

        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({}, last);
        $scope.getToastPosition = function () {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function (pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };

        function sanitizePosition() {
            var current = $scope.toastPosition;
            if (current.bottom && last.top) current.top = false;
            if (current.top && last.bottom) current.bottom = false;
            if (current.right && last.left) current.left = false;
            if (current.left && last.right) current.right = false;
            last = angular.extend({}, current);
        }
        ///END TOAST

        // functions
        
        function saveAndClose(){

            for (var i = 0; i < vm.servicePacks.length; i++)
            {
                if (vm.selectedPackName == vm.servicePacks[i].name)
                {                                        
                    vm.selectedPack = vm.servicePacks[i];
                    break;
                }
            }
            
            $mdDialog.show({
                controller: 'SalesServicePackCheckoutServiceController',
                controllerAs: 'vm',
                locals: {
                    //saleId: vm.sale._id,
                    items : vm.sale.items,
                    customer: vm.customer,
                    pack: vm.selectedPack,
                    pdvLocation : vm.pdvLocation

                },
                templateUrl: 'app/main/sales/servicePack/checkoutDialog2.html',
                clickOutsideToClose: false,
                clickEscapetoClose : true
            })
                .then(function (answer) {

                }, function () {
                    //
                });
        }


        ///customer autocomplete
        vm.customerNameSearchText = ""
        vm.customerSearchTextChange = customerSearchTextChange;
        vm.customerSearchItems = [];

        function filterForCustomers(query) {
            var uppercaseQuery = angular.uppercase(query);
            return function filterFn(customer) {
                return (customer.name.indexOf(uppercaseQuery) === 0);
            };
        }

        function customerSearchTextChange(search) {

            var deferred = $q.defer();
            api.customersSearch.save({
                    searchName : search
                },
                function(response){
                    deferred.resolve( response.d );
                },
                function(error){
                    console.log(error);
                });

            return deferred.promise;

        }



        function removeServicePack(saleId) {
            var confirm = $mdDialog.confirm()
                .title($translate.instant("SALES.CHECK.DIALOG.REMOVE.TITLE"))
                .textContent($translate.instant("SALES.CHECK.DIALOG.REMOVE.SUBTITLE"))
                .ariaLabel('Remove')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok($translate.instant("GENERAL.DIALOG.OK"))
                .cancel($translate.instant("GENERAL.DIALOG.CANCEL"));
            $mdDialog.show(confirm).then(function () {
                api.removeSale.save({
                    saleId: saleId
                },
                    function (response) {
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SALES.CHECK.TOAST.REMOVE.SUCCESS"))
                                .position(pinTo)
                                .hideDelay(2000)
                        );
                        //redirect
                        setTimeout(function () {
                            $state.reload();
                        }, 1000);
                    },
                    function (error) {
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.CHECK.TOAST.REMOVE.ERROR"))
                                .position(pinTo)
                                .hideDelay(1000)
                        );

                        //redirect
                        setTimeout(function () {
                            $state.reload();
                        }, 1000);

                    });
            });
        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.sales', ['ngMaterialDatePicker', 'app.sales.servicePack'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {

        $stateProvider.state('app.sales', {
            url    : '/sales'
        }).state('app.sales.open', {
            url    : '/open',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/sales/openList.html',
                    controller : 'SalesController as vm'
                }
            }

        }).state('app.sales.new', {
            url    : '/new',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/sales/sale.html',
                    controller : 'SalesController as vm'
                }
            }
        }).state('app.sales.checkout', {
            url    : '/checkout/:saleId',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/sales/checkout.html',
                    controller : 'SalesController as vm'
                }
            }
        })
        .state('app.sales.closed', {
            url: '/closed',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sales/closedList.html',
                    controller: 'SalesController as vm'
                }
            }
        })
            .state('app.sales.sellServicePack', {
                url: '/sellservicepack',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/sales/servicePack.html',
                        controller: 'ServicePackController as vm'
                    }
                }
            })


    }
})();
(function () {
    'use strict';

    angular
        .module('app.sales')
        .controller('SalesServicePackCheckoutServiceController', SalesCheckoutServiceController2);

    /** @ngInject */
    function SalesCheckoutServiceController2($q, $state, $scope, api, $translate, $mdDialog,
        $mdToast, items, customer, pack, $mdConstant, $rootScope, pdvLocation) {
        var vm = this;
        vm.saveCheckout = saveCheckout;
        vm.closeDialog = closeDialog;
        vm.clickToSave = clickToSave;
        vm.paymentType = 'CASH';
        var pdvConfObj = $rootScope.pdvConfiguration;
        var pdvConfiguration = {};

        vm.userTpe = $rootScope.userType;
        vm.giftCardValue = 0;

       vm.requestPassword = $rootScope.pdvConfiguration.requestPasswordCheckout;
        if (vm.requestPassword){
            vm.accessCode = "";
        }

        //settings total value
        vm.totalValue = 0;
        vm.totalValueWithSpecialPaymentType = 0;

        vm.totalValue = pack.price;
        vm.totalValueWithSpecialPaymentType = pack.cashPrice;

        vm.paid = 0;
        vm.updateAmountOwned = function () {

            var customerCreditDebit = 0;
            if (vm.customer != undefined && vm.customer.creditDebit != undefined) {
                customerCreditDebit = vm.customer.creditDebit
            }

            if ((vm.visaCreditPayment) || (vm.visaDebitPayment)
                || (vm.masterCreditPayment) || (vm.masterDebitPayment)
                || (vm.amexPayment) || (vm.dinersPayment)
                || (vm.eloCreditPayment) || (vm.eloDebitPayment) || (vm.otherCreditPayment)
                || (vm.otherDebitPayment)
                || (vm.customerDebitPayment)) {
                vm.amountOwned = vm.totalValue + (-1 * customerCreditDebit);
            } else {
                vm.amountOwned = vm.totalValueWithSpecialPaymentType + (-1 * customerCreditDebit);
            }

            vm.amountOwnedAfterDiscount = vm.amountOwned - vm.giftCardValue;
        }
        vm.updateAmountOwned();

        vm.updateAmountPaid = function () {

            var applyDiscount = true;
            if ((vm.visaCreditPayment) || (vm.visaDebitPayment)
                || (vm.masterCreditPayment) || (vm.masterDebitPayment)
                || (vm.amexPayment) || (vm.dinersPayment)
                || (vm.eloCreditPayment) || (vm.eloDebitPayment) || (vm.otherCreditPayment)
                || (vm.otherDebitPayment)
                || (vm.customerDebitPayment)) {
                applyDiscount = false;
            }

            var amount = 0;
            if ((vm.cashPayment) && (vm.paidWithCASH != null)) {
                amount += vm.paidWithCASH;
            }
            if ((vm.checkPayment) && (vm.paidWithCHECK != null)) {
                amount += vm.paidWithCHECK;
            }
            if ((vm.visaCreditPayment) && (vm.paidWithVisaCredit != null)) {
                amount += vm.paidWithVisaCredit;
            }
            if ((vm.visaDebitPayment) && (vm.paidWithVisaDebit != null)) {
                amount += vm.paidWithVisaDebit;
            }
            if ((vm.masterCreditPayment) && (vm.paidWithMasterCredit != null)) {
                amount += vm.paidWithMasterCredit;
            }
            if ((vm.masterDebitPayment) && (vm.paidWithMasterDebit != null)) {
                amount += vm.paidWithMasterDebit;
            }
            if ((vm.amexPayment) && (vm.paidWithAMEX != null)) {
                amount += vm.paidWithAMEX;
            }
            if ((vm.dinersPayment) && (vm.paidWithDINERS != null)) {
                amount += vm.paidWithDINERS;
            }
            if ((vm.eloDebitPayment) && (vm.paidWithELODebit != null)) {
                amount += vm.paidWithELODebit;
            }
            if ((vm.eloCreditPayment) && (vm.paidWithELOCredit != null)) {
                amount += vm.paidWithELOCredit;
            }
            if ((vm.otherCreditPayment) && (vm.paidWithOtherCredit != null)) {
                amount += vm.paidWithOtherCredit;
            }
            if ((vm.otherDebitPayment) && (vm.paidWithOtherDebit != null)) {
                amount += vm.paidWithOtherDebit;
            }
            if ((vm.customerDebitPayment) && (vm.paidWithCUSTOMERDEBIT != null)) {
                amount += vm.paidWithCUSTOMERDEBIT;
            }


            vm.paid = amount;
            vm.paidWithDiscount = vm.paid + vm.giftCardValue;

            //console.log(vm.paid);

            vm.updateAmountOwned();

        }

        ///WATCHES

        $scope.$watch('vm.customer.creditDebit', function (newValue, oldValue) {
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.newCustomerCreditDebit', function (newValue, oldValue) {
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.giftCardValue', function (newValue, oldValue) {
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.cashPayment', function (newValue, oldValue) {
            if (!vm.cashPayment) {
                vm.paidWithCASH = 0;
            }
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.paidWithCASH', function (newValue, oldValue) {
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.customerDebitPayment', function (newValue, oldValue) {
            if (!vm.customerDebitPayment) {
                vm.paidWithCUSTOMERDEBIT = 0;
            }
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.paidWithCUSTOMERDEBIT', function (newValue, oldValue) {
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.checkPayment', function (newValue, oldValue) {
            if (!vm.checkPayment) {
                vm.paidWithCHECK = 0;
            }
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.paidWithCHECK', function (newValue, oldValue) {
            vm.updateAmountPaid();
        })

        $scope.$watch('vm.visaCreditPayment', function (newValue, oldValue) {
            if (!vm.visaCreditPayment) {
                vm.paidWithVisaCredit = 0;
            }
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.paidWithVisaCredit', function (newValue, oldValue) {
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.visaDebitPayment', function (newValue, oldValue) {
            if (!vm.visaDebitPayment) {
                vm.paidWithVisaDebit = 0;
            }
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.paidWithVisaDebit', function (newValue, oldValue) {
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.masterCreditPayment', function (newValue, oldValue) {
            if (!vm.masterCreditPayment) {
                vm.paidWithMasterCredit = 0;
            }
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.paidWithMasterCredit', function (newValue, oldValue) {
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.masterDebitPayment', function (newValue, oldValue) {
            if (!vm.masterDebitPayment) {
                vm.paidWithMasterDebit = 0;
            }
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.paidWithMasterDebit', function (newValue, oldValue) {
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.amexPayment', function (newValue, oldValue) {
            if (!vm.amexPayment) {
                vm.paidWithAMEX = 0;
            }
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.paidWithAMEX', function (newValue, oldValue) {
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.dinersPayment', function (newValue, oldValue) {
            if (!vm.dinersPayment) {
                vm.paidWithDINERS = 0;
            }
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.paidWithDINERS', function (newValue, oldValue) {
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.eloCreditPayment', function (newValue, oldValue) {
            if (!vm.eloCreditPayment) {
                vm.paidWithELOCredit = 0;
            }
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.paidWithELOCredit', function (newValue, oldValue) {
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.eloDebitPayment', function (newValue, oldValue) {
            if (!vm.eloDebitPayment) {
                vm.paidWithELODebit = 0;
            }
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.paidWithELODebit', function (newValue, oldValue) {
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.otherCreditPayment', function (newValue, oldValue) {
            if (!vm.otherCreditPayment) {
                vm.paidWithOtherCredit = 0;
            }
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.paidWithOtherCredit', function (newValue, oldValue) {
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.otherDebitPayment', function (newValue, oldValue) {
            if (!vm.otherDebitPayment) {
                vm.paidWithOtherDebit = 0;
            }
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.paidWithOtherDebit', function (newValue, oldValue) {
            vm.updateAmountPaid();
        })

        //verificando credito e debito
        vm.customer = customer;
        //console.log(vm.customer);
        if ((vm.customer.creditDebitTransactions != undefined) && (vm.customer.creditDebitTransactions.length > 0)) {
            vm.customer.lastCreditDebitObservation = vm.customer.creditDebitTransactions[vm.customer.creditDebitTransactions.length - 1].observation;
        } else {
            vm.customer.lastCreditDebitObservation = 0;
        }

        if (vm.customer.creditDebit == null) {
            vm.customer.creditDebit = 0;
        }

        //////////
        function closeDialog() {
            $mdDialog.cancel();
        }
        function clickToSave() {
            if (false && pdvConfiguration.requestPasswordCheckout) {

                $mdDialog.show({
                    template: [
                        '<md-dialog md-theme="{{ dialog.theme || dialog.defaultTheme }}" aria-label="{{ dialog.ariaLabel }}" ng-class="dialog.css">',
                        '  <md-dialog-content class="md-dialog-content" role="document" tabIndex="-1">',
                        '    <h2 class="md-title">{{ dialog.title }}</h2>',
                        '    <div class="md-dialog-content-body">',
                        '      <p>Informe a sua senha</p>',
                        '    </div>',
                        '    <md-input-container md-no-float class="md-prompt-input-container">',
                        '      <input type=password ng-keypress="dialog.keypress($event)" md-autofocus ng-model="dialog.result" ' +
                        '             placeholder="{{::dialog.placeholder}}">',
                        '    </md-input-container>',
                        '  </md-dialog-content>',
                        '  <md-dialog-actions>',
                        '    <md-button ng-click="dialog.abort()" class="md-primary md-cancel-button">',
                        '      {{ dialog.cancel }}',
                        '    </md-button>',
                        '    <md-button ng-click="dialog.hide()" class="md-primary md-confirm-button" >',
                        '      {{ dialog.ok }}',
                        '    </md-button>',
                        '  </md-dialog-actions>',
                        '</md-dialog>'
                    ].join('').replace(/\s\s+/g, ''),
                    multiple: true,
                    controller: function mdDialogCtrl() {
                        this.title = "Confirmação";
                        this.placeholder = "Senha";
                        this.ok = 'Confirmar';
                        this.cancel = 'Cancelar';
                        this.mdTextContent = "Informe sua senha";

                        this.hide = function () {
                            $mdDialog.hide(this.result);
                        };
                        this.abort = function () {
                            $mdDialog.cancel();
                        };
                        this.keypress = function ($event) {
                            if ($event.keyCode === $mdConstant.KEY_CODE.ENTER) {
                                $mdDialog.hide(this.result);
                            }
                        };
                    },
                    controllerAs: 'dialog',
                    bindToController: true,

                })
                    .then(function (result) {
                        console.log(result);
                        //check password
                        api.checkPassword.save({
                            password: result
                        },
                            function (response) {
                                if (response.d) {
                                    $mdDialog.hide();
                                    saveCheckout();
                                } else {
                                    $mdToast.show(
                                        $mdToast.simple()
                                            .textContent($translate.instant("AUTH.WRONG_PASSWORD"))
                                            .hideDelay(1000)
                                    );
                                    // $mdDialog.hide();


                                }

                            },
                            function (error) {


                            });
                    }, function () {
                        $mdDialog.cancel();
                    });

            } else {
                saveCheckout();
            }
        }
        function saveCheckout() {

            var customerCreditDebit = 0;

            customerCreditDebit = vm.paid - vm.amountOwnedAfterDiscount - vm.paidWithCUSTOMERDEBIT;


            //return;            
            api.sellServicePack.save(

                {
                    customerId: customer._id,
                    servicePackId: pack._id,
                    paymentType: vm.paymentType,
                    authorizationCode: 12,
                    sellDate: Date.now(),
                    paid: vm.paid,
                    pdvLocationId : pdvLocation,
                    debitPayment: vm.paidWithCUSTOMERDEBIT,
                    customerCreditDebit: customerCreditDebit,
                    servicePackName: pack.name,
                    paidWithCASH: vm.paidWithCASH,
                    paidWithVisaCredit: vm.paidWithVisaCredit,
                    paidWithVisaDebit: vm.paidWithVisaDebit,
                    paidWithMasterCredit: vm.paidWithMasterCredit,
                    paidWithMasterDebit: vm.paidWithMasterDebit,
                    paidWithAMEX: vm.paidWithAMEX,
                    paidWithDINERS: vm.paidWithDINERS,
                    paidWithELOCredit : vm.paidWithELOCredit,
                    paidWithELODebit : vm.paidWithELODebit,
                    paidWithOtherCredit: vm.paidWithOtherCredit,
                    paidWithOtherDebit: vm.paidWithOtherDebit,
                    authorizationCodeVisaCredit: vm.authorizationCodeVisaCredit,
                    authorizationCodeVisaDebit: vm.authorizationCodeVisaDebit,
                    authorizationCodeMasterCredit: vm.authorizationCodeMasterCredit,
                    authorizationCodeMasterDebit: vm.authorizationCodeMasterDebit,
                    authorizationCodeAMEX: vm.authorizationCodeAMEX,
                    authorizationCodeDINERS: vm.authorizationCodeDINERS,
                    authorizationCodeELOCredit : vm.authorizationCodeELOCredit,
                    authorizationCodeELODebit : vm.authorizationCodeELODebit,
                    authorizationCodeOtherCredit: vm.authorizationCodeOtherCredit,
                    authorizationCodeOtherDebit: vm.authorizationCodeOtherDebit

                },
                function (response) {
                    $mdDialog.hide();

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SALES.CHECKOUT.TOAST.SAVE.SUCCESS"))
                            .hideDelay(2000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.go('app.sales.servicePack.list');
                    }, 1000);
                },
                function (error) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SALES.CHECKOUT.TOAST.SAVE.ERROR"))
                            .hideDelay(1000)
                    );

                    //redirect
                    setTimeout(function () {
                        $state.go('app.sales.servicePack.list');
                    }, 1000);

                }

            );
        }
    }


})();
(function ()
{
    'use strict';

    angular
        .module('app.report.woweepay',
        [
            // 3rd Party Dependencies
            'datatables',
            'datatables.buttons'
        ]
    )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {


        $stateProvider.state('app.report.woweepay', {
            url    : '/woweepay'
        }).state('app.report.woweepay.extrato', {
            url    : '/extrato',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/report/woweepay/extrato.html',
                    controller : 'ReportWoweePayController as vm'
                }
            }
        }).state('app.report.woweepay.vendas', {
            url    : '/vendas',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/report/woweepay/vendas.html',
                    controller : 'ReportWoweePayController as vm'
                }
            }
        }).state('app.report.woweepay.lancamentosFuturos', {
            url    : '/lancamentosFuturos',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/report/woweepay/lancamentosFuturos.html',
                    controller : 'ReportWoweePayController as vm'
                }
            }
        }).state('app.report.woweepay.pagamentos', {
            url    : '/pagamentos',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/report/woweepay/pagamentos.html',
                    controller : 'ReportWoweePayController as vm'
                }
            }
        })


    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.report.woweepay')
        .controller('ReportWoweePayController', ReportController);

    /** @ngInject */
    function ReportController($mdSidenav, $state, $scope,DTOptionsBuilder,DTColumnBuilder,DTColumnDefBuilder, api,
                                    DTDefaultOptions, $translate, $mdDialog, $mdToast, $rootScope, $window,
                              $compile, $timeout, $filter)
    {
        var vm = this;


        //PRINT function
        vm.print = function(){
            var table = document.getElementById('printArea').innerHTML;
            var myWindow = $window.open('', '', 'width=800, height=600');
            myWindow.document.write("<h1><center>" + vm.title + "</center></h1>");
            myWindow.document.write(table);
            myWindow.print();
        };

        vm.filter = {}
        vm.filter.dtFrom = new Date(new moment().add(-30, 'days').valueOf());
        vm.filter.dtTo = new Date(new moment().valueOf())

        switch($state.current.name){

            case 'app.report.woweepay.lancamentosFuturos':
                vm.showTable = true;
                vm.title = "WoWee Pay - Lançamentos Futuros"
                vm.refresh = refreshLancamentosFuturos;

                vm.openFilter = function(){
                    $mdSidenav('filter')
                        .toggle()
                        .then(function () {

                        });
                }

                refreshLancamentosFuturos();
                break;
            case 'app.report.woweepay.extrato':
                vm.showTable = true;
                vm.title = "WoWee Pay - Extrato"
                vm.refresh = refreshExtrato;

                vm.openFilter = function(){
                    $mdSidenav('filter')
                        .toggle()
                        .then(function () {

                        });
                }

                refreshExtrato();
                break;
            case 'app.report.woweepay.pagamentos':
                vm.showTable = true;
                vm.title = "WoWee Pay - Pagamentos"
                vm.refresh = refreshPagamentos;

                vm.openFilter = function(){
                    $mdSidenav('filter')
                        .toggle()
                        .then(function () {

                        });
                }

                refreshPagamentos();
                break;
            case 'app.report.woweepay.vendas':
                vm.showTable = true;
                vm.title = "WoWee Pay - Vendas"
                vm.refresh = refreshVendas;
                console.log(vm.refresh);

                vm.openFilter = function(){
                    $mdSidenav('filter')
                        .toggle()
                        .then(function () {

                        });
                }

                refreshVendas();
                break;


        }
        //////////
        function refreshLancamentosFuturos(){
            setFilter();

            api.getWoweePayLancamentosFuturos.save({
                    filter : vm.finalFilter
                },
                function(response){
                    vm.showTable = true;
                    vm.saldo = 0;
                    var html = "";
                    var data = "";
                    var first = true;
                    var totalDia = 0;


                    for(var i=0; i < response.d.length; i++){
                        if (data != new moment(response.d[i].expected_on).format('DD/MM/YYYY')){

                            if (!first){
                                html += "<tr>";
                                html += "<td><b>Total do dia: " + $filter('currency')(totalDia, 'R$',2) + " </b></td>";
                                html += "<td></td>";
                                html += "<td></td>";
                                html += "<td></td>";
                                html += "</tr>";
                                totalDia = 0;
                            } else {
                                first = false;
                            }



                            html += "<tr style='background: silver'>";
                            html += "<td colspan='7' align='center'><b>Pagamento previsto para " + new moment(response.d[i].expected_on).add(1,'days').format('DD/MM/YYYY') +  "</b></td>";
                            html += "</tr>";
                            data = new moment(response.d[i].expected_on).format('DD/MM/YYYY');
                        }
                        totalDia += parseFloat(response.d[i].valorLiquido);
                        console.log(totalDia);

                        html += "<tr>";
                        //html += "<td>" + response.d[i].saleId  + "</td>"
                        //html += "<td>" + response.d[i].customerName  + "</td>"
                        //html += "<td>" + response.d[i].services  + "</td>"
                        //html += "<td>" + $filter('date')(response.d[i].dataVenda, "dd/MM/yyyy") + "</td>";
                        //html += "<td>" + $filter('date')(response.d[i].expected_on, "dd/MM/yyyy") + "</td>";
                        html += "<td>" + response.d[i].idZoop + "</td>";
                        html += "<td>" + $filter('currency')(response.d[i].valorBruto, 'R$',2) + "</td>";
                        html += "<td>" + $filter('currency')(response.d[i].taxa, 'R$',2) + "</td>";
                        html += "<td>" + $filter('currency')(response.d[i].valorLiquido, 'R$',2) + "</td>";
                        html += "</tr>";

                    }

                    html += "<tr>";
                    html += "<td><b>Total do dia: " + $filter('currency')(totalDia, 'R$',2) + " </b></td>";
                    html += "<td></td>";
                    html += "<td></td>";
                    html += "<td></td>";
                    html += "</tr>";


                    vm.html = html;

                },
                function(error){
                    console.log(error);
                });
        }

        //////////
        function refreshVendas(){
            setFilter();


            api.getWoweePayVendas.save({
                    filter : vm.finalFilter
                },
                function(response){
                    vm.showTable = true;
                    vm.saldo = 0;
                    var html = "";

                    for(var i=0; i < response.d.length; i++){
                        html += "<tr>";
                        html += "<td>" + response.d[i].saleId  + "</td>"
                        html += "<td>" + response.d[i].idZoop + "</td>";
                        html += "<td>" + $filter('date')(response.d[i].dataVenda, "dd/MM/yyyy") + "</td>";
                        html += "<td>" + response.d[i].customerName  + "</td>"
                        html += "<td>" + response.d[i].services  + "</td>"
                        switch (response.d[i].status) {
                            case "succeeded":
                                html += "<td style='color: green'>" + "Aprovada" + "</td>";
                                break;
                            case "reversed":
                                html += "<td style='color: red'>" + "Revertida" + "</td>";
                                break;
                            default:
                                html += "<td>" + response.d[i].status + "</td>";
                                break;

                        }


                        html += "<td>" + response.d[i].meioPagamento + "</td>";
                        html += "<td>" + $filter('currency')(response.d[i].valorBruto, 'R$',2) + "</td>";
                        //html += "<td>" + $filter('currency')(response.d[i].taxa, 'R$',2) + "</td>";
                        //html += "<td>" + $filter('currency')(response.d[i].valorLiquido, 'R$',2) + "</td>";
                        html += "</tr>";

                    }

                    /*html += "<tr>";
                    html += "<td><b>Total</b></td>";
                    html += "<td></td>";
                    html += "<td></td>";
                    html += "<td></td>";
                    html += "<td></td>";
                    html += "<td></td>";
                    html += "<td></td>";
                    html += "<td><b>" + $filter('currency')(vm.saldo, 'R$',2) + "</b></td>";
                    html += "</tr>";*/

                    vm.html = html;

                },
                function(error){
                    console.log(error);
                });
        }
        //////////
        function refreshExtrato(){
            setFilter();
            console.log('oi');

            api.getWoweePayExtrato.save({
                    filter : vm.finalFilter
                },
                function(response){
                    vm.showTable = true;
                    vm.saldo = 0;
                    var html = "";
                    var data = "";
                    var first = true;
                    var currentBalance = 0;



                    for(var i=0; i < response.d.length; i++){

                        if (data != new moment(response.d[i].date).format('DD/MM/YYYY')){

                            if (!first){
                                html += "<tr>";
                                html += "<td><b>Total do dia: " + $filter('currency')(currentBalance, 'R$',2) + " </b></td>";
                                html += "<td></td>";
                                html += "<td></td>";
                                html += "<td></td>";
                                html += "<td></td>";
                                html += "<td></td>";
                                html += "<td></td>";
                                html += "</tr>";
                            } else {
                                first = false;
                            }

                            currentBalance = response.d[i].currentBalance;

                            html += "<tr style='background: silver'>";
                            html += "<td colspan='7' align='center'><b>" + new moment(response.d[i].date).format('DD/MM/YYYY') +  "</b></td>";
                            html += "</tr>";
                            data = new moment(response.d[i].date).format('DD/MM/YYYY');
                        }

                        html += "<tr>";
                        switch (response.d[i].type) {
                            case "charge_refunded":
                                html += "<td style='color: red'>Venda Estornada</td>"
                                break;
                            case "charge":
                                html += "<td style='color: green'>Venda</td>"
                                break;
                            case "deposit":
                                html += "<td>Depósito</td>"
                                break;
                            case "transfer":
                                html += "<td>Transferência enviada</td>"
                                break;
                            default:
                                html += "<td>" + response.d[i].type  + "</td>"
                                break;
                        }

                        html += "<td>" + response.d[i].nsu  + "</td>"
                        if (response.d[i].transaction != null){
                            html += "<td>" + response.d[i].transaction.authorization_code  + "</td>"
                        } else {
                            html += "<td>-</td>"
                        }

                        html += "<td>" + response.d[i].description + "</td>";

                        if (response.d[i].gross_amount < 0){
                            html += "<td syle='color:red'>" + $filter('currency')(response.d[i].gross_amount, 'R$',2) + "</td>";
                        } else {
                            html += "<td syle='color:green'>" + $filter('currency')(response.d[i].gross_amount, 'R$',2) + "</td>";
                        }

                        if (response.d[i].fee < 0) {
                            html += "<td  syle='color:red'>" + $filter('currency')(response.d[i].fee, 'R$',2) + "</td>";
                        } else {
                            html += "<td  syle='color:green'>" + $filter('currency')(response.d[i].fee, 'R$',2) + "</td>";
                        }

                        if (response.d[i].amount < 0){
                            html += "<td  syle='color:red'>" + $filter('currency')(response.d[i].amount, 'R$',2) + "</td>";
                        } else {
                            html += "<td  syle='color:green'>" + $filter('currency')(response.d[i].amount, 'R$',2) + "</td>";
                        }


                        html += "</tr>";

                    }

                    html += "<tr>";
                    html += "<td><b>Total do dia: " + $filter('currency')(currentBalance, 'R$',2) + " </b></td>";
                    html += "<td></td>";
                    html += "<td></td>";
                    html += "<td></td>";
                    html += "<td></td>";
                    html += "<td></td>";
                    html += "<td></td>";
                    html += "</tr>";

                    vm.html = html;

                },
                function(error){
                    console.log(error);
                });
        }
        //////////
        function refreshPagamentos(){
            setFilter();

            api.getWoweePayPagamentos.save({
                    filter : vm.finalFilter
                },
                function(response){
                    vm.showTable = true;
                    vm.saldo = 0;
                    var html = "";

                    for(var i=0; i < response.d.length; i++){
                        html += "<tr>";
                        html += "<td>" + $filter('date')(response.d[i].data, "dd/MM/yyyy") + "</td>";
                        switch (response.d[i].status) {
                            case "succeeded":
                                html += "<td style='color: green'>" + "Aprovada" + "</td>";
                                break;
                            case "reversed":
                                html += "<td style='color: red'>" + "Revertida" + "</td>";
                                break;
                            default:
                                html += "<td>" + response.d[i].status + "</td>";
                                break;

                        }
                        html += "<td>" + response.d[i].codigoAutorizacao  + "</td>"
                        html += "<td>" + response.d[i].banco  + "</td>"
                        html += "<td>" + response.d[i].agencia  + "</td>"
                        html += "<td>" + response.d[i].conta  + "</td>"
                        html += "<td>" + $filter('currency')(response.d[i].valorBruto, 'R$',2) + "</td>";
                        html += "</tr>";

                    }

                    vm.html = html;

                },
                function(error){
                    console.log(error);
                });
        }



        function setFilter(){
            vm.finalFilter = {};

            //settng data
            vm.finalFilter.dtFrom = vm.filter.dtFrom.valueOf();
            vm.finalFilter.dtTo = vm.filter.dtTo.valueOf();

        }


    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.report.sales',
        [
            // 3rd Party Dependencies
            'datatables',
            'datatables.buttons',
            'gridshore.c3js.chart'
        ]
    )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {


        $stateProvider.state('app.report.sales', {
            url    : '/sales'
        }).state('app.report.sales.salesPerProfessional', {
            url    : '/salesPerProfessional',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/report/sales/salesPerProfessional.html',
                    controller : 'ReportSalesController as vm'
                }
            }
        }).state('app.report.sales.salesPerProfessionalM', {
            url    : '/salesPerProfessionalM/:token',
            views  : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.report.sales.salesPerProfessionalM': {
                    templateUrl: 'app/main/report/sales/salesPerProfessional.html',
                    controller : 'ReportSalesController as vm'
                }
            }
        }).state('app.report.sales.salesPerCategory', {
            url    : '/salesPerCategory',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/report/sales/salesPerCategory.html',
                    controller : 'ReportSalesController as vm'
                }
            }
        }).state('app.report.sales.salesPerCategoryM', {
            url    : '/salesPerCategoryM/:token',
            views  : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.report.sales.salesPerCategoryM': {
                    templateUrl: 'app/main/report/sales/salesPerCategory.html',
                    controller : 'ReportSalesController as vm'
                }
            }
        }).state('app.report.sales.salesAnalytics', {
            url    : '/salesAnalytics',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/report/sales/salesAnalytics.html',
                    controller : 'ReportSalesController as vm'
                }
            }
        }).state('app.report.sales.salesAnalyticsM', {
            url    : '/salesAnalyticsM/:token',
            views  : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.report.sales.salesAnalyticsM': {
                    templateUrl: 'app/main/report/sales/salesAnalytics.html',
                    controller : 'ReportSalesController as vm'
                }
            }
        }).state('app.report.sales.salesSynthethic', {
            url    : '/salesSynthethic',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/report/sales/salesSynthethic.html',
                    controller : 'ReportSalesController as vm'
                }
            }
        }).state('app.report.sales.salesSynthethicM', {
            url    : '/salesSynthethicM/:token',
            views  : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.report.sales.salesSynthethicM': {
                    templateUrl: 'app/main/report/sales/salesSynthethic.html',
                    controller : 'ReportSalesController as vm'
                }
            }
        });




    }

})();
(function () {
    'use strict';

    angular
        .module('app.report.sales')
        .controller('ReportSalesController', ReportController);

    /** @ngInject */
    function ReportController($mdSidenav, $state, $scope, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder, api,
        DTDefaultOptions, $translate, $mdDialog, $mdToast, $rootScope, $window,
        $compile, $timeout, $filter) {
        var vm = this;


        //PRINT function
        vm.print = function () {
            var table = document.getElementById('printArea').innerHTML;
            var myWindow = $window.open('', '', 'width=800, height=600');
            myWindow.document.write("<h1><center>" + vm.title + "</center></h1>");
            myWindow.document.write(table);
            myWindow.print();
        };

        //GET OUTSIDE TOKEN FOR MOBILE
        if ( ($state.current.name == 'app.report.sales.salesPerProfessionalM') ||
            ($state.current.name == 'app.report.sales.salesPerCategoryM') ||
            ($state.current.name == 'app.report.sales.salesAnalyticsM') ||
            ($state.current.name == 'app.report.sales.salesSynthethicM') ){
            var token = $state.params.token;
            token = token.replace("##!##", ".");
            token = token.replace("##!##", ".");
            token = token.replace("##!##", ".");
            $rootScope.securityToken = token;
            $rootScope.$emit('changeToken', []);
            vm.mobile = true;
        } else {
            vm.mobile = false;
        }



        ///FILTER
        api.allSimpleProfessionals.save({},
            function(response){
                vm.professionals =  response.d;

                //console.log(response.d);

                var arTemp = [];
                for( var i=0; i < response.d.length; i++){
                    if ((response.d[i].security == 'MASTER') || (response.d[i].security == 'ADMIN')
                        || (response.d[i].security == 'RECEPCIONIST')){
                        arTemp.push(response.d[i]);
                    }

                }
                vm.users =  arTemp;

            },
            function(error){
                console.log(error);
            });
        api.serviceCategories.save({},
            function (response) {
                vm.serviceCategories = response.d;
            },
            function (error) {
                console.log(error);
            });
        api.productCategories.save({},
            function (response) {
                vm.productCategories = response.d;
            },
            function (error) {
                console.log(error);
            });

        //configuracoes de filtro
        vm.filter = {
            dtFrom: new Date(new moment().add(-1, 'd').valueOf()),
            dtTo: new Date()
        }

        vm.showPdvLocation = false;
        vm.pdvLocations = $rootScope.pdvLocations;

        if ((vm.pdvLocations != undefined) && (vm.pdvLocations.length > 1)){
            vm.showPdvLocation = true;
            vm.pdvLocation = vm.pdvLocations[0].locationId;
        }


        switch ($state.current.name) {

            case 'app.report.sales.salesPerProfessionalM':
            case 'app.report.sales.salesPerProfessional':
                vm.showTable = false;
                vm.refresh = refreshSalesPerProfessional;
                vm.title = "Comissões"

                vm.openFilter = function () {
                    $mdSidenav('filter')
                        .toggle()
                        .then(function () {

                        });
                }

                refreshSalesPerProfessional();

                break;
            case 'app.report.sales.salesPerCategoryM':
            case 'app.report.sales.salesPerCategory':
                vm.showTable = false;
                vm.refresh = refreshSalesPerCategory;
                vm.title = "Vendas por Categoria"


                vm.openFilter = function () {
                    $mdSidenav('filter')
                        .toggle()
                        .then(function () {

                        });
                }

                refreshSalesPerCategory();

                break;

            case 'app.report.sales.salesAnalyticsM':
            case 'app.report.sales.salesAnalytics':
                vm.showTable = true;
                vm.refresh = refreshSalesAnalytics;
                vm.title = "Vendas Analítico"


                vm.openFilter = function () {
                    $mdSidenav('filter')
                        .toggle()
                        .then(function () {

                        });
                }

                refreshSalesAnalytics();


                break;
            case 'app.report.sales.salesSynthethicM':
            case 'app.report.sales.salesSynthethic':
                vm.showTable = true;
                vm.refresh = refreshSalesSynthethic;
                vm.title = "Vendas Sintético"


                vm.openFilter = function () {
                    $mdSidenav('filter')
                        .toggle()
                        .then(function () {

                        });
                }

                refreshSalesSynthethic();


                break;

        }
        //////////
        function refreshSalesAnalytics() {
            setFilter();

            api.salesAnalytics.save({
                filter: vm.finalFilter
            },
                function (response) {
                    vm.sales = response.d;

                    vm.totalPrice = 0;
                    vm.totalComission = 0;
                    vm.totalComissionPrice = 0;
                    vm.totalComissionAjudante = 0;

                    var html = "";

                    //todo
                    for (var i = 0; i < response.d.length; i++) {
                        html += "<tr style='font-size:11px'>";
                        html += "<td>" + $filter('date')(response.d[i].checkoutDate, "dd/MM/yyyy HH:mm") + "</td>";
                        if ((!vm.mobile) && (vm.showPdvLocation)){
                            html += "<td>" + response.d[i].location + "</td>";
                        }
                        if (!vm.mobile) {
                            html += "<td>" + response.d[i].who + "</td>";
                        }
                        html += "<td>" + response.d[i].customerName + "</td>";
                        html += "<td>" + response.d[i].professionalName + "</td>";
                        html += "<td>" + response.d[i].ajudante + "</td>";
                        html += "<td>" + response.d[i].serviceName + "</td>";
                        html += "<td>" + $filter('currency')(response.d[i].servicePrice, 'R$', 2) + "</td>";
                        if (!vm.mobile) {
                            html += "<td>" + $filter('currency')(response.d[i].comissionPrice, 'R$', 2) + "</td>";
                        }
                        if (!vm.mobile) {
                            html += "<td>" + $filter('currency')(response.d[i].comission, 'R$', 2) + " ( " +
                                response.d[i].comissionPercentage
                                + "% )</td>";
                        }
                        if (!vm.mobile) {
                            html += "<td>" + $filter('currency')(response.d[i].comissionAjudante, 'R$', 2) + " ( " +
                                response.d[i].comissionPercentageAjudante
                                + "% )</td>";
                        }

                        html += "</tr>";

                        vm.totalPrice += response.d[i].servicePrice;
                        vm.totalComissionPrice += response.d[i].comissionPrice;
                        vm.totalComission += response.d[i].comission;
                        vm.totalComissionAjudante += response.d[i].comissionAjudante;

                    }

                    //TOTAIZADOR
                    html += "<tr style='font-size:13px'>";
                    html += "<td><b>Totais</b></td>";
                    html += "<td>" + "</td>";
                    html += "<td>" + "</td>";
                    html += "<td>" + "</td>";
                    html += "<td>" + "</td>";
                    if ((!vm.mobile) && (vm.showPdvLocation)) {
                        html += "<td>" + "</td>";
                    }

                    //html += "<td><b>" + $filter('currency')(vm.totalPrice, 'R$',2) + "</b></td>";

                    html += "<td>" + "</td>";
                    html += "<td><b>" + $filter('currency')(vm.totalPrice, 'R$', 2) + "</b></td>";
                    html += "<td><b>" + $filter('currency')(vm.totalComissionPrice, 'R$', 2) + "</b></td>";
                    html += "<td><b>" + $filter('currency')(vm.totalComission, 'R$', 2) + "</b></td>";
                    html += "<td><b>" + $filter('currency')(vm.totalComissionAjudante, 'R$', 2) + "</b></td>";
                    html += "</tr>";

                    vm.html = html;

                    vm.showTable = true;
                },
                function (error) {
                    console.log(error);
                });
        }

        function refreshSalesSynthethic() {

            setFilter();

            api.salesSynthethic.save({
                filter: vm.finalFilter
            },
                function (response) {


                    vm.countTotal = 0;
                    vm.sumTotal = 0;

                    vm.countTotalEnd = 0;
                    vm.sumTotalEnd = 0;

                    var html = "";
                    var category = ""


                    for (var i = 0; i < response.d.length; i++) {

                        if (response.d[i].category != category) {
                            if (category != "") {
                                //totalizado
                                html += "<tr style='background-color:silver'>";
                                html += "<td colspan=2><b>Total</b></td>";
                                html += "<td><b>" + vm.countTotal + "</b></td>";
                                html += "<td><b>" + $filter('currency')(vm.sumTotal, 'R$', 2) + "</b></td>";
                                html += "</tr>";
                            }

                            vm.countTotal = 0;
                            vm.sumTotal = 0;
                            category = response.d[i].category;
                            html += "<tr>";
                            html += "<td colspan=4><b>" + response.d[i].category + "</b></td>";
                            html += "</tr>";

                        }
                        html += "<tr>";
                        html += "<td>&nbsp;</td>";
                        html += "<td>" + response.d[i].service + "</td>";
                        html += "<td>" + response.d[i].totalServices + "</td>";
                        html += "<td>" + $filter('currency')(response.d[i].sumServices, 'R$', 2) + "</td>";
                        html += "</tr>";

                        vm.countTotal += response.d[i].totalServices;
                        vm.sumTotal += response.d[i].sumServices;

                        vm.countTotalEnd += response.d[i].totalServices;
                        vm.sumTotalEnd += response.d[i].sumServices;

                    }

                    //TOTAIZADOR
                    html += "<tr style='background-color:silver'>";
                    html += "<td colspan=2><b>Totais</b></td>";
                    html += "<td><b>" + vm.countTotal + "</b></td>";
                    html += "<td><b>" + $filter('currency')(vm.sumTotal, 'R$', 2) + "</b></td>";
                    html += "</tr>";

                    html += "<tr style='background-color:silver'>";
                    html += "<td colspan=2><b>Total Geral</b></td>";
                    html += "<td><b>" + vm.countTotalEnd + "</b></td>";
                    html += "<td><b>" + $filter('currency')(vm.sumTotalEnd, 'R$', 2) + "</b></td>";
                    html += "</tr>";

                    vm.html = html;


                    vm.showTable = true;
                },
                function (error) {
                    console.log(error);
                });

        }

        function refreshSalesPerProfessional() {

            setFilter();

            api.comissionReport.save({
                filter: vm.finalFilter
            },
                function (response) {
                    vm.totalSale = 0;
                    vm.totalComitionSale = 0;
                    vm.totalComissionOwned = 0;
                    vm.totalParteSalaoBruta=0;
                    vm.totalParteSalaoLiq=0;
                    var total = 0;


                    var html = "";


                    //montando array temp
                    var arTemp = []
                    for (var obj in response.d) {
                        if ((response.d[obj].professionalName != null) && (response.d[obj].professionalId != null)){
                            arTemp.push(response.d[obj]);
                        }

                    }

                    //sort
                    arTemp.sort(function(a, b){
                        return a.professionalName.localeCompare(b.professionalName);
                    })



                    for (var i=0 ; i < arTemp.length; i++) {

                        if ((arTemp[i].professionalName != undefined) && (arTemp[i].comissionOwned > 0)){
                            html += "<tr>";
                            html += "<td>" + arTemp[i].professionalName + "</td>";
                            html += "<td>" + $filter('currency')(arTemp[i].totalSale, 'R$', 2) + "</td>";
                            html += "<td>" + $filter('currency')(arTemp[i].totalComitionSale, 'R$', 2) + "</td>";
                            html += "<td>" + $filter('currency')(arTemp[i].comissionOwned, 'R$', 2) + "</td>";
                            html += "<td>" + $filter('currency')(arTemp[i].parteSalaoBruta, 'R$', 2) + "</td>";
                            html += "<td>" + $filter('currency')(arTemp[i].parteSalaoLiq, 'R$', 2) + "</td>";
                            html += "<td>" + $filter('number')(arTemp[i].parteSalaoLiq/arTemp[i].totalComitionSale * 100, 0) + '%' + "</td>";
                            html += "</tr>";

                            total += arTemp[i].totalSale;
                            vm.totalComitionSale += arTemp[i].totalComitionSale;
                            vm.totalComissionOwned += arTemp[i].comissionOwned;
                            vm.totalParteSalaoBruta += arTemp[i].parteSalaoBruta;
                            vm.totalParteSalaoLiq += arTemp[i].parteSalaoLiq;
                            vm.totalSale += arTemp[i].totalSale;
                        }

                    }

                    //console.log(total);

                    //TOTAIZADOR
                    html += "<tr>";
                    html += "<td><b>Totais</b></td>";
                    html += "<td><b>" + $filter('currency')(vm.totalSale, 'R$', 2) + "</b></td>";
                    html += "<td><b>" + $filter('currency')(vm.totalComitionSale, 'R$', 2) + "</b></td>";
                    html += "<td><b>" + $filter('currency')(vm.totalComissionOwned, 'R$', 2) + "</b></td>";
                    html += "<td><b>" + $filter('currency')(vm.totalParteSalaoBruta, 'R$', 2) + "</b></td>";
                    html += "<td><b>" + $filter('currency')(vm.totalParteSalaoLiq, 'R$', 2) + "</b></td>";
                    html += "<td><b>" + "</b></td>";

                    html += "</tr>";

                    vm.html = html;


                    vm.showTable = true;
                },
                function (error) {
                    console.log(error);
                });

        }
      
        function refreshSalesPerCategory() {

            setFilter();
            vm.showTable = false;

            api.salesByCategory.save({
                filter: vm.finalFilter
            },
                function (response) {

                    vm.categories = [];
                    vm.total = 0;
                    vm.countTotal = 0;

                    var html = "";


                    for (var i = 0; i < response.d.length; i++) {

                        html += "<tr>";
                        html += "<td>" + response.d[i].category + "</td>";
                        html += "<td>" + response.d[i].count + "</td>";
                        html += "<td>" + $filter('currency')(response.d[i].paidPriceSum, 'R$', 2) + "</td>";
                        html += "</tr>";

                        vm.total += response.d[i].paidPriceSum;
                        vm.countTotal += response.d[i].count;

                        vm.categories.push({
                            columnId: response.d[i].category,
                            total: response.d[i].paidPriceSum
                        });



                    }


                    //TOTAIZADOR
                    html += "<tr>";
                    html += "<td><b>Totais</b></td>";
                    html += "<td><b>" + vm.countTotal + "</b></td>";
                    html += "<td><b>" + $filter('currency')(vm.total, 'R$', 2) + "</b></td>";
                    html += "</tr>";

                    vm.html = html;


                    vm.showTable = true;
                },
                function (error) {
                    console.log(error);
                });

        }


        function setFilter() {
            var arPaymentTypes = [];
            var arUsers = [];
            var arProfessionals = [];
            var arCategories = [];
            var arProductCategories = [];
            var arOffers = [];
            var arLocations = [];
            vm.finalFilter = {}

            //settng data
            vm.finalFilter.dtFrom = vm.filter.dtFrom.valueOf();
            vm.finalFilter.dtTo = vm.filter.dtTo.valueOf();

            //filtrando por payment type
            if (vm.filter.paymentType != undefined) {
                if (vm.filter.paymentType.CASH) {
                    arPaymentTypes.push('CASH');
                }
                if (vm.filter.paymentType.VISA_CREDIT) {
                    arPaymentTypes.push('VISA_CREDIT');
                }
                if (vm.filter.paymentType.VISA_DEBIT) {
                    arPaymentTypes.push('VISA_DEBIT');
                }
                if (vm.filter.paymentType.MASTER_CREDIT) {
                    arPaymentTypes.push('MASTER_CREDIT');
                }
                if (vm.filter.paymentType.MASTER_DEBIT) {
                    arPaymentTypes.push('MASTER_DEBIT');
                }
                if (vm.filter.paymentType.AMEX) {
                    arPaymentTypes.push('AMEX');
                }
                if (vm.filter.paymentType.DINERS) {
                    arPaymentTypes.push('DINERS');
                }
                if (vm.filter.paymentType.ELO) {
                    arPaymentTypes.push('ELO');
                }
                if (vm.filter.paymentType.OTHER_CREDIT) {
                    arPaymentTypes.push('OTHER_CREDIT');
                }
                if (vm.filter.paymentType.OTHER_DEBIT) {
                    arPaymentTypes.push('OTHER_DEBIT');
                }
            }

            vm.finalFilter.paymentTypes = arPaymentTypes;

            //operador
            if ((vm.users != undefined) && (vm.filter.users != undefined)) {
                for (var i = 0; i < vm.users.length; i++) {
                    if ((vm.filter.users[vm.users[i]._id] != undefined) && (vm.filter.users[vm.users[i]._id] == true)) {
                        arUsers.push(vm.users[i]._id);
                    }
                }

            }
            vm.finalFilter.users = arUsers;

            //locations
            if ((vm.pdvLocations != undefined) && (vm.filter.locations != undefined)) {
                for (var i = 0; i < vm.pdvLocations.length; i++) {
                    if ((vm.filter.locations[vm.pdvLocations[i].locationId] != undefined) && (vm.filter.locations[vm.pdvLocations[i].locationId] == true)) {
                        arLocations.push(vm.pdvLocations[i].locationId);
                    }
                }

            }
            vm.finalFilter.locations = arLocations;


            //profissional
            if ((vm.professionals != undefined) && (vm.filter.professionals != undefined)) {
                for (var i = 0; i < vm.professionals.length; i++) {
                    if ((vm.filter.professionals[vm.professionals[i]._id] != undefined) && (vm.filter.professionals[vm.professionals[i]._id] == true)) {
                        arProfessionals.push(vm.professionals[i]._id);
                    }
                }

            } else {
                console.log(vm.professionals);
            }
            vm.finalFilter.professionals = arProfessionals;

            //categories de servico
            if ((vm.serviceCategories != undefined) && (vm.filter.categories != undefined)) {
                for (var i = 0; i < vm.serviceCategories.length; i++) {
                    if ((vm.filter.categories[vm.serviceCategories[i]._id] != undefined) && (vm.filter.categories[vm.serviceCategories[i]._id] == true)) {
                        arCategories.push(vm.serviceCategories[i]._id);
                    }
                }

            }
            vm.finalFilter.categories = arCategories;

            console.log("debugando: produtos");
            console.log(vm.productCategories);
            console.log(vm.filter.productCategories);
            //categories de produtos
            if ((vm.productCategories != undefined) && (vm.filter.productCategories != undefined)) {
                for (var i = 0; i < vm.productCategories.length; i++) {
                    if ((vm.filter.productCategories[vm.productCategories[i]._id] != undefined) && (vm.filter.productCategories[vm.productCategories[i]._id] == true)) {
                        arProductCategories.push(vm.productCategories[i]._id);
                        
                    }
                }

            }
            vm.finalFilter.productCategories = arProductCategories;

        }


    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.report.other',
        [
            // 3rd Party Dependencies
            'datatables',
            'datatables.buttons'
        ]
    )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {


        $stateProvider.state('app.report.other', {
            url    : '/other'
        }).state('app.report.other.priceTableList', {
            url    : '/priceTableList',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/report/other/priceTableList.html',
                    controller : 'ReportOtherController as vm'
                }
            }
        }).state('app.report.other.priceTable', {
            url    : '/priceTable/:priceTableId',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/report/other/priceTable.html',
                    controller : 'ReportOtherController as vm'
                }
            }
        });


    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.report.other')
        .controller('ReportOtherController', ReportController);

    /** @ngInject */
    function ReportController($mdSidenav, $state, $scope,DTOptionsBuilder,DTColumnBuilder,DTColumnDefBuilder, api,
                                    DTDefaultOptions, $translate, $mdDialog, $mdToast, $rootScope, $window,
                              $compile, $timeout, $filter)
    {
        var vm = this;


        //PRINT function
        vm.print = function(){
            var table = document.getElementById('printArea').innerHTML;
            var myWindow = $window.open('', '', 'width=800, height=600');
            myWindow.document.write("<h1><center>" + vm.title + "</center></h1>");
            myWindow.document.write(table);
            myWindow.print();
        };



        //configuracoes de filtro
        vm.filter = {
            dtFrom : new Date(new moment().add(-1,'d').valueOf()),
            dtTo : new Date()
        }


        switch($state.current.name){

            case "app.report.other.priceTableList":
                vm.showTable = false;
                vm.showPriceTable = function(priceTableId){
                    $state.go('app.report.other.priceTable',{'priceTableId':priceTableId});
                };

                api.priceTables.save({},
                    function(response){
                        vm.priceTables = response.d;

                        setTimeout(function(){
                            vm.showTable = true;
                            $scope.$apply();
                        },200)

                    },
                    function(error){
                        console.log(error);
                    });

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({autoWidth : false})
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable":     "Nenhum registro disponível",
                        "sInfo":           "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty":      "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered":   "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix":    "",
                        "sInfoThousands":  ",",
                        "sLengthMenu":     "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing":     "Processando...",
                        "sSearch":         "Busca:",
                        "sZeroRecords":    "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst":    "Primeiro",
                            "sLast":     "Ultimo",
                            "sNext":     "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending":  ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });
                //vm.dtColumnDefs = [
                //    DTColumnDefBuilder.newColumnDef(0).notSortable()
                //];
                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                break;
            case "app.report.other.priceTable":
                vm.showTable = false;
                vm.refresh = refreshPriceTable;


                refreshPriceTable();

                break;

        }
        //////////
        function refreshPriceTable(){
            api.priceTable.save({
                    priceTableId:$state.params.priceTableId
                },
                function(response){
                    vm.priceTable = response.d;

                    vm.title = vm.priceTable.name;
                    var html = ""
                    var serviceCategory = "";

                    for(var i=0; i < vm.priceTable.items.length; i++) {


                        if (vm.priceTable.items[i].serviceCategory != serviceCategory){
                            serviceCategory = vm.priceTable.items[i].serviceCategory;
                            html += "<tr>";
                            html += "<td colspan=6><b>" + serviceCategory + "</b></td>";
                            html += "</tr>";

                        }


                        html += "<tr>";
                        html += "<td>" + "</td>";
                        html += "<td>" + vm.priceTable.items[i].service + "</td>";
                        html += "<td>" + $filter('currency')(vm.priceTable.items[i].price, 'R$', 2) + "</td>";
                        html += "<td>" + $filter('currency')(vm.priceTable.items[i].cashPrice, 'R$', 2) + "</td>";
                        html += "<td>" + $filter('currency')(vm.priceTable.items[i].comissionPrice, 'R$', 2) + "</td>";
                        html += "</tr>";

                    }

                    vm.showTable = true;

                    vm.html = html;

                },
                function(error){
                    console.log(error);
                });
        }

        function setFilter(){
            var arPaymentTypes = [];
            var arUsers = [];
            var arProfessionals = [];
            var arCategories = [];
            var arOffers = [];
            vm.finalFilter = {}

            //settng data
            vm.finalFilter.dtFrom = vm.filter.dtFrom.valueOf();
            vm.finalFilter.dtTo = vm.filter.dtTo.valueOf();

            //filtrando por payment type
            if (vm.filter.paymentType != undefined){
                if (vm.filter.paymentType.CASH){
                    arPaymentTypes.push('CASH');
                }
                if (vm.filter.paymentType.VISA_CREDIT){
                    arPaymentTypes.push('VISA_CREDIT');
                }
                if (vm.filter.paymentType.VISA_DEBIT){
                    arPaymentTypes.push('VISA_DEBIT');
                }
                if (vm.filter.paymentType.MASTER_CREDIT){
                    arPaymentTypes.push('MASTER_CREDIT');
                }
                if (vm.filter.paymentType.MASTER_DEBIT){
                    arPaymentTypes.push('MASTER_DEBIT');
                }
                if (vm.filter.paymentType.AMEX){
                    arPaymentTypes.push('AMEX');
                }
                if (vm.filter.paymentType.DINERS){
                    arPaymentTypes.push('DINERS');
                }
                if (vm.filter.paymentType.ELO){
                    arPaymentTypes.push('ELO');
                }
                if (vm.filter.paymentType.OTHER_CREDIT){
                    arPaymentTypes.push('OTHER_CREDIT');
                }
                if (vm.filter.paymentType.OTHER_DEBIT){
                    arPaymentTypes.push('OTHER_DEBIT');
                }
            }

            vm.finalFilter.paymentTypes = arPaymentTypes;

            //operador
            if ((vm.users != undefined) && (vm.filter.users != undefined)){
                for(var i=0; i < vm.users.length; i++){
                    if ((vm.filter.users[vm.users[i].id] != undefined) && (vm.filter.users[vm.users[i].id] == true)){
                        arUsers.push(vm.users[i].id);
                        console.log('aaaa');
                    }
                }

            }
            vm.finalFilter.users = arUsers;


            //profissional
            if ((vm.professionals != undefined) && (vm.filter.professionals != undefined)){
                for(var i=0; i < vm.professionals.length; i++){
                    if ((vm.filter.professionals[vm.professionals[i]._id] != undefined) && (vm.filter.professionals[vm.professionals[i]._id] == true)){
                        arProfessionals.push(vm.professionals[i]._id);
                    }
                }

            } else {
                console.log(vm.professionals);
            }
            vm.finalFilter.professionals = arProfessionals;

            //categories
            if ((vm.serviceCategories != undefined) && (vm.filter.categories != undefined)){
                for(var i=0; i < vm.serviceCategories.length; i++){
                    if ((vm.filter.categories[vm.serviceCategories[i]._id] != undefined) && (vm.filter.categories[vm.serviceCategories[i]._id] == true)){
                        arCategories.push(vm.serviceCategories[i]._id);
                    }
                }

            }
            vm.finalFilter.categories = arCategories;

            //offers
            if ((vm.offers != undefined) && (vm.filter.offers != undefined)){
                for(var i=0; i < vm.offers.length; i++){
                    if ((vm.filter.offers[vm.offers[i]._id] != undefined) && (vm.filter.offers[vm.offers[i]._id] == true)){
                        arOffers.push(vm.offers[i]._id);
                    }
                }

            }
            vm.finalFilter.offers = arOffers;


            //return
            //console.log(vm.finalFilter);

        }


    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.report.marketing',
        [
            // 3rd Party Dependencies
            'datatables',
            'datatables.buttons'
        ]
    )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {


        $stateProvider.state('app.report.marketing', {
            url    : '/marketing'
        }).state('app.report.marketing.usedGiftCards', {
            url    : '/usedGiftCards',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/report/marketing/salesWithGiftCards.html',
                    controller : 'ReportMarketingController as vm'
                }
            }
        }).state('app.report.marketing.messages', {
            url    : '/messages',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/report/marketing/messages.html',
                    controller : 'ReportMarketingController as vm'
                }
            }
        }).state('app.report.marketing.cancelationByApp', {
            url    : '/cancelationByApp',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/report/marketing/cancelationByApp.html',
                    controller : 'ReportMarketingController as vm'
                }
            }
        }).state('app.report.marketing.survey', {
            url    : '/survey',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/report/marketing/survey.html',
                    controller : 'ReportMarketingController as vm'
                }
            }
        }).state('app.report.marketing.canceled', {
            url    : '/canceled',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/report/marketing/canceled.html',
                    controller : 'ReportMarketingController as vm'
                }
            }
        });


    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.report.marketing')
        .controller('ReportMarketingController', ReportController);

    /** @ngInject */
    function ReportController($mdSidenav, $state, $scope,DTOptionsBuilder,DTColumnBuilder,DTColumnDefBuilder, api,
                                    DTDefaultOptions, $translate, $mdDialog, $mdToast, $rootScope, $window,
                              $compile, $timeout, $filter)
    {
        var vm = this;


        //PRINT function
        vm.print = function(){
            var table = document.getElementById('printArea').innerHTML;
            var myWindow = $window.open('', '', 'width=800, height=600');
            myWindow.document.write("<h1><center>" + vm.title + "</center></h1>");
            myWindow.document.write(table);
            myWindow.print();
        };

        vm.showPdvLocation = false;
        vm.pdvLocations = $rootScope.pdvLocations;
        if ((vm.pdvLocations != undefined) && (vm.pdvLocations.length > 1)){
            vm.showPdvLocation = true;
            vm.pdvLocation = vm.pdvLocations[0].locationId;
        }


        ///FILTER
        api.users.save({},
            function(response){
                var arTemp = [];
                for( var i=0; i < response.d.length; i++){
                    if ((response.d[i].type == 'MASTER') || (response.d[i].type == 'ADMIN')
                     || (response.d[i].type == 'RECEPCIONIST')){
                        arTemp.push(response.d[i]);
                    }

                }
                vm.users =  arTemp;

            },
            function(error){
                console.log(error);
            });
        var temp = [];
        temp.push(null);

        api.serviceProfessionals.save({},
            function(response){
                for (var j=0; j < response.d.length; j++){
                    temp.push(response.d[j]);
                }
                vm.professionals =  temp;

            },
            function(error){
                console.log(error);
            });
        api.serviceCategories.save({},
            function(response){
                vm.serviceCategories =  response.d;
            },
            function(error){
                console.log(error);
            });

        //configuracoes de filtro
        vm.filter = {
            dtFrom : new Date(new moment().add(-1,'d').valueOf()),
            dtTo : new Date()
        }


        switch($state.current.name){

            case 'app.report.marketing.usedGiftCards':
                vm.showTable = false;
                vm.refresh = refreshSalesWithGiftCards;
                vm.title = "Vales-Presente"

                vm.openFilter = function(){
                    $mdSidenav('filter')
                        .toggle()
                        .then(function () {

                        });
                }

                refreshSalesWithGiftCards();

                break;
            case 'app.report.marketing.survey':
                vm.showTable = false;
                vm.refresh = refreshSurvey;
                vm.title = "Pesquisa de satisfação"

                vm.openFilter = function(){
                    $mdSidenav('filter')
                        .toggle()
                        .then(function () {

                        });
                }

                refreshSurvey();

                break;
            case 'app.report.marketing.messages':
                vm.showTable = false;
                vm.refresh = refreshMesages;
                vm.title = "Mensagens"

                vm.openFilter = function(){
                    $mdSidenav('filter')
                        .toggle()
                        .then(function () {

                        });
                }

                refreshMesages();

                break;
            case "app.report.marketing.canceled":
                vm.showTable = false;
                vm.refresh = refreshCanceledSchedules;
                vm.title = "Agendamentos cancelados sem reagendamento"

                vm.openFilter = function(){
                    $mdSidenav('filter')
                        .toggle()
                        .then(function () {

                        });
                }

                refreshCanceledSchedules();
                break;



        }
        //////////

        function refreshCanceledSchedules(){
            setFilter();


            api.getCanceledSchedule.save({
                    filter : vm.finalFilter
                },
                function(response){
                    var html = ""

                    for(var i=0; i < response.d.length; i++) {
                        html += "<tr>";
                        html += "<td>" + response.d[i].name + "</td>";
                        html += "<td>" + response.d[i].telephone + "</td>";
                        html += "</tr>";
                    }


                    vm.html = html;
                    vm.showTable = true;
                },
                function(error){
                    console.log(error);
                });
        }

        function refreshMesages(){
            setFilter();

            api.messages.save({
                    filter : vm.finalFilter
                },
                function(response){
                    var html = ""


                    for(var i=0; i < response.d.length; i++) {
                        html += "<tr>";
                        html += "<td>" + $filter('date')(response.d[i].date, "dd/MM/yyyy HH:mm") + "</td>";
                        html += "<td>" + response.d[i].customer + "</td>";
                        html += "<td>" + response.d[i].messageType + "</td>";
                        html += "<td>" + response.d[i].text + "</td>";
                        html += "</tr>";
                    }


                    vm.html = html;
                    vm.showTable = true;
                },
                function(error){
                    console.log(error);
                });
        }

        //////////

        function refreshSurvey(){
            setFilter();

            api.surveyAnswers.save({
                    filter : vm.finalFilter
                },
                function(response){
                    var html = ""
                    //console.log(response.d);


                    var starTotal = 0;
                    for(var i=0; i < response.d.length; i++) {
                        html += "<tr>";
                        html += "<td>" + $filter('date')(response.d[i].date, "dd/MM/yyyy HH:mm") + "</td>";
                        html += "<td>" + response.d[i].customer + "</td>";
                        html += "<td>" + response.d[i].professional + "</td>";
                        html += "<td>" + response.d[i].stars + "</td>";
                        html += "</tr>";

                        starTotal += response.d[i].stars;
                    }
                    var medium = starTotal / response.d.length;

                    //TOTAIZADOR
                    html += "<tr>";
                    html += "<td><b>Media</b></td>";
                    html += "<td></td>";
                    html += "<td></td>";
                    html += "<td><b>" + $filter('currency')(medium, '', 2) + "</b></td>";
                    html += "</tr>";


                    vm.html = html;
                    vm.showTable = true;
                },
                function(error){
                    console.log(error);
                });
        }

        ///////
        function refreshSalesWithGiftCards(){
            setFilter();

            api.salesWithGiftCards.save({
                    filter : vm.finalFilter
                },
                function(response){
                    var html = ""
                    vm.saldo = 0;

                    for(var i=0; i < response.d.length; i++){
                        vm.saldo += response.d[i].giftCardValue;

                        if (response.d[i].giftCardValue > 0){
                            html += "<tr>";
                            html += "<td>" + $filter('date')(response.d[i].checkoutDate, "dd/MM/yyyy HH:mm") + "</td>";
                            html += "<td>" + response.d[i].location + "</td>";
                            html += "<td>" + response.d[i].operator + "</td>";
                            html += "<td>" + response.d[i].customerName + "</td>";
                            html += "<td>" + $filter('currency')(response.d[i].giftCardValue, 'R$',2) + "</td>";
                            html += "<td>" + response.d[i].giftCardObservation + "</td>";
                            html += "</tr>";
                        }


                    }


                    html += "<tr>";
                    html += "<td><b>Total</b></td>";
                    html += "<td></td>";
                    html += "<td></td>";
                    html += "<td></td>";
                    html += "<td></td>";
                    html += "<td><b>" + $filter('currency')(vm.saldo, 'R$',2) + "</b></td>";
                    html += "</tr>";

                    vm.html = html;


                    vm.showTable = true;
                },
                function(error){
                    console.log(error);
                });
        }

        function setFilter(){
            var arPaymentTypes = [];
            var arUsers = [];
            var arProfessionals = [];
            var arCategories = [];
            var arOffers = [];
            vm.finalFilter = {}

            //settng data
            vm.finalFilter.dtFrom = vm.filter.dtFrom.valueOf();
            vm.finalFilter.dtTo = vm.filter.dtTo.valueOf();

            //filtrando por payment type
            if (vm.filter.paymentType != undefined){
                if (vm.filter.paymentType.CASH){
                    arPaymentTypes.push('CASH');
                }
                if (vm.filter.paymentType.VISA_CREDIT){
                    arPaymentTypes.push('VISA_CREDIT');
                }
                if (vm.filter.paymentType.VISA_DEBIT){
                    arPaymentTypes.push('VISA_DEBIT');
                }
                if (vm.filter.paymentType.MASTER_CREDIT){
                    arPaymentTypes.push('MASTER_CREDIT');
                }
                if (vm.filter.paymentType.MASTER_DEBIT){
                    arPaymentTypes.push('MASTER_DEBIT');
                }
                if (vm.filter.paymentType.AMEX){
                    arPaymentTypes.push('AMEX');
                }
                if (vm.filter.paymentType.DINERS){
                    arPaymentTypes.push('DINERS');
                }
                if (vm.filter.paymentType.ELO){
                    arPaymentTypes.push('ELO');
                }
                if (vm.filter.paymentType.OTHER_CREDIT){
                    arPaymentTypes.push('OTHER_CREDIT');
                }
                if (vm.filter.paymentType.OTHER_DEBIT){
                    arPaymentTypes.push('OTHER_DEBIT');
                }
            }

            vm.finalFilter.paymentTypes = arPaymentTypes;

            //locations
            var arLocations = [];
            if ((vm.pdvLocations != undefined) && (vm.filter.locations != undefined)) {
                for (var i = 0; i < vm.pdvLocations.length; i++) {
                    if ((vm.filter.locations[vm.pdvLocations[i].locationId] != undefined) && (vm.filter.locations[vm.pdvLocations[i].locationId] == true)) {
                        arLocations.push(vm.pdvLocations[i].locationId);
                    }
                }

            }
            vm.finalFilter.locations = arLocations;

            //operador
            if ((vm.users != undefined) && (vm.filter.users != undefined)){
                for(var i=0; i < vm.users.length; i++){
                    if ((vm.filter.users[vm.users[i].id] != undefined) && (vm.filter.users[vm.users[i].id] == true)){
                        arUsers.push(vm.users[i].id);
                    }
                }

            }
            vm.finalFilter.users = arUsers;


            //profissional
            vm.finalFilter.professional = vm.filter.professional

            //categories
            if ((vm.serviceCategories != undefined) && (vm.filter.categories != undefined)){
                for(var i=0; i < vm.serviceCategories.length; i++){
                    if ((vm.filter.categories[vm.serviceCategories[i]._id] != undefined) && (vm.filter.categories[vm.serviceCategories[i]._id] == true)){
                        arCategories.push(vm.serviceCategories[i]._id);
                    }
                }

            }
            vm.finalFilter.categories = arCategories;

            //offers
            if ((vm.offers != undefined) && (vm.filter.offers != undefined)){
                for(var i=0; i < vm.offers.length; i++){
                    if ((vm.filter.offers[vm.offers[i]._id] != undefined) && (vm.filter.offers[vm.offers[i]._id] == true)){
                        arOffers.push(vm.offers[i]._id);
                    }
                }

            }
            vm.finalFilter.offers = arOffers;


            //return
            //console.log(vm.finalFilter);

        }


    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.report.finance',
        [
            // 3rd Party Dependencies
            'datatables',
            'datatables.buttons'
        ]
    )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {


        $stateProvider.state('app.report.finance', {
            url    : '/finance'
        }).state('app.report.finance.financeAnalytical', {
            url    : '/financeAnalytical',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/report/finance/financeAnalytical.html',
                    controller : 'ReportFinanceController as vm'
                }
            }
        }).state('app.report.finance.financeAnalyticalM', {
            url    : '/financeAnalyticalM/:token',
            views  : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.report.finance.financeAnalyticalM': {
                    templateUrl: 'app/main/report/finance/financeAnalytical.html',
                    controller : 'ReportFinanceController as vm'
                }
            }
        }).state('app.report.finance.financeAnalyticalByPayment', {
            url    : '/financeAnalyticalByPayment',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/report/finance/financeAnalytical.html',
                    controller : 'ReportFinanceController as vm'
                }
            }
        }).state('app.report.finance.financeAnalyticalByPaymentM', {
            url    : '/financeAnalyticalByPaymentM/:token',
            views  : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.report.finance.financeAnalyticalByPaymentM': {
                    templateUrl: 'app/main/report/finance/financeAnalytical.html',
                    controller : 'ReportFinanceController as vm'
                }
            }
        }).state('app.report.finance.audit', {
            url    : '/financeAudit',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/report/finance/audit.html',
                    controller : 'ReportFinanceController as vm'
                }
            }
        }).state('app.report.finance.auditM', {
            url    : '/financeAuditM/:token',
            views  : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.report.finance.auditM': {
                    templateUrl: 'app/main/report/finance/audit.html',
                    controller : 'ReportFinanceController as vm'
                }
            }
        }).state('app.report.finance.salesPerPaymentType', {
            url    : '/salesPerPaymentType',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/report/finance/salesPerPaymentType.html',
                    controller : 'ReportFinanceController as vm'
                }
            }
        }).state('app.report.finance.salesPerPaymentTypeM', {
            url    : '/salesPerPaymentTypeM/:token',
            views  : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.report.finance.salesPerPaymentTypeM': {
                    templateUrl: 'app/main/report/finance/salesPerPaymentType.html',
                    controller : 'ReportFinanceController as vm'
                }
            }
        }).state('app.report.finance.creditDebitSales', {
            url    : '/creditdebitreport',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/report/finance/salesWithCreditDebit.html',
                    controller : 'ReportFinanceController as vm'
                }
            }
        }).state('app.report.finance.creditDebitSalesM', {
            url    : '/creditdebitreportM/:token',
            views  : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.report.finance.creditDebitSalesM': {
                    templateUrl: 'app/main/report/finance/salesWithCreditDebit.html',
                    controller : 'ReportFinanceController as vm'
                }
            }
        })


    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.report.finance')
        .controller('ReportFinanceController', ReportController);

    /** @ngInject */
    function ReportController($mdSidenav, $state, $scope,DTOptionsBuilder,DTColumnBuilder,DTColumnDefBuilder, api,
                                    DTDefaultOptions, $translate, $mdDialog, $mdToast, $rootScope, $window,
                              $compile, $timeout, $filter)
    {
        var vm = this;


        //PRINT function
        vm.print = function(){
            var table = document.getElementById('printArea').innerHTML;
            var myWindow = $window.open('', '', 'width=800, height=600');
            myWindow.document.write("<h1><center>" + vm.title + "</center></h1>");
            myWindow.document.write(table);
            myWindow.print();
        };

        vm.showPdvLocation = false;
        vm.pdvLocations = $rootScope.pdvLocations;
        if ((vm.pdvLocations != undefined) && (vm.pdvLocations.length > 1)){
            vm.showPdvLocation = true;
            vm.pdvLocation = vm.pdvLocations[0].locationId;
        }


        //GET OUTSIDE TOKEN FOR MOBILE
        if ( ($state.current.name == 'app.report.finance.financeAnalyticalM') ||
            ($state.current.name == 'app.report.finance.financeAnalyticalByPaymentM') ||
            ($state.current.name == 'app.report.finance.auditM') ||
            ($state.current.name == 'app.report.finance.salesPerPaymentTypeM') ||
            ($state.current.name == 'app.report.finance.creditDebitSalesM')
            ){
            var token = $state.params.token;
            token = token.replace("##!##", ".");
            token = token.replace("##!##", ".");
            token = token.replace("##!##", ".");
            $rootScope.securityToken = token;
            $rootScope.$emit('changeToken', []);
            vm.mobile = true;
        } else {
            vm.mobile = false;
        }



        ///FILTER
        /*api.users.save({},
            function(response){


            },
            function(error){
                console.log(error);
            });*/
        api.allSimpleProfessionals.save({},
            function(response){
                vm.professionals =  response.d;

                //console.log(response.d);

                var arTemp = [];
                for( var i=0; i < response.d.length; i++){
                    if ((response.d[i].security == 'MASTER') || (response.d[i].security == 'ADMIN')
                        || (response.d[i].security == 'RECEPCIONIST')){
                        arTemp.push(response.d[i]);
                    }

                }
                vm.users =  arTemp;

            },
            function(error){
                console.log(error);
            });
        api.serviceCategories.save({},
            function(response){
                vm.serviceCategories =  response.d;
            },
            function(error){
                console.log(error);
            });

        //configuracoes de filtro
        vm.filter = {
            dtFrom : new Date(new moment().add(-1,'d').valueOf()),
            dtTo : new Date()
        }

        switch($state.current.name){

            case 'app.report.finance.financeAnalyticalM':
            case 'app.report.finance.financeAnalytical':
                vm.showTable = true;
                vm.title = "Financeiro Analítico"
                vm.refresh = refreshFinanceAnalytics;

                vm.openFilter = function(){
                    $mdSidenav('filter')
                        .toggle()
                        .then(function () {

                        });
                }

                refreshFinanceAnalytics();
                break;
            case 'app.report.finance.financeAnalyticalByPaymentM':
            case 'app.report.finance.financeAnalyticalByPayment':
                vm.showTable = true;
                vm.title = "Financeiro Analítico"
                vm.refresh = refreshFinanceAnalyticsByPayment;

                vm.openFilter = function(){
                    $mdSidenav('filter')
                        .toggle()
                        .then(function () {

                        });
                }

                refreshFinanceAnalyticsByPayment();
                break;

            case 'app.report.finance.auditM':
            case 'app.report.finance.audit':
                vm.showTable = true;
                vm.title = "Auditoria Financeira"
                vm.refresh = refreshAuditFinance;

                vm.openFilter = function(){
                    $mdSidenav('filter')
                        .toggle()
                        .then(function () {

                        });
                }

                refreshAuditFinance();
                break;
            case 'app.report.finance.salesPerPaymentTypeM':
            case 'app.report.finance.salesPerPaymentType':
                vm.showTable = false;
                vm.refresh = refreshSalesPerPaymentType;
                vm.title = "Financeiro por meio de pagamento"
                vm.openFilter = function(){
                    $mdSidenav('filter')
                        .toggle()
                        .then(function () {

                        });
                }


                refreshSalesPerPaymentType();

                break;
            case 'app.report.finance.creditDebitSalesM':
            case 'app.report.finance.creditDebitSales':
                vm.showTable = true;
                vm.refresh = refreshSalesWithCreditDebit;
                vm.title = "Vendas com Crédito/Débito"


                vm.openFilter = function(){
                    $mdSidenav('filter')
                        .toggle()
                        .then(function () {

                        });
                }

                refreshSalesWithCreditDebit();


                break;

        }
        //////////
        function refreshSalesWithCreditDebit(){
            setFilter();

            api.creditDebitReport.save({
                    filter : vm.finalFilter
                },
                function(response){
                    vm.sales = response.d;
                    vm.showTable = true;
                    vm.saldo = 0;
                    var html = "";

                    for(var i=0; i < vm.sales.length; i++){
                        vm.saldo += vm.sales[i].creditDebit;


                        html += "<tr>";
                        html += "<td>" + $filter('date')(response.d[i].checkoutDate, "dd/MM/yyyy HH:mm") + "</td>";
                        html += "<td>" + response.d[i].operator + "</td>";
                        html += "<td>" + response.d[i].customerName + "</td>";
                        html += "<td>" + $filter('currency')(response.d[i].creditDebit, 'R$',2) + "</td>";
                        html += "</tr>";

                    }

                    html += "<tr>";
                    html += "<td><b>Total</b></td>";
                    html += "<td></td>";
                    html += "<td></td>";
                    html += "<td><b>" + $filter('currency')(vm.saldo, 'R$',2) + "</b></td>";
                    html += "</tr>";

                    vm.html = html;

                },
                function(error){
                    console.log(error);
                });
        }

        function refreshSalesPerPaymentType(){

            setFilter();

            api.paymentTypeReport.save({
                    filter : vm.finalFilter
                },
                function(response){
                    vm.showTable = true;


                    vm.total = 0;
                    var html = "";
                    for(var i in response.d){

                        if (response.d[i].paymentType != null){
                            html += "<tr>";
                            html += "<td>" + response.d[i].paymentType + "</td>";
                            html += "<td>" + $filter('currency')(response.d[i].totalSale, 'R$',2) + "</td>";
                            html += "</tr>";
                        }

                        vm.total += response.d[i].totalSale;
                    }

                    //TOTAIZADOR
                    html += "<tr>";
                    html += "<td><b>Totais</b></td>";
                    html += "<td><b>" + $filter('currency')(vm.total, 'R$',2) + "</b></td>";
                    html += "</tr>";

                    vm.html = html;

                },
                function(error){
                    console.log(error);
                });

        }

        function refreshAuditFinance(){
            setFilter();

            api.financeAudit.save({
                    filter : vm.finalFilter
                },
                function(response){
                    vm.showTable = true;
                    console.log(response.d);

                    vm.total = 0;
                    var html = "";
                    for(var i=0; i < response.d.length; i++){

                        html += "<tr>";
                        html += "<td>" + $filter('date')(response.d[i].checkoutDate, "dd/MM/yyyy HH:mm") + "</td>";

                        if (vm.showPdvLocation){
                            html += "<td>" + response.d[i].location + "</td>";
                        }

                        html += "<td>" + response.d[i].operator + "</td>";
                        html += "<td>" + response.d[i].customerName + "</td>";
                        html += "<td>" + $filter('currency')(response.d[i].salePayment.total, 'R$',2) + "</td>";
                        html += "<td>" + $filter('currency')(response.d[i].saleService.total, 'R$',2) + "</td>";
                        html += "</tr>";

                        vm.total += response.d[i].value;
                    }

                    //TOTAIZADOR
                    html += "<tr>";
                    html += "<td><b>Totais</b></td>";
                    html += "<td><b></b></td>";
                    html += "<td><b></b></td>";
                    if (vm.showPdvLocation) {
                        html += "<td><b></b></td>";
                    }
                    html += "<td><b></b></td>";
                    html += "<td><b>" + $filter('currency')(vm.total, 'R$',2) + "</b></td>";
                    html += "</tr>";

                    vm.html = html;

                },
                function(error){
                    console.log(error);
                });
        }

        function refreshFinanceAnalytics(){
            setFilter();

            console.log('ddddoi');

          //  console.log(vm.finalFilter);

            api.financeAnalytics.save({
                    filter : vm.finalFilter
                },
                function(response){
                    vm.showTable = true;

                    vm.total = 0;
                    var html = "";
                    for(var i=0; i < response.d.length; i++){

                        html += "<tr>";
                        html += "<td>" + $filter('date')(response.d[i].checkoutDate, "dd/MM/yyyy HH:mm") + "</td>";
                        if (vm.showPdvLocation) {
                            html += "<td>" + response.d[i].location + "</td>";
                        }
                        html += "<td>" + response.d[i].operator + "</td>";
                        html += "<td>" + response.d[i].customerName + "</td>";
                        html += "<td>" + response.d[i].paymentType + "</td>";
                        html += "<td>" + $filter('currency')(response.d[i].value, 'R$',2) + "</td>";
                        html += "</tr>";

                        vm.total += response.d[i].value;
                    }

                    //TOTAIZADOR
                    html += "<tr>";
                    html += "<td><b>Totais</b></td>";
                    html += "<td><b></b></td>";
                    if (vm.showPdvLocation) {
                        html += "<td><b></b></td>";
                    }
                    html += "<td><b></b></td>";
                    html += "<td><b></b></td>";
                    html += "<td><b>" + $filter('currency')(vm.total, 'R$',2) + "</b></td>";
                    html += "</tr>";

                    vm.html = html;

                },
                function(error){
                    console.log(error);
                });
        }

        function refreshFinanceAnalyticsByPayment(){
            setFilter();

            api.financeAnalytics.save({
                    filter : vm.finalFilter,
                    orderBy : "PAYMENT"
                },
                function(response){
                    vm.showTable = true;

                    vm.total = 0;
                    var html = "";
                    var paymentType = "";
                    vm.countTotal = 0;
                    vm.sumTotal = 0;
                    for(var i=0; i < response.d.length; i++){

                        if (response.d[i].paymentType != paymentType) {
                            if (paymentType != "") {
                                //totalizado
                                html += "<tr style='background-color:silver'>";
                                if (vm.showPdvLocation){
                                    html += "<td><b></b></td>";
                                }
                                html += "<td colspan=2><b>Total</b></td>";
                                html += "<td><b></b></td>";
                                html += "<td><b>" + vm.countTotal + "</b></td>";
                                html += "<td><b>" + $filter('currency')(vm.sumTotal, 'R$', 2) + "</b></td>";
                                html += "</tr>";
                            }

                            vm.countTotal = 0;
                            vm.sumTotal = 0;
                            paymentType = response.d[i].paymentType;
                            html += "<tr>";
                            if (vm.showPdvLocation){
                                html += "<td><b></b></td>";
                            }
                            html += "<td colspan=5><b>" + response.d[i].paymentType + "</b></td>";
                            html += "</tr>";

                        }

                        html += "<tr>";
                        html += "<td>" + $filter('date')(response.d[i].checkoutDate, "dd/MM/yyyy HH:mm") + "</td>";
                        if (vm.showPdvLocation) {
                            html += "<td>" + response.d[i].location + "</td>";
                        }
                        html += "<td>" + response.d[i].operator + "</td>";
                        html += "<td>" + response.d[i].customerName + "</td>";
                        html += "<td>" + response.d[i].paymentType + "</td>";
                        html += "<td>" + $filter('currency')(response.d[i].value, 'R$',2) + "</td>";
                        html += "</tr>";

                        vm.countTotal += 1;
                        vm.sumTotal += response.d[i].value;

                        vm.total += response.d[i].value;
                    }

                    //total meio de pgto
                    html += "<tr style='background-color:silver'>";
                    if (vm.showPdvLocation){
                        html += "<td><b></b></td>";
                    }
                    html += "<td colspan=2><b>Total</b></td>";
                    html += "<td><b></b></td>";
                    html += "<td><b>" + vm.countTotal + "</b></td>";
                    html += "<td><b>" + $filter('currency')(vm.sumTotal, 'R$', 2) + "</b></td>";
                    html += "</tr>";

                    //TOTAIZADOR
                    html += "<tr>";
                    html += "<td><b>Totais</b></td>";
                    html += "<td><b></b></td>";
                    if (vm.showPdvLocation) {
                        html += "<td><b></b></td>";
                    }
                    html += "<td><b></b></td>";
                    html += "<td><b></b></td>";
                    html += "<td><b>" + $filter('currency')(vm.total, 'R$',2) + "</b></td>";
                    html += "</tr>";

                    vm.html = html;

                },
                function(error){
                    console.log(error);
                });
        }


        function setFilter(){
            var arPaymentTypes = [];
            var arUsers = [];
            var arProfessionals = [];
            var arCategories = [];
            var arOffers = [];
            vm.finalFilter = {};
            var arLocations = [];

            //settng data
            vm.finalFilter.dtFrom = vm.filter.dtFrom.valueOf();
            vm.finalFilter.dtTo = vm.filter.dtTo.valueOf();

            //filtrando por payment type
            if (vm.filter.paymentType != undefined){
                if (vm.filter.paymentType.CASH){
                    arPaymentTypes.push('CASH');
                    arPaymentTypes.push('CHECK');
                    arPaymentTypes.push('DINHEIRO');
                }
                if (vm.filter.paymentType.CREDIT){
                    arPaymentTypes.push('CREDIT');
                    arPaymentTypes.push('DINERS');
                    arPaymentTypes.push('AMEX');                    
                }
                if (vm.filter.paymentType.DEBIT){
                    arPaymentTypes.push('DEBIT');
                }
                if (vm.filter.paymentType.VISA_CREDIT){
                    arPaymentTypes.push('VISA_CREDIT');
                }
                if (vm.filter.paymentType.VISA_DEBIT){
                    arPaymentTypes.push('VISA_DEBIT');
                }
                if (vm.filter.paymentType.MASTER_CREDIT){
                    arPaymentTypes.push('MASTER_CREDIT');
                }
                if (vm.filter.paymentType.MASTER_DEBIT){
                    arPaymentTypes.push('MASTER_DEBIT');
                }
                if (vm.filter.paymentType.AMEX){
                    arPaymentTypes.push('AMEX');
                }
                if (vm.filter.paymentType.DINERS){
                    arPaymentTypes.push('DINERS');
                }
                if (vm.filter.paymentType.ELO_CREDIT){
                    arPaymentTypes.push('ELO_CREDIT');
                }
                if (vm.filter.paymentType.ELO_DEBIT){
                    arPaymentTypes.push('ELO_DEBIT');
                }
                if (vm.filter.paymentType.OTHER_CREDIT){
                    arPaymentTypes.push('OTHER_CREDIT');
                }
                if (vm.filter.paymentType.OTHER_DEBIT){
                    arPaymentTypes.push('OTHER_DEBIT');
                }
            }

            vm.finalFilter.paymentTypes = arPaymentTypes;

            //operador
            if ((vm.users != undefined) && (vm.filter.users != undefined)){
                for(var i=0; i < vm.users.length; i++){
                    if ((vm.filter.users[vm.users[i]._id] != undefined) && (vm.filter.users[vm.users[i]._id] == true)){
                        arUsers.push(vm.users[i]._id);
                    }
                }

            }
            vm.finalFilter.users = arUsers;

            //locations
            if ((vm.pdvLocations != undefined) && (vm.filter.locations != undefined)) {
                for (var i = 0; i < vm.pdvLocations.length; i++) {
                    if ((vm.filter.locations[vm.pdvLocations[i].locationId] != undefined) && (vm.filter.locations[vm.pdvLocations[i].locationId] == true)) {
                        arLocations.push(vm.pdvLocations[i].locationId);
                    }
                }

            }
            vm.finalFilter.locations = arLocations;


            //profissional
            if ((vm.professionals != undefined) && (vm.filter.professionals != undefined)){
                for(var i=0; i < vm.professionals.length; i++){
                    if ((vm.filter.professionals[vm.professionals[i]._id] != undefined) && (vm.filter.professionals[vm.professionals[i]._id] == true)){
                        arProfessionals.push(vm.professionals[i]._id);
                    }
                }

            } else {
                console.log(vm.professionals);
            }
            vm.finalFilter.professionals = arProfessionals;

            //categories
            if ((vm.serviceCategories != undefined) && (vm.filter.categories != undefined)){
                for(var i=0; i < vm.serviceCategories.length; i++){
                    if ((vm.filter.categories[vm.serviceCategories[i]._id] != undefined) && (vm.filter.categories[vm.serviceCategories[i]._id] == true)){
                        arCategories.push(vm.serviceCategories[i]._id);
                    }
                }

            }
            vm.finalFilter.categories = arCategories;




            //return
            //console.log(vm.finalFilter);

        }


    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.report.customer',
        [
            // 3rd Party Dependencies
            'datatables',
            'datatables.buttons'
        ]
    )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {


        $stateProvider.state('app.report.customer', {
            url    : '/customer'
        }).state('app.report.customer.customersWithCreditDebit', {
            url    : '/customersWithCreditDebit',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/report/customer/customersWithCreditDebit.html',
                    controller : 'ReportCustomerController as vm'
                }
            }
        }).state('app.report.customer.customersWithCreditDebitM', {
            url    : '/customersWithCreditDebitM/:token',
            views  : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.report.customer.customersWithCreditDebitM': {
                    templateUrl: 'app/main/report/customer/customersWithCreditDebit.html',
                    controller : 'ReportCustomerController as vm'
                }
            }
        }).state('app.report.customer.birthday', {
            url    : '/birthday',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/report/customer/birthday.html',
                    controller : 'ReportCustomerController as vm'
                }
            }
        }).state('app.report.customer.birthdayM', {
            url    : '/birthdayM/:token',
            views  : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.report.customer.birthdayM': {
                    templateUrl: 'app/main/report/customer/birthday.html',
                    controller : 'ReportCustomerController as vm'
                }
            }
        }).state('app.report.customer.top20', {
            url    : '/top20',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/report/customer/top.html',
                    controller : 'ReportCustomerController as vm'
                }
            }
        }).state('app.report.customer.top20M', {
            url    : '/top20M/:token',
            views  : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.report.customer.top20M': {
                    templateUrl: 'app/main/report/customer/top.html',
                    controller : 'ReportCustomerController as vm'
                }
            }
        }).state('app.report.customer.top50', {
            url    : '/top50',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/report/customer/top.html',
                    controller : 'ReportCustomerController as vm'
                }
            }
        }).state('app.report.customer.top50M', {
            url    : '/top50M/:token',
            views  : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.report.customer.top50M': {
                    templateUrl: 'app/main/report/customer/top.html',
                    controller : 'ReportCustomerController as vm'
                }
            }
        }).state('app.report.customer.top100', {
            url    : '/top100',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/report/customer/top.html',
                    controller : 'ReportCustomerController as vm'
                }
            }
        }).state('app.report.customer.top100M', {
            url    : '/top100M/:token',
            views  : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.report.customer.top100M': {
                    templateUrl: 'app/main/report/customer/top.html',
                    controller : 'ReportCustomerController as vm'
                }
            }
        }).state('app.report.customer.top200', {
            url    : '/top200',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/report/customer/top.html',
                    controller : 'ReportCustomerController as vm'
                }
            }
        }).state('app.report.customer.top200M', {
                url    : '/top200M/:token',
                views  : {
                    'main@'                          : {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller : 'MainController as vm'
                    },
                    'content@app.report.customer.top200M': {
                        templateUrl: 'app/main/report/customer/top.html',
                        controller : 'ReportCustomerController as vm'
                    }
                }
            });


    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.report.customer')
        .controller('ReportCustomerController', ReportController);

    /** @ngInject */
    function ReportController($mdSidenav, $state, $scope,DTOptionsBuilder,DTColumnBuilder,DTColumnDefBuilder, api,
                                    DTDefaultOptions, $translate, $mdDialog, $mdToast, $rootScope, $window,
                              $compile, $timeout, $filter)
    {
        var vm = this;


        //PRINT function
        vm.print = function(){
            var table = document.getElementById('printArea').innerHTML;
            var myWindow = $window.open('', '', 'width=800, height=600');
            myWindow.document.write("<h1><center>" + vm.title + "</center></h1>");
            myWindow.document.write(table);
            myWindow.print();
        };

        //GET OUTSIDE TOKEN FOR MOBILE
        if ( ($state.current.name == 'app.report.customer.customersWithCreditDebitM') ||
            ($state.current.name == 'app.report.customer.birthdayM') ||
            ($state.current.name == 'app.report.customer.top20M') ||
            ($state.current.name == 'app.report.customer.top200M') ||
            ($state.current.name == 'app.report.customer.top100M') ||
            ($state.current.name == 'app.report.customer.top50M') ){
            var token = $state.params.token;
            token = token.replace("##!##", ".");
            token = token.replace("##!##", ".");
            token = token.replace("##!##", ".");
            $rootScope.securityToken = token;
            $rootScope.$emit('changeToken', []);
            vm.mobile = true;
        } else {
            vm.mobile = false;
        }


        ///FILTER
        api.users.save({},
            function(response){
                var arTemp = [];
                for( var i=0; i < response.d.length; i++){
                    if ((response.d[i].type == 'MASTER') || (response.d[i].type == 'ADMIN')
                     || (response.d[i].type == 'RECEPCIONIST')){
                        arTemp.push(response.d[i]);
                    }

                }
                vm.users =  arTemp;

            },
            function(error){
                console.log(error);
            });
        api.serviceProfessionals.save({},
            function(response){
                vm.professionals =  response.d;
            },
            function(error){
                console.log(error);
            });
        api.serviceCategories.save({},
            function(response){
                vm.serviceCategories =  response.d;
            },
            function(error){
                console.log(error);
            });

        //configuracoes de filtro
        vm.filter = {
            dtFrom : new Date(new moment().add(-1,'d').valueOf()),
            dtTo : new Date()
        }


        switch($state.current.name){

            case 'app.report.customer.customersWithCreditDebitM':
            case 'app.report.customer.customersWithCreditDebit':
                vm.showTable = false;
                vm.refresh = refreshCustomersWithCreditDebit;
                vm.title = "Clientes com Credito/Debito"

                vm.openFilter = function(){
                    $mdSidenav('filter')
                        .toggle()
                        .then(function () {

                        });
                }

                refreshCustomersWithCreditDebit();

                break;
            case 'app.report.customer.top20M':
            case 'app.report.customer.top20':
                vm.showTable = false;
                vm.refresh = refreshTopCustomers;
                vm.title = "Principais Cliente (TOP 20)"

                vm.openFilter = function(){
                    $mdSidenav('filter')
                        .toggle()
                        .then(function () {

                        });
                }

                vm.top = 20;
                refreshTopCustomers();

                break;
            case 'app.report.customer.top50M':
            case 'app.report.customer.top50':
                vm.showTable = false;
                vm.refresh = refreshTopCustomers;
                vm.title = "Principais Cliente (TOP 50)"

                vm.openFilter = function(){
                    $mdSidenav('filter')
                        .toggle()
                        .then(function () {

                        });
                }

                vm.top = 50;
                refreshTopCustomers();

                break;
            case 'app.report.customer.top100M':
            case 'app.report.customer.top100':
                vm.showTable = false;
                vm.refresh = refreshTopCustomers;
                vm.title = "Principais Cliente (TOP 100)"

                vm.openFilter = function(){
                    $mdSidenav('filter')
                        .toggle()
                        .then(function () {

                        });
                }

                vm.top = 100;
                refreshTopCustomers();

                break;
            case 'app.report.customer.top200M':
            case 'app.report.customer.top200':
                vm.showTable = false;
                vm.refresh = refreshTopCustomers;
                vm.title = "Principais Cliente (TOP 200)"

                vm.openFilter = function(){
                    $mdSidenav('filter')
                        .toggle()
                        .then(function () {

                        });
                }

                vm.top = 200;
                refreshTopCustomers();

                break;
            case 'app.report.customer.birthdayM':
            case 'app.report.customer.birthday':
                vm.showTable = false;
                vm.refresh = refreshCustomersBirthday;
                vm.title = "Aniversariantes do mes"

                vm.openFilter = function(){
                    $mdSidenav('filter')
                        .toggle()
                        .then(function () {

                        });
                }

                refreshCustomersBirthday();

                break;

        }
        //////////
        function refreshCustomersBirthday(){

            api.customerBirthdayReport.save({
                    filterType:vm.filterType,
                    month:vm.month
                },
                function(response){
                    vm.showTable = true;

                    var html = "";

                    for(var i=0; i < response.d.length; i++){

                        html += "<tr>";
                        html += "<td>" + response.d[i].name + "</td>";
                        html += "<td>" + response.d[i].telephone + "</td>";
                        html += "<td>" + response.d[i].birthdayDay + "/" + response.d[i].birthdayMonth + "</td>";
                        html += "</tr>";

                    }

                    vm.html = html;
                },
                function(error){
                    console.log(error);
                });

        }

        function refreshTopCustomers(topX){

            setFilter();

            console.log(vm.finalFilter);

            api.customerTopReport.save({
                    filter:vm.finalFilter,
                    topX:vm.top
                },
                function(response){
                    vm.showTable = true;

                    var html = "";

                    for(var i=0; i < response.d.length; i++){

                        html += "<tr>";
                        html += "<td>" + response.d[i].customerName + "</td>";
                        html += "<td>" + response.d[i].customerTelephone + "</td>";
                        html += "<td>" + $filter('currency')(response.d[i].value, 'R$', 2) + "</td>";
                        html += "</tr>";

                    }


                    vm.html = html;
                },
                function(error){
                    console.log(error);
                });
        }

        function refreshCustomersWithCreditDebit(){
            api.customersWithCreditDebit.save({

                },
                function(response){
                    vm.showTable = true;

                    var html = "";
                    vm.saldo = 0;

                    for(var i=0; i < response.d.length; i++){
                        vm.saldo += response.d[i].creditDebit;


                        html += "<tr>";
                        html += "<td>" + response.d[i].name + "</td>";
                        html += "<td>" + response.d[i].telephone + "</td>";
                        html += "<td>" + $filter('currency')(response.d[i].creditDebit, 'R$',2) + "</td>";
                        html += "</tr>";

                    }


                    html += "<tr>";
                    html += "<td><b>Total</b></td>";
                    html += "<td></td>";
                    html += "<td><b>" + $filter('currency')(vm.saldo, 'R$',2) + "</b></td>";
                    html += "</tr>";

                    vm.html = html;
                },
                function(error){
                    console.log(error);
                });
        }

        function setFilter(){
            var arPaymentTypes = [];
            var arUsers = [];
            var arProfessionals = [];
            var arCategories = [];
            var arOffers = [];
            vm.finalFilter = {}

            //settng data
            vm.finalFilter.dtFrom = vm.filter.dtFrom.valueOf();
            vm.finalFilter.dtTo = vm.filter.dtTo.valueOf();

            //filtrando por payment type
            if (vm.filter.paymentType != undefined){
                if (vm.filter.paymentType.CASH){
                    arPaymentTypes.push('CASH');
                }
                if (vm.filter.paymentType.VISA_CREDIT){
                    arPaymentTypes.push('VISA_CREDIT');
                }
                if (vm.filter.paymentType.VISA_DEBIT){
                    arPaymentTypes.push('VISA_DEBIT');
                }
                if (vm.filter.paymentType.MASTER_CREDIT){
                    arPaymentTypes.push('MASTER_CREDIT');
                }
                if (vm.filter.paymentType.MASTER_DEBIT){
                    arPaymentTypes.push('MASTER_DEBIT');
                }
                if (vm.filter.paymentType.AMEX){
                    arPaymentTypes.push('AMEX');
                }
                if (vm.filter.paymentType.DINERS){
                    arPaymentTypes.push('DINERS');
                }
                if (vm.filter.paymentType.ELO){
                    arPaymentTypes.push('ELO');
                }
                if (vm.filter.paymentType.OTHER_CREDIT){
                    arPaymentTypes.push('OTHER_CREDIT');
                }
                if (vm.filter.paymentType.OTHER_DEBIT){
                    arPaymentTypes.push('OTHER_DEBIT');
                }
            }

            vm.finalFilter.paymentTypes = arPaymentTypes;

            //operador
            if ((vm.users != undefined) && (vm.filter.users != undefined)){
                for(var i=0; i < vm.users.length; i++){
                    if ((vm.filter.users[vm.users[i].id] != undefined) && (vm.filter.users[vm.users[i].id] == true)){
                        arUsers.push(vm.users[i].id);
                        console.log('aaaa');
                    }
                }

            }
            vm.finalFilter.users = arUsers;


            //profissional
            if ((vm.professionals != undefined) && (vm.filter.professionals != undefined)){
                for(var i=0; i < vm.professionals.length; i++){
                    if ((vm.filter.professionals[vm.professionals[i]._id] != undefined) && (vm.filter.professionals[vm.professionals[i]._id] == true)){
                        arProfessionals.push(vm.professionals[i]._id);
                    }
                }

            } else {
                console.log(vm.professionals);
            }
            vm.finalFilter.professionals = arProfessionals;

            //categories
            if ((vm.serviceCategories != undefined) && (vm.filter.categories != undefined)){
                for(var i=0; i < vm.serviceCategories.length; i++){
                    if ((vm.filter.categories[vm.serviceCategories[i]._id] != undefined) && (vm.filter.categories[vm.serviceCategories[i]._id] == true)){
                        arCategories.push(vm.serviceCategories[i]._id);
                    }
                }

            }
            vm.finalFilter.categories = arCategories;

            //offers
            if ((vm.offers != undefined) && (vm.filter.offers != undefined)){
                for(var i=0; i < vm.offers.length; i++){
                    if ((vm.filter.offers[vm.offers[i]._id] != undefined) && (vm.filter.offers[vm.offers[i]._id] == true)){
                        arOffers.push(vm.offers[i]._id);
                    }
                }

            }
            vm.finalFilter.offers = arOffers;


            //return
            //console.log(vm.finalFilter);

        }


    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.marketingv2.spot', ['ngMaterial', 'ngMessages'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.marketingv2.spot', {
                url    : '/spot',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketingv2/spot/configuration.html',
                        controller : 'MarketingSpotController as vm'
                    }
                },
                locals :{
                    campaignType : null
                }
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.marketingv2.spot')
        .controller('MarketingDialogSpotController', MarketingDialogSpotController);

    /** @ngInject */
    function MarketingDialogSpotController($q, api, $mdDialog, $mdToast, $translate, $scope,
                                            $state, $rootScope, campaignType)
    {
        var vm = this;

        ///configurações inciiais
        vm.messageType = 'SMS';
        vm.filterType = campaignType;
        vm.messageSMS = '';


        //recupera a quota
        api.quota.save({
            },
            function(response){
                vm.SMSQuota = response.d.sms;
            },
            function(error){
                vm.SMSQuota = 0;
            });

        vm.close = function(){
            $mdDialog.hide();
        }

        vm.sendMessage = function(){

            var period = null;
            var message = null;

            if (vm.messageType == 'SMS'){
                message = vm.messageSMS;
            }


            api.sendSpotMessage.save({
                    messageType : vm.messageType,
                    message : message,
                    period : period,
                    count:true,
                    filterType : vm.filterType,
                    categoryId : null,
                    professionalId : null
                },
                function(response) {
                    if (response.d > 0) {

                        //montando mensagem
                        var msg = "";
                        if (vm.SMSQuota > response.d){
                            msg = 'A mensagem será enviada para ' + response.d +  ' usuários. Confirma o envio?'
                        } else {
                                msg = 'Infelizmente você não possui quantidade de SMS suficiente para fazer o envio da campanha.Você tem atualmente '+
                                    vm.SMSQuota + ' créditos em sua conta e essa campanha foi direcionada para ' + response.d + ' clientes. Para adquirir mais créditos' +
                                    ' vá em Assinatura >> Extras. Deseja enviar assim mesmo para os ' + vm.SMSQuota + ' clientes?'

                        }


                        var confirm = $mdDialog.confirm()
                            .title('Confirmação')
                            .textContent(msg)
                            .ariaLabel('Confirmação')
                            .clickOutsideToClose(true)
                            .multiple(true)
                            .ok('Sim')
                            .cancel('Não');
                        $mdDialog.show(confirm).then(function () {

                            console.log('aaa');


                            //enviar mensagem
                            api.sendSpotMessage.save({
                                    messageType: vm.messageType,
                                    message: message,
                                    period: period,
                                    count: false,
                                    filterType: vm.filterType,
                                    categoryId: null,
                                    professionalId: null
                                }, function (response) {

                                },
                                function (error) {

                                });

                            var confirm = $mdDialog.confirm()
                                .title('Confirmação')
                                .textContent('As mensagens estão sendo enviadas. Acompanhe os envios no relatório de mensagens.')
                                .ariaLabel('Confirmação')
                                .clickOutsideToClose(true)
                                .multiple(true)
                                .ok('Ok');
                            $mdDialog.show(confirm).then(function () {
                                $state.go('app.report.marketing.messages');
                            });


                        }, function () {

                        });
                    } else {
                        var confirm = $mdDialog.confirm()
                            .title('Aviso')
                            .textContent('A seleção realizada não encontrou nenhum cliente. Refaça o filtro e tente novamente.')
                            .ariaLabel('Confirmação')
                            .clickOutsideToClose(true)
                            .multiple(true)
                            .ok('Ok');
                        $mdDialog.show(confirm).then(function () {

                        });
                    }

                },
                function(error){
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.GENERAL.TOAST.SAVE.ERROR"))
                            .hideDelay(2000)
                    );
                });
        }

        ////====================================================




    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.marketingv2.spot')
        .controller('MarketingSpotController', MarketingSpotController);

    /** @ngInject */
    function MarketingSpotController($q, api, $mdDialog, $mdToast, $translate, $scope,
                                            $state, $rootScope)
    {
        var vm = this;

        ///configurações inciiais
        vm.limitNumber = 100;
        vm.messageType = 'SMS';
        vm.filterTags = {};
        vm.filterTags.period = {
            period : "30"
        };
        vm.filterTags.tags = [];
        vm.filterType = 'TODOS';
        vm.messageSMS = '';
        vm.filterAtivos = {
            period : "30"
        };
        vm.filterServico = {
            period : "30"
        }
        vm.filterProfissional = {
            period : "30"
        }

        //recuperando o filterTYpe


        //recupera a quota
        api.quota.save({
            },
            function(response){
                vm.SMSQuota = response.d.sms;
            },
            function(error){
                vm.SMSQuota = 0;
            });

        //set profissionais
        api.allSimpleProfessionals.save({},
            function(response){
                vm.professionals =  response.d;

            },
            function(error){
                console.log(error);
            });
        api.serviceCategories.save({},
            function (response) {
                vm.serviceCategories = response.d;
            },
            function (error) {
                console.log(error);
            });
        api.spotCampaigns2.save({},
            function (response) {
            console.log(response.d);
                vm.spotCampaigns = response.d;
            },
            function (error) {
                console.log(error);
            });


        vm.sendMessage = function(){

            var period = null;
            var message = null;

            if (vm.messageType == 'SMS'){
                message = vm.messageSMS;
            }

            switch (vm.filterType){
                case "TODOS":
                    period = null;
                    break;
                case "ATIVOS":
                    period = vm.filterAtivos.period;
                    break;
                case "SERVICO":
                    period = vm.filterServico.period;
                    break;
                case "PROFISSIONAL":
                    period = vm.filterProfissional.period;
                    break;
                case "TAG":
                    period = vm.filterTags.period;
                    break;
            }

            api.sendSpotMessage.save({
                    messageType : vm.messageType,
                    message : message,
                    period : period,
                    excludeCustomersFromOtherCampaign:vm.filterTags.excludeCustomersFromOtherCampaign,
                    count:true,
                    limitNumber : vm.limitNumber,
                    filterType : vm.filterType,
                    categoryId : vm.filterServico.category,
                    professionalId : vm.filterProfissional.profissional,
                    tags : vm.filterTags.tags
                },
                function(response) {
                    if (response.d > 0) {

                        //montando mensagem
                        var msg = "";
                        if (vm.SMSQuota > response.d){
                            msg = 'A mensagem será enviada para ' + response.d +  ' usuários. Confirma o envio?'
                        } else {
                                msg = 'Infelizmente você não possui quantidade de SMS suficiente para fazer o envio da campanha.Você tem atualmente '+
                                    vm.SMSQuota + ' créditos em sua conta e essa campanha foi direcionada para ' + response.d + ' clientes. Para adquirir mais créditos' +
                                    ' vá em Assinatura >> Extras. Deseja enviar assim mesmo para os ' + vm.SMSQuota + ' clientes?'

                        }


                        var confirm = $mdDialog.confirm()
                            .title('Confirmação')
                            .textContent(msg)
                            .ariaLabel('Confirmação')
                            .clickOutsideToClose(true)
                            .multiple(true)
                            .ok('Sim')
                            .cancel('Não');
                        $mdDialog.show(confirm).then(function () {
                            //enviar mensagem
                            api.sendSpotMessage.save({
                                    messageType : vm.messageType,
                                    message : message,
                                    period : period,
                                    excludeCustomersFromOtherCampaign:vm.filterTags.excludeCustomersFromOtherCampaign,
                                    count:false,
                                    limitNumber : vm.limitNumber,
                                    filterType : vm.filterType,
                                    categoryId : vm.filterServico.category,
                                    professionalId : vm.filterProfissional.profissional,
                                    tags : vm.filterTags.tags
                                }, function (response) {

                                },
                                function (error) {

                                });

                            var confirm = $mdDialog.confirm()
                                .title('Confirmação')
                                .textContent('As mensagens estão sendo enviadas. Acompanhe os envios no relatório de mensagens.')
                                .ariaLabel('Confirmação')
                                .clickOutsideToClose(true)
                                .multiple(true)
                                .ok('Ok');
                            $mdDialog.show(confirm).then(function () {
                                $state.go('app.report.marketing.messages');
                            });


                        }, function () {

                        });
                    } else {
                        var confirm = $mdDialog.confirm()
                            .title('Aviso')
                            .textContent('A seleção realizada não encontrou nenhum cliente. Refaça o filtro e tente novamente.')
                            .ariaLabel('Confirmação')
                            .clickOutsideToClose(true)
                            .multiple(true)
                            .ok('Ok');
                        $mdDialog.show(confirm).then(function () {

                        });
                    }

                },
                function(error){
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.GENERAL.TOAST.SAVE.ERROR"))
                            .hideDelay(2000)
                    );
                });
        }

        ////====================================================




    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.marketingv2.wom', ['ngMaterial', 'ngMessages', 'ngStorage'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.marketingv2.wom', {
                url    : '/wom',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketingv2/wom/campaigns.html',
                        controller : 'MarketingWomController as vm'
                    }
                }
            })
            .state('app.marketingv2.wom.new', {
                url    : '/new',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketingv2/wom/campaign.html',
                        controller : 'MarketingWomController as vm'
                    }
                }
            })
            .state('app.marketingv2.wom.tutorial', {
                url    : '/tutorial',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketingv2/wom/tutorial.html',
                        controller : 'MarketingWomController as vm'
                    }
                }
            })
            .state('app.marketingv2.wom.edit', {
                url    : '/edit/:campaignId',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketingv2/wom/campaign.html',
                        controller : 'MarketingWomController as vm'
                    }
                }
            })
            .state('app.marketingv2.wom.promoters', {
                url: '/:campaignId/promoters',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/marketingv2/wom/promoters.html',
                        controller: 'MarketingWomController as vm'
                    }
                }
            })
            .state('app.marketingv2.wom.leads', {
                url: '/:campaignId/leads',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/marketingv2/wom/leads.html',
                        controller: 'MarketingWomController as vm'
                    }
                }
            })
            .state('app.marketingv2.wom.promoters.new', {
                url: '/:campaignId/promoters/new',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/marketingv2/wom/promoter.html',
                        controller: 'MarketingWomController as vm'
                    }
                }
            })
            .state('app.marketingv2.wom.promoters.transactions', {
                url: '/:campaignId/promoters/:promoterId/transactions',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/marketingv2/wom/transactions.html',
                        controller: 'MarketingWomController as vm'
                    }
                }
            })
        ;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.marketingv2.wom')
        .controller('MarketingWomController', MarketingWomController);

    /** @ngInject */
    function MarketingWomController($q, api, $mdDialog, $mdToast, $translate, $scope, $timeout,
                                            $state, $rootScope, DTDefaultOptions, DTOptionsBuilder, $localStorage)
    {
        var vm = this;


        $scope.$storage = $localStorage;

        if ($scope.$storage.womFirstTime == null){
            vm.firstTime = true;
            $scope.$storage.womFirstTime = false;
        } else {
            vm.firstTime=false;
        }


        //console.log($scope.$storage.womFirstTime);


        //check if is edit, insert or nothing
        var currentState = $state.current.name;
        vm.ngFlowOptions = {
            // You can configure the ngFlow from here
            target                   : backendServer + '/marketing/wom/saveCampaignWithFile',
            chunkSize                : 15 * 1024 * 1024,
            maxChunkRetries          : 1,
            simultaneousUploads      : 1,
            testChunks               : false,
            progressCallbacksInterval: 1000
        };
        vm.ngFlow = {
            // ng-flow will be injected into here through its directive
            flow: {}
        };
        vm.loading = true;

        //Initialize
        switch (currentState) {
            case "app.marketingv2.wom":
                if (vm.firstTime){
                    $state.go('app.marketingv2.wom.tutorial');
                };

                vm.removeCampaign = removeCampaign;
                vm.showPromoters = showPromoters;
                vm.showLeads = showLeads;
                vm.editCampaign = editCampaign;

                api.womCampaigns.save({},
                    function(response){
                        vm.campaigns = response.d;


                        setTimeout(function(){
                            vm.showTable = true;
                            $scope.$apply();
                        },200)

                    },
                    function(error){
                        console.log(error);
                    });

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({autoWidth : false})
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable":     "Nenhum registro disponível",
                        "sInfo":           "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty":      "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered":   "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix":    "",
                        "sInfoThousands":  ",",
                        "sLengthMenu":     "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing":     "Processando...",
                        "sSearch":         "Busca:",
                        "sZeroRecords":    "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst":    "Primeiro",
                            "sLast":     "Ultimo",
                            "sNext":     "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending":  ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });
                //vm.dtColumnDefs = [
                //    DTColumnDefBuilder.newColumnDef(0).notSortable()
                //];
                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');
                break;
            case "app.marketingv2.wom.new":{
                vm.saveCampaign = saveCampaign;
                vm.campaign = {};
                vm.campaign.name = "";
                vm.campaign.rewardConversionRule = 3;
                vm.campaign.smsInvitePromotor = "Convide seus amigos ao salao e ganhe serviços gratuitos.";
                vm.campaign.smsConfirmationNewCustomer = "Fale com seus amigos do salao e ganhe serviços gratuitos.";
                vm.campaign.rules = "Promoção exclusiva para novos clientes.";
                vm.campaign.title = '';
                vm.campaign.promoterHeading = '';
                vm.campaign.newCustomerHeading = '';
                vm.loading = false;
                break;
            }
            case "app.marketingv2.wom.edit":
                vm.saveCampaign = saveCampaign;
                vm.campaignId = $state.params.campaignId;
                vm.campaign = {};
                vm.campaign.images = [];

                api.womCampaign.save({
                    campaignId : vm.campaignId
                    },
                    function(response){

                        vm.campaign.name = response.d.WOCA_TX_NAME;
                        vm.campaign.title = response.d.WOCA_TX_TITLE;
                        vm.campaign.rewardConversionRule = response.d.WOCA_NR_REWARD_CONVERSION_RULE;
                        vm.campaign.smsInvitePromotor = response.d.WOCA_TX_SMS_PROMOTER_INVITE;
                        vm.campaign.smsConfirmationNewCustomer = response.d.WOCA_TX_SMS_NEW_CUSTOMER_INVITE;
                        vm.campaign.rules = response.d.WOCA_TX_RULES;
                        vm.campaign.promoterHeading = response.d.WOCA_TX_PROMOTER_HEADING;
                        vm.campaign.newCustomerHeading = response.d.WOCA_TX_NEW_CUSTOMER_HEADING;
                        if ((response.d.WOCA_TX_IMAGE_URL != null) && (response.d.WOCA_TX_IMAGE_URL.length == 0)){
                            vm.hasImage = false;
                            vm.loading = false;
                        } else {
                            $timeout(function() {
                                function loadXHR(url) {

                                    return new Promise(function(resolve, reject) {
                                        try {
                                            var xhr = new XMLHttpRequest();
                                            xhr.open("GET", url);
                                            xhr.responseType = "blob";
                                            xhr.onerror = function() {reject("Network error.")};
                                            xhr.onload = function() {
                                                if (xhr.status === 200) {xhr.response.name='temp.jpg'; resolve(xhr.response)}
                                                else {reject("Loading error:" + xhr.statusText)}
                                            };
                                            xhr.send();
                                        }
                                        catch(err) {reject(err.message)}
                                    });
                                }

                                loadXHR("https://s3.amazonaws.com/files.wommify.io/" + response.d.WOCA_TX_IMAGE_URL).then(function(blob) {
                                    vm.ngFlow.flow.addFile(blob);
                                    vm.hasImage = true;
                                    vm.loading = false;
                                });



                            })

                        }

                    },
                    function(error){
                        console.log(error);
                    });

                break;


            case "app.marketingv2.wom.leads":{
                vm.convertLead = convertLead;

                api.womCampaign.save({
                        campaignId : $state.params.campaignId
                    },
                    function(response) {
                        vm.campaignName = response.d.WOCA_TX_NAME;
                    },
                    function(error){
                        console.log(error);
                    });

                api.womGetCampaignLeads.save({
                        campaignId : $state.params.campaignId
                    },
                    function(response){
                        vm.leads = response.d;


                        setTimeout(function(){
                            vm.showTable = true;
                            $scope.$apply();
                        },200)

                    },
                    function(error){
                        console.log(error);
                    });

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({autoWidth : false})
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable":     "Nenhum registro disponível",
                        "sInfo":           "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty":      "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered":   "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix":    "",
                        "sInfoThousands":  ",",
                        "sLengthMenu":     "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing":     "Processando...",
                        "sSearch":         "Busca:",
                        "sZeroRecords":    "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst":    "Primeiro",
                            "sLast":     "Ultimo",
                            "sNext":     "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending":  ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });
                //vm.dtColumnDefs = [
                //    DTColumnDefBuilder.newColumnDef(0).notSortable()
                //];
                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                break;
            }
            case "app.marketingv2.wom.promoters":{
                vm.showTransactions = showTransactions;
                vm.resendLink = resendLink;

                api.womCampaign.save({
                    campaignId : $state.params.campaignId
                },
                    function(response) {
                        vm.campaignName = response.d.WOCA_TX_NAME;
                    },
                    function(error){
                        console.log(error);
                    });

                api.womGetCampaignPromoters.save({
                        campaignId : $state.params.campaignId
                    },
                    function(response){
                        vm.promoters = response.d;


                        setTimeout(function(){
                            vm.showTable = true;
                            $scope.$apply();
                        },200)

                    },
                    function(error){
                        console.log(error);
                    });

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({autoWidth : false})
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable":     "Nenhum registro disponível",
                        "sInfo":           "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty":      "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered":   "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix":    "",
                        "sInfoThousands":  ",",
                        "sLengthMenu":     "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing":     "Processando...",
                        "sSearch":         "Busca:",
                        "sZeroRecords":    "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst":    "Primeiro",
                            "sLast":     "Ultimo",
                            "sNext":     "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending":  ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });
                //vm.dtColumnDefs = [
                //    DTColumnDefBuilder.newColumnDef(0).notSortable()
                //];
                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                break;
            }
            case "app.marketingv2.wom.promoters.transactions":{

                vm.redeemReward = redeemReward;


                api.womCampaign.save({
                        campaignId : $state.params.campaignId
                    },
                    function(response) {
                        vm.campaignName = response.d.WOCA_TX_NAME;
                    },
                    function(error){
                        console.log(error);
                    });
                api.womPromoter.save({
                        promoterId : $state.params.promoterId
                    },
                    function(response) {
                        vm.promoterName = response.d.WOPR_TX_NAME;
                    },
                    function(error){
                        console.log(error);
                    });
                api.womPromoterBalance.save({
                        promoterId : $state.params.promoterId,
                        campaignId : $state.params.campaignId
                    },
                    function(response) {
                        vm.promoterBalance = response.d;
                    },
                    function(error){
                        console.log(error);
                    });

                api.womGetPromoterTransactions.save({
                        campaignId : $state.params.campaignId,
                        promoterId : $state.params.promoterId
                    },
                    function(response){
                        vm.transactions = response.d;


                        setTimeout(function(){
                            vm.showTable = true;
                            $scope.$apply();
                        },200)

                    },
                    function(error){
                        console.log(error);
                    });

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({autoWidth : false})
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable":     "Nenhum registro disponível",
                        "sInfo":           "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty":      "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered":   "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix":    "",
                        "sInfoThousands":  ",",
                        "sLengthMenu":     "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing":     "Processando...",
                        "sSearch":         "Busca:",
                        "sZeroRecords":    "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst":    "Primeiro",
                            "sLast":     "Ultimo",
                            "sNext":     "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending":  ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });
                //vm.dtColumnDefs = [
                //    DTColumnDefBuilder.newColumnDef(0).notSortable()
                //];
                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                break;
            }

            case "app.marketingv2.wom.promoters.new":{
                vm.invitePromoter = invitePromoter;
                vm.promoter = {};
                vm.promoter.name = "";
                vm.promoter.telephone = "";
                vm.promoter.campaignId = $state.params.campaignId;
                vm.campaignId = $state.params.campaignId;

                break;
            }
        }


        //Functions
        function saveCampaign(){

            if (vm.ngFlow.flow.files.length > 0){
                // salvando via ngFlow
                vm.ngFlow.flow.opts.headers = {
                };

                vm.ngFlow.flow.opts.query["campaignId"] = vm.campaignId;
                vm.ngFlow.flow.opts.query["name"] = vm.campaign.name;
                vm.ngFlow.flow.opts.query["title"] = vm.campaign.title;
                vm.ngFlow.flow.opts.query["rewardConversionRule"] = vm.campaign.rewardConversionRule;
                vm.ngFlow.flow.opts.query["smsInvitePromotor"] = vm.campaign.smsInvitePromotor;
                vm.ngFlow.flow.opts.query["smsConfirmationNewCustomer"] = vm.campaign.smsConfirmationNewCustomer;
                vm.ngFlow.flow.opts.query["rules"] = vm.campaign.rules;
                vm.ngFlow.flow.opts.query["promoterHeading"] = vm.campaign.promoterHeading;
                vm.ngFlow.flow.opts.query["promoterRules"] = vm.campaign.promoterRules;
                vm.ngFlow.flow.opts.query["leadRules"] = vm.campaign.leadRules;
                vm.ngFlow.flow.opts.query["newCustomerHeading"] = vm.campaign.newCustomerHeading;
                vm.ngFlow.flow.opts.query["token"] = $rootScope.securityToken;
                vm.ngFlow.flow.opts.query["countryCode"] = 55;


                vm.ngFlow.flow.upload();

            } else {
                api.womSaveCampaign.save({
                        campaignId: vm.campaignId,
                        name: vm.campaign.name,
                        title: vm.campaign.title,
                        rewardConversionRule: vm.campaign.rewardConversionRule,
                        smsInvitePromotor: vm.campaign.smsInvitePromotor,
                        smsConfirmationNewCustomer : vm.campaign.smsConfirmationNewCustomer,
                        rules : vm.campaign.rules,
                        promoterHeading : vm.campaign.promoterHeading,
                        newCustomerHeading : vm.campaign.newCustomerHeading,
                        promoterRules : vm.campaign.promoterRules,
                        leadRules : vm.campaign.leadRules,
                        countryCode : 55

                    },
                    function(response){
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Campanha salva com sucesso")
                                .hideDelay(1000)
                        );
                        //redirect
                        setTimeout(function(){
                            $state.go('app.marketingv2.wom');
                        }, 1000);


                    },
                    function(error){
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Erro ao inserir campanha")
                                .hideDelay(1000)
                        );
                        //redirect
                        setTimeout(function(){
                            $state.go('app.marketingv2.wom');
                        }, 1000);


                    });
            }


        }

        function removeCampaign(id) {
            var confirm = $mdDialog.confirm()
                .title("Aviso")
                .textContent("Você realmente quer excluir essa campanha?")
                .ariaLabel('Remove')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok($translate.instant("GENERAL.DIALOG.OK"))
                .cancel($translate.instant("GENERAL.DIALOG.CANCEL"));
            $mdDialog.show(confirm).then(function() {
                api.womRemoveCampaign.save({
                        campaignId: id
                    },
                    function(response){
                        if (response.s ==200){
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent("Campanha excluída com sucesso")
                                    .hideDelay(2000)
                            );
                            //redirect
                            setTimeout(function(){
                                $state.reload();
                            }, 1000);
                        } else {
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent("Erro ao excluir campanha")
                                    .hideDelay(2000)
                            );

                        }

                    },
                    function(error){
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.SERVICE.CATEGORY.TOAST.REMOVE.ERROR"))
                                .hideDelay(1000)
                        );

                        //redirect
                        setTimeout(function(){
                            $state.reload();
                        }, 1000);

                    });
            });
        };

        function showPromoters(id){
            $state.go('app.marketingv2.wom.promoters',{'campaignId':id});
        }

        function showLeads(id){
            $state.go('app.marketingv2.wom.leads',{'campaignId':id});
        }


        function editCampaign(id){
            $state.go('app.marketingv2.wom.edit',{'campaignId':id});
        }

        function invitePromoter(){
            api.womInvitePromoter.save({
                    campaignId: vm.promoter.campaignId,
                    name: vm.promoter.name,
                    telephone: vm.promoter.telephone
                },
                function(response){
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Promotor convidado com sucesso")
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function(){
                        $state.go('app.marketingv2.wom.promoters',{campaignId:$state.params.campaignId});
                    }, 1000);


                },
                function(error){
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Erro ao convidar promotor")
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function(){
                        $state.go('app.marketingv2.wom.promoters',{campaignId:vm.campaignId});
                    }, 1000);


                });
        }

        function showTransactions(promoterId){
            $state.go('app.marketingv2.wom.promoters.transactions',{'campaignId':$state.params.campaignId, 'promoterId':promoterId});
        }

        function redeemReward(){
            api.womRedeemReward.save({
                    campaignId: $state.params.campaignId,
                    promoterId: $state.params.promoterId
                },
                function(response){
                    if (response.d != 'INSUFICIENT_BALANCE'){
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Premio resgatado com sucesso")
                                .hideDelay(1000)
                        );
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Fundos insuficientes")
                                .hideDelay(1000)
                        );
                    }

                    //redirect
                    setTimeout(function(){
                        $state.reload();
                        //$state.go('app.marketingv2.wom.promoters.transactions',{campaignId:$state.params.campaignId, promoterId:$state.params.promoterId});
                    }, 1000);


                },
                function(error){
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Erro ao resgatar premio")
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function(){
                        //$state.go('app.marketingv2.wom.promoters',{campaignId:vm.campaignId});
                        $state.reload();
                    }, 1000);


                });
        }

        function resendLink(promoterId){
            api.womResendLink.save({
                    campaignId: $state.params.campaignId,
                    promoterId: promoterId
                },
                function(response) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Link enviado com sucesso")
                            .hideDelay(1000)
                    );

                },
                function(error){
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Erro ao enviar link")
                            .hideDelay(1000)
                    );


                });
        }

        function convertLead(cupomCode){
            api.womConvertFriend.save({
                    cupomCode: cupomCode
                },
                function(response) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Conversão registrada com sucesso.")
                            .hideDelay(1000)
                    );

                    $state.reload();

                },
                function(error){
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Erro ao registrar conversão")
                            .hideDelay(1000)
                    );

                    $state.reload();

                });
        }


        /////////////////////////////////////////UPLOAD ARQUIVO
        //lidando com o arquivo

        vm.dropping = false;
        vm.imageZoomOptions = {};
        vm.fileAdded = fileAdded;
        vm.fileSuccess = fileSuccess;
        vm.isFormValid = isFormValid;
        vm.hasImage = false;

        /**
         * File added callback
         * Triggers when files added to the uploader
         *
         * @param file
         */
        function fileAdded(file)
        {
            //console.log(file);
            // Prepare the temp file data for media list
            var uploadingFile = {
                id  : file.uniqueIdentifier,
                file: file,
                type: 'uploading'
            };

            //console.log(uploadingFile);

            // Append it to the media list
            vm.campaign.images = [uploadingFile];
            vm.hasImage = true;

        }

        vm.uploadComplete = function(){
            $mdToast.show(
                $mdToast.simple()
                    .textContent("Campanha salva com sucesso")
                    .hideDelay(1000)
            );
            //redirect
            setTimeout(function(){
                $state.go('app.marketingv2.wom');
            }, 1000);
        }

        /**
         * File upload success callback
         * Triggers when single upload completed
         *
         * @param file
         * @param message
         */
        function fileSuccess(file, message)
        {

            // Iterate through the media list, find the one we
            // are added as a temp and replace its data
            // Normally you would parse the message and extract
            // the uploaded file data from it
            angular.forEach(vm.campaign.images, function (media, index)
            {
                if ( media.id === file.uniqueIdentifier )
                {
                    // Normally you would update the media item
                    // from database but we are cheating here!
                    var fileReader = new FileReader();
                    fileReader.readAsDataURL(media.file.file);
                    fileReader.onload = function (event)
                    {
                        media.url = event.target.result;
                    };

                    // Update the image type so the overlay can go away
                    media.type = 'image';
                }
            });
        }

        /**
         * Checks if the given form valid
         *
         * @param formName
         */
        function isFormValid(formName)
        {
            if ( $scope[formName] && $scope[formName].$valid )
            {
                return $scope[formName].$valid;
            }
        }


        vm.removeImage = function (){

            vm.campaign.images = [];
            vm.hasImage = false;

            vm.ngFlow.flow.cancel()




        }
        ////////////////////////////////



    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.marketingv2.survey', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.marketingv2.survey', {
                url    : '/survey',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketingv2/survey/configuration.html',
                        controller : 'MarketingSurveyController as vm'
                    }
                }
            })
            .state('app.marketingv2.survey.explore', {
                url    : '/explore',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketingv2/survey/explore.html',
                        controller : 'MarketingSurveyController as vm'
                    }
                }
            })
            .state('app.marketingv2.survey.explorenow', {
                url    : '/explorenow',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketingv2/survey/explore.html',
                        controller : 'MarketingSurveyController as vm'
                    }
                }
            })
            .state('app.marketingv2.survey.configuration', {
                url    : '/configuration',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketingv2/survey/configuration.html',
                        controller : 'MarketingSurveyController as vm'
                    }
                }
            })
            .state('app.marketingv2.survey.dashboard', {
                url    : '/dashboard',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketingv2/survey/dashboard.html',
                        controller : 'MarketingSurveyController as vm'
                    }
                }
            })

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.marketingv2.survey')
        .controller('MarketingSurveyController', MarketingSurveyController);

    /** @ngInject */
    function MarketingSurveyController($q, api, $mdDialog, $mdToast, $translate, $scope,
                                            $state, DTOptionsBuilder, DTDefaultOptions,
                                            $rootScope, $localStorage)
    {
        var vm = this;

        var currentState = $state.current.name;
        $scope.$storage = $localStorage;

        //sistema de cores
        vm.npsStyle = {
            color: 'red'
        }

        switch (currentState) {
            case "app.marketingv2.survey.explore":
                if ($scope.$storage.showSurveyExplorer == null){
                    vm.showSurveyExplorer = false;
                } else {
                    vm.showSurveyExplorer = $scope.$storage.showSurveyExplorer;

                    if (vm.showSurveyExplorer){
                        $state.go('app.marketingv2.survey.dashboard');
                    }
                }

                $scope.$watch('vm.showSurveyExplorer', function() {
                    $scope.$storage.showSurveyExplorer = vm.showSurveyExplorer;
                });

                break;
            case "app.marketingv2.survey.dashboard":
                //carregando as medias gerais 30, 60, 90 dias
                api.surveyMedium.save({
                    days: 30
                }, function(response){

                    if (response.d[0].QTD > 0) {
                        vm.QTD30 = response.d[0].QTD;
                        vm.MEDIA30 = response.d[0].MEDIA;
                    } else {
                        vm.QTD30 = 0
                        vm.MEDIA30 = "-"
                    }

                });
                api.surveyMedium.save({
                    days: 60
                }, function(response){
                    if (response.d[0].QTD > 0) {
                        vm.QTD60 = response.d[0].QTD;
                        vm.MEDIA60 = response.d[0].MEDIA;
                    } else {
                        vm.QTD60 = 0
                        vm.MEDIA60 = "-"
                    }

                });
                api.surveyMedium.save({
                    days: 90
                }, function(response){
                    if (response.d[0].QTD > 0) {
                        vm.QTD90 = response.d[0].QTD;
                        vm.MEDIA90 = response.d[0].MEDIA;
                    } else {
                        vm.QTD90 = 0
                        vm.MEDIA90 = "-"
                    }

                });

                //carregando as categorias ja com as notas nos ultimos 30 dias
                api.serviceCategories.save({

                }, function(response){
                    var serviceCategories = response.d;

                    api.surveyMediumByCategory.save({

                    }, function(result){

                        var grade = result.d;

                        for(var i=0 ; i < serviceCategories.length; i++){
                            serviceCategories[i].MEDIA = "-";
                            serviceCategories[i].QTD = 0;
                        }

                        for(var i=0 ; i < serviceCategories.length; i++){
                            for(var j=0 ; j < grade.length; j++) {
                                if (serviceCategories[i]._id == grade[j].SECA_CD_SERVICE_CATEGORY) {
                                    serviceCategories[i].MEDIA = grade[j]["MEDIA"];
                                    serviceCategories[i].QTD = grade[j]["QTD"];
                                }
                            }
                        }



                        vm.serviceCategories = serviceCategories;
                    })
                })

                //carregando as profissionais ja com as notas nos ultimos 30 dias
                //carregando as medias das notas por profissional
                api.getProfessionalsWithSchedule.save({

                }, function(result){

                    var professionals = result.d

                    api.surveyMediumByProfessional.save({

                    }, function(result){

                        var grade = result.d;

                        for(var i=0 ; i < professionals.length; i++){
                            professionals[i].MEDIA = "-";
                            professionals[i].QTD = 0;
                        }

                        for(var i=0 ; i < professionals.length; i++){
                            for(var j=0 ; j < grade.length; j++) {
                                console.log(professionals[i]._id);
                                console.log(grade[j].PROF_CD_PROFESSIONAL);

                                if (professionals[i]._id == grade[j].PROF_CD_PROFESSIONAL) {
                                    professionals[i].MEDIA = grade[j]["MEDIA"];
                                    professionals[i].QTD = grade[j]["QTD"];
                                }
                            }
                        }



                        vm.professionals = professionals;
                    })

                })
                break;
            case "app.marketingv2.survey.configuration":
                //load info
                api.surveyConfiguration.save({
                    },
                    function(response){
                        if ((response.d == undefined) || (response.d == {}) ){
                            vm.configuration = {

                            }

                        } else {
                            vm.configuration = response.d;
                        }

                    },
                    function(error){
                        console.log(error);
                    });

                vm.saveSurveyConfiguration = function(){
                    api.saveMarketingSurveyConfiguration.save({
                            configuration : vm.configuration
                        },
                        function(response){
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent($translate.instant("SETTINGS.GENERAL.TOAST.SAVE.SUCCESS"))
                                    .hideDelay(2000)
                            );

                            $state.go('app.marketingv2.survey.dashboard');

                        },
                        function(error){
                            console.log(error);
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent($translate.instant("SETTINGS.GENERAL.TOAST.SAVE.ERROR"))
                                    .hideDelay(2000)
                            );
                        });
                }
                break;
            case "app.marketingv2.survey.explorenow":
                if ($scope.$storage.showSurveyExplorer == null){
                    vm.showSurveyExplorer = false;
                } else {
                    vm.showSurveyExplorer = $scope.$storage.showSurveyExplorer;
                }

                $scope.$watch('vm.showSurveyExplorer', function() {
                    $scope.$storage.showSurveyExplorer = vm.showSurveyExplorer;
                });

        }





        ////====================================================

        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({},last);
        $scope.getToastPosition = function() {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function(pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if ( current.bottom && last.top ) current.top = false;
            if ( current.top && last.bottom ) current.bottom = false;
            if ( current.right && last.left ) current.left = false;
            if ( current.left && last.right ) current.right = false;
            last = angular.extend({},current);
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.marketingv2.welcome', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.marketingv2.welcome', {
                url    : '/welcome',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketingv2/welcome/configuration.html',
                        controller : 'MarketingWelcomeController as vm'
                    }
                }
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.marketingv2.welcome')
        .controller('MarketingWelcomeController', MarketingWelcomeController);

    /** @ngInject */
    function MarketingWelcomeController($q, api, $mdDialog, $mdToast, $translate, $scope,
                                            $state, $rootScope)
    {
        var vm = this;

        //load info
        api.welcomeConfiguration.save({
            },
            function(response){
                if ((response.d == undefined) || (response.d == {}) ){
                    vm.configuration = {

                    }

                } else {
                    vm.configuration = response.d;
                }

            },
            function(error){
                console.log(error);
            });

        vm.saveConfiguration = function(){
            api.saveWelcomeConfiguration.save({
                    configuration : vm.configuration
                },
                function(response){
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.GENERAL.TOAST.SAVE.SUCCESS"))
                            .hideDelay(2000)
                    );

                    window.Intercom('boot', {
                        "campaign_birthday": vm.configuration.enableSMS // Boolean
                    });


                },
                function(error){
                    console.log(error);
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.GENERAL.TOAST.SAVE.ERROR"))
                            .hideDelay(2000)
                    );
                });
        }

        ////====================================================




    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.marketingv2.reminder', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.marketingv2.reminder', {
                url    : '/reminder',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketingv2/reminder/configuration.html',
                        controller : 'MarketingReminderController as vm'
                    }
                }
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.marketingv2.reminder')
        .controller('MarketingReminderController', MarketingReminderController);

    /** @ngInject */
    function MarketingReminderController($q, api, $mdDialog, $mdToast, $translate, $scope,
                                            $state, DTOptionsBuilder, DTDefaultOptions,
                                            $rootScope)
    {
        var vm = this;

        //load info
        api.reminderConfiguration.save({
            },
            function(response){
                if ((response.d == undefined) || (response.d == {}) ){
                    vm.configuration = {
                        whenType : 'twoDays',
                        sendReminderSMS : true
                    }

                } else {
                    vm.configuration = response.d;
                }

            },
            function(error){
                console.log(error);
            });

        vm.saveReminderConfiguration = function(){
            api.saveReminderConfiguration.save({
                    configuration : vm.configuration
                },
                function(response){
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.GENERAL.TOAST.SAVE.SUCCESS"))
                            .hideDelay(2000)
                    );

                },
                function(error){
                    console.log(error);
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.GENERAL.TOAST.SAVE.ERROR"))
                            .hideDelay(2000)
                    );
                });
        }

        ////====================================================

        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({},last);
        $scope.getToastPosition = function() {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function(pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if ( current.bottom && last.top ) current.top = false;
            if ( current.top && last.bottom ) current.bottom = false;
            if ( current.right && last.left ) current.left = false;
            if ( current.left && last.right ) current.right = false;
            last = angular.extend({},current);
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.marketingv2.partnership', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.marketingv2.partnership', {
                url    : '/partnership'
            }).state('app.marketingv2.partnership.list', {
                url    : '/list',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketingv2/partnership/list.html',
                        controller : 'MarketingPartnershipController as vm'
                    }
                }
            }).state('app.marketingv2.partnership.new', {
                url    : '/list',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketingv2/partnership/partnership.html',
                        controller : 'MarketingPartnershipController as vm'
                    }
                }
            }).state('app.marketingv2.partnership.edit', {
                url    : '/edit/:partnershipId',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketingv2/partnership/partnership.html',
                        controller : 'MarketingPartnershipController as vm'
                    }
                }
            })
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.marketingv2.partnership')
        .controller('MarketingPartnershipController', MarketingPartnershipController);

    /** @ngInject */
    function MarketingPartnershipController($mdSidenav, $q, api, $mdDialog, $mdToast, $translate, $scope, $state,DTOptionsBuilder, DTDefaultOptions)
    {
        var vm = this;
        vm.removePartnership = removePartnership;
        vm.savePartnership = savePartnership;
        vm.editPartnership = editPartnership;

        switch ($state.current.name){
            case 'app.marketingv2.partnership.list':
                vm.showTable = false;

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({autoWidth : false})
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable":     "Nenhum registro disponível",
                        "sInfo":           "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty":      "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered":   "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix":    "",
                        "sInfoThousands":  ",",
                        "sLengthMenu":     "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing":     "Processando...",
                        "sSearch":         "Busca:",
                        "sZeroRecords":    "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst":    "Primeiro",
                            "sLast":     "Ultimo",
                            "sNext":     "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending":  ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });
                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                api.partnerships.save({

                    },
                    function(response){
                        vm.showTable = true;
                        vm.partnerships = response.d;
                    },
                    function(error){
                        console.log(error);
                    });

                break;
            case 'app.marketingv2.partnership.new':
                vm.partnership = {}
                vm.partnership.priority = 10;
                api.priceTables.save({

                    },
                    function(response){
                        vm.priceTables = response.d;
                        vm.partnership.priceTableId = response.d[0]._id;
                    },
                    function(error){
                        console.log(error);
                    });
                break;
            case 'app.marketingv2.partnership.edit':
                api.partnership.save({
                        _id : $state.params.partnershipId
                    },
                    function(response){
                        console.log(response.d);
                        vm.partnership = response.d;

                        api.priceTables.save({

                            },
                            function(response){
                                vm.priceTables = response.d;
                                //vm.partnership.priceTableId = response.d[0]._id;
                            },
                            function(error){
                                console.log(error);
                            });
                    },
                    function(error){
                        console.log(error);
                    });
                break;
        }


        //////////////////////////////////////////////////
        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({},last);
        $scope.getToastPosition = function() {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function(pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if ( current.bottom && last.top ) current.top = false;
            if ( current.top && last.bottom ) current.bottom = false;
            if ( current.right && last.left ) current.left = false;
            if ( current.left && last.right ) current.right = false;
            last = angular.extend({},current);
        }


        function savePartnership(){

            api.savePartnership.save({
                    name:vm.partnership.name,
                    priority: vm.partnership.priority,
                    priceTableId : vm.partnership.priceTableId,
                    _id:$state.params.partnershipId
                },
                function(response) {

                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.PARTNERSHIP.TOAST.SAVE.SUCCESS"))
                            .position(pinTo)
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.go('app.marketingv2.partnership.list');
                    }, 1000);


                },
                function(error){
                    if (close){
                        $mdDialog.hide();
                    } else {
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("MARKETING.PARTNERSHIP.TOAST.SAVE.ERROR"))
                                .position(pinTo )
                                .hideDelay(1000)
                        );
                        //redirect
                        setTimeout(function(){
                            $state.go('app.marketingv2.partnership.list');
                        }, 1000);
                    }

                });
        }

        function removePartnership(id){
            api.removePartnership.save({
                    _id:id
                },
                function(response) {

                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.PARTNERSHIP.TOAST.REMOVE.SUCCESS"))
                            .position(pinTo)
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.reload();
                    }, 1000);


                },
                function(error){
                    if (close){
                        $mdDialog.hide();
                    } else {
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("MARKETING.PARTNERSHIP.TOAST.REMOVE.ERROR"))
                                .position(pinTo )
                                .hideDelay(1000)
                        );
                        //redirect
                        setTimeout(function(){
                            $state.reload();
                        }, 1000);
                    }

                });
        }

        function editPartnership(id){
            $state.go('app.marketingv2.partnership.edit',{partnershipId: id});
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.marketingv2.noshowreschedule', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.marketingv2.noshowreschedule', {
                url    : '/noshowreschedule',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketingv2/noshowreschedule/configuration.html',
                        controller : 'MarketingNoshowRescheduleController as vm'
                    }
                }
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.marketingv2.noshowreschedule')
        .controller('MarketingNoshowRescheduleController', MarketingNoshowRescheduleController);

    /** @ngInject */
    function MarketingNoshowRescheduleController($q, api, $mdDialog, $mdToast, $translate, $scope,
                                            $state, DTOptionsBuilder, DTDefaultOptions,
                                            $rootScope)
    {
        var vm = this;

        //load info
        api.noshowRescheduleConfiguration.save({
            },
            function(response){
                if ((response.d == undefined) || (response.d == {}) ){
                    vm.configuration = {

                    }

                } else {
                    vm.configuration = response.d;
                }

            },
            function(error){
                console.log(error);
            });

        vm.saveConfiguration = function(){
            api.saveNoshowRescheduleConfiguration.save({
                    configuration : vm.configuration
                },
                function(response){
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.GENERAL.TOAST.SAVE.SUCCESS"))
                            .hideDelay(2000)
                    );

                },
                function(error){
                    console.log(error);
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.GENERAL.TOAST.SAVE.ERROR"))
                            .hideDelay(2000)
                    );
                });
        }

        ////====================================================

        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({},last);
        $scope.getToastPosition = function() {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function(pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if ( current.bottom && last.top ) current.top = false;
            if ( current.top && last.bottom ) current.bottom = false;
            if ( current.right && last.left ) current.left = false;
            if ( current.left && last.right ) current.right = false;
            last = angular.extend({},current);
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.marketingv2.loyalty2', ['ngMaterial', 'ngMessages'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.marketingv2.loyalty2', {
                url    : '/loyalty2'
            })
            .state('app.marketingv2.loyalty2.configuration', {
                url    : '/config',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketingv2/loyalty2/config.html',
                        controller : 'MarketingLoyalty2Controller as vm'
                    }
                }
            })
            .state('app.marketingv2.loyalty2.dashboard', {
                url    : '/dashboard',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketingv2/loyalty2/dashboard.html',
                        controller : 'MarketingLoyalty2Controller as vm'
                    }
                }
            })
            .state('app.marketingv2.loyalty2.transactions', {
                url    : '/transactions/:customerId',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketingv2/loyalty2/transactions.html',
                        controller : 'MarketingLoyalty2Controller as vm'
                    }
                }
            })
            .state('app.marketingv2.loyalty2.explore', {
                url    : '/explore',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketingv2/loyalty2/explore.html',
                        controller : 'MarketingLoyalty2Controller as vm'
                    }
                }
            })
            .state('app.marketingv2.loyalty2.explorenow', {
                url    : '/explorenow',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketingv2/loyalty2/explore.html',
                        controller : 'MarketingLoyalty2Controller as vm'
                    }
                }
            })

        ;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.marketingv2.loyalty2')
        .controller('MarketingLoyalty2Controller', MarketingLoyalty2Controller);

    /** @ngInject */
    function MarketingLoyalty2Controller($q, api, $mdDialog, $mdToast, $translate, $scope, $timeout, $compile,
                                            $state, $rootScope, DTDefaultOptions, DTOptionsBuilder, DTColumnBuilder, $localStorage)
    {
        var vm = this;



        //check if is edit, insert or nothing
        var currentState = $state.current.name;
        $scope.$storage = $localStorage;
        var customerId = 0;


        var userType = $rootScope.userType;
        if ((userType == 'MASTER') || (userType == 'ADMIN')){
            vm.profileAdmin = true;
        } else {
            vm.profileAdmin = false;
        }


        //Initialize
        switch (currentState) {
            case "app.marketingv2.loyalty2.configuration":
                vm.configuration = $rootScope.pdvConfiguration;
                if (vm.configuration.loyaltyConfiguration.serviceCost == null){
                    vm.configuration.loyaltyConfiguration.serviceCost = 0;
                }
                if (vm.configuration.loyaltyConfiguration.pointsToRedeem == null){
                    vm.configuration.loyaltyConfiguration.pointsToRedeem = 0;
                }

                api.serviceServices.save({

                },
                function(response){
                    vm.services = response.d.services
                    if (vm.configuration.loyaltyConfiguration.prizeServiceId == null){
                        vm.configuration.loyaltyConfiguration.prizeServiceId = vm.services[0]._id;
                    }

                },
                function(error){

                });

            break;
            case "app.marketingv2.loyalty2.explore":
                if ($scope.$storage.showLoyaltyExplorer == null){
                    vm.showLoyaltyExplorer = false;
                } else {
                    vm.showLoyaltyExplorer = $scope.$storage.showLoyaltyExplorer;

                    if (vm.showLoyaltyExplorer){
                        $state.go('app.marketingv2.loyalty2.dashboard');
                    }
                }

                $scope.$watch('vm.showLoyaltyExplorer', function() {
                    $scope.$storage.showLoyaltyExplorer = vm.showLoyaltyExplorer;
                });


                break;
            case "app.marketingv2.loyalty2.explorenow":
                if ($scope.$storage.showLoyaltyExplorer == null){
                    vm.showLoyaltyExplorer = false;
                } else {
                    vm.showLoyaltyExplorer = $scope.$storage.showLoyaltyExplorer;
                }

                $scope.$watch('vm.showLoyaltyExplorer', function() {
                    $scope.$storage.showLoyaltyExplorer = vm.showLoyaltyExplorer;
                });


                break;

            case "app.marketingv2.loyalty2.dashboard":
                //check configurastion and redirect
                vm.configuration = $rootScope.pdvConfiguration;
                vm.showOnlyWithPoints = true;

                if (vm.profileAdmin){
                    if (!vm.configuration.loyaltyConfiguration.active){
                        $state.go('app.marketingv2.loyalty2.configuration');
                    }
                }

                vm.showTable = false;


                vm.showTable = true;
                vm.dtColumns = [
                    DTColumnBuilder.newColumn('name').withTitle('Nome').notSortable(),
                    DTColumnBuilder.newColumn('telephone').withTitle('Telefone').notSortable(),
                    DTColumnBuilder.newColumn('points').withTitle('Pontos').notSortable(),
                    DTColumnBuilder.newColumn('_id').notVisible().notSortable(),
                    DTColumnBuilder.newColumn(null).withClass('right').withTitle('').renderWith(function (data, type, full) {
                        var sHtml = "";
                        sHtml = sHtml + '<md-button aria-label="Plus" class="md-raised md-simpleButton gp-mini" ng-click="::vm.credit(\'' + full._id + '\')" ><md-tooltip aria-label="Pencil">Creditar pontos</md-tooltip><i class="icon-plus" layout="center"></i></md-button>';
                        sHtml = sHtml + '<md-button aria-label="Less" class="md-raised md-simpleButton gp-mini" ng-click="::vm.resetCustomerLoyalty(\'' + full._id + '\')"><md-tooltip aria-label="Pencil">Zerar Pontos</md-tooltip><i class="icon-trash" layout="center"></i></md-button>';
                        sHtml = sHtml + '<md-button aria-label="Less" class="md-raised md-simpleButton gp-mini" ng-click="::vm.sendBalanceToCustomer(\'' + full._id + '\')"><md-tooltip aria-label="Pencil">Enviar SMS com pontos</md-tooltip><i class="icon-message" layout="center"></i></md-button>';
                        sHtml = sHtml + '<md-button aria-label="Less" class="md-raised md-simpleButton gp-mini" ng-click="::vm.gotoHistory(\'' + full._id + '\')"><md-tooltip aria-label="Pencil">Histórico de pontos</md-tooltip><i class="icon-view-list" layout="center"></i></md-button>';
                        sHtml = sHtml + '<md-button aria-label="Trash" class="md-raised md-simpleButton gp-mini" ng-click="::vm.customerInventory(\'' + full._id + '\')"><md-tooltip aria-label="Pencil">{{ "GENERAL.HINTS.INVENTORY" | translate }}</md-tooltip><i class="icon-shopping" layout="center"></i></md-button>';


                        return sHtml;
                    })


                ];

                //console.log($window.localStorage['securityToken']);
                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption('ajax', {
                        // Either you specify the AjaxDataProp here
                        // dataSrc: 'data',
                        url: backendServer + '/customer/getCustomersLoyalty',
                        type: 'POST',
                        data:{
                            token: $rootScope.securityToken
                        }
                    })
                    .withDataProp('d')
                    .withOption('autoWidth', false)
                    .withOption('processing', true)
                    .withOption('serverSide', true)
                    .withOption('createdRow', function (row) {
                        // Recompiling so we can bind Angular directive to the DT
                        $compile(angular.element(row).contents())($scope);
                    })
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable": "Nenhum registro disponível",
                        "sInfo": "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty": "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered": "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix": "",
                        "sInfoThousands": ",",
                        "sLengthMenu": "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing": "Processando...",
                        "sSearch": "Busca:",
                        "sZeroRecords": "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst": "Primeiro",
                            "sLast": "Ultimo",
                            "sNext": "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending": ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });
                //vm.dtColumnDefs = [
                //    DTColumnDefBuilder.newColumnDef(0).notSortable()
                //];
                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                break;

                break;

            case "app.marketingv2.loyalty2.transactions":
                var customerId = $state.params.customerId;
                api.customer.save({
                    customerId : customerId
                }, function(response) {
                    vm.customerName = response.d.name;
                });
                api.getCustomerLoyaltyTransactions.save({
                    customerId : customerId
                }, function (response) {
                    vm.transactions = response.d;
                    vm.showTable = true;

                })

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({autoWidth : false})
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable":     "Nenhum registro disponível",
                        "sInfo":           "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty":      "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered":   "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix":    "",
                        "sInfoThousands":  ",",
                        "sLengthMenu":     "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing":     "Processando...",
                        "sSearch":         "Busca:",
                        "sZeroRecords":    "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst":    "Primeiro",
                            "sLast":     "Ultimo",
                            "sNext":     "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending":  ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });
                //vm.dtColumnDefs = [
                //    DTColumnDefBuilder.newColumnDef(0).notSortable()
                //];
                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                break;
        }

        ////////////////////////////////
        vm.credit = function (customerId) {

            $mdDialog.show({
                template: [
                    '<md-dialog style="width:500px;"  ng-class="dialog.css">',
                    '<form name="basicForm" class="md-inline-form"  novalidate>' ,
                    '  <md-dialog-content class="md-dialog-content" role="document" tabIndex="-1">',
                    '    <h2 class="md-title">Creditar Pontos na Fidelidade</h2>',
                    '    <div class="md-dialog-content-body">',
                    '      <p>Informe o valor de crédito que deve ser feito. </p>',
                    '    </div>',
                    '    <div layout="row" layout-gt-sm="row">',
                    '    <md-input-container md-no-float class="md-prompt-input-container" flex="50">',
                    '      <label>Valor</label>',
                    '      <input type=number name=valor required md-autofocus ng-model="dialog.result.value" min="1" step="1"> ' +
                    '       <div ng-messages="basicForm.valor.$error" role="alert">',
                    '          <div ng-message="required">',
                    '           <span>Valor é obrigatório</span>',
                    '          </div>',
                    '       </div>',
                    '    </md-input-container>',
                    '    </div>',
                    '    <div layout="row" layout-gt-sm="row">',
                    '    <md-input-container md-no-float class="md-prompt-input-container" flex="100">',
                    '      <label>Observação</label>'+
                    '      <input type=text name=obs required ng-model="dialog.result.observation"  ' +
                    '             placeholder="Observação"></input>',
                    '       <div ng-messages="basicForm.obs.$error" role="alert">',
                    '          <div ng-message="required">',
                    '           <span>Justificativa é obrigatória</span>',
                    '          </div>',
                    '       </div>',
                    '    </md-input-container>',
                    '   </div>',
                    '  <md-dialog-actions>',
                    '    <md-button ng-click="dialog.hide()" ng-disabled="basicForm.$invalid" class="md-raised md-confirm-button" >',
                    '      {{ dialog.ok }}',
                    '    </md-button>',
                    '    <md-button ng-click="dialog.abort()" class="md-raised md-warn">',
                    '      {{ dialog.cancel }}',
                    '    </md-button>',
                    '  </md-dialog-actions>',
                    '</form>',
                    '</md-dialog>'
                ].join('').replace(/\s\s+/g, ''),
                multiple: false,
                controller: function mdDialogCtrl() {
                    this.ok = 'Confirmar';
                    this.cancel = 'Cancelar';
                    this.result = {};
                    this.result.value= 1;
                    this.result.date = new Date();


                    this.hide = function () {
                        $mdDialog.hide(this.result);
                    };
                    this.abort = function () {
                        $mdDialog.cancel();
                    };

                },
                controllerAs: 'dialog',
                bindToController: true,

            })
                .then(function (result) {

                    api.creditCustomerLoyalty.save({
                            customerId : customerId,
                            points : result.value,
                            observation : result.observation,
                            date : result.date
                        },
                        function(response){
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent("Pontos foram cadastrados com sucesso.")
                                    .hideDelay(2000)
                            );

                            $state.reload();
                        },
                        function(error){
                            console.log(error);
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent("Ocorreu um erro ao cadastrar os pontos. Por favor tente novamente")
                                    .hideDelay(2000)
                            );

                            $state.reload();
                        });


                }, function () {
                    $mdDialog.cancel();
                });


        }

        vm.sendBalanceToCustomer = function(customerId){
            api.sendBalanceToCustomer.save({
                    customerId : customerId
                },
                function(response){
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Mensagem foi enviada ao cliente")
                            .hideDelay(2000)
                    );


                },
                function(error){

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Ocorreu um erro ao enviar a mensagem. Verifique se você tem crédito de SMS, caso contrário contate agora o nosso suporte para que possamos lhe ajudar.")
                            .hideDelay(10000)
                    );


                });
        };

        vm.customerInventory = function(customerId) {
            $state.go('app.customer.inventory', { customerId: customerId });
        }


        vm.gotoHistory = function(customerId){
            $state.go('app.marketingv2.loyalty2.transactions', {customerId: customerId});
        }

        vm.resetEntireLoyalty = function(){
            var confirm = $mdDialog.confirm()
                .title("Aviso")
                .textContent("Você realmente quer resetar os pontos de TODA a campanha? Essa operação é  irreversivel.")
                .ariaLabel('Remove')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok($translate.instant("GENERAL.DIALOG.OK"))
                .cancel($translate.instant("GENERAL.DIALOG.CANCEL"));
            $mdDialog.show(confirm).then(function() {
                api.resetEntireLoyalty.save({

                    },
                    function(response){
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Programa de fidelidade foi inteiramente resetado. Todos os pontos foram descartados.")
                                .hideDelay(2000)
                        );


                    },
                    function(error){
                        console.log(error);
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Ocorreu um erro ao resetar o plano de fidelidade.")
                                .hideDelay(2000)
                        );

                        $state.go('app.marketingv2.loyalty2.dashboard');
                    });

            });

        }

        vm.removeTransaction = function(id){
            api.resetTransaction.save({
                    transactionId : id
                },
                function(response){
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Pontos foram estornados.")
                            .hideDelay(2000)
                    );

                    $state.reload();
                },
                function(error){
                    console.log(error);
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Ocorreu um erro ao estornar os pontos.")
                            .hideDelay(2000)
                    );

                    $state.reload();
                });
        }

        vm.resetCustomerLoyalty = function(id){
            var confirm = $mdDialog.confirm()
                .title("Aviso")
                .textContent("Você realmente quer resetar os pontos desse cliente?")
                .ariaLabel('Remove')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok($translate.instant("GENERAL.DIALOG.OK"))
                .cancel($translate.instant("GENERAL.DIALOG.CANCEL"));

            if (id != null){
                customerId = id;
            } else {
                customerId = $state.params.customerId;
            }

            $mdDialog.show(confirm).then(function() {
                api.resetCustomerLoyalty.save({
                        customerId : customerId
                    },
                    function(response){
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Pontos foram excluidos e saldo do cliente foi zerado.")
                                .hideDelay(2000)
                        );

                        $state.reload();
                    },
                    function(error){
                        console.log(error);
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Ocorreu um erro ao resetar o plano de fidelidade.")
                                .hideDelay(2000)
                        );

                        $state.reload();
                    });

            });
        }

        vm.saveConfiguration = function(){
            api.saveGeneralConfiguration.save({
                    configuration : vm.configuration
                },
                function(response){
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.GENERAL.TOAST.SAVE.SUCCESS"))
                            .hideDelay(2000)
                    );

                    $rootScope.pdvConfiguration = response.d;

                    if (vm.configuration.loyaltyConfiguration.active) {
                        $state.go('app.marketingv2.loyalty2.dashboard');
                    }

                },
                function(error){
                    console.log(error);
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.GENERAL.TOAST.SAVE.ERROR"))
                            .hideDelay(2000)
                    );
                });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.marketingv2.loyalty',
        [
            // 3rd Party Dependencies
            'datatables'
        ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {


        $stateProvider.state('app.marketingv2.loyalty', {
            url: '/loyalty'
        }).state('app.marketingv2.loyalty.edit', {
            url: '/edit',
            views: {
                'content@app': {
                    templateUrl: 'app/main/marketingv2/loyalty/loyalty.html',
                    controller: 'LoyaltyController as vm'
                }
            }
        }).state('app.marketingv2.loyalty.mycredits', {
            url: '/mycredits/:token',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.marketingv2.loyalty.mycredits': {
                    templateUrl: 'app/main/marketingv2/loyalty/site.html',
                    controller : 'LoyaltyController as vm'
                }
            }

        }).state('app.marketingv2.loyalty.buzz', {
            url: '/buzz',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.marketingv2.loyalty.buzz': {
                    templateUrl: 'app/main/marketingv2/loyalty/buzz.html',
                    controller : 'LoyaltyController as vm'
                }
            }

        }).state('app.marketingv2.loyalty.buzzRegister', {
            url: '/buzzRegister',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.marketingv2.loyalty.buzzRegister': {
                    templateUrl: 'app/main/marketingv2/loyalty/buzzRegister.html',
                    controller : 'LoyaltyController as vm'
                }
            }

        });

    }

})();
(function () {
    'use strict';


    angular
        .module('app.marketingv2.loyalty')
        .controller('LoyaltyController', LoyaltyController);


    /** @ngInject */
    function LoyaltyController($q, $state, $scope, DTOptionsBuilder,
                               DTColumnBuilder, api, DTDefaultOptions, $translate, $mdDialog,
                               $mdToast, $window, $stateParams) {


        var vm = this;


        //check if is edit, insert or nothing
        var currentState = $state.current.name;


        //Initialize


        switch (currentState) {
            case "app.marketingv2.loyalty.buzz":
                vm.whatsapp = function(){
                    $window.open();
                }
                break;
            case "app.marketingv2.loyalty.mycredits":


                vm.customerTransactions = [
                    {
                        id :0,
                        when: new moment().format('DD/MM/YYYY'),
                        points : 20,
                        serviceName : 'Barba'
                    },
                    {
                        id :2,
                        when: new moment().add(-7,'days').format('DD/MM/YYYY'),
                        points : 20,
                        serviceName : 'Barba'
                    },
                    {
                        id :3,
                        when: new moment().add(-15,'days').format('DD/MM/YYYY'),
                        points : 20,
                        serviceName : 'Barba'
                    },
                    {
                        id :4,
                        when: new moment().add(-30,'days').format('DD/MM/YYYY'),
                        points : 20,
                        serviceName : 'Barba'
                    },
                    {
                        id :5,
                        when: new moment().add(-40,'days').format('DD/MM/YYYY'),
                        points : 20,
                        serviceName : 'Barba'
                    },
                ]
                //getCustomerLoyaltyTransactions($stateParams.token);

                break;
            case "app.marketingv2.loyalty.edit":

               
                //vm.customerPoints = 0;
                vm.value;
                //vm.customerSearchTextChange = customerSearchTextChange;
                vm.getCustomersPoints = getCustomersPoints;
                vm.getServicePoints = getServicePoints;
                vm.exchangePointsForService = exchangePointsForService;
                vm.canExchangePoints = canExchangePoints;



                break;
        }


        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({}, last);
        $scope.getToastPosition = function () {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function (pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if (current.bottom && last.top) current.top = false;
            if (current.top && last.bottom) current.bottom = false;
            if (current.right && last.left) current.left = false;
            if (current.left && last.right) current.right = false;
            last = angular.extend({}, current);
        }
        ///END TOAST

        // Methods

        ///service autocomplete
        vm.serviceSearchText = ""
        vm.serviceSearchTextChange = serviceSearchTextChange;
        vm.serviceSearchItems = [];
        vm.addServiceDialog = {};
        vm.floatinglabel = {
            service: $translate.instant("SALES.CHECK.SERVICE"),
            professional: $translate.instant("SALES.CHECK.PROFESSIONAL")
        }

        function serviceSearchTextChange(search) {
            var deferred = $q.defer();
            api.serviceServicesSearch.save({
                search: search
                //priceTableId : priceTableId
            },
                function (response) {
                    deferred.resolve(response.d);
                },
                function (error) {
                    console.log(error);
                });

            return deferred.promise;

        }
        ///

        function getCustomerLoyaltyTransactions(token){
            api.getCustomerLoyaltyTransactions.save({
                    token : token
                },
                function (response) {
                    console.log(response.d);
                },
                function (error) {
                    console.log(error);
                });
        }


        ///customer autocomplete
        vm.customerNameSearchText = ""
        vm.customerSearchTextChange = customerSearchTextChange;
        vm.customerSearchItems = [];
        //vm.customers = JSON.parse($window.localStorage["cacheCustomers"]);

        function filterForCustomers(query) {
            var uppercaseQuery = angular.uppercase(query);
            return function filterFn(customer) {
                return (customer.name.indexOf(uppercaseQuery) === 0);
            };
        }

        function customerSearchTextChange(search) {

            var deferred = $q.defer();
            api.customersSearch.save({
                searchName: search
            },
                function (response) {

                    deferred.resolve(response.d);

                },
                function (error) {
                    console.log(error);
                });

            return deferred.promise;

        }

        function getCustomersPoints() {
            if (vm.customer == null) return;
            api.getCustomerLoyaltyPoints.save({
                customerId: vm.customer._id
            },
                function (response) {

                    vm.customerPoints = response.d;

                },
                function (error) {
                    console.log(error);
                });

        }

        function getServicePoints() {
            if (vm.addServiceDialog == null || vm.addServiceDialog.service == null) return;

            api.serviceService.save({
                serviceId: vm.addServiceDialog.service._id
            },
                function (response) {

                    vm.selectedService = response.d;
                    if (vm.selectedService.loyaltyPoints == null) {
                        vm.selectedService.loyaltyPoints = "Ø";
                    }

                },
                function (error) {
                    console.log(error);
                });

        }

        function canExchangePoints() {
            if (vm.selectedService == null || vm.selectedService.loyaltyPoints == null || vm.customerPoints == null) return false;
            if (vm.selectedService.loyaltyPoints == "Ø") return false;
            if (vm.selectedService.loyaltyPoints <= vm.customerPoints) return true;
            else return false;
        }

        function exchangePointsForService() {
           
            api.exchangePoints.save({
                quantity: 1,
                points: -1 * vm.selectedService.loyaltyPoints,
                sellDate: Date.now(),
                customerId: vm.customer._id,
                serviceId: vm.selectedService._id,
                comissionPrice:  vm.selectedService.comissionPrice,
                obs: vm.obs
               
            },
                function (response) {
                    vm.getCustomersPoints();
                    vm.obs = null;
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.LOYALTY.TOAST.SAVE.SUCCESS"))
                            .position(pinTo)
                            .hideDelay(1000)
                    );
                    //redirect
                    /*setTimeout(function () {
                        $state.go('app.settings.service.servicePack.list');
                    }, 1000);*/

                },
                function (error) {
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.LOYALTY.TOAST.SAVE.ERROR"))
                            .position(pinTo)
                            .hideDelay(1000)
                    );
                    //redirect
                    /*setTimeout(function () {
                        $state.go('app.settings.service.servicePack.list');
                    }, 1000);*/
                });


        }


        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.marketingv2.campaign', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.marketingv2.campaign', {
                url    : '/campaign'
            }).state('app.marketingv2.campaign.list', {
                url    : '/list',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketingv2/campaign/list.html',
                        controller : 'MarketingCampaignController as vm'
                    }
                }
            }).state('app.marketingv2.campaign.new', {
                url    : '/new',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketingv2/campaign/campaign.html',
                        controller : 'MarketingCampaignController as vm'
                    }
                }
            }).state('app.marketingv2.campaign.edit', {
                url    : '/edit/:campaignId',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketingv2/campaign/campaign.html',
                        controller : 'MarketingCampaignController as vm'
                    }
                }
            })
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.marketingv2.campaign')
        .filter('yesNo', function() {
            return function(input) {
                return input ? 'Sim' : 'Não';
            }
        })
        .controller('MarketingCampaignController', MarketingCampaignController);

    /** @ngInject */
    function MarketingCampaignController($mdSidenav, $q, api, $mdDialog, $mdToast, $translate, $scope, $state,
                                         DTOptionsBuilder, DTDefaultOptions)
    {
        var vm = this;
        vm.saveCampaign = saveCampaign;
        vm.editCampaign = editCampaign;
        vm.campaignTypes = [];
        vm.campaignTypes.push({"value":"WEEKDAY","text":"Dias da semana"});


        switch ($state.current.name){
            case 'app.marketingv2.campaign.list':
                vm.showTable = false;
                vm.removeCampaign = removeCampaign;

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({autoWidth : false})
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable":     "Nenhum registro disponível",
                        "sInfo":           "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty":      "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered":   "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix":    "",
                        "sInfoThousands":  ",",
                        "sLengthMenu":     "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing":     "Processando...",
                        "sSearch":         "Busca:",
                        "sZeroRecords":    "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst":    "Primeiro",
                            "sLast":     "Ultimo",
                            "sNext":     "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending":  ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });
                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                api.campaigns.save({

                    },
                    function(response){
                        vm.showTable = true;
                        vm.campaigns = response.d;
                    },
                    function(error){
                        console.log(error);
                    });


                break;
            case 'app.marketingv2.campaign.new':
                vm.campaign = {}
                vm.campaign.priority = 10;
                vm.campaign.type = "WEEKDAY";
                api.priceTables.save({

                    },
                    function(response){
                        vm.priceTables = response.d;
                        vm.campaign.priceTableId = response.d[0]._id;
                    },
                    function(error){
                        console.log(error);
                    });
                break;

            case 'app.marketingv2.campaign.edit':
                api.campaign.save({
                        _id : $state.params.campaignId
                    },
                    function(response){
                        vm.campaign = response.d;

                        api.priceTables.save({

                            },
                            function(response){
                                vm.priceTables = response.d;
                                //vm.campaign.priceTableId
                                //vm.campaign.priceTableId = response.d[0]._id;
                            },
                            function(error){
                                console.log(error);
                            });
                    },
                    function(error){
                        console.log(error);
                    });
                break;
        }


        //////////////////////////////////////////////////
        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({},last);
        $scope.getToastPosition = function() {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function(pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if ( current.bottom && last.top ) current.top = false;
            if ( current.top && last.bottom ) current.bottom = false;
            if ( current.right && last.left ) current.left = false;
            if ( current.left && last.right ) current.right = false;
            last = angular.extend({},current);
        }


        function saveCampaign(){

            //mptando a ocnfiguracao
            var configuration =  "";

            switch(vm.campaign.type){
                case "WEEKDAY":
                    configuration = JSON.stringify(vm.campaign.configuration);
                    break;
            }


            api.saveCampaign.save({
                    name: vm.campaign.name,
                    type : vm.campaign.type,
                    priority : vm.campaign.priority,
                    priceTableId : vm.campaign.priceTableId,
                    configuration : configuration,
                    _id : $state.params.campaignId
                },
                function(response) {

                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.CAMPAIGN.TOAST.SAVE.SUCCESS"))
                            .position(pinTo)
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.go('app.marketingv2.campaign.list');
                    }, 1000);


                },
                function(error){
                    if (close){
                        $mdDialog.hide();
                    } else {
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("MARKETING.CAMPAIGN.TOAST.SAVE.ERROR"))
                                .position(pinTo )
                                .hideDelay(1000)
                        );
                        //redirect
                        setTimeout(function(){
                            $state.go('app.marketingv2.campaign.list');
                        }, 1000);
                    }

                });
        }

        function removeCampaign(id){


            api.removeCampaign.save({
                    _id : id
                },
                function(response) {

                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.CAMPAIGN.TOAST.SAVE.SUCCESS"))
                            .position(pinTo)
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.reload();
                    }, 1000);


                },
                function(error){
                    if (close){
                        $mdDialog.hide();
                    } else {
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("MARKETING.CAMPAIGN.TOAST.SAVE.ERROR"))
                                .position(pinTo )
                                .hideDelay(1000)
                        );
                        //redirect
                        setTimeout(function(){
                            $state.reload();
                        }, 1000);
                    }

                });
        }

        function editCampaign(id){
            $state.go('app.marketingv2.campaign.edit',{campaignId: id});
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.marketingv2.birthday', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.marketingv2.birthday', {
                url    : '/birthday',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketingv2/birthday/configuration.html',
                        controller : 'MarketingBirthdayController as vm'
                    }
                }
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.marketingv2.birthday')
        .controller('MarketingBirthdayController', MarketingBirthdayController);

    /** @ngInject */
    function MarketingBirthdayController($q, api, $mdDialog, $mdToast, $translate, $scope,
                                            $state, DTOptionsBuilder, DTDefaultOptions,
                                            $rootScope)
    {
        var vm = this;

        //load info
        api.birthdayConfiguration.save({
            },
            function(response){
                if ((response.d == undefined) || (response.d == {}) ){
                    vm.configuration = {

                    }

                } else {
                    vm.configuration = response.d;
                }

            },
            function(error){
                console.log(error);
            });

        vm.saveBirthdayConfiguration = function(){
            api.saveBirthdayConfiguration.save({
                    configuration : vm.configuration
                },
                function(response){
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.GENERAL.TOAST.SAVE.SUCCESS"))
                            .hideDelay(2000)
                    );

//                    console.log( vm.configuration );

                    window.Intercom('boot', {
                        "campaign_birthday": vm.configuration.enableBirthdaySMS // Boolean
                    });

                },
                function(error){
                    console.log(error);
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.GENERAL.TOAST.SAVE.ERROR"))
                            .hideDelay(2000)
                    );
                });
        }

        ////====================================================

        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({},last);
        $scope.getToastPosition = function() {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function(pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if ( current.bottom && last.top ) current.top = false;
            if ( current.top && last.bottom ) current.bottom = false;
            if ( current.right && last.left ) current.left = false;
            if ( current.left && last.right ) current.right = false;
            last = angular.extend({},current);
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.marketing.spot', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.marketing.spot', {
                url    : '/spot'
            }).state('app.marketing.spot.list', {
                url    : '/list',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketing/spot/list.html',
                        controller : 'MarketingSpotController as vm'
                    }
                }
            }).state('app.marketing.spot.new', {
                url    : '/new',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketing/spot/spot.html',
                        controller : 'MarketingSpotController as vm'
                    }
                }
            }).state('app.marketing.spot.edit', {
                url    : '/edit/:spotCampaignId',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketing/spot/spot.html',
                        controller : 'MarketingSpotController as vm'
                    }
                }
            })
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.marketing.spot')
        .controller('MarketingSpotController', MarketingSpotController);

    /** @ngInject */
    function MarketingSpotController($q, api, $mdDialog, $mdToast, $translate, $scope, $state,DTColumnBuilder, DTOptionsBuilder, DTDefaultOptions)
    {
        var vm = this;

        //functions
        vm.saveSpotCampaign = saveSpotCampaign;


        vm.spot = {};

        switch ($state.current.name){
            case 'app.marketing.spot.list':
                vm.showTable = false;
                vm.editSpotCampaign = function(id){
                    $state.go('app.marketing.spot.edit',{spotCampaignId:id});
                };
                vm.removeSpotCampaign = removeSpotCampaign;
                vm.copySpotCampaign =copySpotCampaign;

                api.spotCampaigns.save({},
                    function(response){
                        vm.spotCampaigns = response.d;
                        setTimeout(function(){
                            vm.showTable = true;
                            $scope.$apply();
                        },200)

                    },
                    function(error){
                        console.log(error);
                    });

                $scope.dtColumns = [
                    //here We will add .withOption('name','column_name') for send column name to the server
                    DTColumnBuilder.newColumn("Name", "Name").withOption('name', 'name'),
                    DTColumnBuilder.newColumn("Status", "Status").withOption('name', 'status'),
                    DTColumnBuilder.newColumn("When", "When").withOption('name', 'when')
                ]

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    //.withOption('serverSide', false) // for server side processing
                    //.withOption('processing', true) //for show progress bar
                    //.withOption('ajax', {
                    //    dataSrc: "data",
                    //    url: "/home/getdata",
                    //    type:"POST"
                    //})
                    //.withOption('aaSorting',[0,'asc'])
                    .withOption({autoWidth : false})
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable":     "Nenhum registro disponível",
                        "sInfo":           "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty":      "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered":   "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix":    "",
                        "sInfoThousands":  ",",
                        "sLengthMenu":     "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing":     "Processando...",
                        "sSearch":         "Busca:",
                        "sZeroRecords":    "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst":    "Primeiro",
                            "sLast":     "Ultimo",
                            "sNext":     "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending":  ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });

                DTDefaultOptions.setLoadingTemplate('<h3>Carregando</h3>');
                break;
            case 'app.marketing.spot.new':
                vm.spot = {
                    discountCupom : "N",
                    discountCupomValue : 1,
                    scheduleType : "NOW",
                    discountCupomType : "P",
                    whenTime : 540,
                    filterServiceCategory : 'N',
                    filterProfessionalRelationship : 'N',
                    smsDeliveryMethod : "SP"
                }
                vm.chkServiceCategory = {};
                vm.chkProfessional = {}
                loadTimeTable(function(data) {
                    vm.timetable = data;
                });

                api.serviceCategories.save({

                    },
                    function(response){
                        vm.serviceCategories = response.d;
                    },
                    function(error){
                        console.log(error);
                    });
                api.serviceProfessionals.save({

                    },
                    function(response){
                        vm.professionals = response.d;
                    },
                    function(error){
                        console.log(error);
                    });

                break;
            case 'app.marketing.spot.edit':
                api.spotCampaign.save({
                        id : $state.params.spotCampaignId
                    },
                    function(response){
                        vm.spot = response.d;
                        var when = new moment(vm.spot.when);
                        var whenDate = new moment({
                            year : when.year(),
                            month : when.month(),
                            date : when.date()
                        })
                        vm.spot.whenDate =  new Date(whenDate.valueOf());
                        vm.spot.whenTime = (when.valueOf() - whenDate.valueOf()) / 60000

                        //setando o array de checks
                        vm.chkProfessional = {};
                        vm.chkServiceCategory = {};
                        if (vm.spot.filterProfessionalRelationship == 'Y'){
                            for (var i=0; i < vm.spot.professionalFilter.length; i++){
                                vm.chkProfessional[vm.spot.professionalFilter[i]._id] = true;
                            }
                        }
                        if (vm.spot.filterServiceCategory == 'Y'){
                            for (var i=0; i < vm.spot.serviceCategoryFilter.length; i++){
                                vm.chkServiceCategory[vm.spot.serviceCategoryFilter[i]._id] = true;
                            }
                        }

                    },
                    function(error){
                        console.log(error);
                    });
                loadTimeTable(function(data) {
                    vm.timetable = data;
                });

                api.serviceCategories.save({

                    },
                    function(response){
                        vm.serviceCategories = response.d;
                    },
                    function(error){
                        console.log(error);
                    });
                api.serviceProfessionals.save({

                    },
                    function(response){
                        vm.professionals = response.d;
                    },
                    function(error){
                        console.log(error);
                    });
                break;
        }


        ////====================================================

        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({},last);
        $scope.getToastPosition = function() {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function(pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if ( current.bottom && last.top ) current.top = false;
            if ( current.top && last.bottom ) current.bottom = false;
            if ( current.right && last.left ) current.left = false;
            if ( current.left && last.right ) current.right = false;
            last = angular.extend({},current);
        }

        function loadTimeTable(callback){
            var arTemp = [];
            for(var i=0; i < 1440; i = i + 5){
                var hora = parseInt(i/60);
                var minute = i - (hora * 60);
                var horaStr = hora;
                var minuteStr = minute;

                if (hora < 10){
                    horaStr = "0" + hora;
                }
                if (minute < 10){
                    minuteStr = "0" + minute;
                }
                var obj = {
                    time : i,
                    timeStr : horaStr + ":" + minuteStr
                }
                arTemp.push(obj);
            }

            callback(arTemp);

        }

        function saveSpotCampaign(){
            var when = 0;
            if (vm.spot.whenDate == undefined){
                vm.spot.whenDate = new Date();
            }
            if (vm.spot.discountCupomValidUntil == undefined){
                vm.spot.discountCupomValidUntil = new Date();
            }
            if (vm.spot.scheduleType == 'NOW'){
                when = new Date().valueOf();
            } else {
                var whenDateOnly = new moment(vm.spot.whenDate.valueOf())
                when = new moment({
                    year: whenDateOnly.year(),
                    month : whenDateOnly.month(),
                    date:whenDateOnly.date()
                })
                when = when.valueOf() + vm.spot.whenTime * 1000 * 60;
            }
            var arFilterServiceCategory = [];
            var arFilterProfessional = [];


            for(var i=0; i < vm.serviceCategories.length; i++){
                if (vm.chkServiceCategory[vm.serviceCategories[i]._id]){
                    arFilterServiceCategory.push(vm.serviceCategories[i]);
                }
            }

            for (var i = 0; i < vm.professionals.length; i++) {
                if (vm.chkProfessional[vm.professionals[i]._id]) {
                    arFilterProfessional.push(vm.professionals[i]);
                }
            }

            api.saveSpotCampaign.save({
                    id  :$state.params.spotCampaignId,
                    name : vm.spot.name,
                    description : vm.spot.description,
                    scheduleType : vm.spot.scheduleType,
                    SMSBody : vm.spot.SMSBody,
                    when : when,
                    discountCupom : vm.spot.discountCupom,
                    discountCupomType : vm.spot.discountCupomType,
                    discountCupomValue : vm.spot.discountCupomValue,
                    discountCupomValidUntil : vm.spot.discountCupomValidUntil.valueOf(),
                    serviceCategoryFilter : arFilterServiceCategory,
                    filterServiceCategory : vm.spot.filterServiceCategory,
                    filterProfessionalRelationship : vm.spot.filterProfessionalRelationship,
                    professionalFilter : arFilterProfessional,
                    smsDeliveryMethod : vm.spot.smsDeliveryMethod
                },
                function(response){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.SPOT.TOAST.SAVE.SUCCESS"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function(){
                        $state.go('app.marketing.spot.list');
                    }, 1000);

                },
                function(error){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.SPOT.TOAST.SAVE.ERROR"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function(){
                        $state.go('app.marketing.spot.list');
                    }, 1000);
                });
        }

        function copySpotCampaign(id){

            api.copySpotCampaign.save({
                    id  :id
                },
                function(response){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.SPOT.TOAST.COPY.SUCCESS"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function(){
                        $state.reload();
                    }, 1000);

                },
                function(error){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.SPOT.TOAST.COPY.ERROR"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function(){
                        $state.reload();
                    }, 1000);
                });
        }

        function removeSpotCampaign(id) {
            var confirm = $mdDialog.confirm()
                .title($translate.instant("MARKETING.SPOT.DIALOG.REMOVE.TITLE"))
                .textContent($translate.instant("MARKETING.SPOT.DIALOG.REMOVE.SUBTITLE"))
                .ariaLabel('Remove')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok($translate.instant("GENERAL.DIALOG.OK"))
                .cancel($translate.instant("GENERAL.DIALOG.CANCEL"));
            $mdDialog.show(confirm).then(function() {
                api.removeSpotCampaign.save({
                        id: id
                    },
                    function(response){
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("MARKETING.SPOT.TOAST.REMOVE.SUCCESS"))
                                .position(pinTo )
                                .hideDelay(2000)
                        );
                        //redirect
                        setTimeout(function(){
                            $state.reload();
                        }, 1000);
                    },
                    function(error){
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("MARKETING.SPOT.TOAST.REMOVE.ERROR"))
                                .position(pinTo )
                                .hideDelay(1000)
                        );

                        //redirect
                        setTimeout(function(){
                            $state.reload();
                        }, 1000);

                    });
            });
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.marketing.partnership', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.marketing.partnership', {
                url    : '/partnership'
            }).state('app.marketing.partnership.list', {
                url    : '/list',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketing/partnership/list.html',
                        controller : 'MarketingPartnershipController as vm'
                    }
                }
            }).state('app.marketing.partnership.new', {
                url    : '/list',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketing/partnership/partnership.html',
                        controller : 'MarketingPartnershipController as vm'
                    }
                }
            })
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.marketing.partnership')
        .controller('MarketingPartnershipController', MarketingPartnershipController);

    /** @ngInject */
    function MarketingPartnershipController($mdSidenav, $q, api, $mdDialog, $mdToast, $translate, $scope, $state,DTOptionsBuilder, DTDefaultOptions)
    {
        var vm = this;
        vm.removePartnership = removePartnership;
        vm.savePartnership = savePartnership;

        switch ($state.current.name){
            case 'app.marketing.partnership.list':
                vm.showTable = false;

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({autoWidth : false})
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable":     "Nenhum registro disponível",
                        "sInfo":           "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty":      "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered":   "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix":    "",
                        "sInfoThousands":  ",",
                        "sLengthMenu":     "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing":     "Processando...",
                        "sSearch":         "Busca:",
                        "sZeroRecords":    "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst":    "Primeiro",
                            "sLast":     "Ultimo",
                            "sNext":     "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending":  ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });
                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                refresh();

                break;
        }


        //////////////////////////////////////////////////
        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({},last);
        $scope.getToastPosition = function() {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function(pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if ( current.bottom && last.top ) current.top = false;
            if ( current.top && last.bottom ) current.bottom = false;
            if ( current.right && last.left ) current.left = false;
            if ( current.left && last.right ) current.right = false;
            last = angular.extend({},current);
        }


        function refresh(){
            vm.showTable = false;
            api.partnerships.save({

                },
                function(response){
                    vm.partnerships = response.d;
                    vm.showTable = true;
                },
                function(error){
                    console.log(error);
                });
        }

        function savePartnership(){
            api.savePartnership.save({
                    name:vm.name
                },
                function(response) {

                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.PARTNERSHIP.TOAST.SAVE.SUCCESS"))
                            .position(pinTo)
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.go('app.marketing.partnership.list');
                    }, 1000);


                },
                function(error){
                    if (close){
                        $mdDialog.hide();
                    } else {
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("MARKETING.PARTNERSHIP.TOAST.SAVE.ERROR"))
                                .position(pinTo )
                                .hideDelay(1000)
                        );
                        //redirect
                        setTimeout(function(){
                            $state.go('app.marketing.partnership.list');
                        }, 1000);
                    }

                });
        }

        function removePartnership(id){
            api.removePartnership.save({
                    _id:id
                },
                function(response) {

                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.PARTNERSHIP.TOAST.REMOVE.SUCCESS"))
                            .position(pinTo)
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.reload();
                    }, 1000);


                },
                function(error){
                    if (close){
                        $mdDialog.hide();
                    } else {
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("MARKETING.PARTNERSHIP.TOAST.REMOVE.ERROR"))
                                .position(pinTo )
                                .hideDelay(1000)
                        );
                        //redirect
                        setTimeout(function(){
                            $state.reload();
                        }, 1000);
                    }

                });
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.marketing.offer', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.marketing.offer', {
                url    : '/offer'
            }).state('app.marketing.offer.list', {
                url    : '/list',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketing/offer/list.html',
                        controller : 'MarketingOfferController as vm'
                    }
                }
            }).state('app.marketing.offer.new', {
                url    : '/new',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketing/offer/offer.html',
                        controller : 'MarketingOfferController as vm'
                    }
                }
            }).state('app.marketing.offer.edit', {
                url    : '/edit/:offerId',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketing/offer/offer.html',
                        controller : 'MarketingOfferController as vm'
                    }
                }
            })
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.marketing.offer')
        .filter('yesNo', function() {
            return function(input) {
                return input ? 'Sim' : 'Não';
            }
        })
        .controller('MarketingOfferController', MarketingOfferController);

    /** @ngInject */
    function MarketingOfferController($mdSidenav, $q, api, $mdDialog, $mdToast, $translate, $scope, $state,DTOptionsBuilder, DTDefaultOptions)
    {
        var vm = this;
        vm.saveOffer = saveOffer;
        vm.enableOffer = enableOffer;
        vm.disableOffer = disableOffer;
        vm.editOffer = editOffer;
        vm.roundType = 'NONE';

        switch ($state.current.name){
            case 'app.marketing.offer.list':
                vm.showTable = false;

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({autoWidth : false})
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable":     "Nenhum registro disponível",
                        "sInfo":           "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty":      "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered":   "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix":    "",
                        "sInfoThousands":  ",",
                        "sLengthMenu":     "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing":     "Processando...",
                        "sSearch":         "Busca:",
                        "sZeroRecords":    "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst":    "Primeiro",
                            "sLast":     "Ultimo",
                            "sNext":     "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending":  ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });
                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                refresh();

                break;
            case 'app.marketing.offer.edit':
                api.offer.save({
                        _id : $state.params.offerId
                    },
                    function(response){
                        vm.name = response.d.name;
                        vm.rules = response.d.rules;
                        vm.percentage = response.d.percentage;
                        vm.changeComissionPrice = response.d.changeComissionPrice;
                        vm.requireExplanation = response.d.requireExplanation;
                        vm.roundType = response.d.roundType;
                    },
                    function(error){
                        console.log(error);
                    });
                break;
        }


        //////////////////////////////////////////////////
        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({},last);
        $scope.getToastPosition = function() {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function(pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if ( current.bottom && last.top ) current.top = false;
            if ( current.top && last.bottom ) current.bottom = false;
            if ( current.right && last.left ) current.left = false;
            if ( current.left && last.right ) current.right = false;
            last = angular.extend({},current);
        }


        function refresh(){
            vm.showTable = false;
            api.offers.save({

                },
                function(response){
                    vm.offers = response.d;
                    vm.showTable = true;
                },
                function(error){
                    console.log(error);
                });
        }

        function saveOffer(){
            api.saveOffer.save({
                    name:vm.name,
                    percentage : vm.percentage,
                    rules : vm.rules,
                    changeComissionPrice : vm.changeComissionPrice,
                    requireExplanation:vm.requireExplanation,
                    roundType : vm.roundType,
                    _id : $state.params.offerId
                },
                function(response) {

                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.OFFER.TOAST.SAVE.SUCCESS"))
                            .position(pinTo)
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.go('app.marketing.offer.list');
                    }, 1000);


                },
                function(error){
                    if (close){
                        $mdDialog.hide();
                    } else {
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("MARKETING.OFFER.TOAST.SAVE.ERROR"))
                                .position(pinTo )
                                .hideDelay(1000)
                        );
                        //redirect
                        setTimeout(function(){
                            $state.go('app.marketing.offer.list');
                        }, 1000);
                    }

                });
        }

        function disableOffer(id){
            api.disableOffer.save({
                    _id:id
                },
                function(response) {

                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.OFFER.TOAST.DISABLE.SUCCESS"))
                            .position(pinTo)
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.reload();
                    }, 1000);


                },
                function(error){
                    if (close){
                        $mdDialog.hide();
                    } else {
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("MARKETING.OFFER.TOAST.DISABLE.ERROR"))
                                .position(pinTo )
                                .hideDelay(1000)
                        );
                        //redirect
                        setTimeout(function(){
                            $state.reload();
                        }, 1000);
                    }

                });
        }
        function enableOffer(id){
            api.enableOffer.save({
                    _id:id
                },
                function(response) {

                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.OFFER.TOAST.ENABLE.SUCCESS"))
                            .position(pinTo)
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.reload();
                    }, 1000);


                },
                function(error){
                    if (close){
                        $mdDialog.hide();
                    } else {
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("MARKETING.OFFER.TOAST.ENABLE.ERROR"))
                                .position(pinTo )
                                .hideDelay(1000)
                        );
                        //redirect
                        setTimeout(function(){
                            $state.reload();
                        }, 1000);
                    }

                });
        }

        function editOffer(id){
            $state.go('app.marketing.offer.edit',{offerId: id});
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.marketing.message', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.marketing.message', {
                url    : '/message'
            }).state('app.marketing.message.list', {
                url    : '/list',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketing/message/list.html',
                        controller : 'MarketingMessageController as vm'
                    }
                }
            })
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.marketing.message')
        .controller('MarketingMessageController', MarketingMessageController);

    /** @ngInject */
    function MarketingMessageController($mdSidenav, $q, api, $mdDialog, $mdToast, $translate, $scope, $state,DTOptionsBuilder, DTDefaultOptions)
    {
        var vm = this;
        vm.openFilter = openFilter;
        vm.refresh = refresh;

        switch ($state.current.name){
            case 'app.marketing.message.list':
                vm.showTable = false;
                vm.filter = {};
                vm.filter.fail = true;
                vm.filter.delivered = true;
                var dtFrom = new moment().add(-7,'d');
                vm.filter.dtFrom = new Date(dtFrom.valueOf());
                vm.filter.dtTo = new Date();

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({autoWidth : false})
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable":     "Nenhum registro disponível",
                        "sInfo":           "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty":      "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered":   "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix":    "",
                        "sInfoThousands":  ",",
                        "sLengthMenu":     "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing":     "Processando...",
                        "sSearch":         "Busca:",
                        "sZeroRecords":    "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst":    "Primeiro",
                            "sLast":     "Ultimo",
                            "sNext":     "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending":  ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });
                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                refresh();

                // Component lookup should always be available since we are not using `ng-if`


                break;
        }


        //////////////////////////////////////////////////
        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({},last);
        $scope.getToastPosition = function() {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function(pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if ( current.bottom && last.top ) current.top = false;
            if ( current.top && last.bottom ) current.bottom = false;
            if ( current.right && last.left ) current.left = false;
            if ( current.left && last.right ) current.right = false;
            last = angular.extend({},current);
        }

        function openFilter(){
            $mdSidenav('filter')
                .toggle()
                .then(function () {

                });
        }

        function refresh(){
            vm.showTable = false;
            api.messages.save({
                    dtFrom : vm.filter.dtFrom.valueOf(),
                    dtTo : vm.filter.dtTo.valueOf(),
                    statusFail : vm.filter.fail,
                    statusDelivered : vm.filter.delivered
                },
                function(response){
                    vm.messages = response.d;
                    vm.showTable = true;
                },
                function(error){
                    console.log(error);
                });
        }

        function cancelCupom(id){
            api.cancelCupom.save({
                    id  :id
                },
                function(response){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.CUPOM.TOAST.CANCEL.SUCCESS"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function(){
                        $state.reload();
                    }, 1000);

                },
                function(error){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.CUPOM.TOAST.CANCEL.ERROR"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function(){
                        $state.reload();
                    }, 1000);
                });
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.marketing.marketplace', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.marketing.marketplace', {
                url    : '/marketplace'
            }).state('app.marketing.marketplace.styleplace', {
                url    : '/styleplace',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketing/marketplace/styleplace.html',
                        controller : 'MarketingMarketplaceController as vm'
                    }
                }
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.marketing.marketplace')
        .controller('MarketingMarketplaceController', MarketingMarketplaceController);

    /** @ngInject */
    function MarketingMarketplaceController($q, api, $mdDialog, $mdToast, $translate, $scope, $state, DTOptionsBuilder, DTDefaultOptions)
    {
        var vm = this;

        //functions

        switch ($state.current.name){
            case 'app.marketing.marketplace.styleplace':
                vm.saveStylePlaceConfiguration = saveStylePlaceConfiguration;

                api.marketingConfiguration.save({
                    },
                    function(response){
                        if ((response.d != undefined) && (response.d.marketplace != undefined) && (response.d.marketplace.styleplace != undefined) ){
                            vm.accept = response.d.marketplace.styleplace.accept;
                        } else {
                            vm.accept = false;
                        }

                    },
                    function(error){
                        console.log(error);
                    });

                break;
        }


        ////====================================================

        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({},last);
        $scope.getToastPosition = function() {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function(pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if ( current.bottom && last.top ) current.top = false;
            if ( current.top && last.bottom ) current.bottom = false;
            if ( current.right && last.left ) current.left = false;
            if ( current.left && last.right ) current.right = false;
            last = angular.extend({},current);
        }

        function saveStylePlaceConfiguration(){
            api.saveStylePlaceConfiguration.save({
                    accept: vm.accept
                },
                function(response){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.MARKETPLACE.TOAST.SAVE.SUCCESS"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );

                },
                function(error){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.MARKETPLACE.TOAST.SAVE.ERROR"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );

                });
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.marketing.cupom', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.marketing.cupom', {
                url    : '/cupom'
            }).state('app.marketing.cupom.list', {
                url    : '/list',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketing/cupom/list.html',
                        controller : 'MarketingCupomController as vm'
                    }
                }
            })
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.marketing.cupom')
        .controller('MarketingCupomController', MarketingCupomController);

    /** @ngInject */
    function MarketingCupomController($mdSidenav, $q, api, $mdDialog, $mdToast, $translate, $scope, $state,DTOptionsBuilder, DTDefaultOptions)
    {
        var vm = this;
        vm.openFilter = openFilter;

        switch ($state.current.name){
            case 'app.marketing.cupom.list':
                vm.showTable = false;
                vm.refresh = refresh;
                vm.cancelCupom = cancelCupom;
                vm.filter = {};
                vm.filter.used = true;
                vm.filter.notUsed = true;
                vm.filter.canceled = true;
                vm.filter.expired = true;
                var dtFrom = new moment().add(-7,'d');
                vm.filter.dtFrom = new Date(dtFrom.valueOf());
                vm.filter.dtTo = new Date();

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({autoWidth : false})
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable":     "Nenhum registro disponível",
                        "sInfo":           "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty":      "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered":   "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix":    "",
                        "sInfoThousands":  ",",
                        "sLengthMenu":     "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing":     "Processando...",
                        "sSearch":         "Busca:",
                        "sZeroRecords":    "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst":    "Primeiro",
                            "sLast":     "Ultimo",
                            "sNext":     "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending":  ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });
                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                refresh();

                break;
        }


        //////////////////////////////////////////////////
        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({},last);
        $scope.getToastPosition = function() {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function(pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if ( current.bottom && last.top ) current.top = false;
            if ( current.top && last.bottom ) current.bottom = false;
            if ( current.right && last.left ) current.left = false;
            if ( current.left && last.right ) current.right = false;
            last = angular.extend({},current);
        }

        function openFilter(){
            $mdSidenav('filter')
                .toggle()
                .then(function () {

                });
        }

        function refresh(){
            vm.showTable = false;
            api.cupons.save({
                    dtFrom : vm.filter.dtFrom.valueOf(),
                    dtTo : vm.filter.dtTo.valueOf(),
                    statusUsed : vm.filter.used,
                    statusNotUsed : vm.filter.notUsed,
                    statusExpired : vm.filter.expired,
                    statusCanceled : vm.filter.canceled
                },
                function(response){
                    var arTemp = []
                    for(var i=0; i < response.d.length; i++){
                        var obj = response.d[i];
                        if (obj.cupomType == 'P'){
                            obj.cupomValueStr = obj.cupomValue + " %";
                        } else {
                            obj.cupomValueStr = 'R$ ' + obj.cupomValue ;
                        }

                        arTemp.push(obj);
                    }

                    vm.cupons = arTemp;
                    vm.showTable = true;
                },
                function(error){
                    console.log(error);
                });
        }

        function cancelCupom(id){
            api.cancelCupom.save({
                    id  :id
                },
                function(response){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.CUPOM.TOAST.CANCEL.SUCCESS"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function(){
                        $state.reload();
                    }, 1000);

                },
                function(error){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.CUPOM.TOAST.CANCEL.ERROR"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function(){
                        $state.reload();
                    }, 1000);
                });
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.marketing.configuration', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.marketing.configuration', {
                url    : '/configuration'
            }).state('app.marketing.configuration.schedule', {
                url    : '/schedule',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketing/configuration/schedule.html',
                        controller : 'MarketingConfigurationController as vm'
                    }
                }
            }).state('app.marketing.configuration.birthday', {
                url    : '/birthday',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketing/configuration/birthday.html',
                        controller : 'MarketingConfigurationController as vm'
                    }
                }
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.marketing.configuration')
        .controller('MarketingConfigurationController', MarketingConfigurationController);

    /** @ngInject */
    function MarketingConfigurationController($q, api, $mdDialog, $mdToast, $translate, $scope, $state, DTOptionsBuilder, DTDefaultOptions)
    {
        var vm = this;

        //functions

        switch ($state.current.name){
            case 'app.marketing.configuration.schedule':
                vm.saveScheduleConfiguration = saveScheduleConfiguration;

                api.marketingConfiguration.save({
                    },
                    function(response){
                        if(response.d == undefined){
                            vm.configuration = {
                                smsDeliveryMethod : 'SPFREE',
                                sendSMSOnDay : true,
                                sendEmailSameTime : true,
                                sendEmailOnDay : true,
                                sendSMSSameTime : true,
                                SMSSameTimeMessage : $translate.instant('MARKETING.CONFIGURATION.SCHEDULE.SEND_SMS_MESSAGE_DEFAULT'),
                                EmailSameTimeMessage : $translate.instant('MARKETING.CONFIGURATION.SCHEDULE.SEND_EMAIL_MESSAGE_DEFAULT'),
                                SMSOnDayMessage : $translate.instant('MARKETING.CONFIGURATION.SCHEDULE.SEND_SMSONDAY_MESSAGE_DEFAULT'),
                                EmailOnDayMessage : $translate.instant('MARKETING.CONFIGURATION.SCHEDULE.SEND_EMAILONDAY_MESSAGE_DEFAULT'),
                            }

                        } else {
                            vm.configuration = {};
                            vm.configuration.smsDeliveryMethod = response.d.schedule.smsDeliveryMethod;
                            vm.configuration.sendSMSOnDay = response.d.schedule.sendSMSOnDay;
                            vm.configuration.sendEmailSameTime = response.d.schedule.sendEmailSameTime;
                            vm.configuration.sendEmailOnDay = response.d.schedule.sendEmailOnDay;
                            vm.configuration.sendSMSSameTime = response.d.schedule.sendSMSSameTime;

                            vm.configuration.SMSSameTimeMessage = response.d.schedule.SMSSameTimeMessage;
                            vm.configuration.EmailSameTimeMessage = response.d.schedule.EmailSameTimeMessage;
                            vm.configuration.SMSOnDayMessage = response.d.schedule.SMSOnDayMessage;
                            vm.configuration.EmailOnDayMessage = response.d.schedule.EmailOnDayMessage;

                        }

                    },
                    function(error){
                        console.log(error);
                    });

                break;
            case 'app.marketing.configuration.birthday':
                vm.saveBirthdayConfiguration = saveBirthdayConfiguration;

                api.marketingConfiguration.save({
                    },
                    function(response){
                        if(response.d.birthday == undefined){
                            vm.configuration = {
                                SMSMessage : $translate.instant('MARKETING.CONFIGURATION.BIRTHDAY.SEND_SMS_MESSAGE_DEFAULT'),
                                sendSMS : true,
                                sendEmail : true,
                                EmailMessage : $translate.instant('MARKETING.CONFIGURATION.BIRTHDAY.SEND_EMAIL_MESSAGE_DEFAULT')
                            }

                        } else {
                            vm.configuration = {};
                            vm.configuration.sendSMS = response.d.birthday.sendSMS;
                            vm.configuration.sendEmail = response.d.birthday.sendEmail;
                            vm.configuration.SMSMessage = response.d.birthday.SMSMessage;
                            vm.configuration.EmailMessage = response.d.birthday.EmailMessage;
                        }

                    },
                    function(error){
                        console.log(error);
                    });

                break;
        }


        ////====================================================

        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({},last);
        $scope.getToastPosition = function() {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function(pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if ( current.bottom && last.top ) current.top = false;
            if ( current.top && last.bottom ) current.bottom = false;
            if ( current.right && last.left ) current.left = false;
            if ( current.left && last.right ) current.right = false;
            last = angular.extend({},current);
        }

        function saveScheduleConfiguration(){
            api.saveMarketingScheduleConfiguration.save({
                    configuration: vm.configuration
                },
                function(response){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.CONFIGURATION.TOAST.SAVE.SUCCESS"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );

                },
                function(error){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.PRODUCT.CATEGORY.TOAST.SAVE.ERROR"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );

                });
        }

        function saveBirthdayConfiguration(){
            api.saveMarketingBirthdayConfiguration.save({
                    configuration: vm.configuration
                },
                function(response){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.CONFIGURATION.TOAST.SAVE.SUCCESS"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );

                },
                function(error){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("MARKETING.CONFIGURATION.TOAST.SAVE.ERROR"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );

                });
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.finance.extrato', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.finance.extrato', {
                url    : '/extrato',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/finance/extrato/extrato.html',
                        controller : 'FinanceExtratoController as vm'
                    }
                }

            })
            .state('app.finance.professional', {
                url    : '/professional',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/finance/extrato/profissionais.html',
                        controller : 'FinanceExtratoController as vm'
                    }
                }

            })
            .state('app.finance.transfer', {
                url    : '/transfer',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/finance/extrato/transferencia.html',
                        controller : 'FinanceExtratoController as vm'
                    }
                }

            })
            .state('app.finance.newpayment', {
                url    : '/newpayment',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/finance/extrato/transaction.html',
                        controller : 'FinanceExtratoController as vm'
                    }
                }

            })
            .state('app.finance.newprofesisonalpayment', {
                url    : '/newprofessionalpayment',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/finance/extrato/newprofessionalpayment.html',
                        controller : 'FinanceExtratoController as vm'
                    }
                }

            }).state('app.finance.createRPS', {
            url    : '/createRPS',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/finance/extrato/createRPS.html',
                    controller : 'FinanceExtratoController as vm'
                }
            }

            })
            .state('app.finance.newreceivable', {
                url    : '/newreceivable',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/finance/extrato/transaction.html',
                        controller : 'FinanceExtratoController as vm'
                    }
                }

            })



    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.finance.extrato')
        .controller('FinanceExtratoController', FinanceExtratoController);

    /** @ngInject */
    function FinanceExtratoController(api, $translate, $scope, DTDefaultOptions,
                               DTColumnDefBuilder, DTOptionsBuilder, DTColumnBuilder,$mdSidenav,
                               $mdDialog, $mdToast, $state, $rootScope, $compile, $filter) {

        var vm = this;

        vm.openFilter = function () {
            $mdSidenav('filter')
                .toggle()
                .then(function () {

                });
        }

        //mes atual
        vm.selectedMonth = new moment();
        vm.formattedSelectedMonth = vm.selectedMonth.format("MMM  /  YYYY");


        //navegando nos meses
        vm.nextMonth = function(){
            vm.selectedMonth.add(1, 'month');
            vm.formattedSelectedMonth = vm.selectedMonth.format("MMM  /  YYYY");
            vm.refresh();
        }
        vm.previousMonth = function(){
            vm.selectedMonth.add(-1, 'month');
            vm.formattedSelectedMonth = vm.selectedMonth.format("MMM  /  YYYY");
            vm.refresh();
        }




        switch ($state.current.name) {

            case 'app.finance.extrato':
                vm.showTable = true;
                vm.refresh = refreshExtrato;
                vm.removeTransaction = removeTransaction;

                api.bankAccounts.save({},
                    function (response) {

                        vm.bankAccounts = response.d;
                        vm.bankAccountId = response.d[0].BAAC_CD_BANK_ACCOUNT;

                        //atualizar depois de carregar a conta
                        refreshExtrato();
                    },
                    function (error) {
                        console.log(error);
                    });
                break;
            case 'app.finance.newreceivable':
                vm.saveTransaction = saveTransaction;
                vm.refresh = refreshExtrato;
                vm.transactionType = "RECEIVABLE";
                vm.type = 'PARTNER';
                vm.value = 0.01;
                vm.observation = "";
                vm.when = new Date();
                vm.multiplier = 1;
                vm.title = "Novo Recebimento";
                api.bankAccounts.save({},
                    function (response) {

                        vm.bankAccounts = response.d;
                        vm.bankAccountId = response.d[0].BAAC_CD_BANK_ACCOUNT;
                    },
                    function (error) {
                        console.log(error);
                    });

                api.financialCategories.save({},
                    function(response){

                        vm.categories = [];
                        for(var i=0 ; i < response.d.length; i++){
                            if (response.d[i].FICA_IN_ENTRADASAIDA == 1){
                                vm.categories.push(response.d[i]);
                            }
                        }

                        vm.categoryId = vm.categories[0].FICA_CD_FINANCE_CATEGORY;

                    },
                    function(error){
                        console.log(error);
                    });

                api.partners.save({},
                    function (response) {

                        vm.partners = response.d;
                        vm.partnerId = response.d[0].PART_CD_PARTNER;

                        //atualizar depois de carregar a conta
                        refreshExtrato();
                    },
                    function (error) {
                        console.log(error);
                    });
                break;
            case 'app.finance.createRPS':
                vm.refresh = refreshContaCorrenteProfissionalRPS;
                vm.createRPS = createRPS;

                api.getProfessionalsWithSchedule.save({},
                    function(response){

                        vm.professionals = response.d;

                        vm.professionals.sort(function(a, b){
                            if(a.name < b.name) { return -1; }
                            if(a.name > b.name) { return 1; }
                            return 0;
                        })


                        vm.professionalId = vm.professionals[0]._id;
                        refreshContaCorrenteProfissionalRPS();
                        //console.log(response.d);

                    },
                    function(error){
                        console.log(error);
                    });
                break;
            case 'app.finance.professional':
                vm.refresh = refreshContaCorrenteProfissional;
                vm.removePaymentTransaction = removePaymentTransaction;
                api.getProfessionalsWithSchedule.save({},
                    function(response){

                        vm.professionals = response.d;

                        vm.professionals.sort(function(a, b){
                            if(a.name < b.name) { return -1; }
                            if(a.name > b.name) { return 1; }
                            return 0;
                        })


                        vm.professionalId = vm.professionals[0]._id;
                        refreshContaCorrenteProfissional();
                        //console.log(response.d);

                    },
                    function(error){
                        console.log(error);
                    });
                break;
            case 'app.finance.newpayment':
                vm.type = 'SUPPLIER';
                vm.transactionType = "PAYMENT";
                vm.saveTransaction = saveTransaction;
                vm.refresh = refreshExtrato;
                vm.value = 0.01;
                vm.observation = "";
                vm.when = new Date();
                vm.multiplier = -1;
                vm.title = "Novo Pagamento";

                api.bankAccounts.save({},
                    function (response) {

                        vm.bankAccounts = response.d;
                        vm.bankAccountId = response.d[0].BAAC_CD_BANK_ACCOUNT;
                    },
                    function (error) {
                        console.log(error);
                    });

                api.financialCategories.save({},
                    function(response){

                        vm.categories = [];
                        for(var i=0 ; i < response.d.length; i++){
                            if (response.d[i].FICA_IN_ENTRADASAIDA == -1){
                                vm.categories.push(response.d[i]);
                            }
                        }

                        vm.categoryId = vm.categories[0].FICA_CD_FINANCE_CATEGORY;

                    },
                    function(error){
                        console.log(error);
                    });
                api.suppliers.save({},
                    function(response){

                        vm.suppliers = response.d;
                        vm.supplierId = response.d[0].SUPP_CD_SUPPLIER;

                    },
                    function(error){
                        console.log(error);
                    });

                api.partners.save({},
                    function (response) {

                        vm.partners = response.d;
                        vm.partnerId = response.d[0].PART_CD_PARTNER;

                        //atualizar depois de carregar a conta
                        refreshExtrato();
                    },
                    function (error) {
                        console.log(error);
                    });

                break;
            case 'app.finance.newprofesisonalpayment':
                vm.type = 'PROFESSIONAL';
                vm.transactionType = "PAYMENT";
                vm.saveTransaction = saveProfessionalTransaction;
                vm.value = 0.01;
                vm.observation = "";
                vm.when = new Date();
                vm.multiplier = 1;

                api.bankAccounts.save({},
                    function (response) {

                        vm.bankAccounts = response.d;
                        vm.bankAccountId = response.d[0].BAAC_CD_BANK_ACCOUNT;
                    },
                    function (error) {
                        console.log(error);
                    });

                api.getProfessionalsWithSchedule.save({},
                    function(response){

                        vm.professionals = response.d;

                        vm.professionals.sort(function(a, b){
                            if(a.name < b.name) { return -1; }
                            if(a.name > b.name) { return 1; }
                            return 0;
                        })


                        vm.professionalId = vm.professionals[0]._id;

                    },
                    function(error){
                        console.log(error);
                    });



                break;
            case 'app.finance.transfer':
                vm.saveTransaction = transferTransaction;
                vm.value = 0.01;
                vm.observation = "";
                vm.when = new Date();

                api.bankAccounts.save({},
                    function (response) {

                        vm.bankAccounts = response.d;
                        vm.bankAccountIdFrom = response.d[0].BAAC_CD_BANK_ACCOUNT;
                        vm.bankAccountIdTo = response.d[0].BAAC_CD_BANK_ACCOUNT;
                    },
                    function (error) {
                        console.log(error);
                    });

                break;


        }

        //functions

        function removePaymentTransaction(transactionId){

            api.removeProfessionalPayment.save({
                    transactionId : transactionId

                },
                function(response) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Pagamento desfeito com sucesso.")
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.reload();
                    }, 1000);


                },
                function(error) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Erro ao remover transferência")
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.reload();
                    }, 1000);

                });
        }

        function removeTransaction(transactionId){

            api.removeTransaction.save({
                    transactionId : transactionId

                },
                function(response) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Transferência removida com sucesso.")
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.reload();
                    }, 1000);


                },
                function(error) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Erro ao remover transferência")
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.reload();
                    }, 1000);

                });
        }

        function refreshExtrato(){
            var dtFrom = new moment({
                date: 1,
                month : vm.selectedMonth.month(),
                year : vm.selectedMonth.year()
            });
            var nFrom = dtFrom.valueOf();

            var dtTo = dtFrom.add(1, 'month').add(-1, 'second');
            var nTo = dtTo.valueOf();


            api.initialBalance.save({
                    bankAccountId : vm.bankAccountId,
                    dtTo : nFrom
                },
                function (response) {

                    vm.showTable = true;
                    vm.saldo = response.d;
                    var first = true;
                    var html = "";
                    var data = "";

                    api.transactions.save({
                            bankAccountId : vm.bankAccountId,
                            dtFrom : nFrom,
                            dtTo : nTo
                        },
                        function (response) {

                            //saldo anterior
                            html += "<tr style='min-height: 5px;height:5px;'>";
                            html += "<td></td>";
                            html += "<td></td>";
                            html += "<td></td>";
                            html += "<td></td>";
                            html += "<td><b>Saldo anterior</b></td>";
                            html += "<td><b>" + $filter('currency')(vm.saldo, 'R$',2) + " </b></td>";
                            html += "<td></td>";
                            html += "</tr>";
                            var lastDate = "";

                            for(var i=0; i < response.d.length; i++){

                                if (data != new moment(response.d[i].BAAT_DT_WHEN).format('DD/MM/YYYY')){

                                    if (!first){
                                        html += "<tr style='background: silver'>";
                                        html += "<td></td>";

                                        html += "<td></td>";
                                        html += "<td></td>";
                                        html += "<td></td>";
                                        html += "<td>Saldo em " + lastDate  +  "</td>";
                                        html += "<td><b>" + $filter('currency')(vm.saldo, 'R$',2) + " </b></td>";
                                        html += "<td></td>";
                                        html += "</tr>";

                                    } else {
                                        first = false;
                                    }


                                    data = new moment(response.d[i].BAAT_DT_WHEN).format('DD/MM/YYYY');
                                }

                                html += "<tr style='min-height: 5px;height:5px;'>";
                                if (lastDate != $filter('date')(response.d[i].BAAT_DT_WHEN, "dd/MM/yyyy")){
                                    html += "<td><b>" + $filter('date')(response.d[i].BAAT_DT_WHEN, "dd/MM/yyyy") + "</b></td>";
                                    lastDate = $filter('date')(response.d[i].BAAT_DT_WHEN, "dd/MM/yyyy");
                                } else {
                                    html += "<td></td>";
                                }


                                if (response.d[i].SUPP_CD_SUPPLIER != null){
                                    html += "<td>" + response.d[i].SUPP_TX_NAME + "</td>";
                                } else if (response.d[i].PART_CD_PARTNER != null){
                                    html += "<td>" + response.d[i].PART_TX_NAME + "</td>";
                                } else if (response.d[i].SALE_CD_SALE != null){
                                    html += "<td>Serviço Prestado</td>";
                                } else if (response.d[i].BAAT_CD_BANK_ACCOUNT_TRANSACTION_TRANSFER != null){
                                    html += "<td>Transferência</td>";
                                } else if (response.d[i].PROF_CD_PROFESSIONAL != null){
                                    html += "<td>Pgto. de profissional: " + response.d[i].PROF_TX_NAME + "</td>";
                                } else{
                                    html += "<td>" + "-" + "</td>";
                                }

                                html += "<td>" + response.d[i].BAAT_TX_OBSERVATION + "</td>";

                                vm.saldo += response.d[i].BAAT_NR_VALUE;

                                if (response.d[i].BAAT_NR_VALUE > 0){
                                    html += "<td >" + $filter('currency')(response.d[i].BAAT_NR_VALUE, 'R$',2) + "</td>";
                                    html += "<td></td>";
                                } else {
                                    html += "<td></td>";
                                    html += "<td style='color:red'>" + $filter('currency')(response.d[i].BAAT_NR_VALUE, 'R$',2) + "</td>";
                                }

                                html += "<td></td>";
                                if (response.d[i].PROF_CD_PROFESSIONAL == null){
                                    html += '<td style="align-items: end"><md-button aria-label="Trash" class="md-raised md-warn gp-mini" ng-click="::vm.removeTransaction(\'' +  response.d[i].BAAT_CD_BANK_ACCOUNT_TRANSACTION  +  '\')"><md-tooltip aria-label="Pencil">Remover</md-tooltip><i class="icon-trash" layout="center"></i></md-button></td>';
                                } else{
                                    html += '<td></td>';
                                }


                                html += "</tr>";

                            }

                            html += "<tr style='background: silver'>";
                            html += "<td></td>";
                            html += "<td></td>";
                            html += "<td></td>";
                            html += "<td></td>";
                            html += "<td><b>Saldo Final</b></td>";
                            html += "<td><b>" + $filter('currency')(vm.saldo, 'R$',2) + " </b></td>";
                            html += "<td></td>";
                            html += "</tr>";


                            vm.html = html;


                        },
                        function (error) {
                            console.log(error);
                        });

                },
                function (error) {
                    console.log(error);
                });



        }

        function createRPS(){
            for(var i=0; i < vm.possibleRPS.length; i++ ){
                if (vm["checkbox_" + vm.possibleRPS[i].id] == '1'){
                    //geerar linha de RPS

                }
            }

        }

        function refreshContaCorrenteProfissional(){

            var dtFrom = new moment({
                date: 1,
                month : vm.selectedMonth.month(),
                year : vm.selectedMonth.year()
            });
            var nFrom = dtFrom.valueOf();

            var dtTo = dtFrom.add(1, 'month').add(-1, 'second');
            var nTo = dtTo.valueOf();
            vm.saldo = 0;

            //recuperando o saldo anterior
            api.saldoUntilDtProfessional.save({
                dtFrom : nFrom,
                professionalId : vm.professionalId
            }, function(response){
                vm.saldo = -response.d;

                api.professionalAdvances.save({
                        professionalId : vm.professionalId,
                        dtFrom : nFrom,
                        dtTo : nTo
                    },
                    function (response) {

                        var html = "";
                        var data = "";
                        var first = true;
                        vm.showTable = true;

                        //saldo anterior
                        html += "<tr style='min-height: 5px;height:5px;background:silver;'>";
                        html += "<td></td>";
                        html += "<td></td>";
                        html += "<td></td>";
                        html += "<td><b>Saldo anterior</b></td>";
                        html += "<td><b>" + $filter('currency')(vm.saldo, 'R$',2) + " </b></td>";
                        html += "</tr>";
                        var lastDate = "";

                        for(var i=0; i < response.d.length; i++){

                            if (data != new moment(response.d[i].when).format('DD/MM/YYYY')){

                                if (!first){
                                    html += "<tr style='background: silver'>";
                                    html += "<td></td>";
                                    html += "<td></td>";
                                    html += "<td></td>";
                                    html += "<td>Saldo em " + lastDate  +  "</td>";
                                    html += "<td><b>" + $filter('currency')(vm.saldo, 'R$',2) + " </b></td>";
                                    html += "</tr>";

                                } else {
                                    first = false;
                                }


                                data = new moment(response.d[i].when).format('DD/MM/YYYY');
                            }

                            vm.saldo += -response.d[i].value;

                            html += "<tr style='min-height: 5px;height:5px;'>";
                            if (lastDate != $filter('date')(response.d[i].when, "dd/MM/yyyy")){
                                html += "<td><b>" + $filter('date')(response.d[i].when, "dd/MM/yyyy") + "</b></td>";
                                lastDate = $filter('date')(response.d[i].when, "dd/MM/yyyy");
                            } else {
                                html += "<td></td>";
                            }

                            html += "<td>" + response.d[i].observation + "</td>";

                            if (response.d[i].value < 0){
                                html += "<td >" + $filter('currency')(response.d[i].value*-1, 'R$',2) + "</td>";
                                html += "<td></td>";
                            } else {
                                html += "<td></td>";
                                html += "<td style='color:red'>" + $filter('currency')(response.d[i].value*-1, 'R$',2) + "</td>";
                            }

                            if (response.d[i].value > 0){
                                html += '<td style="align-items: end"><md-button aria-label="Trash" class="md-raised md-warn gp-mini" ng-click="::vm.removePaymentTransaction(\'' +  response.d[i].id  +  '\')"><md-tooltip aria-label="Pencil">Desfazer Pagamento</md-tooltip><i class="icon-trash" layout="center"></i></md-button></td>';
                            } else{
                                html += '<td></td>';
                            }

                            html += "</tr>";

                        }

                        html += "<tr style='background: silver'>";
                        html += "<td></td>";
                        html += "<td></td>";
                        html += "<td></td>";
                        html += "<td><b>Saldo Final</b></td>";
                        html += "<td><b>" + $filter('currency')(vm.saldo, 'R$',2) + " </b></td>";
                        html += "</tr>";


                        vm.html = html;

                    },
                    function (error) {
                        console.log(error);
                    });
            }, function (error) {
                console.log(error);
            });



        }

        function refreshContaCorrenteProfissionalRPS(){

            var dtFrom = new moment({
                date: 1,
                month : vm.selectedMonth.month(),
                year : vm.selectedMonth.year()
            });
            var nFrom = dtFrom.valueOf();

            var dtTo = dtFrom.add(1, 'month').add(-1, 'second');
            var nTo = dtTo.valueOf();
            vm.saldo = 0;

            api.professionalAdvances.save({
                    professionalId : vm.professionalId,
                    dtFrom : nFrom,
                    dtTo : nTo
                },
                function (response) {

                    var html = "";
                    vm.possibleRPS = [];
                    vm.showTable = true;


                    for(var i=0; i < response.d.length; i++){


                        if (response.d[i].value < 0) {


                            vm.possibleRPS.push({id : response.d[i].id});

                            html += "<tr style='min-height: 5px;height:5px;'>";
                            if (response.d[i].rps == null) {
                                html += "<td><md-checkbox ng-true-value='1' ng-checked='true' aria-label='checkbox' ng-model='vm.checkbox_"+response.d[i].id+"'></td>"
                            } else {
                                html += "<td><input type='checkbox' value='0' disabled></td>"
                            }



                            html += "<td>" + $filter('date')(response.d[i].when, "dd/MM/yyyy") + "</td>";

                            html += "<td>" + response.d[i].observation + "</td>";
                            html += "<td >" + $filter('currency')(response.d[i].value * -1, 'R$', 2) + "</td>";

                            if (response.d[i].rps != null){
                                html += "<td>" + response.d[i].rps + "</td>";
                            } else {
                                html += "<td></td>";
                            }



                            html += "</tr>";
                        }

                    }


                    vm.html = html;

                },
                function (error) {
                    console.log(error);
                });

        }

        function saveTransaction(){
            switch(vm.type){
                case "SUPPLIER":
                    vm.partnerId = null;
                    vm.professionalId = null;
                    break;
                case "PARTNER":
                    vm.professionalId = null;
                    vm.supplierId = null;
                    break;
                case "PROFESSIONAL":
                    vm.partnerId = null;
                    vm.supplierId = null;
                    break;
            }

            api.saveBankAccountTransaction.save({
                    bankAccountId : vm.bankAccountId,
                    value : vm.value * vm.multiplier,
                    obs : vm.observation,
                    supplierId : vm.supplierId,
                    partnerId : vm.partnerId,
                    professionalId : vm.professionalId,
                    financeCategoryId : vm.categoryId,
                    when : vm.when.valueOf()

                },
                function(response) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Transação registrada com sucesso.")
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.go('app.finance.extrato');
                    }, 1000);


                },
                function(error) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Erro ao registrar transação")
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.go('app.finance.extrato');
                    }, 1000);

                });
        }

        function saveProfessionalTransaction(){

            api.saveProfessionalAdvance.save({
                    bankAccountId : vm.bankAccountId,
                    value : vm.value * vm.multiplier,
                    observation : vm.observation,
                    professionalId : vm.professionalId,
                    when : vm.when.valueOf()

                },
                function(response) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Pagamento/Vale de profissional registrado com sucesso.")
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.go('app.finance.professional');
                    }, 1000);


                },
                function(error) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Erro ao registrar transação")
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.go('app.finance.professional');
                    }, 1000);

                });
        }

        function transferTransaction(){


            api.saveTransferTransaction.save({
                    bankAccountIdFrom : vm.bankAccountIdFrom,
                    bankAccountIdTo : vm.bankAccountIdTo,
                    value : vm.value ,
                    obs : vm.observation,
                    when : vm.when.valueOf()

                },
                function(response) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Transferência registrada com sucesso.")
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.go('app.finance.extrato');
                    }, 1000);


                },
                function(error) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Erro ao registrar transferência")
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.go('app.finance.extrato');
                    }, 1000);

                });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.auth.verifyEmail', [])
        .config(config);



    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.auth.verifyEmail', {
            url      : '/verifyEmail/:token',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth.verifyEmail': {
                    templateUrl: 'app/main/auth/verifyEmail/verifyEmail.html',
                    controller : 'VerifyEmailController as vm'
                }
            },
            bodyClass : 'register-v2'
        });

    }

})();
(function () {
    'use strict';

    angular
        .module('app.auth.verifyEmail')
        .controller('VerifyEmailController', VerifyEmailController);

    /** @ngInject */
    function VerifyEmailController(api, $state, $translate, $mdToast, $rootScope, $mdDialog, subdomain) {
        var vm = this;
        vm.professionalStatus = 'INACTIVE';
        vm.invalidToken = false;
        vm.processing = true;

        vm.login = function(){
            $state.go('app.auth.signin');
        }

        api.verifyEmail.save(
            {
                token: $state.params.token
            },
            function (response) {
                //toast and transfer
                if (response.s == 200) {



                } else {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(response)
                            .hideDelay(3000)
                    );
                }
            },
            function (error) {
                console.log(error);
            });

            /*
        ///ACCEPT INVITE
        vm.acceptInvite = function () {
            api.acceptInvite.save({
                token: $state.params.token
            },
                function (response) {
                    if (response.s == 200) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Convite aceito com sucesso.")
                                .hideDelay(1000)
                        );
                        //redirect
                        setTimeout(function () {
                            $state.go('app.auth.signin');
                        }, 1000);

                    } else {
                        console.log(response);
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Erro ao aceitar o convite")
                                .hideDelay(1000)
                        );
                    }

                },
                function (error) {
                    console.log(error);
                });
        }

        ///ACCEPT INVITE WITH NORE DATA
        vm.acceptInviteWithSignup = function () {
            api.acceptInviteWithSignup.save({
                token: $state.params.token,
                name: vm.signup.name,
                telephone: vm.signup.telephone,
                password: vm.signup.password,
                email: vm.signup.email
            },
                function (response) {
                    if (response.s == 200) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Convite aceito com sucesso.")
                                .hideDelay(1000)
                        );
                        //redirect
                        setTimeout(function () {
                            $state.go('app.auth.signin');
                        }, 1000);

                    } else {
                        var msg = "Erro ao aceitar o convite";
                        if (response.d.error != undefined) {
                            if (response.d.error == 1) {
                                msg = "Telefone já consta na base, por favor verifique o telefone ou entre em contato com o nosso suporte técnico.";
                            }
                            if (response.d.error == 2) {
                                msg = "Email já consta na base, por favor verifique o email ou entre em contato com o nosso suporte técnico.";
                            }
                        }
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(msg)
                                .hideDelay(4000)
                        );
                    }

                },
                function (error) {
                    console.log(error);
                });
        }
        */
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.verifyAccount', [])
        .config(config);



    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.auth.verifyAccount', {
            url      : '/verifyAccount/:token',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth.verifyAccount': {
                    templateUrl: 'app/main/auth/verifyAccount/verifyAccount.html',
                    controller : 'VerifyAccountController as vm'
                }
            },
            bodyClass : 'register-v2'
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.verifyAccount')
        .controller('VerifyAccountController', VerifyAccountController);

    /** @ngInject */
    function VerifyAccountController(api, $state, $translate, $mdToast, $rootScope,
                                     $mdDialog, subdomain, $location, $window) {
        var vm = this;
        vm.professionalStatus = 'INACTIVE';
        vm.invalidToken = false;
        vm.processing = true;

        api.getInviteInfo.save({
                token: $state.params.token
            },
            function (response) {
                vm.processing = false;

                if (response.s == 200){
                    vm.professionalStatus = response.d.professionalStatus;
                    vm.invalidToken = false;
                    vm.signup = {};
                    vm.signup.email = response.d.email;
                    vm.signup.telephone = response.d.telephone;


                    if ((response.d.telephone != undefined) && (response.d.telephone.length > 0)){
                        vm.showTelephone = true;
                        vm.showEmail = false;
                    } else {
                        vm.showTelephone = false;
                        vm.showEmail = true;
                    }


                } else {
                    vm.invalidToken = true;
                }

            },
            function (error) {
                console.log(error);
            });

        ///ACCEPT INVITE
        vm.acceptInvite = function(){
            api.acceptInvite.save({
                    token: $state.params.token
                },
                function (response) {
                    if (response.s == 200){
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Convite aceito com sucesso.")
                                .hideDelay(1000)
                        );
                        //redirect
                        setTimeout(function(){
                            //$state.go('app.auth.signin');
                            //$location.url("https://bhaa5.app.goo.gl/JdE5");
                            $window.location.href = 'https://bhaa5.app.goo.gl/JdE5';
                        }, 1000);

                    } else {
                        console.log(response);
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Erro ao aceitar o convite")
                                .hideDelay(1000)
                        );
                    }

                },
                function (error) {
                    console.log(error);
                });
        }

        ///ACCEPT INVITE WITH NORE DATA
        vm.acceptInviteWithSignup = function(){
            api.acceptInviteWithSignup.save({
                    token: $state.params.token,
                    name: vm.signup.name,
                    telephone: vm.signup.telephone,
                    password:vm.signup.password,
                    email:vm.signup.email
                },
                function (response) {
                    if (response.s == 200){
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Convite aceito com sucesso.")
                                .hideDelay(1000)
                        );
                        //redirect
                        setTimeout(function(){
                            $window.location.href = 'https://bhaa5.app.goo.gl/JdE5';
                            //$location.url("https://bhaa5.app.goo.gl/JdE5");
                            //$state.go('app.auth.signin');
                        }, 1000);

                    } else {
                        var msg=  "Erro ao aceitar o convite";
                        if (response.d.error != undefined){
                            if (response.d.error == 1){
                                msg = "Telefone já consta na base, por favor verifique o telefone ou entre em contato com o nosso suporte técnico.";
                            }
                            if (response.d.error == 2){
                                msg = "Email já consta na base, por favor verifique o email ou entre em contato com o nosso suporte técnico.";
                            }
                        }
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(msg)
                                .hideDelay(4000)
                        );
                    }

                },
                function (error) {
                    console.log(error);
                });
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.signup', [])
        .config(config);



    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.auth.signup', {
            url      : '/signup',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth.signup': {
                    templateUrl: 'app/main/auth/signup/signup.html',
                    controller : 'SignupController as vm'
                }
            },
            bodyClass: 'login'
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.signup')
        .controller('SignupController', SignupController);

    /** @ngInject */
    function SignupController(api, $state, $translate, $mdToast, $rootScope, $mdDialog, subdomain, $window)
    {
        var vm = this;
        vm.singupAction = singupAction;
        vm.showTerms = showTerms;
        vm.signup = {};
        vm.signup.password = '';
        vm.processing = false;
        vm.showForm = true;

        //logando no branch que user chegou na pagina d esignup
        /*$window.branch.track('signup_access', {  }, function (err, data) {
            console.log(err, data);
        });*/

        function showTerms(){
            $mdDialog.show({
                controller: 'SignupController',
                controllerAs : 'vm',
                templateUrl: 'app/main/auth/signup/termsDialog.html',
                clickOutsideToClose:true,
                multiple:true,
                escapeToClose : true
            })
                .then(function(answer) {

                }, function() {

                });
        }


        vm.showButtonSignup = function(){
            if (subdomain == 'app') return false;
            return false;            
        }

        vm.facebookLogin = function(){
            FB.getLoginStatus(function(response) {
                if (response.status === 'connected') {
                    //entrar no sistema e pegar informacoes
                    FB.api('/me', {
                        fields: 'name,email'
                    }, function(response) {
                        if (!response || response.error) {
                            console.log('Error occured');
                        } else {
                            var email = response.email;
                            var name = response.name;
                            var facebookId = response.id;

                            console.log(email);
                            console.log(name);
                            console.log(facebookId);

                            api.fbSignin.save({
                                    email: email,
                                    facebookId: facebookId,
                                    name: name
                                },
                                function(response){

                                    console.log(response);

                                    if(response.s == 200) {

                                        $rootScope.userName = response.d.userName;
                                        $rootScope.userType = response.d.userType;
                                        $rootScope.userLogin = response.d.userLogin;
                                        $rootScope.pdvName = response.d.pdvName;


                                        $rootScope.securityToken = response.d.token;
                                        $rootScope.$emit('changeToken', []);

                                        $state.go("app.schedule.byprofessional");

                                    }
                                    else if (response.s == 403) {
                                        showEmailAlreadyInUse(response.d);
                                        return;

                                    }            

                                    else{
                                        var message = $translate.instant("AUTH.SIGNIN.ERRORS.EMAIL_OR_PASSWORD_INCORRECT");
                                        //show success Toast
                                        $mdToast.show({
                                            template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                                            hideDelay: 1500,
                                            position : 'top center',
                                            parent   : '#content'
                                        });

                                        vm.admin = "";
                                        vm.adminPassword = "";
                                    }
                                },
                                function(error){
                                    console.log(error);
                                });

                        }
                    });

                }
                else {
                    FB.login(function(){}, {scope: 'publish_actions'});
                }
            });

        }

        function showEmailAlreadyInUse(email) {
            
                        // Appending dialog to document.body to cover sidenav in docs app
                        // Modal dialogs should fully cover application
                        // to prevent interaction outside of dialog
                        $mdDialog.show(
                            $mdDialog.alert()
                                .parent(angular.element(document.querySelector('#popupContainer')))
                                .clickOutsideToClose(true)
                                .title('Email já cadastrado')
                                .textContent('O email ' + email +  ' já esta cadastrado no sistema.\n\nPor favor, efetue o login com ele.')
                                .ariaLabel('Alert Dialog Demo')
                                .ok('Ok')
                            //.targetEvent(ev)
                        );
            
            
        }

        function singupAction() {

            $rootScope.securityToken = null;
            vm.processing = true;

            api.signup2.save({
                    email: vm.signup.email,
                    name:vm.signup.name,
                    password: vm.signup.password

                },
                function(response){

                    if(response.s == 200) {

                        vm.showForm = false;

                        console.log(response);

                        $window.branch.setIdentity(response.d.professionalId + "", function (err, data) {
                            console.log(err, data);

                            //logando no branch que user chegou na pagina d esignup
                            $window.branch.track('signup_web2',  function (err, data) {
                                console.log(err, data);
                            });

                        });



                    } else if (response.s == 401){
                        vm.processing = false;
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Usuário já possui cadastro")
                                .hideDelay(1000)
                        );

                    }
                    else{
                        vm.processing = false;
                        var message = $translate.instant("AUTH.SIGNUP.ERRORS.EMAIL_OR_PASSWORD_INCORRECT");
                        //show success Toast
                        $mdToast.show({
                            template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                            hideDelay: 1500,
                            position : 'top center',
                            parent   : '#content'
                        });

                        vm.admin = "";
                        vm.adminPassword = "";
                    }
                },
                function(error){
                    console.log(error);
                });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.signin', [])
        .config(config);



    /** @ngInject */
    function config($stateProvider)
    {


        // State
        $stateProvider.state('app.auth.signin', {
            url      : '/signin',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth.signin': {
                    templateUrl: 'app/main/auth/signin/signin.html',
                    controller : 'SigninController as vm'
                }
            },
            bodyClass: 'login'
        });

    }

})();
(function () {
    'use strict';

    angular
        .module('app.auth.signin')
        .controller('SigninController', SigninController);

    /** @ngInject */
    function SigninController(api, $state, $translate, $mdToast, $scope, $rootScope, subdomain, $location, $mdDialog, $window) {
        var vm = this;
        vm.login = login;
        vm.showTimer = false;


        vm.user = {};
        vm.requestEmail = false;

        if ((subdomain != null) && (subdomain != "")) {
            vm.user.account = subdomain;
        } else {
            vm.user.account = "demo";
            //vm.user.account = "jfs";
            //vm.user.account = "app"
            //subdomain = "app";

        }

        vm.showButtonSignup = function () {
            //nao temos mais a questao do subdominio
            //if (subdomain == 'app') return true;
            return true;
        }

        vm.accountName = vm.user.account;

        if (vm.accountName == 'app') {
            vm.showAccount = true;
            vm.user.account = '';
        } else {
            vm.showAccount = false;
        }

        $scope.answer = function (answer) {
            $mdDialog.hide(answer);
        };

        vm.registerEmailFBSignIn = function () {

            var email = vm.user.email;
            if ((email == undefined) || (email.indexOf("@") == -1)) {
                return;
            }

            api.updateEmailUser.save({
                email: email
            },
                function (response) {

                    if ($rootScope.userType == 'RECEPCIONIST') {
                        $state.go("app.schedule.byprofessional");
                    } else {
                        $state.go("app.dashboard");
                    }


                },
                function (error) {
                    console.log(error);
                });

        }



        vm.facebookLogin = function () {
            FB.getLoginStatus(function (response) {
                
                if (response.status === 'connected') {
                    //entrar no sistema e pegar informacoes
                    FB.api('/me', {
                        fields: 'name,email'
                    }, function (response) {
                        if (!response || response.error) {
                            console.log('Error occured');
                        } else {
                            var email = response.email;
                            var name = response.name;
                            var facebookId = response.id;


                            api.fbSignin.save({
                                email: email,
                                facebookId: facebookId,
                                name: name,
                                subdomain: subdomain,
                                platform: 'WEB'
                            },
                                function (response) {



                                    if (response.s == 200) {

                                        $rootScope.userAccessCode = response.d.userAccessCode;
                                        $rootScope.userName = response.d.userName;
                                        $rootScope.userLogin = response.d.userLogin;
                                        $rootScope.professionalId = response.d.professionalId;

                                        $rootScope.pdvs = response.d.pdvs;
                                        $rootScope.userType = $rootScope.pdvs[0].userType;
                                        $rootScope.pdvName = $rootScope.pdvs[0].pdvName;
                                        $rootScope.subscriptions = $rootScope.pdvs[0].subscriptions;
                                        $rootScope.pdvId = $rootScope.pdvs[0].pdvId;

                                        //logando no brancg o user
                                        branch.setIdentity(response.d.professionalId + "", function (err, data) {
                                            if (err) console.log(err, data);
                                        });



                                        //checando se deve mostrar a mensagem de trial
                                        $rootScope.showTrial = false;
                                        for (var j = 0; j < $rootScope.subscriptions.length; j++) {
                                            for (var k = 0; k < $rootScope.subscriptions[j].products.length; k++) {
                                                if ($rootScope.subscriptions[j].products[k] == 'WEB') {
                                                    var m1 = new moment($rootScope.subscriptions[j].until);
                                                    if (m1.diff(new moment(), 'days') < 7) {
                                                        $rootScope.showTrial = true;
                                                        $rootScope.validUntil = m1.format('DD/MM/YYYY');
                                                        if (m1.diff(new moment(), 'days') < 0) {
                                                            $rootScope.showMessageVencimento = true;
                                                            $rootScope.showMessageTrial = false;
                                                        } else {
                                                            $rootScope.showMessageTrial = true;
                                                            $rootScope.showMessageVencimento = false;
                                                        }

                                                    }

                                                }
                                            }
                                        }


                                        if (response.d.freshId) {

                                            if (!isElectron){
                                                window.fcWidget.init({
                                                    token: "3d87cc94-44cc-4627-b16d-9a369de069cd",
                                                    host: "https://wchat.freshchat.com",
                                                    externalId: response.d.userId,
                                                    restoreId: response.d.freshId
                                                });
                                            }

                                        } else {
                                            if (!isElectron) {
                                                window.fcWidget.init({
                                                    token: "3d87cc94-44cc-4627-b16d-9a369de069cd",
                                                    host: "https://wchat.freshchat.com",
                                                    externalId: response.d.userId
                                                });
                                            }
                                        }

                                        if (!isElectron) {
                                            window.fcWidget.user.get(function (resp) {
                                                var status = resp && resp.status,
                                                    data = resp && resp.data;
                                                if (status !== 200) {
                                                    window.fcWidget.user.setProperties({
                                                        firstName: response.d.userName,              // user's first name
                                                        email: response.d.userLogin,    // user's email address
                                                        phone: response.d.userLogin,            // phone number without country code
                                                        phoneCountryCode: "+55"         // phone's country code

                                                    });

                                                }
                                            });
                                        }

                                        if (response.d.freshId == null) {
                                            if (!isElectron) {
                                                window.fcWidget.on('user:created', function (resp) {
                                                    var status = resp && resp.status,
                                                        data = resp && resp.data;
                                                    if (status === 200) {
                                                        if (data.restoreId) {
                                                            api.saveFreshId.save({
                                                                    freshId: data.restoreId
                                                                },
                                                                function (response) {
                                                                });
                                                        }
                                                    }
                                                });
                                            }
                                        }


                                        $rootScope.securityToken = response.d.token;
                                        $rootScope.$emit('changeToken', []);

                                        //log stats
                                        api.pdvStats.save({

                                        },
                                            function (response) {


                                                if (response.s == 200) {
                                                    if (!isElectron) {
                                                        window.fcWidget.user.setProperties({
                                                            pdv_name: response.d.pdv_name,
                                                            pdv_id: response.d.pdvId,
                                                            plan_expire_at: response.d.plan_expire_at,
                                                            plan_type: response.d.plan,
                                                            user_profile: $rootScope.userType
                                                        });
                                                    }

                                                }
                                            });

                                        api.pdvLocations.save({

                                        },
                                            function (response) {
                                                $rootScope.pdvLocations = response.d;
                                            });

                                        if (response.d.active == 1) {
                                            if ($rootScope.userType == 'RECEPCIONIST') {
                                                $state.go("app.schedule.byprofessional");
                                            } else {
                                                $state.go("app.dashboard");
                                            }

                                        }
                                        else if ((response.d.userLogin == undefined) || (response.d.userLogin.indexOf("@") == -1)) {
                                            vm.requestEmail = true;
                                            return;
                                        }
                                        else if (response.d.active == 0) {
                                            showEmailConfirmationDialog();
                                            return;
                                        }
                                    }
                                    else if (response.s == 403) {
                                        showEmailAlreadyInUse(response.d);
                                        return;

                                    }
                                    else {
                                        var message = $translate.instant("AUTH.SIGNIN.ERRORS.EMAIL_OR_PASSWORD_INCORRECT");
                                        //show success Toast
                                        $mdToast.show({
                                            template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                                            hideDelay: 1500,
                                            position: 'top center',
                                            parent: '#content'
                                        });

                                        vm.admin = "";
                                        vm.adminPassword = "";
                                    }
                                },
                                function (error) {
                                    console.log(error);
                                });

                        }
                    });

                }
                else {
                    FB.login(function () { }, { scope: 'publish_actions' });
                }
            });

        }

        function login() {
            if ($rootScope.mobilePlatform) {
                $mdDialog.show({
                    controller: SigninController,
                    templateUrl: 'app/main/auth/signin/mobile.html',
                    parent: angular.element(document.body),
                    targetEvent: null,
                    clickOutsideToClose: true,
                    fullscreen: false
                })
                    .then(function (answer) {
                        if (answer == 'ACCESS_WEB') {
                            realLogin();
                        } else {
                            window.location = 'https://play.google.com/store/apps/details?id=br.com.gpsoftware.gpsalao';
                        }

                    }, function () {

                    });


            } else {
                realLogin();
            }


        }

        function showEmailConfirmationDialog() {

            // Appending dialog to document.body to cover sidenav in docs app
            // Modal dialogs should fully cover application
            // to prevent interaction outside of dialog
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#popupContainer')))
                    .clickOutsideToClose(true)
                    .title('Aguardando confirmação de email')
                    .textContent('Por favor verifique seu e-mail clicando no link enviado para ele antes de poder acessar o sistema.')
                    .ariaLabel('Alert Dialog Demo')
                    .ok('Ok')
                //.targetEvent(ev)
            );


        }

        function showEmailAlreadyInUse(email) {

            // Appending dialog to document.body to cover sidenav in docs app
            // Modal dialogs should fully cover application
            // to prevent interaction outside of dialog
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(angular.element(document.querySelector('#popupContainer')))
                    .clickOutsideToClose(true)
                    .title('Email já cadastrado')
                    .textContent('O email ' + email + ' já esta cadastrado no sistema.\n\nPor favor, efetue o login com ele.')
                    .ariaLabel('Alert Dialog Demo')
                    .ok('Ok')
                //.targetEvent(ev)
            );


        }

        function realLogin() {
            api.professionalSignIn.save({
                login: vm.user.login,
                password: vm.user.password,
                account: vm.accountName,
                platform: 'WEB'
            },
                function (response) {

                    if (response.s == 200) {

                        //Se ainda não confirmou o email
                        if (response.d.active == 0) {

                            showEmailConfirmationDialog();
                            return;
                        }


                        //logando no brancg o user
                        branch.setIdentity(response.d.professionalId + "", function (err, data) {
                            if (err) console.log(err, data);
                        });

                        $rootScope.userAccessCode = response.d.userAccessCode;
                        $rootScope.userName = response.d.userName;
                        $rootScope.userLogin = response.d.userLogin;
                        $rootScope.professionalId = response.d.professionalId;
                        $rootScope.isBetaUser = response.d.isBetaUser;

                        
                        $rootScope.pdvs = response.d.pdvs;
                        $rootScope.userType = $rootScope.pdvs[0].userType;
                        $rootScope.pdvName = $rootScope.pdvs[0].pdvName;
                        $rootScope.subscriptions = $rootScope.pdvs[0].subscriptions;
                        $rootScope.pdvId = $rootScope.pdvs[0].pdvId;

                        //checando se deve mostrar a mensagem de trial
                        $rootScope.showTrial = false;
                        var possuiWeb = false;

                        var dtUntil = 0;


                        for (var j = 0; j < $rootScope.subscriptions.length; j++) {
                            for (var k = 0; k < $rootScope.subscriptions[j].products.length; k++) {
                                if ($rootScope.subscriptions[j].products[k] == 'WEB') {

                                    if (new moment($rootScope.subscriptions[j].until).valueOf() > dtUntil) {
                                        dtUntil = new moment($rootScope.subscriptions[j].until).valueOf();
                                    }



                                }
                            }
                        }

                        var m1 = new moment(dtUntil);

                        if (m1.diff(new moment(), 'days') < 7) {
                            $rootScope.showTrial = true;
                            $rootScope.validUntil = m1.format('DD/MM/YYYY');
                            if (m1.diff(new moment(), 'days') < 0) {
                                $rootScope.showMessageVencimento = true;
                                $rootScope.showMessageTrial = false;
                            } else {
                                possuiWeb = true;
                                $rootScope.showMessageTrial = true;
                                $rootScope.showMessageVencimento = false;
                            }

                        } else {
                            possuiWeb = true;
                            $rootScope.showMessageTrial = true;
                            $rootScope.showMessageVencimento = false;
                        }


                        dtUntil = new moment(dtUntil);
                        $rootScope.validUntil = dtUntil.format('DD/MM/YYYY');

                        //window.fcWidget.setExternalId(response.d.userId);
                        //window.fcWidget.user.setFirstName(response.d.userName);
                        //window.fcWidget.user.setEmail(response.d.userLogin);

                        if (response.d.freshId) {
                            if (!isElectron) {
                                window.fcWidget.init({
                                    token: "3d87cc94-44cc-4627-b16d-9a369de069cd",
                                    host: "https://wchat.freshchat.com",
                                    externalId: response.d.userId,
                                    restoreId: response.d.freshId
                                });
                            }
                        } else {
                            if (!isElectron) {
                                window.fcWidget.init({
                                    token: "3d87cc94-44cc-4627-b16d-9a369de069cd",
                                    host: "https://wchat.freshchat.com",
                                    externalId: response.d.userId
                                });
                            }
                        }

                        if (!isElectron) {
                            window.fcWidget.user.get(function (resp) {
                                var status = resp && resp.status,
                                    data = resp && resp.data;
                                if (status !== 200) {
                                    window.fcWidget.user.setProperties({
                                        firstName: response.d.userName,              // user's first name
                                        email: response.d.userLogin,    // user's email address
                                        phone: response.d.userLogin,            // phone number without country code
                                        phoneCountryCode: "+55"         // phone's country code

                                    });

                                }
                            });
                        }

                        if (response.d.freshId == null) {
                            if (!isElectron) {
                                window.fcWidget.on('user:created', function (resp) {
                                    var status = resp && resp.status,
                                        data = resp && resp.data;
                                    if (status === 200) {
                                        if (data.restoreId) {
                                            api.saveFreshId.save({
                                                    freshId: data.restoreId
                                                },
                                                function (response) {
                                                });
                                        }
                                    }
                                });
                            }
                        }



                        //logabdo no facebook e google que usuario ta uentrando
                        fbq('trackCustom', 'web_access');


                        var dtCreatedAt = new Date(response.d.createdAt).valueOf();
                        var dtHoje = new Date().valueOf();
                        var seisDias = 60 * 60 * 24 * 6 * 1000;
                        var tresDias = 60 * 60 * 24 * 3 * 1000;
                        var noveDias = 60 * 60 * 24 * 9 * 1000;


                        //checando se usuario esta na plataforma a mais de 7 dias
                        if (dtHoje - tresDias > dtCreatedAt) {
                            //marcar no facebook que reteve por 3d
                            fbq('trackCustom', 'more_than_3_days');
                        }
                        if (dtHoje - seisDias > dtCreatedAt) {
                            //marcar no facebook que reteve por 6d
                            fbq('trackCustom', 'more_than_6_days');
                        }
                        if (dtHoje - noveDias > dtCreatedAt) {
                            //marcar no facebook que reteve por 9d
                            fbq('trackCustom', 'more_than_9_days');
                        }




                        $rootScope.securityToken = $rootScope.pdvs[0].token;                        
                        $rootScope.$emit('changeToken', []);


                        //log stats
                        api.pdvStats.save({

                        },
                            function (response) {


                                if (response.s == 200) {
                                    if (!isElectron) {
                                        window.fcWidget.user.setProperties({
                                            pdv_name: response.d.pdv_name,
                                            pdv_id: response.d.pdvId,
                                            plan_expire_at: response.d.plan_expire_at,
                                            plan_type: response.d.plan,
                                            user_profile: $rootScope.userType
                                        });
                                    }

                                }
                            });


                        api.pdvLocations.save({

                        },
                            function (response) {
                                $rootScope.pdvLocations = response.d;
                            });


                        if (($rootScope.userType == 'RECEPCIONIST') || ($rootScope.userType == 'PROFESSIONAL')) {
                            $state.go("app.schedule.byprofessional");
                        } else {
                            $state.go("app.dashboard");
                        }


                    }
                    else {
                        var message = $translate.instant("AUTH.SIGNIN.ERRORS.EMAIL_OR_PASSWORD_INCORRECT");
                        //show success Toast
                        $mdToast.show({
                            template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                            hideDelay: 1500,
                            position: 'top center',
                            parent: '#content'
                        });

                        vm.admin = "";
                        vm.adminPassword = "";
                    }
                },
                function (error) {
                    console.log(error);
                });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.auth.forgot-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.auth.forgot-password', {
            url      : '/forgot-password',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth.forgot-password': {
                    templateUrl: 'app/main/auth/forgot-password/forgot-password.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            bodyClass: 'forgot-password'
        });


    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.auth.forgot-password')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController(api,$state,$mdToast,$translate) {
        var vm = this;

        vm.getPassword = getPassword;
        // Data

        // Methods
        function getPassword() {
            api.forgotPassword.save({
                    email: vm.forgotPassword.email
                },
                function(response){

                    if(response.s == 200) {
                        //show success Toast
                        var message = $translate.instant("AUTH.FORGOT-PASSWORD.SUCCESS");
                        $mdToast.show({
                            template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                            hideDelay: 1500,
                            parent   : '#content'
                        });
                        setTimeout(function(){
                            $state.go("app.auth.signin");
                        },1000)
                    }
                    else{
                        var message = $translate.instant("AUTH.FORGOT-PASSWORD.ERRORS.INVALID_EMAIL_ACCOUNT");
                        //show success Toast
                        $mdToast.show({
                            template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                            hideDelay: 1500,
                            parent   : '#content'
                        });

                        vm.admin = "";
                        vm.adminPassword = "";
                    }
                },
                function(error){
                    console.log(error);
                });
        }

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config(msApiProvider)
    {

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.support', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {

        //State
        $stateProvider
            .state('app.support', {
                url    : 'http://www.styleplace.net',
                target : '_blank'
            })
            .state('app.support.chat', {
                url    : ''
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.support')
        .controller('SupportController', SupportController);

    /** @ngInject */
    function SupportController($mdDialog, $scope, topic, $window, $sce,api, $localStorage)
    {
        var vm = this;

        $scope.$storage = $localStorage;
        $scope.changeVideo = function(video) {
            loadVideo(video);
        }
        $scope.otherVideos = [];
        $scope.step1 = true;

        $scope.gotoStart = function () {
            $scope.step1 = false;
        }


        $scope.saveAndClose = function(seeDemo){


            api.saveSurvey.save({
                numeroAtendimentos : vm.numeroAtendimentos,
                numeroProfissionais  :vm.numeroProfissionais,
                formaPagamento : vm.formaPagamento,
                leiSalaoParceiro : vm.leiSalaoParceiro,
                telefone : vm.telefone,
                email : vm.email,
                seeDemo : seeDemo
            }, function(response){
                $scope.$storage.showOnboard = false;
                $scope.close();
            }, function(response){
                $scope.$storage.showOnboard = false;
                $scope.close();
            })
        }

        function loadVideo(video){
            $scope.otherVideos = [];
            switch(video){
                case "customerList":
                    $scope.videoHelp = "Módulo de Clientes";
                    $scope.videoId = "ZwLUgxM_QNE";
                    break;
                case "newCustomer":
                    $scope.videoHelp = "Cadastrando Clientes";
                    $scope.videoId = "CY2rOBkuUa8";
                    break;
                case "scheduleByProfessional":
                    $scope.videoHelp = "Fazendo o primeiro agendamento";
                    $scope.videoId = "Y8N4-FV2LGE";
                    $scope.otherVideos.push({videoId : 'checkin', title : 'Fazendo checkin do cliente'})
                    $scope.otherVideos.push({videoId : 'fluxoCliente', title : 'Acompanhando o cliente'})
                    break;
                case "checkin":
                    $scope.videoHelp = "Fazendo o checkin do cliente";
                    $scope.videoId = "WNOvNNyQ_As";
                    break;
                case "fluxoCliente":
                    $scope.videoHelp = "Acompanhando o cliente";
                    $scope.videoId = "YdCGKUjMP6k";
                    break;
                case "service":
                    $scope.videoHelp = "Configurando Serviços";
                    $scope.videoId = "NXThX0F_6tM";
                    break;
                case "professionalList":
                    $scope.videoHelp = "Controle de Profissionais";
                    $scope.videoId = "cjjacRAD4s4";
                    $scope.otherVideos.push({videoId : 'professional', title : 'Cadastro de Profissionais'})
                    break;
                case "professional":
                    $scope.videoHelp = "Cadastro de Profissionais";
                    $scope.videoId = "4Em3IiVygIU";
                    $scope.otherVideos.push({videoId : 'professionalList', title : 'Controle de Profissionais'})
                    break;
                case "user":
                    $scope.videoHelp = "Controle de Usuários";
                    $scope.videoId = "b98peVe-XfA"
                    break;
                case "partnershipList":
                    $scope.videoHelp = "Parcerias";
                    $scope.videoId = "jI3IlpHHPeY";
                    break;
                case "closedSales":
                    $scope.videoHelp = "Comandas fechadas";
                    $scope.videoId = "O4f9zl4Esq8";
                    break;
                case "openSales":
                    $scope.videoHelp = "Comandas abertas";
                    $scope.videoId = "S27sU5LQhxE";
                    break;




            }
            $scope.url = $sce.trustAsResourceUrl("https://www.youtube.com/embed/" + $scope.videoId + "?rel=0");

        }

        loadVideo(topic);


        $scope.close = function(){
            $mdDialog.hide();
        }

        $scope.goto = function(newWindow){
            $window.open('https://youtu.be/' + $scope.videoId, '_blank');
        }

        $scope.gotoSupport = function(){
            $window.open('https://gpsoftware.zendesk.com', '_blank');
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.wizard', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.wizard', {
                url    : '/wizard',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/wizard/wizard.html',
                        controller : 'WizardController as vm'
                    }
                }
            }) ;


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.wizard')
        .controller('WizardController', WizardController);

    /** @ngInject */
    function WizardController(api, $translate, $scope) {
        var vm = this;

        //checar se tem serviço cadastrado
        api.serviceServices.save({
            },
            function(response){
                if ((response != undefined) && (response.d.services.length > 0)){
                    vm.serviceClass = "md-raised md-green-500-bg"
                    vm.service = "Concluído"
                    vm.serviceStyle = {
                        'color':'Green',
                        'font-size':'11px',
                        'margin-left':'10px'
                    };
                } else {
                    vm.serviceClass = "md-raised md-orange-500-bg"
                    vm.service = "Obrigatório"
                    vm.serviceStyle = {
                        'color':'Red',
                        'font-size':'11px',
                        'margin-left':'10px'
                    };
                }

            },
            function(error){
                console.log(error);
            });

        //checar se tem profissional cadastrado
        api.serviceProfessionals.save({
            },
            function(response){
                console.log(response);

                if ((response != undefined) && (response.d.length > 0)){
                    vm.professionalClass = "md-raised md-green-500-bg"
                    vm.professional = "Concluído"
                    vm.professionalStyle = {
                        'color':'Green',
                        'font-size':'11px',
                        'margin-left':'10px'
                    };
                } else {
                    vm.professionalClass = "md-raised md-orange-500-bg"
                    vm.professional = "Obrigatório"
                    vm.professionalStyle = {
                        'color':'Red',
                        'font-size':'11px',
                        'margin-left':'10px'
                    };
                }

            },
            function(error){
                console.log(error);
            });

        /*api.pdv.save({
            },
            function(response){
                var obj = response.d;

                if ((obj.properties.name.length > 0) &&
                    (obj.properties.address.length > 0) &&
                    (obj.properties.telephone1.length > 0) &&
                    (obj.properties.about.length > 0) )
                {
                    vm.contentClass = "md-raised md-green-500-bg"
                    vm.contentStyle = {
                        'color':'Green',
                        'font-size':'11px',
                        'margin-left':'10px'
                    };
                    vm.content = "Concluído";
                } else {
                    vm.contentClass = "md-raised md-orange-500-bg"
                    vm.content = "Pendente";
                    vm.contentStyle = {
                        'color':'Red',
                        'font-size':'11px',
                        'margin-left':'10px'
                    };
                }

            },
            function(error){
                console.log(error);
            });*/

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.stock',
        [
            // 3rd Party Dependencies
            'datatables'
        ]
    )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {


        $stateProvider.state('app.stock', {
            url    : '/stock'
        }).state('app.stock.entry', {
            url    : '/entry',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/stock/entry.html',
                    controller : 'StockController as vm'
                }
            }
        }).state('app.stock.list', {
            url    : '/list',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/stock/list.html',
                    controller : 'StockController as vm'
                }
            }
        }).state('app.stock.report', {
            url    : '/report',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/stock/list.html',
                    controller : 'StockController as vm'
                }
            }
        });


    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.stock')
        .controller('StockController', StockController);

    /** @ngInject */
    function StockController($state, $scope,DTOptionsBuilder,DTColumnBuilder,DTColumnDefBuilder, api,
                                    DTDefaultOptions, $translate, $mdDialog, $mdToast, $q)
    {
        var vm = this;

        //check if is edit, insert or nothing
        var currentState = $state.current.name;
        vm.productSearchTextChange = productSearchTextChange;
        vm.operationType = 'SET';
        vm.value = 1;
        vm.showTable = false;

        //Initialize
        switch (currentState) {
            case "app.stock.entry":
                vm.saveEntry = function () {
                    api.stockEntry.save({
                            productId: vm.product._id,
                            type: vm.operationType,
                            value: vm.value
                        },
                        function (response) {
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent("Entrada de estoque registrada com sucesso")
                                    .hideDelay(2000)
                            );
                            $state.go('app.stock.list');
                        },
                        function (error) {
                            console.log(error);
                        });
                }


                break;
            case "app.stock.list":
            case "app.stock.report":
                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({autoWidth : false})
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable":     "Nenhum registro disponível",
                        "sInfo":           "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty":      "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered":   "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix":    "",
                        "sInfoThousands":  ",",
                        "sLengthMenu":     "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing":     "Processando...",
                        "sSearch":         "Busca:",
                        "sZeroRecords":    "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst":    "Primeiro",
                            "sLast":     "Ultimo",
                            "sNext":     "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending":  ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });

                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');
                api.products.save({

                    },
                    function (response) {
                        vm.showTable = true;
                        vm.products  = response.d;
                        //console.log(response);
                    },
                    function (error) {
                        console.log(error);
                    });

                break;
        }

        function productSearchTextChange(search) {
            var deferred = $q.defer();
            api.getProductsByName.save({
                    search : search,
                },
                function(response){
                    deferred.resolve( response.d );
                },
                function(error){
                    console.log(error);
                });

            return deferred.promise;

        }



        // functions
        function saveStockEntry() {
            api.saveProductCategory.save({
                    _id: vm.category._id,
                    name: vm.category.name
                },
                function(response){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.PRODUCT.CATEGORY.TOAST.SAVE.SUCCESS"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function(){
                        $state.go('app.settings.product.category.list');
                    }, 1000);
                },
                function(error){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.PRODUCT.CATEGORY.TOAST.SAVE.ERROR"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function(){
                        $state.go('app.settings.product.category.list');
                    }, 1000);
                });

        }
        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.schedule')
        .controller('ViewAppointmentController', ViewAppointmentController);


    /** @ngInject */
    function ViewAppointmentController($scope, $q, api, $translate,
                             scheduleId, $rootScope, $mdDialog, $window){
        var vm = this;


        $scope.close = function(){
            $mdDialog.hide();
        }

        api.serviceRequest.save({
                requestId: scheduleId
            },
            function(response){
                console.log(response.d);
                vm.customerName = response.d.extra.customer.name  + " - " + response.d.extra.customer.telephone;
                vm.serviceName = response.d.extra.service.name;
                vm.when = new moment(response.d.when).format("DD/MM/YYYY HH:mm");
                vm.userName = response.d.userName;
                vm.professionalName = response.d.extra.professional.name;
                vm.createdAt = new moment(response.d.createdAt).format('DD/MM/YYYY HH:mm:ss');
                if (response.d.channel.indexOf('APP') > 0){
                    vm.channel = 'APP';
                } else {
                    vm.channel = 'RECEPÇAO';
                }


            },
            function(error){
                console.log(error);
            });



    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.schedule')
        .controller('FastAppointmentController', FastAppointmentController);


    /** @ngInject */
    function FastAppointmentController($scope, $q, api, professionalId, $mdToast, $translate,
                             time, date, $rootScope, professionalName, $mdDialog, customerId, $window){
        var vm = this;
        //this._mdPanelRef = mdPanelRef;
        vm.professionalId = professionalId;
        vm.professionalName = professionalName;
        vm.style = {'height':210,'width' : 500 };
        vm.professional = {
            _id : professionalId,
            name : professionalName
        }
        vm.showPdvLocation = false;
        vm.pdvLocations = $rootScope.pdvLocations;
        if (vm.pdvLocations.length > 1){
            vm.showPdvLocation = true;
            vm.pdvLocation = vm.pdvLocations[0].locationId;
        }

        vm.hoje = new moment({
            date: new moment().date(),
            month: new moment().month(),
            year: new moment().year()
        }).add(1, 'days').add(-1, 'seconds');

        vm.date = date;


        if (customerId == null){
            vm.customerId = customerId;

            setTimeout(function(){
                if (document.querySelector('#customer-input') != undefined){
                    document.querySelector('#customer-input').focus();
                }

            },1000)

        } else {
            
            api.customer.save({
                    customerId: customerId
                },
                function(response){
                    vm.customer = response.d;
                    document.querySelector('#service-input').focus();



                },
                function(error){
                    console.log(error);
                });
        }
        vm.newCustomer = newCustomer;
        vm.blockProfessionalSelector = ($rootScope.userType == 'PROFESSIONAL');
        vm.getCustomerInventoryAndCredDeb = getCustomerInventoryAndCredDeb;

        var whenDateMoment = new moment(parseFloat(date));
        var whenDate = new moment({
            year: whenDateMoment.year(),
            month: whenDateMoment.month(),
            date: whenDateMoment.date()
        });
        vm.buttonDisabled = false;
        var whenTime = time * 60 * 1000;
        var when = whenDate.valueOf() + whenTime;
        var whenMoment = new moment(when);

        //configurations
        vm.requestPassword = $rootScope.pdvConfiguration.requestPasswordSchedule;
        if (vm.requestPassword){
            vm.accessCode = "";
            vm.style.height = 300;
        }


        vm.title = "Agendamento com " + professionalName + " - " + whenMoment.format('DD-MM-YYYY HH:mm');

        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({},last);
        $scope.getToastPosition = function() {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function(pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if ( current.bottom && last.top ) current.top = false;
            if ( current.top && last.bottom ) current.bottom = false;
            if ( current.right && last.left ) current.left = false;
            if ( current.left && last.right ) current.right = false;
            last = angular.extend({},current);
        }
        ///END TOAST

        ///professional autocomplete
        vm.professionalSearchText = ""
        vm.professionalSearchTextChange = professionalSearchTextChange;
        vm.professionalSearchItems = [];
        function professionalSearchTextChange(search) {
            var deferred = $q.defer();
            api.serviceProfessionalSearch.save({
                    search : search
                },
                function(response){
                    deferred.resolve( response.d );
                },
                function(error){
                    console.log(error);
                });
            return deferred.promise;
        }

        ///customer autocomplete
        vm.customerNameSearchText = ""
        vm.customerSearchTextChange = customerSearchTextChange;
        vm.customerSearchItems = [];

        /* if ($window.localStorage["cacheCustomers"] != null){
         vm.customers = JSON.parse($window.localStorage["cacheCustomers"]);
         } else {
         vm.customers = [];
         }*/


        function filterForCustomers(query) {
            var uppercaseQuery = angular.uppercase(query);
            return function filterFn(customer) {
                return (customer.name.indexOf(uppercaseQuery) === 0);
            };
        }

        function customerSearchTextChange(query) {

            var results = query ? $rootScope.cacheCustomers.filter( filterForServices(query) ) : $rootScope.cacheCustomers,
                deferred;


            if (results.length > 0){
                return results;
            } else {
                var deferred = $q.defer();
                api.customersSearch.save({
                        searchName : query
                    },
                    function(response){
                        
                        deferred.resolve( response.d );
                    },
                    function(error){
                        console.log(error);
                    });

                return deferred.promise;
            }

        }

        ///service autocomplete
        vm.serviceSearchText = ""
        vm.serviceSearchTextChange = serviceSearchTextChange;
        vm.serviceSearchItems = [];

        /*if ($window.localStorage["cacheServices"] != null){
         vm.services = JSON.parse($window.localStorage["cacheServices"]);
         } else {
         vm.services = [];
         }*/


        /**
         * Create filter function for a query string
         */
        function filterForServices(query) {
            var uppercaseQuery = angular.uppercase(query);
            return function filterFn(service) {
                return (service.name.indexOf(uppercaseQuery) === 0);
            };
        }
        function serviceSearchTextChange (query) {
            var results = query ? $rootScope.cacheServices.filter( filterForServices(query) ) : $rootScope.cacheServices,
                deferred;
            return results;
        }

        /*function serviceSearchTextChange(search) {
         var deferred = $q.defer();
         api.serviceServicesSearch.save({
         search : search
         },
         function(response){
         deferred.resolve( response.d );
         },
         function(error){
         console.log(error);
         });

         return deferred.promise;

         }*/

        vm.submitNewSchedule = function(ev){

            event.stopPropagation();
            if (ev.keyCode == 13){
                if (!$scope.basicForm.$invalid){
                    //submit schedule
                    newServiceRequest();
                    //this._mdPanelRef.hide();
                } else {
                    document.querySelector('#professional-input').focus();
                }

            }
        }
        vm.changeFocusToService = function(ev){
            event.stopPropagation();
            if (ev.keyCode == 13){
                document.querySelector('#service-input').focus();
            }
        }

        vm.saveNewSchedule = function(checkin) {
            newServiceRequest(checkin);
            //this._mdPanelRef.hide();
        }

        

        function newCustomer(){
            $mdDialog.show({
                controller: 'CustomerController',
                controllerAs : 'vm',
                templateUrl: 'app/main/customer/customerDialog.html',
                clickOutsideToClose:true,
                multiple:true,
                escapeToClose : true,
                locals: {
                    customerName: vm.customerSearchText
                },
            })
                .then(function(answer) {
                    vm.customer = answer;
                    document.querySelector('#service-input').focus();
                }, function() {

                });
        }

        function getCustomerInventoryAndCredDeb(){
                        
            if (vm.customer == undefined) return;
            
            api.customer.save({                
                customerId: vm.customer._id                
            },
            function (response) {

                
                if (response.s == 200) {
                    vm.customer.creditDebit = "R$"+ response.d.creditDebit.toFixed(2);
                    vm.customer.inventory = "";

                    for (var i = 0; i < response.d.inventory.length; i++ )
                    {
                        if (i == 0) vm.customer.inventory += response.d.inventory[i] ;
                        else vm.customer.inventory +=  ", " + response.d.inventory[i] ;

                    }

                    //return "Saldo: " + response.d.creditDebit + " | " + response.d.inventory;
                }

            },
            function (error) {
                console.log(error);
            });


        }

        $scope.close = function(){
            $mdDialog.hide();
        }

        function ajusteDataSemDST(dt)
        {
            
            if ((Intl.DateTimeFormat().resolvedOptions().timeZone == 'America/Sao_Paulo') && (dt.getTimezoneOffset() != 180))
            {

                //console.log(dt.getTimezoneOffset());
                
                                            
                //return 1*60*60*1000;
                return 0;
                
            }

            return 0;
        }

        //cadastrando novo request
        function newServiceRequest(checkin) {

            
            if (vm.buttonDisabled) return;
            else vm.buttonDisabled = true;

            var whenDateMoment = new moment(parseFloat(date));
            var whenDate = new moment({
                year: whenDateMoment.year(),
                month: whenDateMoment.month(),
                date: whenDateMoment.date()
            });
            var whenTime = time * 60 * 1000;
            var when = whenDate.valueOf() + whenTime + ajusteDataSemDST(new Date(parseFloat(date)));
            

            if (vm.chkPreference == null){
                vm.chkPreference = false;
            }


            api.saveSchedule.save({
                    checkin: checkin,
                    customerId: vm.customer._id,
                    customerName: vm.customer.name,
                    customerEmail: vm.customer.email,
                    customerTelephone: vm.customer.telephone,
                    serviceId: vm.service._id,
                    serviceName: vm.service.name,
                    serviceDuration: vm.service.duration,
                    serviceValue: vm.service.price,
                    preference: vm.chkPreference,
                    when: when,
                    serviceProfessionalId: vm.professional._id,
                    //serviceProfessionalName: vm.professionalName, //TODO: nao é mais preciso
                    accessCode : vm.accessCode,
                    numberOfRepetition : vm.numberOfRepetition,
                    locationId : vm.pdvLocation
                },
                function (response) {

                    
                    if (response.s != 200) {
                        vm.buttonDisabled = false;
                        if (response.s == 500) {
                            //show toast
                            var pinTo = $scope.getToastPosition();
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent($translate.instant("SCHEDULE.TOAST.SAVE.ERROR_PROFESSIONAL_NOT_ENABLED"))
                                    .hideDelay(10000)
                            );
                        }
                        if (response.s == 402) {
                            //show toast
                            var pinTo = $scope.getToastPosition();
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent($translate.instant("GENERAL.ACCESSCODE.NOT_VALID"))
                                    .hideDelay(1000)
                            );
                        }

                        return;
                    }

                    //registrando metrica no analytics
                    /*
                    $window.ga('send', {
                        hitType: 'event',
                        eventCategory: 'SCHEDULE',
                        eventAction: 'NEW'
                    });
                    */

                    $rootScope.$emit('refreshByProfessionalSchedule', null);
                    $mdDialog.hide();
                    //show toast
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SCHEDULE.TOAST.SAVE.SUCCESS"))
                            .position(pinTo)
                            .hideDelay(1000)
                    );


                },
                function (error) {
                    vm.buttonDisabled = false;
                    console.log(error);
                });

        }

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.schedule')
        .controller('ScheduleController', ScheduleController)



        /** @ngInject */
    function ScheduleController($sce, api, $mdSidenav, $mdDialog, $scope, $translate, $mdToast, $state,$rootScope,
                                $window, DTDefaultOptions, DTOptionsBuilder,$compile,$mdPanel)
    {
        var vm = this;


        vm.tableWidth = $window.innerWidth - 250 - 78;

        vm. refreshPendingSchedules= refreshPendingSchedules;
        vm.openNewScheduleDialogByCategory = openNewScheduleDialogByCategory;
        vm.registerServiceRejection = registerServiceRejection;
        vm.filterdate = new Date();
        vm.reloadByCategory = reloadByCategory;
        vm.selectedDate = new Date();


        switch ($state.current.name){
            case "app.schedule.bycategory":

                loadProfessionals(function(data){
                    vm.professionals = data;
                })

                loadCategories(function(data){
                    vm.categoriesAll = data;
                    vm.chkCategories = [];
                    for(var i=0; i < data.length; i++){
                        vm.chkCategories[data[i]._id] = true;
                    }

                });


                updateDataByCategory(function(){
                    vm.showTable = true;
                })


                break;
            case "app.schedule.pendingschedules":
                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({autoWidth : false})
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable":     "Nenhum registro disponível",
                        "sInfo":           "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty":      "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered":   "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix":    "",
                        "sInfoThousands":  ",",
                        "sLengthMenu":     "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing":     "Processando...",
                        "sSearch":         "Busca:",
                        "sZeroRecords":    "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst":    "Primeiro",
                            "sLast":     "Ultimo",
                            "sNext":     "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending":  ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });

                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                updatePendingSchedules(function(data){
                    vm.pendingSchedules = data;
                    setTimeout(function(){
                        vm.showTable = true;
                        $scope.$apply();
                    },200)

                })
                break;
        }




        // Methods
        function registerServiceRejection(category, time){

            api.serviceRegisterRejection.save({
                    serviceCategory : category,
                    whenMinute : time,
                    whenDate : vm.selectedDate
                },
                function(response){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SCHEDULE.SERVICE_REJECTION.TOAST.SUCCESS"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );

                },
                function(error){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SCHEDULE.SERVICE_REJECTION.TOAST.ERROR"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );

                });
        }

        function refreshPendingSchedules(){
            vm.showTable = false;
            updatePendingSchedules(function(data){
                vm.pendingSchedules = data;
                setTimeout(function(){
                    vm.showTable = true;
                    $scope.$apply();
                },200)

            })
        }

        function updateDataByCategory(callback) {
            api.scheduleByCategory.save({
                    date : vm.selectedDate.valueOf(),
                    html : true
                },
                function(response){
                    vm.html = getByCategoryHTML(response.d.schedule, response.d.serviceCategories);
                    callback();
                },
                function(error){
                    console.log(error);
                });
        }

        function getByCategoryHTML(schedule, serviceCategories){

            var html = "";

            html = "<table cellpadding='0' cellspacing='0' style='margin-top: 0px;width:100%;table-layout: fixed;'>";
            html = html + '<thead>'

            html = html + "<tr style='background-color: lightblue;' height='50px'>";
            html = html + "<th style='max-width:50px;min-width:50px;width:50px;border-right: 1px solid darkgrey;border-bottom: 1px solid darkgrey'></th>";

            for(var i=0; i < serviceCategories.length; i++){
                if (vm.chkCategories[serviceCategories[i]._id]){
                    html = html + "<th align='center' style='font-size:11px;max-width:100px;border-right: 1px solid darkgrey;border-bottom: 1px solid darkgrey;text-align: center'>";
                    html = html + serviceCategories[i].name + '</th>';
                }

            };
            html = html + '</tr></thead>';
            html = html + '<tbody>';


            //rever se lenght vai ser diferente de 0
            for (var property in schedule) {
                if (schedule.hasOwnProperty(property)) {
                    html = html + '<tr style="border:dashed 1px  black;min-height: 30px;height: 30px;">';
                    html = html + '<td style="font-size:11px;border-right: 1px solid darkgrey;border-bottom: 1px dashed darkgrey;text-align: center;background-color: lightgray">'
                    html = html + schedule[property].timeStr + '</td>';

                    for (var categoryId in schedule[property].data  ){


                        if (vm.chkCategories[categoryId]) {
                            if (schedule[property].data[categoryId].data.length > 0) {
                                html = html + '<td width="100px" align="center" style="padding-left:5px; min-width:100px;border-right: 1px solid darkgrey;border-bottom: 1px dashed darkgrey;text-align: left">';

                                for (var professional in  schedule[property].data[categoryId].data) {
                                    html = html + '<a href="#" style="font-size:11px" ng-click="vm.openNewScheduleDialogByCategory(\'' + schedule[property].data[categoryId].data[professional]._id + '\',' + schedule[property].time + ' )">';
                                    html = html + schedule[property].data[categoryId].data[professional].name + '</a><br>';
                                }
                            } else {
                                html = html + '<td width="100px" ng-click="registerServiceRejection(\'' + categoryId + '\', ' + schedule[property].time + ')" align="center" style="padding-left:5px; min-width:100px;border-right: 1px solid darkgrey;border-bottom: 1px dashed darkgrey;text-align: left; background-color: LightBlue">';


                            }


                            html = html + '</td>';
                        }
                    }

                    html = html + '</tr>'
                }
            }


            html = html + '</tbody>';

            html = html + '</table>';

            return html;
        }

        function reloadByCategory(){
            updateDataByCategory(function(data){
            })

        }

        function updatePendingSchedules(callback){
            api.pendingServiceRequest.save({

                },
                function(response){
                    callback(response.d);
                },
                function(error){
                    console.log(error);
                });
        }

        function openNewScheduleDialogByCategory(professionalId, whenTime){
            var professional = {};
            for(var i=0; i < vm.professionals.length; i++){
                if (vm.professionals[i]._id == professionalId){
                    professional = vm.professionals[i];
                    break;
                }
            }

            console.log(whenTime);

            $mdDialog.show({
                controller: 'NewScheduleController',
                controllerAs       : 'vm',
                locals : {
                    professional : professional,
                    customer : null,
                    whenTime : whenTime + "",
                    whenDate : vm.filterdate,
                    id:null
                },
                templateUrl: 'app/main/schedule/newSchedule/newSchedule.html',
                clickOutsideToClose:true
            })
                .then(function(answer) {

                }, function() {
                    switch ($state.current.name) {
                        case "app.schedule.byprofessional":
                            updateContent(function(data){

                            });
                            break;
                        case "app.schedule.bycategory":
                            vm.showTable = true;
                            updateDataByCategory(function(data){
                                vm.schedule = data;
                                vm.showTable = true;
                            })
                            break;

                    }

                });
        }

        //load professionals
        function loadProfessionals(callback){
            var dtBefore = new Date();
            api.serviceProfessionals.save({
                },
                function(response){
                    var arTemp = [];
                    for(var i=0; i < response.d.length; i++){
                        var obj = response.d[i];
                        obj.index = i;
                        arTemp.push(obj);
                    }
                    var dtAfter = new Date();
                    callback(arTemp);
                },
                function(error){
                    console.log(error);
                });
        }

        //load categories
        function loadCategories(callback){
            api.serviceCategories.save({
                },
                function(response){
                    callback(response.d);
                },
                function(error){
                    console.log(error);
                });
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.schedule')
        .controller('ScheduleByProfessionalController2', ScheduleByProfessionalController)
        .controller('PanelMenuCtrl', PanelMenuCtrl);

    /** @ngInject */
    function PanelMenuCtrl(mdPanelRef, $mdDialog, $rootScope, api, $mdToast, $translate) {
        var vm = this;
        vm.newAppointment = newAppointment;
        vm.blockSchedule = blockSchedule;
        vm.checkin = checkin;
        vm.cancelCheckin = cancelCheckin;
        vm.noshow  =noshow;
        vm.cancel = cancel;
        vm.reschedule = reschedule;
        this._mdPanelRef = mdPanelRef;

        //////
        function newAppointment(professionalId, time, date) {

            this._mdPanelRef && this._mdPanelRef.close().then(function () {
                api.serviceProfessional.save({
                        professionalId : professionalId
                    },
                    function(response){
                        var filterDate = new Date(date);
                        openNewScheduleDialog(response.d, null, time, filterDate);
                    },
                    function(error){
                        console.log(error);
                    });

            });
        }

        function blockSchedule(professionalId, whenTime, whenDate){
            this._mdPanelRef && this._mdPanelRef.close().then(function () {
                var mWhenDate = new moment(whenDate);
                var periodFrom = new moment({
                    year: mWhenDate.year(),
                    month: mWhenDate.month(),
                    date: mWhenDate.date()
                })
                var nPeriodFrom = periodFrom.valueOf() + (whenTime * 60 * 1000);

                api.serviceProfessional.save({
                        professionalId: professionalId
                    },
                    function (response) {

                        api.saveProfessionalBlock.save({
                                reason: 'Bloqueado por usuário',
                                professionalId: response.d._id,
                                periodFrom: nPeriodFrom,
                                periodTo: nPeriodFrom + (15 * 60 * 1000), //um spot
                                timeFrom: whenTime,
                                timeTo: whenTime + 15,
                                weekDay: mWhenDate.weekday(),
                                type: 'PERIOD'
                            },
                            function (response) {
                                $rootScope.$emit('refreshByProfessionalSchedule', null);
                            },
                            function (error) {
                                console.log(error);
                            });
                    },
                    function (error) {
                        console.log(error);
                    });
            });


        }

        //register checkin
        function checkin(requestId){
            this._mdPanelRef && this._mdPanelRef.close().then(function () {

                api.requestCheckin.save({
                        requestId: requestId
                    },
                    function (response) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SCHEDULE.BYPROFESSIONAL.TOAST.CHECKIN.SUCCESS"))
                                .hideDelay(1000)
                        );

                        $rootScope.$emit('refreshByProfessionalSchedule', null);

                    }, function (error) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SCHEDULE.BYPROFESSIONAL.TOAST.CHECKIN.ERROR"))
                                .hideDelay(1000)
                        );

                        $rootScope.$emit('refreshByProfessionalSchedule', null);

                    })

            });

        }
        //register cancel checkin
        function cancelCheckin(requestId){
            this._mdPanelRef && this._mdPanelRef.close().then(function () {

                api.requestCancelCheckin.save({
                        requestId: requestId
                    },
                    function (response) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SCHEDULE.BYPROFESSIONAL.TOAST.CANCEL_CHECKIN.SUCCESS"))
                                .hideDelay(1000)
                        );

                        $rootScope.$emit('refreshByProfessionalSchedule', null);

                    }, function (error) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SCHEDULE.BYPROFESSIONAL.TOAST.CANCEL_CHECKIN.ERROR"))
                                .hideDelay(1000)
                        );

                        $rootScope.$emit('refreshByProfessionalSchedule', null);

                    })

            });

        }
        //noshow
        function noshow(requestId){
            this._mdPanelRef && this._mdPanelRef.close().then(function () {
                api.requestNoShow.save({
                        requestId: requestId
                    },
                    function (response) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SCHEDULE.BYPROFESSIONAL.TOAST.NOSHOW.SUCCESS"))
                                .hideDelay(1000)
                        );
                        $rootScope.$emit('refreshByProfessionalSchedule', null);
                    }, function (error) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SCHEDULE.BYPROFESSIONAL.TOAST.NOSHOW.ERROR"))
                                .hideDelay(1000)
                        );
                        $rootScope.$emit('refreshByProfessionalSchedule', null);
                    })
            });

        }
        //cancel
        function cancel(requestId){
            this._mdPanelRef && this._mdPanelRef.close().then(function () {
                api.requestCancel.save({
                        requestId: requestId
                    },
                    function (response) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SCHEDULE.BYPROFESSIONAL.TOAST.CANCEL.SUCCESS"))
                                .hideDelay(1000)
                        );
                        $rootScope.$emit('refreshByProfessionalSchedule', null);
                    }, function (error) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SCHEDULE.BYPROFESSIONAL.TOAST.CANCEL.ERROR"))
                                .hideDelay(1000)
                        );
                        $rootScope.$emit('refreshByProfessionalSchedule', null);
                    })
            });

        }
        //reschedule
        function reschedule(id){
            this._mdPanelRef && this._mdPanelRef.close().then(function () {
                $mdDialog.show({
                    controller: 'NewScheduleController',
                    controllerAs: 'vm',
                    locals: {
                        professional: null,
                        customer: null,
                        whenTime: null,
                        whenDate: null,
                        id: id
                    },
                    templateUrl: 'app/main/schedule/newSchedule/newSchedule.html',
                    clickOutsideToClose: false,
                    clickEscapetoClose : true
                })
                    .then(function (answer) {
                        $rootScope.$emit('refreshByProfessionalSchedule', null);
                    }, function () {
                        $rootScope.$emit('refreshByProfessionalSchedule', null);
                    });
            });
        }
        //novo agendamento
        function openNewScheduleDialog (professional, customer, whenTime, whenDate) {
            $mdDialog.show({
                controller: 'NewScheduleController',
                controllerAs: 'vm',
                locals: {
                    professional: professional,
                    customer: customer,
                    whenTime: whenTime,
                    whenDate: whenDate,
                    id: null
                },
                templateUrl: 'app/main/schedule/newSchedule/newSchedule.html',
                clickOutsideToClose: false
            })
                .then(function (answer) {
                    $rootScope.$emit('refreshByProfessionalSchedule', null);
                }, function () {
                    $rootScope.$emit('refreshByProfessionalSchedule', null);
                });
        }

    }

        /** @ngInject */
    function ScheduleByProfessionalController($sce, api, $mdSidenav, $mdDialog, $scope, $translate, $mdToast, $state,$rootScope,
                                $window, DTDefaultOptions, DTOptionsBuilder,$compile,$mdPanel)
    {
        var vm = this;
        this._mdPanel = $mdPanel;
        vm.tableWidth = $window.innerWidth - 250 - 78;
        vm.filterdate = new Date();
        vm.reload = reload;
        vm.selectedDate = new Date();
        vm.showMenuBusy = showMenuBusy;
        vm.showMenuNotBusy = showMenuNotBusy;
        vm.showMenuCheckedIn = showMenuCheckedIn;
        vm.previousDate = function(){
            var temp = new moment(vm.selectedDate.valueOf());
            temp = temp.add(-1, 'd');
             vm.selectedDate = new Date(temp.valueOf());
            reload();
        }
        vm.nextDate = function(){
            var temp = new moment(vm.selectedDate.valueOf());
            temp = temp.add(1, 'd');
            vm.selectedDate = new Date(temp.valueOf());
            reload();
        }


        // Loading professioanals

        loadProfessionals(function(data){
            vm.professionals = data;
            vm.professionalsAll = data;
            vm.chkProf = [];
            for(var i=0; i < data.length; i++){
                vm.chkProf[data[i]._id] = true;
            }
            if (vm.professionals.length * 100 > vm.tableWidth){
                vm.colSize = 100;
            } else {
                vm.colSize = vm.tableWidth / vm.professionals.length;
            }

            //Loading timetable
            loadTimeTable(function(data){
                vm.timetable = data;
            })

            vm.showTable = false;

            console.log(new Date())
            updateContent(function(data){
                console.log(new Date())
                vm.showTable = true;
                vm.html = getHTMLByProfessional(data);
                console.log(new Date())
            });

        })





        // Methods
        $scope.trustAsHtml = function(string) {
            return $sce.trustAsHtml(string);
        };

        function showMenuBusy(ev, id, requestId, professionalId, professionalName, time, timeStr) {

            var position = this._mdPanel.newPanelPosition()
                .relativeTo('.busy-div_' + id)
                .addPanelPosition(this._mdPanel.xPosition.ALIGN_START, this._mdPanel.yPosition.BELOW);

            var config = {
                attachTo: angular.element(document.body),
                controller: PanelMenuCtrl,
                controllerAs: 'ctrl',
                template:
                '<div class="demo-menu-example" ' +
                '     aria-label="Select your option" ' +
                '     role="listbox">' +
                '  <div class="demo-menu-item" ' +
                '       aria-selected="OPTION" ' +
                '       tabindex="-1" ' +
                '       role="option" ' +
                '       ng-click="ctrl.checkin(\'' + requestId + '\')">' +
                '    Cliente chegou' +
                '  </div>' +
                '  <div class="demo-menu-item" ' +
                '       aria-selected="OPTION" ' +
                '       tabindex="-1" ' +
                '       role="option" ' +
                '       ng-click="ctrl.cancel(\'' + requestId  +'\')">' +
                '    Cliente cancelou' +
                '  </div>' +
                '  <div class="demo-menu-item" ' +
                '       aria-selected="OPTION" ' +
                '       tabindex="-1" ' +
                '       role="option" ' +
                '       ng-click="ctrl.reschedule(\'' + requestId + '\')">' +
                '    Cliente quer reagendar' +
                '  </div>' +
                '  <div class="demo-menu-item" ' +
                '       aria-selected="OPTION" ' +
                '       tabindex="-1" ' +
                '       role="option" ' +
                '       ng-click="ctrl.noshow(\'' + requestId + '\')">' +
                '    Cliente não apareceu' +
                '  </div>' +

                '<md-divider></md-divider>' +
                '  <div class="demo-menu-item" ' +
                '       aria-selected="OPTION" ' +
                '       tabindex="-1" ' +
                '       role="option" ' +
                '       ng-click="ctrl.newAppointment(\'' + professionalId + '\', ' + time +',' + vm.filterdate.valueOf() + ')">' +
                '    Agendar com ' + professionalName + ' as ' + timeStr +
                '  </div>' +

                '</div>',
                panelClass: 'demo-menu-example',
                position: position,
                locals: {

                },
                openFrom: ev,
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: false,
                zIndex: 2
            };

            this._mdPanel.open(config);
            event.stopPropagation();
        };

        function showMenuNotBusy(ev, id, professionalId, professionalName, time, timeStr) {

            var position = this._mdPanel.newPanelPosition()
                .relativeTo('.demo-menu-open-button_' + id)
                .addPanelPosition(this._mdPanel.xPosition.ALIGN_START, this._mdPanel.yPosition.BELOW);

            var config = {
                attachTo: angular.element(document.body),
                controller: PanelMenuCtrl,
                controllerAs: 'ctrl',
                template:
                '<div class="demo-menu-example" ' +
                '     aria-label="Select your option" ' +
                '     role="listbox">' +
                '  <div class="demo-menu-item" ' +
                '       aria-selected="OPTION" ' +
                '       tabindex="-1" ' +
                '       role="option" ' +
                '       ng-click="ctrl.newAppointment(\'' + professionalId + '\', ' + time +',' + vm.filterdate.valueOf() + ')">' +
                '    Agendar com ' + professionalName + ' as ' + timeStr +
                '  </div>' +
                    '<md-divider></md-divider>' +
                '  <div class="demo-menu-item" ' +
                '       aria-selected="OPTION" ' +
                '       tabindex="-1" ' +
                '       role="option" ' +
                '       ng-click="ctrl.blockSchedule(\'' + professionalId + '\', ' + time +',' + vm.filterdate.valueOf() + ')">' +
                '    Bloquear Horário ' + professionalName + ' as ' + timeStr +
                '  </div>' +
                '</div>',
                panelClass: 'demo-menu-example',
                position: position,
                locals: {

                },
                openFrom: ev,
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: false,
                zIndex: 2
            };

            this._mdPanel.open(config);
            event.stopPropagation();
        };

        function showMenuCheckedIn(ev, id, requestId, professionalId, professionalName, time, timeStr) {

            var position = this._mdPanel.newPanelPosition()
                .relativeTo('.busy-div_' + id)
                .addPanelPosition(this._mdPanel.xPosition.ALIGN_START, this._mdPanel.yPosition.BELOW);

            var config = {
                attachTo: angular.element(document.body),
                controller: PanelMenuCtrl,
                controllerAs: 'ctrl',
                template:
                '<div class="demo-menu-example" ' +
                '     aria-label="Select your option" ' +
                '     role="listbox">' +
                '  <div class="demo-menu-item" ' +
                '       aria-selected="OPTION" ' +
                '       tabindex="-1" ' +
                '       role="option" ' +
                '       ng-click="ctrl.cancelCheckin(\'' + requestId + '\')">' +
                '    Ops, o cliente ainda não chegou' +
                '  </div>' +
                '<md-divider></md-divider>' +
                '  <div class="demo-menu-item" ' +
                '       aria-selected="OPTION" ' +
                '       tabindex="-1" ' +
                '       role="option" ' +
                '       ng-click="ctrl.newAppointment(\'' + professionalId + '\', ' + time +',' + vm.filterdate.valueOf() + ')">' +
                '    Agendar com ' + professionalName + ' as ' + timeStr +
                '  </div>' +

                '</div>',
                panelClass: 'demo-menu-example',
                position: position,
                locals: {

                },
                openFrom: ev,
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: false,
                zIndex: 2
            };

            this._mdPanel.open(config);
            event.stopPropagation();
        };

        function getHTMLByProfessional(schedule){
            var id = 0;

            var html = "";
            html = html + '<table cellpadding="0" cellspacing="0" style="width:100%">';
            html = html + '<thead >';
            html = html + '<tr style="background-color: white;" height="50px" >';
            html = html + '<th style="max-width:50px;min-width:50px;width:50px;border-right: 1px solid lightgrey;border-bottom: 1px solid darkgrey"></th>';

            for(var i=0; i < vm.professionals.length; i++){
                if (vm.chkProf[vm.professionals[i]._id]){
                    html = html + '<th  align="center" style="min-width:100px;border-right: 1px solid lightgray;border-bottom: 1px solid darkgrey;text-align: center;color:Gray">';
                    html = html + vm.professionals[i].name;
                    html = html + "</th>";
                }
            }


            html = html + '</tr>';
            html = html + '</thead>';
            html = html + '<tbody>';
            for(var i=0; i < vm.timetable.length; i++){
                html = html + '<tr style="height: 30px;">';

                var borderBottom = '';

                if ((vm.timetable[i].timeStr.indexOf(':15') == -1) && (vm.timetable[i].timeStr.indexOf('45') == -1)){
                    borderBottom = '0px dashed darkgrey';
                } else {
                    borderBottom = '1px solid rgba(0, 0, 0, .1)';
                }

                html = html + '<td valign="top" style="max-width:50px;min-width:50px;width:50px;font-size:13px; border-right: 2px solid darkgrey;border-bottom: ' +  borderBottom  + ' ;text-align: right;background-color: white; padding-right:3px;" >';
                if ((vm.timetable[i].timeStr.indexOf(':15') == -1) && (vm.timetable[i].timeStr.indexOf('45') == -1)){
                    html = html + vm.timetable[i].timeStr;
                }
                html = html + '</td>';

                for(var p=0 ; p < vm.professionals.length; p++){
                    if (vm.chkProf[vm.professionals[p]._id]) {
                        var backgroundColor = '';
                        if ((schedule[vm.professionals[p]._id] == undefined) ||
                            (schedule[vm.professionals[p]._id][vm.timetable[i].time] == undefined) ||
                            (schedule[vm.professionals[p]._id][vm.timetable[i].time].status == undefined) ||
                            (schedule[vm.professionals[p]._id][vm.timetable[i].time].status == 'BUSY')) {
                            backgroundColor = 'background-color:rgba(255,152,0,0.1)';
                        } else {
                            //backgroundColor = 'background-color:#9BCFE6';

                            backgroundColor = "background-image: url('/assets/images/backgrounds/schedule.png');"
                        }
                        id = id + 1;




                        if ((vm.timetable[i].timeStr.indexOf(':15') == -1) && (vm.timetable[i].timeStr.indexOf('45') == -1)){
                            borderBottom = '0px dashed darkgrey';
                        } else {
                            borderBottom = '1px solid rgba(0, 0, 0, .1); ';
                        }



                        html = html + '<td ng-click="vm.showMenuNotBusy($event, ' + id + ', \'' + vm.professionals[p]._id + '\',\'' + vm.professionals[p].name + '\','
                            + vm.timetable[i].time + ',\'' + vm.timetable[i].timeStr + '\' )" class="demo-menu-open-button_' + id + '" style="min-width:100px;border-right: 1px dashed rgba(0, 0, 0, .1);border-bottom: ' + borderBottom + ';' + backgroundColor + '; ">';


                        html = html + '<div  style="position:relative;margin-top: 0px;" >';

                        if ((schedule[vm.professionals[p]._id][vm.timetable[i].time] == undefined) ) {
                            html = html + '<div style="margin-left: 2px;height:30px"  >';
                            html = html + '</div>';
                        } else {
                            for (var d = 0; d < schedule[vm.professionals[p]._id][vm.timetable[i].time].data.length; d++) {
                                var busyBackgroundColor = 'blue';
                                var menuAction = "";
                                switch (schedule[vm.professionals[p]._id][vm.timetable[i].time].data[d].status) {
                                    case "CHECKIN":
                                        busyBackgroundColor = 'green';
                                        menuAction = "showMenuCheckedIn";
                                        break;
                                    case "CHECKOUT":
                                        busyBackgroundColor = 'purple';
                                        menuAction = "showMenuCheckedOut";
                                        break;
                                    default:
                                        busyBackgroundColor = 'blue';
                                        menuAction = "showMenuBusy";
                                        break;
                                }


                                var vWidth = 99 / schedule[vm.professionals[p]._id][vm.timetable[i].time].data.length + '%';
                                var vHeight = 30 * schedule[vm.professionals[p]._id][vm.timetable[i].time].data[d].slotSize;
                                var vMarginLeft = ((vm.colSize / schedule[vm.professionals[p]._id][vm.timetable[i].time].data.length)
                                    * (schedule[vm.professionals[p]._id][vm.timetable[i].time].data[d].index)) - 0
                                var html2 = '';
                                html2 = html2 + '<div class="busy-div_' + id + '" style="position: absolute;' +
                                    'opacity: 0.9;' +
                                    'border: 1px solid white;' +
                                    'background-color: ' + busyBackgroundColor + ';' +
                                    'margin-left:' + vMarginLeft + 'px;' +
                                    'margin-top: -15px;' +
                                    'width: ' + vWidth + ';' +
                                    'height: ' + vHeight + 'px;' +
                                    'border-radius: 5px;" ' +
                                    'ng-click="vm.' + menuAction + '($event,' + id + ',\'' + schedule[vm.professionals[p]._id][vm.timetable[i].time].data[d]._id + '\'' + ', \'' + vm.professionals[p]._id + '\',\'' + vm.professionals[p].name + '\','
                                    + vm.timetable[i].time + ',\'' + vm.timetable[i].timeStr + '\')">';
                                html2 = html2 + '<span style="color:white;font-weight: normal;font-size:10px;" >';
                                html2 = html2 + schedule[vm.professionals[p]._id][vm.timetable[i].time].data[d].customerName;
                                html2 = html2 + '</span><br>'
                                html2 = html2 + '<span href="#" style="color:white;font-size:10px">';
                                html2 = html2 + schedule[vm.professionals[p]._id][vm.timetable[i].time].data[d].serviceName;
                                html2 = html2 + '</span>';
                                html2 = html2 + '</div>';

                                html = html + html2;


                            }
                        }


                        html = html + '</td>'
                    }

                }
                html = html + '</tr>';
            }

            html = html + '</tbody>';
            html = html + '</table>';


            return html;



        }

        vm.updateFilter = function () {
            vm.html = getHTMLByProfessional(vm.schedule);
        }

        ///EVENTOS
        $rootScope.$on('refreshByProfessionalSchedule', function(event, args) {

            loadContent(function (data){
                vm.html = {};
                vm.html = getHTMLByProfessional(data);
            })
        });


        function reload(){
           $rootScope.$emit('refreshByProfessionalSchedule', null);
        }


        //load professionals
        function loadProfessionals(callback){
            api.serviceProfessionals.save({
                },
                function(response){
                    var arTemp = [];
                    for(var i=0; i < response.d.length; i++){
                        var obj = response.d[i];
                        obj.index = i;
                        arTemp.push(obj);
                    }
                    callback(arTemp);
                },
                function(error){
                    console.log(error);
                });
        }

        //load timetable
        function loadTimeTable(callback){
            var arTemp = [];
            for(var i=480; i < 1320; i = i + 15){
                var hour = parseInt(i/60);
                if (hour < 10){
                    hour = "0" + hour;
                }

                var minute = i - (hour * 60);

                if (minute < 10){
                    minute = "0" + minute;
                }



                var obj = {
                    time : i,
                    timeStr : hour + ":" + minute,
                    monday : true,
                    tuesday : true,
                    wednesday : true,
                    thursday : true,
                    friday : true,
                    saturday : true,
                    sunday : true,
                }
                arTemp.push(obj);
            }

            callback(arTemp);
        }

        //load schedule
        function loadContent(callback){
            Date.prototype.stdTimezoneOffset = function() {
                var jan = new Date(this.getFullYear(), 0, 1);
                var jul = new Date(this.getFullYear(), 6, 1);
                return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
            }



            Date.prototype.dst = function() {
                return this.getTimezoneOffset() < this.stdTimezoneOffset();
            }

            var date = new Date();
            var ServerDifferenceMinutes = -date.getTimezoneOffset();

            console.log(ServerDifferenceMinutes);

            api.scheduleByPDV.save({
                    date : vm.selectedDate.valueOf(),
                    timeZone :  ServerDifferenceMinutes
                },
                function(response){
                    callback(response.d);
                }, function(error){
                    console.log(error);
                })

        }



        //iupdate content
        function updateContent(callback){
            //loading content
            loadContent(function (data){
                vm.schedule = data;
                callback(data);
            })

        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.schedule')
        .controller('ScheduleByProfessionalController', ScheduleByProfessionalController)
        .controller('PanelMenuCtrl', PanelMenuCtrl);



    function PanelMenuCtrl(mdPanelRef, $mdDialog, $rootScope, api, $mdToast, $translate, $mdPanel, $scope, $state) {
        var vm = this;
        vm.newAppointment = newAppointment;
        vm.newFastAppointment = newFastAppointment;
        vm.viewAppointment = viewAppointment;
        vm.blockSchedule = blockSchedule;
        vm.checkin = checkin;
        vm.transferAppointment = transferAppointment;
        vm.cancelCheckin = cancelCheckin;
        vm.noshow  =noshow;
        vm.cut = cut;
        vm.removeSchedule = removeSchedule;
        vm.cancel = cancel;
        vm.removeSchedule = removeSchedule;
        vm.copyCustomer = copyCustomer;
        vm.pasteCustomer  = pasteCustomer;
        vm.sendNoShowSMS = sendNoShowSMS;
        vm.unblockSchedule = unblockSchedule;
        vm.customerHistory = customerHistory;
        vm.undoNoShow = undoNoShow;

        vm.reschedule = reschedule;
        this._mdPanelRef = mdPanelRef;
        vm._mdPanel = $mdPanel;

        //////
        function customerHistory(customerId){
            this._mdPanelRef && this._mdPanelRef.close().then(function () {
                $state.go('app.customer.history', {customerId: customerId});
            })
        }

        function sendNoShowSMS(requestId, customerId){


            this._mdPanelRef && this._mdPanelRef.close().then(function () {

                api.serviceRequest.save({
                        requestId : requestId
                    },
                    function(response){
                        
                        var when = new moment(response.d.when);
                        var message = "";
                        var name = response.d.customerName.split(" ")[0];
                        var pdvName = $rootScope.pdvName;
                        message = "Ola " + name + ", voce tem um agendamento no " +
                            pdvName + " em " + when.format("DD/MM") + " as " + when.format("HH:mm") +
                            " caso nao possa comparecer clique aqui http://c.styp.us/i=" + requestId;

                        api.sendSMS.save({
                                message : message,
                                customerId : customerId
                            },
                            function(response){
                                $mdToast.show(
                                    $mdToast.simple()
                                        .textContent($translate.instant("MARKETING.MESSAGE.REMINDER.SUCCESS"))
                                        .hideDelay(1000)
                                );
                            },
                            function(error){
                                console.log(error);
                            });

                    },
                    function(error){
                        console.log(error);
                    });


            });
        }

        function cut(requestId){
            this._mdPanelRef && this._mdPanelRef.close().then(function () {
                $rootScope.lastCutRequestId = requestId;
                
            });
        }
        function copyCustomer(customerId){
            this._mdPanelRef && this._mdPanelRef.close().then(function () {
                $rootScope.lastCopyCustomerId = customerId;
            });
        }
        function pasteCustomer(professionalId, time, date, professionalName){

            this._mdPanelRef && this._mdPanelRef.close().then(function () {
                $mdDialog.show({
                    controller: 'FastAppointmentController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/schedule/fastAppointment.html',
                    parent: angular.element(document.body),
                    targetEvent: null,
                    multiple: true,
                    clickOutsideToClose: true,
                    zIndex: 1,
                    locals: {
                        professionalId: professionalId,
                        professionalName: professionalName,
                        time: time,
                        date: date,
                        customerId: $rootScope.lastCopyCustomerId
                    },
                    escapeToClose: true,
                    focusOnOpen: true
                })
                    .then(function (answer) {


                    }, function () {

                    });
            });



        }

        function removeSchedule(professionalId, time, date, serviceId){

            this._mdPanelRef && this._mdPanelRef.close().then(function () {

            });



        }

        function ajusteDataSemDST(dt)
        {
            
            if ((Intl.DateTimeFormat().resolvedOptions().timeZone == 'America/Sao_Paulo') && (dt.getTimezoneOffset() != 180))
            {

                                            
                //return 1*60*60*1000;
                return 0;
                
                
            }

            return 0;
        }

        function transferAppointment(professionalId, time, date, serviceId){

            this._mdPanelRef && this._mdPanelRef.close().then(function () {
                if ($rootScope.lastCutRequestId != null){

                    var whenDateMoment = new moment(parseFloat(date));
                    var whenDate = new moment({
                        year: whenDateMoment.year(),
                        month: whenDateMoment.month(),
                        date: whenDateMoment.date()
                    });
                    var whenTime = time * 60 * 1000;
                    var when = whenDate.valueOf() + whenTime + ajusteDataSemDST(new Date(parseFloat(date)));

                    api.updateSchedule.save({
                            requestId  :$rootScope.lastCutRequestId,
                            when : when,
                            serviceProfessionalId : professionalId
                        },
                        function(response){
                            //show toast

                            if (response.s != 200){
                                $mdToast.show(
                                    $mdToast.simple()
                                        .textContent($translate.instant("SCHEDULE.BYPROFESSIONAL.TOAST.TRANSFER.ERROR"))
                                        .hideDelay(1000)
                                );


                                return;
                            }

                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent($translate.instant("SCHEDULE.BYPROFESSIONAL.TOAST.TRANSFER.SUCCESS"))
                                    .hideDelay(1000)
                            );

                            $rootScope.$emit('refreshByProfessionalSchedule', null);



                        },
                        function(error){
                            console.log(error);
                        });


                    $rootScope.lastCutRequestId = null;
                }

            });

        }

        function undoNoShow(scheduleId){
            this._mdPanelRef && this._mdPanelRef.close().then(function () {

                api.requestUndoNoShow.save({
                        requestId : scheduleId
                    },
                    function(response){
                        //show toast

                        if (response.s != 200){
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent($translate.instant("SCHEDULE.BYPROFESSIONAL.TOAST.UNDONOSHOW.ERROR"))
                                    .hideDelay(1000)
                            );


                            return;
                        }

                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SCHEDULE.BYPROFESSIONAL.TOAST.UNDONOSHOW.SUCCESS"))
                                .hideDelay(1000)
                        );

                        $rootScope.$emit('refreshByProfessionalSchedule', null);



                    },
                    function(error){
                        console.log(error);
                    });

            });
        }

        function viewAppointment(scheduleId) {

            this._mdPanelRef && this._mdPanelRef.close().then(function () {
                $mdDialog.show({
                    controller: 'ViewAppointmentController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/schedule/viewAppointment.html',
                    parent: angular.element(document.body),
                    targetEvent: null,
                    multiple: true,
                    clickOutsideToClose: true,
                    zIndex: 1,
                    locals: {
                        scheduleId : scheduleId
                    },
                    escapeToClose: true,
                    focusOnOpen: true
                })
                    .then(function (answer) {


                    }, function () {

                    });
            });



        }


        function newFastAppointment(professionalId, time, date, professionalName, customerId) {

            this._mdPanelRef && this._mdPanelRef.close().then(function () {
                $mdDialog.show({
                    controller: 'FastAppointmentController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/schedule/fastAppointment.html',
                    parent: angular.element(document.body),
                    targetEvent: null,
                    multiple: true,
                    clickOutsideToClose: true,
                    zIndex: 1,
                    locals: {
                        professionalId: professionalId,
                        professionalName: professionalName,
                        time: time,
                        date: date,
                        customerId: null
                    },
                    escapeToClose: true,
                    focusOnOpen: true
                })
                    .then(function (answer) {


                    }, function () {

                    });
            });



        }

        function newAppointment(professionalId, time, date) {

            this._mdPanelRef && this._mdPanelRef.close().then(function () {
                api.serviceProfessional.save({
                        professionalId : professionalId
                    },
                    function(response){

                        var filterDate = new Date(date);


                        openNewScheduleDialog(response.d, null, time, filterDate);
                    },
                    function(error){
                        console.log(error);
                    });

            });
        }

        function blockSchedule(professionalId, professionalName, whenTime, whenDate){


            this._mdPanelRef && this._mdPanelRef.close().then(function () {
                var mWhenDate = new moment(whenDate);
                var periodFrom = new moment({
                    year: mWhenDate.year(),
                    month: mWhenDate.month(),
                    date: mWhenDate.date()
                })
                var nPeriodFrom = periodFrom.valueOf() + (whenTime * 60 * 1000);

                //abrir panel de bloqueio
                $mdDialog.show({
                    controller: 'BlockDialogCtrl',
                    controllerAs: 'vm',
                    locals:{
                        professionalId : professionalId,
                        professionalName : professionalName,
                        time : whenTime,
                        date : whenDate
                    },
                    templateUrl: 'app/main/schedule/newBlock.html',
                    clickOutsideToClose: true
                })
                    .then(function (answer) {

                    }, function () {
                        //newSchedule();
                    });

            });


        }

        function unblockSchedule(blockId){


            this._mdPanelRef && this._mdPanelRef.close().then(function () {


                api.removeProfessionalBlock.save({
                        _id: blockId
                    },
                    function (response) {
                        $rootScope.$emit('refreshByProfessionalSchedule', null);
                    },
                    function (error) {
                        console.log(error);
                    });

            });


        }

        //register checkin
        function checkin(requestId){
            this._mdPanelRef && this._mdPanelRef.close().then(function () {

                api.requestCheckin.save({
                        requestId: requestId
                    },
                    function (response) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SCHEDULE.BYPROFESSIONAL.TOAST.CHECKIN.SUCCESS"))
                                .hideDelay(1000)
                        );

                        $rootScope.$emit('refreshByProfessionalSchedule', null);

                    }, function (error) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SCHEDULE.BYPROFESSIONAL.TOAST.CHECKIN.ERROR"))
                                .hideDelay(1000)
                        );

                        $rootScope.$emit('refreshByProfessionalSchedule', null);

                    })

            });

        }
        //register cancel checkin
        function cancelCheckin(requestId){
            this._mdPanelRef && this._mdPanelRef.close().then(function () {

                api.requestCancelCheckin.save({
                        requestId: requestId
                    },
                    function (response) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SCHEDULE.BYPROFESSIONAL.TOAST.CANCEL_CHECKIN.SUCCESS"))
                                .hideDelay(1000)
                        );

                        $rootScope.$emit('refreshByProfessionalSchedule', null);

                    }, function (error) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SCHEDULE.BYPROFESSIONAL.TOAST.CANCEL_CHECKIN.ERROR"))
                                .hideDelay(1000)
                        );

                        $rootScope.$emit('refreshByProfessionalSchedule', null);

                    })

            });

        }
        //noshow
        function noshow(requestId){
            this._mdPanelRef && this._mdPanelRef.close().then(function () {
                api.requestNoShow.save({
                        requestId: requestId
                    },
                    function (response) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SCHEDULE.BYPROFESSIONAL.TOAST.NOSHOW.SUCCESS"))
                                .hideDelay(1000)
                        );
                        $rootScope.$emit('refreshByProfessionalSchedule', null);
                    }, function (error) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SCHEDULE.BYPROFESSIONAL.TOAST.NOSHOW.ERROR"))
                                .hideDelay(1000)
                        );
                        $rootScope.$emit('refreshByProfessionalSchedule', null);
                    })
            });

        }

        //remove
        function removeSchedule(requestId){
           
            this._mdPanelRef && this._mdPanelRef.close().then(function () {
                api.removeSchedule.save({
                        requestId: requestId
                    },
                    function (response) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SCHEDULE.BYPROFESSIONAL.TOAST.REMOVE.SUCCESS"))
                                .hideDelay(1000)
                        );
                        $rootScope.$emit('refreshByProfessionalSchedule', null);
                    }, function (error) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SCHEDULE.BYPROFESSIONAL.TOAST.REMOVE.ERROR"))
                                .hideDelay(1000)
                        );
                        $rootScope.$emit('refreshByProfessionalSchedule', null);
                    })
            });

        }

        //cancel
        function cancel(requestId){
            this._mdPanelRef && this._mdPanelRef.close().then(function () {
                /*//check for another insert
                var confirm = $mdDialog.confirm()
                    .title('Cancelar serviços')
                    .textContent('Deseja cancelar todos os serviços do cliente no dia de hoje além do serviço selecionado?')
                    .ariaLabel('Lucky day')
                    .multiple(true)
                    .clickOutsideToClose(true)
                    .parent(angular.element(document.body))
                    .ok('Sim')
                    .cancel('Não');
                $mdDialog.show(confirm).then(function() {
                    api.requestCancel.save({
                            requestId: requestId,
                            cancelMultiple : true
                        },
                        function (response) {
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent($translate.instant("SCHEDULE.BYPROFESSIONAL.TOAST.CANCEL.SUCCESS"))
                                    .hideDelay(1000)
                            );
                            $rootScope.$emit('refreshByProfessionalSchedule', null);
                        }, function (error) {
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent($translate.instant("SCHEDULE.BYPROFESSIONAL.TOAST.CANCEL.ERROR"))
                                    .hideDelay(1000)
                            );
                            $rootScope.$emit('refreshByProfessionalSchedule', null);
                        })
                }, function() {

                });

                return;*/

                api.requestCancel.save({
                        requestId: requestId,
                        cancelMultiple : false
                    },
                    function (response) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SCHEDULE.BYPROFESSIONAL.TOAST.CANCEL.SUCCESS"))
                                .hideDelay(1000)
                        );
                        $rootScope.$emit('refreshByProfessionalSchedule', null);
                    }, function (error) {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SCHEDULE.BYPROFESSIONAL.TOAST.CANCEL.ERROR"))
                                .hideDelay(1000)
                        );
                        $rootScope.$emit('refreshByProfessionalSchedule', null);
                    })

            });

        }
        //reschedule
        function reschedule(id, professionalId, professionalName, time, date, customerId){
            this._mdPanelRef && this._mdPanelRef.close().then(function () {

                //mostrar mensagem que basta ele clicar sobre o novo local
                $mdToast.show(
                    $mdToast.simple()
                        .textContent("Clique sobre o local que você deseja transferir o agendamento.")
                        .hideDelay(1000)
                );

               /* $mdDialog.show({
                    controller: 'FastAppointmentController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/schedule/fastAppointment.html',
                    parent: angular.element(document.body),
                    targetEvent: null,
                    multiple: true,
                    clickOutsideToClose: true,
                    zIndex: 1,
                    locals: {
                        professionalId: professionalId,
                        professionalName: professionalName,
                        time: time,
                        date: date,
                        scheduleId : id,
                        customerId: customerId
                    },
                    escapeToClose: true,
                    focusOnOpen: true
                })
                    .then(function (answer) {


                    }, function () {

                    });*/

                /*$mdDialog.show({
                    controller: 'NewScheduleController',
                    controllerAs: 'vm',
                    locals: {
                        professional: null,
                        customer: null,
                        whenTime: null,
                        whenDate: null,
                        id: id
                    },
                    templateUrl: 'app/main/schedule/newSchedule/newSchedule.html',
                    clickOutsideToClose: false,
                    clickEscapetoClose : true
                })
                    .then(function (answer) {
                        $rootScope.$emit('refreshByProfessionalSchedule', null);
                    }, function () {
                        $rootScope.$emit('refreshByProfessionalSchedule', null);
                    });*/
            });
        }
        //novo agendamento
        function openNewScheduleDialog (professional, customer, whenTime, whenDate) {
            $mdDialog.show({
                controller: 'NewScheduleController',
                controllerAs: 'vm',
                locals: {
                    professional: professional,
                    customer: customer,
                    whenTime: whenTime,
                    whenDate: whenDate,
                    id: null
                },
                templateUrl: 'app/main/schedule/newSchedule/newSchedule.html',
                clickOutsideToClose: false
            })
                .then(function (answer) {
                    $rootScope.$emit('refreshByProfessionalSchedule', null);
                }, function () {
                    $rootScope.$emit('refreshByProfessionalSchedule', null);
                });
        }

    }

    /** @ngInject */
    function ScheduleByProfessionalController($sce, api, $mdSidenav, $mdDialog, $scope, $translate, $mdToast, $state,$rootScope,
                                $window, DTDefaultOptions, DTOptionsBuilder,$compile,$mdPanel)
    {
        var vm = this;
        this._mdPanel = $mdPanel;
        vm.tableWidth = $window.innerWidth - 250 - 78;
        vm.filterdate = new Date();
        vm.reload = reload;
        vm.selectedDate = new Date();
        vm.showMenuBusy = showMenuBusy;
        vm.showMenuNotBusy = showMenuNotBusy;
        vm.showMenuCheckedIn = showMenuCheckedIn;
        vm.showMenuCancel = showMenuCancel;
        vm.showMenuBlocked = showMenuBlocked;
        vm.showMenuNoshow = showMenuNoshow;


        $scope.$on('$viewContentLoaded', function(event) {
            $("input.md-datepicker-input").prop('readonly', true);

            angular.element(".md-datepicker-button").each(function () {
                var el = this;
                var ip = angular.element(el).parent().find("input").bind('click', function (e) {
                    angular.element(el).click();
                });
                angular.element(this).css('visibility', 'hidden');
            });

        });

        vm.previousDate = function(){
            var temp = new moment(vm.selectedDate.valueOf());
            temp = temp.add(-1, 'd');
             vm.selectedDate = new Date(temp.valueOf());
            reload();
        }
        vm.nextDate = function(){        
            var temp = new moment(vm.selectedDate.valueOf());
            temp = temp.add(1, 'd');
            vm.selectedDate = new Date(temp.valueOf());
            reload();
        }
        vm.todayDate = function(){
            vm.selectedDate = new Date();
            reload();
        }


        // Loading professioanals
        loadProfessionals(function(data){
            vm.professionals = data;
            vm.professionalsAll = data;
            vm.chkProf = [];
            for(var i=0; i < data.length; i++){
                vm.chkProf[data[i]._id] = true;
            }
            if (vm.professionals.length * 100 > vm.tableWidth){
                vm.colSize = 100;
            } else {
                vm.colSize = vm.tableWidth / vm.professionals.length;
            }

           

            //Loading timetable
            loadTimeTable(function(data){
                vm.timetable = data;
            })

            vm.showTable = false;

            updateContent(function(data){
                //console.log(new Date())
                vm.showTable = true;
                vm.html = getHTMLByProfessional(data);
            });

        })





        // Methods
        $scope.trustAsHtml = function(string) {
            return $sce.trustAsHtml(string);
        };

        function showMenuBusy(ev, id, requestId, professionalId, professionalName, time, timeStr,
        customerId, customerName, customerPhone) {

            var showCheckin = true;
            var hoje = new moment({
                date: new moment().date(),
                month: new moment().month(),
                year: new moment().year()
            }).add(1, 'days').add(-1, 'seconds');


            if (vm.selectedDate.valueOf() > hoje.valueOf()){
                showCheckin = false;
            }

            var position = this._mdPanel.newPanelPosition()
                .relativeTo('.busy-div_' + id)
                .addPanelPosition(this._mdPanel.xPosition.CENTER, this._mdPanel.yPosition.BELOW);

            var sHtml = '<div class="demo-menu-example" ' +
                '     aria-label="Select your option" ' +
                '     role="listbox">' +
                '  <div class="demo-menu-item" ' +
                '       aria-selected="OPTION" ' +
                '       tabindex="-1" ' +
                '       role="option" ' +
                '       ng-click="ctrl.customerHistory(\'' + customerId + '\')">' +
                customerName + ' - ' + customerPhone +
                '  </div>' +
                '<md-divider></md-divider>';

            if (showCheckin){
                sHtml += '  <div class="demo-menu-item" ' +
                '       aria-selected="OPTION" ' +
                '       tabindex="-1" ' +
                '       role="option" ' +
                '       ng-click="ctrl.checkin(\'' + requestId + '\')">' +
                '    Cliente chegou' +
                '  </div>' ;

            }

            sHtml += '  <div class="demo-menu-item" ' +
            '       aria-selected="OPTION" ' +
            '       tabindex="-1" ' +
            '       role="option" ' +
            '       ng-click="ctrl.cancel(\'' + requestId  +'\')">' +
            '    Cliente cancelou' +
            '  </div>' ;

            if (showCheckin){
            sHtml += '  <div class="demo-menu-item" ' +
                '       aria-selected="OPTION" ' +
                '       tabindex="-1" ' +
                '       role="option" ' +
                '       ng-click="ctrl.noshow(\'' + requestId + '\')">' +
                '    Cliente não apareceu' +
                '  </div>'
            }

            sHtml += '<md-divider></md-divider>' +
            '  <div class="demo-menu-item" ' +
            '       aria-selected="OPTION" ' +
            '       tabindex="-1" ' +
            '       role="option" ' +
            '       ng-click="ctrl.cut(\'' + requestId + '\')">' +
            '    Transferir Agendamento' +
            '  </div>' +
            '  <div class="demo-menu-item" ' +
            '       aria-selected="OPTION" ' +
            '       tabindex="-1" ' +
            '       role="option" ' +
            '       ng-click="ctrl.copyCustomer(\'' + customerId + '\')">' +
            '    Copiar Cliente' +
            '  </div>' +
            '<md-divider></md-divider>' +
            '  <div class="demo-menu-item" ' +
            '       aria-selected="OPTION" ' +
            '       tabindex="-1" ' +
            '       role="option" ' +
            '       ng-click="ctrl.sendNoShowSMS(' + requestId + ',' + customerId  + ')">' +
            '    Enviar lembrete de agendamento (SMS) ' +
            '  </div>' +
            '<md-divider></md-divider>' +
            '  <div class="demo-menu-item" ' +
            '       aria-selected="OPTION" ' +
            '       tabindex="-1" ' +
            '       role="option" ' +
            '       ng-click="ctrl.newFastAppointment(\'' + professionalId + '\', ' + time +',' + vm.selectedDate.valueOf() + ',\'' + professionalName + '\')">' +
            '    Agendar com ' + professionalName + ' as ' + timeStr +
            '  </div>' +
            '<md-divider></md-divider>' +
            '  <div class="demo-menu-item" ' +
            '       aria-selected="OPTION" ' +
            '       tabindex="-1" ' +
            '       role="option" ' +
            '       ng-click="ctrl.viewAppointment(\'' + requestId + '\')">' +
            '    Ver Informações ' +
            '  </div>' +

            '</div>'

            var config = {
                attachTo: angular.element(document.body),
                controller: PanelMenuCtrl,
                controllerAs: 'ctrl',
                template: sHtml,
                panelClass: 'demo-menu-example',
                position: position,
                locals: {

                },
                openFrom: ev,
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: false,
                zIndex: 2
            };

            this._mdPanel.open(config);
            event.stopPropagation();
        };


        function showMenuNotBusy(ev, id, professionalId, professionalName, time, timeStr) {

            var position = this._mdPanel.newPanelPosition()
                .relativeTo('.demo-menu-open-button_' + id)
                .addPanelPosition(this._mdPanel.xPosition.CENTER, this._mdPanel.yPosition.BELOW);

            var config = {
                attachTo: angular.element(document.body),
                controller: PanelMenuCtrl,
                controllerAs: 'ctrl',
                template:
                '<div class="demo-menu-example" ' +
                '     aria-label="Select your option" ' +
                '     role="listbox">' +
                '  <div class="demo-menu-item" ' +
                '       aria-selected="OPTION" ' +
                '       tabindex="-1" ' +
                '       role="option" ' +
                '       ng-click="ctrl.newFastAppointment(\'' + professionalId + '\', ' + time +',' + vm.selectedDate.valueOf() + ',\'' + professionalName + '\')">' +
                '    Agendar com ' + professionalName + ' as ' + timeStr +
                '  </div>' +
                    '<md-divider></md-divider>' +
                '  <div class="demo-menu-item" ' +
                '       aria-selected="OPTION" ' +
                '       tabindex="-1" ' +
                '       role="option" ' +
                '       ng-click="ctrl.transferAppointment(\'' + professionalId + '\', ' + time +',' + vm.selectedDate.valueOf() + ',\'' + professionalName + '\')">' +
                '    Transferir agendamento recortado para ' + professionalName + ' as ' + timeStr +
                '  </div>' +
                '  <div class="demo-menu-item" ' +
                '       aria-selected="OPTION" ' +
                '       tabindex="-1" ' +
                '       role="option" ' +
                '       ng-click="ctrl.pasteCustomer(\'' + professionalId + '\', ' + time +',' + vm.selectedDate.valueOf() + ',\'' + professionalName + '\')">' +
                '    Colar Cliente' +
                '  </div>' +

                '<md-divider></md-divider>' +

                    /*'  <div class="demo-menu-item" ' +
                    '       aria-selected="OPTION" ' +
                    '       tabindex="-1" ' +
                    '       role="option" ' +
                    '       ng-click="ctrl.newFastAppointment(\'' + professionalId + '\', ' + time +',' + vm.selectedDate.valueOf() + ',\'' + professionalName + '\')">' +
                    '    Agendamento Expresso' +
                    '  </div>' +*/

                    '  <div class="demo-menu-item" ' +
                    '       aria-selected="OPTION" ' +
                    '       tabindex="-1" ' +
                    '       role="option" ' +
                    '       ng-click="ctrl.blockSchedule(\'' + professionalId + '\',\'' + professionalName + '\',' + time +',' + vm.selectedDate.valueOf() + ')">' +
                    //'    Bloquear Horário ' + professionalName + ' as ' + timeStr +
                '    Bloquear Horário ' + professionalName +
                    '  </div>' +
                '</div>',
                panelClass: 'demo-menu-example',
                position: position,
                locals: {

                },
                openFrom: ev,
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: false,
                zIndex: 2
            };

            this._mdPanel.open(config);
            event.stopPropagation();
        };

        function showMenuNoshow(ev, id, requestId) {


            var position = this._mdPanel.newPanelPosition()
                .relativeTo('.demo-menu-open-button_' + id)
                .addPanelPosition(this._mdPanel.xPosition.CENTER, this._mdPanel.yPosition.BELOW);

            var config = {
                attachTo: angular.element(document.body),
                controller: PanelMenuCtrl,
                controllerAs: 'ctrl',
                template:
                '<div class="demo-menu-example role="listbox">' +
                '  <div class="demo-menu-item" ' +
                '       aria-selected="OPTION" ' +
                '       tabindex="-1" ' +
                '       role="option" ' +
                '       ng-click="ctrl.undoNoShow(\'' + requestId + '\')">' +
                '    Desfazer ausência do cliente' +
                '  </div>' +
                '</div>',
                panelClass: 'demo-menu-example',
                position: position,
                locals: {

                },
                openFrom: ev,
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: false,
                zIndex: 2
            };

            this._mdPanel.open(config);
            event.stopPropagation();
        };

        function showMenuBlocked(ev, id, blockId) {


            var position = this._mdPanel.newPanelPosition()
                .relativeTo('.demo-menu-open-button_' + id)
                .addPanelPosition(this._mdPanel.xPosition.CENTER, this._mdPanel.yPosition.BELOW);

            var config = {
                attachTo: angular.element(document.body),
                controller: PanelMenuCtrl,
                controllerAs: 'ctrl',
                template:
                '<div class="demo-menu-example role="listbox">' +
                '  <div class="demo-menu-item" ' +
                '       aria-selected="OPTION" ' +
                '       tabindex="-1" ' +
                '       role="option" ' +
                '       ng-click="ctrl.unblockSchedule(\'' + blockId + '\')">' +
                '    Cancelar Bloqueio' +
                '  </div>' +
                '</div>',
                panelClass: 'demo-menu-example',
                position: position,
                locals: {

                },
                openFrom: ev,
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: false,
                zIndex: 2
            };

            this._mdPanel.open(config);
            event.stopPropagation();
        };

        function showMenuCancel(ev, id, requestId, professionalId, professionalName, time, timeStr, customerId) {

            var position = this._mdPanel.newPanelPosition()
                .relativeTo('.busy-div_' + id)
                .addPanelPosition(this._mdPanel.xPosition.CENTER, this._mdPanel.yPosition.BELOW);

            var config = {
                attachTo: angular.element(document.body),
                controller: PanelMenuCtrl,
                controllerAs: 'ctrl',
                template:
                '<div class="demo-menu-example" ' +
                '     aria-label="Select your option" ' +
                '     role="listbox">' +
                '  <div class="demo-menu-item" ' +
                '       aria-selected="OPTION" ' +
                '       tabindex="-1" ' +
                '       role="option" ' +
                '       ng-click="ctrl.removeSchedule(\'' + requestId + '\')">' +
                '    Excluir o agendamento' +
                '  </div>' +
                '  <div class="demo-menu-item" ' +
                '       aria-selected="OPTION" ' +
                '       tabindex="-1" ' +
                '       role="option" ' +
                '       ng-click="ctrl.copyCustomer(\'' + customerId + '\')">' +
                '    Copiar Cliente' +
                '  </div>' +


                '</div>',
                panelClass: 'demo-menu-example',
                position: position,
                locals: {

                },
                openFrom: ev,
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: false,
                zIndex: 2
            };

            this._mdPanel.open(config);
            event.stopPropagation();
        };

        function showMenuCheckedIn(ev, id, requestId, professionalId, professionalName, time, timeStr,
        customerId) {

            var position = this._mdPanel.newPanelPosition()
                .relativeTo('.busy-div_' + id)
                .addPanelPosition(this._mdPanel.xPosition.CENTER, this._mdPanel.yPosition.BELOW);

            var config = {
                attachTo: angular.element(document.body),
                controller: PanelMenuCtrl,
                controllerAs: 'ctrl',
                template:
                '<div class="demo-menu-example" ' +
                '     aria-label="Select your option" ' +
                '     role="listbox">' +
                '  <div class="demo-menu-item" ' +
                '       aria-selected="OPTION" ' +
                '       tabindex="-1" ' +
                '       role="option" ' +
                '       ng-click="ctrl.cancelCheckin(\'' + requestId + '\')">' +
                '    Ops, o cliente ainda não chegou' +
                '  </div>' +
                '<md-divider></md-divider>' +
                '  <div class="demo-menu-item" ' +
                '       aria-selected="OPTION" ' +
                '       tabindex="-1" ' +
                '       role="option" ' +
                '       ng-click="ctrl.cut(\'' + requestId + '\')">' +
                '    Recortar' +
                '  </div>' +
                '  <div class="demo-menu-item" ' +
                '       aria-selected="OPTION" ' +
                '       tabindex="-1" ' +
                '       role="option" ' +
                '       ng-click="ctrl.copyCustomer(\'' + customerId + '\')">' +
                '    Copiar Cliente' +
                '  </div>' +

                '<md-divider></md-divider>' +
                '  <div class="demo-menu-item" ' +
                '       aria-selected="OPTION" ' +
                '       tabindex="-1" ' +
                '       role="option" ' +
                '       ng-click="ctrl.newAppointment(\'' + professionalId + '\', ' + time +',' + vm.filterdate.valueOf() + ')">' +
                '    Agendar com ' + professionalName + ' as ' + timeStr +
                '  </div>' +

                '</div>',
                panelClass: 'demo-menu-example',
                position: position,
                locals: {

                },
                openFrom: ev,
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: false,
                zIndex: 2
            };

            this._mdPanel.open(config);
            event.stopPropagation();
        };

        vm.moveHour = function(event){
           
        }
        function getHTMLByProfessional(schedule){
            var id = 0;

            var html = "";
            html = html + '<table cellpadding="0" cellspacing="0" style="width:100%" ;>';
            html = html + '<thead >';
            html = html + '<tr style="background-color: white;" height="50px" >';
            html = html + '<th style="max-width:50px;min-width:50px;width:50px;border-right: 1px solid lightgrey;border-bottom: 1px solid darkgrey"></th>';

            for(var i=0; i < vm.professionals.length; i++){
                if (vm.chkProf[vm.professionals[i]._id]){
                    html = html + '<th  align="center" style="min-width:100px;border-right: 1px solid lightgray;border-bottom: 1px solid darkgrey;text-align: center;color:Gray">';
                    html = html + vm.professionals[i].name;
                    html = html + "</th>";
                }
            }


            html = html + '</tr>';
            html = html + '</thead>';
            html = html + '<tbody>';
            for(var i=0; i < vm.timetable.length; i++){
                html = html + '<tr style="height: 30px;">';

                var borderBottom = '';

                if ((vm.timetable[i].timeStr.indexOf(':15') == -1) && (vm.timetable[i].timeStr.indexOf('45') == -1)){
                    borderBottom = '0px dashed darkgrey';
                } else {
                    borderBottom = '1px solid rgba(0, 0, 0, .1)';
                }

                html = html + '<td valign="top" style="max-width:50px;min-width:50px;width:50px;font-size:13px; border-right: 2px solid darkgrey;border-bottom: ' +  borderBottom  + ' ;text-align: right;background-color: white; padding-right:3px;" >';
                if ((vm.timetable[i].timeStr.indexOf(':15') == -1) && (vm.timetable[i].timeStr.indexOf('45') == -1)){
                    html = html + vm.timetable[i].timeStr;
                }
                html = html + '</td>';

                for(var p=0 ; p < vm.professionals.length; p++){
                    if (vm.chkProf[vm.professionals[p]._id]) {


                        var blocked = false;
                        var reason = "";
                        var blockId = 0;
                        var backgroundColor = '';
                        if ((schedule[vm.professionals[p]._id] == undefined) ||
                            (schedule[vm.professionals[p]._id][vm.timetable[i].time] == undefined) ||
                            (schedule[vm.professionals[p]._id][vm.timetable[i].time].status == undefined) ||
                            (schedule[vm.professionals[p]._id][vm.timetable[i].time].status == 'BUSY')) {
                            backgroundColor = 'background-color:rgba(255,152,0,0.1)';
                        } else {
                            backgroundColor = "background-image: url('/assets/images/backgrounds/schedule.png');"
                            blocked = true;
                            if (schedule[vm.professionals[p]._id][vm.timetable[i].time] != undefined){

                                blockId = schedule[vm.professionals[p]._id][vm.timetable[i].time]._id;
                                if (schedule[vm.professionals[p]._id][vm.timetable[i].time].reason != undefined){
                                    reason = schedule[vm.professionals[p]._id][vm.timetable[i].time].reason;
                                }

                            }
                        }
                        id = id + 1;


                        if ((vm.timetable[i].timeStr.indexOf(':15') == -1) && (vm.timetable[i].timeStr.indexOf('45') == -1)){
                            borderBottom = '0px dashed darkgrey';
                        } else {
                            borderBottom = '1px solid rgba(0, 0, 0, .1); ';
                        }



                        if (!blocked) {
                            html = html + '<td ng-click="vm.showMenuNotBusy($event, ' + id + ', \'' + vm.professionals[p]._id + '\',\'' + vm.professionals[p].name + '\','
                                + vm.timetable[i].time + ',\'' + vm.timetable[i].timeStr + '\' )" class="demo-menu-open-button_' + id + '" style="min-width:100px;border-right: 1px dashed rgba(0, 0, 0, .1);border-bottom: ' + borderBottom + ';' + backgroundColor + '; ">';
                        } else {


                            if (blockId != 0){
                                html = html + '<td ng-click="vm.showMenuBlocked($event, ' + id + ', \'' + blockId + '\' )" class="demo-menu-open-button_' + id + '" style="min-width:100px;border-right: 1px dashed rgba(0, 0, 0, .1);border-bottom: ' + borderBottom + ';' + backgroundColor + '; ">';
                                html = html + "<span style='font-size:10px;font-weight:bold;'>" + reason + "</span>";
                            } else {
                                html = html + '<td ng-click="vm.showMenuNotBusy($event, ' + id + ', \'' + vm.professionals[p]._id + '\',\'' + vm.professionals[p].name + '\','
                                    + vm.timetable[i].time + ',\'' + vm.timetable[i].timeStr + '\' )" class="demo-menu-open-button_' + id + '" style="min-width:100px;border-right: 1px dashed rgba(0, 0, 0, .1);border-bottom: ' + borderBottom + ';' + backgroundColor + '; ">';
                            }

                        }


                        html = html + '<div  style="position:relative;margin-top: 0px;" >';

                        if ((schedule[vm.professionals[p]._id][vm.timetable[i].time] == undefined) ) {
                            html = html + '<div style="margin-left: 2px;height:30px"  >';
                            html = html + '</div>';
                        } else {
                            for (var d = 0; d < schedule[vm.professionals[p]._id][vm.timetable[i].time].data.length; d++) {
                                var busyBackgroundColor = 'blue';
                                var foregroundColor = 'white';
                                var menuAction = "";
                                //console.log(schedule[vm.professionals[p]._id][vm.timetable[i].time].data[d].status);
                                switch (schedule[vm.professionals[p]._id][vm.timetable[i].time].data[d].status) {
                                    case "CHECKIN":
                                        busyBackgroundColor = 'yellow';
                                        menuAction = "showMenuCheckedIn";
                                        foregroundColor = "black";
                                        break;
                                    case "CHECKOUT":
                                        busyBackgroundColor = 'green';
                                        menuAction = "showMenuCheckedOut";
                                        break;
                                    case "CANCELED":
                                        busyBackgroundColor = 'red';
                                        menuAction = "showMenuCancel";
                                        break;
                                    case "NOSHOW":
                                        busyBackgroundColor = 'orange';
                                        menuAction = "showMenuNoshow";
                                        break;
                                    default:
                                        busyBackgroundColor = 'blue';
                                        menuAction = "showMenuBusy";
                                        break;
                                }


                                var vWidth = 99 / schedule[vm.professionals[p]._id][vm.timetable[i].time].data.length + '%';
                                var vHeight = 30 * schedule[vm.professionals[p]._id][vm.timetable[i].time].data[d].slotSize;
                                var vMarginLeft = ((vm.colSize / schedule[vm.professionals[p]._id][vm.timetable[i].time].data.length)
                                    * (schedule[vm.professionals[p]._id][vm.timetable[i].time].data[d].index)) - 0
                                var html2 = '';
                                html2 = html2 + '<div class="busy-div_' + id + '" style="position: absolute;' +
                                    'opacity: 0.9;' +
                                    'border: 1px solid white;' +
                                    'background-color: ' + busyBackgroundColor + ';' +
                                    'margin-left:' + vMarginLeft + 'px;' +
                                    'margin-top: -15px;' +
                                    'width: ' + vWidth + ';' +
                                    'height: ' + vHeight + 'px;' +
                                    'border-radius: 5px;" ' +
                                    'ng-click="vm.' + menuAction + '($event,' + id + ',\'' + schedule[vm.professionals[p]._id][vm.timetable[i].time].data[d]._id + '\'' + ', \'' + vm.professionals[p]._id + '\',\'' + vm.professionals[p].name + '\','
                                    + vm.timetable[i].time + ',\'' + vm.timetable[i].timeStr + '\',\'' +
                                    schedule[vm.professionals[p]._id][vm.timetable[i].time].data[d].customerId + '\',\'' +
                                    schedule[vm.professionals[p]._id][vm.timetable[i].time].data[d].customerName + '\',\'' +
                                    schedule[vm.professionals[p]._id][vm.timetable[i].time].data[d].customerTelephone + '\' )">';
                                html2 = html2 + '<span style="color:' + foregroundColor + ';font-weight: normal;font-size:10px;" >';
                                html2 = html2 + vm.timetable[i].timeStr + " - " + schedule[vm.professionals[p]._id][vm.timetable[i].time].data[d].customerName;
                                html2 = html2 + '</span><br>'
                                html2 = html2 + '<span href="#" style="color:' + foregroundColor + ';font-size:10px">';
                                if (schedule[vm.professionals[p]._id][vm.timetable[i].time].data[d].locationName != null){
                                    html2 = html2 + schedule[vm.professionals[p]._id][vm.timetable[i].time].data[d].locationName + " - ";
                                }

                                html2 = html2 + schedule[vm.professionals[p]._id][vm.timetable[i].time].data[d].serviceName;
                                html2 = html2 + '</span>';
                                html2 = html2 + '</div>';

                                html = html + html2;


                            }
                        }


                        html = html + '</td>'
                    }

                }
                html = html + '</tr>';
            }

            html = html + '</tbody>';
            html = html + '</table>';


            return html;



        }

        vm.updateFilter = function () {
            vm.html = getHTMLByProfessional(vm.schedule);
        }

        ///EVENTOS
        $rootScope.$on('refreshByProfessionalSchedule', function(event, args) {


            loadContent(function (data){
                vm.html = {};
                vm.html = getHTMLByProfessional(data);
                vm.showTable = true;
                
            })
        });


        function reload(){
            vm.showTable = false;
            $rootScope.$emit('refreshByProfessionalSchedule', null);
        }


        //load professionals
        function loadProfessionals(callback){
            api.serviceProfessionals.save({
                professionalList : ($rootScope.userType == 'PROFESSIONAL') ? $rootScope.professionalId : null
                },
                function(response){
                    
                    var arTemp = [];
                    for(var i=0; i < response.d.length; i++){
                        var obj = response.d[i];
                        obj.index = i;
                        arTemp.push(obj);
                    }
                    callback(arTemp);
                },
                function(error){
                    console.log(error);
                });
        }

        //load timetable
        function loadTimeTable(callback){
            var arTemp = [];
            for(var i=360; i < 1440; i = i + 15){
                var hour = parseInt(i/60);
                if (hour < 10){
                    hour = "0" + hour;
                }

                var minute = i - (hour * 60);

                if (minute < 10){
                    minute = "0" + minute;
                }



                var obj = {
                    time : i,
                    timeStr : hour + ":" + minute,
                    monday : true,
                    tuesday : true,
                    wednesday : true,
                    thursday : true,
                    friday : true,
                    saturday : true,
                    sunday : true,
                }
                arTemp.push(obj);
            }

            callback(arTemp);
        }

        //load schedule
        function loadContent(callback){
            Date.prototype.stdTimezoneOffset = function() {
                var jan = new Date(this.getFullYear(), 0, 1);
                var jul = new Date(this.getFullYear(), 6, 1);
                return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
            }



            Date.prototype.dst = function() {
                return this.getTimezoneOffset() < this.stdTimezoneOffset();
            }

            var date = new Date();
            var ServerDifferenceMinutes = -date.getTimezoneOffset();

            //console.log(ServerDifferenceMinutes);

            api.scheduleByPDV.save({
                    date : vm.selectedDate.valueOf(),
                    timeZone :  ServerDifferenceMinutes,
                    showNoShow : $rootScope.pdvConfiguration.showNoShow,
                    showCanceled: $rootScope.pdvConfiguration.showCanceled

                },
                function(response){
                
                    callback(response.d);
                }, function(error){
                    console.log(error);
                })

        }



        //iupdate content
        function updateContent(callback){
            //loading content
            loadContent(function (data){
                vm.schedule = data;
                callback(data);
            })

        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.schedule')
        .controller('BlockDialogCtrl', BlockDialogCtrl);

    function BlockDialogCtrl($scope, $q, api, professionalId, $mdToast, $translate,
                             time, date, $rootScope, professionalName, $mdDialog){
        var vm = this;
        vm.professionalId = professionalId;
        vm.professionalName = professionalName;
        vm.saveBlock = blockSchedule;

        //configurations
        vm.requestPassword = $rootScope.pdvConfiguration.requestPasswordBlock;
        if (vm.requestPassword){
            vm.accessCode = "";
        }

        $scope.close = function(){
            $mdDialog.hide();
        }


        var whenDateMoment = new moment(parseFloat(date));
        var whenDate = new moment({
            year: whenDateMoment.year(),
            month: whenDateMoment.month(),
            date: whenDateMoment.date()
        });
        var whenTime = time * 60 * 1000;
        var when = whenDate.valueOf() + whenTime;
        var whenMoment = new moment(when);

        vm.timeFrom = time;
        vm.timeTo = time + 30;

        vm.arTimes = [];
        for(var i=420; i <= 1440; i= i + 15 ){
            var hour = parseInt(i / 60)
            var minute = (i - (hour * 60));
            if (minute < 10){
                minute = "0" + minute;
            }
            var strTime = hour + ":" + minute;
            vm.arTimes.push({minutes:i, str:strTime});
        }


        function ajusteDataSemDST(dt)
        {
            
            if ((Intl.DateTimeFormat().resolvedOptions().timeZone == 'America/Sao_Paulo') && (dt.getTimezoneOffset() != 180))
            {

                                            
                return 1*60*60*1000;
                //return 0;
                
            }

            return 0;
        }

        function blockSchedule() {

            var mWhenDate = new moment(date);
            var periodFrom = new moment({
                year: mWhenDate.year(),
                month: mWhenDate.month(),
                date: mWhenDate.date()
            })
            var nPeriodFrom = periodFrom.valueOf() + (vm.timeFrom * 60 * 1000) + ajusteDataSemDST(new Date(parseFloat(date)));
            var nPeriodTo = periodFrom.valueOf() + (vm.timeTo * 60 * 1000)+ ajusteDataSemDST(new Date(parseFloat(date)));

            console.log(vm.accessCode);

            api.saveProfessionalBlock.save({
                    reason: vm.reason,
                    professionalId: professionalId,
                    periodFrom: nPeriodFrom,
                    periodTo: nPeriodTo,
                    timeFrom: vm.timeFrom,
                    timeTo: vm.timeTo,
                    weekDay: mWhenDate.weekday(),
                    type: 'PERIOD',
                    accessCode : vm.accessCode
                },
                function (response) {
                    if (response.s == 200){
                        $rootScope.$emit('refreshByProfessionalSchedule', null);

                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SCHEDULE.BYPROFESSIONAL.TOAST.BLOCK.SUCCESS"))
                                .hideDelay(1000)
                        );

                        $mdDialog.hide();

                    } else {

                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("GENERAL.ACCESSCODE.NOT_VALID"))
                                .hideDelay(1000)
                        );

                    }


                },
                function (error) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SCHEDULE.BYPROFESSIONAL.TOAST.BLOCK.ERROR"))
                            .hideDelay(1000)
                    );

                });



        }

    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.sales')
        .controller('SalesDialogServiceController', SalesDialogServiceController);

    /** @ngInject */
    function SalesDialogServiceController($q, $state, $scope,api, $translate, $mdDialog, $mdToast, priceTableId, isProduct)
    {
        var vm = this;

        

        //check if is edit, insert or nothing
        var currentState = $state.current.name;

        vm.serviceSearchText = ""
        vm.serviceSearchTextChange = serviceSearchTextChange;
        vm.productSearchTextChange = productSearchTextChange;
        vm.serviceSearchItems = [];
        vm.addServiceDialog = {};
        vm.floatinglabel = {
            service : $translate.instant("SALES.CHECK.SERVICE"),
            professional : $translate.instant("SALES.CHECK.PROFESSIONAL"),
            product : $translate.instant("SALES.CHECK.PRODUCT")
        }
        vm.addServiceInList = addServiceInList;
        vm.closeDialog = closeDialog;

        ///professional autocomplete
        vm.professionalSearchText = ""
        vm.professionalSearchTextChange = professionalSearchTextChange;
        vm.professionalSearchItems = [];


        // functions
        function addServiceInList(){
            //verificar se profissional pode exercer esse papel
            var foundAndOk1 = false;
            var foundAndOk2 = false;

            if (!isProduct){
                for(var i=0; i < vm.addServiceDialog.professional.services.length; i++){
                    if (vm.addServiceDialog.professional.services[i].serviceId == vm.addServiceDialog.service._id){
                        if (vm.addServiceDialog.professional.services[i].comission != undefined){
                            foundAndOk1 = true;
                            break;
                        }
                    }
                }


                if (vm.addServiceDialog.professional2 != undefined){
                    for(var i=0; i < vm.addServiceDialog.professional2.services.length; i++){
                        if (vm.addServiceDialog.professional2.services[i].serviceId == vm.addServiceDialog.service._id){
                            if (vm.addServiceDialog.professional2.services[i].comission != undefined){
                                foundAndOk2 = true;
                                break;
                            }
                        }
                    }
                } else {
                    foundAndOk2 = true;
                }




            }

            //dialog de produto
            if (isProduct){
                foundAndOk1 = true;
                foundAndOk2 = true;

            }

            if (!foundAndOk1){
                $mdToast.show(
                    $mdToast.simple()
                        .textContent($translate.instant("SCHEDULE.TOAST.SAVE.ERROR_PROFESSIONAL_NOT_ENABLED"))
                        .hideDelay(10000)
                );
                return;
            }

            if (!foundAndOk2){
                $mdToast.show(
                    $mdToast.simple()
                        .textContent("Primeiro ajudante não está habilitado para executar o serviço")
                        .hideDelay(10000)
                );
                return;
            }


            $mdDialog.cancel({service:vm.addServiceDialog.service, professional:vm.addServiceDialog.professional,
                ajudante:vm.addServiceDialog.professional2});
        }

        function closeDialog(){
            $mdDialog.cancel();
        }

        function productSearchTextChange(search) {
            var deferred = $q.defer();
            api.getProductsByName.save({
                    search : search,                    
                },
                function(response){
                    deferred.resolve( response.d );
                },
                function(error){
                    console.log(error);
                });

            return deferred.promise;

        }

        function serviceSearchTextChange(search) {
            var deferred = $q.defer();
            api.serviceServicesSearch.save({
                    search : search,
                    priceTableId : priceTableId
                },
                function(response){
                    deferred.resolve( response.d );
                },
                function(error){
                    console.log(error);
                });

            return deferred.promise;

        }

        function professionalSearchTextChange(search) {
            var deferred = $q.defer();
            api.serviceProfessionalSearchFast2.save({
                    search : search
                },
                function(response){
                    deferred.resolve( response.d );
                },
                function(error){
                    console.log(error);
                });
            return deferred.promise;
        }

        //////////
    }

})();
(function () {
    'use strict';

    angular
        .module('app.sales')
        .controller('SalesController', SalesController);

    /** @ngInject */
    function SalesController($q, $state, $scope, DTOptionsBuilder, DTColumnBuilder, DTColumnDefBuilder, api,
        DTDefaultOptions, $translate, $mdDialog, $mdToast, $compile,
        $filter, $rootScope) {
        var vm = this;

        //check if is edit, insert or nothing
        var currentState = $state.current.name;
        vm.priceTable = {}

        vm.isElectron = isElectron;

        vm.allowOpen = function(check){
            if (($rootScope.userType == 'RECEPCIONIST') && (!$rootScope.pdvConfiguration.allowRecepcionistOpenComandaAntiga)) {
                if (check.checkoutDate < new moment({
                        date: new moment().date(),
                        month: new moment().month(),
                        year: new moment().year()
                    }).valueOf()) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        }


        //lidando com datas
        $scope.$on('$viewContentLoaded', function (event) {
            $("datePicker").prop('readonly', true);

            angular.element(".md-datepicker-button").each(function () {
                var el = this;
                var ip = angular.element(el).parent().find("input").bind('click', function (e) {
                    angular.element(el).click();
                });
                angular.element(this).css('visibility', 'hidden');
            });


        });
        vm.maxDate = new Date();

        //Initialize
        switch (currentState) {
            case "app.sales.open":
                vm.showTable = false;
                vm.removeCheck = removeCheck;
                vm.checkout = checkout;
                vm.showDelete = false;




                vm.unlock = function(id) {
                    console.log(id);
                    api.unlockSale.save({
                        saleId: id
                    }, function(response){
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Comanda liberada com sucesso.")
                                .hideDelay(2000)
                        );

                        $state.reload();
                    });
                }

                if ($rootScope.userType == 'RECEPCIONIST'){
                    if ($rootScope.pdvConfiguration.allowRecepcionistDeleteSale){
                        vm.showDelete = true;
                    }
                } else {
                    vm.showDelete = true;
                }
                api.openSales.save({},
                    function (response) {

                        vm.checks = response.d;

                        setTimeout(function () {
                            vm.showTable = true;
                            $scope.$apply();
                        }, 200)

                    },
                    function (error) {
                        console.log(error);
                    });

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({ autoWidth: false })
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable": "Nenhum registro disponível",
                        "sInfo": "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty": "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered": "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix": "",
                        "sInfoThousands": ",",
                        "sLengthMenu": "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing": "Processando...",
                        "sSearch": "Busca:",
                        "sZeroRecords": "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst": "Primeiro",
                            "sLast": "Ultimo",
                            "sNext": "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending": ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });

                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                break;
            case "app.sales.closed":
                vm.showTable = false;
                vm.removeCheck = removeCheck;
                vm.reopen = reopen;
                vm.sendRecipeToCostumer = sendRecipeToCostumer;

                vm.dtColumns = [
                    DTColumnBuilder.newColumn('checkoutDate').withTitle('Dt. Abertura').notSortable().renderWith(function (data, type, full) {
                        return $filter('date')(data, "dd/MM/yyyy HH:mm");
                    }),
                    DTColumnBuilder.newColumn('checkoutDate2').withTitle('Dt. Fechamento').notSortable().renderWith(function (data, type, full) {
                        return $filter('date')(data, "dd/MM/yyyy HH:mm");
                    }),
                    DTColumnBuilder.newColumn('customerName').withTitle('Cliente').notSortable(),
                    DTColumnBuilder.newColumn('customerTelephone').withTitle('Telefone').notSortable(),
                    DTColumnBuilder.newColumn('paid').withTitle('Valor').notSortable().renderWith(function (data, type, full) {
                        return $filter('currency')(data, 'R$', 2);
                    }),
                    DTColumnBuilder.newColumn('_id').notVisible().notSortable(),
                    DTColumnBuilder.newColumn(null).withClass('right').withTitle('').renderWith(function (data, type, full) {
                        var sHtml = "";
                        //recibo
                        if (full.customerEmail) sHtml = sHtml + '<md-button aria-label="Trash" class="md-raised  gp-mini" ng-click="vm.sendRecipeToCostumer(\'' + full._id + '\', \'' + full.customerEmail + '\')"><md-tooltip aria-label="Pencil">{{ "GENERAL.HINTS.RECIPE" | translate }}</md-tooltip><i class="icon-receipt" layout="center"></i></md-button>';
                        console.log(full.customerEmail);
                        //reopen
                        sHtml = sHtml + '<md-button aria-label="Trash" class="md-raised  gp-mini" ng-click="vm.reopen(\'' + full._id + '\')"><md-tooltip aria-label="Pencil">{{ "GENERAL.HINTS.REOPEN" | translate }}</md-tooltip><i class="icon-pencil" layout="center"></i></md-button>';

                        if ($rootScope.userType == 'RECEPCIONIST'){
                            if ($rootScope.pdvConfiguration.allowRecepcionistDeleteSale){
                                sHtml = sHtml + '<md-button aria-label="Trash" class="md-raised md-warn gp-mini" ng-click="vm.removeCheck(\'' + full._id  + '\')"><md-tooltip aria-label="Pencil">{{ "GENERAL.HINTS.TRASH" | translate }}</md-tooltip><i class="icon-trash" layout="center"></i></md-button>';
                            }
                        } else {
                            sHtml = sHtml + '<md-button aria-label="Trash" class="md-raised md-warn gp-mini" ng-click="vm.removeCheck(\'' + full._id  + '\')"><md-tooltip aria-label="Pencil">{{ "GENERAL.HINTS.TRASH" | translate }}</md-tooltip><i class="icon-trash" layout="center"></i></md-button>';
                        }


                        return sHtml ;
                    })

                ];

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption('ajax', {
                        url: backendServer + '/sale/getClosedSalesPaged',
                        type: 'POST',
                        data: {
                            token: $rootScope.securityToken
                        }
                    })
                    .withDataProp('d')
                    .withOption('autoWidth', false)
                    .withOption('processing', true)
                    .withOption('serverSide', true)
                    .withOption('createdRow', function (row) {
                        // Recompiling so we can bind Angular directive to the DT
                        $compile(angular.element(row).contents())($scope);
                    })
                    //.withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable": "Nenhum registro disponível",
                        "sInfo": "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty": "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered": "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix": "",
                        "sInfoThousands": ",",
                        "sLengthMenu": "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing": "Processando...",
                        "sSearch": "Busca:",
                        "sZeroRecords": "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst": "Primeiro",
                            "sLast": "Ultimo",
                            "sNext": "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending": ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });

                DTDefaultOptions.setLoadingTemplate('<h3>Carregando</h3>');

                break;
            case "app.sales.new":
                ///customer autocomplete
                vm.customerNameSearchText = ""
                vm.customerSearchTextChange = customerSearchTextChange;
                vm.customerSearchItems = [];
                vm.checkoutDate = new Date();

                vm.showPdvLocation = false;
                vm.pdvLocations = $rootScope.pdvLocations;
                if (vm.pdvLocations.length > 1){
                    vm.showPdvLocation = true;
                    vm.pdvLocation = vm.pdvLocations[0].locationId;
                }


                if (($rootScope.userType != null) &&
                    (($rootScope.userType == 'ADMIN') ||
                        ($rootScope.userType == 'MASTER'))) {
                    vm.showDate = true;
                }
                //translates
                vm.floatinglabel = {
                    customer: $translate.instant("SALES.CHECK.CUSTOMER")
                }
                vm.sale = {};
                vm.newSale = newSale;
                break;
            case "app.sales.checkout":
                vm.saleId = $state.params.saleId;
                vm.closeDialog = closeDialog;
                vm.addService = addService;
                vm.addProduct = addProduct;
                vm.removeServiceItem = removeServiceItem;
                vm.addProduct = addProduct;
                vm.save = save;
                vm.saveAndClose = saveAndClose;
                vm.saveAndClose2 = saveAndClose2;
                vm.addServiceDialog = {};

                vm.cancel = function(){
                    api.unlockSale.save({
                        saleId: vm.saleId
                    }, function(response){
                        $state.go("app.sales.open");
                    });

                };


                api.lockSale.save({
                    saleId : vm.saleId
                }, function(response){

                });



                vm.floatinglabel = {
                    service: $translate.instant("SALES.CHECK.SERVICE")
                }


                //apresentar botao de add service
                vm.allowAddProduct = false;
                vm.allowAddService = false;

                if ($rootScope.userType == 'RECEPCIONIST'){
                    vm.allowAddService = $rootScope.pdvConfiguration.allowRecepcionistAddService;
                    vm.allowAddProduct = $rootScope.pdvConfiguration.allowRecepcionistAddProduct;
                } else {
                    console.log('teste');
                    vm.allowAddService = true;
                    vm.allowAddProduct = true;
                }

                vm.serviceSearchText = ""
                vm.serviceSearchTextChange = serviceSearchTextChange;
                vm.serviceSearchItems = [];


                api.sale.save({
                    saleId: vm.saleId
                },
                    function (response) {

                        //console.log(response.d);
                        vm.customerId = response.d.customerId;

                        api.priceTableByCustomer.save({
                            customerId: response.d.customerId,
                            checkoutDate: response.d.checkoutDate
                        },
                            function (response) {
                                vm.priceTable = response.d;
                                vm.priceTableId = response.d._id;
                                vm.sale.priceTable = response.d.name;
                                //console.log(response.d);
                            },
                            function (error) {


                            });




                        vm.sale = response.d;
                        vm.sale.totalValue = 0;
                        vm.sale.paid = 0;
                        
                        updateTotalValue();


                    },
                    function (error) {


                    });


                break;
        }

        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({}, last);
        $scope.getToastPosition = function () {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function (pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if (current.bottom && last.top) current.top = false;
            if (current.top && last.bottom) current.bottom = false;
            if (current.right && last.left) current.left = false;
            if (current.left && last.right) current.right = false;
            last = angular.extend({}, current);
        }
        ///END TOAST

        // functions
        function removeCheck(saleId) {
            var confirm = $mdDialog.confirm()
                .title($translate.instant("SALES.CHECK.DIALOG.REMOVE.TITLE"))
                .textContent($translate.instant("SALES.CHECK.DIALOG.REMOVE.SUBTITLE"))
                .ariaLabel('Remove')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok($translate.instant("GENERAL.DIALOG.OK"))
                .cancel($translate.instant("GENERAL.DIALOG.CANCEL"));
            $mdDialog.show(confirm).then(function () {
                api.removeSale.save({
                    saleId: saleId
                },
                    function (response) {
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SALES.CHECK.TOAST.REMOVE.SUCCESS"))
                                .position(pinTo)
                                .hideDelay(2000)
                        );
                        //redirect
                        setTimeout(function () {
                            $state.reload();
                        }, 1000);
                    },
                    function (error) {
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.CHECK.TOAST.REMOVE.ERROR"))
                                .position(pinTo)
                                .hideDelay(1000)
                        );

                        //redirect
                        setTimeout(function () {
                            $state.reload();
                        }, 1000);

                    });
            });
        }
        function newSale() {
            api.saveSale.save({
                customerId: vm.sale.customer._id,
                customerName: vm.sale.customer.name,
                customerTelephone: vm.sale.customer.telephone,
                checkoutDate: vm.checkoutDate.valueOf(),
                locationId : vm.pdvLocation
            },
                function (response) {
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SALES.CHECK.TOAST.SAVE.SUCCESS"))
                            .position(pinTo)
                            .hideDelay(2000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.go('app.sales.open');
                    }, 1000);
                },
                function (error) {
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.CHECK.TOAST.SAVE.ERROR"))
                            .position(pinTo)
                            .hideDelay(1000)
                    );

                    //redirect
                    setTimeout(function () {
                        $state.go('app.sales.open');
                    }, 1000);

                });
        }
        function addProduct() {
            $mdDialog.show({
                controller: 'SalesDialogServiceController',
                controllerAs: 'vm',
                locals: {
                    priceTableId: vm.priceTableId,
                    isProduct: true
                },
                templateUrl: 'app/main/sales/productDialog.html',
                clickOutsideToClose: true
            })
                .then(function (answer) {

                }, function (response) {
                    if (response != undefined) {
                        var obj = {};
                       
                        obj.service = response.service;                        
                        obj.professional = response.professional;

                        //achar as condfigurações desse profissional para esse serviço
                        /*var service = {};
                        for(var j=0; j < response.professional.services.length; j++){
                            if (response.service._id == response.professional.services[j].serviceId){
                                service = response.professional.services[j];
                                break;
                            }
                        }*/
                        //bloco acima usado somente ara pegar a comissao do profissional
                        //para determinado serviço

                        function generateUUID() {
                            var d = new Date().getTime();
                            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                                var r = (d + Math.random() * 16) % 16 | 0;
                                d = Math.floor(d / 16);
                                return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                            });
                            return uuid;
                        };

                        //--
                        var professionalId = null;
                        var professionalName = null;
                        if (response.professional != null){
                            professionalId = response.professional._id;
                            professionalName = response.professional.name;
                        }
                        var obj = {
                                    _id : generateUUID(),
                                    type : 'P',
                                    itemId : response.service._id,
                                    serviceCategoryId : response.service.categoryId,
                                    name : response.service.name,
                                    professionalId : professionalId,
                                    professionalName : professionalName,
                                    inventoryIdRemovedFromCustomer : 0,
                                    itemPrice : response.service.price,
                                    itemCashPrice : response.service.cashPrice ,
                                    itemComissionPrice : response.service.comissionPrice,
                                    itemComission : response.service.comission
                                }


                                vm.sale.items.push(obj);

                                updateTotalValue();

                    }

                });
        }
        function addService() {
            $mdDialog.show({
                controller: 'SalesDialogServiceController',
                controllerAs: 'vm',
                locals: {
                    priceTableId: vm.priceTableId,
                    isProduct: false
                },
                templateUrl: 'app/main/sales/serviceDialog.html',
                clickOutsideToClose: true
            })
                .then(function (answer) {

                }, function (response) {
                    if (response != undefined) {
                        var obj = {};

                        obj.service = response.service;
                        obj.professional = response.professional;
                        obj.ajudante = response.ajudante;


                        //achar as condfigurações desse profissional para esse serviço
                        var service = {};
                        for (var j = 0; j < response.professional.services.length; j++) {
                            if (response.service._id == response.professional.services[j].serviceId) {
                                service = response.professional.services[j];
                                break;
                            }
                        }
                        var service2 = {};
                        if (response.ajudante != undefined){
                            for (var j = 0; j < response.ajudante.services.length; j++) {
                                if (response.service._id == response.ajudante.services[j].serviceId) {
                                    service2 = response.ajudante.services[j];
                                    break;
                                }
                            }

                        }

                        //bloco acima usado somente ara pegar a comissao do profissional
                        //para determinado serviço

                        function generateUUID() {
                            var d = new Date().getTime();
                            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                                var r = (d + Math.random() * 16) % 16 | 0;
                                d = Math.floor(d / 16);
                                return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                            });
                            return uuid;
                        };

                        //verificar se o cliente em questao tem esse serviceId em estoque
                        //se tiver o comissionPrice deve ser esse do acordo e o restante deve ser 0
                        //o nome do serviço deve ser alterado com a obs (PACOTE)
                        api.customersServiceInventory.save({
                            customerId: vm.customerId,
                            serviceId: obj.service._id
                        },
                            function (responseInventory) {

                                var price = 0;
                                var cashPrice = 0;
                                var comissionPrice = 0;
                                var inventoryIdRemovedFromCustomer = 0;

                                //tm algum serviço desse em estoque
                                if (responseInventory.d.length > 0) {
                                    price = 0;
                                    cashPrice = 0;
                                    comissionPrice = responseInventory.d[0].comissionPrice;
                                    inventoryIdRemovedFromCustomer = responseInventory.d[0]._id;
                                } else {
                                    price = response.service.price;
                                    cashPrice = response.service.cashPrice;
                                    comissionPrice = response.service.comissionPrice;
                                }

                                var ajudanteId = null;
                                if (response.ajudante != null){
                                    ajudanteId = response.ajudante._id;
                                }
                                var obj = {
                                    _id: generateUUID(),
                                    type: 'S',
                                    itemId: response.service._id,
                                    serviceCategoryId: response.service.categoryId,
                                    name: response.service.name,
                                    professionalId: response.professional._id,
                                    professionalName: response.professional.name,
                                    inventoryIdRemovedFromCustomer: inventoryIdRemovedFromCustomer,
                                    itemPrice: price,
                                    itemCashPrice: cashPrice,
                                    itemComissionPrice: comissionPrice,
                                    itemComission: service.comission,
                                    itemComissionAjudante: service2.comissionAjudante,
                                    ajudanteId : ajudanteId
                                }

                                //console.log(obj);

                                vm.sale.items.push(obj);

                                updateTotalValue();

                                //TESTE: salvar comanda nesse momento
                                vm.save(true);

                            },
                            function (error) {
                                console.log(error);
                            });


                    }

                });
        }
        function updateTotalValue() {
            //update total value
            var totalValue = 0;
            for (var i = 0; i < vm.sale.items.length; i++) {
                totalValue += vm.sale.items[i].itemPrice;
            }
            vm.sale.totalValue = totalValue;
        }
        function removeServiceItem(itemId) {
            var arTemp = [];
            for (var i = 0; i < vm.sale.items.length; i++) {
                if (vm.sale.items[i]._id != itemId) {
                    arTemp.push(vm.sale.items[i]);
                }
            }
            vm.sale.items = arTemp;

            //TESTE: salvar comanda nesse momento
            vm.save(true);


            updateTotalValue();

        }

        function saveAndClose2() {


            $mdDialog.show({
                controller: 'SalesCheckoutServiceController2',
                controllerAs: 'vm',
                locals: {
                    saleId: vm.sale._id,
                    items: vm.sale.items
                },
                templateUrl: 'app/main/sales/checkoutDialog2.html',
                clickOutsideToClose: false,
                multiple:true,
                clickEscapetoClose: false
            })
                .then(function (answer) {

                }, function () {
                    //
                });
        }

        function saveAndClose() {

            console.log(vm.sale.items);

            $mdDialog.show({
                controller: 'SalesCheckoutServiceController',
                controllerAs: 'vm',
                locals: {
                    saleId: vm.sale._id,
                    items: vm.sale.items
                },
                templateUrl: 'app/main/sales/checkoutDialog.html',
                clickOutsideToClose: false,
                clickEscapetoClose: true
            })
                .then(function (answer) {

                }, function () {
                    //
                });
        }

        function save(actionAdd) {

            api.saveSale.save({
                saleId: vm.sale._id,
                items: vm.sale.items,
                status: "OPEN"
            },
                function (response) {
                    if (!actionAdd) {

                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SALES.CHECKOUT.TOAST.SAVE.SUCCESS"))
                                .position(pinTo)
                                .hideDelay(2000)
                        );
                        //redirect
                        setTimeout(function () {
                            $state.go('app.sales.open');
                        }, 1000);
                    }
                },
                function (error) {
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.CHECKOUT.TOAST.SAVE.ERROR"))
                            .position(pinTo)
                            .hideDelay(1000)
                    );

                    //redirect
                    setTimeout(function () {
                        $state.go('app.sales.open');
                    }, 1000);

                });
        }

        function sendRecipeToCostumer(id, email)
        {
            api.sendCustomerRecipe.save({
                saleId: id,
                email : email
            },
            function (response) {
                var pinTo = $scope.getToastPosition();
                if (response.s == 200){
                $mdToast.show(
                    $mdToast.simple()
                        .textContent($translate.instant("SALES.RECEIPT.TOAST.SUCCESS"))
                        .position(pinTo)
                        .hideDelay(2000)
                );                
            }
            else{
                $mdToast.show(
                    $mdToast.simple()
                        .textContent($translate.instant("SALES.RECEIPT.TOAST.ERROR"))
                        .position(pinTo)
                        .hideDelay(1000)
                );
            }
            },
            function (error) {
                var pinTo = $scope.getToastPosition();
                $mdToast.show(
                    $mdToast.simple()
                        .textContent($translate.instant("SALES.RECEIPT.TOAST.ERROR"))
                        .position(pinTo)
                        .hideDelay(1000)
                );
            });

        }

        function reopen(id) {

            var status = "";

            api.reopenSale.save({
                    saleId: id,
                    userType : $rootScope.userType,
                    allowRecepcionistOpenComandaCaixaFechado : $rootScope.pdvConfiguration.allowNewSaleWithoutCashier
                },
                function (response) {
                    var pinTo = $scope.getToastPosition();
                    if (response.s == 200){
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SALES.REOPEN.TOAST.SAVE.SUCCESS"))
                            .position(pinTo)
                            .hideDelay(2000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.go('app.sales.open');
                    }, 1000);
                }
                else{
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SALES.REOPEN.TOAST.SAVE.ERROR"))
                            .position(pinTo)
                            .hideDelay(1000)
                    );
                }
                },
                function (error) {
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SALES.REOPEN.TOAST.SAVE.ERROR"))
                            .position(pinTo)
                            .hideDelay(1000)
                    );

                    //redirect
                    setTimeout(function () {
                        $state.reload();
                    }, 1000);

                });


        }


        function closeDialog() {
            $mdDialog.cancel();
        }

        function checkout(saleId) {

            //antes de ir para a tela de checkout o sistema deve validar se
            //o operador logado tem caixa aberto
            if ($rootScope.pdvConfiguration.allowNewSaleWithoutCashier){
                $state.go('app.sales.checkout', { 'saleId': saleId });
            } else {
                //nesse caso devo verificar se operador possui caixa aberto
                api.getOpenCashier.save({
                        oneProfesional:true
                    },
                    function(response){
                        if (response.d != null){
                            $state.go('app.sales.checkout', { 'saleId': saleId });
                        } else {
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent("Operador não possui um caixa aberto. Por favor abra o caixa antes de tentar fechar comandas.")
                                    .hideDelay(4000)
                            );
                        }
                    },
                    function(error){
                        console.log(error);
                    });

            }



        }

        function customerSearchTextChange(search) {

            var deferred = $q.defer();
            api.customersSearch.save({
                searchName: search
            },
                function (response) {
                    deferred.resolve(response.d);
                },
                function (error) {
                    console.log(error);
                });

            return deferred.promise;

        }

        function serviceSearchTextChange(search) {
            var deferred = $q.defer();
            api.serviceServicesSearch.save({
                search: search
            },
                function (response) {
                    deferred.resolve(response.d);
                },
                function (error) {
                    console.log(error);
                });

            return deferred.promise;

        }

        function editCheck(categoryId) {
            $state.go('app.settings.product.category.edit', { 'categoryId': categoryId });
        }
        //////////
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.customer',
        [
            // 3rd Party Dependencies
            'datatables'
        ]
    )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {


        $stateProvider.state('app.customer', {
            url    : '/customer'
        }).state('app.customer.list', {
            url    : '/list',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/customer/list.html',
                    controller : 'CustomerController as vm'
                },
                locals:{
                    customerName : ''
                }
            }
        }).state('app.customer.newFromSchedule', {
            url    : '/new/:customerName',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/customer/customer.html',
                    controller : 'CustomerController as vm'
                }
            }
        }).state('app.customer.new', {
            url    : '/new',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/customer/customer.html',
                    controller : 'CustomerController as vm'
                }
            }
        }).state('app.customer.edit', {
            url    : '/edit/:customerId',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/customer/customer.html',
                    controller : 'CustomerController as vm'
                }
            }
        }).state('app.customer.history', {
            url    : '/hisotry/:customerId',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/customer/history.html',
                    controller : 'CustomerController as vm'
                }
            }
        }).state('app.customer.inventory', {
            url    : '/inventory/:customerId',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/customer/inventory.html',
                    controller : 'CustomerController as vm'
                }
            }
        });


    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.sales')
        .controller('SalesCheckoutPopupWoweeDialog', SalesCheckoutPopupWoweeDialog);

        angular
        .module('app.customer')
        .controller('SalesCheckoutPopupWoweeDialog', SalesCheckoutPopupWoweeDialog);

    /** @ngInject */
    function SalesCheckoutPopupWoweeDialog($q, $state, $scope,api, $translate, $mdDialog, $window,
                                            $mdToast, $mdConstant, $rootScope, value, creditDebit, saleId)
    {
        var vm = this;

        vm.parcelas = 1;
        vm.value = value;
        vm.creditDebit = creditDebit;
        vm.processing = false;

        vm.closeAndApply = function(){

            //write to file            
            writeTEF(vm.creditDebit + ((vm.creditDebit == "C")? vm.parcelas : ""), parseFloat(vm.value) *100);

            //fica lendo o TEF
            vm.processing = true;
            vm.timer = setInterval(function () {

                var out = readTEF();
                if (out != null){
                    clearInterval(vm.timer);


                    var zoopObj = JSON.parse(out);
                    console.log(out);


                    if (zoopObj.status == "succeeded"){
                        clearInterval(vm.timer);

                        //resgatando o codigo de auitorizacao
                        var authorizationCode = 0;
                        for(var i=0; i < zoopObj.history.length; i++){
                            if (zoopObj.history[i].operation_type == 'authorization'){
                                authorizationCode = zoopObj.history[i].authorization_code;
                                break;
                            }
                        }

                        var value = 0;
                        if (typeof vm.value == 'string'){
                            value = vm.value.replace(',','.');
                        } else {
                            value = vm.value;
                        }



                        $mdDialog.hide({
                            ignore : false,
                            zoopObj : zoopObj,
                            bandeiraName :  deParaNomeBandeira(zoopObj.payment_method.card_brand),
                            codAutorizacao : authorizationCode,
                            value : parseFloat(value)
                        });
                    } else  {
                        clearInterval(vm.timer);

                        var dialogOptions = {type: 'info', buttons: ['OK'], message: 'Erro ao processar transação.'}

                        showMessage(dialogOptions);


                        $mdDialog.hide({
                            ignore: true,
                            value: parseFloat(vm.value)
                        });
                    }

                }
            }, 1000);




            return;



        }

        function deParaNomeBandeira(bandeira)
        {
            if (bandeira.toLowerCase().includes("visa")) return "VISA";
            if (bandeira.toLowerCase().includes("master")) return "MASTER";
            if (bandeira.toLowerCase().includes("maes")) return "MASTER";
            if (bandeira.toLowerCase().includes("elo")) return "ELO";
            if (bandeira.toLowerCase().includes("ame")) return "AMEX";
            if (bandeira.toLowerCase().includes("diner")) return "DINERS";
            if (bandeira.toLowerCase().includes("hiper")) return "HIPERCARD";
            if (bandeira.toLowerCase().includes("cab")) return "CABAL";

            return bandeira;
            
        }

        vm.closeDialog = function(){
            clearInterval(vm.timer);
            $mdDialog.hide({ignore:true});
            /*api.cancelPendingTEFPayment.save({

            }, function(response){
                $mdDialog.hide({ignore:true});
            })*/

        }

    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.sales')
        .controller('SalesCheckoutPopupGiftCardDialog', SalesCheckoutPopupGiftCardDialog);

    /** @ngInject */
    function SalesCheckoutPopupGiftCardDialog($q, $state, $scope,api, $translate, $mdDialog,
                                            $mdToast, $mdConstant, $rootScope, value)
    {
        var vm = this;

        vm.value = value;

        vm.closeAndApply = function(){
            $mdDialog.hide({
                'value' : parseFloat(vm.value.replace(',', '.')),
                'obs' : vm.obs
            });
        }

        vm.closeDialog = function(){
            $mdDialog.hide({ignore:true});
        }

    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.sales')
        .controller('SalesCheckoutPopupDialog', SalesCheckoutPopupDialog);

    /** @ngInject */
    function SalesCheckoutPopupDialog($q, $state, $scope,api, $translate, $mdDialog,
                                            $mdToast, $mdConstant, $rootScope, creditoDebito, adquirenteId, value)
    {
        var vm = this;


        vm.value = value;

        vm.closeAndApply = function(){
            for(var i=0; i < vm.bandeiras.length; i++){
                if (vm.bandeiras[i].PDVA_CD_PDV_ADQUIRENTE == vm.cardId){
                    vm.bandeiraName = vm.bandeiras[i].BAND_TX_BANDEIRA;
                }
            }
            var value = 0;
            if (typeof vm.value == 'string'){
                value = vm.value.replace(',','.');
            } else {
                value = vm.value;
            }

            console.log(value);

            $mdDialog.hide({
                'value' : parseFloat(value),
                'codAutorizacao' : vm.codAutorizacao,
                'creditoDebito' : creditoDebito,
                'adquirenteName' : vm.adquirenteName,
                'cardId' : vm.cardId,
                'bandeiraName':vm.bandeiraName
            });
        }

        vm.closeDialog = function(){
            $mdDialog.hide({ignore:true});
        }

        api.cards.save({

        }, function(response){

            vm.bandeiras = [];

            var bandeiras = [];

            for(var i=0 ; i < response.d.length; i++){
                if (response.d[i].PDVA_BL_ACTIVE){
                    if (response.d[i].ADQU_CD_ADQUIRENTE == adquirenteId){
                        vm.adquirenteName = response.d[i].ADQU_TX_NAME;
                        vm.bandeiras.push({
                            BAND_CD_BANDEIRA : response.d[i].BAND_CD_BANDEIRA,
                            BAND_TX_BANDEIRA :  response.d[i].BAND_TX_BANDEIRA,
                            ADQU_TX_NAME : response.d[i].ADQU_TX_NAME,
                            PDVA_CD_PDV_ADQUIRENTE : response.d[i].PDVA_CD_PDV_ADQUIRENTE
                        });
                    }
                }
            }

            vm.cardId = vm.bandeiras[0].PDVA_CD_PDV_ADQUIRENTE;

        }, function(error){
            console.log(error);
        })
    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.sales')
        .controller('SalesCheckoutPopupCashDialog', SalesCheckoutPopupCashDialog);

    /** @ngInject */
    function SalesCheckoutPopupCashDialog($q, $state, $scope,api, $translate, $mdDialog,
                                            $mdToast, $mdConstant, $rootScope, value)
    {
        var vm = this;

        vm.value = value;




        vm.closeAndApply = function(){

            var valueconverted = 0;
            if (typeof vm.value == 'string'){
                valueconverted = vm.value.replace(',','.');
            } else {
                valueconverted = vm.value;
            }

            $mdDialog.hide({
                'value' : parseFloat(valueconverted),
                'observation' : vm.observation
            });
        }
        vm.closeDialog = function(){
            $mdDialog.hide({ignore:true});
        }

    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.sales')
        .controller('SalesCheckoutServiceController2', SalesCheckoutServiceController2);

    /** @ngInject */
    function SalesCheckoutServiceController2($q, $state, $scope,api, $translate, $mdDialog,
                                            $mdToast, saleId, items, $mdConstant, $rootScope, $filter)
    {
        var vm = this;
        vm.payments = [];


        vm.saldo = 0;


        ////REVER
        var pdvConfObj = $rootScope.pdvConfiguration;
        var pdvConfiguration = {};

        vm.userTpe = $rootScope.userType;

        vm.isElectron = isElectron;


        vm.paid = 0;
        ////ATE AQUI
        vm.saveCheckout = saveCheckout;
        vm.closeDialog = closeDialog;
        vm.giftCardValue = 0;


        //setando o valor devido de acordo com os itens
        //settings total value
        vm.totalValue = 0;
        vm.totalValueWithSpecialPaymentType = 0;

        for (var i=0; i < items.length; i++){
            vm.totalValue += items[i].itemPrice;
            vm.totalValueWithSpecialPaymentType += items[i].itemCashPrice;
        }

        //total devido de acordo com o cashdiscount ou nao
        vm.getTotalOwned = function(){

            console.log(vm.saldo);

            if (vm.cashDiscount){
                return vm.saldo - (vm.totalValue - vm.totalValueWithSpecialPaymentType);
            } else {
                return vm.saldo ;
            }

        }

        //update no saldo
        vm.updateSaldo = function(){
            //checando se só ta usando dinheiro
            vm.cashDiscount = true;
            vm.cashDiscountStyle = { 'text-decoration' : 'none' , 'padding-left': '10px', 'color':'green' }
            for (var i=0; i < vm.payments.length; i++){
                if (vm.payments[i].creditoDebito != 'CASH'){
                    vm.cashDiscount = false;
                    vm.cashDiscountStyle = { 'text-decoration' : 'line-through', 'padding-left': '10px', 'color':'green' }

                }
            };


            var paid = 0;
            for(var i=0; i < vm.payments.length; i++){
                paid += vm.payments[i].value;
            }
            if (vm.customer == null){
                vm.saldo = vm.totalValue - paid - vm.giftCardValue ;
            } else {
                vm.saldo = vm.totalValue - paid - vm.giftCardValue - vm.customer.creditDebit;
            }

            console.log(vm.totalValue);
            console.log(paid);
            console.log(vm.giftCardValue);
            console.log(vm.saldo.toFixed(2));

            vm.saldo = vm.saldo.toFixed(2);
            if (vm.customer != null) {
                console.log("===>" + vm.customer.creditDebit);
            }


            //setando o label do botao
            //chdecando se salao permite debito
            if (vm.getTotalOwned() > 0){
                vm.buttonName = 'Falta Receber ' + $filter('currency')(vm.getTotalOwned(), 'R$', 2) + ' para fechar comanda';
                vm.buttonColor = {backgroundColor : 'red', color:'white'};
            } else if (vm.getTotalOwned() == 0) {
                vm.buttonName = 'Fechar comanda';
                vm.buttonColor = {backgroundColor : 'green',  color:'white'};
            } else {
                vm.buttonName = 'Dar ' + $filter('currency')(-vm.getTotalOwned(), 'R$', 2) + ' de troco ou creditar e fechar comanda';
                vm.buttonColor = {backgroundColor : 'green',  color:'white'};
            }

            if ($rootScope.pdvConfiguration.allowNewSaleWithDebt){
                if (vm.getTotalOwned() > 0){
                    vm.buttonDisabled = false;
                } else {
                    vm.buttonDisabled = false;
                }
            } else {
                if (vm.getTotalOwned() > 0){
                    vm.buttonDisabled = true;
                } else {
                    vm.buttonDisabled = false;
                }
            }
            if(vm.buttonDisabled){
                vm.buttonColor = {backgroundColor : 'silver',  color:'white'};
            }






        }
        vm.updateSaldo();


        //pegar todos os cartoes que tenho habilitado  por forma de pgto
        api.cards.save({

        }, function (response) {
            vm.cards = response.d;
            vm.cardsAux = [];
            vm.adquirentes = [];
            var aux = [];

            for(var i=0 ; i < response.d.length; i++){
                if (response.d[i].PDVA_BL_ACTIVE){
                    if (aux.indexOf(vm.cards[i].ADQU_TX_NAME)==-1){
                        aux.push(vm.cards[i].ADQU_TX_NAME);
                        vm.cardsAux.push({title: vm.cards[i].ADQU_TX_NAME + ' - Credito', 'adquirenteId' : vm.cards[i].ADQU_CD_ADQUIRENTE, 'creditoDebito' : 'C'});
                        vm.cardsAux.push({title : vm.cards[i].ADQU_TX_NAME + ' - Debito', 'adquirenteId' : vm.cards[i].ADQU_CD_ADQUIRENTE, 'creditoDebito' : 'D'});
                    }

                }
            }




        }, function(error){
            console.log(error);
        })

        //cada adquiernte tem n bandeiras associadas que devem ser apresentadas em uma combo ou radios no popup
        //a cada pagamento, devemos inserir no array de payments o valor, o id da combinacao card+bandeira+forma de pgto
        vm.addCardPayment = function(adquirenteId, creditoDebito){

            //open modal dialog
            $mdDialog.show({
                controller: 'SalesCheckoutPopupDialog',
                controllerAs: 'vm',
                templateUrl: 'app/main/sales/addCardPayment.html',
                clickOutsideToClose: false,
                multiple:true,
                locals : {
                    'creditoDebito' : creditoDebito,
                    'adquirenteId' : adquirenteId,
                    value : vm.getTotalOwned()
                },
                clickEscapetoClose: true
            })
                .then(function (answer) {

                    if ((!answer.ignore) || (answer.ignore == null)) {
                        vm.payments.push({
                            'creditoDebito':answer.creditoDebito,
                            'bandeiraId': answer.bandeiraId,
                            'bandeiraName':answer.bandeiraName,
                            'codAutorizacao' : answer.codAutorizacao,
                            'cardId' : answer.cardId,
                            'adquirenteName' : answer.adquirenteName,
                            'value': parseFloat(answer.value,2),
                            'id':generateUUID()
                        })

                        vm.updateSaldo();
                    }



                }, function () {
                    //
                });
        }
        function generateUUID() {
            var d = new Date().getTime();
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
            return uuid;
        };

        vm.addCashPayment = function(){

            //open modal dialog
            $mdDialog.show({
                controller: 'SalesCheckoutPopupCashDialog',
                controllerAs: 'vm',
                templateUrl: 'app/main/sales/addCashPayment.html',
                clickOutsideToClose: false,
                multiple:true,
                locals : {
                    value : vm.getTotalOwned()
                },
                clickEscapetoClose: true
            })
                .then(function (answer) {

                    if ((!answer.ignore) || (answer.ignore == null)) {
                        vm.payments.push({
                            'creditoDebito': 'CASH',
                            'observation': answer.observation,
                            'value': parseFloat(answer.value,2),
                            'id':generateUUID()
                        })

                        vm.updateSaldo();
                    }


                }, function () {
                    //
                });
        }
        vm.cancelPayment = function(id){
            var index = -1;
            for(var i=0; i < vm.payments.length;i++) {
                if (vm.payments[i].id == id) {
                    index = i;
                }
            }

            if (index >= 0) {
                if (vm.payments[index].zoopObj != null) {
                    api.estornarTransacaoZoop.save({
                        idZoop: vm.payments[index].zoopObj.id
                    }, function (response) {
                        vm.payments.splice(index, 1);
                        vm.updateSaldo();
                        //alert('Transação estornada com sucesso');
                    })
                } else {
                    vm.payments.splice(index, 1);
                    vm.updateSaldo();
                }

            }

        }
        vm.addGiftCard = function(){
            //open modal dialog
            $mdDialog.show({
                controller: 'SalesCheckoutPopupGiftCardDialog',
                controllerAs: 'vm',
                templateUrl: 'app/main/sales/addGiftCard.html',
                clickOutsideToClose: false,
                multiple:true,
                locals :{
                    value : 0
                },
                clickEscapetoClose: true
            })
                .then(function (answer) {
                    if ((!answer.ignore) || (answer.ignore == null)) {
                        vm.giftCardValue = parseFloat(answer.value).toFixed(2);
                        vm.giftCardObservation = answer.obs;
                        vm.updateSaldo();
                    }

                }, function () {
                    //
                });
        }
        vm.cancelGiftCard = function(){
            vm.giftCardValue = 0;
            vm.giftCardObservation = '';
            vm.updateSaldo();
        }
        vm.addWoweePayment = function(creditDebit){
            //open modal dialog


            $mdDialog.show({
                controller: 'SalesCheckoutPopupWoweeDialog',
                controllerAs: 'vm',
                templateUrl: 'app/main/sales/addPaymentWowee.html',
                clickOutsideToClose: false,
                multiple:true,
                locals :{
                    value : vm.getTotalOwned(),
                    creditDebit : creditDebit,
                    saleId : saleId
                },
                clickEscapetoClose: false
            })
                .then(function (answer) {
                    if ((!answer.ignore) || (answer.ignore == null)) {
                        vm.payments.push({
                            'creditoDebito':creditDebit,
                            'bandeiraId': 1,
                            'bandeiraName': answer.bandeiraName,
                            'codAutorizacao' : answer.codAutorizacao,
                            'cardId' : 'WOWEE',
                            'adquirenteName' : 'WOWEE PAY',
                            'value': answer.value,
                            'zoopTransId' : answer.zoopObj.id,
                            'zoopObj' : answer.zoopObj,
                            'id':generateUUID()
                        })
                        vm.updateSaldo();
                    }

                }, function () {
                    //
                });



        }



        //loading sale
        api.sale.save({
                saleId : saleId
            },
            function(response){
                vm.sale = response.d;


                api.customer.save({
                    customerId : response.d.customerId
                }, function(response){
                    //verificando credito e debito
                    vm.customer = response.d;
                    vm.updateSaldo();


                }, function(err){

                });

            },
            function(error){


            });




        //////////
        function closeDialog(){
            $mdDialog.cancel();
        }

        

        function saveCheckout(){
            vm.processing = true;
            //checa se tem troco e se deve mudar o valor antes de fazer o checkout de fato
            if (vm.getTotalOwned() < 0) {
                var troco = vm.getTotalOwned() *-1;

                $mdDialog.show({
                    template: [
                        '<md-dialog md-theme="{{ dialog.theme || dialog.defaultTheme }}" aria-label="{{ dialog.ariaLabel }}" ng-class="dialog.css">',
                        '  <md-dialog-content class="md-dialog-content" role="document" tabIndex="-1">',
                        '    <h2 class="md-title">Confirmação</h2>',
                        '    <div class="md-dialog-content-body">',
                        '      <p>O que deseja fazer com o troco de R$ ' + troco + '?',
                        '    </div>',
                        '  </md-dialog-content>',
                        '  <md-dialog-actions>',
                        '    <md-button ng-click="dialog.comoCredito()" class="md-primary md-cancel-button">',
                        '      Deixar como crédito',
                        '    </md-button>',
                        '    <md-button ng-click="dialog.comoTroco()" class="md-primary md-confirm-button" >',
                        '      Devolver o troco',
                        '    </md-button>',
                        '  </md-dialog-actions>',
                        '</md-dialog>'
                    ].join('').replace(/\s\s+/g, ''),
                    multiple: true,
                    controller: function mdDialogCtrl() {
                        this.comoCredito = function () {
                            $mdDialog.hide('CREDIT');
                        };
                        this.comoTroco = function () {
                            $mdDialog.hide('TROCO');
                        };
                    },
                    controllerAs: 'dialog',
                    bindToController: true,

                })
                    .then(function (result) {
                        if (result == 'CREDIT'){
                            saveCheckout2()
                        } else {
                            //nesse caso o sistema deve dar o troco do cliente
                            //o operador dara o troco informado e o sistema reduz o valor pago em dinheiro



                            var paidWithCASH=0;
                            for(var i=0 ; i < vm.payments.length; i++){
                                if (vm.payments[i].creditoDebito == 'CASH'){
                                    paidWithCASH = vm.payments[i].value;
                                    break;
                                }
                            }

                            //console.log(paidWithCASH);
                            //console.log(troco);



                            if (paidWithCASH - troco < 0){
                                alert('Operação de saque de caixa não é permitida');
                                return;
                            } else {
                                vm.paidWithCASH = vm.paidWithCASH - troco;

                                for(var i=0 ; i < vm.payments.length; i++){
                                    if (vm.payments[i].creditoDebito == 'CASH'){
                                        vm.payments[i].value -= troco;
                                        break;
                                    }
                                }


                                saveCheckout2();




                            }

                        }
                    }, function () {
                        $mdDialog.cancel();
                    });

            } else {
                saveCheckout2();
            }
        }

        //de fato o checkout
        function saveCheckout2(){


            vm.loading = true;

            var obj = {
                items : items,
                saleId: saleId,
                status : 'CLOSED',
                paid : vm.paid,
                debitPayment: vm.getTotalOwned(),

                totalValue : vm.totalValue,
                totalValueWithSpecialPaymentType : vm.totalValueWithSpecialPaymentType,

                customerId : vm.customer._id,
                customerName : vm.customer.name,
                giftCardValue : vm.giftCardValue,
                giftCardObservation : vm.giftCardObservation,
                payments : vm.payments,


                serviceRequestId : vm.sale.serviceRequestId,

                userWillReceiveCredit : vm.userWillReceiveCredit,

            };

            //console.log(obj);


            api.saveSale5.save(obj,
                function(response){

                    vm.loading = false;

                    switch(response.s){
                        case 200:
                            $mdDialog.hide();

                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent($translate.instant("SALES.CHECKOUT.TOAST.SAVE.SUCCESS"))
                                    .hideDelay(2000)
                            );
                            //redirect
                            setTimeout(function(){
                                $state.go('app.sales.open');
                            }, 1000);
                            break;
                        case 401:
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent($translate.instant("SALES.CHECKOUT.TOAST.SAVE.ERROR401"))
                                    .hideDelay(2000)
                            );

                            break;
                        case 402:
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent($translate.instant("SALES.CHECKOUT.TOAST.SAVE.ERROR402"))
                                    .hideDelay(3000)
                            );
                            break;
                        case 500:
                            switch (response.d){
                                case "NO_CASHIER":
                                    $mdToast.show(
                                        $mdToast.simple()
                                            .textContent("Operador não tem caixa aberto!")
                                            .hideDelay(2000)
                                    );
                                    break;
                                default:
                                    $mdToast.show(
                                        $mdToast.simple()
                                            .textContent($translate.instant("SALES.CHECKOUT.TOAST.SAVE.ERROR"))
                                            .hideDelay(1000)
                                    );
                                    break;
                            }
                            break;
                        default:
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent($translate.instant("SALES.CHECKOUT.TOAST.SAVE.ERROR"))
                                    .hideDelay(1000)
                            );

                            //redirect
                            setTimeout(function(){
                                $state.go('app.sales.open');
                            }, 1000);

                            break;
                    }

                },
                function(error){


                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SALES.CHECKOUT.TOAST.SAVE.ERROR"))
                            .hideDelay(1000)
                    );

                    //redirect
                    setTimeout(function(){
                        $state.go('app.sales.open');
                    }, 1000);

                });
        }
    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.sales')
        .controller('SalesCheckoutServiceController', SalesCheckoutServiceController);

    /** @ngInject */
    function SalesCheckoutServiceController($q, $state, $scope,api, $translate, $mdDialog,
                                            $mdToast, saleId, items, $mdConstant, $rootScope)
    {
        var vm = this;
        vm.saveCheckout = saveCheckout;
        vm.closeDialog = closeDialog;
        vm.clickToSave = clickToSave;
        vm.paymentType ='CASH';
        var pdvConfObj = $rootScope.pdvConfiguration;
        var pdvConfiguration = {};

        vm.userTpe = $rootScope.userType;
        vm.giftCardValue = 0;

        vm.requestPassword = $rootScope.pdvConfiguration.requestPasswordCheckout;
        if (vm.requestPassword){
            vm.accessCode = "";
        }

        vm.isElectron = isElectron;

        //settings total value
        vm.totalValue = 0;
        vm.totalValueWithSpecialPaymentType = 0;

        for (var i=0; i < items.length; i++){
            vm.totalValue += items[i].itemPrice;
            vm.totalValueWithSpecialPaymentType += items[i].itemCashPrice;
        }

        vm.paid = 0;


        api.cards.save({

        }, function(response) {

            vm.adquirentes = [];

            for(var i=0 ; i < response.d.length; i++){
                if (response.d[i].PDVA_BL_ACTIVE == 1){
                    vm.adquirentes.push(response.d[i]);
                }
            }


            vm.visaCreditOperadora = vm.adquirentes[0].ADQU_TX_NAME;
            vm.visaDebitOperadora = vm.adquirentes[0].ADQU_TX_NAME;
            vm.masterCreditOperadora = vm.adquirentes[0].ADQU_TX_NAME;
            vm.masterDebitOperadora = vm.adquirentes[0].ADQU_TX_NAME;
            vm.amexOperadora = vm.adquirentes[0].ADQU_TX_NAME;
            vm.dinersOperadora = vm.adquirentes[0].ADQU_TX_NAME;
            vm.eloCreditOperadora = vm.adquirentes[0].ADQU_TX_NAME;
            vm.eloDebitOperadora = vm.adquirentes[0].ADQU_TX_NAME;
            vm.otherCreditOperadora = vm.adquirentes[0].ADQU_TX_NAME;
            vm.otherDebitOperadora = vm.adquirentes[0].ADQU_TX_NAME;



        });


        vm.updateAmountOwned = function() {

            var customerCreditDebit = 0;
            if (vm.customer != undefined && vm.customer.creditDebit != undefined){
                customerCreditDebit = vm.customer.creditDebit
            }

            if ((vm.visaCreditPayment) || (vm.visaDebitPayment)
                || (vm.masterCreditPayment) || (vm.masterDebitPayment)
                || (vm.amexPayment) || (vm.dinersPayment)
                || (vm.eloCreditPayment) || (vm.eloDebitPayment) || (vm.otherCreditPayment)
                || (vm.otherDebitPayment)
                || (vm.customerDebitPayment)) {
                vm.amountOwned = vm.totalValue + (-1*customerCreditDebit);
            }else{
                vm.amountOwned = vm.totalValueWithSpecialPaymentType + (-1*customerCreditDebit);
            }

            vm.amountOwnedAfterDiscount = vm.amountOwned - vm.giftCardValue;
        }
        vm.updateAmountOwned();
        vm.updateAmountPaid = function(){

            var applyDiscount = true;
            if ((vm.visaCreditPayment) || (vm.visaDebitPayment)
            || (vm.masterCreditPayment) || (vm.masterDebitPayment)
            || (vm.amexPayment) || (vm.dinersPayment)
            || (vm.eloCreditPayment) || (vm.eloDebitPayment) || (vm.otherCreditPayment)
            || (vm.otherDebitPayment)
            || (vm.customerDebitPayment)){
                applyDiscount = false;
            }

            var amount = 0;
            if ((vm.cashPayment) && (vm.paidWithCASH != null)){
                amount += vm.paidWithCASH;
            }
            if ((vm.checkPayment) && (vm.paidWithCHECK != null)){
                amount += vm.paidWithCHECK;
            }
            if ((vm.visaCreditPayment)&& (vm.paidWithVisaCredit != null)){
                amount += vm.paidWithVisaCredit;
            }
            if ((vm.visaDebitPayment)&& (vm.paidWithVisaDebit != null)){
                amount += vm.paidWithVisaDebit;
            }
            if ((vm.masterCreditPayment)&& (vm.paidWithMasterCredit != null)){
                amount += vm.paidWithMasterCredit;
            }
            if ((vm.masterDebitPayment)&& (vm.paidWithMasterDebit != null)){
                amount += vm.paidWithMasterDebit;
            }
            if ((vm.amexPayment)&& (vm.paidWithAMEX != null)){
                amount += vm.paidWithAMEX;
            }
            if ((vm.dinersPayment)&& (vm.paidWithDINERS != null)){
                amount += vm.paidWithDINERS;
            }
            if ((vm.eloDebitPayment)&& (vm.paidWithELODebit != null)){
                amount += vm.paidWithELODebit;
            }
            if ((vm.eloCreditPayment)&& (vm.paidWithELOCredit != null)){
                amount += vm.paidWithELOCredit;
            }
            if ((vm.otherCreditPayment)&& (vm.paidWithOtherCredit != null)){
                amount += vm.paidWithOtherCredit;
            }
            if ((vm.otherDebitPayment)&& (vm.paidWithOtherDebit != null)){
                amount += vm.paidWithOtherDebit;
            }
            if ((vm.customerDebitPayment)&& (vm.paidWithCUSTOMERDEBIT != null)){
                amount += vm.paidWithCUSTOMERDEBIT;
            }


            vm.paid = amount;
            vm.paidWithDiscount = vm.paid + vm.giftCardValue;

            //console.log(vm.paid);

            vm.updateAmountOwned();

        }

        //UPDATE VALOR NO CARTAO
        vm.checkCash = function(){
            vm.paidWithCASH = vm.amountOwned;
        }
        vm.checkCheck = function(){
            vm.paidWithCHECK = vm.amountOwned;
        }
        vm.checkVisaCredit = function(){
            vm.paidWithVisaCredit = vm.totalValue;
        }
        vm.checkVisaDebit = function(){
            vm.paidWithVisaDebit = vm.totalValue;
        }
        vm.checkMasterCredit = function(){
            vm.paidWithMasterCredit = vm.totalValue;
        }
        vm.checkMasterDebit = function(){
            vm.paidWithMasterDebit = vm.totalValue;
        }
        vm.checkAMEX = function(){
            vm.paidWithAMEX = vm.totalValue;
        }
        vm.checkDINERS = function(){
            vm.paidWithDINERS = vm.totalValue;
        }
        vm.checkELOCredit = function(){
            vm.paidWithELOCredit = vm.totalValue;
        }
        vm.checkELODebit = function(){
            vm.paidWithELODebit = vm.totalValue;
        }
        vm.checkOtherCredit = function(){
            vm.paidWithOtherCredit = vm.totalValue;
        }
        vm.checkOtherDebit = function(){
            vm.paidWithOtherDebit = vm.totalValue;
        }

        ///WATCHES
        $scope.$watch('vm.customer.creditDebit', function(newValue, oldValue) {
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.newCustomerCreditDebit', function(newValue, oldValue) {
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.giftCardValue', function(newValue, oldValue) {
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.cashPayment', function(newValue, oldValue) {
            if (!vm.cashPayment){
                vm.paidWithCASH = 0;
            }
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.paidWithCASH', function(newValue, oldValue) {
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.customerDebitPayment', function(newValue, oldValue) {
            if (!vm.customerDebitPayment){
                vm.paidWithCUSTOMERDEBIT = 0;
            }
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.paidWithCUSTOMERDEBIT', function(newValue, oldValue) {
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.checkPayment', function(newValue, oldValue) {
            if (!vm.checkPayment){
                vm.paidWithCHECK = 0;
            }
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.paidWithCHECK', function(newValue, oldValue) {
            vm.updateAmountPaid();
        })

        $scope.$watch('vm.visaCreditPayment', function(newValue, oldValue) {
            if (!vm.visaCreditPayment){
                vm.paidWithVisaCredit = 0;
            }
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.paidWithVisaCredit', function(newValue, oldValue) {
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.visaDebitPayment', function(newValue, oldValue) {
            if (!vm.visaDebitPayment){
                vm.paidWithVisaDebit = 0;
            }
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.paidWithVisaDebit', function(newValue, oldValue) {
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.masterCreditPayment', function(newValue, oldValue) {
            if (!vm.masterCreditPayment){
                vm.paidWithMasterCredit = 0;
            }
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.paidWithMasterCredit', function(newValue, oldValue) {
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.masterDebitPayment', function(newValue, oldValue) {
            if (!vm.masterDebitPayment){
                vm.paidWithMasterDebit = 0;
            }
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.paidWithMasterDebit', function(newValue, oldValue) {
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.amexPayment', function(newValue, oldValue) {
            if (!vm.amexPayment){
                vm.paidWithAMEX = 0;
            }
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.paidWithAMEX', function(newValue, oldValue) {
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.dinersPayment', function(newValue, oldValue) {
            if (!vm.dinersPayment){
                vm.paidWithDINERS = 0;
            }
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.paidWithDINERS', function(newValue, oldValue) {
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.eloCreditPayment', function(newValue, oldValue) {
            if (!vm.eloCreditPayment){
                vm.paidWithELOCredit = 0;
            }
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.paidWithELOCredit', function(newValue, oldValue) {
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.eloDebitPayment', function(newValue, oldValue) {
            if (!vm.eloDebitPayment){
                vm.paidWithELODebit = 0;
            }
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.paidWithELODebit', function(newValue, oldValue) {
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.otherCreditPayment', function(newValue, oldValue) {
            if (!vm.otherCreditPayment){
                vm.paidWithOtherCredit = 0;
            }
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.paidWithOtherCredit', function(newValue, oldValue) {
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.otherDebitPayment', function(newValue, oldValue) {
            if (!vm.otherDebitPayment){
                vm.paidWithOtherDebit = 0;
            }
            vm.updateAmountPaid();
        })
        $scope.$watch('vm.paidWithOtherDebit', function(newValue, oldValue) {
            vm.updateAmountPaid();
        })


        //loading sale
        api.sale.save({
                saleId : saleId
            },
            function(response){
                vm.sale = response.d;


                api.customer.save({
                    customerId : response.d.customerId
                }, function(response){
                    //verificando credito e debito
                    vm.customer = response.d;
                    console.log(vm.customer);
                    if ((vm.customer.creditDebitTransactions != undefined) && (vm.customer.creditDebitTransactions.length > 0)){
                        vm.customer.lastCreditDebitObservation = vm.customer.creditDebitTransactions[vm.customer.creditDebitTransactions.length-1].observation;
                    } else {
                        vm.customer.lastCreditDebitObservation = 0;
                    }

                    if (vm.customer.creditDebit == null){
                        vm.customer.creditDebit = 0;
                    }


                    //vm.paid = vm.paid - vm.customer.creditDebit;

                    //if (vm.paid < 0){
                    //    vm.paid = 0;
                    //}

                }, function(err){

                });

            },
            function(error){


            });




        //////////
        function closeDialog(){
            $mdDialog.cancel();
        }
        function clickToSave(){
            if (pdvConfiguration.requestPasswordCheckout) {

                $mdDialog.show({
                    template: [
                        '<md-dialog md-theme="{{ dialog.theme || dialog.defaultTheme }}" aria-label="{{ dialog.ariaLabel }}" ng-class="dialog.css">',
                        '  <md-dialog-content class="md-dialog-content" role="document" tabIndex="-1">',
                        '    <h2 class="md-title">{{ dialog.title }}</h2>',
                        '    <div class="md-dialog-content-body">',
                        '      <p>Informe a sua senha</p>',
                        '    </div>',
                        '    <md-input-container md-no-float class="md-prompt-input-container">',
                        '      <input type=password ng-keypress="dialog.keypress($event)" md-autofocus ng-model="dialog.result" ' +
                        '             placeholder="{{::dialog.placeholder}}">',
                        '    </md-input-container>',
                        '  </md-dialog-content>',
                        '  <md-dialog-actions>',
                        '    <md-button ng-click="dialog.abort()" class="md-primary md-cancel-button">',
                        '      {{ dialog.cancel }}',
                        '    </md-button>',
                        '    <md-button ng-click="dialog.hide()" class="md-primary md-confirm-button" >',
                        '      {{ dialog.ok }}',
                        '    </md-button>',
                        '  </md-dialog-actions>',
                        '</md-dialog>'
                    ].join('').replace(/\s\s+/g, ''),
                    multiple: true,
                    controller: function mdDialogCtrl() {
                        this.title = "Confirmação";
                        this.placeholder = "Senha";
                        this.ok = 'Confirmar';
                        this.cancel = 'Cancelar';
                        this.mdTextContent = "Informe sua senha";

                        this.hide = function () {
                            $mdDialog.hide(this.result);
                        };
                        this.abort = function () {
                            $mdDialog.cancel();
                        };
                        this.keypress = function ($event) {
                            if ($event.keyCode === $mdConstant.KEY_CODE.ENTER) {
                                $mdDialog.hide(this.result);
                            }
                        };
                    },
                    controllerAs: 'dialog',
                    bindToController: true,

                })
                    .then(function (result) {
                        console.log(result);
                        //check password
                        api.checkPassword.save({
                                password: result
                            },
                            function (response) {
                                if (response.d) {
                                    $mdDialog.hide();
                                    saveCheckout();
                                } else {
                                    $mdToast.show(
                                        $mdToast.simple()
                                            .textContent($translate.instant("AUTH.WRONG_PASSWORD"))
                                            .hideDelay(1000)
                                    );
                                    // $mdDialog.hide();


                                }

                            },
                            function (error) {


                            });
                    }, function () {
                        $mdDialog.cancel();
                    });

            } else {
                saveCheckout();
            }
        }
        function saveCheckout(){
            vm.processing = true;
            //checa se tem troco e se deve mudar o valor antes de fazer o checkout de fato
            if (vm.paid > vm.amountOwnedAfterDiscount) {
                var troco = vm.paid - vm.amountOwnedAfterDiscount;

                $mdDialog.show({
                    template: [
                        '<md-dialog md-theme="{{ dialog.theme || dialog.defaultTheme }}" aria-label="{{ dialog.ariaLabel }}" ng-class="dialog.css">',
                        '  <md-dialog-content class="md-dialog-content" role="document" tabIndex="-1">',
                        '    <h2 class="md-title">Confirmação</h2>',
                        '    <div class="md-dialog-content-body">',
                        '      <p>O que deseja fazer com o troco de R$ ' + troco + '?',
                        '    </div>',
                        '  </md-dialog-content>',
                        '  <md-dialog-actions>',
                        '    <md-button ng-click="dialog.comoCredito()" class="md-primary md-cancel-button">',
                        '      Deixar como crédito',
                        '    </md-button>',
                        '    <md-button ng-click="dialog.comoTroco()" class="md-primary md-confirm-button" >',
                        '      Devolver o troco',
                        '    </md-button>',
                        '  </md-dialog-actions>',
                        '</md-dialog>'
                    ].join('').replace(/\s\s+/g, ''),
                    multiple: true,
                    controller: function mdDialogCtrl() {
                        this.comoCredito = function () {
                            $mdDialog.hide('CREDIT');
                        };
                        this.comoTroco = function () {
                            $mdDialog.hide('TROCO');
                        };
                    },
                    controllerAs: 'dialog',
                    bindToController: true,

                })
                    .then(function (result) {
                        if (result == 'CREDIT'){
                            saveCheckout2()
                        } else {
                            //nesse caso o sistema deve dar o troco do cliente
                            //o operador dara o troco informado e o sistema reduz o valor pago em dinheiro

                            if (vm.paidWithCASH - troco < 0){
                                alert('Operação de saque de caixa não é permitida');
                            } else {
                                vm.paidWithCASH = vm.paidWithCASH - troco;
                                vm.updateAmountPaid();
                                saveCheckout2();
                            }

                        }
                    }, function () {
                        $mdDialog.cancel();
                    });

            } else {
                saveCheckout2();
            }
        }
        //de fato o checkout
        function saveCheckout2(){
            var customerCreditDebit = 0;
            customerCreditDebit = vm.paid - vm.amountOwnedAfterDiscount - vm.paidWithCUSTOMERDEBIT;


            api.saveSale.save({
                    items : items,
                    saleId: saleId,
                    status : 'CLOSED',
                    paid : vm.paid,
                    debitPayment: vm.paidWithCUSTOMERDEBIT,
                    ownedValue : vm.amountOwnedAfterDiscount,
                    totalValue : vm.totalValue,
                    totalValueWithSpecialPaymentType : vm.totalValueWithSpecialPaymentType,
                    customerId : vm.customer._id,
                    customerName : vm.customer.name,
                    paymentType : vm.paymentType,
                    serviceRequestId : vm.sale.serviceRequestId,
                    //customerCreditDebit : vm.paid - vm.amountOwned,
                    customerCreditDebit : customerCreditDebit,
                    userWillReceiveCredit : vm.userWillReceiveCredit,
                    giftCardValue : vm.giftCardValue,
                    giftCardObservation : vm.giftCardObservation,
                    offer : vm.offer,
                    accessCode : vm.accessCode,
                    offerExplanation : vm.offerExplanation,
                    paidWithCHECK : vm.paidWithCHECK,
                    paidWithCASH : vm.paidWithCASH,
                    paidWithVisaCredit : vm.paidWithVisaCredit,
                    paidWithVisaDebit: vm.paidWithVisaDebit,
                    paidWithMasterCredit : vm.paidWithMasterCredit,
                    paidWithMasterDebit : vm.paidWithMasterDebit,
                    paidWithAMEX : vm.paidWithAMEX,
                    paidWithDINERS : vm.paidWithDINERS,
                    paidWithELOCredit : vm.paidWithELOCredit,
                    paidWithELODebit : vm.paidWithELODebit,
                    paidWithOtherCredit : vm.paidWithOtherCredit,
                    paidWithOtherDebit : vm.paidWithOtherDebit,
                    authorizationCodeVisaCredit : vm.authorizationCodeVisaCredit,
                    authorizationCodeVisaDebit : vm.authorizationCodeVisaDebit,
                    authorizationCodeMasterCredit : vm.authorizationCodeMasterCredit,
                    authorizationCodeMasterDebit : vm.authorizationCodeMasterDebit,
                    authorizationCodeAMEX : vm.authorizationCodeAMEX,
                    authorizationCodeDINERS : vm.authorizationCodeDINERS,
                    authorizationCodeELOCredit : vm.authorizationCodeELOCredit,
                    authorizationCodeELODebit : vm.authorizationCodeELODebit,
                    authorizationCodeOtherCredit : vm.authorizationCodeOtherCredit,
                    authorizationCodeOtherDebit : vm.authorizationCodeOtherDebit,

                    visaCreditOperadora : vm.visaCreditOperadora,
                    visaDebitOperadora : vm.visaDebitOperadora,
                    masterCreditOperadora : vm.masterCreditOperadora,
                    masterDebitOperadora : vm.masterDebitOperadora,
                    amexOperadora : vm.amexOperadora,
                    dinersOperadora : vm.dinersOperadora,
                    eloCreditOperadora : vm.eloCreditOperadora,
                    eloDebitOperadora : vm.eloDebitOperadora,
                    otherCreditOperadora : vm.otherCreditOperadora,
                    otherDebitOperadora : vm.otherDebitOperadora
                },
                function(response){

                    switch(response.s){
                        case 200:
                            $mdDialog.hide();

                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent($translate.instant("SALES.CHECKOUT.TOAST.SAVE.SUCCESS"))
                                    .hideDelay(2000)
                            );
                            //redirect
                            setTimeout(function(){
                                $state.go('app.sales.open');
                            }, 1000);
                            break;
                        case 401:
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent($translate.instant("SALES.CHECKOUT.TOAST.SAVE.ERROR401"))
                                    .hideDelay(2000)
                            );

                            break;
                        case 402:
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent($translate.instant("SALES.CHECKOUT.TOAST.SAVE.ERROR402"))
                                    .hideDelay(3000)
                            );
                            break;
                        case 500:
                            switch (response.d){
                                case "NO_CASHIER":
                                    $mdToast.show(
                                        $mdToast.simple()
                                            .textContent("Operador não tem caixa aberto!")
                                            .hideDelay(2000)
                                    );
                                    break;
                                default:
                                    $mdToast.show(
                                        $mdToast.simple()
                                            .textContent($translate.instant("SALES.CHECKOUT.TOAST.SAVE.ERROR"))
                                            .hideDelay(1000)
                                    );
                                    break;
                            }
                            break;
                        default:
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent($translate.instant("SALES.CHECKOUT.TOAST.SAVE.ERROR"))
                                    .hideDelay(1000)
                            );

                            //redirect
                            setTimeout(function(){
                                $state.go('app.sales.open');
                            }, 1000);

                            break;
                    }

                },
                function(error){


                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SALES.CHECKOUT.TOAST.SAVE.ERROR"))
                            .hideDelay(1000)
                    );

                    //redirect
                    setTimeout(function(){
                        $state.go('app.sales.open');
                    }, 1000);

                });
        }
    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.professional',
            [
                // 3rd Party Dependencies
                'datatables','datatables.fixedheader'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {


        $stateProvider.state('app.professional', {
            url    : '/professional'
        }).state('app.professional.list', {
            url    : '/list',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/professional/list.html',
                    controller : 'ProfessionalController as vm'
                }
            }
        }).state('app.professional.new', {
            url    : '/new/:wizard',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/professional/professional.html',
                    controller : 'ProfessionalController as vm'
                }
            }
        }).state('app.professional.edit', {
            url    : '/edit/:professionalId',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/professional/professional.html',
                    controller : 'ProfessionalController as vm'
                }
            }
        }).state('app.professional.invite', {
            url    : '/invite',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/professional/inviteProfessional.html',
                    controller : 'ProfessionalController as vm'
                }
            }
        }).state('app.professional.service', {
            url    : '/service'
        }).state('app.professional.service.list', {
            url    : '/list/:professionalId',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/professional/servicelist.html',
                    controller : 'ProfessionalController as vm'
                }
            }
        }).state('app.professional.service.new', {
            url    : '/new/:professionalId',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/professional/service.html',
                    controller : 'ProfessionalController as vm'
                }
            }
        }).state('app.professional.service.edit', {
            url    : '/edit/:professionalId/:serviceId',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/professional/service.html',
                    controller : 'ProfessionalController as vm'
                }
            }
        }).state('app.professional.block', {
            url    : '/block'
        }).state('app.professional.block.list', {
            url    : '/list/:professionalId',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/professional/blocklist.html',
                    controller : 'ProfessionalController as vm'
                }
            }
        }).state('app.professional.block.new', {
            url    : '/new/:professionalId',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/professional/block.html',
                    controller : 'ProfessionalController as vm'
                }
            }
        }).state('app.professional.advance', {
            url    : '/advance'
        }).state('app.professional.advance.list', {
            url    : '/list',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/professional/advanceList.html',
                    controller : 'ProfessionalController as vm'
                }
            }
        }).state('app.professional.advance.new', {
            url    : '/new',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/professional/advance.html',
                    controller : 'ProfessionalController as vm'
                }
            }
        }).state('app.professional.advance.edit', {
            url    : '/new/:paymentId',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/professional/advance.html',
                    controller : 'ProfessionalController as vm'
                }
            }
        }).state('app.professional.relatedPDV', {
            url    : '/relatedPDV',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/professional/relatedPDV.html',
                    controller : 'ProfessionalController as vm'
                }
            }
        }).state('app.professional.changePassword', {
            url    : '/changePassword',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/professional/changePassword.html',
                    controller : 'ProfessionalController as vm'
                }
            }
        }).state('app.professional.changeMyInfo', {
            url    : '/changeMyInfo',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/professional/changeMyInfo.html',
                    controller : 'ProfessionalController as vm'
                }
            }
        });



        // Api
        //msApiProvider.register('tables.employees100', ['app/data/tables/employees100.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.professional')
        .controller('ProfessionalController', ProfessionalController);

    /** @ngInject */
    function ProfessionalController($state, $scope,DTOptionsBuilder,DTColumnBuilder,api,
                                    DTDefaultOptions, $translate, $mdDialog, $mdToast, $rootScope)
    {
        var vm = this;

        //check if is edit, insert or nothing
        var currentState = $state.current.name;
        vm.wizard = $state.params.wizard;
        var paymentId = {};
        vm.changePassword = changePassword;
        vm.changeMyInfo = changeMyInfo;


        //Initialize
        switch (currentState) {
            case "app.professional.changePassword":
                vm.user = {};
                vm.user.codigoAcesso = $rootScope.userAccessCode;
                break;
            case "app.professional.changeMyInfo":
                vm.name = $rootScope.userName;
                break;
            case "app.professional.relatedPDV":
                vm.removeRelatedPDV = removeRelatedPDV;
                vm.setAsDefault = setAsDefault;

                api.getRelatedPDVS.save({
                    },
                    function(response){
                        vm.pdvRelated = response.d;
                        setTimeout(function(){
                            vm.showTable = true;
                            $scope.$apply();
                        },200)

                    },
                    function(error){
                        console.log(error);
                    });

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({autoWidth : false})
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable":     "Nenhum registro disponível",
                        "sInfo":           "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty":      "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered":   "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix":    "",
                        "sInfoThousands":  ",",
                        "sLengthMenu":     "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing":     "Processando...",
                        "sSearch":         "Busca:",
                        "sZeroRecords":    "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst":    "Primeiro",
                            "sLast":     "Ultimo",
                            "sNext":     "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending":  ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });

                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');


                break;
            case "app.professional.list":
                vm.showTable = false;
                vm.removeProfessional = removeProfessional;
                vm.goToServiceList = goToServiceList;
                vm.goToEditProfessional = goToEditProfessional;
                vm.goToBlockList = goToBlockList;

                api.allSimpleProfessionals.save({
                    },
                    function(response){
                        vm.professionals = response.d;

                        for(var i=0; i < vm.professionals.length; i++){
                            if (vm.professionals[i].status == 'PENDING'){
                                vm.professionals[i].status = 'Pendente de Aprovação';
                            }

                            if (vm.professionals[i].name == undefined){
                                vm.professionals[i].name = '-';
                            }

                            //console.log(vm.professionals[i].email);
                        }


                        setTimeout(function(){
                            vm.showTable = true;
                            $scope.$apply();
                        },200)

                    },
                    function(error){
                        console.log(error);
                    });

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({autoWidth : false})
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable":     "Nenhum registro disponível",
                        "sInfo":           "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty":      "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered":   "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix":    "",
                        "sInfoThousands":  ",",
                        "sLengthMenu":     "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing":     "Processando...",
                        "sSearch":         "Busca:",
                        "sZeroRecords":    "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst":    "Primeiro",
                            "sLast":     "Ultimo",
                            "sNext":     "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending":  ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });

                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                break;
            case "app.professional.block.list":
                vm.showTable = false;
                vm.removeProfessionalBlock = removeProfessionalBlock;
                vm.professionalId = $state.params.professionalId;

                api.serviceProfessional.save({
                        professionalId: $state.params.professionalId
                    },
                    function(response){
                        vm.professional = response.d;
                        var arTemp = [];
                        for(var i=0; i < response.d.blockedSchedule.length; i++){
                            var obj = response.d.blockedSchedule[i];

                            switch(obj.type){
                                case "EVERYDAY":
                                    var hourFrom = parseInt(parseInt(obj.timeFrom)/60) ;
                                    var minuteFrom = parseInt(obj.timeFrom) - (hourFrom*60);
                                    var hourTo = parseInt(parseInt(obj.timeTo)/60) ;
                                    var minuteTo = parseInt(obj.timeTo) - (hourTo*60);

                                    if (hourFrom < 10){
                                        hourFrom = "0" + hourFrom;
                                    }
                                    if (minuteFrom < 10){
                                        minuteFrom = "0" + minuteFrom;
                                    }
                                    if (hourTo < 10){
                                        hourTo = "0" + hourTo;
                                    }
                                    if (minuteTo < 10){
                                        minuteTo = "0" + minuteTo;
                                    }

                                    obj.period = $translate.instant('GENERAL.EVERYDAY') + "  " +
                                        $translate.instant('GENERAL.FROM') + " " + hourFrom + ":" + minuteFrom + " " +
                                        $translate.instant('GENERAL.TO') + " " + hourTo + ":" + minuteTo;

                                    break;
                                case "RECURSIVE_TIME":
                                    var weekday = $translate.instant('GENERAL.DAYOFWEEK.' + obj.weekday.toUpperCase());
                                    var hourFrom = parseInt(parseInt(obj.timeFrom)/60) ;
                                    var minuteFrom = parseInt(obj.timeFrom) - (hourFrom*60);
                                    var hourTo = parseInt(parseInt(obj.timeTo)/60) ;
                                    var minuteTo = parseInt(obj.timeTo) - (hourTo*60);

                                    if (hourFrom < 10){
                                        hourFrom = "0" + hourFrom;
                                    }
                                    if (minuteFrom < 10){
                                        minuteFrom = "0" + minuteFrom;
                                    }
                                    if (hourTo < 10){
                                        hourTo = "0" + hourTo;
                                    }
                                    if (minuteTo < 10){
                                        minuteTo = "0" + minuteTo;
                                    }

                                    obj.period = weekday + " " + $translate.instant('GENERAL.FROM') + " " + hourFrom + ":" + minuteFrom + " " +
                                        $translate.instant('GENERAL.TO') + " " + hourTo + ":" + minuteTo;

                                    break;
                            }

                            arTemp.push(obj)

                        }
                        vm.blockedSchedule = arTemp;
                        setTimeout(function(){
                            vm.showTable = true;
                            $scope.$apply();
                        },200)

                    },
                    function(error){
                        console.log(error);
                    });

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({autoWidth : false})
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable":     "Nenhum registro disponível",
                        "sInfo":           "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty":      "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered":   "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix":    "",
                        "sInfoThousands":  ",",
                        "sLengthMenu":     "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing":     "Processando...",
                        "sSearch":         "Busca:",
                        "sZeroRecords":    "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst":    "Primeiro",
                            "sLast":     "Ultimo",
                            "sNext":     "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending":  ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });

                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                break;
            case "app.professional.service.list":
                vm.showTable = false;
                vm.removeProfessionalService = removeProfessionalService;
                vm.professionalId = $state.params.professionalId;
                vm.getServicePrice = getServicePrice;
                vm.getServiceDuration = getServiceDuration;
                vm.getServiceEnabled = getServiceEnabled;
                vm.editServiceProfessional = editServiceProfessional;

                loadServices(function(data){
                    vm.services = data.services;
                    vm.categories = data.categories;
                    setTimeout(function(){
                        vm.showTable = true;
                        $scope.$apply();
                    },200)

                });


                api.serviceProfessional.save({
                        professionalId: $state.params.professionalId
                    },
                    function(response){
                        vm.professional = response.d;


                    },
                    function(error){
                        console.log(error);
                    });

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({autoWidth : false})
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable":     "Nenhum registro disponível",
                        "sInfo":           "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty":      "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered":   "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix":    "",
                        "sInfoThousands":  ",",
                        "sLengthMenu":     "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing":     "Processando...",
                        "sSearch":         "Busca:",
                        "sZeroRecords":    "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst":    "Primeiro",
                            "sLast":     "Ultimo",
                            "sNext":     "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending":  ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });

                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                break;
            case "app.professional.block.new":
                vm.professionalId = $state.params.professionalId;
                vm.saveBlockProfessional = saveBlockProfessional;
                vm.block = {
                    reason : '',
                    periodFromDate : new Date(),
                    periodToDate : new Date(),
                    periodFromTime : 480,
                    periodToTime : 480,
                    type:'PERIOD',
                    weekday:'monday',
                    _id : ''
                }
                vm.timetable = loadTimeTable();



                break;
            case "app.professional.advance.list":

                vm.showTable = false;
                vm.removeProfessionalAdvance = removeProfessionalAdvance;
                vm.professionalId = $state.params.professionalId;
                vm.editProfessionalAdvance = editProfessionalAdvance;


                api.professionalAdvances.save({

                    },
                    function(response){
                        vm.payments = response.d;
                        vm.showTable = true;
                    },
                    function(error){
                        console.log(error);
                    });

                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({autoWidth : false})
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable":     "Nenhum registro disponível",
                        "sInfo":           "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty":      "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered":   "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix":    "",
                        "sInfoThousands":  ",",
                        "sLengthMenu":     "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing":     "Processando...",
                        "sSearch":         "Busca:",
                        "sZeroRecords":    "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst":    "Primeiro",
                            "sLast":     "Ultimo",
                            "sNext":     "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending":  ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });

                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                break;
            case "app.professional.invite":
                vm.inviteProfessional = inviteProfessional;

                break;
            case "app.professional.advance.new":
                //lidando com datas
                $scope.$on('$viewContentLoaded', function (event) {
                    $("datePicker").prop('readonly', true);

                    angular.element(".md-datepicker-button").each(function () {
                        var el = this;
                        var ip = angular.element(el).parent().find("input").bind('click', function (e) {
                            angular.element(el).click();
                        });
                        angular.element(this).css('visibility', 'hidden');
                    });


                });
                paymentId = $state.params.paymentId;
                vm.saveProfessionalAdvance = saveProfessionalAdvance;
                vm.advance = {
                    when : new Date()
                }

                api.serviceProfessionals.save({
                    },
                    function(response){
                        vm.professionals = response.d;
                    },
                    function(error){
                        console.log(error);
                    });

                break;
            case "app.professional.advance.edit":
                //lidando com datas
                $scope.$on('$viewContentLoaded', function (event) {
                    $("datePicker").prop('readonly', true);

                    angular.element(".md-datepicker-button").each(function () {
                        var el = this;
                        var ip = angular.element(el).parent().find("input").bind('click', function (e) {
                            angular.element(el).click();
                        });
                        angular.element(this).css('visibility', 'hidden');
                    });


                });
                paymentId = $state.params.paymentId;

                vm.saveProfessionalAdvance = saveProfessionalAdvance;
                api.professionalAdvance.save({
                    paymentId : paymentId
                    },
                    function(response){
                        vm.advance = response.d;
                        vm.advance.when = new Date(vm.advance.when);
                    },
                    function(error){
                        console.log(error);
                    });

                api.serviceProfessionals.save({
                    },
                    function(response){
                        vm.professionals = response.d;
                    },
                    function(error){
                        console.log(error);
                    });

                break;
            case "app.professional.service.edit":
                vm.serviceId = $state.params.serviceId;
                vm.professionalId = $state.params.professionalId;
                vm.getServiceEnabled = getServiceEnabled;

                api.serviceProfessional.save({
                        professionalId: $state.params.professionalId
                    },
                    function(response){
                        vm.professional = response.d;

                        vm.serviceEnabled = "NO";
                        for(var i=0; i < vm.professional.services.length; i++){
                            if (vm.professional.services[i].serviceId == $state.params.serviceId){
                                vm.serviceEnabled = "YES";
                                vm.price = vm.professional.services[i].price;
                                vm.comission = vm.professional.services[i].comission;
                                vm.duration = vm.professional.services[i].duration;
                                break;
                            }
                        }

                        if (vm.serviceEnabled == "NO"){
                            loadServices(function(data){
                                for(var i=0; i < data.services.length; i++){
                                    if (vm.serviceId == data.services[i]._id){
                                        vm.price = data.services[i].price;
                                        vm.comission = data.services[i].comission;
                                        vm.duration = data.services[i].duration;
                                        break;
                                    }
                                }
                            });


                        }


                        setTimeout(function(){
                            vm.showTable = true;
                            $scope.$apply();
                        },200)

                    },
                    function(error){
                        console.log(error);
                    });


                vm.saveServiceProfessional = saveServiceProfessional;
                //vm.timetable = loadTimeTable();

                break;
            case "app.professional.new":
                vm.saveProfessional = saveProfessional;
                vm.professional = {
                    name : '',
                    email : '',
                    telephone : '',
                    cpf : '',
                    scheduleGroup : 0,
                    contractType : 'CLT',
                    services : [],
                    slots : []
                };

                vm.clickCategory = function(category, enable){
                    for(var i=0; i < category.services.length; i++){
                        vm.chkService[category.services[i]._id] = enable;
                    }

                }


                loadServices(function(data){
                    vm.services = data.services;
                    vm.servicePrice={};
                    vm.serviceComissionPrice={};
                    vm.serviceComission={};
                    vm.serviceDuration={};
                    vm.chkService = {};
                    vm.chkCategory=[];
                    for(var i=0; i < vm.services.length; i++){
                        //vm.servicePrice[vm.services[i]._id] = vm.services[i].price;
                        //vm.serviceComissionPrice[vm.services[i]._id] = vm.services[i].comissionPrice;
                        vm.serviceComission[vm.services[i]._id] = vm.services[i].comission;
                        vm.serviceComissionAjudante[vm.services[i]._id] = 0;
                        vm.serviceDuration[vm.services[i]._id] = vm.services[i].duration;
                    }
                    vm.categories = data.categories;
                    for(var i=0; i < vm.categories.length; i++){
                        var arTemp = [];
                        for(var j=0; j < vm.services.length; j++){
                            if (vm.categories[i]._id == vm.services[j].categoryId){
                                arTemp.push(vm.services[j]);
                                vm.chkService[vm.services[j]._id] = false;
                            }
                        }
                        vm.categories[i].services = arTemp;
                        vm.chkCategory[vm.categories[i]._id] = false;

                        //adicionando o watches
                        vm.updateServiceValues = function(categoryId){
                            for(var j=0; j < vm.services.length; j++){
                                if (categoryId == vm.services[j].categoryId){
                                    vm.serviceComission[vm.services[j]._id] = vm.categoryComission[categoryId];
                                    vm.serviceComissionAjudante[vm.services[j]._id] = vm.categoryComissionAjudante[categoryId];
                                }
                            }
                        }

                    }

                })

                initializeTimetable();

                //loading defaults
                vm.businessHours = {};
                vm.businessHours.workMonday = 'YES';
                vm.businessHours.workTuesday = 'YES';
                vm.businessHours.workWednesday = 'YES';
                vm.businessHours.workThursday = 'YES';
                vm.businessHours.workFriday = 'YES';
                vm.businessHours.workSaturday = 'YES';
                vm.businessHours.workSunday = 'NO';

                //loading default time
                vm.businessHours.openTimeMonday = 540;
                vm.businessHours.closeTimeMonday = 1020;

                vm.businessHours.openTimeTuesday = 540;
                vm.businessHours.closeTimeTuesday = 1020;

                vm.businessHours.openTimeWednesday = 540;
                vm.businessHours.closeTimeWednesday = 1020;

                vm.businessHours.openTimeThursday = 540;
                vm.businessHours.closeTimeThursday = 1020;

                vm.businessHours.openTimeFriday = 540;
                vm.businessHours.closeTimeFriday = 1020;

                vm.businessHours.openTimeSaturday = 540;
                vm.businessHours.closeTimeSaturday = 1020;

                vm.businessHours.openTimeSunday = 540;
                vm.businessHours.closeTimeSunday = 1020;

                break;

            case "app.professional.edit":
                vm.saveProfessional = saveProfessional;
                initializeTimetable();
                vm.chkService = {};
                vm.serviceComission={};
                vm.serviceDuration={};


                //clique na categoria
                vm.clickCategory = function(category, enable){
                    for(var i=0; i < category.services.length; i++){
                        vm.chkService[category.services[i]._id] = enable;
                    }

                    vm.categoryIndeterminate[category._id] = false;

                }
                vm.clickService = function(category){


                    setTimeout(function(){
                        var todos = true;
                        var nenhum = true;
                        var indeterminado = false;
                        for(var j=0 ; j < category.services.length; j++){

                            if (vm.chkService[category.services[j]._id]){
                                nenhum=false;
                            }  else {
                                todos=false;
                            }

                            if (!todos && !nenhum){
                                indeterminado=true;
                                break;
                            }
                        }


                        if (todos){
                            vm.chkCategory[category._id] = true;
                            vm.categoryIndeterminate[category._id] = false;
                        } else if (nenhum){
                            vm.chkCategory[category._id] = false;
                            vm.categoryIndeterminate[category._id] = false;
                        } else {
                            vm.chkCategory[category._id] = false;
                            vm.categoryIndeterminate[category._id] = true;

                        }
                    },1000)


                }


                loadServices(function(dataServices){
                    vm.services = dataServices.services;
                    vm.categories = dataServices.categories;
                    vm.servicePrice={};
                    vm.serviceComissionPrice={};
                    vm.serviceComission={};
                    vm.serviceComissionAjudante = {};
                    vm.serviceDuration={};
                    vm.chkService = {};
                    vm.chkCategory=[];
                    vm.categoryIndeterminate = {};


                    //removendo as categorias vazias
                    var arTemp = [];
                    for(var i=0; i < vm.categories.length; i++){
                        var found  = false;

                        for(var j=0; j < vm.services.length; j++) {
                            if (vm.services[j].category._id == vm.categories[i]._id){
                                found = true;
                            }
                        }
                        if (found){
                            arTemp.push(vm.categories[i]);
                        }
                    }
                    vm.categories = arTemp;

                    for(var i=0; i < vm.services.length; i++){
                        //vm.servicePrice[vm.services[i]._id] = vm.services[i].price;
                        //vm.serviceComissionPrice[vm.services[i]._id] = vm.services[i].comissionPrice;
                        //vm.serviceComission[vm.services[i]._id] = vm.services[i].comission;
                        vm.serviceDuration[vm.services[i]._id] = vm.services[i].duration  ;
                    }


                    for(var i=0; i < vm.categories.length; i++){
                        var arTemp = [];
                        for(var j=0; j < vm.services.length; j++){
                            if (vm.categories[i]._id == vm.services[j].categoryId){
                                arTemp.push(vm.services[j]);
                                vm.chkService[vm.services[j]._id] = false;
                            }
                        }
                        vm.categories[i].services = arTemp;
                        vm.chkCategory[vm.categories[i]._id] = false;

                        //adicionando o watches
                        vm.updateServiceValues = function(categoryId){
                            for(var j=0; j < vm.services.length; j++){
                                if (categoryId == vm.services[j].categoryId){
                                    if (vm.categoryComission != null){
                                        vm.serviceComission[vm.services[j]._id] = vm.categoryComission[categoryId];
                                    }
                                    if (vm.categoryComissionAjudante != null){
                                        vm.serviceComissionAjudante[vm.services[j]._id] = vm.categoryComissionAjudante[categoryId];
                                    }

                                }
                            }
                        }

                    }

                    //load professional
                    loadProfessional($state.params.professionalId, function(data){

                        vm.professional = data;


                        //loading defaults
                        vm.businessHours = data.businessHours;

                        //checking hasSchedule
                        if (vm.professional.hasSchedule == 1){
                            vm.professional.hasSchedule = true;
                        } else {
                            vm.professional.hasSchedule = false;
                        }


                        if (data.services != null){
                            for(var j=0; j < data.services.length; j++){
                                vm.chkService[data.services[j].serviceId] = true;
                                vm.serviceComission[data.services[j].serviceId] = data.services[j].comission;
                                vm.serviceComissionAjudante[data.services[j].serviceId] = data.services[j].comissionAjudante;
                                vm.serviceDuration[data.services[j].serviceId] = data.services[j].duration;
                            }
                        }


                        for(var i=0; i < vm.categories.length; i++){
                            var todos = true;
                            var nenhum = true;
                            for(var j=0 ; j < vm.categories[i].services.length; j++){
                                var found = false;
                                for(var k=0; k < data.services.length; k++) {
                                    if (data.services[k].serviceId == vm.categories[i].services[j]._id){
                                        nenhum = false;
                                        found = true;
                                        break;
                                    }
                                }
                                if (!found){
                                    todos=false;
                                    break;
                                }
                            }

                            if (todos){
                                vm.chkCategory[vm.categories[i]._id] = true;
                                vm.categoryIndeterminate[vm.categories[i]._id] = false;
                            } else if (nenhum){
                                vm.chkCategory[vm.categories[i]._id] = false;
                                vm.categoryIndeterminate[vm.categories[i]._id] = false;
                            } else {
                                vm.chkCategory[vm.categories[i]._id] = false;
                                vm.categoryIndeterminate[vm.categories[i]._id] = true;
                            }

                        }



                    })


                })




                break;
        }


        // Methods
        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({},last);
        $scope.getToastPosition = function() {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function(pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if ( current.bottom && last.top ) current.top = false;
            if ( current.top && last.bottom ) current.bottom = false;
            if ( current.right && last.left ) current.left = false;
            if ( current.left && last.right ) current.right = false;
            last = angular.extend({},current);
        }
        ///END TOAST

        function loadTimeTable(){
            var arTemp = [];
            for(var i=0; i < 1440; i = i + 15){
                var hour = parseInt(i/60);
                if (hour < 10){
                    hour = "0" + hour;
                }

                var minute = i - (hour * 60);

                if (minute < 10){
                    minute = "0" + minute;
                }



                var obj = {
                    time : i,
                    timeStr : hour + ":" + minute
                }
                arTemp.push(obj);
            }

            return arTemp;
        }

        function setAsDefault(pdvId){
            api.setRelatedPDVAsDefault.save({
                    pdvId: pdvId
                },
                function(response){
                    if (response.s == 200){
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Salão default alterado com sucesso")
                                .hideDelay(1000)
                        );
                        //redirect
                        setTimeout(function(){
                            $state.reload();
                        }, 1000);
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Erro ao alterar salão default")
                                .hideDelay(1000)
                        );
                    }

                },
                function(error){
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Erro ao alterar salão default")
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function(){
                        $state.reload();
                    }, 1000);
                });
        }

        function removeRelatedPDV(pdvId){
            api.removeRelatedPDV.save({
                    pdvId: pdvId
                },
                function(response){
                    if (response.s == 200){
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Salão vinculado removido")
                                .hideDelay(1000)
                        );
                        //redirect
                        setTimeout(function(){
                            $state.reload();
                        }, 1000);
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Erro ao remover vínculo")
                                .hideDelay(1000)
                        );
                    }

                },
                function(error){
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Erro ao enviar convite")
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function(){
                        $state.reload();
                    }, 1000);
                });
        }

        function initializeTimetable(){
            vm.timetable = [];

            for(var i=0 ;i < 1440; i = i + 30){
                var obj = {};
                obj.value = i;
                var hour = "";
                hour = parseInt(i/60);
                if (hour < 10){
                    hour = "0" + hour;
                }
                var minutes = "";
                minutes = i - (parseInt(i/60)*60);
                if (minutes < 10){
                    minutes = "0" + minutes;
                }

                obj.text = hour + ":" + minutes;

                vm.timetable.push(obj);
            }

        }




        function toggleServiceSelection(serviceId) {
            var idx = vm.selectedServices.indexOf(serviceId);

            // is currently selected
            if (idx > -1) {
                vm.selectedServices.splice(idx, 1);
            } else {
                vm.selectedServices.push(serviceId);
            }

            vm.professional.services = vm.selectedServices;

        }

        function isSlotChecked(time, day){
            for(var i = 0 ; i < vm.timetable.length; i++){
                if (vm.timetable[i].time == time){
                    switch (day){
                        case "MONDAY":
                            return vm.timetable[i].monday;
                        case "TUESDAY":
                            return vm.timetable[i].tuesday;
                        case "WEDNESDAY":
                            return vm.timetable[i].wednesday;
                        case "THURSDAY":
                            return vm.timetable[i].thursday;
                        case "FRIDAY":
                            return vm.timetable[i].friday;
                        case "SATURDAY":
                            return vm.timetable[i].saturday;
                        case "SUNDAY":
                            return vm.timetable[i].sunday;
                    }
                }


            }
        }

        function toggleSlotSelection(time, day) {
            for(var i = 0 ; i < vm.timetable.length; i++){
                if (vm.timetable[i].time == time){
                    switch (day){
                        case "MONDAY":
                            vm.timetable[i].monday = !vm.timetable[i].monday;
                            break;
                        case "TUESDAY":
                            vm.timetable[i].tuesday = !vm.timetable[i].tuesday;
                            break;
                        case "WEDNESDAY":
                            vm.timetable[i].wednesday = !vm.timetable[i].wednesday;
                            break;
                        case "THURSDAY":
                            vm.timetable[i].thursday = !vm.timetable[i].thursday;
                            break;
                        case "FRIDAY":
                            vm.timetable[i].friday = !vm.timetable[i].friday;
                            break;
                        case "SATURDAY":
                            vm.timetable[i].saturday = !vm.timetable[i].saturday;
                            break;
                        case "SUNDAY":
                            vm.timetable[i].sunday = !vm.timetable[i].sunday;
                            break;
                    }
                }

            }

            vm.professional.slots = vm.timetable;

        }

        function inviteProfessional(){
            api.inviteProfessional.save({
                    email: vm.user.email,
                    telephone:vm.user.telephone,
                    type:vm.user.type
                },
                function(response){
                    if (response.s == 200){
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Convite enviado com sucesso")
                                .hideDelay(1000)
                        );
                        //redirect
                        setTimeout(function(){
                            $state.go('app.professional.list');
                        }, 1000);
                    } 
                    else if (response.s == 502){
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Esse profissional já está vinculado ao salão.")
                                .hideDelay(2000)
                        );
                        //redirect
                        setTimeout(function(){
                            $state.go('app.professional.list');
                        }, 1000);
                    }                     
                    else {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Erro ao enviar convite")
                                .hideDelay(1000)
                        );
                    }

                },
                function(error){
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent("Erro ao enviar convite")
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function(){
                        $state.go('app.professional.list');
                    }, 1000);
                });
        }

        function changePassword(){
            api.changePassword.save(
                {
                    password:vm.user.password
                },
                function(response){
                    //toast and transfer
                    if (response.s == 200){

                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.ACCOUNT.CHANGEPASSWORD.TOAST.SAVE.SUCCESS"))
                                .hideDelay(1000)
                        );




                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.ACCOUNT.CHANGEPASSWORD.TOAST.SAVE.ERROR"))
                                .hideDelay(1000)
                        );
                    }
                },
                function(error){
                    console.log(error);
                });
        }

        function changeMyInfo(){
            api.changeMyInfo.save(
                {
                    name : vm.name
                },
                function(response){
                    //toast and transfer
                    if (response.s == 200){
                        $rootScope.userName = vm.name;
                        $rootScope.changeUserName(vm.name);

                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Informações salvas com sucesso")
                                .hideDelay(1000)
                        );


                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Erro ao salvar informações")
                                .hideDelay(1000)
                        );
                    }
                },
                function(error){
                    console.log(error);
                });
        }

        function saveProfessionalAdvance(){

            api.saveProfessionalAdvance.save({
                    _id: paymentId,
                    professionalId : vm.advance.professionalId,
                    value:vm.advance.value,
                    observation:vm.advance.observation,
                    when:vm.advance.when.valueOf()
                },
                function(response){
                    if (response.s == 200){
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("FINANCE.PROFESSIONAL_ADVANCE.TOAST.SUCCESS"))
                                .hideDelay(1000)
                        );
                        //redirect
                        setTimeout(function(){
                            $state.go('app.professional.advance.list');
                        }, 1000);
                    } else {
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("FINANCE.PROFESSIONAL_ADVANCE.TOAST.ERROR"))
                                .hideDelay(1000)
                        );
                    }

                },
                function(error){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("FINANCE.PROFESSIONAL_ADVANCE.TOAST.ERROR"))
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function(){
                        $state.go('app.professional.advance.list');
                    }, 1000);
                });
        }

        function loadProfessional(professionalId, callback){
            api.serviceProfessional.save({
                    professionalId : professionalId
                },
                function(response){
                    callback(response.d);
                },
                function(error){
                    console.log(error);
                });
        }
        function loadCategories(callback){
            api.serviceCategories.save({
                },
                function(response){
                    callback(response.d);
                },
                function(error){
                    console.log(error);
                });
        }

        function loadServices(callback){
            api.serviceServices.save({},
                function(response){
                    console.log(response);
                    callback(response.d);
                },
                function(error){
                    console.log(error);
                });
        }

        function servicesByCategoryId(categoryId){
            var arTemp = []
            for(var i = 0 ; i < vm.services.length; i++){
                if (vm.services[i].categoryId == categoryId){
                    arTemp.push(vm.services[i]);
                }
            }

            return arTemp;
        }

        function saveProfessional() {

            var arServices = [];
            for(var i=0; i < vm.services.length; i++){
                if (vm.chkService[vm.services[i]._id]){

                    var service = {
                        //"price" : vm.servicePrice[vm.services[i]._id],
                        //"comissionPrice" : vm.serviceComissionPrice[vm.services[i]._id],
                        "comission" : vm.serviceComission[vm.services[i]._id],
                        "comissionAjudante" : vm.serviceComissionAjudante[vm.services[i]._id],
                        "duration" : 30,
                        "serviceId" : vm.services[i]._id,
                        "categoryId" : vm.services[i].categoryId,
                    };

                    arServices.push(service);
                }
            }

            if (vm.professional.enableSMS == undefined){
                vm.professional.enableSMS = false;
            }
            if (vm.professional.enableEmail == undefined){
                vm.professional.enableEmail = false;
            }
            if (vm.professional.allowOverbooking == undefined){
                vm.professional.allowOverbooking = false;
            }
            if (vm.professional.hasSchedule == undefined){
                vm.professional.hasSchedule = false;
            }



            api.saveProfessional.save({
                    _id: vm.professional._id,
                    name: vm.professional.name,
                    email: vm.professional.email,
                    telephone : vm.professional.telephone,
                    enableSMS : 1,
                    enableEmail : 1,
                    cpf : vm.professional.cpf,
                    scheduleGroup : vm.professional.scheduleGroup,
                    services : arServices,
                    contractType : vm.professional.contractType,
                    allowOverbooking : 1,
                    businessHours : vm.businessHours,
                    blnSchedule : vm.professional.hasSchedule
                },
                function(response){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.SERVICE.PROFESSIONAL.TOAST.SAVE.SUCCESS"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );

                    if (currentState == 'app.professional.new'){
                        //show form to add another
                        var confirm = $mdDialog.confirm()
                            .title('Confirmação')
                            .textContent('Deseja salvar outro profissional?')
                            .ariaLabel('Confirmação')
                            .clickOutsideToClose(true)
                            .multiple(true)
                            .ok('Sim')
                            .cancel('Não');
                        $mdDialog.show(confirm).then(function() {
                            $state.reload();
                        }, function() {
                            if (vm.wizard){
                                $state.go('app.wizard');
                            } else {
                                $state.go('app.professional.list');
                            }
                        });

                    } else {
                        setTimeout(function(){
                            $state.go('app.professional.list');
                        }, 1000);
                    }

                },
                function(error){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.SERVICE.PROFESSIONAL.TOAST.SAVE.ERROR"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function(){
                        $state.go('app.professional.list');
                    }, 1000);
                });

        }

        function saveBlockProfessional(){
            //resgatar o block from
            var dtFrom = new moment(vm.block.periodFromDate.valueOf());
            var dtTo = new moment(vm.block.periodToDate.valueOf());

            var dateFrom = moment({
                year:dtFrom.year(),
                month:dtFrom.month(),
                date:dtFrom.date()
            })
            var dateTo = moment({
                year:dtTo.year(),
                month:dtTo.month(),
                date:dtTo.date()
            })
            var dateFromValue = dateFrom.valueOf() + vm.block.periodFromTime * 60 * 1000;
            var dateToValue = dateTo.valueOf() + vm.block.periodToTime * 60 * 1000;

            switch (vm.block.type){
                case "PERIOD":
                    if (dateToValue <= dateFromValue){
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.SERVICE.PROFESSIONAL.BLOCK.TOAST.VALIDATION.INVALID_DATE"))
                                .position(pinTo )
                                .hideDelay(1000)
                        );

                        return;
                    }
                    break;
                case "EVERYDAY":

                    if (vm.block.periodFromTime >= vm.block.periodToTime) {
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.SERVICE.PROFESSIONAL.BLOCK.TOAST.VALIDATION.INVALID_TIME"))
                                .position(pinTo)
                                .hideDelay(1000)
                        );

                        console.log('aaaa');
                        return;
                        break;
                    }
                    break;
                case "RECURSIVE_TIME":
                    if (vm.block.periodToTime <= vm.block.periodFromTime){
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.SERVICE.PROFESSIONAL.BLOCK.TOAST.VALIDATION.INVALID_TIME"))
                                .position(pinTo )
                                .hideDelay(1000)
                        );

                        return;
                    }

            }


            api.saveProfessionalBlock.save({
                    _id: $state.params.blockId,
                    professionalId : $state.params.professionalId,
                    reason: vm.block.reason,
                    periodFrom: dateFromValue,
                    periodTo : dateToValue,
                    type : vm.block.type,
                    timeFrom : vm.block.periodFromTime,
                    timeTo : vm.block.periodToTime,
                    weekday : vm.block.weekday
                },
                function(response){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.SERVICE.PROFESSIONAL.BLOCK.TOAST.SAVE.SUCCESS"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function(){
                        $state.go('app.professional.block.list',{professionalId:$state.params.professionalId});
                    }, 1000);
                },
                function(error){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.SERVICE.PROFESSIONAL.BLOCK.TOAST.SAVE.ERROR"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function(){
                        $state.go('app.professional.block.list',{professionalId:$state.params.professionalId});
                    }, 1000);
                });
        }

        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({},last);
        $scope.getToastPosition = function() {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function(pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if ( current.bottom && last.top ) current.top = false;
            if ( current.top && last.bottom ) current.bottom = false;
            if ( current.right && last.left ) current.left = false;
            if ( current.left && last.right ) current.right = false;
            last = angular.extend({},current);
        }
        ///END TOAST

        function saveServiceProfessional(){
            var serviceId = "";
            var duration = 0;
            var price = 0;
            var serviceName = "";
            var enabled = "NO";


            api.saveProfessionalService.save({
                    professionalId : $state.params.professionalId,
                    duration: vm.duration,
                    price: vm.price,
                    comission : vm.comission,
                    serviceId : vm.serviceId,
                    enabled : vm.serviceEnabled
                },
                function(response){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.SERVICE.PROFESSIONAL.SERVICE.TOAST.SAVE.SUCCESS"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function(){
                        $state.go('app.professional.service.list',{professionalId:$state.params.professionalId});
                    }, 1000);
                },
                function(error){
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SETTINGS.SERVICE.PROFESSIONAL.SERVICE.TOAST.SAVE.ERROR"))
                            .position(pinTo )
                            .hideDelay(1000)
                    );
                    //redirect
                    setTimeout(function(){
                        $state.go('app.professional.service.list',{professionalId:$state.params.professionalId});
                    }, 1000);
                });
        }

        function removeProfessionalAdvance(paymentId) {

            api.removeProfessionalAdvance.save({
                    paymentId: paymentId
                },
                function (response) {
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("FINANCE.PROFESSIONAL_ADVANCE.TOAST.REMOVE.SUCCESS"))
                            .hideDelay(2000)
                    );
                    //redirect
                    setTimeout(function () {
                        $state.reload();
                    }, 1000);
                },
                function (error) {
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("FINANCE.PROFESSIONAL_ADVANCE.TOAST.REMOVE.ERROR"))
                            .hideDelay(1000)
                    );

                    //redirect
                    setTimeout(function () {
                        $state.reload();
                    }, 1000);

                });

        }

        function removeProfessional(professionalId) {
            var confirm = $mdDialog.confirm()
                .title($translate.instant("SETTINGS.SERVICE.PROFESSIONAL.DIALOG.REMOVE.TITLE"))
                .textContent($translate.instant("SETTINGS.SERVICE.PROFESSIONAL.DIALOG.REMOVE.SUBTITLE"))
                .ariaLabel('Remove')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok($translate.instant("GENERAL.DIALOG.OK"))
                .cancel($translate.instant("GENERAL.DIALOG.CANCEL"));
            $mdDialog.show(confirm).then(function() {
                api.removeProfessional.save({
                        professionalId: professionalId
                    },
                    function(response){
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.SERVICE.PROFESSIONAL.TOAST.REMOVE.SUCCESS"))
                                .position(pinTo )
                                .hideDelay(2000)
                        );
                        //redirect
                        setTimeout(function(){
                            $state.reload();
                        }, 1000);
                    },
                    function(error){
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.SERVICE.PROFESSIONAL.TOAST.REMOVE.ERROR"))
                                .position(pinTo )
                                .hideDelay(1000)
                        );

                        //redirect
                        setTimeout(function(){
                            $state.reload();
                        }, 1000);

                    });
            });
        };

        function removeProfessionalBlock(blockId) {
            var confirm = $mdDialog.confirm()
                .title($translate.instant("SETTINGS.SERVICE.PROFESSIONAL.BLOCK.DIALOG.REMOVE.TITLE"))
                .textContent($translate.instant("SETTINGS.SERVICE.PROFESSIONAL.BLOCK.DIALOG.REMOVE.SUBTITLE"))
                .ariaLabel('Remove')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok($translate.instant("GENERAL.DIALOG.OK"))
                .cancel($translate.instant("GENERAL.DIALOG.CANCEL"));
            $mdDialog.show(confirm).then(function() {

                api.removeProfessionalBlock.save({
                        professionalId: vm.professionalId,
                        _id : blockId
                    },
                    function(response){
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.SERVICE.PROFESSIONAL.BLOCK.TOAST.REMOVE.SUCCESS"))
                                .position(pinTo )
                                .hideDelay(2000)
                        );
                        //redirect
                        setTimeout(function(){
                            $state.reload();
                        }, 1000);
                    },
                    function(error){
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.SERVICE.PROFESSIONAL.BLOCK.TOAST.REMOVE.ERROR"))
                                .position(pinTo )
                                .hideDelay(1000)
                        );

                        //redirect
                        setTimeout(function(){
                            $state.reload();
                        }, 1000);

                    });
            });
        };

        function removeProfessionalService(serviceId) {
            var confirm = $mdDialog.confirm()
                .title($translate.instant("SETTINGS.SERVICE.PROFESSIONAL.SERVICE.DIALOG.REMOVE.TITLE"))
                .textContent($translate.instant("SETTINGS.SERVICE.PROFESSIONAL.SERVICE.DIALOG.REMOVE.SUBTITLE"))
                .ariaLabel('Remove')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok($translate.instant("GENERAL.DIALOG.OK"))
                .cancel($translate.instant("GENERAL.DIALOG.CANCEL"));
            $mdDialog.show(confirm).then(function() {

                api.removeProfessionalService.save({
                        professionalId: vm.professionalId,
                        _id : serviceId
                    },
                    function(response){
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.SERVICE.PROFESSIONAL.SERVICE.TOAST.REMOVE.SUCCESS"))
                                .position(pinTo )
                                .hideDelay(2000)
                        );
                        //redirect
                        setTimeout(function(){
                            $state.reload();
                        }, 1000);
                    },
                    function(error){
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("SETTINGS.SERVICE.PROFESSIONAL.SERVICE.TOAST.REMOVE.ERROR"))
                                .position(pinTo )
                                .hideDelay(1000)
                        );

                        //redirect
                        setTimeout(function(){
                            $state.reload();
                        }, 1000);

                    });
            });
        };

        function getServicePrice(serviceId){
            for(var i=0; i < vm.professional.services.length; i++){
                if (vm.professional.services[i].serviceId == serviceId){
                    return vm.professional.services[i].price;
                }
            }

            if (vm.services != undefined){
                for(var i=0; i < vm.services.length; i++){
                    if (vm.services[i]._id == serviceId){
                        return vm.services[i].price;
                    }
                }
            }

        }

        function getServiceDuration(serviceId){
            for(var i=0; i < vm.professional.services.length; i++){
                if (vm.professional.services[i].serviceId == serviceId){
                    return vm.professional.services[i].duration;
                }
            }
            if (vm.services != undefined) {
                for (var i = 0; i < vm.services.length; i++) {
                    if (vm.services[i]._id == serviceId) {
                        return vm.services[i].duration;
                    }
                }
            }
        }

        function getServiceEnabled(serviceId){
            for(var i=0; i < vm.professional.services.length; i++){
                if (vm.professional.services[i].serviceId == serviceId){
                    return "SIM";
                }
            }

            return "NAO";
        }


        $scope.$watch('vm.service',function(newValue, oldValue){
            if (vm.services != undefined){
                for(var i=0; i < vm.services.length; i++){
                    if (vm.services[i]._id == vm.service){
                        vm.price = vm.services[i].price;
                        vm.duration = vm.services[i].duration;


                    }
                }
            }


        })

        function goToServiceList(professionalId){
            $state.go('app.professional.service.list',{professionalId:professionalId})
        }
        function goToEditProfessional(professionalId){
            $state.go('app.professional.edit',{professionalId:professionalId})
        }
        function goToBlockList(professionalId){
            $state.go('app.professional.block.list',{professionalId:professionalId})
        }
        function editServiceProfessional(professionalId, serviceId){
            $state.go('app.professional.service.edit',{professionalId:professionalId, serviceId:serviceId})
        }
        function editProfessionalAdvance(paymentId){
            $state.go('app.professional.advance.edit',{paymentId:paymentId})
        }


        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.finance', ['app.finance.extrato'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.finance', {
                url    : '/finance'
            })
            .state('app.finance.cashier', {
                url    : '/cashier',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/finance/cashier.html',
                        controller : 'FinanceController as vm'
                    }
                }
            })
             .state('app.finance.opencashier', {
                url: '/openCashier',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/finance/openCashier.html',
                        controller: 'FinanceController as vm'
                    }
                }
            })
            .state('app.finance.report', {
                url: '/report',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/finance/reportCashier.html',
                        controller: 'FinanceController as vm'
                    }
                }
            })
            .state('app.finance.tef', {
                url: '/tef',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/finance/tefTransactions.html',
                        controller: 'TEFController as vm'
                    }
                }
            })


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.finance')
        .controller('TEFController', TEFController);

    /** @ngInject */
    function TEFController(api, $translate, $scope, DTDefaultOptions,
                               DTColumnDefBuilder, DTOptionsBuilder, DTColumnBuilder,
                               $mdDialog, $mdToast, $state, $rootScope, $compile, $filter) {
        var vm = this;


        refreshVendas();

        /////////////////////////////////
        //////////
        function refreshVendas(){
            setFilter();


            api.getWoweePayVendas.save({
                    filter : vm.finalFilter
                },
                function(response){
                    vm.showTable = true;
                    vm.items = [];
                    for(var i=0; i < response.d.length; i++){
                        var status = "";
                        switch (response.d[i].status) {
                            case "succeeded":
                                status = "Aprovada" ;
                                break;
                            case "reversed":
                                status = "Revertida" ;
                                break;
                            default:
                                status = response.d[i].status;
                                break;

                        }
                        response.d[i].status = status;
                        vm.items.unshift(response.d[i]);
                    }





                },
                function(error){
                    console.log(error);
                });
        }

        function setFilter(){
            vm.finalFilter = {};

            //settng data
            vm.finalFilter.dtFrom = new moment().add(-1,'days').valueOf();
            vm.finalFilter.dtTo = new moment().valueOf();

        }

        vm.estornarTransacao = function(idZoop)
        {
            api.estornarTransacaoZoop.save({
                idZoop:idZoop
            }, function(response){
                $state.reload();
            })


        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.finance')
        .controller('FinanceController', FinanceController);

    /** @ngInject */
    function FinanceController(api, $translate, $scope, DTDefaultOptions,
                               DTColumnDefBuilder, DTOptionsBuilder, DTColumnBuilder,
                               $mdDialog, $mdToast, $state, $rootScope, $compile, $filter) {
        var vm = this;

        //declarando algumas variaveis
        var selectedCashier = -99;
        if (($rootScope.userType == 'ADMIN') || ($rootScope.userType == 'MASTER')){
            vm.oneProfessional = false;
            selectedCashier = -1;
        } else {
            vm.oneProfessional = true;
            selectedCashier = -99;
        }

        vm.selectedDate = new Date();
        vm.isOpen = false;

        vm.openFilter = function(){
            $mdSidenav('filter')
                .toggle()
                .then(function () {

                });
        }


        vm.openCashiers = [];
        vm.cash = {
            cashier : selectedCashier,
            total:0
        };
        vm.debit = {
            cashier : selectedCashier,
            total:0
        };
        vm.credit = {
            cashier : selectedCashier,
            total:0
        };
        vm.fiado = {
            cashier : selectedCashier,
            total:0
        };
        vm.giftcard = {
            cashier : selectedCashier,
            total:0
        };


        vm.showOpenCashier = false
        vm.showCloseCashier = false;
        vm.showTable = false;


        vm.dtColumns = [
            DTColumnBuilder.newColumn('id').withTitle('Id').notSortable(),
            DTColumnBuilder.newColumn('userName').withTitle('Operador').notSortable(),
            DTColumnBuilder.newColumn('openDate').withTitle('Data').notSortable().renderWith(function (data, type, full) {
                var dt = new moment(data);
                if (dt.isValid()) {
                    return dt.format('DD/MM');
                } else {
                    return "-";
                }
            }),
            DTColumnBuilder.newColumn('openValue').withTitle('Abriu Com').notSortable().renderWith(function (data, type, full) {
                return $filter('currency')(data , '', 2);
            }),
            /*DTColumnBuilder.newColumn('closeDate').withTitle('Dt. Fechamento').notSortable().renderWith(function (data, type, full) {
                var dt = new moment(data);
                if (dt.isValid()){
                    return dt.format('DD/MM');
                } else {
                    return "-";
                }

            }),*/
            DTColumnBuilder.newColumn('closeValue').withTitle('Fechou Com').notSortable().renderWith(function (data, type, full) {
                return $filter('currency')(data , '', 2);
            }),
            DTColumnBuilder.newColumn('difference').withTitle('Dif.').notSortable().renderWith(function (data, type, full) {
                return $filter('currency')(data , '', 2);
            }),
            DTColumnBuilder.newColumn('nextOpenValue').withTitle('Valor Flutuado').notSortable().renderWith(function (data, type, full) {
                return $filter('currency')(data , '', 2);
            }),
            DTColumnBuilder.newColumn('finalValue').withTitle('Valor Final').notSortable().renderWith(function (data, type, full) {
                return $filter('currency')(data , '', 2);
            }),
            DTColumnBuilder.newColumn('creditValue').withTitle('Valor Crédito').notSortable().renderWith(function (data, type, full) {
                return $filter('currency')(data , '', 2);
            }),
            DTColumnBuilder.newColumn('debitValue').withTitle('Valor Débito').notSortable().renderWith(function (data, type, full) {
                return $filter('currency')(data , '', 2);
            }),
            DTColumnBuilder.newColumn('observation').withTitle('Obs').notSortable(),
            DTColumnBuilder.newColumn('validated').withTitle('').notSortable().renderWith(function (data, type, full) {
                var sHtml = "";
                if (data){
                    sHtml = "<i class='icon-check' style='color: green;' layout='center'><md-tooltip>Caixa validado pela gerência</md-tooltip></i>"
                } else {
                    sHtml = "<i class='icon-cancel' style='color: red;' layout='center'><md-tooltip>Caixa pendente de validação</md-tooltip></i>"
                }

                return sHtml;
            }),
        ];

        vm.showTable = true;

        //console.log($window.localStorage['securityToken']);
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withPaginationType('simple')
            .withDisplayLength(10)
            .withOption('ajax', {
                // Either you specify the AjaxDataProp here
                // dataSrc: 'data',
                url: backendServer + '/finance/getCashiers',
                type: 'POST',
                data:{
                    token: $rootScope.securityToken
                }
            })
            .withDataProp('d')
            .withOption('autoWidth', false)
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('createdRow', function (row) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row).contents())($scope);
            })
            .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
            .withLanguage({
                "sEmptyTable": "Nenhum registro disponível",
                "sInfo": "Mostrando _START_ até _END_ de _TOTAL_ registros",
                "sInfoEmpty": "Mostrando 0 até 0 de 0 registros",
                "sInfoFiltered": "(filtrado de um total de _MAX_ registros)",
                "sInfoPostFix": "",
                "sInfoThousands": ",",
                "sLengthMenu": "Mostrar _MENU_ registros",
                "sLoadingRecords": "Carregando...",
                "sProcessing": "Processando...",
                "sSearch": "Busca:",
                "sZeroRecords": "Não encontramos nenhum registro",
                "oPaginate": {
                    "sFirst": "Primeiro",
                    "sLast": "Ultimo",
                    "sNext": "Próximo",
                    "sPrevious": "Anterior"
                },
                "oAria": {
                    "sSortAscending": ": activate to sort column ascending",
                    "sSortDescending": ": activate to sort column descending"
                }
            });
        //vm.dtColumnDefs = [
        //    DTColumnDefBuilder.newColumnDef(0).notSortable()
        //];
        DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

        /////////////////////////////////
        //inicializando
        setCashierStatus();
        //getCashiers();
        getOpenCashiers();
        setTimeout(function(){
            getCashTotal();
            getDebitTotal();
            getCreditTotal();
            }, 1000);



        ///getFiadoTotal();
        //getGiftCardTotal();
        if ($state.current.name == 'app.finance.report'){
            reloadChecklist();

            vm.reloadChecklist = function(){
                reloadChecklist();
            }

            vm.validateCashiers = function(){
                api.validateCashiers.save({
                    date : vm.selectedDate
                }, function(response){

                }, function(err){

                })
            }
        }


        /////////////////////////////////
        //////////
        function refreshVendas(){
            setFilter();


            api.getWoweePayVendas.save({
                    filter : vm.finalFilter
                },
                function(response){
                    vm.showTable = true;
                    vm.saldo = 0;
                    var html = "";

                    for(var i=0; i < response.d.length; i++){
                        html += "<tr>";
                        html += "<td>" + response.d[i].saleId  + "</td>"
                        html += "<td>" + response.d[i].idZoop + "</td>";
                        html += "<td>" + $filter('date')(response.d[i].dataVenda, "dd/MM/yyyy") + "</td>";
                        html += "<td>" + response.d[i].customerName  + "</td>"
                        html += "<td>" + response.d[i].services  + "</td>"
                        switch (response.d[i].status) {
                            case "succeeded":
                                html += "<td style='color: green'>" + "Aprovada" + "</td>";
                                break;
                            case "reversed":
                                html += "<td style='color: red'>" + "Revertida" + "</td>";
                                break;
                            default:
                                html += "<td>" + response.d[i].status + "</td>";
                                break;

                        }


                        html += "<td>" + response.d[i].meioPagamento + "</td>";
                        html += "<td>" + $filter('currency')(response.d[i].valorBruto, 'R$',2) + "</td>";
                        //html += "<td>" + $filter('currency')(response.d[i].taxa, 'R$',2) + "</td>";
                        //html += "<td>" + $filter('currency')(response.d[i].valorLiquido, 'R$',2) + "</td>";
                        html += "</tr>";

                    }

                    /*html += "<tr>";
                    html += "<td><b>Total</b></td>";
                    html += "<td></td>";
                    html += "<td></td>";
                    html += "<td></td>";
                    html += "<td></td>";
                    html += "<td></td>";
                    html += "<td></td>";
                    html += "<td><b>" + $filter('currency')(vm.saldo, 'R$',2) + "</b></td>";
                    html += "</tr>";*/

                    vm.html = html;

                },
                function(error){
                    console.log(error);
                });
        }

        function reloadChecklist(){


            api.getReportCashier.save({
                    date : vm.selectedDate
                },
                function(response){

                    vm.totalServiceSale = response.d.totalServiceSale
                    vm.totalServicePackSale = response.d.totalServicePackSale
                    vm.totalProductSale = response.d.totalProductSale
                    vm.totalDiscount = response.d.totalDiscount
                    vm.totalPaid = response.d.totalPaid
                    vm.totalCreditoDebito = response.d.totalCreditoDebito
                    vm.totalPaidCredit = response.d.totalPaidCredit
                    vm.totalPaidDebit = response.d.totalPaidDebit
                    vm.totalCashCashier = response.d.totalCashCashier
                    vm.totalCreditCashier = response.d.totalCreditCashier
                    vm.totalDebitCashier = response.d.totalDebitCashier
                    vm.totalPaidCash = response.d.totalPaidCash

                },
                function(error){
                    console.log(error);
                });
        }

        //verificando se o caixa esta aberto
        //nesse caso devo verificar se operador possui caixa aberto
        function setCashierStatus(){
            api.getOpenCashier.save({
                    oneProfesional:true
                },
                function(response){
                    if (response.d != null){
                        vm.showOpenCashier = false;
                        vm.showCloseCashier = true;
                    } else {
                        vm.showOpenCashier = true;
                        vm.showCloseCashier = false;
                    }
                },
                function(error){
                    console.log(error);
                });
        }

        function getCashiers(){
            api.getCashiers.save({
                },
                function(response){
                    vm.cashiers = response.d;
                    vm.showTable = true;
                },
                function(error){
                    console.log(error);
                });
        }

        function getOpenCashiers(){
            //nesse caso devo verificar se operador possui caixa aberto
            api.getOpenCashier.save({
                    oneProfesional:vm.oneProfessional
                },
                function(response){
                    if (!vm.oneProfessional){
                        vm.openCashiers = [];
                        vm.openCashiers.push({
                            id:-1,
                            professional:'Todos os caixas'
                        })

                        vm.openCashiers.push.apply(vm.openCashiers, response.d);
                    }else {
                        if (response.d != null) {
                            console.log(response.d);
                            vm.openCashiers.push({id: response.d.id, professional: response.d.professional});
                            vm.cash.cashier = response.d.id;
                            vm.debit.cashier = response.d.id;
                            vm.credit.cashier = response.d.id;
                            vm.fiado.cashier = response.d.id;
                            vm.giftcard.cashier = response.d.id;
                        } else {
                            vm.openCashiers.push({id: -99, professional: 'Nao existe caixa aberto'});
                            vm.cash.cashier = -99;
                            vm.debit.cashier = -99;
                            vm.credit.cashier = -99;
                            vm.fiado.cashier = -99;
                            vm.giftcard.cashier = -99;
                        }

                    }



                },
                function(error){
                    console.log(error);
                });

        }

        function getCashiersTotals(paymentType, cashierId, callback){
            //nesse caso devo verificar se operador possui caixa aberto
            api.getSalesWithinCashierByPaymentType.save({
                    cashierId : cashierId,
                    paymentType : paymentType
                },
                function(response){
                    callback(response.d);
                },
                function(error){
                    console.log(error);
                });

        }

        function getCashTotal(){
            getCashiersTotals("CASH", vm.cash.cashier ,function(data){
                vm.cash.total = data;
            });
        }

        function getCreditTotal(){
            getCashiersTotals("CREDIT", vm.credit.cashier, function(data){
                vm.credit.total = data;
            });
        }

        function getDebitTotal(){
            getCashiersTotals("DEBIT", vm.debit.cashier, function(data){
                vm.debit.total = data;
            });
        }

        function getFiadoTotal(){
            getCashiersTotals("FIADO", vm.fiado.cashier, function(data){
                vm.fiado.total = data;
            });
        }

        function getGiftCardTotal(){
            getCashiersTotals("GIFTCARD", vm.giftcard.cashier, function(data){
                vm.giftCard.total = data;
            });
        }

        /////////////////////////////////
        vm.changeCashCashier = function(){
            getCashTotal();
        };
        vm.changeDebitCashier = function(){
            getDebitTotal();
        }
        vm.changeCreditCashier = function(){
            getCreditTotal();
        }
        vm.changeFiadoCashier = function(){
            getFiadoTotal();
        }
        vm.changeGiftCardCashier = function(){
            getGiftCardTotal();
        }

        vm.openCashierDialog = function(){
            $mdDialog.show({
                template: [
                    '<md-dialog style="width:500px;"  ng-class="dialog.css">',
                    '<form name="basicForm" class="md-inline-form"  novalidate>' ,
                    '  <md-dialog-content class="md-dialog-content" role="document" tabIndex="-1">',
                    '    <h2 class="md-title">Abrir Caixa</h2>',
                    '    <div class="md-dialog-content-body">',
                    '      <p>Informe o valor presente no caixa nesse momento</p>',
                    '    </div>',
                    '    <div layout="row" layout-gt-sm="row">',
                    '    <md-input-container md-no-float class="md-prompt-input-container" flex="50">',
                    '      <label>Valor</label>',
                    '      <input type=number name=valor required md-autofocus ng-model="dialog.result.value" ' +
                    '           min="0"  >',
                    '       <div ng-messages="basicForm.valor.$error" role="alert">',
                    '          <div ng-message="required">',
                    '           <span>Valor é obrigatório</span>',
                    '          </div>',
                    '       </div>',
                    '    </md-input-container>',
                    '    </div>',
                    '  <md-dialog-actions>',
                    '    <md-button ng-click="dialog.abort()" class="md-raised md-warn">',
                    '      {{ dialog.cancel }}',
                    '    </md-button>',
                    '    <md-button ng-click="dialog.hide()" ng-disabled="basicForm.$invalid" class="md-raised md-confirm-button" >',
                    '      {{ dialog.ok }}',
                    '    </md-button>',
                    '  </md-dialog-actions>',
                    '</form>',
                    '</md-dialog>'
                ].join('').replace(/\s\s+/g, ''),
                multiple: true,
                controller: function mdDialogCtrl() {
                    this.ok = 'Confirmar';
                    this.cancel = 'Cancelar';
                    this.result = {};
                    this.result.value= 0;
                    this.hide = function () {
                        $mdDialog.hide(this.result);
                    };
                    this.abort = function () {
                        $mdDialog.cancel();
                    };

                },
                controllerAs: 'dialog',
                bindToController: true,

            })
                .then(function (result) {

                    console.log(result);
                    api.openCashier.save({
                            openValue: result.value
                        },
                        function (response) {
                            if (response.s==200) {
                                $mdToast.show(
                                    $mdToast.simple()
                                        .textContent("Caixa aberto com sucesso.")
                                        .hideDelay(1000)
                                );

                                $mdDialog.hide();
                                $state.reload();
                            } else {
                                $mdToast.show(
                                    $mdToast.simple()
                                        .textContent("Erro ao abrir o caixa")
                                        .hideDelay(1000)
                                );
                                $mdDialog.hide();


                            }

                        },
                        function (error) {
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent("Erro ao abrir o caixa")
                                    .hideDelay(1000)
                            );
                            $mdDialog.hide();

                        });


                }, function () {
                    $mdDialog.cancel();
                });
        }

        vm.closeCashierDialog = function(){
            $mdDialog.show({
                template: [
                    '<md-dialog style="width:500px;"  ng-class="dialog.css">',
                    '<form name="basicForm" class="md-inline-form"  novalidate>' ,
                    '  <md-dialog-content class="md-dialog-content" role="document" tabIndex="-1">',
                    '    <h2 class="md-title">Fechar Caixa</h2>',
                    '    <div layout="row" layout-gt-sm="row">',
                    '    <md-input-container md-no-float class="md-prompt-input-container" flex="50">',
                    '      <label>Valor no caixa em dinheiro</label>',
                    '      <input type=number name=valor required md-autofocus ng-model="dialog.result.value" min="0" ng-change="changeDifference()" >',
                    '       <div ng-messages="basicForm.valor.$error" role="alert">',
                    '          <div ng-message="required">',
                    '           <span>Valor é obrigatório</span>',
                    '          </div>',
                    '       </div>',
                    '    </md-input-container>',

                    '    <md-input-container md-no-float class="md-prompt-input-container" flex="50">',
                    '      <label>Diferença (Val. Esperado - Val. Real)</label>',
                    '      <input type=number name=valor ng-model="dialog.result.difference" ng-disabled="true" >' ,
                    '    </md-input-container>',

                    '    </div>',
                    '    <div layout="row" layout-gt-sm="row">',
                    '    <md-input-container md-no-float class="md-prompt-input-container" flex="50">',
                    '      <label>Valor para próximo caixa</label>',
                    '      <input type=number name=valor required ng-model="dialog.result.nextOpenValue" min="0" ng-change="changeDifference()" >',
                    '       <div ng-messages="basicForm.valor.$error" role="alert">',
                    '          <div ng-message="required">',
                    '           <span>Valor é obrigatório</span>',
                    '          </div>',
                    '       </div>',
                    '    </md-input-container>',

                    '    <md-input-container md-no-float class="md-prompt-input-container" flex="50">',
                    '      <label>Valor Cofre</label>',
                    '      <input type=number name=valor ng-model="dialog.result.finalValue" ng-disabled="true" >' ,
                    '    </md-input-container>',

                    '    </div>',
                    '    <div layout="row" layout-gt-sm="row">',
                    '    <md-input-container md-no-float class="md-prompt-input-container" flex="50">',
                    '      <label>Valor Crédito</label>',
                    '      <input type=number name="creditValue"  ng-model="dialog.result.creditValue" min="0"  />',
                    '    </md-input-container>',
                    '    <md-input-container md-no-float class="md-prompt-input-container" flex="50">',
                    '      <label>Valor Débito</label>',
                    '      <input type=number name=valor ng-model="dialog.result.debitValue" min="0"  >',
                    '    </md-input-container>',
                    '    </div>',

                    '    <div layout="row" layout-gt-sm="row">',

                    '    <md-input-container md-no-float class="md-prompt-input-container" flex="100">',
                    '      <label>Observação</label>',
                    '      <input type=text  name=observation ng-model="dialog.result.observation">',
                    '    </md-input-container>',
                    '    </div>',


                    '  <md-dialog-actions>',
                    '    <md-button ng-click="dialog.abort()" class="md-raised md-warn">',
                    '      {{ dialog.cancel }}',
                    '    </md-button>',
                    '    <md-button ng-click="dialog.hide()" ng-disabled="basicForm.$invalid" class="md-raised md-confirm-button" >',
                    '      {{ dialog.ok }}',
                    '    </md-button>',

                    '  </md-dialog-actions>',
                    '</form>',
                    '</md-dialog>'
                ].join('').replace(/\s\s+/g, ''),
                multiple: true,
                controller: function mdDialogCtrl($scope) {
                    var vm2 = this;
                    this.ok = 'Confirmar';
                    this.cancel = 'Cancelar';
                    this.result = {};
                    this.result.value = 0;
                    this.result.nextOpenValue = 0;

                    $scope.changeDifference = function(){
                        vm2.result.difference = +(((vm2.result.value*100) - (vm2.result.vendas*100))/100).toFixed(2);
                        vm2.result.finalValue = +(((vm2.result.value*100) - (vm2.result.nextOpenValue*100))/100).toFixed(2);
                    }

                    api.getSalesWithinCashier.save({

                        },
                        function(response){
                            vm2.result.vendas = response.d;
                            vm2.result.difference = vm2.result.vendas ;




                            console.log(vm2.result.vendas);


                        },
                        function(error){
                            console.log(error);
                        });
                    api.getOpenCashier.save({
                            oneProfesional:true
                        },
                        function(response){
                            console.log(response.d);
                            vm2.result.openValue = response.d.openValue;
                        },
                        function(error){
                            console.log(error);
                        });



                    this.hide = function () {
                        $mdDialog.hide(this.result);
                    };
                    this.abort = function () {
                        $mdDialog.cancel();
                    };

                },
                controllerAs: 'dialog',
                bindToController: true,

            })
                .then(function (result) {

                    console.log(result);

                    api.closeCashier.save({
                            closeValue: result.value,
                            nextOpenValue: result.nextOpenValue,
                            observation : result.observation,
                            finalValue : result.finalValue,
                            difference : result.difference,
                            creditValue : result.creditValue,
                            debitValue : result.debitValue
                        },
                        function (response) {
                            if (response.s==200) {
                                $mdToast.show(
                                    $mdToast.simple()
                                        .textContent("Caixa aberto com sucesso.")
                                        .hideDelay(1000)
                                );

                                $state.reload();
                                $mdDialog.hide();
                            } else {
                                $mdToast.show(
                                    $mdToast.simple()
                                        .textContent("Erro ao abrir o caixa")
                                        .hideDelay(1000)
                                );
                                $mdDialog.hide();


                            }

                        },
                        function (error) {
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent("Erro ao abrir o caixa")
                                    .hideDelay(1000)
                            );
                            $mdDialog.hide();

                        });


                }, function () {
                    $mdDialog.cancel();
                });
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dashboard', [
            // 3rd Party Dependencies
            'datatables',
            'flow',
            'nvd3',
            'textAngular',
            'xeditable',
            'gridshore.c3js.chart'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.dashboard', {
                url    : '/dashboard',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/dashboard/dashboard.html',
                        controller : 'DashboardController as vm'
                    }
                },
                bodyClass: 'dashboard'
            });


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboard')
        .controller('DashboardController', DashboardController);

    /** @ngInject */
    function DashboardController(api, $translate, $scope, $mdDialog, $window, $rootScope, $localStorage)
    {
        var vm = this;

        $scope.$storage = $localStorage;


        if ($scope.$storage.showOnboard == null) {
            $mdDialog.show({
                controller: 'SupportController as vm',
                templateUrl: 'app/main/support/onboard.html',
                parent: angular.element(document.body),
                targetEvent: null,
                multiple: true,
                clickOutsideToClose: false,
                locals: {
                    topic: ''
                },
                fullscreen: false
            })
                .then(function (answer) {



                }, function () {

                });
        }



        api.dashboard.save({
            },
            function(response){
                vm.dashboardData = response.d;


                var arDataAgendamento = [];
                var arDataFinanceiro = [];
                var arPE = [];
                var arFaturamentoLiquido = [];
                var arImpostos = [];
                var arMargemPorCategoria =[];
                var arResultadoOperacionalPorCategoria = [];

                for(var i=0; i < response.d.ultimos12Agendamentos.length; i++){
                    arDataAgendamento.push({
                        x: new Date(new moment({
                            date : 1,
                            month : response.d.ultimos12Agendamentos[i].MES-1,
                            year : response.d.ultimos12Agendamentos[i].ANO
                        }).valueOf()),
                        y : response.d.ultimos12Agendamentos[i].TOTAL
                    })
                }
                for(var i=0; i < response.d.ultimos12Faturamentos.length; i++){
                    arDataFinanceiro.push({
                        x: new Date(new moment({
                            date : 1,
                            month : response.d.ultimos12Faturamentos[i].MES-1,
                            year : response.d.ultimos12Faturamentos[i].ANO
                        }).valueOf()),
                        y : response.d.ultimos12Faturamentos[i].TOTAL
                    })
                }
                for(var i=0; i < response.d.ultimos12FaturamentosLiquido.length; i++){
                    arFaturamentoLiquido.push({
                        x: new Date(new moment({
                            date : 1,
                            month : response.d.ultimos12FaturamentosLiquido[i].MES-1,
                            year : response.d.ultimos12FaturamentosLiquido[i].ANO
                        }).valueOf()),
                        y : response.d.ultimos12FaturamentosLiquido[i].TOTAL
                    });
                    arPE.push({
                        x: new Date(new moment({
                            date : 1,
                            month : response.d.ultimos12FaturamentosLiquido[i].MES-1,
                            year : response.d.ultimos12FaturamentosLiquido[i].ANO
                        }).valueOf()),
                        y : response.d.fixedCost
                    })
                    arImpostos.push({
                        x: new Date(new moment({
                            date : 1,
                            month : response.d.ultimos12FaturamentosLiquido[i].MES-1,
                            year : response.d.ultimos12FaturamentosLiquido[i].ANO
                        }).valueOf()),
                        y : response.d.impostosUltimos12[i]
                    })
                }

                for(var i=0; i < response.d.resultadoOperacionalPorCategoria.length; i++){
                    arResultadoOperacionalPorCategoria.push({
                        x: response.d.resultadoOperacionalPorCategoria[i].CATEGORY,
                        y : response.d.resultadoOperacionalPorCategoria[i].TOTAL
                    });


                }




                var chartData = [{
                    key : "Agendamentos",
                    values : arDataAgendamento
                }];
                vm.faturamento12Meses = [
                    {
                        key : "Financeiro",
                        values : arDataFinanceiro
                    }
                ];

                vm.PE12Meses = [
                    {
                        key : "Resultado Liquido",
                        values : arFaturamentoLiquido
                    }
                ];

                vm.margemBrutaPorCategoria = [
                    {
                        key : "Resultado Operacional",
                        values : arResultadoOperacionalPorCategoria
                    }
                ];


                var arTopServices = [];
                for(var i=0 ; i  < response.d.arTopCategoriasServico.length; i++){
                    arTopServices.push({
                        key : response.d.arTopCategoriasServico[i].x,
                        y :  response.d.arTopCategoriasServico[i].y,
                    })
                }

                vm.chartFinanceiroCategoria = {
                    options: {
                        chart: {
                            type      : 'pieChart',
                            height    : 350,
                            donut     : true,
                            x         : function (d)
                            {
                                return d.key;
                            },
                            y         : function (d)
                            {
                                return d.y;
                            },
                            showLabels: false,

                            pie               : {
                                startAngle: function (d)
                                {
                                    return d.startAngle;
                                },
                                endAngle  : function (d)
                                {
                                    return d.endAngle;
                                }
                            },
                            transitionDuration: 500,

                        }
                    },

                    data: arTopServices

                };

                var arMapaAgendamento = [];
                var itemMap = 0;
                vm.segundaManha = 0;
                vm.tercaManha = 0;
                vm.quartaManha = 0;
                vm.quintaManha = 0;
                vm.sextaManha = 0;
                vm.sabadoManha = 0;
                vm.domingoManha = 0;
                vm.segundaManhaCount = 0;
                vm.tercaManhaCount = 0;
                vm.quartaManhaCount = 0;
                vm.quintaManhaCount = 0;
                vm.sextaManhaCount = 0;
                vm.sabadoManhaCount = 0;
                vm.domingoManhaCount = 0;

                vm.segundaTarde = 0;
                vm.tercaTarde = 0;
                vm.quartaTarde = 0;
                vm.quintaTarde = 0;
                vm.sextaTarde = 0;
                vm.sabadoTarde = 0;
                vm.domingoTarde = 0;
                vm.segundaTardeCount = 0;
                vm.tercaTardeCount = 0;
                vm.quartaTardeCount = 0;
                vm.quintaTardeCount = 0;
                vm.sextaTardeCount = 0;
                vm.sabadoTardeCount = 0;
                vm.domingoTardeCount = 0;

                vm.segundaNoite = 0;
                vm.tercaNoite = 0;
                vm.quartaNoite = 0;
                vm.quintaNoite = 0;
                vm.sextaNoite = 0;
                vm.sabadoNoite = 0;
                vm.domingoNoite = 0;
                vm.segundaNoiteCount = 0;
                vm.tercaNoiteCount = 0;
                vm.quartaNoiteCount = 0;
                vm.quintaNoiteCount = 0;
                vm.sextaNoiteCount = 0;
                vm.sabadoNoiteCount = 0;
                vm.domingoNoiteCount = 0;

                vm.expectativaPorTurnoManha = 50;
                vm.expectativaPorTurnoTarde = 50;
                vm.expectativaPorTurnoNoite = 50;


                for (var i=0 ; i < response.d.arMapaAgendamento.length; i++){
                    if (response.d.arMapaAgendamento[i].HORA < 12){

                        switch(response.d.arMapaAgendamento[i].DIA){
                            case 0:
                                vm.segundaManha+=response.d.arMapaAgendamento[i].TOTAL;
                                vm.segundaManhaCount++;
                                break;
                            case 1:
                                vm.tercaManha+=response.d.arMapaAgendamento[i].TOTAL;
                                vm.tercaManhaCount++;
                                break;
                            case 2:
                                vm.quartaManha+=response.d.arMapaAgendamento[i].TOTAL;
                                vm.quartaManhaCount++;
                                break;
                            case 3:
                                vm.quintaManha+=response.d.arMapaAgendamento[i].TOTAL;
                                vm.quintaManhaCount++;
                                break;
                            case 4:
                                vm.sextaManha+=response.d.arMapaAgendamento[i].TOTAL;
                                vm.sextaManhaCount++;
                                break;
                            case 5:
                                vm.sabadoManha += response.d.arMapaAgendamento[i].TOTAL;
                                vm.sabadoManhaCount++;
                                break;
                            case 6:
                                vm.domingoManha+=response.d.arMapaAgendamento[i].TOTAL;
                                vm.domingoManhaCount++;
                                break;
                        }
                    }
                    if ((response.d.arMapaAgendamento[i].HORA > 12) && (response.d.arMapaAgendamento[i].HORA < 18)){
                        switch(response.d.arMapaAgendamento[i].DIA){
                            case 0:
                                vm.segundaTarde+=response.d.arMapaAgendamento[i].TOTAL;
                                vm.segunadTardeCount++;
                                break;
                            case 1:
                                vm.tercaTarde+=response.d.arMapaAgendamento[i].TOTAL;
                                vm.tercaTardeCount++;
                                break;
                            case 2:
                                vm.quartaTarde+=response.d.arMapaAgendamento[i].TOTAL;
                                vm.quartaTardeCount++;
                                break;
                            case 3:
                                vm.quintaTarde+=response.d.arMapaAgendamento[i].TOTAL;
                                vm.quintaTardeCount++;
                                break;
                            case 4:
                                vm.sextaTarde+=response.d.arMapaAgendamento[i].TOTAL;
                                vm.sextaTardeCount++;
                                break;
                            case 5:
                                vm.sabadoTarde+=response.d.arMapaAgendamento[i].TOTAL;
                                vm.sabadoTardeCount++;
                                break;
                            case 6:
                                vm.domingoTarde+=response.d.arMapaAgendamento[i].TOTAL;
                                vm.domingoTardeCount++;
                                break;
                        }
                    }
                    if ((response.d.arMapaAgendamento[i].HORA > 18) ){
                        switch(response.d.arMapaAgendamento[i].DIA){
                            case 0:
                                vm.segundaNoite+=response.d.arMapaAgendamento[i].TOTAL;
                                vm.segundaNoiteCount++;
                                break;
                            case 1:
                                vm.tercaNoite+=response.d.arMapaAgendamento[i].TOTAL;
                                vm.tercaNoiteCount++;
                                break;
                            case 2:
                                vm.quartaNoite+=response.d.arMapaAgendamento[i].TOTAL;
                                vm.quartaNoiteCount++;
                                break;
                            case 3:
                                vm.quintaNoite+=response.d.arMapaAgendamento[i].TOTAL;
                                vm.quintaNoiteCount++;
                                break;
                            case 4:
                                vm.sextaNoite+=response.d.arMapaAgendamento[i].TOTAL;
                                vm.sextaNoiteCount++;
                                break;
                            case 5:
                                vm.sabadoNoite+=response.d.arMapaAgendamento[i].TOTAL;
                                vm.sabadoNoiteCount++;
                                break;
                            case 6:
                                vm.domingoNoite+=response.d.arMapaAgendamento[i].TOTAL;
                                vm.domingoNoiteCount++;
                                break;
                        }
                    }
                }

                //calculandoas medias
                if (vm.segundaManhaCount != 0){
                    vm.segundaManha = parseInt(vm.segundaManha / vm.segundaManhaCount);
                } else {
                    vm.segundaManha = 0;
                }

                if (vm.tercaManhaCount != 0) {
                    vm.tercaManha = parseInt(vm.tercaManha / vm.tercaManhaCount);
                } else {
                    vm.tercaManha = 0;
                }

                if (vm.quartaManhaCount != 0) {
                    vm.quartaManha = parseInt(vm.quartaManha / vm.quartaManhaCount);
                } else {
                    vm.quartaManha = 0;
                }

                if (vm.quintaManhaCount != 0) {
                    vm.quintaManha = parseInt(vm.quintaManha / vm.quintaManhaCount);
                } else {
                    vm.quintaManha = 0;
                }

                if (vm.sextaManhaCount != 0) {
                    vm.sextaManha = parseInt(vm.sextaManha / vm.sextaManhaCount);
                } else {
                    vm.sextaManha = 0;
                }

                if (vm.sabadoManhaCount != 0) {
                    vm.sabadoManha = parseInt(vm.sabadoManha / vm.sabadoManhaCount);
                } else {
                    vm.sabadoManha = 0;
                }

                if (vm.domingoManhaCount != 0) {
                    vm.domingoManha = parseInt(vm.domingoManha / vm.domingoManhaCount);
                } else {
                    vm.domingoManha = 0;
                }

                //TARDE
                if (vm.segundaTardeCount != 0){
                    vm.segundaTarde = parseInt(vm.segundaTarde / vm.segundaTardeCount);
                } else {
                    vm.segundaTarde = 0;
                }

                if (vm.tercaTardeCount != 0) {
                    vm.tercaTarde = parseInt(vm.tercaTarde / vm.tercaTardeCount);
                } else {
                    vm.tercaTarde = 0;
                }

                if (vm.quartaTardeCount != 0) {
                    vm.quartaTarde = parseInt(vm.quartaTarde / vm.quartaTardeCount);
                } else {
                    vm.quartaTarde = 0;
                }

                if (vm.quintaTardeCount != 0) {
                    vm.quintaTarde = parseInt(vm.quintaTarde / vm.quintaTardeCount);
                } else {
                    vm.quintaTarde = 0;
                }

                if (vm.sextaTardeCount != 0) {
                    vm.sextaTarde = parseInt(vm.sextaTarde / vm.sextaTardeCount);
                } else {
                    vm.sextaTarde = 0;
                }

                if (vm.sabadoTardeCount != 0) {
                    vm.sabadoTarde = parseInt(vm.sabadoTarde / vm.sabadoTardeCount);
                } else {
                    vm.sabadoTarde = 0;
                }

                if (vm.domingoTardeCount != 0) {
                    vm.domingoTarde = parseInt(vm.domingoTarde / vm.domingoTardeCount);
                } else {
                    vm.domingoTarde = 0;
                }
                
                //NOITE
                if (vm.segundaNoiteCount != 0){
                    vm.segundaNoite = parseInt(vm.segundaNoite / vm.segundaNoiteCount);
                } else {
                    vm.segundaNoite = 0;
                }

                if (vm.tercaNoiteCount != 0) {
                    vm.tercaNoite = parseInt(vm.tercaNoite / vm.tercaNoiteCount);
                } else {
                    vm.tercaNoite = 0;
                }

                if (vm.quartaNoiteCount != 0) {
                    vm.quartaNoite = parseInt(vm.quartaNoite / vm.quartaNoiteCount);
                } else {
                    vm.quartaNoite = 0;
                }

                if (vm.quintaNoiteCount != 0) {
                    vm.quintaNoite = parseInt(vm.quintaNoite / vm.quintaNoiteCount);
                } else {
                    vm.quintaNoite = 0;
                }

                if (vm.sextaNoiteCount != 0) {
                    vm.sextaNoite = parseInt(vm.sextaNoite / vm.sextaNoiteCount);
                } else {
                    vm.sextaNoite = 0;
                }

                if (vm.sabadoNoiteCount != 0) {
                    vm.sabadoNoite = parseInt(vm.sabadoNoite / vm.sabadoNoiteCount);
                } else {
                    vm.sabadoNoite = 0;
                }

                if (vm.domingoNoiteCount != 0) {
                    vm.domingoNoite = parseInt(vm.domingoNoite / vm.domingoNoiteCount);
                } else {
                    vm.domingoNoite = 0;
                }
                

                //setando estilo
                var estiloRed = {
                    "background-color": "#E1FFE6",
                    "font-size":'12px',
                    "font-weight" : 'bold',
                    "color" : 'black'
                }
                var estiloYellow = {
                    "background-color": '#B4FFB7',
                    "font-size":'12px',
                    "font-weight" : 'bold',
                    "color" : 'black'
                }
                var estiloGreen = {
                    "background-color": 'green',
                    "font-size":'12px',
                    "font-weight" : 'bold',
                    "color" : 'white'
                }
                vm.estiloSegundaManha = {};
                vm.estiloTercaManha = {};
                vm.estiloQuartaManha = {};
                vm.estiloQuintaManha = {};
                vm.estiloSextaManha = {};
                vm.estiloSabadoManha = {};
                vm.estiloDomingoManha = {};
                
                vm.estiloSegundaTarde = {};
                vm.estiloTercaTarde = {};
                vm.estiloQuartaTarde = {};
                vm.estiloQuintaTarde = {};
                vm.estiloSextaTarde = {};
                vm.estiloSabadoTarde = {};
                vm.estiloDomingoTarde = {};

                vm.estiloSegundaNoite = {};
                vm.estiloTercaNoite = {};
                vm.estiloQuartaNoite = {};
                vm.estiloQuintaNoite = {};
                vm.estiloSextaNoite = {};
                vm.estiloSabadoNoite = {};
                vm.estiloDomingoNoite = {};
                //MANHA
                if (((vm.segundaManha*100)/vm.expectativaPorTurnoManha) < 40){
                    vm.estiloSegundaManha = estiloRed;
                } else if (((vm.segundaManha*100)/vm.expectativaPorTurnoManha) < 70){
                    vm.estiloSegundaManha = estiloYellow;
                } else {
                    vm.estiloSegundaManha = estiloGreen;
                }
                if (((vm.tercaManha*100)/vm.expectativaPorTurnoManha) < 40){
                    vm.estiloTercaManha = estiloRed;
                } else if (((vm.tercaManha*100)/vm.expectativaPorTurnoManha) < 70){
                    vm.estiloTercaManha = estiloYellow;
                } else {
                    vm.estiloTercaManha = estiloGreen;
                }
                if (((vm.quartaManha*100)/vm.expectativaPorTurnoManha) < 40){
                    vm.estiloQuartaManha = estiloRed;
                } else if (((vm.quartaManha*100)/vm.expectativaPorTurnoManha) < 70){
                    vm.estiloQuartaManha = estiloYellow;
                } else {
                    vm.estiloQuartaManha = estiloGreen;
                }
                if (((vm.quintaManha*100)/vm.expectativaPorTurnoManha) < 40){
                    vm.estiloQuintaManha = estiloRed;
                } else if (((vm.quintaManha*100)/vm.expectativaPorTurnoManha) < 70){
                    vm.estiloQuintaManha = estiloYellow;
                } else {
                    vm.estiloQuintaManha = estiloGreen;
                }
                if (((vm.sextaManha*100)/vm.expectativaPorTurnoManha) < 40){
                    vm.estiloSextaManha = estiloRed;
                } else if (((vm.sextaManha*100)/vm.expectativaPorTurnoManha) < 70){
                    vm.estiloSextaManha = estiloYellow;
                } else {
                    vm.estiloSextaManha = estiloGreen;
                }
                if (((vm.sabadoManha*100)/vm.expectativaPorTurnoManha) < 40){
                    vm.estiloSabadoManha = estiloRed;
                } else if (((vm.sabadoManha*100)/vm.expectativaPorTurnoManha) < 70){
                    vm.estiloSabadoManha = estiloYellow;
                } else {
                    vm.estiloSabadoManha = estiloGreen;
                }
                if (((vm.domingoManha*100)/vm.expectativaPorTurnoManha) < 40){
                    vm.estiloDomingoManha = estiloRed;
                } else if (((vm.domingoManha*100)/vm.expectativaPorTurnoManha) < 70){
                    vm.estiloDomingoManha = estiloYellow;
                } else {
                    vm.estiloDomingoManha = estiloGreen;
                }

                //TARDE
                if (((vm.segundaTarde*100)/vm.expectativaPorTurnoTarde) < 40){
                    vm.estiloSegundaTarde = estiloRed;
                } else if (((vm.segundaTarde*100)/vm.expectativaPorTurnoTarde) < 70){
                    vm.estiloSegundaTarde = estiloYellow;
                } else {
                    vm.estiloSegundaTarde = estiloGreen;
                }
                if (((vm.tercaTarde*100)/vm.expectativaPorTurnoTarde) < 40){
                    vm.estiloTercaTarde = estiloRed;
                } else if (((vm.tercaTarde*100)/vm.expectativaPorTurnoTarde) < 70){
                    vm.estiloTercaTarde = estiloYellow;
                } else {
                    vm.estiloTercaTarde = estiloGreen;
                }
                if (((vm.quartaTarde*100)/vm.expectativaPorTurnoTarde) < 40){
                    vm.estiloQuartaTarde = estiloRed;
                } else if (((vm.quartaTarde*100)/vm.expectativaPorTurnoTarde) < 70){
                    vm.estiloQuartaTarde = estiloYellow;
                } else {
                    vm.estiloQuartaTarde = estiloGreen;
                }
                if (((vm.quintaTarde*100)/vm.expectativaPorTurnoTarde) < 40){
                    vm.estiloQuintaTarde = estiloRed;
                } else if (((vm.quintaTarde*100)/vm.expectativaPorTurnoTarde) < 70){
                    vm.estiloQuintaTarde = estiloYellow;
                } else {
                    vm.estiloQuintaTarde = estiloGreen;
                }
                if (((vm.sextaTarde*100)/vm.expectativaPorTurnoTarde) < 40){
                    vm.estiloSextaTarde = estiloRed;
                } else if (((vm.sextaTarde*100)/vm.expectativaPorTurnoTarde) < 70){
                    vm.estiloSextaTarde = estiloYellow;
                } else {
                    vm.estiloSextaTarde = estiloGreen;
                }
                if (((vm.sabadoTarde*100)/vm.expectativaPorTurnoTarde) < 40){
                    vm.estiloSabadoTarde = estiloRed;
                } else if (((vm.sabadoTarde*100)/vm.expectativaPorTurnoTarde) < 70){
                    vm.estiloSabadoTarde = estiloYellow;
                } else {
                    vm.estiloSabadoTarde = estiloGreen;
                }
                if (((vm.domingoTarde*100)/vm.expectativaPorTurnoTarde) < 40){
                    vm.estiloDomingoTarde = estiloRed;
                } else if (((vm.domingoTarde*100)/vm.expectativaPorTurnoTarde) < 70){
                    vm.estiloDomingoTarde = estiloYellow;
                } else {
                    vm.estiloDomingoTarde = estiloGreen;
                }

                //NOITE
                if (((vm.segundaNoite*100)/vm.expectativaPorTurnoNoite) < 40){
                    vm.estiloSegundaNoite = estiloRed;
                } else if (((vm.segundaNoite*100)/vm.expectativaPorTurnoNoite) < 70){
                    vm.estiloSegundaNoite = estiloYellow;
                } else {
                    vm.estiloSegundaNoite = estiloGreen;
                }
                if (((vm.tercaNoite*100)/vm.expectativaPorTurnoNoite) < 40){
                    vm.estiloTercaNoite = estiloRed;
                } else if (((vm.tercaNoite*100)/vm.expectativaPorTurnoNoite) < 70){
                    vm.estiloTercaNoite = estiloYellow;
                } else {
                    vm.estiloTercaNoite = estiloGreen;
                }
                if (((vm.quartaNoite*100)/vm.expectativaPorTurnoNoite) < 40){
                    vm.estiloQuartaNoite = estiloRed;
                } else if (((vm.quartaNoite*100)/vm.expectativaPorTurnoNoite) < 70){
                    vm.estiloQuartaNoite = estiloYellow;
                } else {
                    vm.estiloQuartaNoite = estiloGreen;
                }
                if (((vm.quintaNoite*100)/vm.expectativaPorTurnoNoite) < 40){
                    vm.estiloQuintaNoite = estiloRed;
                } else if (((vm.quintaNoite*100)/vm.expectativaPorTurnoNoite) < 70){
                    vm.estiloQuintaNoite = estiloYellow;
                } else {
                    vm.estiloQuintaNoite = estiloGreen;
                }
                if (((vm.sextaNoite*100)/vm.expectativaPorTurnoNoite) < 40){
                    vm.estiloSextaNoite = estiloRed;
                } else if (((vm.sextaNoite*100)/vm.expectativaPorTurnoNoite) < 70){
                    vm.estiloSextaNoite = estiloYellow;
                } else {
                    vm.estiloSextaNoite = estiloGreen;
                }
                if (((vm.sabadoNoite*100)/vm.expectativaPorTurnoNoite) < 40){
                    vm.estiloSabadoNoite = estiloRed;
                } else if (((vm.sabadoNoite*100)/vm.expectativaPorTurnoNoite) < 70){
                    vm.estiloSabadoNoite = estiloYellow;
                } else {
                    vm.estiloSabadoNoite = estiloGreen;
                }
                if (((vm.domingoNoite*100)/vm.expectativaPorTurnoNoite) < 40){
                    vm.estiloDomingoNoite = estiloRed;
                } else if (((vm.domingoNoite*100)/vm.expectativaPorTurnoNoite) < 70){
                    vm.estiloDomingoNoite = estiloYellow;
                } else {
                    vm.estiloDomingoNoite = estiloGreen;
                }

                vm.widget1 = {
                    title: 'Agendamentos',
                    chart: {
                        options: {
                            chart: {
                                type                   : 'lineChart',
                                color                  : ['#4caf50', '#3f51b5', '#ff5722'],
                                useInteractiveGuideline: true,
                                clipVoronoi            : false,
                                interpolate            : 'cardinal',
                                x                      : function (d)
                                {
                                    return d.x;
                                },
                                y                      : function (d)
                                {
                                    return d.y;
                                },
                                xAxis                  : {
                                    tickFormat: function(d) { return d3.time.format('%b %d')(new Date(d)); },
                                    showMaxMin: false
                                },
                                yAxis                  : {
                                    tickFormat: function (d)
                                    {
                                        return d + '';
                                    }
                                },
                                interactiveLayer       : {
                                    tooltip: {
                                        gravity: 's',
                                        classes: 'gravity-s'
                                    }
                                }
                            }
                        },
                        data   : chartData
                    }
                };
                vm.widget3 = {
                    title: 'Ponto de Equilibrio',
                    chart: {
                        options: {
                            chart: {
                                type                   : 'discreteBarChart',

                                useInteractiveGuideline: true,
                                clipVoronoi            : false,
                                interpolate            : 'cardinal',
                                x                      : function (d)
                                {
                                    return d.x;
                                },
                                y                      : function (d)
                                {
                                    return d.y;
                                },
                                xAxis                  : {
                                    tickFormat: function(d) { return d3.time.format('%b %d')(new Date(d)); },
                                    showMaxMin: false
                                },
                                yAxis                  : {
                                    tickFormat: function (d)
                                    {
                                        return d + '';
                                    }
                                },

                                interactiveLayer       : {
                                    tooltip: {
                                        gravity: 's',
                                        classes: 'gravity-s'
                                    }
                                }
                            }
                        },
                        data   : vm.PE12Meses
                    }
                };
                vm.widget4 = {
                    chart: {
                        options: {
                            chart: {
                                type                   : 'discreteBarChart',

                                useInteractiveGuideline: true,
                                clipVoronoi            : false,
                                interpolate            : 'cardinal',
                                x                      : function (d)
                                {
                                    return d.x;
                                },
                                y                      : function (d)
                                {
                                    return d.y;
                                },
                                xAxis                  : {
                                    tickFormat: function(d) { return d; }
                                },
                                yAxis                  : {
                                    tickFormat: function (d)
                                    {
                                        return d + '';
                                    }
                                },

                                interactiveLayer       : {
                                    tooltip: {
                                        gravity: 's',
                                        classes: 'gravity-s'
                                    }
                                }
                            }
                        },
                        data   : vm.PE12Meses
                    }
                };


                if (vm.dashboardData.percentualMudancaFinanceiro < 0){
                    vm.faturamentoColor = {color:'red'};
                } else {
                    vm.faturamentoColor = {color:'green'};
                }
                if (vm.dashboardData.percentualMudancaAgendamento < 0){
                    vm.agendamentoColor = {color:'red'};
                } else {
                    vm.agendamentoColor = {color:'green'};
                }




            },
            function(error){
                console.log(error);
            });



        ////////////ACTIONS////////////////
        vm.sendSMS = function(type){
            console.log(type);

            $mdDialog.show({
                controller: 'MarketingDialogSpotController',
                controllerAs: 'vm',
                templateUrl: 'app/main/marketingv2/spot/configurationDialog.html',
                clickOutsideToClose: true,
                locals:{
                    campaignType: type
                }
            })
                .then(function (answer) {

                }, function (response) {
                    console.log(response);

                });
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.customer')
        .controller('CustomerController', CustomerController);

    /** @ngInject */
    function CustomerController($state, $scope,DTOptionsBuilder,DTColumnBuilder,DTColumnDefBuilder, api,
                                $compile, DTDefaultOptions, $translate, $mdDialog, $mdToast, $rootScope,
                                $filter)
    {
        var vm = this;

        var name = '';

      /*  if (customerName != null){
            name = customerName;
        }*/

        //user for dialog
        vm.customer = {
            _id : null,
            gender : 'female',
            name : name,
            enableSMS : true,
            enableEmail : true,
            email : '',
            newCustomer : 'Y',
            telephone : ''
        };
        vm.saveCustomer = saveCustomer;
        vm.saveCustomerDialog = saveCustomerDialog;
        vm.closeDialog = closeDialog;




        //check if is edit, insert or nothing
        var currentState = $state.current.name;

        //Initialize
        switch (currentState) {
            case "app.customer.list":
                vm.showTable = false;
                vm.removeCustomer = removeCustomer;
                vm.editCustomer = editCustomer;
                vm.customerInventory = customerInventory;
                vm.newSchedule = newSchedule;
                vm.registerCreditDebit = registerCreditDebit;
                vm.customerHistory = customerHistory;


                vm.showTable = true;
                vm.dtColumns = [
                    DTColumnBuilder.newColumn('name').withTitle('Nome').notSortable(),
                    DTColumnBuilder.newColumn('email').withTitle('Email').notSortable(),
                    DTColumnBuilder.newColumn('telephone').withTitle('Telefone').notSortable(),
                    //DTColumnBuilder.newColumn('birthday').withTitle('Aniversário').notSortable(),
                    DTColumnBuilder.newColumn('_id').notVisible().notSortable(),
                    DTColumnBuilder.newColumn(null).withClass('right').withTitle('').renderWith(function (data, type, full) {
                        var sHtml = "";
                        //sHtml = sHtml + "<md-button aria-label= 'Pencil' class='md-raised md-accent gp-mini'  ng-click='::vm.newSchedule(customer)' ><md-tooltip aria-label='Pencil'>{{ 'GENERAL.HINTS.SCHEDULE' | translate }}</md-tooltip><i class='icon-calendar' layout='center'></i></md-button>";
                        sHtml = sHtml + '<md-button aria-label="Pencil" class="md-raised md-simpleButton gp-mini" ng-click="::vm.editCustomer(\'' + full._id + '\')" ><md-tooltip aria-label="Pencil">{{ "GENERAL.HINTS.EDIT" | translate }}</md-tooltip><i class="icon-pencil" layout="center"></i></md-button>';
                        sHtml = sHtml + '<md-button aria-label="Trash" class="md-raised md-simpleButton gp-mini" ng-click="::vm.customerInventory(\'' + full._id + '\')"><md-tooltip aria-label="Pencil">{{ "GENERAL.HINTS.INVENTORY" | translate }}</md-tooltip><i class="icon-shopping" layout="center"></i></md-button>';

                        if (($rootScope.userType == 'ADMIN')||($rootScope.userType == 'MASTER')){
                            sHtml = sHtml + '<md-button aria-label="cash" class="md-raised md-simpleButton gp-mini" ng-click="vm.registerCreditDebit(\'' + full._id  + '\')"><md-tooltip aria-label="Cash">{{ "GENERAL.HINTS.CREDITDEBIT" | translate }}</md-tooltip><i class="icon-currency-usd" layout="center"></i></md-button>';
                        } else if ($rootScope.userType == 'RECEPCIONIST'){
                            if ($rootScope.pdvConfiguration.allowRecepcionistCreditCustomer){
                                sHtml = sHtml + '<md-button aria-label="cash" class="md-raised md-simpleButton gp-mini" ng-click="vm.registerCreditDebit(\'' + full._id  + '\')"><md-tooltip aria-label="Cash">{{ "GENERAL.HINTS.CREDITDEBIT" | translate }}</md-tooltip><i class="icon-currency-usd" layout="center"></i></md-button>';
                            }
                        }



                        sHtml = sHtml + '<md-button aria-label="cash" class="md-raised md-simpleButton gp-mini" ng-click="vm.customerHistory(\'' + full._id + '\')"><md-tooltip aria-label="Cash">{{ "GENERAL.HINTS.HISTORY" | translate }}</md-tooltip><i class="icon-history" layout="center"></i></md-button>';

                        if ($rootScope.userType == 'RECEPCIONIST') {
                            if ($rootScope.pdvConfiguration.allowRecepcionistDeleteCustomer) {
                                sHtml = sHtml + '<md-button aria-label="Trash" class="md-raised md-warn gp-mini" ng-click="::vm.removeCustomer(\'' + full._id + '\')"><md-tooltip aria-label="Pencil">{{ "GENERAL.HINTS.TRASH" | translate }}</md-tooltip><i class="icon-trash" layout="center"></i></md-button>';
                            }
                        } else {
                            sHtml = sHtml + '<md-button aria-label="Trash" class="md-raised md-warn gp-mini" ng-click="::vm.removeCustomer(\'' + full._id + '\')"><md-tooltip aria-label="Pencil">{{ "GENERAL.HINTS.TRASH" | translate }}</md-tooltip><i class="icon-trash" layout="center"></i></md-button>';
                        }


                        return sHtml;
                    })


                ];

                //console.log($window.localStorage['securityToken']);
                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption('ajax', {
                        // Either you specify the AjaxDataProp here
                        // dataSrc: 'data',
                        url: backendServer + '/customer/getCustomersPaged',
                        type: 'POST',
                        data:{
                            token: $rootScope.securityToken
                        }
                    })
                    .withDataProp('d')
                    .withOption('autoWidth', false)
                    .withOption('processing', true)
                    .withOption('serverSide', true)
                    .withOption('createdRow', function (row) {
                        // Recompiling so we can bind Angular directive to the DT
                        $compile(angular.element(row).contents())($scope);
                    })
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable": "Nenhum registro disponível",
                        "sInfo": "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty": "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered": "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix": "",
                        "sInfoThousands": ",",
                        "sLengthMenu": "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing": "Processando...",
                        "sSearch": "Busca:",
                        "sZeroRecords": "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst": "Primeiro",
                            "sLast": "Ultimo",
                            "sNext": "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending": ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });
                //vm.dtColumnDefs = [
                //    DTColumnDefBuilder.newColumnDef(0).notSortable()
                //];
                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                break;
            case "app.customer.history":
                loadCustomer($state.params.customerId, function (data) {
                    vm.customerName = data.name;
                });

                vm.showTable = true;

                //history
                vm.dtColumnsHistory = [
                    DTColumnBuilder.newColumn('date').withTitle('Data').notSortable().renderWith(function (data, type, full) {
                        return $filter('date')(data, "dd/MM/yyyy HH:mm");
                    }),
                    DTColumnBuilder.newColumn('serviceName').withTitle('Serviço').notSortable(),
                    DTColumnBuilder.newColumn('professionalName').withTitle('Profissional').notSortable(),
                    /*DTColumnBuilder.newColumn('itemPrice').withTitle('Valor').notSortable().renderWith(function (data, type, full) {
                        return $filter('currency')(data, 'R$', 2);
                    }),*/
                    DTColumnBuilder.newColumn('_id').notVisible().notSortable(),
                    DTColumnBuilder.newColumn(null).withClass('right').withTitle('').renderWith(function (data, type, full) {
                        var sHtml = "";
                        //sHtml = sHtml + "<md-button aria-label= 'Pencil' class='md-raised md-accent gp-mini'  ng-click='::vm.newSchedule(customer)' ><md-tooltip aria-label='Pencil'>{{ 'GENERAL.HINTS.SCHEDULE' | translate }}</md-tooltip><i class='icon-calendar' layout='center'></i></md-button>";
                        return sHtml;
                    })


                ];

                vm.dtOptionsHistory = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption('ajax', {
                        url: backendServer + '/sale/getSalesByCustomerPaged',
                        type: 'POST',
                        data:{
                            customerId : $state.params.customerId,
                            token: $rootScope.securityToken
                        }
                    })
                    .withDataProp('d')
                    .withOption('autoWidth', false)
                    .withOption('processing', true)
                    .withOption('serverSide', true)
                    .withOption('createdRow', function (row) {
                        // Recompiling so we can bind Angular directive to the DT
                        $compile(angular.element(row).contents())($scope);
                    })
                    .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable": "Nenhum registro disponível",
                        "sInfo": "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty": "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered": "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix": "",
                        "sInfoThousands": ",",
                        "sLengthMenu": "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing": "Processando...",
                        "sSearch": "Busca:",
                        "sZeroRecords": "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst": "Primeiro",
                            "sLast": "Ultimo",
                            "sNext": "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending": ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });
                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                //history
                vm.dtColumnsHistoryProduct = [
                    DTColumnBuilder.newColumn('date').withTitle('Data').notSortable().renderWith(function (data, type, full) {
                        return $filter('date')(data, "dd/MM/yyyy HH:mm");
                    }),
                    DTColumnBuilder.newColumn('productName').withTitle('Serviço').notSortable(),
                    DTColumnBuilder.newColumn('professionalName').withTitle('Profissional').notSortable(),
                    /*DTColumnBuilder.newColumn('itemPrice').withTitle('Valor').notSortable().renderWith(function (data, type, full) {
                        return $filter('currency')(data, 'R$', 2);
                    }),*/
                    //DTColumnBuilder.newColumn('_id').notVisible().notSortable(),
                    DTColumnBuilder.newColumn(null).withClass('right').withTitle('').renderWith(function (data, type, full) {
                        var sHtml = "";
                        //sHtml = sHtml + "<md-button aria-label= 'Pencil' class='md-raised md-accent gp-mini'  ng-click='::vm.newSchedule(customer)' ><md-tooltip aria-label='Pencil'>{{ 'GENERAL.HINTS.SCHEDULE' | translate }}</md-tooltip><i class='icon-calendar' layout='center'></i></md-button>";
                        return sHtml;
                    })


                ];

                vm.dtOptionsHistoryProduct = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption('ajax', {
                        url: backendServer + '/sale/getProductSalesByCustomer',
                        type: 'POST',
                        data:{
                            customerId : $state.params.customerId,
                            token: $rootScope.securityToken
                        }
                    })
                    .withDataProp('d')
                    .withOption('autoWidth', false)
                    .withOption('processing', true)
                    .withOption('serverSide', true)
                    .withOption('createdRow', function (row) {
                        // Recompiling so we can bind Angular directive to the DT
                        $compile(angular.element(row).contents())($scope);
                    })
                    .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable": "Nenhum registro disponível",
                        "sInfo": "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty": "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered": "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix": "",
                        "sInfoThousands": ",",
                        "sLengthMenu": "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing": "Processando...",
                        "sSearch": "Busca:",
                        "sZeroRecords": "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst": "Primeiro",
                            "sLast": "Ultimo",
                            "sNext": "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending": ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });
                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                //transactions
                vm.dtColumnsTransactions = [
                    DTColumnBuilder.newColumn('date').withTitle('Data').notSortable().renderWith(function (data, type, full) {
                        return $filter('date')(data, "dd/MM/yyyy HH:mm");
                    }),
                    DTColumnBuilder.newColumn('operator').withTitle('Operador').notSortable(),
                    DTColumnBuilder.newColumn('amount').withTitle('Valor').notSortable(),
                    DTColumnBuilder.newColumn('observation').withTitle('Observação').notSortable(),
                    DTColumnBuilder.newColumn('_id').notVisible().notSortable(),
                    DTColumnBuilder.newColumn(null).withClass('right').withTitle('').renderWith(function (data, type, full) {
                        var sHtml = "";
                        //sHtml = sHtml + "<md-button aria-label= 'Pencil' class='md-raised md-accent gp-mini'  ng-click='::vm.newSchedule(customer)' ><md-tooltip aria-label='Pencil'>{{ 'GENERAL.HINTS.SCHEDULE' | translate }}</md-tooltip><i class='icon-calendar' layout='center'></i></md-button>";
                        return sHtml;
                    })


                ];

                vm.dtOptionsTransactions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption('ajax', {
                        url: backendServer + '/customer/getCustomerTransactions',
                        type: 'POST',
                        data:{
                            customerId : $state.params.customerId,
                            token: $rootScope.securityToken
                        }
                    })
                    .withDataProp('d')
                    .withOption('autoWidth', false)
                    .withOption('processing', true)
                    .withOption('serverSide', true)
                    .withOption('createdRow', function (row) {
                        // Recompiling so we can bind Angular directive to the DT
                        $compile(angular.element(row).contents())($scope);
                    })
                    .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable": "Nenhum registro disponível",
                        "sInfo": "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty": "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered": "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix": "",
                        "sInfoThousands": ",",
                        "sLengthMenu": "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing": "Processando...",
                        "sSearch": "Busca:",
                        "sZeroRecords": "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst": "Primeiro",
                            "sLast": "Ultimo",
                            "sNext": "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending": ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });
                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');


                //schedules
                vm.dtColumnsSchedules = [
                    DTColumnBuilder.newColumn('date').withTitle('Data').notSortable().renderWith(function (data, type, full) {
                        return $filter('date')(data, "dd/MM/yyyy HH:mm");
                    }),
                    DTColumnBuilder.newColumn('service').withTitle('Serviço').notSortable(),
                    DTColumnBuilder.newColumn('amount').withTitle('Valor').notSortable(),
                    DTColumnBuilder.newColumn('status').withTitle('Status').notSortable(),
                    DTColumnBuilder.newColumn(null).withClass('right').withTitle('').renderWith(function (data, type, full) {
                        var sHtml = "";
                        //sHtml = sHtml + "<md-button aria-label= 'Pencil' class='md-raised md-accent gp-mini'  ng-click='::vm.newSchedule(customer)' ><md-tooltip aria-label='Pencil'>{{ 'GENERAL.HINTS.SCHEDULE' | translate }}</md-tooltip><i class='icon-calendar' layout='center'></i></md-button>";
                        return sHtml;
                    })


                ];

                vm.dtOptionsSchedules = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption('ajax', {
                        url: backendServer + '/customer/getCustomerSchedules',
                        type: 'POST',
                        data:{
                            customerId : $state.params.customerId,
                            token: $rootScope.securityToken
                        }
                    })
                    .withDataProp('d')
                    .withOption('autoWidth', false)
                    .withOption('processing', true)
                    .withOption('serverSide', true)
                    .withOption('createdRow', function (row) {
                        // Recompiling so we can bind Angular directive to the DT
                        $compile(angular.element(row).contents())($scope);
                    })
                    .withDOM('rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable": "Nenhum registro disponível",
                        "sInfo": "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty": "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered": "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix": "",
                        "sInfoThousands": ",",
                        "sLengthMenu": "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing": "Processando...",
                        "sSearch": "Busca:",
                        "sZeroRecords": "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst": "Primeiro",
                            "sLast": "Ultimo",
                            "sNext": "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending": ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });
                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                break;

            case "app.customer.inventory":
                vm.removeInventoryItem =removeInventoryItem;
                
                vm.dtOptions = DTOptionsBuilder.newOptions()
                    .withPaginationType('simple')
                    .withDisplayLength(10)
                    .withOption({ autoWidth: false })
                    .withDOM('<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>')
                    .withLanguage({
                        "sEmptyTable": "Nenhum registro disponível",
                        "sInfo": "Mostrando _START_ até _END_ de _TOTAL_ registros",
                        "sInfoEmpty": "Mostrando 0 até 0 de 0 registros",
                        "sInfoFiltered": "(filtrado de um total de _MAX_ registros)",
                        "sInfoPostFix": "",
                        "sInfoThousands": ",",
                        "sLengthMenu": "Mostrar _MENU_ registros",
                        "sLoadingRecords": "Carregando...",
                        "sProcessing": "Processando...",
                        "sSearch": "Busca:",
                        "sZeroRecords": "Não encontramos nenhum registro",
                        "oPaginate": {
                            "sFirst": "Primeiro",
                            "sLast": "Ultimo",
                            "sNext": "Próximo",
                            "sPrevious": "Anterior"
                        },
                        "oAria": {
                            "sSortAscending": ": activate to sort column ascending",
                            "sSortDescending": ": activate to sort column descending"
                        }
                    });

                DTDefaultOptions.setLoadingTemplate('<h3>Loading</h3>');

                api.getCustomerInventory.save({

                    customerId: $state.params.customerId
                },
                    function (response) {

                    console.log(response.d);
                        vm.items = response.d;
                            
                        vm.showTable = true;

                    },
                    function (error) {
                        console.log(error);
                    });

                

                break;


            case "app.customer.new":

                vm.loading = false;
                vm.saveCustomer = saveCustomer;

                api.partnerships.save({

                },
                    function (response) {

                        vm.partnerships = [];
                        vm.partnerships.push(null);
                        for (var i = 0; i < response.d.length; i++) {
                            vm.partnerships.push(response.d[i]);
                        }


                        vm.customer = {
                            _id: null,
                            gender: 'female',
                            name: $state.params.customerName,
                            cpf: '',
                            enableSMS: true,
                            enableEmail: true,
                            email: '',
                            newCustomer: 'Y',
                            telephone: ''
                        };

                    },
                    function (error) {
                        console.log(error);
                    });



                break;

            case "app.customer.newFromSchedule":
                api.partnerships.save({

                },
                    function (response) {

                        vm.partnerships = [];
                        vm.partnerships.push(null);
                        for (var i = 0; i < response.d.length; i++) {
                            vm.partnerships.push(response.d[i]);
                        }



                        vm.customer = {
                            _id: null,
                            gender: 'female',
                            name: $state.params.customerName,
                            cpf: '',
                            enableSMS: true,
                            newCustomer: 'Y',
                            enableEmail: true,
                            email: '',
                            telephone: ''
                        };
                    },
                    function (error) {
                        console.log(error);
                    });

                vm.saveCustomer = saveCustomer;
                break;

            case "app.customer.edit":
                vm.saveCustomer = saveCustomer;

                loadCustomer($state.params.customerId, function (data) {
                    if (data.enableSMS == 1) {
                        data.enableSMS = true;
                    } else {
                        data.enableSMS = false;
                    }
                    if (data.enableEmail == 1) {
                        data.enableEmail = true;
                    } else {
                        data.enableEmail = false;
                    }
                    vm.customer = data;

                    api.partnerships.save({

                    },
                        function (response) {

                            vm.partnerships = [];
                            vm.partnerships.push(null);
                            for (var i = 0; i < response.d.length; i++) {
                                vm.partnerships.push(response.d[i]);
                            }


                        },
                        function (error) {
                            console.log(error);
                        });

                })


                break;
        }

        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({}, last);
        $scope.getToastPosition = function () {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function (pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if (current.bottom && last.top) current.top = false;
            if (current.top && last.bottom) current.bottom = false;
            if (current.right && last.left) current.left = false;
            if (current.left && last.right) current.right = false;
            last = angular.extend({}, current);
        }
        ///END TOAST

        // functions
        function loadCustomer(customerId, callback) {
            api.customer.save({
                customerId: customerId
            },
                function (response) {
                    callback(response.d);
                },
                function (error) {
                    console.log(error);
                });
        }

        function removeInventoryItem(item){
            api.removeInventoryItem.save({
                inventoryId : item
            }, function(response){
                $mdToast.show(
                    $mdToast.simple()
                        .textContent("Item consumido com sucesso.")
                        .hideDelay(1000)
                );
                $mdDialog.hide(response.d);
                $state.reload();
            })
        }

        function saveCustomerDialog() {
            var birthday = 0;
            if (vm.customer.birthday != null) {
                birthday = vm.customer.birthday.valueOf();
            }
            if (vm.customer.cpf == null) {
                vm.customer.cpf = '';
            }
            vm.loading = true;
            api.saveCustomer.save({
                customerId: vm.customer._id,
                name: vm.customer.name,
                email: vm.customer.email,
                gender: vm.customer.gender,
                cpf: vm.customer.cpf,
                enableSMS: vm.customer.enableSMS,
                enableEmail: vm.customer.enableEmail,
                birthdayDay: vm.customer.birthdayDay,
                birthdayMonth: vm.customer.birthdayMonth,
                telephone: vm.customer.telephone,
                partnershipId: vm.customer.partnershipId,
                observation: vm.customer.observation
            },
                function (response) {

                    var pinTo = $scope.getToastPosition();
                    vm.loading = false;

                    if (response.s == 200){

                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("CUSTOMER.TOAST.SAVE.SUCCESS"))
                                .hideDelay(1000)
                        );
                        $mdDialog.hide(response.d);

                    } else if (response.s == 500){
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent("Telefone já cadastrado")
                                .hideDelay(1000)
                        );
                    }
                },
                function (error) {
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("CUSTOMER.TOAST.SAVE.ERROR"))
                            .hideDelay(1000)
                    );

                    vm.closeDialog();

                });
        }
        function saveCustomer() {
            var birthday = 0;
            if (vm.customer.birthday != null) {
                birthday = vm.customer.birthday.valueOf();
            }
            vm.loading = true;
            api.saveCustomer.save({
                customerId: vm.customer._id,
                name: vm.customer.name,
                email: vm.customer.email,
                gender: vm.customer.gender,
                cpf: '',
                newCustomer: vm.customer.newCustomer,
                enableSMS: vm.customer.enableSMS,
                enableEmail: vm.customer.enableEmail,
                birthdayDay: vm.customer.birthdayDay,
                birthdayMonth: vm.customer.birthdayMonth,
                telephone: vm.customer.telephone,
                partnershipId: vm.customer.partnershipId,
                observation: vm.customer.observation,
                knowUs : vm.customer.knowUs
            },
                function (response) {

                    vm.loading = false;
                    var pinTo = $scope.getToastPosition();
                    if (response.s == 200){
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("CUSTOMER.TOAST.SAVE.SUCCESS"))
                                .hideDelay(1000)
                        );

                        //redirect
                        setTimeout(function () {
                            $state.go('app.customer.list');

                            //se veio de um novo agenbdamento deve reabrir a ficha de agendamento

                            if (currentState == 'app.customer.newFromSchedule') {
                                newSchedule(response.d);
                            }
                        }, 1000);

                    } else {
                        if (response.s == 500){
                            $mdToast.show(
                                $mdToast.simple()
                                    .textContent("Telefone já cadastrado")
                                    .hideDelay(1000)
                            );
                        }

                    }


                },
                function (error) {
                    var pinTo = $scope.getToastPosition();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("CUSTOMER.TOAST.SAVE.ERROR"))
                            .hideDelay(1000)
                    );
                    if ((currentState == 'app.customer.new') || (currentState == 'app.customer.edit')) {
                        //redirect
                        setTimeout(function () {
                            $state.go('app.customer.list');
                        }, 1000);
                    } else {
                        vm.closeDialog();
                    }
                });

        }

        function removeCustomer(customerId) {
            var confirm = $mdDialog.confirm()
                .title($translate.instant("CUSTOMER.DIALOG.REMOVE.TITLE"))
                .textContent($translate.instant("CUSTOMER.DIALOG.REMOVE.SUBTITLE"))
                .ariaLabel('Remove')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok($translate.instant("GENERAL.DIALOG.OK"))
                .cancel($translate.instant("GENERAL.DIALOG.CANCEL"));
            $mdDialog.show(confirm).then(function () {

                api.removeCustomer.save({
                    customerId: customerId
                },
                    function (response) {
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("CUSTOMER.TOAST.REMOVE.SUCCESS"))
                                .hideDelay(2000)
                        );
                        //redirect
                        setTimeout(function () {
                            $state.reload();
                        }, 1000);
                    },
                    function (error) {
                        var pinTo = $scope.getToastPosition();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent($translate.instant("CUSTOMER.TOAST.REMOVE.ERROR"))
                                .hideDelay(1000)
                        );

                        //redirect
                        setTimeout(function () {
                            $state.reload();
                        }, 1000);

                    });
            });
        };

        function editCustomer(customerId) {
            $state.go('app.customer.edit', { customerId: customerId });
        }
        function customerInventory(customerId) {
            $state.go('app.customer.inventory', { customerId: customerId });
        }
        function customerHistory(customerId) {
            $state.go('app.customer.history', { customerId: customerId });
        }

        function newSchedule(customer) {
            $mdDialog.show({
                controller: 'NewScheduleController',
                controllerAs: 'vm',
                locals: {
                    professional: undefined,
                    customer: customer,
                    whenTime: undefined,
                    whenDate : undefined
                },
                templateUrl: 'app/main/schedule/newSchedule/newSchedule.html',
                clickOutsideToClose: true
            })
                .then(function (answer) {

                }, function () {
                    $rootScope.$broadcast('openNewScheduleDialog');
                });
        }

        function closeDialog(){
            $mdDialog.hide(null);
        }

        function registerCreditDebit(customerId) {

            $mdDialog.show({
                template: [
                    '<md-dialog style="width:500px;"  ng-class="dialog.css">',
                    '<form name="basicForm" class="md-inline-form"  novalidate>' ,
                    '  <md-dialog-content class="md-dialog-content" role="document" tabIndex="-1">',
                    '    <h2 class="md-title">Crédito/Débito</h2>',
                    '    <div class="md-dialog-content-body">',
                    '      <p>Informe o valor de crédito ou débito. </p>',
                    '    </div>',
                    '    <div layout="row" layout-gt-sm="row">',
                    '    <md-input-container md-no-float class="md-prompt-input-container" flex="50">',
                    '      <label>Valor</label>',
                    '      <input type=number name=valor required md-autofocus ng-model="dialog.result.value" ' +
                    '             placeholder="Ex. 50 para crédito ou -35 para débito" >',
                    '       <div ng-messages="basicForm.valor.$error" role="alert">',
                    '          <div ng-message="required">',
                    '           <span>Valor é obrigatório</span>',
                    '          </div>',
                    '       </div>',
                    '    </md-input-container>',
                    '    <md-input-container md-no-float class="md-prompt-input-container" style="margin-top:18px"  flex="50">',
                    '      <label>Forma de Pagamento</label>',
                    '      <md-select name=paymentForm ng-disabled="dialog.result.value<=0" ng-model="dialog.result.paymentForm">',
                    ((($rootScope.userType == 'ADMIN') || ($rootScope.userType == 'MASTER')))? '         <md-option selected value="NONE">Nenhuma</md-option>':'',
                    '         <md-option value="CASH">Dinheiro</md-option>',
                    '         <md-option value="CHECK">Cheque</md-option>',
                    '         <md-option value="VISA_CREDIT">Visa Credito</md-option>',
                    '         <md-option value="VISA_DEBIT">Visa Débito</md-option>',
                    '         <md-option value="MASTER_CREDIT">Master Credito</md-option>',
                    '         <md-option value="MASTER_DEBIT">Master Débito</md-option>',
                    '         <md-option value="AMEX">AMEX</md-option>',
                    '         <md-option value="DINERS">DINERS</md-option>',
                    '         <md-option value="ELO">ELO</md-option>',
                    '         <md-option value="WOWEE_CREDIT">WoWee Credito</md-option>',
                    '         <md-option value="WOWEE_DEBIT">WoWee Debito</md-option>',
                    '         <md-option value="OTHER_CREDIT">Outros Credito</md-option>',
                    '         <md-option value="OTHER_DEBIT">Outros Débito</md-option>',
                    '      </md-select>',
                    '       <div ng-messages="basicForm.valor.$error" role="alert">',
                    '          <div ng-message="required">',
                    '           <span>Forma de pagamento é obrigatória</span>',
                    '          </div>',
                    '       </div>',
                    '    </md-input-container>',
                    '    </div>',
                    '    <div layout="row" layout-gt-sm="row">',
                    '    <md-input-container md-no-float class="md-prompt-input-container" flex="100">',
                    '      <label>Justificativa</label>'+
                    '      <input type=text name=obs required ng-model="dialog.result.observation"  ' +
                    '             placeholder="Justificativa"></input>',
                    '       <div ng-messages="basicForm.obs.$error" role="alert">',
                    '          <div ng-message="required">',
                    '           <span>Justificativa é obrigatória</span>',
                    '          </div>',
                    '       </div>',
                    '    </md-input-container>',
                    '   </div>',
                    '   <div layout="row" layout-gt-sm="row" style="margin-top:-20px">',
                    '    <md-input-container  md-no-float class="md-prompt-input-container" style="margin-top:0px" ng-if="dialog.showPdvLocation" flex="50" >',
                    '       <label>Local</label>',
                    '       <md-select ng-model="dialog.result.pdvLocation" required style="margin-top:-10px">',
                    '           <md-option ng-value="item.locationId" ng-repeat="item in dialog.pdvLocations">{{item.name}}</md-option>',
                    '       </md-select>',
                    '    </md-input-container>',
                    '    <md-input-container md-no-float class="md-prompt-input-container" style="margin-top:0px" >',
                    '      <label>Data</label>'+
                    '      <input type=date name=date required ng-model="dialog.result.date"  ' +
                    '             placeholder="Data"></input>',
                    '    </md-input-container>',
                    '   </div>',
                    '  <md-dialog-actions>',
                    '    <md-button ng-click="dialog.hide()" ng-disabled="basicForm.$invalid" class="md-raised md-confirm-button" >',
                    '      {{ dialog.ok }}',
                    '    </md-button>',
                    '    <md-button ng-click="dialog.abort()" class="md-raised md-warn">',
                    '      {{ dialog.cancel }}',
                    '    </md-button>',
                    '  </md-dialog-actions>',
                    '</form>',
                    '</md-dialog>'
                ].join('').replace(/\s\s+/g, ''),
                multiple: true,
                controller: function mdDialogCtrl() {
                    this.ok = 'Confirmar';
                    this.cancel = 'Cancelar';
                    this.result = {};
                    this.result.value= 0;
                    this.result.tefFailed = false;
                    this.result.date = new Date();

                    this.showPdvLocation = false;
                    this.pdvLocations = $rootScope.pdvLocations;
                    if (this.pdvLocations.length > 1){
                        this.showPdvLocation = true;
                        this.result.pdvLocation = this.pdvLocations[0].locationId;
                    }


                    this.hide = function () {
                        
                        $scope.mResult = this.result; //para trafegar entre diferentes dialogs
                        //mostra a tela de espera da maquininha
                        if (this.result.paymentForm.indexOf("WOWEE") !== -1)
                        {      
                                                        
                            $mdDialog.show({
                                controller: 'SalesCheckoutPopupWoweeDialog',
                                controllerAs: 'vm',
                                templateUrl: 'app/main/sales/addPaymentWowee.html',
                                clickOutsideToClose: false,
                                preserveScope: true,
                                scope: $scope,
                                multiple:true,                                
                                locals :{
                                    value : this.result.value,
                                    creditDebit : (this.result.paymentForm == "WOWEE_CREDIT") ? "C" : "D",
                                    saleId : 0
                                },
                                clickEscapetoClose: false
                            })
                                .then(function (answer) {
                                    
                                    if ((!answer.ignore) || (answer.ignore == null)) {
                                        
                                        if ($scope.mResult.paymentForm == "WOWEE_CREDIT")
                                        {
                                            $scope.mResult.paymentForm = "CREDITO - WOWEE PAY - " + answer.bandeiraName;
                                        }
                                        else
                                        {
                                            $scope.mResult.paymentForm = "DEBITO - WOWEE PAY - " + answer.bandeiraName;
                                        }
                                        
                                        $scope.mResult.value = answer.value;
                                    }
                                    else 
                                    {
                                        $scope.mResult.tefFailed = true;
                                    }
                                    $mdDialog.hide();
                
                                }, function () {                                   
                                });
                        }

                        else $mdDialog.hide();
                    };
                    this.abort = function () {
                        $mdDialog.cancel();
                    };

                },
                controllerAs: 'dialog',
                bindToController: true,

            })
                .then(function () {

                    var result = $scope.mResult; 
                                        
                                        if (result.tefFailed) 
                                        {
                    
                                            $mdToast.show(
                                                $mdToast.simple()
                                                    .textContent($translate.instant("CUSTOMER.CREDITDEBIT.ERROR"))
                                                    .hideDelay(1000)
                                            );
                    
                                            return;        
                                        }

                    api.creditCustomer.save({
                            customerId: customerId,
                            creditDebitValue : result.value,
                            paymentForm : result.paymentForm,
                            creditDebitObservation : result.observation,
                            date : (new Date()).valueOf(),
                            locationId : result.pdvLocation
                        },
                        function (response) {
                            if (response.s==200) {
                                $mdToast.show(
                                    $mdToast.simple()
                                        .textContent($translate.instant("CUSTOMER.CREDITDEBIT.SUCCESS"))
                                        .hideDelay(1000)
                                );

                                $mdDialog.hide();
                            } else {
                                $mdToast.show(
                                    $mdToast.simple()
                                        .textContent($translate.instant("CUSTOMER.CREDITDEBIT.ERROR"))
                                        .hideDelay(1000)
                                );
                                $mdDialog.hide();


                            }

                        },
                        function (error) {


                        });
                }, function () {
                    $mdDialog.cancel();
                });


        }


                function addWoweePayment(creditDebit){
                       //open modal dialog
           
                       $mdDialog.show({
                           controller: 'SalesCheckoutPopupWoweeDialog',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/sales/addPaymentWowee.html',
                            clickOutsideToClose: false,
                            multiple:true,
                            locals :{
                                value : vm.saldo,
                                creditDebit : creditDebit,
                                saleId : saleId
                            },
                            clickEscapetoClose: false
                        })
                            .then(function (answer) {
                                if ((!answer.ignore) || (answer.ignore == null)) {
                                    vm.payments.push({
                                        'creditoDebito':creditDebit,
                                        //'bandeiraId': answer.bandeiraId,
                                        'bandeiraId': 1,
                                        //'bandeiraName':answer.bandeiraName,
                                        'bandeiraName':'VISA',
                                        //'codAutorizacao' : answer.codAutorizacao,
                                        'codAutorizacao' : '111',
                                        'cardId' : 'WOWEE',
                                        //'adquirenteName' : 'WoWee PAY',
                                        'adquirenteName' : 'WOWEE PAY',
                                        'value': answer.value,
                                        'id':generateUUID()
                                    })
                                    vm.updateSaldo();
                                    //chamar aquele outro metodo aqui!!
                                    
                                }
            
                            }, function () {
                                //
                            });
                    }

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'grey',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'grey',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            simpleButton :{
                name: 'orange'
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'grey',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController)
        .controller('PanelDialogCtrlExpressCheckin', PanelDialogCtrlExpressCheckin)


    /** @ngInject */
    ToolbarController.$inject = ['$scope', 'api', '$rootScope', '$window', '$q', '$state', '$timeout', '$mdSidenav', '$translate',
    '$mdToast', 'msNavigationService', '$mdDialog', 'hotkeys', '$mdPanel', '$location'];
    function ToolbarController($scope, api, $rootScope, $window, $q, $state, $timeout, $mdSidenav, $translate, $mdToast,
                               msNavigationService, $mdDialog, hotkeys, $mdPanel, $location)
    {
        var vm = this;

        //loading user name
        vm.userName = $rootScope.userName;
        vm.pdvName = $rootScope.pdvName;
        vm.pdvs = $rootScope.pdvs;


        //console.log($rootScope.plan);
        //mostrar periodo de trial
        /*vm.showTrial = function(){
            console.log($rootScope.validUntil);
            console.log($rootScope.validUntil.valueOf() - new Date().valueOf());
            return false;
        }*/


        vm.changePDV = function(pdv) {

            //CHENAGE PDV
            //$rootScope.userName = response.d.userName;
            $rootScope.userType = pdv.userType;
            $rootScope.pdvName = vm.pdvName = pdv.pdvName;
            $rootScope.subscriptions = pdv.subscriptions;
            $rootScope.securityToken = pdv.token;
            $rootScope.pdvId = pdv.pdvId;


            $rootScope.$emit('changeToken', []);

            console.log(pdv.token);

            $rootScope.showTrial = false;
            for(var j=0; j < $rootScope.subscriptions.length; j++){
                for(var k=0; k < $rootScope.subscriptions[j].products.length; k++){
                    if ($rootScope.subscriptions[j].products[k] == 'WEB'){
                        var m1 = new moment($rootScope.subscriptions[j].until);
                        if (m1.diff(new moment(), 'days') < 7){
                            $rootScope.showTrial = true;
                            $rootScope.validUntil = m1.format('DD/MM/YYYY');
                            if  (m1.diff(new moment(), 'days') < 0) {
                                $rootScope.showMessageVencimento = true;
                                $rootScope.showMessageTrial = false;
                            } else {
                                $rootScope.showMessageTrial = true;
                                $rootScope.showMessageVencimento = false;
                            }

                        }

                    }
                }
            }

            //pegar os pdvLocations
            api.pdvLocations.save({
                },
                function (response) {
                    $rootScope.pdvLocations = response.d;


                    console.log(response.d);
                });

            //
            createCache();

            //load info
            api.generalConfiguration.save({
                },
                function(response){
                    if(response.d == undefined){
                        vm.configuration = {
                            requestPasswordSchedule : false,
                            requestPasswordCheckout : false,
                            requestPasswordBlock : false,
                            allowScheduleByProfessional : false,
                            allowCustomerEditByProfessional : false,
                            transferServiceFromScheduleToSale : true,
                            showCanceled : false,
                            showNoShow : false,
                            sendReminderEmail : false,
                            sendReminderEmail2 : false,
                            sendReminderSMS : false,
                            notification : {
                            }
                        }

                    } else {
                        //console.log(response.d)
                        vm.configuration = response.d;
                        if (response.d.requestPasswordSchedule == 1){
                            vm.configuration.requestPasswordSchedule = true;
                        } else {
                            vm.configuration.requestPasswordSchedule = false;
                        }
                        if (response.d.requestPasswordCheckout == 1){
                            vm.configuration.requestPasswordCheckout = true;
                        } else {
                            vm.configuration.requestPasswordCheckout = false;
                        }
                        if (response.d.allowScheduleByProfessional == 1){
                            vm.configuration.allowScheduleByProfessional = true;
                        } else {
                            vm.configuration.allowScheduleByProfessional = false;
                        }
                        if (response.d.allowCustomerEditByProfessional == 1){
                            vm.configuration.allowCustomerEditByProfessional = true;
                        } else {
                            vm.configuration.allowCustomerEditByProfessional = false;
                        }
                        if (response.d.transferServiceFromScheduleToSale == 1){
                            vm.configuration.transferServiceFromScheduleToSale = true;
                        } else {
                            vm.configuration.transferServiceFromScheduleToSale = false;
                        }


                        if (response.d.requestPasswordBlock == 1){
                            vm.configuration.requestPasswordBlock = true;
                        } else {
                            vm.configuration.requestPasswordBlock = false;
                        }
                        if (response.d.showCanceled == 1){
                            vm.configuration.showCanceled = true;
                        } else {
                            vm.configuration.showCanceled = false;
                        }
                        if (response.d.showNoShow == 1){
                            vm.configuration.showNoShow = true;
                        } else {
                            vm.configuration.showNoShow = false;
                        }

                        if (response.d.sendReminderEmail == 1){
                            vm.configuration.sendReminderEmail = true;
                        } else {
                            vm.configuration.sendReminderEmail = false;
                        }
                        if (response.d.sendReminderEmail2 == 1){
                            vm.configuration.sendReminderEmail2 = true;
                        } else {
                            vm.configuration.sendReminderEmail2 = false;
                        }
                        if (response.d.sendReminderSMS == 1){
                            vm.configuration.sendReminderSMS = true;
                        } else {
                            vm.configuration.sendReminderSMS = false;
                        }
                        vm.configuration.notification = response.d.notification;

                        $rootScope.pdvConfiguration = vm.configuration;

                    }

                },
                function(error){
                    console.log(error);
                });


            //perfil do profissional no pdv
            if (($rootScope.userType == 'MASTER') || ($rootScope.userType == 'ADMIN') ){
                if ($state.current.name == "app.dashboard"){
                    $state.reload("app.dashboard");
                } else {
                    $state.go("app.dashboard");
                }
            } else {
                if ($state.current.name == "app.schedule.byprofessional"){
                    $state.reload("app.schedule.byprofessional");
                } else {
                    $state.go("app.schedule.byprofessional");
                }
            }



        }

        vm.mgotoTutorialNovosClientes = function(){
            $state.go('app.tutorial.novosclientes');
        }
        vm.gotoSubscription = function(){
            $state.go('app.subscription.price-table');
        }
        vm.gotoSMS = function(){
            $state.go('app.subscription.extras');
        }
        vm.gotoChangeInfo = function(){
            $state.go('app.professional.changeMyInfo');
        }

        vm.goToChangePassword = function(){
            $state.go('app.professional.changePassword');
        }

        vm.goToChangeRelatedPDVS = function(){
            $state.go('app.professional.relatedPDV');
        }


        vm.showPPT = function(){
            $mdDialog.show({
                controller: 'SupportController as vm',
                templateUrl: 'app/main/support/ppt.html',
                parent: angular.element(document.body),
                targetEvent: null,
                multiple:true,
                clickOutsideToClose:true,
                locals:{
                    topic : ''
                },
                fullscreen: false
            })
                .then(function(answer) {


                }, function() {

                });
        }

        vm.goToHelp = function(){
            window.open('https://gpsoftware.zendesk.com', '_blank');
        }
        vm.goToWizard = function(){
            $state.go('app.wizard');
        }
        vm.changePassword = function(){
            $state.go('app.settings.account.user.changePassword');
        }

        vm.gotoSignup = function(){
            $window.open('https://app.gpsoftware.com.br/auth/signup', '_blank');
        }

        $rootScope.changeUserName = function(name){
            vm.userName = name;
        }

        function getSubdomain(){
            var host = $location.host();
            if (host.indexOf('.') < 0){
                return null;
            }
            else
                return host.split('.')[0];
        }

        if (getSubdomain() == 'demo') {
            vm.showButtonContaExclusiva = true;
        } else {
            vm.showButtonContaExclusiva = false;
        }

        if (getSubdomain() == 'app') {
            vm.showPickSalao = true;
        } else {
            vm.showPickSalao = false;
        }




        hotkeys.add({
            combo: 'f4',
            description: 'Novo agendamento',
            callback: function() {
                newSchedule();
            }
        });
        hotkeys.add({
            combo: 'f3',
            description: 'Search Customer',
            callback: function() {
                //search customer
            }
        });
        hotkeys.add({
            combo: 'f6',
            description: 'Busca Cliente',
            callback: function() {
                searchCustomer();
            }
        });


        // Data
        $rootScope.global = {
            search: ''
        };



        vm.bodyEl = angular.element('body');

        vm.languages = {
            pt: {
                'title'      : 'Portugues',
                'translation': 'TOOLBAR.PORTUGUESE',
                'code'       : 'pt',
                'flag'       : 'pt-br'
            }
        };

        //loading configuration
        //load info
        api.generalConfiguration.save({
            },
            function(response){
                if(response.d == undefined){
                    vm.configuration = {
                        requestPasswordSchedule : false,
                        requestPasswordCheckout : false,
                        requestPasswordBlock : false,
                        showCanceled : false,
                        showNoShow : false,
                        sendReminderEmail : false,
                        sendReminderEmail2 : false,
                        sendReminderSMS : false
                    }

                } else {
                    //console.log(response.d)
                    $rootScope.pdvConfiguration = response.d;
                }

            },
            function(error){
                console.log(error);
            });

        //caching objects
        //salvando serviços em cache temporario
        function accentFold(inStr) {
            return inStr.replace(/([àáâãäå])|([ç])|([èéêë])|([ìíîï])|([ñ])|([òóôõöø])|([ß])|([ùúûü])|([ÿ])|([æ])/g, function(str,a,c,e,i,n,o,s,u,y,ae) { if(a) return 'a'; else if(c) return 'c'; else if(e) return 'e'; else if(i) return 'i'; else if(n) return 'n'; else if(o) return 'o'; else if(s) return 's'; else if(u) return 'u'; else if(y) return 'y'; else if(ae) return 'ae'; });
        }
        //zerando o cache
        $rootScope.cacheServices = [];
        $rootScope.cacheCustomers = [];



        // Methods
        vm.newSchedule = newSchedule;
        vm.searchCustomer = searchCustomer;
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;
        vm._mdPanel = $mdPanel;

        //produce cache
        createCache();
        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }

        function createCache(){
            api.serviceServices.save({},
                function(response){
                    var arTemp = response.d.services;
                    for(var i=0; i < arTemp.length; i++){
                        arTemp[i].name = angular.uppercase(accentFold(angular.lowercase(arTemp[i].name)));
                    }
                    $rootScope.cacheServices = arTemp;
                },
                function(error){
                    console.log(error);
                });
            api.customers.save({},
                function(response){
                    var arTemp = response.d;
                    for(var i=0; i < arTemp.length; i++){
                        arTemp[i].name = angular.uppercase(accentFold(angular.lowercase(arTemp[i].name)));
                    }
                    $rootScope.cacheCustomers = arTemp;
                },
                function(error){
                    console.log(error);
                });
        }

        function searchCustomer(){
            console.log('oi');
            $mdDialog.show({
                controller: PanelDialogCtrlExpressCheckin,
                controllerAs : 'vm',
                templateUrl: 'app/main/schedule/fastCheckin.html',
                clickOutsideToClose:true,
                multiple:true,
                escapeToClose : true,
                locals: {
                    customerName: vm.customerSearchText
                },
            })
                .then(function(answer) {

                }, function() {

                });

            /*var position = vm._mdPanel.newPanelPosition()
                .absolute()
                .center();

            var config = {
                attachTo: angular.element(document.body),
                controller: PanelDialogCtrlExpressCheckin,
                controllerAs: 'vm',
                templateUrl: 'app/main/customer/customerPanel.html',
                hasBackdrop: true,
                panelClass: 'dialog-search-customer',
                position: position,
                trapFocus: true,
                zIndex:100,
                clickOutsideToClose: true,
                escapeToClose: true,
                focusOnOpen: true
            };
            vm._mdPanel.open(config);*/
        }

        function newSchedule() {
            $mdDialog.show({
                controller: 'NewScheduleController',
                controllerAs: 'vm',
                locals: {
                    professional: null,
                    customer: null,
                    whenTime: null,
                    whenDate: null,
                    id: null
                },
                templateUrl: 'app/main/schedule/newSchedule/newSchedule.html',
                clickOutsideToClose: false
            })
                .then(function (answer) {

                }, function () {
                    $rootScope.$emit('refreshByProfessionalSchedule', null);
                });

        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }


        /**
         * Logout Function
         */
        function logout()
        {
            //$rootScope.securityToken =  "";
            //$rootScope.userName = "";

            branch.logout();

            $state.go('app.auth.signin');

            //$window.open('https://app.gpsoftware.com.br');
        }

        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded()
        {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query)
        {

            if (query.length <= 2){
                return true;
            }

            var deferred = $q.defer();
            api.customersSearch.save({
                    searchName:query
                },
                function(response){
                    var arTemp = [];
                    for(var i=0; i < response.d.length; i++){
                        var obj = {
                            title:response.d[i].name,
                            obj : response.d[i]
                        }
                        arTemp.push(obj);
                    }
                    deferred.resolve(arTemp)
                },
                function(error){
                    console.log(error);
                });

            return deferred.promise;


        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item)
        {
            if (item != undefined) {
                if (item.obj) {
                    $mdDialog.show({
                        controller: 'NewScheduleController',
                        controllerAs: 'vm',
                        locals: {
                            professional: undefined,
                            customer: item.obj,
                            whenTime: undefined,
                            whenDate: undefined
                        },
                        templateUrl: 'app/main/schedule/newSchedule/newSchedule.html',
                        clickOutsideToClose: true
                    })
                        .then(function (answer) {

                        }, function () {
                            newSchedule();
                        });
                }
            } else {
                $state.go('app.customer.newFromSchedule', {customerName:''});
            }
        }


    }


    //////////////

    PanelDialogCtrlExpressCheckin.$inject = ['$scope', '$q', 'api', '$mdToast', '$translate', '$rootScope',
        '$window', '$mdDialog']

    function PanelDialogCtrlExpressCheckin($scope, $q, api, $mdToast, $translate, $rootScope,
                 $window, $mdDialog){
        var vm = this;

        vm.checkinRequest = checkinRequest;
        vm.cancelRequest = cancelRequest;

        refreshPending();

       // vm.title = "Informe o nome do(a) cliente" ;

        ///>>>>>>TOAST CONFIG
        var last = {
            bottom: false,
            top: true,
            left: false,
            right: true
        };
        $scope.toastPosition = angular.extend({},last);
        $scope.getToastPosition = function() {
            sanitizePosition();
            return Object.keys($scope.toastPosition)
                .filter(function(pos) { return $scope.toastPosition[pos]; })
                .join(' ');
        };
        function sanitizePosition() {
            var current = $scope.toastPosition;
            if ( current.bottom && last.top ) current.top = false;
            if ( current.top && last.bottom ) current.bottom = false;
            if ( current.right && last.left ) current.left = false;
            if ( current.left && last.right ) current.right = false;
            last = angular.extend({},current);
        }
        ///END TOAST

        $scope.close = function(){
            $mdDialog.hide();
        }

        function checkinRequest(requestId) {
            api.requestCheckin.save({
                    requestId: requestId
                },
                function (response) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SCHEDULE.BYPROFESSIONAL.TOAST.CHECKIN.SUCCESS"))
                            .hideDelay(1000)
                    );
                    $scope.close();
                    $rootScope.$emit('refreshByProfessionalSchedule', null);

                }, function (error) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SCHEDULE.BYPROFESSIONAL.TOAST.CHECKIN.ERROR"))
                            .hideDelay(1000)
                    );

                    $rootScope.$emit('refreshByProfessionalSchedule', null);

                })
        };

        function cancelRequest(requestId){
            api.requestCancel.save({
                    requestId: requestId
                },
                function (response) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SCHEDULE.BYPROFESSIONAL.TOAST.CANCEL.SUCCESS"))
                            .hideDelay(1000)
                    );
                    $rootScope.$emit('refreshByProfessionalSchedule', null);
                    refreshCustomerSchedules();
                }, function (error) {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant("SCHEDULE.BYPROFESSIONAL.TOAST.CANCEL.ERROR"))
                            .hideDelay(1000)
                    );
                    $rootScope.$emit('refreshByProfessionalSchedule', null);

                })
        }

        function refreshPending() {
            vm.processing = true;
            api.getPendingCheckinToday.save({

                },
                function (response) {
                    vm.schedules = response.d;
                    vm.processing = false;
                    console.log(response.d);
                },
                function (error) {
                    console.log(error);
                });

        }


    }






})();
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [

            // Core
            'app.core',

            'cfp.hotkeys',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Quick Panel
            //'app.quick-panel',

            //AUTH
            'app.auth',

            // CRM
            'app.dashboard',


            //Customer
            'app.customer',

            //Marketing
            'app.marketingv2',

            //Professionals
            'app.professional',

            //Financeiro
            'app.finance',

            //Settings
            'app.settings',

            //subscription
            'app.subscription',

            //stock
            'app.stock',

            //Agenda
            'app.schedule',

            //Support
            'app.support',

            //Sales
            'app.sales',

            //Report
            'app.report',

            //Wizard
            'app.wizard'
        ]);
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');

        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);


    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, $window, $location, api)
    {
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function (e, toState)
        {
            $rootScope.loadingProgress = true;

        });

        $window.branch.init('key_live_jaEYqdGTnMs0swBXH3vwRmfpxEd9M37K', {},function(err, data) {
            console.log(err,data);
        });


        $window.fbAsyncInit = function() {

            FB.init({
                appId: '328671950923384',
                status: true,
                cookie: true,
                xfbml: true,
                version: 'v2.4'
            });




        };

        (function(d){
            // load the Facebook javascript SDK

            var js,
                id = 'facebook-jssdk',
                ref = d.getElementsByTagName('script')[0];

            if (d.getElementById(id)) {
                return;
            }

            js = d.createElement('script');
            js.id = id;
            js.async = true;
            js.src = "//connect.facebook.net/en_US/all.js";

            ref.parentNode.insertBefore(js, ref);

        }(document));



        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        //add google analytics
        //$window.ga('create', 'UA-84403071-3', 'auto');

        // track pageview on state change
        $rootScope.$on('$stateChangeSuccess', function (event) {
          //  $window.ga('send', 'pageview', $location.path());
        });

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });


    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/auth/signin');


        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            },
            contentWithNavigation  : {
                main      : 'app/core/layouts/content-with-navigation.html',
                toolbar   : 'app/toolbar/layouts/content-with-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/content-with-navigation/navigation.html'
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    }
                }
            }).state('appblank', {
                template: '<h1>My Contacts</h1>'
            });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController)
        .factory('subdomain', ['$location', function ($location) {
            var host = $location.host();
            if (host.indexOf('.') < 0){
                return null;
            }
            else
                return host.split('.')[0];
        }]);

    /** @ngInject */
    function IndexController(fuseTheming, $rootScope,$state,$scope, msNavigationService, $mdDialog,
                api, $timeout, $location,$window)
    {
        var vm = this;

        //versao do softeware
        $rootScope.version = 'Version 1.2.9';


        //cpmentei abaixo para passar sempre pelo login
        var token = null;

        if ($rootScope.securityToken == null){

            setTimeout(function(){

                if (($location.$$url == '/auth/signup') || ($location.$$url.indexOf('/auth/verifyAccount') > -1)  || ($location.$$url.indexOf('/auth/verifyEmail') > -1)  ){

                } else if ($location.$$url.indexOf('/report/sales/salesPerProfessionalM') > -1){

                } else if ($location.$$url.indexOf('/report/sales/salesSynthethicM') > -1){

                } else if ($location.$$url.indexOf('/report/sales/salesAnalyticsM') > -1){

                } else if ($location.$$url.indexOf('/report/sales/salesPerCategoryM') > -1){

                } else if ($location.$$url.indexOf('/report/finance/financeAnalyticalM') > -1){

                } else if ($location.$$url.indexOf('/report/finance/financeAnalyticalByPaymentM') > -1){

                } else if ($location.$$url.indexOf('/report/finance/financeAuditM') > -1){

                } else if ($location.$$url.indexOf('/report/finance/salesPerPaymentTypeM') > -1){

                } else if ($location.$$url.indexOf('/report/finance/creditdebitreportM') > -1){

                }  else if ($location.$$url.indexOf('/report/customer/customersWithCreditDebitM') > -1){

                }  else if ($location.$$url.indexOf('/report/customer/birthdayM') > -1){

                }  else if ($location.$$url.indexOf('/report/customer/top20M') > -1){

                }  else if ($location.$$url.indexOf('/report/customer/top50M') > -1){

                }  else if ($location.$$url.indexOf('/report/customer/top100M') > -1){

                }  else if ($location.$$url.indexOf('/report/customer/top200M') > -1){

                }  else if ($location.$$url.indexOf('/marketingv2/loyalty/mycredits') > -1){

                }  else if ($location.$$url.indexOf('/marketingv2/loyalty/buzz') > -1){

                }  else if ($location.$$url.indexOf('/marketingv2/loyalty/buzzRegister') > -1){

                }  else {
                    $state.go('app.auth.signin');
                }



            }, 10)

        }


        $rootScope.showHelp = function(topic){
            $mdDialog.show({
                controller: 'SupportController',
                templateUrl: 'app/main/support/videoHelp.html',
                parent: angular.element(document.body),
                targetEvent: null,
                multiple:true,
                clickOutsideToClose:true,
                locals:{
                    topic : topic
                },
                fullscreen: false
            })
                .then(function(answer) {


                }, function() {

                });
        }

        //bloquear botao de login
        function mobileAndTabletcheck() {
            var check = false;
            (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
            return check;
        };
        $rootScope.mobilePlatform = mobileAndTabletcheck();



        // Change theme
        fuseTheming.setActiveTheme("default");

        vm.themes = fuseTheming.themes;


        //ABRIR novo agendamento
        $rootScope.$on('openNewScheduleDialog', function(event, args) {
            $mdDialog.show({
                controller: 'NewScheduleController',
                controllerAs: 'vm',
                locals: {
                    professional: null,
                    customer: null,
                    whenTime: null,
                    whenDate: null,
                    id: null
                },
                templateUrl: 'app/main/schedule/newSchedule/newSchedule.html',
                clickOutsideToClose: false
            })
                .then(function (answer) {

                }, function () {
                    $rootScope.$emit('refreshByProfessionalSchedule', null);
                });
        });



        //////////// Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            $window.dataLayer.push({
                event: 'pageView',
                action: $location.path(),
            });


            if ($rootScope.securityToken != undefined){
                if ($state.current.name != 'app.auth.signin'){
                    api.generalConfiguration.save({
                        },
                        function(response) {
                            $rootScope.pdvConfiguration = response.d;
                            updateMenu();
                        });
                }


            }

            function updateMenu(){
                var userType = $rootScope.userType;
                msNavigationService.clearNavigation();

                var allowAccess = false;
                /*for(var j=0; j < $rootScope.subscriptions.length; j++){
                    for(var k=0; k < $rootScope.subscriptions[j].products.length; k++){
                        if ($rootScope.subscriptions[j].products[k] == 'WEB'){
                            allowAccess = true;
                            $rootScope.validUntil = $rootScope.subscriptions[j].until;
                        }
                    }
                }*/
                var dtUntil = 0;
                for(var j=0; j < $rootScope.subscriptions.length; j++){
                    for(var k=0; k < $rootScope.subscriptions[j].products.length; k++){
                        if ($rootScope.subscriptions[j].products[k] == 'WEB'){

                            if (new moment($rootScope.subscriptions[j].until).valueOf() > dtUntil){
                                dtUntil = new moment($rootScope.subscriptions[j].until).valueOf();
                            }

                        }
                    }
                }

                var m1 = new moment(dtUntil);

                if (m1.diff(new moment(), 'days') < 0) {
                    allowAccess = false;
                } else {
                    allowAccess = true;
                }

                    //console.log(allowAccess);

                if (allowAccess){

                    if ((userType == 'MASTER') || (userType == 'ADMIN')){
                        msNavigationService.saveItem('dashboard', {
                            title    : 'Painel de Controle',
                            icon     : 'icon-chart-arc',
                            state : 'app.dashboard',
                            weight   : 10
                        });



                        msNavigationService.saveItem('schedule', {
                            title    : 'Schedule',
                            icon     : 'icon-book-open',
                            translate: 'MENU.SCHEDULE',
                            weight   : 20,
                            state:'app.schedule.byprofessional'
                        });
                        /*msNavigationService.saveItem('schedule.byprofessional', {
                            title    : 'Schedule',
                            translate: 'MENU.SCHEDULE.BYPROFESSIONAL',
                            weight   : 21,
                            state:'app.schedule.byprofessional'
                        });*/
                        /* msNavigationService.saveItem('schedule.bycategory', {
                             title    : 'Schedule',
                             translate: 'MENU.SCHEDULE.BYCATEGORY',
                             weight   : 22,
                             state:'app.schedule.bycategory'
                         });*/
                        /* msNavigationService.saveItem('schedule.schedules', {
                             title    : 'Schedule',
                             translate: 'MENU.SCHEDULE.PENDINGSCHEDULES',
                             weight   : 23,
                             state:'app.schedule.pendingschedules'
                         });*/
                        msNavigationService.saveItem('customer', {
                            title    : 'Customer',
                            translate: 'MENU.CUSTOMER',
                            icon : 'icon-account-multiple',
                            state : 'app.customer.list',
                            weight   : 30
                        });
                        msNavigationService.saveItem('sales', {
                            title    : 'Sales',
                            translate: 'MENU.SALES',
                            icon : 'icon-cash',
                            weight   : 40
                        });
                        msNavigationService.saveItem('sales.sales', {
                            title    : 'Sales',
                            translate: 'MENU.SALES.OPEN',
                            state:'app.sales.open',
                            weight   : 41
                        });
                        msNavigationService.saveItem('sales.closed', {
                            title    : 'Sales',
                            translate: 'MENU.SALES.CLOSED',
                            state:'app.sales.closed',
                            weight   : 42
                        });
                        msNavigationService.saveItem('sales.servicePack', {
                            title    : 'ServicePack',
                            translate: 'MENU.SALES.SERVICE_PACK',
                            state:'app.sales.servicePack.list',
                            weight   : 43
                        });
                        ////FINANCE
                        msNavigationService.saveItem('finance', {
                            title    : 'Finance',
                            icon     : 'icon-currency-usd',
                            translate: 'MENU.FINANCE',
                            class      : 'navigation-dashboards project-dashboard',
                            weight   : 50
                        });

                        msNavigationService.saveItem('finance.openCashier', {
                            title    : 'Caixa',
                            weight   : 51
                        });
                        msNavigationService.saveItem('finance.openCashier.openCashier', {
                            title    : 'Caixas',
                            state:'app.finance.opencashier',
                            weight   : 1
                        });
                        msNavigationService.saveItem('finance.openCashier.cashiers', {
                            title    : 'Histórico de Caixa',
                            state:'app.finance.cashier',
                            weight   : 2
                        });
                        msNavigationService.saveItem('finance.openCashier.dailyReport', {
                            title    : 'Checklist Caixa',
                            state:'app.finance.report',
                            weight   : 3
                        });

                        msNavigationService.saveItem('finance.extrato', {
                            title    : 'Extrato Bancário',
                            weight   : 52,
                            state:'app.finance.extrato',
                        });

                        msNavigationService.saveItem('finance.profissionais', {
                            title    : 'Conta corrente profissional',
                            weight   : 53,
                            state:'app.finance.professional',
                        });

                            msNavigationService.saveItem('finance.tef', {
                                title    : 'Transações WoWee Pay',
                                weight   : 53,
                                state:'app.finance.tef',
                            });

                       /* msNavigationService.saveItem('finance.createRPS', {
                            title    : 'RPS Profissionais',
                            weight   : 54,
                            state:'app.finance.createRPS',
                        });
*/



                        msNavigationService.saveItem('marketingv2', {
                            title    : 'Vender Mais',
                            icon     : 'icon-bullhorn',
                            translate: 'MENU.MARKETING',
                            class      : 'navigation-dashboards project-dashboard',
                            weight   : 300
                        });
                        /*msNavigationService.saveItem('marketingv2.spot', {
                            title    : 'Envio de Mensagens',
                            state : 'app.marketingv2.spot',
                            weight   : 301
                        });
                        msNavigationService.saveItem('marketingv2.wom', {
                            title    : 'Boca a Boca',
                            state : 'app.marketingv2.wom',
                            weight   : 302
                        });*/
                        msNavigationService.saveItem('marketingv2.reminder', {
                            title    : 'Reminder',
                            translate: 'MENU.MARKETING.CONTINUOUS.REMINDER',
                            state : 'app.marketingv2.reminder',
                            weight   : 303
                        });
                        msNavigationService.saveItem('marketingv2.servicePack', {
                            title    : 'Configurar pacotes promocionais',
                            state : 'app.settings.service.servicePack.list',
                            weight   : 304
                        });
                        msNavigationService.saveItem('marketingv2.partnership', {
                            title    : 'Partnership',
                            translate: 'MENU.MARKETING.PARTNERSHIP',
                            state : 'app.marketingv2.partnership.list',
                            weight   : 304
                        });
                        msNavigationService.saveItem('marketingv2.campaign', {
                            title    : 'Campaigns',
                            translate: 'MENU.MARKETING.CAMPAIGN',
                            state : 'app.marketingv2.campaign.list',
                            weight   : 304
                        });

                        //////

                        msNavigationService.saveItem('fidelizarclientes', {
                            title    : 'Encante seus Clientes',
                            icon     : 'icon-star',
                            class      : 'navigation-dashboards project-dashboard',
                            weight   : 350
                        });

                        /*msNavigationService.saveItem('fidelizarclientes.checkup', {
                            title    : 'Checkup',
                            state : 'app.marketingv2.checkup.encante',
                            weight   : 1
                        });*/

                        msNavigationService.saveItem('fidelizarclientes.loyaty', {
                            title    : 'Fidelidade',
                            state : 'app.marketingv2.loyalty2.explore',
                            weight   : 1
                        });

                        msNavigationService.saveItem('fidelizarclientes.survey', {
                            title    : 'Controle de Qualidade',
                            state : 'app.marketingv2.survey.explore',
                            weight   : 2
                        });

                        msNavigationService.saveItem('fidelizarclientes.birthday', {
                            title    : 'Promoção de aniversário',
                            state : 'app.marketingv2.birthday',
                            weight   : 3
                        });

                        msNavigationService.saveItem('fidelizarclientes.welcome', {
                            title    : 'Reschedule',
                            translate: 'MENU.MARKETING.CONTINUOUS.WELCOME',
                            state : 'app.marketingv2.welcome',
                            weight   : 4
                        });








                        ///Reports
                        msNavigationService.saveItem('report', {
                            title    : 'Reports',
                            icon     : 'icon-chart-line',
                            translate: 'MENU.REPORTS',
                            weight   : 400
                        });
                        msNavigationService.saveItem('report.sales', {
                            title    : 'Sales',
                            translate: 'MENU.REPORTS.SALES',
                            weight   : 400
                        });
                        msNavigationService.saveItem('report.sales.salesAnalytics', {
                            title    : 'Vendas',
                            translate: 'MENU.REPORTS.SALESANALYTICS',
                            state : 'app.report.sales.salesAnalytics',
                            weight   : 401
                        });
                        msNavigationService.saveItem('report.sales.salesSintetico', {
                            title    : 'Vendas Sintetico',
                            translate: 'MENU.REPORTS.SALESSYNTHETHIC',
                            state : 'app.report.sales.salesSynthethic',
                            weight   : 402
                        });
                        msNavigationService.saveItem('report.sales.salesPerProfessional', {
                            title    : 'Comission',
                            translate: 'MENU.REPORTS.COMISSION',
                            state : 'app.report.sales.salesPerProfessional',
                            weight   : 402
                        });
                        msNavigationService.saveItem('report.sales.salesPerCategory', {
                            title    : 'Category',
                            translate: 'MENU.REPORTS.PERCATEGORY',
                            state : 'app.report.sales.salesPerCategory',
                            weight   : 402
                        });
                        msNavigationService.saveItem('report.finance', {
                            title    : 'Financeiro',
                            translate: 'MENU.REPORTS.FINANCE',
                            weight   : 410
                        });
                        msNavigationService.saveItem('report.finance.audit', {
                            title    : 'Finance Audit',
                            translate: 'MENU.REPORTS.FINANCEAUDIT',
                            state : 'app.report.finance.audit',
                            weight   : 411
                        });
                        msNavigationService.saveItem('report.finance.salesAnalyticsGroupByPaymentType', {
                            title    : 'Payment Type',
                            translate: 'MENU.REPORTS.SALESBYPAYMENT',
                            state : 'app.report.finance.salesPerPaymentType',
                            weight   : 412
                        });
                        /*msNavigationService.saveItem('report.finance.creditDebitPerUser', {
                            title    : 'Payment Type',
                            translate: 'MENU.REPORTS.CREDITDEBIT',
                            state : 'app.report.finance.creditDebitSales',
                            weight   : 413
                        });*/
                        msNavigationService.saveItem('report.finance.financeAnalytical', {
                            title    : 'Finance Analyitical',
                            translate: 'MENU.REPORTS.FINANCEANALYTICAL',
                            state : 'app.report.finance.financeAnalytical',
                            weight   : 413
                        });
                        msNavigationService.saveItem('report.finance.financeAnalyticalByPayment', {
                            title    : 'Finance Analyitical',
                            translate: 'MENU.REPORTS.FINANCEANALYTICAL_BYPAYMENT',
                            state : 'app.report.finance.financeAnalyticalByPayment',
                            weight   : 414
                        });
                        msNavigationService.saveItem('report.customers', {
                            title    : 'Customers',
                            translate: 'MENU.REPORTS.CUSTOMERS',
                            weight   : 420
                        });
                        msNavigationService.saveItem('report.customers.creditdebit', {
                            title    : 'Customers with credit/debit',
                            state : 'app.report.customer.customersWithCreditDebit',
                            translate: 'MENU.REPORTS.CUSTOMERSWITHCREDITDEBIT',
                            weight   : 421
                        });
                        msNavigationService.saveItem('report.customers.birthday', {
                            title    : 'Birthday',
                            state : 'app.report.customer.birthday',
                            translate: 'MENU.REPORTS.CUSTOMERBIRTHDAY',
                            weight   : 422
                        });
                        msNavigationService.saveItem('report.customers.top20', {
                            title    : 'Top20',
                            state : 'app.report.customer.top20',
                            translate: 'MENU.REPORTS.CUSTOMERTOP20',
                            weight   : 423
                        });
                        msNavigationService.saveItem('report.customers.top50', {
                            title    : 'Top50',
                            state : 'app.report.customer.top50',
                            translate: 'MENU.REPORTS.CUSTOMERTOP50',
                            weight   : 424
                        });
                        msNavigationService.saveItem('report.customers.top100', {
                            title    : 'Top100',
                            state : 'app.report.customer.top100',
                            translate: 'MENU.REPORTS.CUSTOMERTOP100',
                            weight   : 425
                        });
                        msNavigationService.saveItem('report.customers.top200', {
                            title    : 'Top200',
                            state : 'app.report.customer.top200',
                            translate: 'MENU.REPORTS.CUSTOMERTOP200',
                            weight   : 426
                        });


                        msNavigationService.saveItem('report.marketing', {
                            title    : 'Marketing',
                            translate: 'MENU.REPORTS.MARKETING',
                            weight   : 430
                        });
                        msNavigationService.saveItem('report.marketing.usedGiftCards', {
                            title    : 'Used GiftCards',
                            state : 'app.report.marketing.usedGiftCards',
                            translate: 'MENU.REPORTS.USEDGIFTCARDS',
                            weight   : 431
                        });
                        msNavigationService.saveItem('report.marketing.messages', {
                            title    : 'Mensagens',
                            state : 'app.report.marketing.messages',
                            translate: 'MENU.REPORTS.MESSAGES',
                            weight   : 432
                        });
                        msNavigationService.saveItem('report.marketing.survey', {
                            title    : 'Survey',
                            state : 'app.report.marketing.survey',
                            translate: 'MENU.REPORTS.SURVEY',
                            weight   : 433
                        });

                        //precisa d emais testes
                        /*
                        msNavigationService.saveItem('report.marketing.cancel', {
                            title    : 'Cancel',
                            state : 'app.report.marketing.canceled',
                            translate: 'MENU.REPORTS.CANCEL',
                            weight   : 434
                        });*/

                        msNavigationService.saveItem('report.other', {
                            title    : 'Other',
                            translate: 'MENU.REPORTS.OTHERS',
                            weight   : 440
                        });
                        msNavigationService.saveItem('report.other.priceTable', {
                            title    : 'PriceTable',
                            translate: 'MENU.REPORTS.PRICE_TABLE',
                            state : 'app.report.other.priceTableList',
                            weight   : 441
                        });
                        msNavigationService.saveItem('report.other.stocklist', {
                            title    : 'Listagem de estoque',
                            weight   : 1,
                            state : 'app.stock.report'
                        });

                        msNavigationService.saveItem('report.woweepay', {
                            title    : 'Wowee Pay',
                            translate: 'MENU.REPORTS.WOWEE_PAY',
                            weight   : 450
                        });


                        msNavigationService.saveItem('report.woweepay.extrato', {
                            title    : 'Wowee Pay - Extrato',
                            translate: 'MENU.REPORTS.WOWEE_PAY_EXTRATO',
                            state : 'app.report.woweepay.extrato',
                            weight   : 451
                        });

                        msNavigationService.saveItem('report.woweepay.vendas', {
                            title    : 'Wowee Pay - Vendas',
                            translate: 'MENU.REPORTS.WOWEE_PAY_VENDAS',
                            state : 'app.report.woweepay.vendas',
                            weight   : 452
                        });


                        msNavigationService.saveItem('report.woweepay.futuro', {
                            title    : 'Wowee Pay - Laçamentos Futuros',
                            translate: 'MENU.REPORTS.WOWEE_PAY_FUTUROS',
                            state : 'app.report.woweepay.lancamentosFuturos',
                            weight   : 454
                        });
                        msNavigationService.saveItem('report.woweepay.pagamentos', {
                            title    : 'Wowee Pay - Pagamentos',
                            translate: 'MENU.REPORTS.WOWEE_PAY_PAGAMENTO',
                            state : 'app.report.woweepay.pagamentos',
                            weight   : 453
                        });




                        // Navigation settings
                        msNavigationService.saveItem('settings', {
                            title    : 'Settings',
                            icon     : 'icon-cog',
                            translate: 'MENU.SETTINGS',
                            weight   : 450
                        });
                        msNavigationService.saveItem('settings.account', {
                            title    : 'Account',
                            icon     : 'icon-domain',
                            translate: 'MENU.SETTINGS.ACCOUNT',
                            weight   : 10
                        });
                        msNavigationService.saveItem('settings.account.businesshours', {
                            title    : 'Business Info',
                            icon     : 'icon-timetable',
                            translate: 'MENU.SETTINGS.ACCOUNT.BUSINESSINFO.BUSINESSHOURS',
                            state    : 'app.settings.account.businessinfo.businesshours',
                            weight   : 11
                        });
                        msNavigationService.saveItem('settings.finance', {
                            title    : 'Finance',
                            icon     : 'icon-cash',
                            translate: 'MENU.SETTINGS.FINANCE',
                            weight   : 12
                        });
                        msNavigationService.saveItem('settings.finance.bankaccount', {
                            title    : 'Bank Account',
                            state    : 'app.settings.finance.bankaccount.list',
                            translate: 'MENU.SETTINGS.FINANCE.BANKACCOUNT',
                            weight   : 1
                        });
                        msNavigationService.saveItem('settings.finance.card', {
                            title    : 'Cartão Crédito/Débito',
                            state    : 'app.settings.finance.card.list',
                            weight   : 1
                        });
                        msNavigationService.saveItem('settings.finance.category', {
                            title    : 'Categorias',
                            state    : 'app.settings.finance.category.list',
                            translate: 'MENU.SETTINGS.FINANCE.CATEGORY',
                            weight   : 2
                        });
                        msNavigationService.saveItem('settings.finance.partner', {
                            title    : 'Sócios',
                            state    : 'app.settings.finance.partner.list',
                            translate: 'MENU.SETTINGS.FINANCE.PARTNER',
                            weight   : 3
                        });
                        msNavigationService.saveItem('settings.finance.supplier', {
                            title    : 'Fornecedores',
                            state    : 'app.settings.finance.supplier.list',
                            translate: 'MENU.SETTINGS.FINANCE.SUPPLIER',
                            weight   : 4
                        });

                        msNavigationService.saveItem('settings.service', {
                            title    : 'Service',
                            icon     : 'icon-content-cut',
                            translate: 'MENU.SETTINGS.SERVICE',
                            weight   : 20
                        });
                        msNavigationService.saveItem('settings.service.cateogry', {
                            title    : 'Category',
                            translate: 'MENU.SETTINGS.SERVICE.CATEGORY',
                            state : 'app.settings.service.category.list',
                            weight   : 21
                        });
                        msNavigationService.saveItem('settings.service.service', {
                            title    : 'Service',
                            translate: 'MENU.SETTINGS.SERVICE.SERVICE',
                            state : 'app.settings.service.service.list',
                            weight   : 23
                        });
                        msNavigationService.saveItem('settings.service.priceTable', {
                            title    : 'Price Table',
                            translate: 'MENU.SETTINGS.SERVICE.PRICE_TABLE',
                            state : 'app.settings.service.priceTable.list',
                            weight   : 24
                        });

                        msNavigationService.saveItem('settings.product', {
                            title    : 'Product',
                            translate: 'MENU.SETTINGS.PRODUCT',
                            icon     : 'icon-tennis',
                            weight   : 30
                        });
                        msNavigationService.saveItem('settings.product.category', {
                            title    : 'Category',
                            translate: 'MENU.SETTINGS.PRODUCT.CATEGORY',
                            weight   : 31,
                            state    : 'app.settings.product.category.list'
                        });
                        msNavigationService.saveItem('settings.product.product', {
                            title    : 'Product',
                            translate: 'MENU.SETTINGS.PRODUCT.PRODUCT',
                            weight   : 32,
                            state    : 'app.settings.product.product.list'
                        });
                        msNavigationService.saveItem('settings.product.stock', {
                            title    : 'Estoque',
                            icon     : 'icon-cart',
                            weight   : 399
                        });
                        msNavigationService.saveItem('settings.product.stock.list', {
                            title    : 'Listagem de estoque',
                            weight   : 1,
                            state : 'app.stock.list'
                        });
                        msNavigationService.saveItem('settings.product.stock.entry', {
                            title    : 'Entrada de estoque',
                            weight   : 2,
                            state : 'app.stock.entry'
                        });
                        msNavigationService.saveItem('settings.professional', {
                            title    : 'Professional',
                            translate: 'MENU.SETTINGS.SERVICE.PROFESSIONAL',
                            state : 'app.professional.list',
                            weight   : 40
                        });
                        msNavigationService.saveItem('settings.general', {
                            title    : 'General',
                            translate: 'MENU.SETTINGS.GENERAL',
                            weight   : 500,
                            state    : 'app.settings.general'
                        });
                        /*msNavigationService.saveItem('assinatura', {
                            title    : 'Assinatura',
                            icon     : 'icon-shop-bag',
                            weight   : 450
                        });
                        msNavigationService.saveItem('assinatura.planos', {
                            title    : 'Planos',
                            state : 'app.subscription.price-table',
                            icon     : 'icon-shop-bag',
                            weight   : 451
                        });
                        msNavigationService.saveItem('assinatura.extras', {
                            title    : 'Extras (SMS & Whatsapp)',
                            state : 'app.subscription.extras',
                            icon     : 'icon-shop-bag',
                            weight   : 452
                        });*/

                    } else if (userType == 'RECEPCIONIST'){
                        msNavigationService.saveItem('schedule', {
                            title    : 'Schedule',
                            icon     : 'icon-book-open',
                            translate: 'MENU.SCHEDULE',
                            state:'app.schedule.byprofessional',
                            weight   : 10
                        });
                        msNavigationService.saveItem('customer', {
                            title    : 'Customer',
                            translate: 'MENU.CUSTOMER',
                            icon : 'icon-account-multiple',
                            state : 'app.customer.list',
                            weight   : 20
                        });
                        msNavigationService.saveItem('sales', {
                            title    : 'Sales',
                            translate: 'MENU.SALES',
                            icon : 'icon-cash',
                            weight   : 40
                        });
                        msNavigationService.saveItem('sales.sales', {
                            title    : 'Sales',
                            translate: 'MENU.SALES.OPEN',
                            state:'app.sales.open',
                            weight   : 41
                        });
                        if ($rootScope.pdvConfiguration.allowRecepcionistSeeComandaFechada){
                            msNavigationService.saveItem('sales.closed', {
                                title    : 'Sales',
                                translate: 'MENU.SALES.CLOSED',
                                state:'app.sales.closed',
                                weight   : 42
                            });
                        };
                        msNavigationService.saveItem('sales.servicePack', {
                            title    : 'ServicePack',
                            translate: 'MENU.SALES.SERVICE_PACK',
                            state:'app.sales.servicePack.list',
                            weight   : 43
                        });
                        msNavigationService.saveItem('openCashier', {
                            title    : 'Caixa',
                            icon     : 'icon-currency-usd',

                            state:'app.finance.opencashier',
                            weight   : 51
                        });
                        msNavigationService.saveItem('loyaty', {
                            title    : 'Fidelidade',
                            icon     : 'icon-heart',
                            state : 'app.marketingv2.loyalty2.dashboard',
                            weight   : 0
                        });
                    } else if (userType == 'PROFESSIONAL'){
                        msNavigationService.saveItem('schedule', {
                            title    : 'Schedule',
                            icon     : 'icon-book-open',
                            translate: 'MENU.SCHEDULE',
                            state:'app.schedule.byprofessional',
                            weight   : 10
                        });
                    }
                } else {
                    msNavigationService.saveItem('assinatura', {
                        title    : 'Assinatura',
                        icon     : 'icon-shop-bag',
                        weight   : 450
                    });
                    msNavigationService.saveItem('assinatura.planos', {
                        title    : 'Planos',
                        state : 'app.subscription.price-table',
                        icon     : 'icon-shop-bag',
                        weight   : 451
                    });

                    $state.go('app.subscription.price-table');
                }
            }



        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($translateProvider,$translatePartialLoaderProvider, msApiProvider,
                    $mdThemingProvider, $mdDateLocaleProvider ) {
        // Put your common app configurations here
        // Set base address
        msApiProvider.setBaseUrl(backendServer);

        console.log(isElectron);

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        // Translation
        $translatePartialLoaderProvider.addPart('app');

        $translateProvider.preferredLanguage('pt');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        //Themes
        $mdThemingProvider.theme('dark-grey').backgroundPalette('grey').dark();
        $mdThemingProvider.theme('dark-orange').backgroundPalette('orange').dark();
        $mdThemingProvider.theme('dark-green').backgroundPalette('green').dark();
        $mdThemingProvider.theme('dark-purple').backgroundPalette('deep-purple').dark();
        $mdThemingProvider.theme('dark-blue').backgroundPalette('blue').dark();
        $mdThemingProvider.theme('dark-red').backgroundPalette('red').dark();

        $mdDateLocaleProvider.formatDate = function (date) {
            return moment(date).format('DD-MM-YYYY');
        };


    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource, $rootScope) {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        //ASSIANTURA
        api.newSubscription = $resource(backendServer + '/admin/newSubscription', {}, {
            save: {
                method: 'POST',
                params: {}
            }
        });

        ///AUTH
        api.fbSignin = $resource(backendServer + '/pdv/fbSignIn2', {}, {
            save: {
                method: 'POST',
                params: {}
            }
        });

        api.signin = $resource(backendServer + '/user/signInUser', {}, {
            save: {
                method: 'POST',
                params: {}
            }
        });

        api.signin2 = $resource(backendServer + '/user/signInUser2', {}, {
            save: {
                method: 'POST',
                params: {}
            }
        });

        api.professionalSignIn = $resource(backendServer + '/professional/signIn2', {}, {
            save: {
                method: 'POST',
                params: {}
            }
        });

        api.signin3 = $resource(backendServer + '/user/signInUser3', {}, {
            save: {
                method: 'POST',
                params: {}
            }
        });


        api.signup = $resource(backendServer + '/emails/sendSignupEmail', {}, {
            save: {
                method: 'POST',
                params: {}
            }
        });

        api.signup2 = $resource(backendServer + '/pdv/signUp2', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken,
                    platform:'WEB'
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.signup2 = $resource(backendServer + '/pdv/signUp2', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken,
                        platform:'WEB'
                    }
                }
            });
        });
        api.editUserPDVRelation = $resource(backendServer + '/user/editUserPDVRelation', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.editUserPDVRelation = $resource(backendServer + '/user/editUserPDVRelation', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });

        api.removeUserPDVRelation = $resource(backendServer + '/user/removeUserPDVRelation', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.removeUserPDVRelation = $resource(backendServer + '/user/removeUserPDVRelation', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });


        api.userByLogin = $resource(backendServer + '/user/getUserByLogin', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.userByLogin = $resource(backendServer + '/user/getUserByLogin', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });

        api.quota = $resource(backendServer + '/pdv/getQuota', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.quota = $resource(backendServer + '/pdv/getQuota', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });

        api.changeMyInfo = $resource(backendServer + '/professional/changeMyInfo', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.changeMyInfo = $resource(backendServer + '/professional/changeMyInfo', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });

        api.getRelatedPDVS = $resource(backendServer + '/professional/getRelatedPDVS', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.getRelatedPDVS = $resource(backendServer + '/professional/getRelatedPDVS', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });

        api.setRelatedPDVAsDefault = $resource(backendServer + '/professional/setDefaultPDV', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.setRelatedPDVAsDefault = $resource(backendServer + '/professional/setDefaultPDV', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });

        api.removeRelatedPDV = $resource(backendServer + '/professional/removeRelatedPDV', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.removeRelatedPDV = $resource(backendServer + '/professional/removeRelatedPDV', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });

        api.allSimpleProfessionals = $resource(backendServer + '/professional/getAllProfessionalsSimple', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.allSimpleProfessionals = $resource(backendServer + '/professional/getAllProfessionalsSimple', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });



        api.changePassword = $resource(backendServer + '/professional/changePassword', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.changePassword = $resource(backendServer + '/professional/changePassword', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });

        api.updateEmailUser = $resource(backendServer + '/user/updateEmailUser', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.updateEmailUser = $resource(backendServer + '/user/updateEmailUser', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });

        api.forgotPassword = $resource(backendServer + '/user/resetPassword', {}, {
            save: {
                method: 'POST',
                params: {}
            }
        });

        $rootScope.$on('changeToken', function () {
            api.checkAccessCode = $resource(backendServer + '/user/checkAccessCode', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });

        })

        api.checkAccessCode = $resource(backendServer + '/user/checkAccessCode', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.checkPassword = $resource(backendServer + '/user/checkPassword', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });

        })

        api.checkPassword = $resource(backendServer + '/user/checkPassword', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });



        ///SCHEDULE

        $rootScope.$on('changeToken', function () {
            api.scheduleByPDV = $resource(backendServer + '/schedule/getServiceRequestsByPDV2', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });

        })

        api.scheduleByPDV = $resource(backendServer + '/schedule/getServiceRequestsByPDV2', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

       /* $rootScope.$on('changeToken', function () {
            api.scheduleByPDVL = $resource('https://ci20sufbe2.execute-api.sa-east-1.amazonaws.com/default/getServiceRequestByPDVLambda', {}, {
                save: {
                    method: 'POST',
                    params: {

                    }
                }
            });

        })

        api.scheduleByPDVL = $resource('https://ci20sufbe2.execute-api.sa-east-1.amazonaws.com/default/getServiceRequestByPDVLambda', {}, {
            save: {
                method: 'POST',
                params: {

                }
            }
        });*/

        $rootScope.$on('changeToken', function () {
            api.pdvStats = $resource(backendServer + '/pdv/getPDVStats', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });

        })

        api.pdvStats = $resource(backendServer + '/pdv/getPDVStats', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.pdvLocations = $resource(backendServer + '/pdv/getPDVLocations', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });

        })

        api.pdvLocations = $resource(backendServer + '/pdv/getPDVLocations', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });


        $rootScope.$on('changeToken', function () {
            api.saveSchedule = $resource(backendServer + '/schedule/newServiceRequest', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.saveSchedule = $resource(backendServer + '/schedule/newServiceRequest', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });



        $rootScope.$on('changeToken', function () {
            api.scheduleOptions = $resource(backendServer + '/scheduler/getServiceRequestsOptions', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });

        api.scheduleOptions = $resource(backendServer + '/scheduler/getServiceRequestsOptions', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.requestsGroupByProfessional = $resource(backendServer + '/scheduler/getServiceRequestsByPDVGroupByProfessional', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.requestsGroupByProfessional = $resource(backendServer + '/scheduler/getServiceRequestsByPDVGroupByProfessional', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.requestsCount = $resource(backendServer + '/scheduler/getServiceRequestsByPDVCount', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.requestsCount = $resource(backendServer + '/scheduler/getServiceRequestsByPDVCount', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.requestsNotFilled = $resource(backendServer + '/scheduler/getServiceRequestsByPDVNotFilled', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.requestsNotFilled = $resource(backendServer + '/scheduler/getServiceRequestsByPDVNotFilled', {}, {
            save: {
                method: 'POST',
                params: {
                    token : $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.requestsGroupByChannel = $resource(backendServer + '/scheduler/getServiceRequestsByPDVGroupByChannel', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.requestsGroupByChannel = $resource(backendServer + '/scheduler/getServiceRequestsByPDVGroupByChannel', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.requestNoShowReport = $resource(backendServer + '/scheduler/getServiceRequestsNoShow', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.requestNoShowReport = $resource(backendServer + '/scheduler/getServiceRequestsNoShow', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.requestCanceledReport = $resource(backendServer + '/scheduler/getServiceRequestsCanceled', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.requestCanceledReport = $resource(backendServer + '/scheduler/getServiceRequestsCanceled', {}, {
            save: {
                method: 'POST',
                params: {
                    token : $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.requestsGroupByDay = $resource(backendServer + '/scheduler/getServiceRequestsByPDVGroupByDay', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.requestsGroupByDay = $resource(backendServer + '/scheduler/getServiceRequestsByPDVGroupByDay', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });


        $rootScope.$on('changeToken', function () {
            api.requestNoShow = $resource(backendServer + '/schedule/noshowRequest', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.requestNoShow = $resource(backendServer + '/schedule/noshowRequest', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.requestUndoNoShow = $resource(backendServer + '/schedule/undoNoshowRequest', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.requestUndoNoShow = $resource(backendServer + '/schedule/undoNoshowRequest', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });



        $rootScope.$on('changeToken', function () {
            api.requestCancel = $resource(backendServer + '/schedule/cancelRequest', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.requestCancel = $resource(backendServer + '/schedule/cancelRequest', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });


        $rootScope.$on('changeToken', function () {
            api.getPendingCheckinToday = $resource(backendServer + '/schedule/getServiceRequestsPendingCheckinToday', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.getPendingCheckinToday = $resource(backendServer + '/schedule/getServiceRequestsPendingCheckinToday', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });


        $rootScope.$on('changeToken', function () {
            api.requestCheckin = $resource(backendServer + '/schedule/checkinRequest', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.requestCheckin = $resource(backendServer + '/schedule/checkinRequest', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });


        $rootScope.$on('changeToken', function () {
            api.requestCancelCheckin = $resource(backendServer + '/schedule/cancelCheckinRequest', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.requestCancelCheckin = $resource(backendServer + '/schedule/cancelCheckinRequest', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });



        $rootScope.$on('changeToken', function () {
            api.scheduleByCategory = $resource(backendServer + '/schedule/getScheduleByServiceCategory', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.scheduleByCategory = $resource(backendServer + '/schedule/getScheduleByServiceCategory', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });


        $rootScope.$on('changeToken', function () {
            api.serviceRequest = $resource(backendServer + '/schedule/getServiceRequest', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.serviceRequest = $resource(backendServer + '/schedule/getServiceRequest', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.serviceRequestsByCustomer = $resource(backendServer + '/schedule/getServiceRequestsByCustomer', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.serviceRequestsByCustomer = $resource(backendServer + '/schedule/getServiceRequestsByCustomer', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.removeSchedule = $resource(backendServer + '/schedule/removeRequest', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.removeSchedule = $resource(backendServer + '/schedule/removeRequest', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });



        $rootScope.$on('changeToken', function () {
            api.updateSchedule = $resource(backendServer + '/schedule/updateServiceRequest', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.updateSchedule = $resource(backendServer + '/schedule/updateServiceRequest', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });


        $rootScope.$on('changeToken', function () {
            api.pendingServiceRequest = $resource(backendServer + '/scheduler/getPendingServiceRequests', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.pendingServiceRequest = $resource(backendServer + '/scheduler/getPendingServiceRequests', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });



        ///CUSTOMER

        $rootScope.$on('changeToken', function () {
            api.getCustomerLoyaltyPoints = $resource(backendServer + '/customer/getCustomerLoyaltyPoints', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.getCustomerLoyaltyPoints = $resource(backendServer + '/customer/getCustomerLoyaltyPoints', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.getCustomerLoyaltyTransactions = $resource(backendServer + '/marketing/loyalty/getCustomerLoyaltyTransactions', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.getCustomerLoyaltyTransactions = $resource(backendServer + '/marketing/loyalty/getCustomerLoyaltyTransactions', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.creditCustomerLoyalty = $resource(backendServer + '/marketing/loyalty/creditCustomerLoyalty', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.creditCustomerLoyalty = $resource(backendServer + '/marketing/loyalty/creditCustomerLoyalty', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.resetEntireLoyalty = $resource(backendServer + '/marketing/loyalty/resetEntireLoyalty', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.resetEntireLoyalty = $resource(backendServer + '/marketing/loyalty/resetEntireLoyalty', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.resetCustomerLoyalty = $resource(backendServer + '/marketing/loyalty/resetCustomerLoyalty', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.resetCustomerLoyalty = $resource(backendServer + '/marketing/loyalty/resetCustomerLoyalty', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.sendBalanceToCustomer = $resource(backendServer + '/marketing/loyalty/sendBalanceToCustomer', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.sendBalanceToCustomer = $resource(backendServer + '/marketing/loyalty/sendBalanceToCustomer', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.resetTransaction = $resource(backendServer + '/marketing/loyalty/resetTransaction', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.resetTransaction = $resource(backendServer + '/marketing/loyalty/resetTransaction', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });


        $rootScope.$on('changeToken', function () {
            api.getCustomerTransactions = $resource(backendServer + '/customer/getCustomerTransactions', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.getCustomerTransactions = $resource(backendServer + '/customer/getCustomerTransactions', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.lockSale = $resource(backendServer + '/sale/lockSale', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.lockSale = $resource(backendServer + '/sale/lockSale', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.unlockSale = $resource(backendServer + '/sale/unlockSale', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.unlockSale = $resource(backendServer + '/sale/unlockSale', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.getCustomerInventory = $resource(backendServer + '/customer/getCustomerInventory', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.getCustomerInventory = $resource(backendServer + '/customer/getCustomerInventory', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.saveSurvey = $resource(backendServer + '/pdv/saveSurvey', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.saveSurvey = $resource(backendServer + '/pdv/saveSurvey', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });



        $rootScope.$on('changeToken', function () {
            api.removeInventoryItem = $resource(backendServer + '/customer/removeInventoryItem', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.removeInventoryItem = $resource(backendServer + '/customer/removeInventoryItem', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

         $rootScope.$on('changeToken', function () {
            api.customersServiceInventory = $resource(backendServer + '/customer/getCustomerInventoryForService', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.customersServiceInventory = $resource(backendServer + '/customer/getCustomerInventoryForService', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.customersWithCreditDebit = $resource(backendServer + '/customer/getCustomersWithCreditDebit', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.customersWithCreditDebit = $resource(backendServer + '/customer/getCustomersWithCreditDebit', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.creditCustomer = $resource(backendServer + '/customer/creditCustomer', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.creditCustomer = $resource(backendServer + '/customer/creditCustomer', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.customers = $resource(backendServer + '/customer/getCustomers', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.customers = $resource(backendServer + '/customer/getCustomers', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.registerLoyaltyPoints = $resource(backendServer + '/customer/registerLoyaltyPoints', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.registerLoyaltyPoints = $resource(backendServer + '/customer/registerLoyaltyPoints', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.sellServicePack = $resource(backendServer + '/service/servicePack/sellServicePack', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.sellServicePack = $resource(backendServer + '/service/servicePack/sellServicePack', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.getServicePackSales = $resource(backendServer + '/service/servicePack/getServicePackSales', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.getServicePackSales = $resource(backendServer + '/service/servicePack/getServicePackSales', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.customerHistory = $resource(backendServer + '/sale/getSalesByCustomer', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.customerHistory = $resource(backendServer + '/sale/getSalesByCustomer', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.customersSearch = $resource(backendServer + '/customer/getCustomersByName', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.customersSearch = $resource(backendServer + '/customer/getCustomersByName', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.customer = $resource(backendServer + '/customer/getCustomer', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.customer = $resource(backendServer + '/customer/getCustomer', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.saveCustomer = $resource(backendServer + '/customer/saveCustomer', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.saveCustomer = $resource(backendServer + '/customer/saveCustomer', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.removeCustomer = $resource(backendServer + '/customer/removeCustomer', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.removeCustomer = $resource(backendServer + '/customer/removeCustomer', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.verifyEmail = $resource(backendServer + '/pdv/verifyEmail', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.verifyEmail = $resource(backendServer + '/pdv/verifyEmail', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });


        ///SETTINGS
        ///SETTINGS >> GENERAL
        $rootScope.$on('changeToken', function () {
            api.generalConfiguration = $resource(backendServer + '/pdv/getGeneralConfiguration', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.generalConfiguration = $resource(backendServer + '/pdv/getGeneralConfiguration', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.saveGeneralConfiguration = $resource(backendServer + '/pdv/saveGeneralConfiguration', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.saveGeneralConfiguration = $resource(backendServer + '/pdv/saveGeneralConfiguration', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        ///SETTINGS >> ACCOUNT >> BUSINESSHOURS
        $rootScope.$on('changeToken', function () {
            api.saveBusinessHours = $resource(backendServer + '/pdv/saveBusinessHours', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.saveBusinessHours = $resource(backendServer + '/pdv/saveBusinessHours', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.businessHours = $resource(backendServer + '/pdv/getBusinessHours', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.businessHours = $resource(backendServer + '/pdv/getBusinessHours', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        ///SETTINGS >> ACCOUNT >> USERS

        $rootScope.$on('changeToken', function () {
            api.users = $resource(backendServer + '/user/getUsers', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.users = $resource(backendServer + '/user/getUsers', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });



        $rootScope.$on('changeToken', function () {
            api.saveUser = $resource(backendServer + '/user/saveUser', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.saveUser = $resource(backendServer + '/user/saveUser', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });



        $rootScope.$on('changeToken', function () {
            api.removeUser = $resource(backendServer + '/user/removeUser', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.removeUser = $resource(backendServer + '/user/removeUser', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });



        $rootScope.$on('changeToken', function () {
            api.user = $resource(backendServer + '/user/getUser', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.user = $resource(backendServer + '/user/getUser', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        ///STOCK

        $rootScope.$on('changeToken', function () {
            api.stockEntry = $resource(backendServer + '/product/newStockEntry', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.stockEntry = $resource(backendServer + '/product/newStockEntry', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });


        ///SETTINGS >> SERVICES
        ///SETTINGS >> SERVICES >>> PACOTE DE SERVICOS

        //SERVICE PACKS===============================

        $rootScope.$on('changeToken', function () {
            api.getServicePack = $resource(backendServer + '/service/servicePack/getServicePack', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.getServicePack = $resource(backendServer + '/service/servicePack/getServicePack', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.getServicePacks = $resource(backendServer + '/service/servicePack/getServicePacks', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.getServicePacks = $resource(backendServer + '/service/servicePack/getServicePacks', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.saveServicePack = $resource(backendServer + '/service/servicePack/saveServicePack', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.saveServicePack = $resource(backendServer + '/service/servicePack/saveServicePack', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.removeServicePack = $resource(backendServer + '/service/servicePack/removeServicePack', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.removeServicePack = $resource(backendServer + '/service/servicePack/removeServicePack', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        //end SERVICE PACKS
        ///SETTINGS >> FINANCE >> BANK ACCOUNT
        $rootScope.$on('changeToken', function () {
            api.bankAccounts = $resource(backendServer + '/finance/getBankAccounts', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.bankAccounts = $resource(backendServer + '/service/getBankAccounts', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.cards = $resource(backendServer + '/finance/getCards', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.cards = $resource(backendServer + '/service/getCards', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.adquirentes2 = $resource(backendServer + '/finance/getAdquirentes', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.adquirentes2 = $resource(backendServer + '/service/getAdquirentes', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.createNewTEFTransaction = $resource(backendServer + '/integration/createNEWTEFPayment', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.createNewTEFTransaction = $resource(backendServer + '/integration/createNEWTEFPayment', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.checkPendingTEF = $resource(backendServer + '/integration/checkPendingTEFTransaction2', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.checkPendingTEF = $resource(backendServer + '/integration/checkPendingTEFTransaction2', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.cancelPendingTEFPayment = $resource(backendServer + '/integration/cancelPendingTEFPayment', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.cancelPendingTEFPayment = $resource(backendServer + '/integration/cancelPendingTEFPayment', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.estornarTransacaoZoop = $resource(backendServer + '/integration/estornarTransacaoZoop', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.estornarTransacaoZoop = $resource(backendServer + '/integration/estornarTransacaoZoop', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.financialCategories = $resource(backendServer + '/finance/getFinanceCategories', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.financialCategories = $resource(backendServer + '/finance/getFinanceCategories', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.banks = $resource(backendServer + '/finance/getBanks', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.banks = $resource(backendServer + '/finance/getBanks', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.saveBankAccount = $resource(backendServer + '/finance/saveBankAccount', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });

        api.saveBankAccount = $resource(backendServer + '/finance/saveBankAccount', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.bankAccount = $resource(backendServer + '/finance/getBankAccount', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });

        api.bankAccount = $resource(backendServer + '/finance/getBankAccount', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.removeBankAccount = $resource(backendServer + '/finance/removeBankAccount', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });

        api.removeBankAccount = $resource(backendServer + '/finance/removeBankAccount', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.card = $resource(backendServer + '/finance/getCard', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });

        api.card = $resource(backendServer + '/finance/getCard', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.saveCard = $resource(backendServer + '/finance/saveCard', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });

        api.saveCard = $resource(backendServer + '/finance/saveCard', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });




        $rootScope.$on('changeToken', function () {
            api.partners = $resource(backendServer + '/finance/getPartners', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.partners = $resource(backendServer + '/finance/getPartners', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });




        $rootScope.$on('changeToken', function () {
            api.partner = $resource(backendServer + '/finance/getPartner', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.partner = $resource(backendServer + '/finance/getPartner', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.removePartner = $resource(backendServer + '/finance/removePartner', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.removePartner = $resource(backendServer + '/finance/removePartner', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.savePartner = $resource(backendServer + '/finance/savePartner', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.savePartner = $resource(backendServer + '/finance/savePartner', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        ////

        $rootScope.$on('changeToken', function () {
            api.suppliers = $resource(backendServer + '/finance/getSuppliers', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.suppliers = $resource(backendServer + '/finance/getSuppliers', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.supplier = $resource(backendServer + '/finance/getSupplier', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.supplier = $resource(backendServer + '/finance/getSupplier', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.removeSupplier = $resource(backendServer + '/finance/removeSupplier', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.removeSupplier = $resource(backendServer + '/finance/removeSupplier', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.saveSupplier = $resource(backendServer + '/finance/saveSupplier', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.saveSupplier = $resource(backendServer + '/finance/saveSupplier', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.transactions = $resource(backendServer + '/finance/getTransactions', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.transactions = $resource(backendServer + '/finance/getTransactions', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        ///SETTINGS >> SERVICES >> PRICE TABLE

        $rootScope.$on('changeToken', function () {
            api.priceTableByCustomer = $resource(backendServer + '/service/getPriceTableByCustomer', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.priceTableByCustomer = $resource(backendServer + '/service/getPriceTableByCustomer', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.duplicatePriceTable = $resource(backendServer + '/service/duplicatePriceTable', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.duplicatePriceTable = $resource(backendServer + '/service/duplicatePriceTable', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.duplicateService = $resource(backendServer + '/service/duplicate', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.duplicateService = $resource(backendServer + '/service/duplicate', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.savePriceTable = $resource(backendServer + '/service/savePriceTable', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.savePriceTable = $resource(backendServer + '/service/savePriceTable', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.removePriceTable = $resource(backendServer + '/service/removePriceTable', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.removePriceTable = $resource(backendServer + '/service/removePriceTable', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.priceTable = $resource(backendServer + '/service/getPriceTable', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.priceTable = $resource(backendServer + '/service/getPriceTable', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.priceTables = $resource(backendServer + '/service/getPriceTables', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.priceTables = $resource(backendServer + '/service/getPriceTables', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        ///SETTINGS >> SERVICES >> CATEGORY
        $rootScope.$on('changeToken', function () {
            api.serviceCategory = $resource(backendServer + '/service/getCategory', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.serviceCategory = $resource(backendServer + '/service/getCategory', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.serviceCategories = $resource(backendServer + '/service/getCategories', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.serviceCategories = $resource(backendServer + '/service/getCategories', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.saveCategory = $resource(backendServer + '/service/saveCategory', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.saveCategory = $resource(backendServer + '/service/saveCategory', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.removeCategory = $resource(backendServer + '/service/removeCategory', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.removeCategory = $resource(backendServer + '/service/removeCategory', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        ///SETTINGS >> SERVICES >> SERVICE
        $rootScope.$on('changeToken', function () {
            api.serviceServices = $resource(backendServer + '/service/getServices', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.serviceServices = $resource(backendServer + '/service/getServices', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.serviceServicesSearch = $resource(backendServer + '/service/getServicesByName', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.serviceServicesSearch = $resource(backendServer + '/service/getServicesByName', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.serviceService = $resource(backendServer + '/service/getService', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.serviceService = $resource(backendServer + '/service/getService', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.saveService = $resource(backendServer + '/service/saveService', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.saveService = $resource(backendServer + '/service/saveService', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.removeService = $resource(backendServer + '/service/removeService', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.removeService = $resource(backendServer + '/service/removeService', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        ///SETTINGS >> SERVICES >> PROFESIONAL
        $rootScope.$on('changeToken', function () {
            api.professionalsByService = $resource(backendServer + '/professional/getProfessionalsByService', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.professionalsByService = $resource(backendServer + '/professional/getProfessionalsByService', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });


        $rootScope.$on('changeToken', function () {
            api.serviceProfessionals = $resource(backendServer + '/professional/getProfessionalsWithSchedule', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.serviceProfessionals = $resource(backendServer + '/professional/getProfessionalsWithSchedule', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });



        $rootScope.$on('changeToken', function () {
            api.getProfessionalsWithSchedule = $resource(backendServer + '/professional/getProfessionalsWithSchedule', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.getProfessionalsWithSchedule = $resource(backendServer + '/professional/getProfessionalsWithSchedule', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });



        $rootScope.$on('changeToken', function () {
            api.serviceProfessionalSearch = $resource(backendServer + '/professional/getProfessionalsByName', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.serviceProfessionalSearch = $resource(backendServer + '/professional/getProfessionalsByName', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.serviceProfessionalSearchFast = $resource(backendServer + '/professional/getFastProfessionalsByName', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.serviceProfessionalSearchFast = $resource(backendServer + '/professional/getFastProfessionalsByName', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.serviceProfessionalSearchFast2 = $resource(backendServer + '/professional/getFastProfessionalsByName2', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.serviceProfessionalSearchFast2 = $resource(backendServer + '/professional/getFastProfessionalsByName2', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });


        $rootScope.$on('changeToken', function () {
            api.serviceProfessional = $resource(backendServer + '/professional/getProfessional', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.serviceProfessional = $resource(backendServer + '/professional/getProfessional', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.saveFreshId = $resource(backendServer + '/professional/saveFreshId', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.saveFreshId = $resource(backendServer + '/professional/saveFreshId', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });



        ////PROFESSIONAL-ADVANCE

        $rootScope.$on('changeToken', function () {
            api.removeProfessionalPayment = $resource(backendServer + '/professional/removeProfessionalPayment', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.removeProfessionalPayment = $resource(backendServer + '/professional/removeProfessionalPayment', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.saldoUntilDtProfessional = $resource(backendServer + '/professional/getBalance', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.saldoUntilDtProfessional = $resource(backendServer + '/professional/getBalance', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.saveProfessionalAdvance = $resource(backendServer + '/professional/saveProfessionalPayment', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.saveProfessionalAdvance = $resource(backendServer + '/professional/saveProfessionalPayment', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.professionalAdvance = $resource(backendServer + '/professional/getProfessionalPayment', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.professionalAdvance = $resource(backendServer + '/professional/getProfessionalPayment', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.professionalAdvances = $resource(backendServer + '/professional/getProfessionalPayments', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });newSubscription
        });
        api.professionalAdvances = $resource(backendServer + '/professional/getProfessionalPayments', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.removeProfessionalAdvance = $resource(backendServer + '/professional/removeProfessionalPayment', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.removeProfessionalAdvance = $resource(backendServer + '/professional/removeProfessionalPayment', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        ////END


        $rootScope.$on('changeToken', function () {
            api.saveProfessional = $resource(backendServer + '/professional/saveProfessional', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.saveProfessional = $resource(backendServer + '/professional/saveProfessional', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });



        $rootScope.$on('changeToken', function () {
            api.saveProfessionalBlock = $resource(backendServer + '/professional/saveProfessionalBlock', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.saveProfessionalBlock = $resource(backendServer + '/professional/saveProfessionalBlock', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });



        $rootScope.$on('changeToken', function () {
            api.removeProfessionalBlock = $resource(backendServer + '/professional/removeProfessionalBlock', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.removeProfessionalBlock = $resource(backendServer + '/professional/removeProfessionalBlock', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });



        $rootScope.$on('changeToken', function () {
            api.removeProfessional = $resource(backendServer + '/professional/removeProfessional2', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.removeProfessional = $resource(backendServer + '/professional/removeProfessional2', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.inviteProfessional = $resource(backendServer + '/professional/inviteProfessional', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.inviteProfessional = $resource(backendServer + '/professional/inviteProfessional', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.getInviteInfo = $resource(backendServer + '/professional/getInviteInfo', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.getInviteInfo = $resource(backendServer + '/professional/getInviteInfo', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.acceptInvite = $resource(backendServer + '/professional/acceptInvite', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.acceptInvite = $resource(backendServer + '/professional/acceptInvite', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.acceptInviteWithSignup = $resource(backendServer + '/professional/acceptInviteWithSignup', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.acceptInviteWithSignup = $resource(backendServer + '/professional/acceptInviteWithSignup', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });



        /////PRODUCT

        $rootScope.$on('changeToken', function () {
            api.removeProduct = $resource(backendServer + '/product/removeProduct', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.removeProduct = $resource(backendServer + '/product/removeProduct', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.saveProduct = $resource(backendServer + '/product/saveProduct', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.saveProduct = $resource(backendServer + '/product/saveProduct', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.product = $resource(backendServer + '/product/getProduct', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.product = $resource(backendServer + '/product/getProduct', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.products = $resource(backendServer + '/product/getProducts', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.products = $resource(backendServer + '/product/getProducts', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.getProductsByName = $resource(backendServer + '/product/getProductsByName', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.getProductsByName = $resource(backendServer + '/product/getProductsByName', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        ///SETTINGS >> PRODUCT >> CATEGORY
        $rootScope.$on('changeToken', function () {
            api.productCategories = $resource(backendServer + '/product/getCategories', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.productCategories = $resource(backendServer + '/product/getCategories', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.productCategory = $resource(backendServer + '/product/getCategory', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.productCategory = $resource(backendServer + '/product/getCategory', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.saveProductCategory = $resource(backendServer + '/product/saveCategory', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.saveProductCategory = $resource(backendServer + '/product/saveCategory', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.removeProductCategory = $resource(backendServer + '/product/removeCategory', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.removeProductCategory = $resource(backendServer + '/product/removeCategory', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });


        ///>>>>>SALES

        $rootScope.$on('changeToken', function () {
            api.sendCustomerRecipe = $resource(backendServer + '/customer/sendCustomerRecipe', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.sendCustomerRecipe = $resource(backendServer + '/customer/sendCustomerRecipe', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.reopenSale = $resource(backendServer + '/sale/reopenSale', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.reopenSale = $resource(backendServer + '/sale/reopenSale', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.openSales = $resource(backendServer + '/sale/getOpenSales', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.openSales = $resource(backendServer + '/sale/getOpenSales', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.closedSales = $resource(backendServer + '/sale/getClosedSales', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.closedSales = $resource(backendServer + '/sale/getClosedSales', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.removeSale = $resource(backendServer + '/sale/removeSale', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.removeSale = $resource(backendServer + '/sale/removeSale', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.saveSale = $resource(backendServer + '/sale/saveSale4', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.saveSale = $resource(backendServer + '/sale/saveSale4', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.saveSale5 = $resource(backendServer + '/sale/saveSale5', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.saveSale5 = $resource(backendServer + '/sale/saveSale5', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.saveTransferTransaction = $resource(backendServer + '/finance/transferTransaction', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.saveTransferTransaction = $resource(backendServer + '/sale/transferTransaction', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.adquirentes = $resource(backendServer + '/finance/getAdquirentes', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.adquirentes = $resource(backendServer + '/finance/getAdquirentes', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.saveBankAccountTransaction = $resource(backendServer + '/finance/saveTransaction', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.saveBankAccountTransaction = $resource(backendServer + '/finance/saveTransaction', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.removeTransaction = $resource(backendServer + '/finance/removeTransaction', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.removeTransaction = $resource(backendServer + '/finance/removeTransaction', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.initialBalance = $resource(backendServer + '/finance/getInitialBalance', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.initialBalance = $resource(backendServer + '/finance/getInitialBalance', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });


        $rootScope.$on('changeToken', function () {
            api.sale = $resource(backendServer + '/sale/getSale', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.sale = $resource(backendServer + '/sale/getSale', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        ///MARKETING
        //MARKETING >> CONFIGURATION
        $rootScope.$on('changeToken', function () {
            api.sendSpotMessage = $resource(backendServer + '/marketing/spot/sendSpotMessage', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.sendSpotMessage = $resource(backendServer + '/marketing/spot/sendSpotMessage', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.saveReminderConfiguration = $resource(backendServer + '/marketing/configuration/saveReminderConfiguration', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.saveReminderConfiguration = $resource(backendServer + '/marketing/configuration/saveReminderConfiguration', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.saveBirthdayConfiguration = $resource(backendServer + '/marketing/configuration/saveBirthdayConfiguration', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.saveBirthdayConfiguration = $resource(backendServer + '/marketing/configuration/saveBirthdayConfiguration', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.reminderConfiguration = $resource(backendServer + '/marketing/configuration/getReminderConfiguration', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.reminderConfiguration = $resource(backendServer + '/marketing/configuration/getReminderConfiguration', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.birthdayConfiguration = $resource(backendServer + '/marketing/configuration/getBirthdayConfiguration', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.birthdayConfiguration = $resource(backendServer + '/marketing/configuration/getBirthdayConfiguration', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.surveyConfiguration = $resource(backendServer + '/marketing/configuration/getSurveyConfiguration', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.surveyConfiguration = $resource(backendServer + '/marketing/configuration/getSurveyConfiguration', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.surveyMediumByProfessional = $resource(backendServer + '/marketing/survey/getSurveyMediumGroupedByProfessional', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.surveyMediumByProfessional = $resource(backendServer + '/marketing/survey/getSurveyMediumGroupedByProfessional', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.surveyMediumByCategory = $resource(backendServer + '/marketing/survey/getSurveyMediumGroupedByServiceCategory', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.surveyMediumByCategory = $resource(backendServer + '/marketing/survey/getSurveyMediumGroupedByServiceCategory', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.surveyMedium = $resource(backendServer + '/marketing/survey/getSurveyMedium', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.surveyMedium = $resource(backendServer + '/marketing/survey/getSurveyMedium', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.noshowRescheduleConfiguration = $resource(backendServer + '/marketing/configuration/getNoshowRescheduleConfiguration', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.noshowRescheduleConfiguration = $resource(backendServer + '/marketing/configuration/getNoshowRescheduleConfiguration', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.welcomeConfiguration = $resource(backendServer + '/marketing/configuration/getWelcomeConfiguration', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.welcomeConfiguration = $resource(backendServer + '/marketing/configuration/getWelcomeConfiguration', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.saveWelcomeConfiguration = $resource(backendServer + '/marketing/configuration/saveWelcomeConfiguration', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.saveWelcomeConfiguration = $resource(backendServer + '/marketing/configuration/saveWelcomeConfiguration', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        //MARKETING >> SMS
        $rootScope.$on('changeToken', function () {
            api.sendSMS = $resource(backendServer + '/marketing/sms/sendSMS', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.sendSMS = $resource(backendServer + '/marketing/sms/sendSMS', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        //MARKETING >> CAMPAIGN
        $rootScope.$on('changeToken', function () {
            api.saveCampaign = $resource(backendServer + '/marketing/campaign/saveCampaign', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.saveCampaign = $resource(backendServer + '/marketing/campaign/saveCampaign', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.campaigns = $resource(backendServer + '/marketing/campaign/getCampaigns', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.campaigns = $resource(backendServer + '/marketing/campaign/getCampaigns', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.campaign = $resource(backendServer + '/marketing/campaign/getCampaign', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.campaign = $resource(backendServer + '/marketing/campaign/getCampaign', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.removeCampaign = $resource(backendServer + '/marketing/campaign/removeCampaign', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.removeCampaign = $resource(backendServer + '/marketing/campaign/removeCampaign', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });


         //MARKETING >> LOYALTY
        $rootScope.$on('changeToken', function () {
            api.exchangePoints = $resource(backendServer + '/marketing/loyalty/exchangePoints', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.exchangePoints = $resource(backendServer + '/marketing/loyalty/exchangePoints', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        //MARKETING >> PARTNER
        $rootScope.$on('changeToken', function () {
            api.partnership = $resource(backendServer + '/marketing/partnership/getPartnership', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.partnership = $resource(backendServer + '/marketing/partnership/getPartnership', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.partnerships = $resource(backendServer + '/marketing/partnership/getPartnerships', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.partnerships = $resource(backendServer + '/marketing/partnership/getPartnerships', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.savePartnership = $resource(backendServer + '/marketing/partnership/savePartnership', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.savePartnership = $resource(backendServer + '/marketing/partnership/savePartnership', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.removePartnership = $resource(backendServer + '/marketing/partnership/removePartnership', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.removePartnership = $resource(backendServer + '/marketing/partnership/removePartnership', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        api.offers = $resource(backendServer + '/marketing/offer/getOffers', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.offers = $resource(backendServer + '/marketing/offer/getOffers', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.saveOffer = $resource(backendServer + '/marketing/offer/saveOffer', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.saveOffer = $resource(backendServer + '/marketing/offer/saveOffer', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.enableOffer = $resource(backendServer + '/marketing/offer/enableOffer', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.enableOffer = $resource(backendServer + '/marketing/offer/enableOffer', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.disableOffer = $resource(backendServer + '/marketing/offer/disableOffer', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.disableOffer = $resource(backendServer + '/marketing/offer/disableOffer', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.offer = $resource(backendServer + '/marketing/offer/getOffer', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.offer = $resource(backendServer + '/marketing/offer/getOffer', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        ///////END OFFER
        api.saveSpotCampaign = $resource(backendServer + '/marketing/saveSpotCampaign', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.spotCampaigns = $resource(backendServer + '/marketing/getSpotCampaigns', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.spotCampaigns = $resource(backendServer + '/marketing/getSpotCampaigns', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.spotCampaigns2 = $resource(backendServer + '/marketing/spot/getSpotCampaigns', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.spotCampaigns2 = $resource(backendServer + '/marketing/spot/getSpotCampaigns', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        //////////////////WOM//////////////////////
        $rootScope.$on('changeToken', function () {
            api.womCampaigns = $resource(backendServer + '/marketing/wom/getCampaigns', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.womCampaigns = $resource(backendServer + '/marketing/wom/getCampaigns', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.womGetCampaignLeads = $resource(backendServer + '/marketing/wom/getLeads', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.womGetCampaignLeads = $resource(backendServer + '/marketing/wom/getLeads', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.womConvertFriend = $resource(backendServer + '/marketing/wom/convertLead', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.womConvertFriend = $resource(backendServer + '/marketing/wom/convertLead', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.womCampaign = $resource(backendServer + '/marketing/wom/getCampaign', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.womCampaign = $resource(backendServer + '/marketing/wom/getCampaign', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.womSaveCampaign = $resource(backendServer + '/marketing/wom/saveCampaign', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.womSaveCampaign = $resource(backendServer + '/marketing/wom/saveCampaign', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.womRemoveCampaign = $resource(backendServer + '/marketing/wom/removeCampaign', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.womRemoveCampaign = $resource(backendServer + '/marketing/wom/removeCampaign', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.womGetCampaignPromoters = $resource(backendServer + '/marketing/wom/getCampaignPromoters', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.womGetCampaignPromoters = $resource(backendServer + '/marketing/wom/getCampaignPromoters', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.womInvitePromoter = $resource(backendServer + '/marketing/wom/newCampaignPromoter', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.womInvitePromoter = $resource(backendServer + '/marketing/wom/newCampaignPromoter', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.womPromoter = $resource(backendServer + '/marketing/wom/getPromoter', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.womPromoter = $resource(backendServer + '/marketing/wom/getPromoter', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.womGetPromoterTransactions = $resource(backendServer + '/marketing/wom/getPromoterTransactions', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.womGetPromoterTransactions = $resource(backendServer + '/marketing/wom/getPromoterTransactions', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.womPromoterBalance = $resource(backendServer + '/marketing/wom/getPromoterBalance', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.womPromoterBalance = $resource(backendServer + '/marketing/wom/getPromoterBalance', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.womRedeemReward = $resource(backendServer + '/marketing/wom/redeemReward', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.womRedeemReward = $resource(backendServer + '/marketing/wom/redeemReward', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.womResendLink = $resource(backendServer + '/marketing/wom/resendLinkCampaignPromoter', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.womResendLink = $resource(backendServer + '/marketing/wom/resendLinkCampaignPromoter', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        ///////////////////////////////////////////
        $rootScope.$on('changeToken', function () {
            api.spotCampaign = $resource(backendServer + '/marketing/getSpotCampaign', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.spotCampaign = $resource(backendServer + '/marketing/getSpotCampaign', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.pdv = $resource(backendServer + '/pdv/getPDV', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.pdv = $resource(backendServer + '/pdv/getPDV', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        api.log = $resource(backendServer + '/pdv/saveLog', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.log = $resource(backendServer + '/pdv/saveLog', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        $rootScope.$on('changeToken', function () {
            api.pdvSaveAbout = $resource(backendServer + '/pdv/saveAboutInformation', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.pdvSaveAbout = $resource(backendServer + '/pdv/saveAboutInformation', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.pdvSaveLocation = $resource(backendServer + '/pdv/saveLocation', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.pdvSaveLocation = $resource(backendServer + '/pdv/saveLocation', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.pdvSavePhoto = $resource(backendServer + '/pdv/addSlideToSlideShow', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.pdvSavePhoto = $resource(backendServer + '/pdv/addSlideToSlideShow', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.pdvRemovePhoto = $resource(backendServer + '/pdv/removeSlideFromSlideShow', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.pdvRemovePhoto = $resource(backendServer + '/pdv/removeSlideFromSlideShow', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.saveStylePlaceConfiguration = $resource(backendServer + '/marketing/saveStylePlaceConfiguration', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.saveStylePlaceConfiguration = $resource(backendServer + '/marketing/saveStylePlaceConfiguration', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.removeSpotCampaign = $resource(backendServer + '/marketing/removeSpotCampaign', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.removeSpotCampaign = $resource(backendServer + '/marketing/removeSpotCampaign', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.copySpotCampaign = $resource(backendServer + '/marketing/copySpotCampaign', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.copySpotCampaign = $resource(backendServer + '/marketing/copySpotCampaign', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        ////////CUPONS
        $rootScope.$on('changeToken', function () {
            api.cupons = $resource(backendServer + '/cupom/getCuponsByPDV', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.cupons = $resource(backendServer + '/cupom/getCuponsByPDV', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.cancelCupom = $resource(backendServer + '/cupom/cancelCupom', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.cancelCupom = $resource(backendServer + '/cupom/cancelCupom', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.coupomByCustomerAndId = $resource(backendServer + '/cupom/getCoupomByCustomerAndId', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.coupomByCustomerAndId = $resource(backendServer + '/cupom/getCoupomByCustomerAndId', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        ////////////////////////
        $rootScope.$on('changeToken', function () {
            api.messages = $resource(backendServer + '/marketing/getMessages', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.messages = $resource(backendServer + '/marketing/getMessages', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        ////////////////////////FINANCE
        $rootScope.$on('changeToken', function () {
            api.validateCashiers = $resource(backendServer + '/finance/validateCashiers', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.validateCashiers = $resource(backendServer + '/finance/validateCashiers', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.getReportCashier = $resource(backendServer + '/finance/getReportCashier', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.getReportCashier = $resource(backendServer + '/finance/getReportCashier', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });


        $rootScope.$on('changeToken', function () {
            api.bandeiras = $resource(backendServer + '/finance/getBandeiras', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.bandeiras = $resource(backendServer + '/finance/getBandeiras', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });


        $rootScope.$on('changeToken', function () {
            api.openCashier = $resource(backendServer + '/finance/openCashier', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.openCashier = $resource(backendServer + '/finance/openCashier', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.getOpenCashier = $resource(backendServer + '/finance/getOpenCashier', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.getOpenCashier = $resource(backendServer + '/finance/getOpenCashier', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.closeCashier = $resource(backendServer + '/finance/closeCashier', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.closeCashier = $resource(backendServer + '/finance/closeCashier', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.getCashiers = $resource(backendServer + '/finance/getCashiers', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.getCashiers = $resource(backendServer + '/finance/getCashiers', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.getSalesWithinCashier = $resource(backendServer + '/finance/getSalesWithinCashier', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.getSalesWithinCashier = $resource(backendServer + '/finance/getSalesWithinCashier', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.getSalesWithinCashier2 = $resource(backendServer + '/finance/getSalesWithinCashier2', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.getSalesWithinCashier2 = $resource(backendServer + '/finance/getSalesWithinCashier2', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.getSalesWithinCashierByPaymentType = $resource(backendServer + '/finance/getSalesWithinCashierByPaymentType', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.getSalesWithinCashierByPaymentType = $resource(backendServer + '/finance/getSalesWithinCashierByPaymentType', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });


        //////////////////////REPORT

        $rootScope.$on('changeToken', function () {
            api.dashboard = $resource(backendServer + '/report/getDashboard', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.dashboard = $resource(backendServer + '/report/getDashboard', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        //wowee pay
        $rootScope.$on('changeToken', function () {
            api.getWoweePayLancamentosFuturos = $resource(backendServer + '/report/getWoweePayLancamentosFuturos', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.getWoweePayLancamentosFuturos = $resource(backendServer + '/report/getWoweePayLancamentosFuturos', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        //
        $rootScope.$on('changeToken', function () {
            api.getWoweePayExtrato = $resource(backendServer + '/report/getWoweePayExtrato', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.getWoweePayExtrato = $resource(backendServer + '/report/getWoweePayExtrato', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        //
        $rootScope.$on('changeToken', function () {
            api.getWoweePayVendas = $resource(backendServer + '/report/getWoweePayVendas', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.getWoweePayVendas = $resource(backendServer + '/report/getWoweePayVendas', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        //
        $rootScope.$on('changeToken', function () {
            api.getWoweePayPagamentos = $resource(backendServer + '/report/getWoweePayPagamentos', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.getWoweePayPagamentos = $resource(backendServer + '/report/getWoweePayPagamentos', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        ///////////
        $rootScope.$on('changeToken', function () {
            api.getCanceledSchedule = $resource(backendServer + '/report/getCanceledSchedule', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.getCanceledSchedule = $resource(backendServer + '/report/getCanceledSchedule', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.salesSynthethic = $resource(backendServer + '/report/getSalesSynthethic', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.salesSynthethic = $resource(backendServer + '/report/getSalesSynthethic', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.surveyAnswers = $resource(backendServer + '/report/getSurveyAnswers', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.surveyAnswers = $resource(backendServer + '/report/getSurveyAnswers', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.salesByCategory = $resource(backendServer + '/report/getSaleByCategory', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.salesByCategory = $resource(backendServer + '/report/getSaleByCategory', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.salesWithGiftCards = $resource(backendServer + '/report/getSalesWithGiftCard', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.salesWithGiftCards = $resource(backendServer + '/report/getSalesWithGiftCard', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.messages = $resource(backendServer + '/report/getMessages', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.messages = $resource(backendServer + '/report/getMessages', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.creditDebitReport = $resource(backendServer + '/report/getCreditDebit', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.creditDebitReport = $resource(backendServer + '/report/getCreditDebit', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.financeAudit = $resource(backendServer + '/report/getFinanceAudit', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.financeAudit = $resource(backendServer + '/report/getFinanceAudit', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.financeAnalytics = $resource(backendServer + '/report/getFinanceAnalytics', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.financeAnalytics = $resource(backendServer + '/report/getFinanceAnalytics', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.comissionReport = $resource(backendServer + '/report/getComissions', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.comissionReport = $resource(backendServer + '/report/getComissions', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.paymentTypeReport = $resource(backendServer + '/report/getSalesByPaymentTypes', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.paymentTypeReport = $resource(backendServer + '/report/getSalesByPaymentTypes', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });


        $rootScope.$on('changeToken', function () {
            api.userSalesReport = $resource(backendServer + '/report/getSalesByUser', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.userSalesReport = $resource(backendServer + '/report/getSalesByUser', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.customerBirthdayReport = $resource(backendServer + '/customer/getCustomersBirthday', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.customerBirthdayReport = $resource(backendServer + '/customer/getCustomersBirthday', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.customerTopReport = $resource(backendServer + '/report/getCustomersTop', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.customerTopReport = $resource(backendServer + '/report/getCustomersTop', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.salesAnalyticsByUser = $resource(backendServer + '/report/getSalesAnalyticsByUser', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.salesAnalyticsByUser = $resource(backendServer + '/report/getSalesAnalyticsByUser', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        $rootScope.$on('changeToken', function () {
            api.salesAnalyticsByPaymentType = $resource(backendServer + '/report/getSalesAnalyticsByPaymentType', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.salesAnalyticsByPaymentType = $resource(backendServer + '/report/getSalesAnalyticsByPaymentType', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.salesAnalyticsByProfessional = $resource(backendServer + '/report/getSaleByProfessional', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.salesAnalyticsByProfessional = $resource(backendServer + '/report/getSaleByProfessional', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.salesAnalytics = $resource(backendServer + '/report/getSales', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.salesAnalytics = $resource(backendServer + '/report/getSales', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        ///configuration marketing
        $rootScope.$on('changeToken', function () {
            api.marketingConfiguration = $resource(backendServer + '/marketing/getConfiguration', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.marketingConfiguration = $resource(backendServer + '/marketing/getConfiguration', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.saveMarketingScheduleConfiguration = $resource(backendServer + '/marketing/saveScheduleConfiguration', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.saveMarketingScheduleConfiguration = $resource(backendServer + '/marketing/saveScheduleConfiguration', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.saveMarketingBirthdayConfiguration = $resource(backendServer + '/marketing/saveBirthdayConfiguration', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.saveMarketingBirthdayConfiguration = $resource(backendServer + '/marketing/saveBirthdayConfiguration', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.saveMarketingSurveyConfiguration = $resource(backendServer + '/marketing/configuration/saveSurveyConfiguration', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.saveMarketingSurveyConfiguration = $resource(backendServer + '/marketing/configuration/saveSurveyConfiguration', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });
        $rootScope.$on('changeToken', function () {
            api.saveNoshowRescheduleConfiguration = $resource(backendServer + '/marketing/configuration/saveNoshowRescheduleConfiguration', {}, {
                save: {
                    method: 'POST',
                    params: {
                        token: $rootScope.securityToken
                    }
                }
            });
        });
        api.saveNoshowRescheduleConfiguration = $resource(backendServer + '/marketing/configuration/saveNoshowRescheduleConfiguration', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });

        /////UTIL
        api.sendLeadLoverInfo = $resource(backendServer + '/util/sendFormLeadLover', {}, {
            save: {
                method: 'POST',
                params: {
                    token: $rootScope.securityToken
                }
            }
        });



        return api;
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.product.product', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        //State
        $stateProvider
            .state('app.settings.product.product', {
                url    : '/product'
            }).state('app.settings.product.product.list', {
                url    : '/list',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/settings/product/product/list.html',
                        controller : 'ProductController as vm'
                    }
                }
            }).state('app.settings.product.product.new', {
                url    : '/new',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/settings/product/product/product.html',
                        controller : 'ProductController as vm'
                    }
                }
            }).state('app.settings.product.product.edit', {
                url    : '/edit/:productId',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/settings/product/product/product.html',
                        controller : 'ProductController as vm'
                    }
                }
            });

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.content.location', ['uiGmapgoogle-maps'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, uiGmapGoogleMapApiProvider) {

        //Google maps
        uiGmapGoogleMapApiProvider.configure({
            key: 'AIzaSyBvXlLeB8MZYU-teK1jDPGWPA_9BOwkBLM',
            v: '3.21', //defaults to latest 3.X anyhow
            libraries: 'drawing'
        });

        $stateProvider
            .state('app.settings.content.location', {
                url: '/location',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/settings/content/location/location.html',
                        controller: 'ContentLocationController as vm'
                    }
                }
            })
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.service', ['app.settings.service.category',
            'app.settings.service.service','app.settings.service.priceTable','app.settings.service.servicePack'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {




        //State
        $stateProvider
            .state('app.settings.service', {
                url    : '/service'
            });

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.finance', ['app.settings.finance.category',
            'app.settings.finance.card','app.settings.finance.bankaccount','app.settings.finance.partner',
            ,'app.settings.finance.supplier'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {




        //State
        $stateProvider
            .state('app.settings.finance', {
                url    : '/finance'
            });

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.content', ['app.settings.content.about','app.settings.content.location'
            ,'app.settings.content.photo'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.settings.content', {
                url    : '/content'
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.settings.account', ['app.settings.account.user','app.settings.account.businessinfo'
            ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {





        //State
        $stateProvider
            .state('app.settings.account', {
                url    : '/account'
            });

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.marketingv2.checkup', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.marketingv2.checkup', {
                url    : '/checkup'
            })
            .state('app.marketingv2.checkup.encante', {
                url    : '/encante',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/marketingv2/checkup/encante.html'
                    }
                }
            })


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.marketing.content', ['app.marketing.content.about','app.marketing.content.location'
            ,'app.marketing.content.photo'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.marketing.content', {
                url    : '/content'
            });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.subscription', ['app.subscription.price-table','app.subscription.extras'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.subscription', {
                url    : '/subscription'
            })

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.settings', ['app.settings.account', 'app.settings.service', 'app.settings.product',
            'app.settings.general', 'app.settings.content', 'app.settings.finance'
         ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {


        //State
        $stateProvider
            .state('app.settings', {
                url    : '/settings'
            });






    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.report',
        [
            // 3rd Party Dependencies
            'datatables',
            'datatables.buttons',
            'app.report.sales',
            'app.report.finance',
            'app.report.customer',
            'app.report.marketing',
            'app.report.other',
            'app.report.woweepay'
        ]
    )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {


        $stateProvider.state('app.report', {
            url    : '/report'
        });



    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.marketingv2', ['app.marketingv2.campaign',
            'app.marketingv2.partnership', 'app.marketingv2.reminder', 'app.marketingv2.birthday'
            , 'app.marketingv2.loyalty', 'app.marketingv2.survey', 'app.marketingv2.noshowreschedule'
            , 'app.marketingv2.welcome', 'app.marketingv2.spot', 'app.marketingv2.wom',
            'app.marketingv2.loyalty2','app.marketingv2.checkup'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.marketingv2', {
                url    : '/marketingv2'
            })

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.marketing', ['app.marketing.spot', 'app.marketing.cupom', 'app.marketing.message',
            'app.marketing.configuration', 'app.marketing.content', 'app.marketing.marketplace',
            'app.marketing.partnership','app.marketing.offer'])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.marketing', {
                url    : '/marketing'
            })

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth', ['app.auth.signin','app.auth.signup','app.auth.forgot-password','app.auth.verifyAccount','app.auth.verifyEmail'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {

        //State
        $stateProvider
            .state('app.auth', {
                url    : '/auth'
            });

    }
})();
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('report', [
        ]);
})();
angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"QUICKPANEL.CHAT\">CHAT</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/layouts/content-only-2.html","<md-content ui-view=\"content\" flex></md-content>");
$templateCache.put("app/core/layouts/content-only.html","<md-content ui-view=\"content\" flex></md-content>");
$templateCache.put("app/core/layouts/content-with-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\"><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"column\" layout-align=\"start end\" flex></div><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\" layout-align=\"end\"></md-toolbar></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/dashboard/dashboard.html","<div class=\"center\" flex ms-scroll><div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div \nlayout=\"row\" layout-align=\"space-between\" style=\"height: 100px\"><div style=\"margin:20px\"><span \nclass=\"md-display-1 font-weight-300\">Olá {{userName}}!</span></div></div></div></div><div class=\"content\"><md-tabs \nmd-dynamic-height><md-tab label=\"Agendamentos\" id=\"teste3\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\nAgendamentos Hoje</div></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"font-size-72 line-height-72\" ng-style=\"vm.agendamentoColor\">{{vm.dashboardData.totalAgendamentoHoje}}</div>\n</div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">Mesmo dia da semana anterior: </span><span class=\"h4 ml-8\" \nng-style=\"vm.agendamentoColor\">{{vm.dashboardData.totalAgendamentoMesmoDiaSemanaPassada}}</span></div>\n</ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"h3\">Agendamentos no mes</div></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"font-size-72 line-height-72\" ng-style=\"vm.agendamentoColor\">{{vm.dashboardData.totalAgendamentoNoMes}}</div>\n</div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">Previsão para esse mes: </span><span class=\"h4 ml-8\" \nng-style=\"vm.agendamentoColor\"><md-tooltip>Cálculo baseado na média dos últimos 4 meses</md-tooltip>\n{{vm.dashboardData.expectativaAgendamentoNoMes}}</span></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">Comparativo com mes anterior no momento: \n</span><span class=\"h4 ml-8\" ng-style=\"vm.agendamentoColor\">{{vm.dashboardData.percentualMudancaAgendamento}} %</span>\n</div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">Agendamentos</div></div><nvd3 \nclass=\"h-320\" options=\"vm.widget1.chart.options\" data=\"vm.widget1.chart.data\"></nvd3></ms-widget-front></ms-widget>\n</div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">Mapa de Ocupação (Beta)</div></div><div \nstyle=\"margin: 10px;border:1px solid silver\"><md-grid-list md-cols=\"8\" md-rows=\"1\" md-row-height=\"30px\" md-gutter=\"0\">\n<md-grid-tile style=\"background-color: cornsilk\"></md-grid-tile><md-grid-tile style=\"background-color: cornsilk\"><span \nstyle=\"font-size: 12px; font-weight: bold\">Segunda-Feira</span></md-grid-tile><md-grid-tile \nstyle=\"background-color: cornsilk\"><span style=\"font-size: 12px; font-weight: bold\">Terça-Feira</span></md-grid-tile>\n<md-grid-tile style=\"background-color: cornsilk\"><span style=\"font-size: 12px; font-weight: bold\">Quarta-Feira</span>\n</md-grid-tile><md-grid-tile style=\"background-color: cornsilk\"><span style=\"font-size: 12px; font-weight: bold\">\nQuinta-Feira</span></md-grid-tile><md-grid-tile style=\"background-color: cornsilk\"><span \nstyle=\"font-size: 12px; font-weight: bold\">Sexta-Feira</span></md-grid-tile><md-grid-tile \nstyle=\"background-color: cornsilk\"><span style=\"font-size: 12px; font-weight: bold\">Sábado</span></md-grid-tile>\n<md-grid-tile style=\"background-color: cornsilk\"><span style=\"font-size: 12px; font-weight: bold\">Domingo</span>\n</md-grid-tile></md-grid-list><md-grid-list md-cols=\"8\" md-rows=\"1\" md-row-height=\"30px\" md-gutter=\"0px\"><md-grid-tile \nstyle=\"background-color: cornsilk\"><span style=\"font-size: 12px; font-weight: bold\">Manha (08 as 12)</span>\n</md-grid-tile><md-grid-tile ng-style=\"vm.estiloSegundaManha\"><span>\n{{vm.segundaManha}} ({{(vm.segundaManha*100)/vm.expectativaPorTurnoManha }} %)</span></md-grid-tile><md-grid-tile \nng-style=\"vm.estiloTercaManha\"><span>{{vm.tercaManha}} ({{(vm.tercaManha*100)/vm.expectativaPorTurnoManha }} %)</span>\n</md-grid-tile><md-grid-tile ng-style=\"vm.estiloQuartaManha\"><span>\n{{vm.quartaManha}} ({{(vm.quartaManha*100)/vm.expectativaPorTurnoManha }} %)</span></md-grid-tile><md-grid-tile \nng-style=\"vm.estiloQuintaManha\"><span>{{vm.quintaManha}} ({{(vm.quintaManha*100)/vm.expectativaPorTurnoManha }} %)\n</span></md-grid-tile><md-grid-tile ng-style=\"vm.estiloSextaManha\"><span>\n{{vm.sextaManha}} ({{(vm.sextaManha*100)/vm.expectativaPorTurnoManha }} %)</span></md-grid-tile><md-grid-tile \nng-style=\"vm.estiloSabadoManha\"><span>{{vm.sabadoManha}} ({{(vm.sabadoManha*100)/vm.expectativaPorTurnoManha }} %)\n</span></md-grid-tile><md-grid-tile ng-style=\"vm.estiloDomingoManha\"><span>\n{{vm.domingoManha}} ({{(vm.domingoManha*100)/vm.expectativaPorTurnoManha }} %)</span></md-grid-tile></md-grid-list>\n<md-grid-list md-cols=\"8\" md-rows=\"1\" md-row-height=\"30px\" md-gutter=\"0px\"><md-grid-tile \nstyle=\"background-color: cornsilk\"><span style=\"font-size: 12px; font-weight: bold\">Tarde (12 as 18)</span>\n</md-grid-tile><md-grid-tile ng-style=\"vm.estiloSegundaTarde\"><span>\n{{vm.segundaTarde}} ({{(vm.segundaTarde*100)/vm.expectativaPorTurnoTarde }} %)</span></md-grid-tile><md-grid-tile \nng-style=\"vm.estiloTercaTarde\"><span>{{vm.tercaTarde}} ({{(vm.tercaTarde*100)/vm.expectativaPorTurnoTarde }} %)</span>\n</md-grid-tile><md-grid-tile ng-style=\"vm.estiloQuartaTarde\"><span>\n{{vm.quartaTarde}} ({{(vm.quartaTarde*100)/vm.expectativaPorTurnoTarde }} %)</span></md-grid-tile><md-grid-tile \nng-style=\"vm.estiloQuintaTarde\"><span>{{vm.quintaTarde}} ({{(vm.quintaTarde*100)/vm.expectativaPorTurnoTarde }} %)\n</span></md-grid-tile><md-grid-tile ng-style=\"vm.estiloSextaTarde\"><span>\n{{vm.sextaTarde}} ({{(vm.sextaTarde*100)/vm.expectativaPorTurnoTarde }} %)</span></md-grid-tile><md-grid-tile \nng-style=\"vm.estiloSabadoTarde\"><span>{{vm.sabadoTarde}} ({{(vm.sabadoTarde*100)/vm.expectativaPorTurnoTarde }} %)\n</span></md-grid-tile><md-grid-tile ng-style=\"vm.estiloDomingoTarde\"><span>\n{{vm.domingoTarde}} ({{(vm.domingoTarde*100)/vm.expectativaPorTurnoTarde }} %)</span></md-grid-tile></md-grid-list>\n<md-grid-list md-cols=\"8\" md-rows=\"1\" md-row-height=\"30px\" md-gutter=\"0px\"><md-grid-tile \nstyle=\"background-color: cornsilk\"><span style=\"font-size: 12px; font-weight: bold\">Noite (18 as 22)</span>\n</md-grid-tile><md-grid-tile ng-style=\"vm.estiloSegundaNoite\"><span>\n{{vm.segundaNoite}} ({{(vm.segundaNoite*100)/vm.expectativaPorTurnoNoite }} %)</span></md-grid-tile><md-grid-tile \nng-style=\"vm.estiloTercaNoite\"><span>{{vm.tercaNoite}} ({{(vm.tercaNoite*100)/vm.expectativaPorTurnoNoite }} %)</span>\n</md-grid-tile><md-grid-tile ng-style=\"vm.estiloQuartaNoite\"><span>\n{{vm.quartaNoite}} ({{(vm.quartaNoite*100)/vm.expectativaPorTurnoNoite }} %)</span></md-grid-tile><md-grid-tile \nng-style=\"vm.estiloQuintaNoite\"><span>{{vm.quintaNoite}} ({{(vm.quintaNoite*100)/vm.expectativaPorTurnoNoite }} %)\n</span></md-grid-tile><md-grid-tile ng-style=\"vm.estiloSextaNoite\"><span>\n{{vm.sextaNoite}} ({{(vm.sextaNoite*100)/vm.expectativaPorTurnoNoite }} %)</span></md-grid-tile><md-grid-tile \nng-style=\"vm.estiloSabadoNoite\"><span>{{vm.sabadoNoite}} ({{(vm.sabadoNoite*100)/vm.expectativaPorTurnoNoite }} %)\n</span></md-grid-tile><md-grid-tile ng-style=\"vm.estiloDomingoNoite\"><span>\n{{vm.domingoNoite}} ({{(vm.domingoNoite*100)/vm.expectativaPorTurnoNoite }} %)</span></md-grid-tile></md-grid-list>\n</div><span style=\"font-weight: bold; font-size:12px;margin:10px\">\n- Cálculos baseados na média de ocupação dos últimos 30 dias</span></ms-widget-front></ms-widget></div></md-tab><md-tab\n label=\"Financeiro\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">Faturamento Hoje</div>\n</div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"font-size-72 line-height-72\" \nng-style=\"vm.faturamentoColor\">R$ {{vm.dashboardData.totalFinanceiroHoje}} K</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">Previsão para o dia:</span> <span class=\"h4 ml-8\" \nng-style=\"vm.faturamentoColor\"><md-tooltip>Calculado baseado nos serviços agendados para o dia.</md-tooltip>\nR$ {{vm.dashboardData.expectativaFaturamentoHoje}}</span></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">Comparativo com mesmo dia da semana anterior:\n</span> <span class=\"h4 ml-8\" ng-style=\"vm.faturamentoColor\">\nR$ {{vm.dashboardData.totalFinanceiroMesmoDiaSemanaPassada}}</span></div></ms-widget-front></ms-widget><ms-widget \nflippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">Faturamento no Mes</div>\n</div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"font-size-72 line-height-72\" \nng-style=\"vm.faturamentoColor\">R$ {{vm.dashboardData.totalFinanceiroNoMes}} K</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">Previsão para esse mes:</span> <span class=\"h4 ml-8\" \nng-style=\"vm.faturamentoColor\">{{vm.dashboardData.expectativaFinanceira | currency : \'R$\': 2}}</span></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">Comparativo com o mes anterior:</span> <span class=\"h4 ml-8\" \nng-style=\"vm.faturamentoColor\">\n{{vm.dashboardData.percentualMudancaFinanceiro}}% ( R$ {{vm.dashboardData.totalFinanceiroNoMesPassado}} K)</span></div>\n</ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">Resultado Líquido</div></div>\n<nvd3 class=\"h-320\" options=\"vm.widget3.chart.options\" data=\"vm.PE12Meses\"></nvd3></ms-widget-front></ms-widget>\n<ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\nResultado por Categoria (Últimos 90 dias)</div></div><nvd3 class=\"h-320\" options=\"vm.widget4.chart.options\" \ndata=\"vm.margemBrutaPorCategoria\"></nvd3></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"h3\">Faturamento</div></div><nvd3 class=\"h-320\" options=\"vm.widget1.chart.options\" data=\"vm.faturamento12Meses\">\n</nvd3></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Principais Serviços</div></div><nvd3 \noptions=\"vm.chartFinanceiroCategoria.options\" data=\"vm.chartFinanceiroCategoria.data\"></nvd3></ms-widget-front>\n</ms-widget></div></md-tab><md-tab label=\"Marketing\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><ms-widget-front \nclass=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\nNovos Clientes Hoje</div></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"font-size-72 line-height-72\" style=\"color:gray\">{{vm.dashboardData.totalClientesHoje}}</div></div>\n</ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\">\n<ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"h3\">Novos Clientes no Mes</div></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\">\n<div class=\"font-size-72 line-height-72\" style=\"color:gray\">{{vm.dashboardData.totalClietesMes}}</div></div>\n</ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">Total de Clientes</div>\n</div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"font-size-72 line-height-72\" \nstyle=\"color:gray\">{{vm.dashboardData.totalClientes}}</div></div></ms-widget-front></ms-widget><ms-widget \nflippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\nClientes Ativos (última compra nos últimos 45 dias)</div></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"font-size-72 line-height-72\" style=\"color:gray\">\n{{vm.dashboardData.totalClientesAtivos}}</div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Clientes Desativando (última compra entre 120 e 45 dias)</div>\n</div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"font-size-72 line-height-72\" \nstyle=\"color:gray\">{{vm.dashboardData.totalClientesDesativando}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 ml-8 secondary-text\">\nQue tal mandar um SMS para esses clientes oferecendo alguma promoção? Esse é o momento certo para que eles não se esqueçam de vocês.\n</span></div></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">Clientes Inativos</div></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"font-size-72 line-height-72\" style=\"color:gray\">\n{{vm.dashboardData.totalClientesInativos}}</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 ml-8 secondary-text\">\nNão seria bom trazer parte desses clientes de volta? Monte um super desconto e envie para esses clientes.</span></div>\n</ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\nNovos Usuários App Próprio Hoje</div></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"font-size-72 line-height-72\" style=\"color:gray\">0</div></div></ms-widget-front></ms-widget><ms-widget \nflippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\nNovos Usuários App Próprio no Mes</div></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"font-size-72 line-height-72\" style=\"color:gray\">0</div></div></ms-widget-front></ms-widget></div></md-tab>\n</md-tabs></div>");
$templateCache.put("app/main/finance/cashier.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Financeiro</span></div><div \nclass=\"title\">Caixa</div></div><div layout=\"row\" layout-align=\"start center\"></div></div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-40dp\" layout=\"row\" layout-align=\"center center\" height=\"100px\" ng-show=\"!vm.showTable\">\n<br><span style=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></div><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table datatable=\"\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\" class=\"row-border hover\"></table></div></div></div>");
$templateCache.put("app/main/finance/openCashier.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Financeiro</span></div><div \nclass=\"title\">Caixas abertos</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised\" \nng-click=\"vm.openCashierDialog()\" ng-if=\"vm.showOpenCashier\">Abrir Caixa</md-button><md-button class=\"md-raised\" \nng-click=\"vm.closeCashierDialog()\" ng-if=\"vm.showCloseCashier\">Fechar Caixa</md-button></div></div><div \nclass=\"content\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><md-select class=\"simplified font-size-16\" \nng-model=\"vm.cash.cashier\" ng-change=\"vm.changeCashCashier()\" aria-label=\"Change range\"><md-option \nng-repeat=\"item in vm.openCashiers\" value=\"{{item.id}}\">{{item.professional}}</md-option></md-select></div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72\">\n{{vm.cash.total | currency : \'R$ \' : 2}}</div><div class=\"h3 secondary-text font-weight-500\">Caixa em Dinheiro</div>\n</div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">Comandas fechadas no(s) caixa(s) aberto(s)</span></div></ms-widget-front>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><md-select \nclass=\"simplified font-size-16\" ng-model=\"vm.debit.cashier\" ng-change=\"vm.changeDebitCashier()\" \naria-label=\"Change range\"><md-option ng-repeat=\"item in vm.openCashiers\" value=\"{{item.id}}\">{{item.professional}}\n</md-option></md-select></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{vm.debit.total | currency : \'R$ \' : 2}}</div><div \nclass=\"h3 secondary-text font-weight-500\">Caixa em Débito</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">\nComandas fechadas no(s) caixa(s) aberto(s)</span></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><md-select class=\"simplified font-size-16\" \nng-model=\"vm.credit.cashier\" ng-change=\"vm.changeCreditCashier()\" aria-label=\"Change range\"><md-option \nng-repeat=\"item in vm.openCashiers\" value=\"{{item.id}}\">{{item.professional}}</md-option></md-select></div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72\">\n{{vm.credit.total | currency : \'R$ \' : 2}}</div><div class=\"h3 secondary-text font-weight-500\">Caixa em Crédito</div>\n</div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">Comandas fechadas no(s) caixa(s) aberto(s)</span></div></ms-widget-front>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" ng-if=\"false\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n<md-select class=\"simplified font-size-16\" ng-model=\"vm.fiado.cashier\" ng-change=\"vm.changeFiadoCashier()\" \naria-label=\"Change range\"><md-option ng-repeat=\"item in vm.openCashiers\" value=\"{{item.id}}\">{{item.professional}}\n</md-option></md-select></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{vm.fiado.total | currency : \'R$ \' : 2}}</div><div \nclass=\"h3 secondary-text font-weight-500\">Fiado</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">Comandas fechadas no(s) caixa(s) aberto(s)\n</span></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"25\" ng-if=\"false\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><md-select class=\"simplified font-size-16\" ng-model=\"vm.giftcard.cashier\" \nng-change=\"vm.changeGiftCardCashier()\" aria-label=\"Change range\"><md-option ng-repeat=\"item in vm.openCashiers\" \nvalue=\"{{item.id}}\">{{item.professional}}</md-option></md-select></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72\">\n{{vm.giftcard.total | currency : \'R$ \' : 2}}</div><div class=\"h3 secondary-text font-weight-500\">Gratuidade</div></div>\n<div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\">Comandas fechadas no(s) caixa(s) aberto(s)</span></div></ms-widget-front>\n</ms-widget></div></div></div>");
$templateCache.put("app/main/finance/reportCashier.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Financeiro</span></div><div \nclass=\"title\">Checklist Caixa</div></div><div layout=\"row\" layout-align=\"start center\"><div style=\"width:140px\">\n<md-datepicker md-placeholder=\"Data\" \nstyle=\"width:100%;margin-left:0px;margin-top:-10px;font-weight:bolder;color:white\" ng-change=\"vm.reloadChecklist()\" \nng-model=\"vm.selectedDate\" md-is-open=\"vm.isOpen\"></md-datepicker><md-button class=\"md-raised\" \nstyle=\"margin-top:-58px;width:140px;margin-left:0px\" aria-label=\"Previous\" ng-click=\"vm.isOpen = true\" translate \ntranslate-attr-aria-label=\"CALENDAR.DATE\">{{vm.selectedDate | date:\'dd/MM/yyyy\'}}</md-button></div><md-button \nclass=\"md-raised\" ng-click=\"vm.validateCashiers()\">Validar Caixa do Dia</md-button></div></div><div class=\"content\" \nlayout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\"><div layout=\"column\" style=\"width: 400px\"><span>\nTotal de Serviços Vendidos - R$ {{vm.totalServiceSale}}</span> <span>\nTotal de Pacotes Vendidos - R$ {{vm.totalServicePackSale}}</span> <span>\nTotal de Produtos Vendidos - R$ {{vm.totalProductSale}}</span> <strong>\nTotal de Vendas no Dia - R$ {{vm.totalServiceSale + vm.totalProductSale}}</strong><br><span>\nCreditos/Debitos de Clientes - R$ {{vm.totalCreditoDebito}}</span> <span>Descontos - R$ {{vm.totalDiscount}}</span> \n<strong>Valor recebido - R$ {{vm.totalPaid}}</strong><br><span>\nEntrada em Dinheiro (Informado pelo operadores) - R$ {{vm.totalCashCashier}}</span> <span>\nEntrada em Credito (Informado pelo operadores) - R$ {{vm.totalCreditCashier}}</span> <span>\nEntrada em Debito (Informado pelo operadores) - R$ {{vm.totalDebitCashier}}</span> <strong>\nTotal Informado pelos Operadores - R$ {{vm.totalCashCashier + vm.totalCreditCashier + vm.totalDebitCashier}}</strong>\n<br><span>Dinheiro (registrado pelo sistema) - R$ {{vm.totalPaidCash}}</span> <span>\nCartão de crédito (registrado pelo sistema) - R$ {{vm.totalPaidCredit}}</span> <span>\nCartão de débito (registrado pelo sistema) - R$ {{vm.totalPaidDebit}}</span> <strong>\nTotal Credito/Debito - R$ {{vm.totalPaidCredit + vm.totalPaidDebit}}</strong> <strong>\nTotal Credito/Debito/Dinheiro registrado pelo Sistema - R$ {{vm.totalPaidCredit + vm.totalPaidDebit + vm.totalPaidCash}}\n</strong><br><strong>\nFalta/Sobra de Caixa - {{(vm.totalPaidCredit + vm.totalPaidDebit + vm.totalPaidCash) - (vm.totalCashCashier + vm.totalCreditCashier + vm.totalDebitCashier)}}\n</strong></div></div></div></div>");
$templateCache.put("app/main/finance/tefTransactions.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">WoWee Pay\n</div><br>Vendas - Powered by Zoop</div><div layout=\"row\" layout-align=\"start center\"></div></div><div class=\"content\" \nid=\"printArea\"><md-content class=\"content\" flex ng-if=\"!vm.showTable\"><br><span \nstyle=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></md-content><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Id. Transação</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Dt. Venda</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Meio de Pagamento</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Valor</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"></span></div></th></tr></thead><tbody><tr \nng-repeat=\"item in vm.items\"><td>{{item.idZoop}}</td><td>{{item.dataVenda | date : \'dd/MM/yyyy HH:mm:ss\'}}</td><td>\n{{item.status}}</td><td>{{item.meioPagamento}}</td><td>{{item.valorBruto | currency : \'R$ \': 2}}</td><td \nng-if=\"item.status==\'Aprovada\'\"><md-button class=\"md-raised md-warn gp-mini\" \nng-click=\"vm.estornarTransacao(item.idZoop)\"><md-tooltip aria-label=\"Pencil\">Desfazer Transação</md-tooltip><i \nclass=\"icon-trash\" layout=\"center\"></i></md-button></td><td ng-if=\"item.status!=\'Aprovada\'\"></td></tr></tbody></table>\n</div></div><md-sidenav class=\"md-sidenav-right\" md-component-id=\"filter\" md-is-locked-open=\"false\" md-whiteframe=\"4\">\n<md-toolbar class=\"md-hue-2\"><div class=\"md-toolbar-tools\"><h2>{{\'GENERAL.FILTER\' | translate}}</h2><span flex></span>\n<md-button class=\"md-raised md-orange-500-bg\" aria-label=\"Refresh\" ng-click=\"vm.refresh()\">\n{{\'GENERAL.REFRESH\'|translate}}</md-button></div></md-toolbar><md-content layout-padding style=\"overflow-x:scroll\">\n<md-subheader style=\"margin-left: -20px\">Período</md-subheader><div layout=\"row\" style=\"margin-top: -20px\"><span \nstyle=\"margin-left: 10px\">{{\'GENERAL.FROM\'|translate}}<md-datepicker ng-model=\"vm.filter.dtFrom\"></md-datepicker>\n</span></div><div layout=\"row\" style=\"margin-top: -10px\"><span style=\"margin-left: 10px\">{{\'GENERAL.TO\'|translate}}\n<md-datepicker ng-model=\"vm.filter.dtTo\"></md-datepicker></span></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/customer/customer.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'CUSTOMER.HEADER\' | translate }}</span></div><div class=\"title\">{{ \'CUSTOMER.HEADER\' | translate }}</div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised gp-mini\" ng-click=\"showHelp(\'newCustomer\');\">?\n<md-tooltip aria-label=\"Pencil\">Vídeo Explicativo</md-tooltip></md-button></div></div><div class=\"content\" \nlayout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" \nng-submit=\"vm.saveCustomer()\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"CUSTOMER.FIELDS.NAME\"></label><input type=\"text\" name=\"name\" ng-model=\"vm.customer.name\" required \ndata-intro=\"Entre o nome do cliente\" data-step=\"1\" data-disable-interaction=\"false\"><div \nng-messages=\"basicForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'CUSTOMER.VALIDATION.NAME_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container flex>\n<label translate=\"CUSTOMER.FIELDS.TELEPHONE\"></label><input type=\"text\" name=\"telephone\" \nng-model=\"vm.customer.telephone\" ng-required=\"true\" \ndata-intro=\"Informe o celular do cliente. Atenção é importante informar o celular com o DDD para que o sistema possa enviar SMS para esse cliente.\" \ndata-step=\"2\" ng-pattern=\"/^[1-9]{2}[1-9][0-9]{7,8}$/\"><div ng-messages=\"basicForm.telephone.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{ \'CUSTOMER.VALIDATION.TELEPHONE_REQUIRED\' | translate }}</span></div><div \nng-message=\"pattern\"><span>Telefone Inválido</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"CUSTOMER.FIELDS.EMAIL\"></label><input type=\"text\" name=\"email\" ng-model=\"vm.customer.email\">\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex ng-if=\"false\"><label \ntranslate=\"CUSTOMER.FIELDS.CPF\"></label><input type=\"text\" name=\"cpf\" ng-model=\"vm.customer.cpf\"></md-input-container>\n<md-input-container flex><label translate=\"CUSTOMER.FIELDS.BIRTHDAY.DAY\"></label><md-select \nng-model=\"vm.customer.birthdayDay\"><md-option ng-value=\"1\">1</md-option><md-option ng-value=\"2\">2</md-option><md-option\n ng-value=\"3\">3</md-option><md-option ng-value=\"4\">4</md-option><md-option ng-value=\"5\">5</md-option><md-option \nng-value=\"6\">6</md-option><md-option ng-value=\"7\">7</md-option><md-option ng-value=\"8\">8</md-option><md-option \nng-value=\"9\">9</md-option><md-option ng-value=\"10\">10</md-option><md-option ng-value=\"11\">11</md-option><md-option \nng-value=\"12\">12</md-option><md-option ng-value=\"13\">13</md-option><md-option ng-value=\"14\">14</md-option><md-option \nng-value=\"15\">15</md-option><md-option ng-value=\"16\">16</md-option><md-option ng-value=\"17\">17</md-option><md-option \nng-value=\"18\">18</md-option><md-option ng-value=\"19\">19</md-option><md-option ng-value=\"20\">20</md-option><md-option \nng-value=\"21\">21</md-option><md-option ng-value=\"22\">22</md-option><md-option ng-value=\"23\">23</md-option><md-option \nng-value=\"24\">24</md-option><md-option ng-value=\"25\">25</md-option><md-option ng-value=\"26\">26</md-option><md-option \nng-value=\"27\">27</md-option><md-option ng-value=\"28\">28</md-option><md-option ng-value=\"29\">29</md-option><md-option \nng-value=\"30\">30</md-option><md-option ng-value=\"31\">31</md-option></md-select></md-input-container><md-input-container\n flex><label translate=\"CUSTOMER.FIELDS.BIRTHDAY.MONTH\"></label><md-select ng-model=\"vm.customer.birthdayMonth\">\n<md-option ng-value=\"1\">Janeiro</md-option><md-option ng-value=\"2\">Fevereiro</md-option><md-option ng-value=\"3\">Março\n</md-option><md-option ng-value=\"4\">Abril</md-option><md-option ng-value=\"5\">Maio</md-option><md-option ng-value=\"6\">\nJunho</md-option><md-option ng-value=\"7\">Julho</md-option><md-option ng-value=\"8\">Agosto</md-option><md-option \nng-value=\"9\">Setembro</md-option><md-option ng-value=\"10\">Outubro</md-option><md-option ng-value=\"11\">Novembro\n</md-option><md-option ng-value=\"12\">Dezembro</md-option></md-select></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex ng-if=\"true\"><md-checkbox name=\"enableSMS\" \nng-model=\"vm.customer.enableSMS\"></md-checkbox><span>{{\'CUSTOMER.FIELDS.ENABLE_SMS\' | translate}}</span>\n</md-input-container><md-input-container flex ng-if=\"true\"><md-checkbox name=\"enableSMS\" \nng-model=\"vm.customer.enableEmail\"></md-checkbox><span>{{\"CUSTOMER.FIELDS.ENABLE_EMAIL\"|translate}}</span>\n</md-input-container><md-input-container flex><label translate=\"CUSTOMER.FIELDS.KNOWUS\"></label><md-select \nng-model=\"vm.customer.knowUs\"><md-option value=\"FACEBOOK\">Facebook</md-option><md-option value=\"GOOGLE\">Google\n</md-option><md-option value=\"MAGAZINE\">Revista</md-option><md-option value=\"FRIEND\">Indicação</md-option><md-option \nvalue=\"LOCAL\">Passo sempre aqui</md-option><md-option value=\"OTHER\">Outros</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"CUSTOMER.FIELDS.PARTNERSHIP\"></label><md-select \nng-model=\"vm.customer.partnershipId\"><md-option ng-value=\"item._id\" ng-repeat=\"item in vm.partnerships\">{{item.name}}\n</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex>\n<md-radio-group ng-model=\"vm.customer.gender\"><md-radio-button value=\"female\">{{ \'GENERAL.WOMAN\' | translate }}\n</md-radio-button><md-radio-button value=\"male\">{{ \'GENERAL.MAN\' | translate }}</md-radio-button></md-radio-group>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"CUSTOMER.FIELDS.OBSERVATION\"></label><input type=\"text\" name=\"text\" ng-model=\"vm.customer.observation\">\n</md-input-container></div><md-button type=\"submit\" class=\"md-raised\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid || vm.loading\">{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button><md-button \ntype=\"button\" class=\"md-raised md-warn\" aria-label=\"Cancel\" ui-sref=\"app.customer.list\">\n{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/customer/customerDialog.html","<md-dialog aria-label=\"New Customer\" style=\"width: 600px; height:400px\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{ \'CUSTOMER.NEW\' | translate }}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"GENERAL.DIALOG.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><form name=\"basicForm\" class=\"md-inline-form\" \nng-submit=\"vm.saveCustomerDialog()\" novalidate style=\"padding: 30px\"><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"CUSTOMER.FIELDS.NAME\"></label><input type=\"text\" name=\"name\" \nng-model=\"vm.customer.name\" md-autofocus=\"true\" ng-disabled=\"vm.customer._id!=undefined\" required><div \nng-messages=\"basicForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'CUSTOMER.VALIDATION.NAME_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container flex>\n<label translate=\"CUSTOMER.FIELDS.TELEPHONE\"></label><input type=\"text\" name=\"telephone\" \nng-model=\"vm.customer.telephone\" required ng-pattern=\"/^[1-9]{2}[1-9][0-9]{7,8}$/\"><div \nng-messages=\"basicForm.telephone.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'CUSTOMER.VALIDATION.TELEPHONE_REQUIRED\' | translate }}</span></div><div ng-message=\"pattern\"><span>\nTelefone Inválido</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"CUSTOMER.FIELDS.EMAIL\"></label><input type=\"email\" name=\"email\" \nng-model=\"vm.customer.email\"></md-input-container><md-input-container flex><label \ntranslate=\"CUSTOMER.FIELDS.BIRTHDAY.DAY\"></label><md-select ng-model=\"vm.customer.birthdayDay\"><md-option ng-value=\"1\">\n1</md-option><md-option ng-value=\"2\">2</md-option><md-option ng-value=\"3\">3</md-option><md-option ng-value=\"4\">4\n</md-option><md-option ng-value=\"5\">5</md-option><md-option ng-value=\"6\">6</md-option><md-option ng-value=\"7\">7\n</md-option><md-option ng-value=\"8\">8</md-option><md-option ng-value=\"9\">9</md-option><md-option ng-value=\"10\">10\n</md-option><md-option ng-value=\"11\">11</md-option><md-option ng-value=\"12\">12</md-option><md-option ng-value=\"13\">13\n</md-option><md-option ng-value=\"14\">14</md-option><md-option ng-value=\"15\">15</md-option><md-option ng-value=\"16\">16\n</md-option><md-option ng-value=\"17\">17</md-option><md-option ng-value=\"18\">18</md-option><md-option ng-value=\"19\">19\n</md-option><md-option ng-value=\"20\">20</md-option><md-option ng-value=\"21\">21</md-option><md-option ng-value=\"22\">22\n</md-option><md-option ng-value=\"23\">23</md-option><md-option ng-value=\"24\">24</md-option><md-option ng-value=\"25\">25\n</md-option><md-option ng-value=\"26\">26</md-option><md-option ng-value=\"27\">27</md-option><md-option ng-value=\"28\">28\n</md-option><md-option ng-value=\"29\">29</md-option><md-option ng-value=\"30\">30</md-option><md-option ng-value=\"31\">31\n</md-option></md-select></md-input-container><md-input-container flex><label \ntranslate=\"CUSTOMER.FIELDS.BIRTHDAY.MONTH\"></label><md-select ng-model=\"vm.customer.birthdayMonth\"><md-option \nng-value=\"1\">Janeiro</md-option><md-option ng-value=\"2\">Fevereiro</md-option><md-option ng-value=\"3\">Março</md-option>\n<md-option ng-value=\"4\">Abril</md-option><md-option ng-value=\"5\">Maio</md-option><md-option ng-value=\"6\">Junho\n</md-option><md-option ng-value=\"7\">Julho</md-option><md-option ng-value=\"8\">Agosto</md-option><md-option ng-value=\"9\">\nSetembro</md-option><md-option ng-value=\"10\">Outubro</md-option><md-option ng-value=\"11\">Novembro</md-option><md-option\n ng-value=\"12\">Dezembro</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nng-if=\"false\"><md-input-container flex><md-checkbox name=\"enableSMS\" ng-model=\"vm.customer.enableSMS\"></md-checkbox>\n<span>{{\'CUSTOMER.FIELDS.ENABLE_SMS\' | translate}}</span></md-input-container><md-input-container flex><md-checkbox \nname=\"enableSMS\" ng-model=\"vm.customer.enableEmail\"></md-checkbox><span>{{\"CUSTOMER.FIELDS.ENABLE_EMAIL\"|translate}}\n</span></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><md-radio-group \nng-model=\"vm.customer.gender\"><md-radio-button value=\"female\">{{ \'GENERAL.WOMAN\' | translate }}</md-radio-button>\n<md-radio-button value=\"male\">{{ \'GENERAL.MAN\' | translate }}</md-radio-button></md-radio-group></md-input-container>\n</div><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">\n{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button></form></md-dialog>");
$templateCache.put("app/main/customer/customerPanel.html","<md-dialog aria-label=\"Checkin\" style=\"width: 800px; height:400px\"><form name=\"basicForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Checkin Expresso</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"close()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-autocomplete ng-if=\"false\" flex required \nstyle=\"height:65px;margin-top:10px;margin-left:10px;font-size:12px\" ng-disabled=\"false\" md-input-name=\"customerId\" \nmd-input-id=\"customer-input\" md-autofocus=\"true\" md-input-minlength=\"3\" md-no-cache=\"true\" \nmd-selected-item=\"vm.customer\" md-search-text=\"vm.customerSearchText\" \nmd-items=\"item in vm.customerSearchTextChange(vm.customerSearchText)\" md-item-text=\"item.name\" \nplaceholder=\"Informe o nome ou telefone do cliente\" ng-attr-md-floating-label=\"Cliente\" md-require-match \nng-keydown=\"vm.changeFocusToService($event);\"><md-item-template><span md-highlight-text=\"vm.customerNameSearchText\" \nstyle=\"font-size:12px\">{{item.name + \' - \' + item.telephone}}</span></md-item-template></md-autocomplete><div \nstyle=\"width:100%;font-size:13px\" ng-if=\"vm.schedules.length > 0 && vm.processing == false\"><table style=\"width:100%\">\n<tr><td><strong>Data/Hora</strong></td><td><strong>Serviço</strong></td><td><strong>Profissional</strong></td><td></td>\n</tr><tr ng-repeat=\"item in vm.schedules\"><td>{{item.when | date : \'dd/MM/yyyy HH:mm\'}}</td><td>{{item.serviceName}}\n</td><td>{{item.professionalName}}</td><td><md-button ng-click=\"vm.checkinRequest(item._id)\" \nng-disabled=\"item.status == \'CHECKIN\'\">Checkin</md-button><md-button ng-click=\"vm.cancelRequest(item._id)\">Cancelar\n</md-button></td></tr></table></div><div style=\"width:100%;font-size:13px\" \nng-if=\"vm.schedules.length == 0 && vm.processing == false\">\nOps, não encontramos agendamentos pendentes para esse cliente.</div><div \nstyle=\"width:100%;font-size:13px;font-weight:bolder;left-margin:20px\" ng-if=\"vm.processing == true\">\nBuscando agendamentos...</div></form></md-dialog>");
$templateCache.put("app/main/customer/history.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-cloak><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\">\n</md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\"><a \nstyle=\"color:black\" href=\"/customer/list\">{{ \'CUSTOMER.HEADER\' | translate }}</a></span></div><div class=\"title\">\n{{ vm.customerName }}</div></div></div><div class=\"content\"><div class=\"white-bg md-whiteframe-40dp\" layout=\"row\" \nlayout-align=\"center center\" height=\"100px\" ng-show=\"!vm.showTable\"><br><span \nstyle=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></div><md-tabs md-dynamic-height \nmd-border-bottom ng-show=\"vm.showTable\"><md-tab label=\"Serviços Contratados\"><div class=\"white-bg md-whiteframe-4dp\">\n<table datatable=\"\" dt-options=\"vm.dtOptionsHistory\" dt-columns=\"vm.dtColumnsHistory\" class=\"row-border hover\"></table>\n</div></md-tab><md-tab label=\"Produtos Comprados\"><div class=\"white-bg md-whiteframe-4dp\"><table datatable=\"\" \ndt-options=\"vm.dtOptionsHistoryProduct\" dt-columns=\"vm.dtColumnsHistoryProduct\" class=\"row-border hover\"></table></div>\n</md-tab><md-tab label=\"Conta Corrente\"><div class=\"white-bg md-whiteframe-4dp\"><table datatable=\"\" \ndt-options=\"vm.dtOptionsTransactions\" dt-columns=\"vm.dtColumnsTransactions\" class=\"row-border hover\"></table></div>\n</md-tab><md-tab label=\"Agendamentos\"><div class=\"white-bg md-whiteframe-4dp\"><table datatable=\"\" \ndt-options=\"vm.dtOptionsSchedules\" dt-columns=\"vm.dtColumnsSchedules\" class=\"row-border hover\"></table></div></md-tab>\n</md-tabs></div></div>");
$templateCache.put("app/main/customer/inventory.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'CUSTOMER.HEADER\' | translate }}</span></div><div class=\"title\">{{ \'CUSTOMER.INVENTORY.HEADER\' | translate }}</div>\n</div></div><div class=\"content\"><div class=\"white-bg md-whiteframe-40dp\" layout=\"row\" layout-align=\"center center\" \nheight=\"100px\" ng-show=\"!vm.showTable\"><br><span style=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span>\n</div><div class=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'CUSTOMER.INVENTORY.NAME\' | translate }}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'CUSTOMER.INVENTORY.DATE_CREATED\' | translate }}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'CUSTOMER.INVENTORY.DATE_USED\' | translate }}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'CUSTOMER.INVENTORY.STATUS\' | translate }}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">Observação</span></div></th><th>&nbsp;</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.items\"><td>{{ item.serviceName }}</td><td>{{ item.dateCreated | date:\'dd/MM/yyyy\' }}</td><td>\n{{ item.dateUsed | date:\'dd/MM/yyyy\' }}</td><td>{{ \'GENERAL.\' + item.status | translate }}</td><td>\n{{ item.observation }}</td><td align=\"right\"><md-button ng-if=\"item.status == \'NOT_USED\'\" aria-label=\"Trash\" \nclass=\"md-raised md-warn gp-mini\" ng-click=\"vm.removeInventoryItem(item.id)\" ng-show=\"user.type!=\'MASTER\'\"><md-tooltip \naria-label=\"Pencil\">{{ \'GENERAL.HINTS.TRASH\' | translate }}</md-tooltip><i class=\"icon-trash\" layout=\"center\"></i>\n</md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/customer/list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-cloak><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\">\n</md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'CUSTOMER.HEADER\' | translate }}</span></div><div class=\"title\">{{ \'CUSTOMER.HEADER\' | translate }}</div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised\" ui-sref=\"app.customer.new\">\n{{ \'CUSTOMER.NEW\' | translate }}</md-button></div></div><div class=\"content\"><div class=\"white-bg md-whiteframe-40dp\" \nlayout=\"row\" layout-align=\"center center\" height=\"100px\" ng-show=\"!vm.showTable\"><br><span \nstyle=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></div><div class=\"white-bg md-whiteframe-4dp\" \nng-show=\"vm.showTable\"><table datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" \nclass=\"row-border hover\"></table></div></div></div>");
$templateCache.put("app/main/professional/advance.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'FINANCE.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'FINANCE.PROFESSIONAL_ADVANCE.HEADER\' | translate }}</span></div><div class=\"title\">\n{{ \'FINANCE.PROFESSIONAL_ADVANCE.HEADER\' | translate }}</div></div><div layout=\"row\" layout-align=\"start center\"></div>\n</div><div class=\"content\" layout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.saveProfessionalAdvance()\" novalidate><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"FINANCE.PROFESSIONAL_ADVANCE.FIELDS.PROFESSIONAL\"></label><md-select \nng-model=\"vm.advance.professionalId\" name=\"professional\" required><md-option ng-repeat=\"item in vm.professionals\" \nng-value=\"item._id\">{{item.name}}</md-option></md-select><div ng-messages=\"basicForm.professional.$error\" \nng-if=\"basicForm.professional.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'FINANCE.PROFESSIONAL_ADVANCE.VALIDATION.NAME_REQUIRED\' | translate }}</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"FINANCE.PROFESSIONAL_ADVANCE.FIELDS.VALUE\"></label><input type=\"number\" \nname=\"valor\" ng-model=\"vm.advance.value\" required><div ng-messages=\"basicForm.valor.$error\" \nng-if=\"basicForm.valor.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'FINANCE.PROFESSIONAL_ADVANCE.VALIDATION.VALUE_REQUIRED\' | translate }}</span></div></div></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-top:-70px;margin-left:-10px\"><md-input-container>\n<md-datepicker ng-model=\"vm.advance.when\" name=\"date\" md-placeholder=\"Date\" aria-label=\"Data\" required></md-datepicker>\n<div ng-messages=\"basicForm.date.$error\" ng-if=\"basicForm.date.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'FINANCE.PROFESSIONAL_ADVANCE.VALIDATION.DATE_REQUIRED\' | translate }}</span></div></div></md-input-container></div>\n<div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"FINANCE.PROFESSIONAL_ADVANCE.FIELDS.OBSERVATION\"></label><input type=\"text\" name=\"observation\" \nng-model=\"vm.advance.observation\" required><div ng-messages=\"basicForm.observation.$error\" \nng-if=\"basicForm.observation.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'FINANCE.PROFESSIONAL_ADVANCE.VALIDATION.OBSERVATION_REQUIRED\' | translate }}</span></div></div>\n</md-input-container></div><md-button type=\"submit\" class=\"md-raised\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid\">{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button><md-button type=\"button\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\" \nui-sref=\"app.professional.advance.list({professionalId:vm.professionalId})\">{{ \'GENERAL.BUTTON.CANCEL\' | translate }}\n</md-button></form></div></div></div>");
$templateCache.put("app/main/professional/advanceList.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'FINANCE.HEADER\' | translate }}</span></div><span class=\"title\">\n{{ \'FINANCE.PROFESSIONAL_ADVANCE.HEADER\' | translate }}</span></div><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-raised\" ui-sref=\"app.professional.advance.new({professionalId : vm.professionalId})\">\n{{ \'FINANCE.PROFESSIONAL_ADVANCE.NEW\' | translate }}</md-button></div></div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-40dp\" layout=\"row\" layout-align=\"center center\" height=\"100px\" ng-show=\"!vm.showTable\">\n<br><span style=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></div><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'FINANCE.PROFESSIONAL_ADVANCE.FIELDS.PROFESSIONAL\' | translate }}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'FINANCE.PROFESSIONAL_ADVANCE.FIELDS.VALUE\' | translate }}</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'FINANCE.PROFESSIONAL_ADVANCE.FIELDS.DATE\' | translate }}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'FINANCE.PROFESSIONAL_ADVANCE.FIELDS.OBSERVATION\' | translate }}\n</span></div></th><th></th></tr></thead><tbody><tr ng-repeat=\"payment in vm.payments\"><td>\n{{ payment.professionalName }}</td><td>{{ payment.value | currency: \'R$\' }}</td><td>\n{{ payment.when | date:\'dd/MM/yyyy\' }}</td><td>{{ payment.observation }}</td><td align=\"right\"><md-button \naria-label=\"Pencil\" class=\"md-raised gp-mini\" ng-click=\"vm.editProfessionalAdvance(payment.id)\"><md-tooltip \naria-label=\"Pencil\">{{ \'GENERAL.HINTS.EDIT\' | translate }}</md-tooltip><i class=\"icon-pencil\" layout=\"center\"></i>\n</md-button><md-button aria-label=\"Trash\" class=\"md-raised md-warn gp-mini\" \nng-click=\"vm.removeProfessionalAdvance(payment.id)\"><md-tooltip aria-label=\"Pencil\">\n{{ \'GENERAL.HINTS.TRASH\' | translate }}</md-tooltip><i class=\"icon-trash\" layout=\"center\"></i></md-button></td></tr>\n</tbody></table></div></div></div>");
$templateCache.put("app/main/professional/block.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'SETTINGS.SERVICE.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator\"></md-icon><span class=\"parent\">{{ \'SETTINGS.SERVICE.PROFESSIONAL.HEADER\' | translate }}</span>\n<md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>{{vm.professional.name}}</div><div \nclass=\"title\">{{ \'SETTINGS.SERVICE.PROFESSIONAL.BLOCK.HEADER\' | translate }}</div></div><div layout=\"row\" \nlayout-align=\"start center\"></div></div><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" \nng-submit=\"vm.saveBlockProfessional()\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex>\n<label translate=\"SETTINGS.SERVICE.PROFESSIONAL.BLOCK.REASON\"></label><input type=\"text\" name=\"name\" \nng-model=\"vm.block.reason\" required><div ng-messages=\"basicForm.name.$error\" ng-if=\"basicForm.name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>\n{{ \'SETTINGS.SERVICE.PROFESSIONAL.VALIDATION.NAME_REQUIRED\' | translate }}</span></div></div></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><md-radio-group ng-model=\"vm.block.type\">\n<md-radio-button data-value=\"PERIOD\">{{ \'SETTINGS.SERVICE.PROFESSIONAL.BLOCK.PERIOD\' | translate }}</md-radio-button>\n<br><md-radio-button data-value=\"EVERYDAY\">{{ \'SETTINGS.SERVICE.PROFESSIONAL.BLOCK.EVERYDAY\' | translate }}\n</md-radio-button><br><md-radio-button data-value=\"RECURSIVE_TIME\">\n{{ \'SETTINGS.SERVICE.PROFESSIONAL.BLOCK.RECURSIVE_TIME\' | translate }}</md-radio-button><br></md-radio-group>\n</md-input-container></div><div layout=\"row\" class=\"date-row\" ng-if=\"vm.block.type==\'PERIOD\'\"><label \ntranslate=\"SETTINGS.SERVICE.PROFESSIONAL.BLOCK.PERIODFROM\" flex></label><label \ntranslate=\"SETTINGS.SERVICE.PROFESSIONAL.BLOCK.PERIODTO\" flex></label></div><div layout=\"row\" class=\"date-row\" \nng-if=\"vm.block.type==\'PERIOD\'\"><md-input-container class=\"md-block\"><md-datepicker ng-model=\"vm.block.periodFromDate\" \nname=\"date\" md-placeholder=\"Date\" aria-label=\"Data\"></md-datepicker></md-input-container><md-input-container \nclass=\"no-errors-spacer\" flex md-no-float><md-select name=\"time\" ng-model=\"vm.block.periodFromTime\" \naria-label=\"Horario\"><md-option value=\"{{item.time}}\" ng-repeat=\"item in vm.timetable\">{{item.timeStr}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\"><md-datepicker ng-model=\"vm.block.periodToDate\" \nname=\"date\" md-placeholder=\"Date\" aria-label=\"Data\"></md-datepicker></md-input-container><md-input-container \nclass=\"no-errors-spacer\" flex md-no-float><md-select name=\"time\" ng-model=\"vm.block.periodToTime\" aria-label=\"Horario\">\n<md-option value=\"{{item.time}}\" ng-repeat=\"item in vm.timetable\">{{item.timeStr}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" class=\"date-row\" ng-if=\"vm.block.type==\'EVERYDAY\'\"><label \ntranslate=\"SETTINGS.SERVICE.PROFESSIONAL.BLOCK.PERIODFROM\" flex></label><label \ntranslate=\"SETTINGS.SERVICE.PROFESSIONAL.BLOCK.PERIODTO\" flex></label></div><div layout=\"row\" class=\"date-row\" \nng-if=\"vm.block.type==\'EVERYDAY\'\"><md-input-container class=\"no-errors-spacer\" flex md-no-float><md-select name=\"time\" \nng-model=\"vm.block.periodFromTime\" aria-label=\"Horario\"><md-option ng-value=\"item.time\" \nng-repeat=\"item in vm.timetable\">{{item.timeStr}}</md-option></md-select></md-input-container><md-input-container \nclass=\"no-errors-spacer\" flex md-no-float><md-select name=\"time\" ng-model=\"vm.block.periodToTime\" aria-label=\"Horario\">\n<md-option ng-value=\"item.time\" ng-repeat=\"item in vm.timetable\">{{item.timeStr}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" class=\"date-row\" ng-if=\"vm.block.type==\'RECURSIVE_TIME\'\"><label \ntranslate=\"SETTINGS.SERVICE.PROFESSIONAL.BLOCK.DAYOFWEEK\" flex>Dia da semana</label><label \ntranslate=\"SETTINGS.SERVICE.PROFESSIONAL.BLOCK.PERIODFROM\" flex></label><label \ntranslate=\"SETTINGS.SERVICE.PROFESSIONAL.BLOCK.PERIODTO\" flex></label></div><div layout=\"row\" class=\"date-row\" \nng-if=\"vm.block.type==\'RECURSIVE_TIME\'\"><md-input-container class=\"no-errors-spacer\" flex md-no-float><md-select \naria-label=\"weekday\" ng-model=\"vm.block.weekday\"><md-option data-value=\"monday\">\n{{ \'GENERAL.DAYOFWEEK.MONDAY\' | translate }}</md-option><md-option data-value=\"tuesday\">\n{{ \'GENERAL.DAYOFWEEK.TUESDAY\' | translate }}</md-option><md-option data-value=\"wednesday\">\n{{ \'GENERAL.DAYOFWEEK.WEDNESDAY\' | translate }}</md-option><md-option data-value=\"thursday\">\n{{ \'GENERAL.DAYOFWEEK.THURSDAY\' | translate }}</md-option><md-option data-value=\"friday\">\n{{ \'GENERAL.DAYOFWEEK.FRIDAY\' | translate }}</md-option><md-option data-value=\"saturday\">\n{{ \'GENERAL.DAYOFWEEK.SATURDAY\' | translate }}</md-option><md-option data-value=\"sunday\">\n{{ \'GENERAL.DAYOFWEEK.SUNDAY\' | translate }}</md-option></md-select></md-input-container><md-input-container \nclass=\"no-errors-spacer\" flex md-no-float><md-select name=\"time\" ng-model=\"vm.block.periodFromTime\" \naria-label=\"Horario\"><md-option value=\"{{item.time}}\" ng-repeat=\"item in vm.timetable\">{{item.timeStr}}</md-option>\n</md-select></md-input-container><md-input-container class=\"no-errors-spacer\" flex md-no-float><md-select name=\"time\" \nng-model=\"vm.block.periodToTime\" aria-label=\"Horario\"><md-option value=\"{{item.time}}\" \nng-repeat=\"item in vm.timetable\">{{item.timeStr}}</md-option></md-select></md-input-container></div><md-button \ntype=\"submit\" class=\"md-raised\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">\n{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button><md-button type=\"button\" class=\"md-raised md-warn\" \naria-label=\"Cancel\" ui-sref=\"app.professional.block.list({professionalId:vm.professionalId})\">\n{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/professional/blocklist.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'SETTINGS.SERVICE.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator\"></md-icon><a href=\"\" ui-sref=\"app.professional.list\" style=\"color:Black\"><span class=\"parent\">\n{{ \'SETTINGS.SERVICE.PROFESSIONAL.HEADER\' | translate }}</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator\"></md-icon>{{vm.professional.name}}</div><div class=\"title\">\n{{ \'SETTINGS.SERVICE.PROFESSIONAL.BLOCK.HEADER\' | translate }}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-raised\" \nui-sref=\"app.professional.block.new({professionalId : vm.professionalId})\">\n{{ \'SETTINGS.SERVICE.PROFESSIONAL.BLOCK.NEW\' | translate }}</md-button></div></div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-40dp\" layout=\"row\" layout-align=\"center center\" height=\"100px\" ng-show=\"!vm.showTable\">\n<br><span style=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></div><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'SETTINGS.SERVICE.PROFESSIONAL.BLOCK.REASON\' | translate }}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'SETTINGS.SERVICE.PROFESSIONAL.BLOCK.PERIOD\' | translate }}</span>\n</div></th><th></th></tr></thead><tbody><tr ng-repeat=\"block in ::vm.blockedSchedule\"><td>{{ block.reason }}</td><td>\n{{ block.period }}</td><td align=\"right\"><md-button aria-label=\"Trash\" class=\"md-raised md-warn gp-mini\" \nng-click=\"vm.removeProfessionalBlock(block._id)\"><md-tooltip aria-label=\"Pencil\">\n{{ \'GENERAL.HINTS.TRASH\' | translate }}</md-tooltip><i class=\"icon-trash\" layout=\"center\"></i></md-button></td></tr>\n</tbody></table></div></div></div>");
$templateCache.put("app/main/professional/changeMyInfo.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'SETTINGS.ACCOUNT.HEADER\' | translate }}</span></div><div class=\"title\">Minhas Informações\n</div></div></div><div class=\"content\" layout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\"><form \nname=\"basicForm\" class=\"md-inline-form\" ng-submit=\"vm.changeMyInfo()\" novalidate><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"SETTINGS.ACCOUNT.USER.FIELDS.NAME\"></label><input \ntype=\"text\" name=\"name\" ng-model=\"vm.name\" required><div ng-messages=\"basicForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{ \'SETTINGS.ACCOUNT.USER.VALIDATION.NAME_REQUIRED\' | translate }}</span></div></div>\n</md-input-container></div><md-button type=\"submit\" class=\"md-raised\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid\">{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/professional/changePassword.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'SETTINGS.ACCOUNT.HEADER\' | translate }}</span></div><div class=\"title\">Alterar Senha</div>\n</div></div><div class=\"content\" layout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.changePassword()\" novalidate><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label>Código de acesso</label><input type=\"text\" name=\"password\" \nng-model=\"vm.user.codigoAcesso\" readonly=\"readonly\" disabled=\"disabled\"></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"SETTINGS.ACCOUNT.USER.FIELDS.PASSWORD\">\n</label><input type=\"password\" name=\"password\" ng-model=\"vm.user.password\" required><div \nng-messages=\"basicForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'SETTINGS.ACCOUNT.USER.VALIDATION.PASSWORD_REQUIRED\' | translate }}</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"SETTINGS.ACCOUNT.USER.FIELDS.PASSWORD2\"></label><input type=\"password\" \nname=\"password2\" ng-model=\"vm.user.password2\" required ng-pattern=\"{{vm.user.password}}\"><div \nng-messages=\"basicForm.password2.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'SETTINGS.ACCOUNT.USER.VALIDATION.PASSWORD2_REQUIRED\' | translate }}</span></div><div ng-message=\"pattern\"><span>\n{{ \'SETTINGS.ACCOUNT.USER.VALIDATION.PASSWORD2_INVALID\' | translate }}</span></div></div></md-input-container></div>\n<md-button type=\"submit\" class=\"md-raised\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">\n{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/professional/inviteProfessional.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'SETTINGS.ACCOUNT.HEADER\' | translate }}</span></div><div class=\"title\">Convidar Profissional\n</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised gp-mini\" \nng-click=\"showHelp(\'user\');\">?<md-tooltip aria-label=\"Pencil\">Vídeo Explicativo</md-tooltip></md-button></div></div>\n<div class=\"content\" layout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\"><div layout=\"column\"><strong>\nComo convidar?</strong><br>\nPreencha no campo abaixo o e-mail ou o telefone (com DDD) do profissional que você deseja convidar. Essa pessoa irá receber em seu e-mail uma mensagem contendo um link para ela terminar o cadastro.\n<br></div></div></div><div class=\"content\" layout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\"><form \nname=\"basicForm\" class=\"md-inline-form\" ng-submit=\"vm.inviteProfessional()\" novalidate><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"SETTINGS.ACCOUNT.USER.FIELDS.EMAIL\"></label><input \ntype=\"text\" name=\"login\" ng-model=\"vm.user.email\" ng-required=\"!vm.user.telephone\" ng-change=\"vm.user.telephone = \'\'\">\n<div ng-messages=\"basicForm.login.$error\" role=\"alert\"><div ng-message=\"required\"><span>Email ou Telefone é obrigatório\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">OU</div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label>Telefone (com DDD ex. 2198121XXXX)</label><input type=\"text\" \nname=\"login\" ng-model=\"vm.user.telephone\" ng-required=\"!vm.user.email\" ng-change=\"vm.user.email = \'\'\"><div \nng-messages=\"basicForm.login.$error\" role=\"alert\"><div ng-message=\"required\"><span>Email ou Telefone é obrigatório\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"SETTINGS.ACCOUNT.USER.FIELDS.TYPE\"></label><md-select name=\"type\" ng-model=\"vm.user.type\" required=\"\">\n<md-option data-value=\"ADMIN\">{{ \'GENERAL.USERTYPES.ADMIN\' | translate }}</md-option><md-option \ndata-value=\"RECEPCIONIST\">{{ \'GENERAL.USERTYPES.RECEPCIONIST\' | translate }}</md-option><md-option \ndata-value=\"PROFESSIONAL\">{{ \'GENERAL.USERTYPES.PROFESSIONAL\' | translate }}</md-option></md-select><div \nng-messages=\"basicForm.type.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'SETTINGS.ACCOUNT.USER.VALIDATION.TYPE_REQUIRED\' | translate }}</span></div></div></md-input-container></div>\n<md-button type=\"submit\" class=\"md-raised\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">\n{{ \'GENERAL.BUTTON.INVITE\' | translate }}</md-button><md-button type=\"button\" class=\"md-raised md-warn\" \naria-label=\"Cancel\" ui-sref=\"app.settings.account.user.list\">{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button>\n</form></div></div></div>");
$templateCache.put("app/main/professional/list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span></div><div class=\"title\">\n{{ \'SETTINGS.SERVICE.PROFESSIONAL.HEADER\' | translate }}</div></div><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-raised\" ui-sref=\"app.professional.invite\">Convidar Profissional</md-button><md-button \nclass=\"md-raised gp-mini\" ng-click=\"showHelp(\'professionalList\');\">?<md-tooltip aria-label=\"Pencil\">Vídeo Explicativo\n</md-tooltip></md-button></div></div><div class=\"content\"><div class=\"white-bg md-whiteframe-40dp\" layout=\"row\" \nlayout-align=\"center center\" height=\"100px\" ng-show=\"!vm.showTable\"><br><span \nstyle=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></div><div class=\"white-bg md-whiteframe-4dp\" \nng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Nome</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Email</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Telefone</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Perfil</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th></th></tr>\n</thead><tbody><tr ng-repeat=\"employee in ::vm.professionals\"><td>{{ employee.name }}</td><td>{{ employee.email }}</td>\n<td>{{ employee.telephone }}</td><td><div ng-switch on=\"employee.security\"><span ng-switch-when=\"MASTER\">Master</span> \n<span ng-switch-when=\"RECEPCIONIST\">Recepcionista</span> <span ng-switch-when=\"PROFESSIONAL\">Profissional</span> <span \nng-switch-when=\"ADMIN\">Administrador</span></div></td><td>{{ employee.status }}</td><td align=\"right\"><md-button \naria-label=\"Pencil\" class=\"md-raised gp-mini\" ng-click=\"vm.goToEditProfessional(employee._id)\"><md-tooltip \naria-label=\"Pencil\">Editar</md-tooltip><i class=\"icon-pencil\" layout=\"center\"></i></md-button><md-button \naria-label=\"Trash\" ng-if=\"employee.security != \'MASTER\'\" class=\"md-raised md-warn gp-mini\" \nng-click=\"vm.removeProfessional(employee._id)\"><md-tooltip aria-label=\"Pencil\">{{ \'GENERAL.HINTS.TRASH\' | translate }}\n</md-tooltip><i class=\"icon-trash\" layout=\"center\"></i></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/professional/professional.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\" ng-cloak><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\">\n</md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><a\n href=\"\" ui-sref=\"app.professional.list\" style=\"color:Black\"><span class=\"parent\">\n{{ \'SETTINGS.SERVICE.PROFESSIONAL.HEADER\' | translate }}</span></a></div><div class=\"title\">\n{{ \'SETTINGS.SERVICE.PROFESSIONAL.HEADER\' | translate }}</div></div><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-raised gp-mini\" ng-click=\"showHelp(\'professional\');\">?<md-tooltip aria-label=\"Pencil\">\nVídeo Explicativo</md-tooltip></md-button></div></div><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" ms-horizontal-stepper ng-submit=\"vm.saveProfessional()\" \nng-model=\"vm.horizontalStepper\" novalidate><ms-horizontal-stepper-step ng-form=\"step1\" step=\"1\" \nstep-title=\"\'Informações Pessoais\'\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"SETTINGS.SERVICE.PROFESSIONAL.FIELDS.NAME\"></label><input type=\"text\" name=\"name\" \nng-model=\"vm.professional.name\" disabled=\"disabled\"><div ng-messages=\"basicForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{ \'SETTINGS.SERVICE.PROFESSIONAL.VALIDATION.NAME_REQUIRED\' | translate }}</span></div>\n</div></md-input-container><md-input-container flex><label translate=\"SETTINGS.SERVICE.PROFESSIONAL.FIELDS.EMAIL\">\n</label><input type=\"text\" name=\"email\" ng-model=\"vm.professional.email\" disabled=\"disabled\"><div \nng-messages=\"basicForm.email.$error\" role=\"alert\"><div ng-message=\"email\"><span>\n{{ \'SETTINGS.SERVICE.PROFESSIONAL.VALIDATION.EMAIL_FORMAT\' | translate }}</span></div></div></md-input-container></div>\n<div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"SETTINGS.SERVICE.PROFESSIONAL.FIELDS.TELEPHONE\"></label><input type=\"text\" name=\"telephone\" \nng-model=\"vm.professional.telephone\" disabled=\"disabled\"></md-input-container><md-input-container flex><label \ntranslate=\"SETTINGS.SERVICE.PROFESSIONAL.FIELDS.SCHEDULE_GROUP\"></label><input type=\"number\" name=\"scheduleGroup\" \nmin=\"0\" ng-model=\"vm.professional.scheduleGroup\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-checkbox aria-label=\"checkService\" ng-model=\"vm.professional.hasSchedule\">Possui Agenda</md-checkbox></div>\n</ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"step2\" step=\"2\" step-title=\"\'Serviços\'\">\n<md-subheader>Marque os serviços que este profissional está apto a executar</md-subheader><div layout=\"column\" \nstyle=\"margin-left:20px\" ng-repeat=\"category in vm.categories\"><div layout=\"row\"><span \nstyle=\"margin-left:0px;margin-top:15px;margin-right:10px\">{{category.name}}</span><md-button aria-label=\"Pencil\" \nclass=\"md-raised md-accent gp-mini\" ng-click=\"vm.clickCategory(category, true)\">Marcar Todos</md-button><md-button \naria-label=\"Pencil\" class=\"md-raised md-accent gp-mini\" ng-click=\"vm.clickCategory(category, false)\">Desmarcar Todos\n<md-checkbox aria-label=\"checkService\" ng-if=\"false\" style=\"font-size:16px\" \nmd-indeterminate=\"vm.categoryIndeterminate[category._id]\" ng-model=\"vm.chkCategory[category._id]\" \nng-click=\"vm.clickCategory(category)\">{{category.name}}</md-checkbox><br></md-button></div><div layout=\"row\" \nstyle=\"margin-top:-15px\"><md-input-container style=\"margin-left:100px;width:250px\"><label>% Profissional</label><input \ntype=\"number\" ng-change=\"vm.updateServiceValues(category._id)\" ng-model=\"vm.categoryComission[category._id]\"> <span \nstyle=\"font-size:12px;color:red\">Informe a comissao para alterar a comissao de todos os serviço pertencentes ao grupo\n</span></md-input-container><md-input-container style=\"margin-left:100px;width:250px\"><label>% Ajudante</label><input \ntype=\"number\" ng-change=\"vm.updateServiceValues(category._id)\" ng-model=\"vm.categoryComissionAjudante[category._id]\">\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" ng-repeat=\"service in category.services\" \nstyle=\"margin-left:60px;height:50px\"><md-checkbox style=\"font-size:16px\" ng-model=\"vm.chkService[service._id]\" \naria-label=\"servico\" ng-click=\"vm.clickService(category, service)\"></md-checkbox><div layout=\"row\" \nstyle=\"margin-left:4px;margin-top:-25px\"><div layout=\"column\" flex=\"50\"><md-input-container flex \nstyle=\"margin-left:10px;width:400px;font-size:15px\"><input type=\"text\" aria-label=\"service-name\" ng-disabled=\"true\" \nng-model=\"service.name\"></md-input-container></div><div layout=\"row\" flex=\"100\"><md-input-container flex \nng-if=\"vm.chkService[service._id]\" style=\"margin-left:150px\"><label>% Profissional</label><input type=\"number\" min=\"0\" \nname=\"{{\'comission_\' + service._id}}\" style=\"width:140px\" ng-model=\"vm.serviceComission[service._id]\" required><div \nng-messages=\"step2[\'comission_\' + service._id].$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'SETTINGS.SERVICE.PROFESSIONAL.VALIDATION.COMISSION_REQUIRED\' | translate }}</span></div></div></md-input-container>\n<md-input-container flex ng-if=\"vm.chkService[service._id]\" style=\"margin-left:50px\"><label>% Ajudante</label><input \ntype=\"number\" min=\"0\" name=\"{{\'comission_ajudante_\' + service._id}}\" style=\"width:100px\" \nng-model=\"vm.serviceComissionAjudante[service._id]\"></md-input-container></div></div></div></div>\n</ms-horizontal-stepper-step></form></div></div></div>");
$templateCache.put("app/main/professional/professional2.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\" ng-cloak><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\">\n</md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'SETTINGS.SERVICE.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator\"></md-icon><a href=\"\" ui-sref=\"app.professional.list\" style=\"color:Black\"><span class=\"parent\">\n{{ \'SETTINGS.SERVICE.PROFESSIONAL.HEADER\' | translate }}</span></a></div><div class=\"title\">\n{{ \'SETTINGS.SERVICE.PROFESSIONAL.HEADER\' | translate }}</div></div><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-raised gp-mini\" ng-click=\"showHelp(\'professional\');\">?<md-tooltip aria-label=\"Pencil\">\nVídeo Explicativo</md-tooltip></md-button></div></div><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" ms-horizontal-stepper ng-submit=\"vm.saveProfessional()\" \nng-model=\"vm.horizontalStepper\" novalidate><ms-horizontal-stepper-step ng-form=\"step1\" step=\"1\" step-title=\"\'Convite\'\">\n<div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"SETTINGS.SERVICE.PROFESSIONAL.FIELDS.EMAIL\"></label><input type=\"email\" name=\"email\" \nng-model=\"vm.professional.email\"><div ng-messages=\"basicForm.email.$error\" role=\"alert\"><div ng-message=\"email\"><span>\n{{ \'SETTINGS.SERVICE.PROFESSIONAL.VALIDATION.EMAIL_FORMAT\' | translate }}</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"SETTINGS.SERVICE.PROFESSIONAL.FIELDS.TELEPHOME\"></label><input type=\"tel\" \nname=\"telephone\" ng-model=\"vm.professional.telephone\"><div ng-messages=\"basicForm.telephone.$error\" role=\"alert\"><div \nng-message=\"telephone\"><span>{{ \'SETTINGS.SERVICE.PROFESSIONAL.VALIDATION.TELEPHONE_FORMAT\' | translate }}</span></div>\n</div></md-input-container></div></ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"step2\" step=\"2\" \nstep-title=\"\'Informações Pessoais\'\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"SETTINGS.SERVICE.PROFESSIONAL.FIELDS.EMAIL\"></label><input type=\"email\" name=\"email\" \nng-model=\"vm.professional.email\"><div ng-messages=\"basicForm.email.$error\" role=\"alert\"><div ng-message=\"email\"><span>\n{{ \'SETTINGS.SERVICE.PROFESSIONAL.VALIDATION.EMAIL_FORMAT\' | translate }}</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"SETTINGS.SERVICE.PROFESSIONAL.FIELDS.NAME\"></label><input type=\"text\" \nname=\"name\" ng-model=\"vm.professional.name\" required><div ng-messages=\"basicForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{ \'SETTINGS.SERVICE.PROFESSIONAL.VALIDATION.NAME_REQUIRED\' | translate }}</span></div>\n</div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"SETTINGS.SERVICE.PROFESSIONAL.FIELDS.TELEPHONE\"></label><input type=\"text\" name=\"telephone\" \nng-model=\"vm.professional.telephone\"></md-input-container><md-input-container flex><label \ntranslate=\"SETTINGS.SERVICE.PROFESSIONAL.FIELDS.SCHEDULE_GROUP\"></label><input type=\"number\" name=\"scheduleGroup\" \nmin=\"0\" ng-model=\"vm.professional.scheduleGroup\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"SETTINGS.ACCOUNT.USER.FIELDS.TYPE\"></label><md-select name=\"type\" \nng-model=\"vm.user.type\" required=\"\" ng-disabled=\"vm.user.id!=undefined || vm.user.type ==\'MASTER\'\"><md-option \ndata-value=\"ADMIN\">{{ \'GENERAL.USERTYPES.ADMIN\' | translate }}</md-option><md-option data-value=\"RECEPCIONIST\">\n{{ \'GENERAL.USERTYPES.RECEPCIONIST\' | translate }}</md-option><md-option data-value=\"PROFESSIONAL\">\n{{ \'GENERAL.USERTYPES.PROFESSIONAL\' | translate }}</md-option></md-select><div ng-messages=\"basicForm.type.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{ \'SETTINGS.ACCOUNT.USER.VALIDATION.TYPE_REQUIRED\' | translate }}</span>\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"SETTINGS.ACCOUNT.USER.FIELDS.PASSWORD\"></label><input type=\"password\" name=\"password\" \nng-model=\"vm.user.password\" required><div ng-messages=\"basicForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{ \'SETTINGS.ACCOUNT.USER.VALIDATION.PASSWORD_REQUIRED\' | translate }}</span></div></div>\n</md-input-container><md-input-container flex><label translate=\"SETTINGS.ACCOUNT.USER.FIELDS.PASSWORD2\"></label><input \ntype=\"password\" name=\"password2\" ng-model=\"vm.user.password2\" required ng-pattern=\"{{vm.user.password}}\"><div \nng-messages=\"basicForm.password2.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'SETTINGS.ACCOUNT.USER.VALIDATION.PASSWORD2_REQUIRED\' | translate }}</span></div><div ng-message=\"pattern\"><span>\n{{ \'SETTINGS.ACCOUNT.USER.VALIDATION.PASSWORD2_INVALID\' | translate }}</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"SETTINGS.ACCOUNT.USER.FIELDS.ACCESS_CODE\"></label><input type=\"password\" \nname=\"accessCode\" ng-model=\"vm.user.accessCode\"></md-input-container></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"step3\" step=\"3\" step-title=\"\'Serviços\'\"><md-subheader>\nMarque os serviços que este profissional está apto a executar</md-subheader><div layout=\"column\" \nstyle=\"margin-left:20px\" ng-repeat=\"category in vm.categories\"><div layout=\"row\"><span \nstyle=\"margin-left:0px;margin-top:15px;margin-right:10px\">{{category.name}}</span><md-button aria-label=\"Pencil\" \nclass=\"md-raised md-accent gp-mini\" ng-click=\"vm.clickCategory(category, true)\">Marcar Todos</md-button><md-button \naria-label=\"Pencil\" class=\"md-raised md-accent gp-mini\" ng-click=\"vm.clickCategory(category, false)\">Desmarcar Todos\n<md-checkbox ng-if=\"false\" style=\"font-size:16px\" md-indeterminate=\"vm.categoryIndeterminate[category._id]\" \nng-model=\"vm.chkCategory[category._id]\" ng-click=\"vm.clickCategory(category)\">{{category.name}}</md-checkbox><br>\n</md-button></div><div layout=\"row\" style=\"margin-top:-15px\"><md-input-container style=\"margin-left:100px;width:250px\">\n<label translate=\"SETTINGS.SERVICE.PROFESSIONAL.FIELDS.COMISSION\"></label><input type=\"number\" \nng-change=\"vm.updateServiceValues(category._id)\" ng-model=\"vm.categoryComission[category._id]\"> <span \nstyle=\"font-size:12px;color:red\">Informe a comissao para alterar a comissao de todos os serviço pertencentes ao grupo\n</span></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" ng-repeat=\"service in category.services\" \nstyle=\"margin-left:60px;height:50px\"><md-checkbox style=\"font-size:16px\" ng-model=\"vm.chkService[service._id]\" \nng-click=\"vm.clickService(category, service)\"></md-checkbox><div layout=\"row\" style=\"margin-left:4px;margin-top:-25px\">\n<div layout=\"column\" flex=\"50\"><md-input-container flex style=\"margin-left:10px;width:400px;font-size:15px\"><input \ntype=\"text\" aria-label=\"service-name\" ng-disabled=\"true\" ng-model=\"service.name\"></md-input-container></div><div \nlayout=\"row\" flex=\"50\"><md-input-container flex ng-if=\"vm.chkService[service._id]\" style=\"margin-left:150px\"><label \ntranslate=\"SETTINGS.SERVICE.PROFESSIONAL.FIELDS.COMISSION\"></label><input type=\"number\" min=\"1\" \nname=\"{{\'comission_\' + service._id}}\" style=\"width:100px\" ng-model=\"vm.serviceComission[service._id]\" required><div \nng-messages=\"step2[\'comission_\' + service._id].$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'SETTINGS.SERVICE.PROFESSIONAL.VALIDATION.COMISSION_REQUIRED\' | translate }}</span></div></div></md-input-container>\n</div></div></div></div></ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"step4\" step=\"4\" \nstep-title=\"\'Horários\'\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"GENERAL.DAYOFWEEK.MONDAY\"></label></md-input-container><md-input-container flex><md-radio-group \nng-model=\"vm.businessHours.workMonday\"><md-radio-button data-value=\"YES\" aria-label=\"YES\"><span \ntranslate=\"GENERAL.WORKYES\"></span></md-radio-button><md-radio-button data-value=\"NO\" aria-label=\"NO\"><span \ntranslate=\"GENERAL.WORKNO\"></span></md-radio-button></md-radio-group></md-input-container><md-input-container flex>\n<label translate=\"GENERAL.ENTERTIME\"></label><md-select name=\"openTimeMonday\" \nng-model=\"vm.businessHours.openTimeMonday\" ng-disabled=\"vm.businessHours.workMonday!=\'YES\'\"><md-option \nng-repeat=\"item in vm.timetable\" data-value=\"{{item.value}}\">{{item.text}}</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"GENERAL.LEAVETIME\"></label><md-select name=\"closeTimeMonday\" \nng-model=\"vm.businessHours.closeTimeMonday\" ng-disabled=\"vm.businessHours.workMonday!=\'YES\'\"><md-option \nng-repeat=\"item in vm.timetable\" data-value=\"{{item.value}}\">{{item.text}}</md-option></md-select></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"GENERAL.DAYOFWEEK.TUESDAY\">\n</label></md-input-container><md-input-container flex><md-radio-group ng-model=\"vm.businessHours.workTuesday\">\n<md-radio-button data-value=\"YES\" aria-label=\"YES\"><span translate=\"GENERAL.WORKYES\"></span></md-radio-button>\n<md-radio-button data-value=\"NO\" aria-label=\"NO\"><span translate=\"GENERAL.WORKNO\"></span></md-radio-button>\n</md-radio-group></md-input-container><md-input-container flex><label translate=\"GENERAL.ENTERTIME\"></label><md-select \nng-model=\"vm.businessHours.openTimeTuesday\" ng-disabled=\"vm.businessHours.workTuesday!=\'YES\'\"><md-option \nng-repeat=\"item in vm.timetable\" data-value=\"{{item.value}}\">{{item.text}}</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"GENERAL.LEAVETIME\"></label><md-select \nng-model=\"vm.businessHours.closeTimeTuesday\" ng-disabled=\"vm.businessHours.workTuesday!=\'YES\'\"><md-option \nng-repeat=\"item in vm.timetable\" data-value=\"{{item.value}}\">{{item.text}}</md-option></md-select></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"GENERAL.DAYOFWEEK.WEDNESDAY\">\n</label></md-input-container><md-input-container flex><md-radio-group ng-model=\"vm.businessHours.workWednesday\">\n<md-radio-button data-value=\"YES\" aria-label=\"YES\"><span translate=\"GENERAL.WORKYES\"></span></md-radio-button>\n<md-radio-button data-value=\"NO\" aria-label=\"NO\"><span translate=\"GENERAL.WORKNO\"></span></md-radio-button>\n</md-radio-group></md-input-container><md-input-container flex><label translate=\"GENERAL.ENTERTIME\"></label><md-select \nng-model=\"vm.businessHours.openTimeWednesday\" ng-disabled=\"vm.businessHours.workWednesday!=\'YES\'\"><md-option \nng-repeat=\"item in vm.timetable\" data-value=\"{{item.value}}\">{{item.text}}</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"GENERAL.LEAVETIME\"></label><md-select \nng-model=\"vm.businessHours.closeTimeWednesday\" ng-disabled=\"vm.businessHours.workWednesday!=\'YES\'\"><md-option \nng-repeat=\"item in vm.timetable\" data-value=\"{{item.value}}\">{{item.text}}</md-option></md-select></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"GENERAL.DAYOFWEEK.THURSDAY\">\n</label></md-input-container><md-input-container flex><md-radio-group ng-model=\"vm.businessHours.workThursday\">\n<md-radio-button data-value=\"YES\" aria-label=\"YES\"><span translate=\"GENERAL.WORKYES\"></span></md-radio-button>\n<md-radio-button data-value=\"NO\" aria-label=\"NO\"><span translate=\"GENERAL.WORKNO\"></span></md-radio-button>\n</md-radio-group></md-input-container><md-input-container flex><label translate=\"GENERAL.ENTERTIME\"></label><md-select \nng-model=\"vm.businessHours.openTimeThursday\" ng-disabled=\"vm.businessHours.workThursday!=\'YES\'\"><md-option \nng-repeat=\"item in vm.timetable\" data-value=\"{{item.value}}\">{{item.text}}</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"GENERAL.LEAVETIME\"></label><md-select \nng-model=\"vm.businessHours.closeTimeThursday\" ng-disabled=\"vm.businessHours.workThursday!=\'YES\'\"><md-option \nng-repeat=\"item in vm.timetable\" data-value=\"{{item.value}}\">{{item.text}}</md-option></md-select></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"GENERAL.DAYOFWEEK.FRIDAY\">\n</label></md-input-container><md-input-container flex><md-radio-group ng-model=\"vm.businessHours.workFriday\">\n<md-radio-button data-value=\"YES\" aria-label=\"YES\"><span translate=\"GENERAL.WORKYES\"></span></md-radio-button>\n<md-radio-button data-value=\"NO\" aria-label=\"NO\"><span translate=\"GENERAL.WORKNO\"></span></md-radio-button>\n</md-radio-group></md-input-container><md-input-container flex><label translate=\"GENERAL.ENTERTIME\"></label><md-select \nng-model=\"vm.businessHours.openTimeFriday\" ng-disabled=\"vm.businessHours.workFriday!=\'YES\'\"><md-option \nng-repeat=\"item in vm.timetable\" data-value=\"{{item.value}}\">{{item.text}}</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"GENERAL.LEAVETIME\"></label><md-select \nng-model=\"vm.businessHours.closeTimeFriday\" ng-disabled=\"vm.businessHours.workFriday!=\'YES\'\"><md-option \nng-repeat=\"item in vm.timetable\" data-value=\"{{item.value}}\">{{item.text}}</md-option></md-select></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"GENERAL.DAYOFWEEK.SATURDAY\">\n</label></md-input-container><md-input-container flex><md-radio-group ng-model=\"vm.businessHours.workSaturday\">\n<md-radio-button data-value=\"YES\" aria-label=\"YES\"><span translate=\"GENERAL.WORKYES\"></span></md-radio-button>\n<md-radio-button data-value=\"NO\" aria-label=\"NO\"><span translate=\"GENERAL.WORKNO\"></span></md-radio-button>\n</md-radio-group></md-input-container><md-input-container flex><label translate=\"GENERAL.ENTERTIME\"></label><md-select \nng-model=\"vm.businessHours.openTimeSaturday\" ng-disabled=\"vm.businessHours.workSaturday!=\'YES\'\"><md-option \nng-repeat=\"item in vm.timetable\" data-value=\"{{item.value}}\">{{item.text}}</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"GENERAL.LEAVETIME\"></label><md-select \nng-model=\"vm.businessHours.closeTimeSaturday\" ng-disabled=\"vm.businessHours.workSaturday!=\'YES\'\"><md-option \nng-repeat=\"item in vm.timetable\" data-value=\"{{item.value}}\">{{item.text}}</md-option></md-select></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"GENERAL.DAYOFWEEK.SUNDAY\">\n</label></md-input-container><md-input-container flex><md-radio-group ng-model=\"vm.businessHours.workSunday\">\n<md-radio-button data-value=\"YES\" aria-label=\"YES\"><span translate=\"GENERAL.WORKYES\"></span></md-radio-button>\n<md-radio-button data-value=\"NO\" aria-label=\"NO\"><span translate=\"GENERAL.WORKNO\"></span></md-radio-button>\n</md-radio-group></md-input-container><md-input-container flex><label translate=\"GENERAL.ENTERTIME\"></label><md-select \nng-model=\"vm.businessHours.openTimeSunday\" ng-disabled=\"vm.businessHours.workSunday!=\'YES\'\"><md-option \nng-repeat=\"item in vm.timetable\" data-value=\"{{item.value}}\">{{item.text}}</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"GENERAL.LEAVETIME\"></label><md-select \nng-model=\"vm.businessHours.closeTimeSunday\" ng-disabled=\"vm.businessHours.workSunday!=\'YES\'\"><md-option \nng-repeat=\"item in vm.timetable\" data-value=\"{{item.value}}\">{{item.text}}</md-option></md-select></md-input-container>\n</div></ms-horizontal-stepper-step></form></div></div></div>");
$templateCache.put("app/main/professional/relatedPDV.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-cloak><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\">\n</md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'SETTINGS.SERVICE.HEADER\' | translate }}</span></div><div class=\"title\">Salões Vinculados</div>\n</div><div layout=\"row\" layout-align=\"start center\"></div></div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-40dp\" layout=\"row\" layout-align=\"center center\" height=\"100px\" ng-show=\"!vm.showTable\">\n<br><span style=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></div><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nSalão</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Perfil</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Default</span></div></th><th></th></tr>\n</thead><tbody><tr ng-repeat=\"item in ::vm.pdvRelated\"><td>{{ item.pdvName }}</td><td>{{ item.security }}</td><td>\n{{ item.status }}</td><td ng-if=\"item.default==1\">X</td><td ng-if=\"item.default==0\"></td><td align=\"right\"><md-button \naria-label=\"Trash\" class=\"md-raised gp-mini\" ng-click=\"vm.setAsDefault(item.pdvId)\"><md-tooltip aria-label=\"Pencil\">\nDefault</md-tooltip><i class=\"icon-select-all\" layout=\"center\"></i></md-button><md-button aria-label=\"Trash\" \nng-if=\"item.security != \'MASTER\'\" class=\"md-raised md-warn gp-mini\" ng-click=\"vm.removeRelatedPDV(item.pdvId)\">\n<md-tooltip aria-label=\"Pencil\">{{ \'GENERAL.HINTS.TRASH\' | translate }}</md-tooltip><i class=\"icon-trash\" \nlayout=\"center\"></i></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/professional/service.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'SETTINGS.SERVICE.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator\"></md-icon><span class=\"parent\">{{ \'SETTINGS.SERVICE.PROFESSIONAL.HEADER\' | translate }}</span>\n<md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>{{vm.professional.name}}</div><div \nclass=\"title\">{{ \'SETTINGS.SERVICE.PROFESSIONAL.SERVICE.HEADER\' | translate }}</div></div><div layout=\"row\" \nlayout-align=\"start center\"></div></div><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" \nng-submit=\"vm.saveServiceProfessional()\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex>\n<md-radio-group ng-model=\"vm.serviceEnabled\"><md-radio-button data-value=\"YES\">\n{{ \'SETTINGS.SERVICE.PROFESSIONAL.SERVICE.ENABLED\' | translate }}</md-radio-button><md-radio-button data-value=\"NO\">\n{{ \'SETTINGS.SERVICE.PROFESSIONAL.SERVICE.DISABLED\' | translate }}</md-radio-button></md-radio-group>\n</md-input-container><md-input-container flex><label translate=\"SETTINGS.SERVICE.PROFESSIONAL.FIELDS.PRICE\"></label>\n<input type=\"number\" name=\"price\" ng-model=\"vm.price\" required ng-disabled=\"vm.serviceEnabled==\'NO\'\"><div \nng-messages=\"basicForm.price.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'SETTINGS.SERVICE.PROFESSIONAL.VALIDATION.PRICE_REQUIRED\' | translate }}</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"SETTINGS.SERVICE.PROFESSIONAL.FIELDS.COMISSION\"></label><input \ntype=\"number\" name=\"comission\" ng-model=\"vm.comission\" required ng-disabled=\"vm.serviceEnabled==\'NO\'\"><div \nng-messages=\"basicForm.comission.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'SETTINGS.SERVICE.PROFESSIONAL.VALIDATION.COMISSION_REQUIRED\' | translate }}</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"SETTINGS.SERVICE.PROFESSIONAL.FIELDS.TIME\"></label><md-select name=\"time\" \nng-model=\"vm.duration\" required=\"\" ng-disabled=\"vm.serviceEnabled==\'NO\'\"><md-option data-value=\"15\">15 minutos\n</md-option><md-option data-value=\"30\">30 minutos</md-option><md-option data-value=\"45\">45 minutos</md-option>\n<md-option data-value=\"60\">1 hora</md-option><md-option data-value=\"75\">1 hora e 15 minutos</md-option><md-option \ndata-value=\"90\">1 hora e 30 minutos</md-option><md-option data-value=\"105\">1 hora e 45 minutos</md-option><md-option \ndata-value=\"120\">2 horas</md-option><md-option data-value=\"135\">2 horas e 15 minutos</md-option><md-option \ndata-value=\"150\">2 horas e 30 minutos</md-option><md-option data-value=\"165\">2 horas e 45 minutos</md-option><md-option\n data-value=\"180\">3 horas</md-option><md-option data-value=\"195\">3 horas e 15 minutos</md-option><md-option \ndata-value=\"210\">3 horas e 30 minutos</md-option><md-option data-value=\"225\">3 horas e 45 minutos</md-option><md-option\n data-value=\"240\">4 horas</md-option><md-option data-value=\"255\">4 horas e 15 minutos</md-option><md-option \ndata-value=\"270\">4 horas e 30 minutos</md-option><md-option data-value=\"285\">4 horas e 45 minutos</md-option>\n</md-select><div ng-messages=\"basicForm.time.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'SETTINGS.SERVICE.PROFESSIONAL.VALIDATION.TIME_REQUIRED\' | translate }}</span></div></div></md-input-container>\n</div><md-button type=\"submit\" class=\"md-raised\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">\n{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button><md-button type=\"button\" class=\"md-raised md-warn\" \naria-label=\"Cancel\" ui-sref=\"app.professional.service.list({professionalId:vm.professionalId})\">\n{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/professional/servicelist.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'SETTINGS.SERVICE.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator\"></md-icon><a href=\"\" ui-sref=\"app.professional.list\" style=\"color:Black\"><span class=\"parent\">\n{{ \'SETTINGS.SERVICE.PROFESSIONAL.HEADER\' | translate }}</span></a><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator\"></md-icon>{{vm.professional.name}}</div><div class=\"title\">\n{{ \'SETTINGS.SERVICE.PROFESSIONAL.SERVICE.HEADER\' | translate }}</div></div><div layout=\"row\" \nlayout-align=\"start center\"></div></div><div class=\"content\"><div class=\"white-bg md-whiteframe-40dp\" layout=\"row\" \nlayout-align=\"center center\" height=\"100px\" ng-show=\"!vm.showTable\"><br><span \nstyle=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></div><div class=\"white-bg md-whiteframe-4dp\" \nng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'SETTINGS.SERVICE.PROFESSIONAL.SERVICE.SERVICE\' | translate }}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'SETTINGS.SERVICE.PROFESSIONAL.SERVICE.PRICE\' | translate }}</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'SETTINGS.SERVICE.PROFESSIONAL.SERVICE.DURATION\' | translate }}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'SETTINGS.SERVICE.PROFESSIONAL.SERVICE.ENABLED\' | translate }}\n</span></div></th><th></th></tr></thead><tbody><tr ng-repeat=\"service in ::vm.services\"><td>{{ service.name }}</td><td>\n{{ vm.getServicePrice(service._id) }}</td><td>{{ vm.getServiceDuration(service._id) }}</td><td>\n{{ vm.getServiceEnabled(service._id) }}</td><td align=\"right\"><md-button aria-label=\"Pencil\" class=\"md-raised gp-mini\" \nng-click=\"vm.editServiceProfessional(vm.professionalId, service._id)\"><md-tooltip aria-label=\"Pencil\">\n{{ \'GENERAL.HINTS.EDIT\' | translate }}</md-tooltip><i class=\"icon-pencil\" layout=\"center\"></i></md-button></td></tr>\n</tbody></table></div></div></div>");
$templateCache.put("app/main/schedule/bycategory.html","<div id=\"forms\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"content-card\" layout=\"column\" flex \nstyle=\"width:auto\"><md-content class=\"content\" flex ng-if=\"!vm.showTable\"><br><span \nstyle=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></md-content><md-content class=\"content\" flex \nng-if=\"vm.showTable\"><div compile=\"vm.html\" id=\"code\"></div></md-content></div><div class=\"content-card\" \nlayout=\"column\" style=\"width:2px;background-color: #000066\"></div><div class=\"content-card\" layout=\"column\" \nstyle=\"width:250px\" ng-if=\"true\"><md-toolbar class=\"md-accent\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div \nclass=\"md-toolbar-tools\"><span flex class=\"menu-title\" translate=\"SCHEDULE.BYPROFESSIONAL.FILTER.HEADER\"></span>\n<md-button class=\"md-raised md-orange-500-bg\" aria-label=\"Refresh\" ng-click=\"vm.reloadByCategory()\">\n{{ \'GENERAL.FILTER\' | translate }}</md-button></div></md-toolbar><md-content class=\"content\" flex ms-scroll><md-list>\n<md-subheader class=\"md-no-sticky\" style=\"padding: 10px\" translate=\"SCHEDULE.BYPROFESSIONAL.FILTER.DATE\">\n</md-subheader><md-datepicker ng-model=\"vm.filterdate\"></md-datepicker><md-divider></md-divider><br><md-subheader \nclass=\"md-no-sticky\" style=\"padding: 10px\" translate=\"SCHEDULE.BYPROFESSIONAL.FILTER.CATEGORIES\">F</md-subheader><div \nstyle=\"padding: 10px\"><div layout=\"row\" ng-repeat=\"category in vm.categoriesAll\"><md-checkbox \nng-model=\"vm.chkCategories[category._id]\">{{category.name}}</md-checkbox></div></div></md-list></md-content></div>\n</div>");
$templateCache.put("app/main/schedule/byprofessional-filters-sidenav.html","<md-toolbar class=\"md-accent\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><span flex \nclass=\"menu-title\" translate=\"SCHEDULE.BYPROFESSIONAL.FILTER.HEADER\"></span><md-button ng-if=\"vm.filteringIsOn()\" \nng-click=\"vm.clearFilters()\" class=\"md-icon-button\" aria-label=\"clear filters\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip><span translate=\"GENERAL.CLEAR_FILTER\">Clear Filters</span>\n</md-tooltip></md-button></div></md-toolbar><md-content class=\"\" ms-scroll><md-list><md-subheader class=\"md-no-sticky\" \nstyle=\"padding: 10px\" translate=\"SCHEDULE.BYPROFESSIONAL.FILTER.DATE\"></md-subheader><md-datepicker \nng-model=\"vm.filterdate\" ng-change=\"vm.reload()\"></md-datepicker><md-divider></md-divider><br><md-subheader \nclass=\"md-no-sticky\" style=\"padding: 10px\" translate=\"SCHEDULE.BYPROFESSIONAL.FILTER.PROFESSIONALS\">Filter by Labels\n</md-subheader><div style=\"padding: 10px\"><md-checkbox ng-model=\"vm.chkProf[professional._id]\" \nng-click=\"vm.updateIndex()\" ng-repeat=\"professional in vm.professionalsAll\">{{professional.name}}</md-checkbox></div>\n</md-list></md-content>");
$templateCache.put("app/main/schedule/byprofessional.html","<div id=\"forms\" class=\"page-layout carded fullwidth doc-page\" layout=\"column\"><div layout=\"row\" style=\"height:50px\" \nclass=\"md-accent-bg\" style=\"background-color:gray\"><div class=\"header-bottom\" layout=\"row\" \nlayout-align=\"center center\" flex><md-input-container style=\"margin-left:0px\"><md-button class=\"md-raised\" \naria-label=\"Today\" ng-click=\"vm.todayDate();\">{{\'GENERAL.TODAY\'|translate}}</md-button></md-input-container>\n<md-input-container><md-button class=\"md-raised\" aria-label=\"Previous\" ng-click=\"vm.previousDate();\" translate \ntranslate-attr-aria-label=\"CALENDAR.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button>\n</md-input-container><div style=\"width:140px\"><md-datepicker md-placeholder=\"Data\" \nstyle=\"width:100%;margin-left:0px;margin-top:-10px;font-weight:bolder;color:white\" ng-change=\"vm.reload()\" \nng-model=\"vm.selectedDate\" md-is-open=\"vm.isOpen\"></md-datepicker><md-button class=\"md-raised\" \nstyle=\"margin-top:-58px;width:140px;margin-left:0px\" aria-label=\"Previous\" ng-click=\"vm.isOpen = true\" translate \ntranslate-attr-aria-label=\"CALENDAR.DATE\">{{vm.selectedDate | date:\'dd/MM/yyyy\'}}</md-button></div><md-input-container \nstyle=\"margin-left:0px\"><md-button aria-label=\"Next\" class=\"md-raised\" ng-click=\"vm.nextDate();\" translate \ntranslate-attr-aria-label=\"CALENDAR.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button>\n</md-input-container><span flex></span><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-raised gp-mini\" ng-click=\"showHelp(\'scheduleByProfessional\');\">?<md-tooltip aria-label=\"Pencil\">\nVídeo Explicativo</md-tooltip></md-button></div></div></div><div layout=\"column\" flex style=\"width:auto\"><md-content \nclass=\"content\" flex ng-if=\"!vm.showTable\"><br><span style=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b>\n</span></md-content><script>\nvar timer = {};\n            function moveHour(event){\n                if(timer !== null) {\n                    clearTimeout(timer);\n                }\n                timer = setTimeout(function() {\n                    // do something\n                    console.log(event);\n\n                    var doc = document.documentElement;\n\n                    console.log($(\'#cont\').scrollTop());\n                    var left = $(\'#cont\').scrollLeft();\n                    var top = $(\'#cont\').scrollTop();\n                    $(\'#tabelaHoras\').css({ left: left });\n\n                    $(\'#tableProfessional\').css({ top: top });\n\n\n                    console.log(window.scrollY);\n                    console.log(left);\n\n                }, 100);\n\n            }\n</script><md-content class=\"content\" flex ng-if=\"vm.showTable\" id=\"cont\" onscroll=\"moveHour(event)\"><div \ncompile=\"vm.html\" id=\"code\"></div><div id=\"tabelaHoras\" \nstyle=\"background-color:white;position: absolute;width:48px;top:49px;left:0px\"><div ng-repeat=\"time in vm.timetable\" \nstyle=\"width:100%;text-align: right; position: relative;height:30.5px;border-top:1px solid lightgray\"><span \nstyle=\"width:100%;margin-right:5px; font-size:11px\" \nng-if=\"time.timeStr.indexOf(\':15\') == -1 && time.timeStr.indexOf(\':45\') == -1\">{{time.timeStr}}</span> <span \nng-if=\"time.timeStr.indexOf(\':15\') != -1 || time.timeStr.indexOf(\':45\') != -1\">&nbsp;</span></div></div><table \nid=\"tableProfessional\" cellpadding=\"0\" cellspacing=\"0\" style=\"width:100%;position: absolute;top:0px;left:0px\"><thead>\n<tr style=\"background-color: white\" height=\"50px\"><th \nstyle=\"max-width:50px;min-width:50px;width:50px;border-right: 1px solid lightgrey;border-bottom: 1px solid darkgrey\">\n</th><th ng-repeat=\"professional in vm.professionals\" align=\"center\" \nstyle=\"min-width:100px;border-right: 1px solid lightgray;border-bottom: 1px solid darkgrey;text-align: center;color:Gray\">\n{{professional.name}}</th></tr></thead></table></md-content></div><div class=\"content-card\" layout=\"column\" \nstyle=\"width:2px;background-color: #000066\" ng-if=\"false\"></div><div class=\"content-card\" layout=\"column\" \nstyle=\"width:250px\" ng-if=\"false\"><md-toolbar class=\"md-accent\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div \nclass=\"md-toolbar-tools\"><span flex class=\"menu-title\" translate=\"SCHEDULE.BYPROFESSIONAL.FILTER.HEADER\"></span>\n<md-button class=\"md-raised md-orange-500-bg\" aria-label=\"Refresh\" ng-click=\"vm.reload()\">\n{{ \'GENERAL.FILTER\' | translate }}</md-button></div></md-toolbar><md-content class=\"content\" flex ms-scroll><md-list>\n<md-subheader class=\"md-no-sticky\" style=\"padding: 10px\" translate=\"SCHEDULE.BYPROFESSIONAL.FILTER.DATE\">\n</md-subheader><md-datepicker ng-model=\"vm.filterdate\"></md-datepicker><md-divider></md-divider><br><md-subheader \nclass=\"md-no-sticky\" style=\"padding: 10px\" translate=\"SCHEDULE.BYPROFESSIONAL.FILTER.PROFESSIONALS\">SP</md-subheader>\n<div style=\"padding: 10px\"><div layout=\"row\" ng-repeat=\"professional in vm.professionalsAll\"><md-checkbox \nng-model=\"vm.chkProf[professional._id]\">{{professional.name}}</md-checkbox></div></div></md-list></md-content></div>\n</div>");
$templateCache.put("app/main/schedule/byprofessional2.html","<div id=\"forms\" class=\"page-layout carded fullwidth doc-page\" layout=\"column\"><div layout=\"row\" style=\"height:50px\" \nclass=\"md-accent-bg\"><div class=\"header-bottom\" layout=\"row\" layout-align=\"center center\"><md-input-container>\n<md-button aria-label=\"Previous\" ng-click=\"vm.previousDate();\" translate translate-attr-aria-label=\"CALENDAR.PREVIOUS\">\n<md-icon md-font-icon=\"icon-chevron-left\" style=\"color:white\"></md-icon></md-button></md-input-container>\n<md-input-container><input time=\"false\" date=\"true\" mdc-datetime-picker=\"\" type=\"text\" id=\"date\" placeholder=\"\" \nstyle=\"margin-left:-20px;color:white;width:190px;text-align:center;alignment:center\" format=\"dddd, DD MMMM,  YYYY\" \nng-change=\"vm.reload()\" cancel-text=\"Cancelar\" ok-text=\"Alterar\" today-text=\"Hoje\" lang=\"pt-br\" \nng-model=\"vm.selectedDate\" readonly=\"readonly\"></md-input-container><md-input-container style=\"margin-left:-20px\">\n<md-button aria-label=\"Next\" ng-click=\"vm.nextDate();\" translate translate-attr-aria-label=\"CALENDAR.PREVIOUS\"><md-icon\n md-font-icon=\"icon-chevron-right\" style=\"color:white\"></md-icon></md-button></md-input-container></div></div><div \nlayout=\"column\" flex style=\"width:auto\"><md-content class=\"content\" flex ng-if=\"vm.showTable\"><div layout=\"column\">\n<table><thead fix-head><tr>&nbsp;felipe</tr></thead><tr ng-repeat=\"time in vm.timetable\"><td><span>{{time.timeStr}}\n</span></td></tr></table></div><div layout=\"column\"><table><thead><tr ng-repeat=\"time in ::vm.timetable\"><td \nng-repeat=\"professional in ::vm.professionals\">{{professional.name}}</td></tr></thead></table></div></md-content></div>\n<div class=\"content-card\" layout=\"column\" style=\"width:2px;background-color: #000066\" ng-if=\"false\"></div><div \nclass=\"content-card\" layout=\"column\" style=\"width:250px\" ng-if=\"false\"><md-toolbar class=\"md-accent\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><span flex class=\"menu-title\" \ntranslate=\"SCHEDULE.BYPROFESSIONAL.FILTER.HEADER\"></span><md-button class=\"md-raised md-orange-500-bg\" \naria-label=\"Refresh\" ng-click=\"vm.reload()\">{{ \'GENERAL.FILTER\' | translate }}</md-button></div></md-toolbar>\n<md-content class=\"content\" flex ms-scroll><md-list><md-subheader class=\"md-no-sticky\" style=\"padding: 10px\" \ntranslate=\"SCHEDULE.BYPROFESSIONAL.FILTER.DATE\"></md-subheader><md-datepicker ng-model=\"vm.filterdate\"></md-datepicker>\n<md-divider></md-divider><br><md-subheader class=\"md-no-sticky\" style=\"padding: 10px\" \ntranslate=\"SCHEDULE.BYPROFESSIONAL.FILTER.PROFESSIONALS\">SP</md-subheader><div style=\"padding: 10px\"><div layout=\"row\" \nng-repeat=\"professional in vm.professionalsAll\"><md-checkbox ng-model=\"vm.chkProf[professional._id]\">\n{{professional.name}}</md-checkbox></div></div></md-list></md-content></div></div>");
$templateCache.put("app/main/schedule/byservice.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SCHEDULE.HEADER\' | translate }}</span></div><div class=\"title\">{{ \'SCHEDULE.BYPROFESSIONAL.HEADER\' | translate }}\n</div></div><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" flex-order=\"3\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.toggleFilter(\'filters-sidenav\')\" aria-label=\"Filter Cards\" translate \ntranslate-attr-aria-label=\"SB.FILTER_CARDS\"><md-icon md-font-icon=\"icon-filter-variant\"></md-icon><md-tooltip><span \ntranslate=\"SB.FILTER_CARDS\">Filter Cards</span></md-tooltip></md-button></div></div><div class=\"content\" \nms-scroll=\"true\"><table cellpadding=\"0\" cellspacing=\"0\"><thead><tr style=\"background-color: lightgray\" height=\"50px\">\n<th width=\"100px\" style=\"min-width:100px;border-right: 1px solid darkgrey;border-bottom: 1px solid darkgrey\"></th><th \nwidth=\"300px\" align=\"center\" \nstyle=\"min-width:200px;border-right: 1px solid darkgrey;border-bottom: 1px solid darkgrey;text-align: center\" \nng-repeat=\"professional in vm.professionals\">{{professional.name}}</th></tr></thead><tbody><tr height=\"50px\" \nng-repeat=\"item in vm.timetable\"><td \nstyle=\"border-right: 1px solid darkgrey;border-bottom: 1px solid darkgrey;text-align: center;background-color: lightgray\">\n{{item.timeStr}}</td><td \nstyle=\"padding: 10px; border-right: 1px solid darkgrey;border-bottom: 1px solid darkgrey;text-align: left\" \nng-repeat=\"professional in vm.professionals\" ng-show=\"vm.schedule[professional._id][item.time].slotSize!=0\" \nrowspan=\"{{vm.schedule[professional._id][item.time].slotSize}}\"><md-tooltip>{{professional.name}} as {{item.timeStr}}\n</md-tooltip>{{vm.schedule[professional._id][item.time].status}}</td></tr></tbody></table></div><md-sidenav \nclass=\"filters-sidenav md-sidenav-right\" md-component-id=\"filters-sidenav\" \nng-include=\"\'app/main/schedule/byprofessional-filters-sidenav.html\'\"></md-sidenav></div>");
$templateCache.put("app/main/schedule/fastAppointment.html","<md-dialog aria-label=\"Schedule\" style=\"vm.style\"><form name=\"basicForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Novo Agendamento</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"close()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-autocomplete flex required \nstyle=\"height:65px;margin-top:0px;margin-left:10px;font-size:12px;width:450px\" ng-disabled=\"false\" \nmd-input-name=\"customerId\" md-input-id=\"customer-input\" md-autofocus=\"true\" md-input-minlength=\"3\" md-no-cache=\"true\" \nmd-selected-item=\"vm.customer\" md-selected-item-change=\"vm.getCustomerInventoryAndCredDeb(vm.customer)\" \nmd-search-text=\"vm.customerSearchText\" md-items=\"item in vm.customerSearchTextChange(vm.customerSearchText)\" \nmd-item-text=\"item.name\" placeholder=\"Informe o nome ou telefone do cliente\" ng-attr-md-floating-label=\"Cliente\" \nmd-require-match ng-keydown=\"vm.changeFocusToService($event);\"><md-item-template><span \nmd-highlight-text=\"vm.customerNameSearchText\" style=\"font-size:12px\">{{item.name + \' - \' + item.telephone}}</span>\n</md-item-template><br><a href=\"#\" ng-click=\"vm.newCustomer()\">Clique para cadastrar novo cliente?</a><div \nng-messages=\"basicForm.customerId.$error\" ng-if=\"basicForm.customerId.$touched\"><div ng-message=\"required\"><span \ntranslate=\"SCHEDULE.VALIDATION.CUSTOMER_REQUIRED\"></span></div><div ng-message=\"md-require-match\"><span \ntranslate=\"SCHEDULE.VALIDATION.CUSTOMER_INVALID\"></span></div></div></md-autocomplete><div style=\"margin-top:25px\" \nlayout-xs=\"column\" layout=\"row\" layout-align=\"center end\"><br>\nSaldo: {{vm.customer.creditDebit}} | Inventário: {{vm.customer.inventory}}</div><md-autocomplete required \nstyle=\"height:65px;font-size:12px;margin-top:0px;margin-left:10px; width:450px\" md-input-id=\"service-input\" \nmd-input-name=\"serviceId\" md-input-minlength=\"2\" md-autofocus=\"false\" md-no-cache=\"false\" \nmd-selected-item=\"vm.service\" md-search-text=\"vm.serviceSearchText\" \nmd-items=\"item in vm.serviceSearchTextChange(vm.serviceSearchText)\" md-item-text=\"item.name\" md-require-match \nng-attr-md-floating-label=\"Serviço\" ng-keydown=\"vm.submitNewSchedule($event);\"><md-item-template><span \nmd-highlight-text=\"vm.serviceSearchText\" style=\"font-size:12px\">\n{{item.fastCode}} - {{item.name}} - {{item.price | currency : \'R$ \' : 2}}</span></md-item-template><div \nng-messages=\"basicForm.serviceId.$error\" ng-if=\"basicForm.serviceId.$touched\"><div ng-message=\"required\"><span \ntranslate=\"SCHEDULE.VALIDATION.SERVICE_REQUIRED\"></span></div><div ng-message=\"md-require-match\"><span \ntranslate=\"SCHEDULE.VALIDATION.SERVICE_INVALID\"></span></div></div></md-autocomplete><div layout=\"row\" \nlayout-gt-sm=\"row\" style=\"width:470px;margin-left:10px;margin-top:0px\"><md-checkbox ng-model=\"vm.chkPreference\">\nCliente escolheu pelo profissional</md-checkbox></div><md-autocomplete required \nstyle=\"height:65px;font-size:12px;margin-top:0px;margin-left:10px; width:450px\" md-input-id=\"professional-input\" \nmd-input-name=\"professionalId\" md-input-minlength=\"1\" md-autofocus=\"false\" md-no-cache=\"false\" \nmd-selected-item=\"vm.professional\" md-search-text=\"vm.professionalSearchText\" \nmd-items=\"item in vm.professionalSearchTextChange(vm.professionalSearchText)\" md-item-text=\"item.name\" \nmd-require-match ng-attr-md-floating-label=\"Profissional\" ng-disabled=\"vm.blockProfessionalSelector\" \nng-keydown=\"vm.submitNewSchedule($event);\"><md-item-template><span md-highlight-text=\"vm.professionalSearchText\" \nstyle=\"font-size:11px\">{{item.name}}</span></md-item-template><div ng-messages=\"basicForm.professionalId.$error\" \nng-if=\"basicForm.professionalId.$touched\"><div ng-message=\"required\"><span \ntranslate=\"SCHEDULE.VALIDATION.PROFESSIONAL_REQUIRED\"></span></div><div ng-message=\"md-require-match\"><span \ntranslate=\"SCHEDULE.VALIDATION.PROFESSIONAL_INVALID\"></span></div></div></md-autocomplete><div layout=\"row\" \nlayout-gt-sm=\"row\" style=\"width:470px;margin-left:-10px;margin-top:0px\"><md-input-container \nstyle=\"width:100%;margin-left:20px;margin-top:30px\" ng-if=\"vm.showPdvLocation\"><label>Local de Atendimento</label>\n<md-select ng-model=\"vm.pdvLocation\" required><md-option ng-value=\"item.locationId\" \nng-repeat=\"item in vm.pdvLocations\">{{item.name}}</md-option></md-select></md-input-container><md-input-container \nstyle=\"width:100%;margin-left:20px;margin-top:30px\"><label>Número de Repetições</label><md-select \nng-model=\"vm.numberOfRepetition\"><md-option data-value=\"0\" selected=\"selected\">Sem repetição</md-option><md-option \ndata-value=\"1\">Repetir na próxima semana</md-option><md-option data-value=\"2\">Repetir nas próximas 2 semanas\n</md-option><md-option data-value=\"3\">Repetir nas próximas 3 semanas</md-option><md-option data-value=\"4\">\nRepetir nas próximas 4 semanas</md-option><md-option data-value=\"5\">Repetir nas próximas 5 semanas</md-option>\n<md-option data-value=\"6\">Repetir nas próximas 6 semanas</md-option><md-option data-value=\"7\">\nRepetir nas próximas 7 semanas</md-option><md-option data-value=\"8\">Repetir nas próximas 8 semanas</md-option>\n</md-select></md-input-container></div><div layout=\"row\" layout-gt-sm=\"row\" \nstyle=\"width:470px;margin-left:-10px;margin-top:-20px\" ng-if=\"vm.requestPassword\"><md-input-container \nstyle=\"width:100%;margin-left:20px;margin-top:30px\"><label translate=\"GENERAL.ACCESSCODE\"></label><input \ntype=\"password\" name=\"accessCode\" ng-model=\"vm.accessCode\" required maxlength=\"10\" \nng-keydown=\"vm.submitNewSchedule($event);\"><div ng-messages=\"basicForm.accessCode.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{ \'GENERAL.ACCESSCODE.REQUIRED\' | translate }}</span></div></div></md-input-container>\n</div><md-dialog-actions layout=\"row\"><md-button class=\"md-accent md-raised\" ng-click=\"vm.saveNewSchedule(false)\" \nng-disabled=\"basicForm.$invalid\" style=\"margin-top:-20px\">Agendar</md-button><md-button class=\"md-accent md-raised\" \nng-click=\"vm.saveNewSchedule(true)\" ng-disabled=\"basicForm.$invalid\" ng-if=\"!(vm.date.valueOf() > vm.hoje.valueOf())\" \nstyle=\"margin-top:-20px\">Agendar e Chekin</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/schedule/fastBlock.html","<div layout-align=\"center center\" layout=\"row\" style=\"font-weight:bold;color:Red\"><br>{{vm.title}}</div><div \naria-label=\"Schedule\" layout=\"row\" layout-align=\"left center\"><form name=\"basicForm\" novalidate><div layout=\"row\" \nlayout-gt-sm=\"row\" style=\"width:470px\"><md-input-container style=\"width:100%;margin-left:20px;margin-top:30px\"><label \ntranslate=\"SETTINGS.SERVICE.PROFESSIONAL.BLOCK.REASON\"></label><input type=\"text\" name=\"reason\" ng-model=\"vm.reason\" \nrequired maxlength=\"50\"><div ng-messages=\"basicForm.reason.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'SETTINGS.SERVICE.PROFESSIONAL.BLOCK.REASON_REQUIRED\' | translate }}</span></div></div></md-input-container>\n<md-input-container style=\"width:100%;margin-left:20px;margin-top:30px\"><label \ntranslate=\"SETTINGS.SERVICE.PROFESSIONAL.BLOCK.TIME\"></label><md-select ng-model=\"vm.time\"><md-option ng-value=\"1\">\n15 minutos</md-option><md-option selected=\"selected\" ng-value=\"2\">30 minutos</md-option><md-option ng-value=\"3\">\n45 minutos</md-option><md-option ng-value=\"4\">1 Hora</md-option></md-select></md-input-container></div><div \nlayout=\"row\" layout-gt-sm=\"row\" style=\"width:470px;margin-top:-40px\" ng-if=\"vm.requestPassword\"><md-input-container \nstyle=\"width:100%;margin-left:20px;margin-top:30px\"><label translate=\"GENERAL.ACCESSCODE\"></label><input \ntype=\"password\" name=\"accessCode\" ng-model=\"vm.accessCode\" required maxlength=\"10\"><div \nng-messages=\"basicForm.accessCode.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'GENERAL.ACCESSCODE.REQUIRED\' | translate }}</span></div></div></md-input-container></div><div layout=\"row\" \nlayout-gt-sm=\"row\" style=\"margin-top:-20px;margin-left:10px\"><md-button ng-disabled=\"basicForm.$invalid\" \nng-click=\"vm.saveBlock()\">Bloquear</md-button></div></form></div>");
$templateCache.put("app/main/schedule/fastCheckin.html","<md-dialog aria-label=\"Schedule\" style=\"min-width:600px\"><form name=\"basicForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Checkin Expresso</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"close()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-content style=\"padding:20px; font-size:13px\">\n<table style=\"width:100%\"><tr><td><strong>Data/Hora</strong></td><td><strong>Cliente</strong></td><td><strong>Serviço\n</strong></td><td><strong>Profissional</strong></td><td></td></tr><tr ng-repeat=\"item in vm.schedules\"><td \nstyle=\"width:100px\">{{item.when | date : \'HH:mm\'}}</td><td>{{item.customerName}}</td><td>{{item.serviceName}}</td><td>\n{{item.professionalName}}</td><td><md-button class=\"md-raised\" ng-click=\"vm.checkinRequest(item._id)\" \nng-disabled=\"item.status == \'CHECKIN\'\">Checkin</md-button></td></tr></table></md-content><div \nstyle=\"min-height:200px; padding:20px; font-size:13px;font-weight:bolder;left-margin:20px\" \nng-if=\"vm.processing == true\">Buscando agendamentos...</div></form></md-dialog>");
$templateCache.put("app/main/schedule/listPendingSchedule.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SCHEDULE.HEADER\' | translate }}</span></div><div class=\"title\">{{ \'SCHEDULE.PENDING.HEADER\' | translate }}</div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised md-orange-500-bg\" \nng-click=\"vm.refreshPendingSchedules();\">{{ \'GENERAL.REFRESH\' | translate }}</md-button></div></div><div \nclass=\"content\"><md-content class=\"content\" flex ng-if=\"!vm.showTable\"><br><span \nstyle=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></md-content><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'SCHEDULE.PENDING.FIELDS.CUSTOMER_NAME\' | translate }}</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'SCHEDULE.PENDING.FIELDS.CUSTOMER_TELEPHONE\' | translate }}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'SCHEDULE.PENDING.FIELDS.SERVICE_NAME\' | translate }}</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'SCHEDULE.PENDING.FIELDS.PROFESSIONAL_NAME\' | translate }}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'SCHEDULE.PENDING.FIELDS.WHEN\' | translate }}</span></div></th><th>\n</th></tr></thead><tbody><tr ng-repeat=\"serviceRequest in vm.pendingSchedules\"><td>{{ serviceRequest.customerName }}\n</td><td>{{ serviceRequest.customerTelephone }}</td><td>{{ serviceRequest.serviceName }}</td><td>\n{{ serviceRequest.serviceProfessionalName }}</td><td>{{ serviceRequest.when | date:\'dd/MM/yyyy HH:mm\'}}</td><td \nalign=\"right\"><md-button aria-label=\"Pencil\" class=\"md-raised md-accent gp-mini\" \nng-click=\"vm.reschedule(serviceRequest._id)\"><md-tooltip aria-label=\"Pencil\">\n{{ \'SCHEDULE.PENDING.HINTS.RESCHEDULE\' | translate }}</md-tooltip><i class=\"icon-calendar\" layout=\"center\"></i>\n</md-button><md-button aria-label=\"Trash\" class=\"md-raised md-warn gp-mini\" \nng-click=\"vm.checkin(serviceRequest._id, serviceRequest.customerId, serviceRequest.customerName, serviceRequest.customerTelephone)\">\n<md-tooltip aria-label=\"Pencil\">{{ \'SCHEDULE.PENDING.HINTS.CHECKIN\' | translate }}</md-tooltip><i class=\"icon-check\" \nlayout=\"center\"></i></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/schedule/newBlock.html","<md-dialog aria-label=\"Schedule\" style=\"min-width:400px\"><form name=\"basicForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Bloquear Horário</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"close()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-content style=\"padding:20px; font-size:13px\">\n<div layout=\"row\" layout-gt-sm=\"row\" style=\"width:470px\"><md-input-container \nstyle=\"width:100%;margin-left:20px;margin-top:30px\"><label translate=\"SETTINGS.SERVICE.PROFESSIONAL.BLOCK.TIME_FROM\">\n</label><md-select ng-model=\"vm.timeFrom\"><md-option ng-repeat=\"item in vm.arTimes\" ng-value=\"item.minutes\">\n{{item.str}}</md-option></md-select></md-input-container><md-input-container \nstyle=\"width:100%;margin-left:20px;margin-top:30px\"><label translate=\"SETTINGS.SERVICE.PROFESSIONAL.BLOCK.TIME_TO\">\n</label><md-select ng-model=\"vm.timeTo\"><md-option ng-repeat=\"item in vm.arTimes\" ng-value=\"item.minutes\">{{item.str}}\n</md-option></md-select></md-input-container></div><div layout=\"row\" layout-gt-sm=\"row\" style=\"width:470px\">\n<md-input-container style=\"width:100%;margin-left:20px;margin-top:30px\"><label \ntranslate=\"SETTINGS.SERVICE.PROFESSIONAL.BLOCK.REASON\"></label><input type=\"text\" name=\"reason\" ng-model=\"vm.reason\" \nrequired maxlength=\"50\"><div ng-messages=\"basicForm.reason.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'SETTINGS.SERVICE.PROFESSIONAL.BLOCK.REASON_REQUIRED\' | translate }}</span></div></div></md-input-container></div>\n<div layout=\"row\" layout-gt-sm=\"row\" style=\"width:470px;margin-top:-40px\" ng-if=\"vm.requestPassword\">\n<md-input-container style=\"width:100%;margin-left:20px;margin-top:30px\"><label translate=\"GENERAL.ACCESSCODE\"></label>\n<input type=\"password\" name=\"accessCode\" ng-model=\"vm.accessCode\" required maxlength=\"10\"><div \nng-messages=\"basicForm.accessCode.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'GENERAL.ACCESSCODE.REQUIRED\' | translate }}</span></div></div></md-input-container></div></md-content>\n<md-dialog-actions layout=\"row\"><md-button ng-disabled=\"basicForm.$invalid\" class=\"md-raised md-warn\" \nng-click=\"vm.saveBlock()\">Bloquear</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/schedule/viewAppointment.html","<md-dialog aria-label=\"Schedule\" style=\"vm.style\"><form name=\"basicForm\" novalidate><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Informações do Agendamento</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"close()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-input-container><input type=\"text\" \nplaceholder=\"Cliente\" ng-model=\"vm.customerName\" readonly=\"readonly\"></md-input-container><md-input-container \nstyle=\"margin-top:-20px\"><input type=\"text\" placeholder=\"Serviço\" ng-model=\"vm.serviceName\" readonly=\"readonly\">\n</md-input-container><md-input-container style=\"margin-top:-20px\"><input type=\"text\" placeholder=\"Profissional\" \nng-model=\"vm.professionalName\" readonly=\"readonly\"></md-input-container><md-input-container style=\"margin-top:-20px\">\n<input type=\"text\" placeholder=\"Quando\" ng-model=\"vm.when\" readonly=\"readonly\"></md-input-container><md-input-container\n style=\"margin-top:-20px\"><input type=\"text\" placeholder=\"Marcado em\" ng-model=\"vm.createdAt\" readonly=\"readonly\">\n</md-input-container><md-input-container style=\"margin-top:-20px\"><input type=\"text\" placeholder=\"Canal\" \nng-model=\"vm.channel\" readonly=\"readonly\"></md-input-container><md-input-container style=\"margin-top:-20px\"><input \ntype=\"text\" placeholder=\"Operador\" ng-model=\"vm.userName\" readonly=\"readonly\"></md-input-container></form></md-dialog>");
$templateCache.put("app/main/sales/addCardPayment.html","<md-dialog aria-label=\"New Message\"><form name=\"basicForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Lançar Pagamento</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"GENERAL.DIALOG.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content layout=\"column\" \nstyle=\"width:330px;height:255px;padding: 20px\" flex><div layout=\"row\" flex><md-input-container flex><label \nstyle=\"font-size: 20px; font-weight: bold\">Valor</label><input type=\"currency\" name=\"value\" ng-model=\"vm.value\">\n</md-input-container></div><div layout=\"row\" flex><md-input-container flex><label \nstyle=\"font-size: 20px; font-weight: bold\">Bandeira</label><md-select ng-model=\"vm.cardId\" \nname=\"adquirenteVisaCredito\"><md-option data-value=\"{{bandeira.PDVA_CD_PDV_ADQUIRENTE}}\" \nng-repeat=\"bandeira in vm.bandeiras\">{{bandeira.BAND_TX_BANDEIRA}}</md-option></md-select></md-input-container></div>\n<div layout=\"row\" flex><md-input-container flex><label style=\"font-size: 20px; font-weight: bold\">Cod. Autorização\n</label><input type=\"text\" name=\"codAutorizacao\" ng-model=\"vm.codAutorizacao\"></md-input-container></div></md-content>\n<md-divider></md-divider><md-dialog-actions layout=\"row\" layout-align=\"space-between \"><md-button \nng-click=\"vm.closeAndApply()\" class=\"md-warn md-raised\">Lançar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sales/addCashPayment.html","<md-dialog aria-label=\"New Message\"><form name=\"basicForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Lançar Pagamento</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"GENERAL.DIALOG.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content layout=\"column\" \nstyle=\"width:330px;height:255px;padding: 20px\" flex><div layout=\"row\" flex><md-input-container flex><label \nstyle=\"font-size: 20px; font-weight: bold\">Valor</label><input type=\"currency\" name=\"value\" ng-model=\"vm.value\">\n</md-input-container></div><div layout=\"row\" flex><md-input-container flex><label \nstyle=\"font-size: 20px; font-weight: bold\">Observação</label><input type=\"text\" name=\"observation\" \nng-model=\"vm.observation\"></md-input-container></div></md-content><md-divider></md-divider><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between \"><md-button ng-click=\"vm.closeAndApply()\" class=\"md-warn md-raised\">Lançar\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sales/addGiftCard.html","<md-dialog aria-label=\"New Message\"><form name=\"basicForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Conceder Desconto</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"GENERAL.DIALOG.CLOSE\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content layout=\"column\" \nstyle=\"width:330px;height:255px;padding: 20px\" flex><div layout=\"row\" flex><md-input-container flex><label \nstyle=\"font-size: 20px; font-weight: bold\">Valor</label><input type=\"currency\" name=\"value\" ng-model=\"vm.value\">\n</md-input-container></div><div layout=\"row\" flex><md-input-container flex><label \nstyle=\"font-size: 20px; font-weight: bold; width:235px\">Observaçao</label><input style=\"width:255px\" type=\"text\" \nname=\"obs\" ng-model=\"vm.obs\"></md-input-container></div></md-content><md-divider></md-divider><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between \"><md-button ng-click=\"vm.closeAndApply()\" class=\"md-warn md-raised\">\nAplicar Desconto</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sales/addPaymentWowee.html","<md-dialog aria-label=\"New Message\"><form name=\"basicForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Receber</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"GENERAL.DIALOG.CLOSE\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-content layout=\"column\" style=\"width:330px;height:155px;padding: 20px\" flex \nng-if=\"!vm.processing\"><div layout=\"row\" flex><md-input-container flex><label \nstyle=\"font-size: 25px; font-weight: bold\">Valor</label><input style=\"font-size: 25px; font-weight: bold\" type=\"text\" \nname=\"value\" ng-model=\"vm.value\"></md-input-container><md-input-container ng-show=\"vm.creditDebit == \'C\'\" flex><label \nstyle=\"font-size: 25px; font-weight: bold\">Parcelas</label><md-select ng-model=\"vm.parcelas\" placeholder=\"Parcelas\">\n<md-option value=\"1\" ng-selected=\"true\">1</md-option><md-option value=\"2\">2</md-option><md-option value=\"3\">3\n</md-option><md-option value=\"4\">4</md-option><md-option value=\"5\">5</md-option><md-option value=\"6\">6</md-option>\n<md-option value=\"7\">7</md-option><md-option value=\"8\">8</md-option><md-option value=\"9\">9</md-option><md-option \nvalue=\"10\">10</md-option><md-option value=\"11\">11</md-option><md-option value=\"11\">12</md-option></md-select>\n</md-input-container></div></md-content><md-content layout=\"column\" style=\"width:330px;height:155px;padding: 20px\" \nflex ng-if=\"vm.processing\"><label style=\"font-size: 25px; font-weight: bold\">Processando</label></md-content>\n<md-divider></md-divider><md-dialog-actions layout=\"row\" layout-align=\"space-between \" ng-if=\"!vm.processing\">\n<md-button ng-click=\"vm.closeAndApply()\" class=\"md-warn md-raised\">Receber via TEF</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/sales/checkout.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">{{ \'SALES.HEADER\' | translate }}\n</span></div><div class=\"title\">{{ \'SALES.CHECKOUT.HEADER\' | translate }}</div></div></div><div class=\"content\" \nlayout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" novalidate>\n<div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"SALES.CHECKOUT.FIELDS.CUSTOMER_NAME\"></label><input type=\"text\" name=\"customerName\" \nng-model=\"vm.sale.customerName\" disabled=\"disabled\"></md-input-container><md-input-container flex><label \ntranslate=\"SALES.CHECKOUT.FIELDS.CUSTOMER_TELEPHONE\"></label><input type=\"text\" name=\"customerTelephone\" \nng-model=\"vm.sale.customerTelephone\" disabled=\"disabled\"></md-input-container><md-input-container flex><label \ntranslate=\"SALES.CHECKOUT.FIELDS.TOTAL_VALUE\"></label><input type=\"number\" name=\"totalValue\" \nng-model=\"vm.sale.totalValue\" disabled=\"disabled\"></md-input-container><md-input-container flex><label \ntranslate=\"SALES.CHECKOUT.FIELDS.PRICE_TABLE\"></label><input type=\"text\" name=\"priceTable\" \nng-model=\"vm.sale.priceTable\" disabled=\"disabled\"></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<div flex-gt-sm=\"100\" flex><md-toolbar layout=\"row\" class=\"md-hue-3\" style=\"height:20px\"><div class=\"md-toolbar-tools\">\n<span>{{\'SALES.CHECKOUT.ITEMS\' | translate}}</span></div><div class=\"right\"><md-button ng-click=\"vm.addProduct();\" \nclass=\"md-raised\" ng-if=\"vm.allowAddService\">{{\'SALES.CHECKOUT.ADDPRODUCT\' | translate}}</md-button></div><div \nclass=\"right\"><md-button ng-click=\"vm.addService();\" class=\"md-raised\" ng-if=\"vm.allowAddProduct\">\n{{\'SALES.CHECKOUT.ADDSERVICE\' | translate}}</md-button></div></md-toolbar><md-content><md-list flex><md-list-item \nclass=\"secondary-button-padding\" ng-repeat=\"item in vm.sale.items\"><p>\n{{item.itemPrice | currency:\"R$ \"}} - {{ item.name }} - {{item.professionalName}}</p><md-button class=\"md-secondary\" \nng-click=\"vm.removeServiceItem(item._id)\">{{\'GENERAL.REMOVE\' | translate}}</md-button><md-divider></md-divider>\n</md-list-item></md-list></md-content></div></div><md-divider></md-divider><md-button type=\"button\" class=\"md-raised\" \nng-click=\"vm.save();\" aria-label=\"Submit\">{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button><md-button type=\"button\" \nclass=\"md-raised\" ng-if=\"!vm.isElectron\" ng-click=\"vm.saveAndClose();\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid || vm.sale.items==0\">{{ \'GENERAL.BUTTON.SAVE_AND_CHECKOUT\' | translate }}</md-button>\n<md-button type=\"button\" class=\"md-raised\" ng-if=\"!vm.isElectron\" ng-click=\"vm.saveAndClose2();\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid || vm.sale.items==0\">Fechar comanda Beta</md-button><md-button type=\"button\" \nclass=\"md-raised\" ng-if=\"vm.isElectron\" ng-click=\"vm.saveAndClose2();\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid || vm.sale.items==0\">Fechar comanda</md-button><md-button type=\"button\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\" ng-click=\"vm.cancel()\">{{ \'GENERAL.BUTTON.CANCEL\' | translate }}\n</md-button></form></div></div></div>");
$templateCache.put("app/main/sales/checkoutDialog.html","<md-dialog aria-label=\"New Message\"><form name=\"basicForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{ \'SALES.CHECKOUT.HEADER\' | translate }}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"GENERAL.DIALOG.CLOSE\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content layout=\"row\" \nstyle=\"width:800px;height:355px\" flex><md-dialog-content flex=\"100\" layout=\"row\"><div style=\"width:399px\"><md-subheader\n style=\"margin-left:-20px\">Forma de pagamento</md-subheader><br><md-content style=\"height:250px;margin-top:-30px\"><div \nng-class=\"{selectedPaymentForm : vm.customerDebitPayment, notSelectedPaymentForm : !vm.customerDebitPayment}\">\n<md-checkbox ng-model=\"vm.customerDebitPayment\">{{ \'GENERAL.PAYMENT_TYPE.CUSTOMERDEBIT\' | translate }}</md-checkbox>\n<br><div style=\"margin-top:0px;margin-left:0px\" layout=\"row\" ng-if=\"vm.customerDebitPayment\"><md-input-container><input\n type=\"number\" name=\"paidWithCUSTOMERDEBIT\" ng-model=\"vm.paidWithCUSTOMERDEBIT\" min=\"0\" \nng-required=\"vm.customerDebitPayment\" placeholder=\"R$\"></md-input-container></div></div><div \nng-class=\"{selectedPaymentForm : vm.cashPayment, notSelectedPaymentForm : !vm.cashPayment}\"><md-checkbox \nng-model=\"vm.cashPayment\" ng-click=\"vm.checkCash()\">{{ \'GENERAL.PAYMENT_TYPE.CASH\' | translate }}</md-checkbox><br><div\n style=\"margin-top:0px;margin-left:0px\" layout=\"row\" ng-if=\"vm.cashPayment\"><md-input-container><input type=\"number\" \nname=\"paidWithCASH\" ng-model=\"vm.paidWithCASH\" min=\"0\" ng-required=\"vm.cashPayment\" placeholder=\"R$\">\n</md-input-container></div></div><div \nng-class=\"{selectedPaymentForm : vm.checkPayment, notSelectedPaymentForm : !vm.checkPayment}\"><md-checkbox \nng-model=\"vm.checkPayment\" ng-click=\"vm.checkCheck()\">{{ \'GENERAL.PAYMENT_TYPE.CHECK\' | translate }}</md-checkbox><br>\n<div style=\"margin-top:0px;margin-left:0px\" layout=\"row\" ng-if=\"vm.checkPayment\"><md-input-container><input \ntype=\"number\" name=\"paidWithCHECK\" ng-model=\"vm.paidWithCHECK\" min=\"0\" ng-required=\"vm.checkPayment\" placeholder=\"R$\">\n</md-input-container><md-input-container ng-if=\"false\"><input type=\"text\" ng-model=\"vm.informationCheck\" \nplaceholder=\"Info.\"></md-input-container></div></div><div \nng-class=\"{selectedPaymentForm : vm.visaCreditPayment, notSelectedPaymentForm : !vm.visaCreditPayment}\"><md-checkbox \nng-model=\"vm.visaCreditPayment\" ng-click=\"vm.checkVisaCredit()\">{{ \'GENERAL.PAYMENT_TYPE.VISA_CREDIT\' | translate }}\n</md-checkbox><br><div style=\"margin-top:-10px;margin-left:0px\" layout=\"row\" ng-if=\"vm.visaCreditPayment\">\n<md-input-container><input type=\"number\" ng-model=\"vm.paidWithVisaCredit\" min=\"0\" ng-required=\"vm.visaCreditPayment\" \nplaceholder=\"R$\"></md-input-container><md-input-container><label>Adquirente</label><md-select \nng-model=\"vm.visaCreditOperadora\" name=\"adquirenteVisaCredito\"><md-option data-value=\"{{item.ADQU_TX_NAME}}\" \nng-repeat=\"item in vm.adquirentes\">{{item.ADQU_TX_NAME}}</md-option></md-select></md-input-container>\n<md-input-container><input type=\"number\" ng-model=\"vm.authorizationCodeVisaCredit\" min=\"0\" \nplaceholder=\"Cod. Autorização\"></md-input-container></div></div><div \nng-class=\"{selectedPaymentForm : vm.visaDebitPayment, notSelectedPaymentForm : !vm.visaDebitPayment}\"><md-checkbox \nng-model=\"vm.visaDebitPayment\" ng-click=\"vm.checkVisaDebit()\">{{ \'GENERAL.PAYMENT_TYPE.VISA_DEBIT\' | translate }}\n</md-checkbox><br><div style=\"margin-top:-10px;margin-left:0px\" layout=\"row\" ng-if=\"vm.visaDebitPayment\">\n<md-input-container><input type=\"number\" ng-model=\"vm.paidWithVisaDebit\" min=\"0\" ng-required=\"vm.visaDebitPayment\" \nplaceholder=\"R$\"></md-input-container><md-input-container><label>Adquirente</label><md-select \nng-model=\"vm.visaDebitOperadora\"><md-option data-value=\"{{item.ADQU_TX_NAME}}\" ng-repeat=\"item in vm.adquirentes\">\n{{item.ADQU_TX_NAME}}</md-option></md-select></md-input-container><md-input-container><input type=\"number\" \nng-model=\"vm.authorizationCodeVisaDebit\" min=\"0\" placeholder=\"Cod. Autorização\"></md-input-container></div></div><div \nng-class=\"{selectedPaymentForm : vm.masterCreditPayment, notSelectedPaymentForm : !vm.masterCreditPayment}\">\n<md-checkbox ng-model=\"vm.masterCreditPayment\" ng-click=\"vm.checkMasterCredit()\">\n{{ \'GENERAL.PAYMENT_TYPE.MASTER_CREDIT\' | translate }}</md-checkbox><br><div style=\"margin-top:-10px;margin-left:0px\" \nlayout=\"row\" ng-if=\"vm.masterCreditPayment\"><md-input-container><input type=\"number\" \nng-model=\"vm.paidWithMasterCredit\" min=\"0\" ng-required=\"vm.masterCreditPayment\" placeholder=\"R$\"></md-input-container>\n<md-input-container><label>Adquirente</label><md-select ng-model=\"vm.masterCreditOperadora\"><md-option \ndata-value=\"{{item.ADQU_TX_NAME}}\" ng-repeat=\"item in vm.adquirentes\">{{item.ADQU_TX_NAME}}</md-option></md-select>\n</md-input-container><md-input-container><input type=\"number\" ng-model=\"vm.authorizationCodeMasterCredit\" min=\"0\" \nplaceholder=\"Cod. Autorização\"></md-input-container></div></div><div \nng-class=\"{selectedPaymentForm : vm.masterDebitPayment, notSelectedPaymentForm : !vm.masterDebitPayment}\"><md-checkbox \nng-model=\"vm.masterDebitPayment\" ng-click=\"vm.checkMasterDebit()\">{{ \'GENERAL.PAYMENT_TYPE.MASTER_DEBIT\' | translate }}\n</md-checkbox><br><div style=\"margin-top:-10px;margin-left:0px\" layout=\"row\" ng-if=\"vm.masterDebitPayment\">\n<md-input-container><input type=\"number\" ng-model=\"vm.paidWithMasterDebit\" min=\"0\" ng-required=\"vm.masterDebitPayment\" \nplaceholder=\"R$\"></md-input-container><md-input-container><label>Adquirente</label><md-select \nng-model=\"vm.masterDebitOperadora\"><md-option data-value=\"{{item.ADQU_TX_NAME}}\" ng-repeat=\"item in vm.adquirentes\">\n{{item.ADQU_TX_NAME}}</md-option></md-select></md-input-container><md-input-container><input type=\"number\" \nng-model=\"vm.authorizationCodeMasterDebit\" min=\"0\" placeholder=\"Cod. Autorização\"></md-input-container></div></div><div\n ng-class=\"{selectedPaymentForm : vm.amexPayment, notSelectedPaymentForm : !vm.amexPayment}\"><md-checkbox \nng-model=\"vm.amexPayment\" ng-click=\"vm.checkAMEX()\">{{ \'GENERAL.PAYMENT_TYPE.AMEX\' | translate }}</md-checkbox><br><div\n style=\"margin-top:-10px;margin-left:0px\" layout=\"row\" ng-if=\"vm.amexPayment\"><md-input-container><input type=\"number\" \nng-model=\"vm.paidWithAMEX\" min=\"0\" ng-required=\"vm.amexPayment\" placeholder=\"R$\"></md-input-container>\n<md-input-container><label>Adquirente</label><md-select ng-model=\"vm.amexOperadora\"><md-option \ndata-value=\"{{item.ADQU_TX_NAME}}\" ng-repeat=\"item in vm.adquirentes\">{{item.ADQU_TX_NAME}}</md-option></md-select>\n</md-input-container><md-input-container><input type=\"number\" ng-model=\"vm.authorizationCodeAMEX\" min=\"0\" \nplaceholder=\"Cod. Autorização\"></md-input-container></div></div><div \nng-class=\"{selectedPaymentForm : vm.dinersPayment, notSelectedPaymentForm : !vm.dinersPayment}\"><md-checkbox \nng-model=\"vm.dinersPayment\" ng-click=\"vm.checkDINERS()\">{{ \'GENERAL.PAYMENT_TYPE.DINERS\' | translate }}</md-checkbox>\n<br><div style=\"margin-top:-10px;margin-left:0px\" layout=\"row\" ng-if=\"vm.dinersPayment\"><md-input-container><input \ntype=\"number\" ng-model=\"vm.paidWithDINERS\" min=\"0\" ng-required=\"vm.dinersPayment\" placeholder=\"R$\">\n</md-input-container><md-input-container><label>Adquirente</label><md-select ng-model=\"vm.dinersOperadora\"><md-option \ndata-value=\"{{item.ADQU_TX_NAME}}\" ng-repeat=\"item in vm.adquirentes\">{{item.ADQU_TX_NAME}}</md-option></md-select>\n</md-input-container><md-input-container><input type=\"number\" ng-model=\"vm.authorizationCodeDINERS\" min=\"0\" \nplaceholder=\"Cod. Autorização\"></md-input-container></div></div><div \nng-class=\"{selectedPaymentForm : vm.eloCreditPayment, notSelectedPaymentForm : !vm.eloCreditPayment}\"><md-checkbox \nng-model=\"vm.eloCreditPayment\" ng-click=\"vm.checkELOCredit()\">{{ \'GENERAL.PAYMENT_TYPE.ELO_CREDIT\' | translate }}\n</md-checkbox><br><div style=\"margin-top:-10px;margin-left:0px\" layout=\"row\" ng-if=\"vm.eloCreditPayment\">\n<md-input-container><input type=\"number\" ng-model=\"vm.paidWithELOCredit\" min=\"0\" ng-required=\"vm.eloCreditPayment\" \nplaceholder=\"R$\"></md-input-container><md-input-container><label>Adquirente</label><md-select \nng-model=\"vm.eloCreditOperadora\"><md-option data-value=\"{{item.ADQU_TX_NAME}}\" ng-repeat=\"item in vm.adquirentes\">\n{{item.ADQU_TX_NAME}}</md-option></md-select></md-input-container><md-input-container><input type=\"number\" \nng-model=\"vm.authorizationCodeELOCredit\" min=\"0\" placeholder=\"Cod. Autorização\"></md-input-container></div></div><div \nng-class=\"{selectedPaymentForm : vm.eloDebitPayment, notSelectedPaymentForm : !vm.eloDebitPayment}\"><md-checkbox \nng-model=\"vm.eloDebitPayment\" ng-click=\"vm.checkELODebit()\">{{ \'GENERAL.PAYMENT_TYPE.ELO_DEBIT\' | translate }}\n</md-checkbox><br><div style=\"margin-top:-10px;margin-left:0px\" layout=\"row\" ng-if=\"vm.eloDebitPayment\">\n<md-input-container><input type=\"number\" ng-model=\"vm.paidWithELODebit\" min=\"0\" ng-required=\"vm.eloDebitPayment\" \nplaceholder=\"R$\"></md-input-container><md-input-container><label>Adquirente</label><md-select \nng-model=\"vm.eloDebitOperadora\"><md-option data-value=\"{{item.ADQU_TX_NAME}}\" ng-repeat=\"item in vm.adquirentes\">\n{{item.ADQU_TX_NAME}}</md-option></md-select></md-input-container><md-input-container><input type=\"number\" \nng-model=\"vm.authorizationCodeELODebit\" min=\"0\" placeholder=\"Cod. Autorização\"></md-input-container></div></div><div \nng-class=\"{selectedPaymentForm : vm.otherCreditPayment, notSelectedPaymentForm : !vm.otherCreditPayment}\"><md-checkbox \nng-model=\"vm.otherCreditPayment\" ng-click=\"vm.checkOtherCredit()\">{{ \'GENERAL.PAYMENT_TYPE.OTHER_CREDIT\' | translate }}\n</md-checkbox><br><div style=\"margin-top:-10px;margin-left:0px\" layout=\"row\" ng-if=\"vm.otherCreditPayment\">\n<md-input-container><input type=\"number\" ng-model=\"vm.paidWithOtherCredit\" min=\"0\" ng-required=\"vm.otherCreditPayment\" \nplaceholder=\"R$\"></md-input-container><md-input-container><label>Adquirente</label><md-select \nng-model=\"vm.otherCreditOperadora\"><md-option data-value=\"{{item.ADQU_TX_NAME}}\" ng-repeat=\"item in vm.adquirentes\">\n{{item.ADQU_TX_NAME}}</md-option></md-select></md-input-container><md-input-container><input type=\"number\" \nng-model=\"vm.authorizationCodeOtherCredit\" min=\"0\" placeholder=\"Cod. Autorização\"></md-input-container></div></div><div\n ng-class=\"{selectedPaymentForm : vm.otherDebitPayment, notSelectedPaymentForm : !vm.otherDebitPayment}\"><md-checkbox \nng-model=\"vm.otherDebitPayment\" ng-click=\"vm.checkOtherDebit()\">{{ \'GENERAL.PAYMENT_TYPE.OTHER_DEBIT\' | translate }}\n</md-checkbox><br><div style=\"margin-top:-10px;margin-left:0px\" layout=\"row\" ng-if=\"vm.otherDebitPayment\">\n<md-input-container><input type=\"number\" ng-model=\"vm.paidWithOtherDebit\" min=\"0\" ng-required=\"vm.otherDebitPayment\" \nplaceholder=\"R$\"></md-input-container><md-input-container><label>Adquirente</label><md-select \nng-model=\"vm.otherDebitOperadora\"><md-option data-value=\"{{item.ADQU_TX_NAME}}\" ng-repeat=\"item in vm.adquirentes\">\n{{item.ADQU_TX_NAME}}</md-option></md-select></md-input-container><md-input-container><input type=\"number\" \nng-model=\"vm.authorizationCodeOtherDebit\" min=\"0\" placeholder=\"Cod. Autorização\"></md-input-container></div></div>\n</md-content></div><div style=\"width: 2px;background-color: lightblue;height:310px;margin-top:-31px\"></div><div \nstyle=\"width:399px\"><div layout=\"row\" style=\"margin-top:20px\"><md-input-container \nstyle=\"margin-top:-20px;left-margin:0px;padding-left:15px\" flex><layout style=\"font-size:12px\">Total em Deb/Cred\n</layout><input type=\"number\" name=\"paid\" ng-model=\"vm.totalValue\" ng-disabled=\"true\"></md-input-container>\n<md-input-container style=\"margin-top:-20px;left-margin:0px;padding-left:15px\" flex><layout style=\"font-size:12px\">\nTotal em din/che</layout><input type=\"number\" ng-model=\"vm.totalValueWithSpecialPaymentType\" ng-disabled=\"true\">\n</md-input-container><md-input-container style=\"margin-top:-20px;left-margin:0px;padding-left:15px\" flex><layout \nstyle=\"font-size:12px\">Cred/Deb Anterior</layout><input type=\"text\" name=\"customerCreditDebit\" \nng-model=\"vm.customer.creditDebit\" ng-disabled=\"true\"><br><span style=\"font-size:11px; color:Red\" \nng-if=\"vm.customer.creditDebit < 0\">{{vm.customer.lastCreditDebitObservation}}</span> <span \nstyle=\"font-size:11px; color:Blue\" ng-if=\"vm.customer.creditDebit > 0\">{{vm.customer.lastCreditDebitObservation}}\n</span></md-input-container></div><div layout=\"row\"><md-input-container \nstyle=\"margin-top:-20px;left-margin:0px;padding-left:15px\" flex><layout style=\"font-size:12px\">Valor devido</layout>\n<input type=\"text\" name=\"customerCreditDebit\" ng-model=\"vm.amountOwned\" ng-disabled=\"true\"><br></md-input-container>\n<md-input-container style=\"margin-top:-20px;left-margin:0px;padding-left:15px\" flex><layout style=\"font-size:12px\">\nDesconto Total (R$)</layout><input type=\"number\" name=\"giftCard\" ng-model=\"vm.giftCardValue\" min=\"0\">\n</md-input-container><md-input-container style=\"margin-top:-20px;left-margin:0px;padding-left:15px\" flex><layout \nstyle=\"font-size:12px\">Observação</layout><input type=\"text\" name=\"giftCardOBS\" ng-model=\"vm.giftCardObservation\"><div \nng-messages=\"basicForm.giftCardOBS.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"SALES.CHECKOUT.VALIDATION.EXPLANATION_REQUIRED\"></span></div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container style=\"margin-top:-20px;left-margin:0px;padding-left:15px\" flex><layout \nstyle=\"font-size:12px\">Valor após desconto</layout><input type=\"text\" name=\"amountOwnedAfterDiscount\" \nng-model=\"vm.amountOwnedAfterDiscount\" ng-disabled=\"true\"><br></md-input-container><md-input-container \nstyle=\"margin-top:-20px;left-margin:0px\" flex><layout style=\"font-size:12px\">Valor Pago (R$)</layout><input \ntype=\"number\" name=\"paid\" ng-model=\"vm.paid\" required disabled=\"disabled\"><div ng-messages=\"basicForm.paid.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{ \'SALES.CHECKOUT.VALIDATION.PAID_REQUIRED\' | translate }}</span></div>\n</div></md-input-container></div><div layout=\"row\" ng-if=\"vm.requestPassword\"><md-input-container \nstyle=\"width:100%;margin-left:10px;margin-top:-10px\"><label translate=\"GENERAL.ACCESSCODE\"></label><input \ntype=\"password\" name=\"accessCode\" ng-model=\"vm.accessCode\" required maxlength=\"10\"><div \nng-messages=\"basicForm.accessCode.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'GENERAL.ACCESSCODE.REQUIRED\' | translate }}</span></div></div></md-input-container></div></div></md-dialog-content>\n</md-content><md-divider></md-divider><md-dialog-actions layout=\"row\" layout-align=\"space-between \"><md-button \nng-click=\"vm.clickToSave()\" class=\"md-warn md-raised\" aria-label=\"SAVE\" \nng-disabled=\"vm.processing || (vm.paidWithDiscount < vm.amountOwned) || ( (vm.requestPassword) && ( (vm.accessCode == \'\') || (vm.accessCode == null))) \" \ntranslate=\"GENERAL.BUTTON.CHECKOUT\" translate-attr-aria-label=\"CALENDAR.SAVE\"></md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/sales/checkoutDialog2.html","<md-dialog aria-label=\"New Message\"><form name=\"basicForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{ \'SALES.CHECKOUT.HEADER\' | translate }}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"GENERAL.DIALOG.CLOSE\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content flex=\"100\" layout=\"row\" \nstyle=\"height:350px;width: 800px\"><div style=\"width:399px\" class=\"scrollable\"><md-button \nstyle=\"height: 60px; width:160px; border-radius: 8px;background: #4AA02C; color: white\" ng-click=\"vm.addGiftCard()\">\nConceder Desconto</md-button><md-button \nstyle=\"height: 60px; width:160px; border-radius: 8px;background: blue; color: white\" ng-click=\"vm.addCashPayment()\">\nDinheiro/Cheque</md-button><md-button \nstyle=\"height: 60px; width:160px; border-radius: 8px;background: #FCB63A; color: white\" \nng-click=\"vm.addWoweePayment(\'C\')\">WoWee Credito</md-button><md-button \nstyle=\"height: 60px; width:160px; border-radius: 8px;background: #FCB63A; color: white\" \nng-click=\"vm.addWoweePayment(\'D\')\">WoWee Debito</md-button><md-button \nstyle=\"height: 60px; width:160px;border-radius: 8px;background: blue; color: white\" ng-repeat=\"card in vm.cardsAux\" \nng-click=\"vm.addCardPayment(card.adquirenteId, card.creditoDebito)\">{{card.title}}</md-button></div><div \nstyle=\"width: 2px;background-color: lightblue;height:350px;margin-top:-31px\"></div><div style=\"width:350px\" \nclass=\"scrollable\"><div layout=\"row\" style=\"margin-top:20px\"><md-input-container \nstyle=\"margin-top:-20px;left-margin:0px;padding-left:15px\" flex><span \nstyle=\"font-size:15px;color:red;font-weight: bold\">Total de serviços contratados</span><br><layout \nstyle=\"font-size:40px;color:red\" flex>{{vm.totalValue | currency : \'R$ \' : 2}}</layout></md-input-container></div><div \nlayout=\"row\" style=\"border: 1px solid silver; height: 1px\">&nbsp;</div><div layout=\"row\" \nng-show=\"vm.totalValueWithSpecialPaymentType!=vm.totalValue\" style=\"margin-top:10px\"><layout \nng-style=\"vm.cashDiscountStyle\">\n(-) Desconto para pgto em dinheiro: {{(vm.totalValue - vm.totalValueWithSpecialPaymentType) | currency : \'R$ \': 2}}\n</layout></div><div layout=\"row\" ng-show=\"vm.customer.creditDebit > 0\"><layout style=\"padding-left: 10px;color:green\">\n(-) Creditos Anteriores: {{vm.customer.creditDebit | currency : \'R$\':2}}</layout></div><div layout=\"row\" \nng-show=\"vm.customer.creditDebit < 0\"><layout style=\"padding-left: 10px;color:red\">\n(+) Débitos Anteriores: {{-vm.customer.creditDebit | currency : \'R$\':2}}</layout></div><div layout=\"row\" \nng-if=\"vm.giftCardValue > 0\"><span style=\"padding-left: 10px;color:green\">\n(-) Descontos concedidos: {{vm.giftCardValue | currency : \'R$\': 2}}&nbsp;&nbsp;</span> <a href=\"#\" \nstyle=\"color: blue;text-decoration: underline\" ng-click=\"vm.cancelGiftCard()\">- Cancelar</a></div><div layout=\"row\" \nng-repeat=\"item in vm.payments\"><span style=\"padding-left: 10px;color:green\" ng-if=\"item.cardId != null\">\n(-) {{item.creditoDebito === \"C\" ? \"Credito\" : \"Debito\"}} - {{item.adquirenteName}} - {{item.value | currency : \'R$\': 2}}&nbsp;&nbsp;\n</span> <span style=\"padding-left: 10px;color:green\" ng-if=\"item.cardId == null\">\n(-) Pagamento em dinheiro - {{item.value | currency : \'R$\': 2}}&nbsp;&nbsp;</span> <a href=\"#\" \nstyle=\"color: blue;text-decoration: underline\" ng-click=\"vm.cancelPayment(item.id)\">- Cancelar</a></div></div>\n</md-dialog-content><md-divider></md-divider><md-dialog-actions layout=\"row\" align=\"end\"><md-button \nng-click=\"vm.saveCheckout()\" class=\"md-raised right\" aria-label=\"SAVE\" ng-style=\"vm.buttonColor\" \nng-disabled=\"vm.buttonDisabled || vm.loading\" translate-attr-aria-label=\"CALENDAR.SAVE\">{{vm.buttonName}}</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sales/closedList.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">{{ \'SALES.HEADER\' | translate }}\n</span></div><div class=\"title\">{{ \'SALES.CLOSEDCHECK.HEADER\' | translate }}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-raised gp-mini\" ng-click=\"showHelp(\'closedSales\');\">?<md-tooltip \naria-label=\"Pencil\">Vídeo Explicativo</md-tooltip></md-button></div></div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-4dp\"><table datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" \nclass=\"row-border hover\"></table></div></div></div>");
$templateCache.put("app/main/sales/openList.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">{{ \'SALES.HEADER\' | translate }}\n</span></div><div class=\"title\">{{ \'SALES.OPENCHECK.HEADER\' | translate }}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-raised\" ui-sref=\"app.sales.new\">{{ \'SALES.NEWCHECK\' | translate }}\n</md-button><md-button class=\"md-raised gp-mini\" ng-click=\"showHelp(\'openSales\');\">?<md-tooltip aria-label=\"Pencil\">\nVídeo Explicativo</md-tooltip></md-button></div></div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\" \nng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \ndt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{ \'SALES.OPENCHECK.CUSTOMER_NAME\' | translate }}</span></div></th><th class=\"secondary-text\"><div\n class=\"table-header\"><span class=\"column-title\">{{ \'SALES.OPENCHECK.CUSTOMER_TELEPHONE\' | translate }}</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'SALES.OPENCHECK.DATE\' | translate }}</span></div></th><th></th></tr></thead><tbody><tr \nng-repeat=\"check in ::vm.checks\"><td>{{ check.customerName }}</td><td>{{ check.customerTelephone }}</td><td>\n{{ check.checkoutDate | date:\'dd/MM/yyyy\'}}</td><td align=\"right\"><md-button ng-if=\"check.locked\" aria-label=\"Trash\" \nclass=\"md-raised gp-mini\" ng-click=\"vm.unlock(check._id)\"><md-tooltip aria-label=\"Pencil\">Destrancar comanda\n</md-tooltip><i class=\"icon-lock-unlocked-outline\" layout=\"center\"></i></md-button><md-button \nng-if=\"::vm.allowOpen(check)\" aria-label=\"cash\" class=\"md-raised gp-mini\" ng-click=\"vm.checkout(check._id)\"><md-tooltip\n aria-label=\"Cash\">Fechar comanda</md-tooltip><i class=\"icon-currency-usd\" layout=\"center\"></i></md-button><md-button \nng-if=\"vm.showDelete\" aria-label=\"Trash\" class=\"md-raised md-warn gp-mini\" ng-click=\"vm.removeCheck(check._id)\">\n<md-tooltip aria-label=\"Pencil\">{{ \'GENERAL.HINTS.TRASH\' | translate }}</md-tooltip><i class=\"icon-trash\" \nlayout=\"center\"></i></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/sales/productDialog.html","<md-dialog aria-label=\"New Message\" style=\"width:600px\"><form name=\"basicForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{ \'SALES.CHECK.ADDNEW_PRODUCT\' | translate }}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"GENERAL.DIALOG.CLOSE\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content layout=\"row\"><md-dialog-content\n ms-scroll flex=\"100\" style=\"width: 300px\"><md-autocomplete flex required style=\"height:70px\" \nmd-input-name=\"serviceId\" md-input-minlength=\"1\" md-no-cache=\"true\" md-autofocus=\"true\" \nmd-selected-item=\"vm.addServiceDialog.service\" md-search-text=\"vm.serviceSearchText\" \nmd-items=\"item in vm.productSearchTextChange(vm.serviceSearchText)\" md-item-text=\"item.name\" md-require-match \nng-attr-md-floating-label=\"{{vm.floatinglabel.product}}\"><md-item-template><span \nmd-highlight-text=\"vm.serviceSearchText\">{{item.name}}</span></md-item-template><div \nng-messages=\"basicForm.serviceId.$error\" ng-if=\"basicForm.serviceId.$touched\"><div ng-message=\"required\">\nÉ obrigatório informar o produto</div><div ng-message=\"md-require-match\">Produto Inválido</div></div></md-autocomplete>\n<md-autocomplete flex style=\"height:70px\" md-input-name=\"professionalId\" md-input-minlength=\"1\" md-no-cache=\"true\" \nmd-selected-item=\"vm.addServiceDialog.professional\" md-search-text=\"vm.professionalSearchText\" \nmd-items=\"item in vm.professionalSearchTextChange(vm.professionalSearchText)\" md-item-text=\"item.name\" \nmd-require-match ng-attr-md-floating-label=\"{{vm.floatinglabel.professional}}\"><md-item-template><span \nmd-highlight-text=\"vm.professionalSearchText\">{{item.name}}</span></md-item-template><div \nng-messages=\"basicForm.professionalId.$error\" ng-if=\"basicForm.professionalId.$touched\"><div ng-message=\"required\">\n<span translate=\"SCHEDULE.VALIDATION.PROFESSIONAL_REQUIRED\"></span></div><div ng-message=\"md-require-match\"><span \ntranslate=\"SCHEDULE.VALIDATION.PROFESSIONAL_INVALID\"></span></div></div></md-autocomplete></md-dialog-content>\n</md-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button \nng-click=\"vm.addServiceInList()\" class=\"md-warn md-raised\" aria-label=\"SAVE\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\" translate=\"GENERAL.BUTTON.SAVE\"></md-button><md-button \nng-click=\"vm.closeDialog()\" class=\"md-accent md-raised\" aria-label=\"SAVE\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\" translate=\"GENERAL.BUTTON.CANCEL\"></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sales/sale.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">{{ \'SALES.HEADER\' | translate }}\n</span></div><div class=\"title\">{{ \'SALES.OPENCHECK.HEADER\' | translate }}</div></div></div><div class=\"content\" \nlayout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" \nng-submit=\"vm.newSale()\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-autocomplete flex required \nmd-input-name=\"customerId\" md-autofocus=\"true\" md-input-minlength=\"1\" md-no-cache=\"true\" \nmd-selected-item=\"vm.sale.customer\" md-search-text=\"vm.customerSearchText\" \nmd-items=\"item in vm.customerSearchTextChange(vm.customerSearchText)\" md-item-text=\"item.name\" \nplaceholder=\"Informe o nome ou telefone do cliente\" ng-attr-md-floating-label=\"{{vm.floatinglabel.customer}}\" \nmd-require-match><md-item-template><span md-highlight-text=\"vm.customerNameSearchText\">{{item.name}}</span>\n</md-item-template><div ng-messages=\"basicForm.customerId.$error\" ng-if=\"basicForm.customerId.$touched\"><div \nng-message=\"required\"><span translate=\"SCHEDULE.VALIDATION.CUSTOMER_REQUIRED\"></span></div><div \nng-message=\"md-require-match\"><span translate=\"SCHEDULE.VALIDATION.CUSTOMER_INVALID\">. </span><a href=\"#\" \nng-click=\"vm.newCustomer()\">Deseja cadastrar como novo cliente?</a></div></div></md-autocomplete></div><div \nlayout=\"column\" layout-gt-sm=\"row\" style=\"width:470px;margin-left:-10px;margin-top:0px\" ng-if=\"vm.showPdvLocation\">\n<md-input-container style=\"width:100%;margin-left:20px;margin-top:30px\"><label>Local de Atendimento</label><md-select \nng-model=\"vm.pdvLocation\" required><md-option ng-value=\"item.locationId\" ng-repeat=\"item in vm.pdvLocations\">\n{{item.name}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-datepicker \nmd-placeholder=\"Data\" style=\"width:200px;margin-left:0px;margin-top:-30px;font-weight:bolder;color:white\" \nng-model=\"vm.checkoutDate\" md-max-date=\"vm.maxDate\" md-is-open=\"vm.isOpen\"></md-datepicker></div><md-button \ntype=\"submit\" class=\"md-raised\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">\n{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button><md-button type=\"button\" class=\"md-raised md-warn\" \naria-label=\"Cancel\" ui-sref=\"app.sales.open\">{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button></form></div></div>\n</div>");
$templateCache.put("app/main/sales/serviceDialog.html","<md-dialog aria-label=\"New Message\" style=\"width:600px\"><form name=\"basicForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{ \'SALES.CHECK.ADDNEW_SERVICE\' | translate }}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"GENERAL.DIALOG.CLOSE\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content layout=\"row\"><md-dialog-content\n ms-scroll flex=\"100\" style=\"width: 300px\"><md-autocomplete flex required style=\"height:70px\" \nmd-input-name=\"serviceId\" md-input-minlength=\"1\" md-no-cache=\"true\" md-autofocus=\"true\" \nmd-selected-item=\"vm.addServiceDialog.service\" md-search-text=\"vm.serviceSearchText\" \nmd-items=\"item in vm.serviceSearchTextChange(vm.serviceSearchText)\" md-item-text=\"item.name\" md-require-match \nng-attr-md-floating-label=\"{{vm.floatinglabel.service}}\"><md-item-template><span \nmd-highlight-text=\"vm.serviceSearchText\">{{item.name}}</span></md-item-template><div \nng-messages=\"basicForm.serviceId.$error\" ng-if=\"basicForm.serviceId.$touched\"><div ng-message=\"required\"><span \ntranslate=\"SCHEDULE.VALIDATION.SERVICE_REQUIRED\"></span></div><div ng-message=\"md-require-match\"><span \ntranslate=\"SCHEDULE.VALIDATION.SERVICE_INVALID\"></span></div></div></md-autocomplete><md-autocomplete flex required \nstyle=\"height:70px\" md-input-name=\"professionalId\" md-input-minlength=\"1\" md-no-cache=\"true\" \nmd-selected-item=\"vm.addServiceDialog.professional\" md-search-text=\"vm.professionalSearchText\" \nmd-items=\"item in vm.professionalSearchTextChange(vm.professionalSearchText)\" md-item-text=\"item.name\" \nmd-require-match ng-attr-md-floating-label=\"Profissional\"><md-item-template><span \nmd-highlight-text=\"vm.professionalSearchText\">{{item.name}}</span></md-item-template><div \nng-messages=\"basicForm.professionalId.$error\" ng-if=\"basicForm.professionalId.$touched\"><div ng-message=\"required\">\n<span translate=\"SCHEDULE.VALIDATION.PROFESSIONAL_REQUIRED\"></span></div><div ng-message=\"md-require-match\"><span \ntranslate=\"SCHEDULE.VALIDATION.PROFESSIONAL_INVALID\"></span></div></div></md-autocomplete><md-autocomplete flex \nstyle=\"height:70px\" md-input-name=\"professionalId2\" md-input-minlength=\"1\" md-no-cache=\"true\" \nmd-selected-item=\"vm.addServiceDialog.professional2\" md-search-text=\"vm.professionalSearchText2\" \nmd-items=\"item in vm.professionalSearchTextChange(vm.professionalSearchText2)\" md-item-text=\"item.name\" \nmd-require-match ng-attr-md-floating-label=\"Ajudante\"><md-item-template><span \nmd-highlight-text=\"vm.professionalSearchText2\">{{item.name}}</span></md-item-template></md-autocomplete>\n</md-dialog-content></md-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button \nng-click=\"vm.addServiceInList()\" class=\"md-warn md-raised\" aria-label=\"SAVE\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\" translate=\"GENERAL.BUTTON.SAVE\"></md-button><md-button \nng-click=\"vm.closeDialog()\" class=\"md-accent md-raised\" aria-label=\"CANCEL\" translate=\"GENERAL.BUTTON.CANCEL\">\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/support/onboard.html","<md-dialog aria-label=\"Video Help\" style=\"height:70%;max-height:70%;width:60%\"><form ng-cloak name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar ng-if=\"!step1\"><div class=\"md-toolbar-tools\" \nstyle=\"background: #FCB63A; color:#000000\"><h2>Antes de começarmos nos ajude respondendo a essas perguntas</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"close()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><iframe ng-if=\"step1\" \nstyle=\"position:fixed; top:00px; left:0px; bottom:0px; right:0px; width:100%; height:88%; border:none; margin:0; padding:0; overflow:hidden; z-index:999999\" \nsrc=\"https://www.wowee.club/programa-para-salao-e-barbearia/features.html\" frameborder=\"0\" allowfullscreen></iframe>\n<md-content ng-if=\"!step1\" flex><div layout=\"row\" flex=\"100\"><md-input-container \nstyle=\"margin: 20px; margin-top: 40px\" flex><label>Quantos atendimentos você realiza por mês?</label><md-select \nng-model=\"vm.numeroAtendimentos\"><md-option data-value=\"100\">100 atendimentos mais ou menos</md-option><md-option \ndata-value=\"300\">300 atendimentos mais ou menos</md-option><md-option data-value=\"700\">700 atendimentos mais ou menos\n</md-option><md-option data-value=\"1000\">Mais de 1000 atendimentos</md-option></md-select></md-input-container>\n<md-input-container style=\"margin: 20px; margin-top: 40px\" flex><label>Quantos profissionais trabalham em seu salão?\n</label><md-select ng-model=\"vm.numeroProfissionais\"><md-option data-value=\"1\">Somente eu mesmo</md-option><md-option \ndata-value=\"3\">Somos eu e mais dois profissionais</md-option><md-option data-value=\"7\">\nSomos por volta de 7 profissionais</md-option><md-option data-value=\"12\">Somos por volta de 12 profissionais\n</md-option><md-option data-value=\"20\">Temos um total de 20 ou mais profissionais</md-option></md-select>\n</md-input-container></div><div layout=\"row\" flex=\"100\"><md-input-container style=\"margin: 20px; margin-top: 40px\" \nflex><label>Quais formas de pagamento você aceita?</label><md-select ng-model=\"vm.formaPagamento\"><md-option \ndata-value=\"DINHEIRO\">Somente dinheiro</md-option><md-option data-value=\"DINHEIRO_E_DEBITO\">\nDinheiro, cheque e cartões de débito</md-option><md-option data-value=\"TODAS\">Todas</md-option></md-select>\n</md-input-container><md-input-container style=\"margin: 20px; margin-top: 40px\" flex><label>\nVocê precisa de ajuda com a lei do salão parceiro?</label><md-select ng-model=\"vm.leiSalaoParceiro\"><md-option \ndata-value=\"SIM\">Sim</md-option><md-option data-value=\"NAO\">Nao</md-option></md-select></md-input-container></div>\n<md-subheader>Quer falar com um de nossos consultores para que ele te apresente o sistema?</md-subheader><div \nlayout=\"row\" flex=\"100\"><md-input-container style=\"margin: 20px; margin-top: 40px\" flex><label>Informe seu telefone\n</label><input type=\"tel\" ng-model=\"vm.telefone\"></md-input-container><md-input-container \nstyle=\"margin: 20px; margin-top: 40px\" flex><label>Informe seu email</label><input type=\"email\" ng-model=\"vm.email\">\n</md-input-container></div></md-content><md-divider style=\"position: fixed; right: 0px; bottom:40px\"></md-divider>\n<md-dialog-actions layout=\"row\" style=\"position: fixed; right: 0px; bottom:0px\"><span flex></span><md-button \nclass=\"md-raised\" ng-click=\"gotoStart()\" ng-if=\"step1\">Gostou? Vamos começar?</md-button><md-button class=\"md-raised\" \nng-click=\"saveAndClose(true)\" ng-if=\"!step1\">Quero que alguém me apresente o sistema</md-button><md-button \nclass=\"md-raised\" ng-click=\"saveAndClose(false)\" ng-if=\"!step1\">Só quero conhecer o sistema</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/support/ppt.html","<md-dialog aria-label=\"Video Help\" style=\"height:70%;max-height:70%;width:60%\"><form ng-cloak name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar><div class=\"md-toolbar-tools\" style=\"background: #FCB63A; color:#000000\">\n<h2>Veja o que podemos fazer pelo seu salão</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"close()\">\n<md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><iframe ng-if=\"step1\" \nstyle=\"position:fixed; top:60px; left:0px; bottom:0px; right:0px; width:100%; height:95%; border:none; margin:0; padding:0; overflow:hidden; z-index:999999\" \nsrc=\"https://www.wowee.club/programa-para-salao-e-barbearia/features.html\" frameborder=\"0\" allowfullscreen></iframe>\n</form></md-dialog>");
$templateCache.put("app/main/support/videoHelp.html","<md-dialog aria-label=\"Video Help\" style=\"height:530px;max-height:530px\"><form ng-cloak><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Ajuda - {{videoHelp}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"close()\"><md-icon md-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><iframe width=\"560\" height=\"315\" \nsrc=\"{{url}}\" frameborder=\"0\" allowfullscreen></iframe><div layout=\"row\" ng-show=\"otherVideos.length > 0\">Veja também: \n<span ng-repeat=\"other in otherVideos\">&nbsp;<a href=\"#\" ng-click=\"changeVideo(other.videoId)\">{{other.title}}</a>\n &nbsp;|&nbsp;</span></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nclass=\"md-raised\" ng-click=\"goto()\">Abrir em tela cheia</md-button><md-button class=\"md-raised\" \nng-click=\"gotoSupport()\">Continuo com dúvidas</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/wizard/wizard.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">\nBem vindo ao SP System</div></div></div><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><p style=\"margin-left:20px; font-size:20px\">\nOlá, antes de dar inicio a revolução no seu salão é necessário seguir alguns passos de configuração...<br><br></p>\n<table style=\"width:100%\"><tr><td><md-button ng-class=\"vm.serviceClass\" style=\"height:87px;width:200px\" \nui-sref=\"app.settings.service.service.new({wizard:true})\"><md-tooltip>\nClique aqui para cadastrar os serviços que você presta.</md-tooltip>Cadastrar<br>Serviços</md-button><br><span \nng-style=\"vm.serviceStyle\">{{vm.service}}</span></td><td><img src=\"assets/images/chevron_right1600.png\"></td><td>\n<md-button ng-class=\"vm.professionalClass\" style=\"height:87px;width:200px\" \nui-sref=\"app.professional.new({wizard:true})\"><md-tooltip>\nClique aqui para cadastrar os profissionais que atendem em seu salão.</md-tooltip>Cadastrar<br>Profissionais\n</md-button><br><span ng-style=\"vm.professionalStyle\">{{vm.professional}}</span></td></tr></table></div></div></div>");
$templateCache.put("app/main/stock/entry.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Controle de Estoque</span></div>\n<div class=\"title\">Entrada de Estoque</div></div></div><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" ng-submit=\"vm.saveCategory()\" \nnovalidate><div layout=\"row\" layout-gt-sm=\"row\"><md-autocomplete flex required style=\"height:70px\" \nmd-input-name=\"productId\" md-input-minlength=\"1\" md-no-cache=\"true\" md-autofocus=\"true\" md-selected-item=\"vm.product\" \nmd-search-text=\"vm.productSearchText\" md-items=\"item in vm.productSearchTextChange(vm.productSearchText)\" \nmd-item-text=\"item.name\" md-require-match ng-attr-md-floating-label=\"Produto\"><md-item-template><span \nmd-highlight-text=\"vm.productSearchText\">{{item.name}}</span></md-item-template><div \nng-messages=\"basicForm.productId.$error\" ng-if=\"basicForm.productId.$touched\"><div ng-message=\"required\">\nÉ obrigatório informar o produto</div><div ng-message=\"md-require-match\">Produto Inválido</div></div></md-autocomplete>\n</div><div layout=\"row\" layout-gt-sm=\"row\"><md-radio-group ng-model=\"vm.operationType\"><md-radio-button \ndata-value=\"SET\">Desejo setar a quantidade do estoque</md-radio-button><br><md-radio-button data-value=\"ADD\">\nDesejo registrar uma compra/adição ao estoque</md-radio-button><br><md-radio-button data-value=\"SUBTRACT\">\nDesejo registrar uma perda/subtração ao estoque</md-radio-button><br></md-radio-group></div><div layout=\"row\" \nlayout-gt-sm=\"row\" flex=\"25\"><md-input-container flex><label>Quantidade</label><input type=\"number\" name=\"value\" \nng-model=\"vm.value\" min=\"1\" required><div ng-messages=\"basicForm.value.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>É obrigatório preencher uma quantidade</span></div></div></md-input-container></div><md-button type=\"button\" \nng-click=\"vm.saveEntry()\" class=\"md-raised\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">\n{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button><md-button type=\"button\" class=\"md-raised md-warn\" \naria-label=\"Cancel\" ui-sref=\"app.settings.product.category.list\">{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button>\n</form></div></div></div>");
$templateCache.put("app/main/stock/list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Controle de Estoque</span></div>\n<div class=\"title\">Listagem de Estoque</div></div></div><div class=\"content\"><div class=\"white-bg md-whiteframe-40dp\" \nlayout=\"row\" layout-align=\"center center\" height=\"100px\" ng-show=\"!vm.showTable\"><br><span \nstyle=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></div><div class=\"white-bg md-whiteframe-4dp\" \nng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \ndt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Produto</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Qtd. Min</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Qtd. Max</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Qtd. Atual</span></div></th><th></th></tr></thead><tbody><tr ng-repeat=\"product in ::vm.products\">\n<td>{{ product.name }}</td><td>{{ product.minQty }}</td><td>{{ product.maxQty }}</td><td>{{ product.qty }}</td><td \nalign=\"right\"></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/main/auth/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><h1>WoWee</h1>\n<div class=\"title\" translate=\"AUTH.FORGOT-PASSWORD.TITLE\"></div><form name=\"form\" novalidate \nng-submit=\"vm.getPassword()\"><md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" \nng-model=\"vm.forgotPassword.email\" placeholder=\"Email address\" translate \ntranslate-attr-placeholder=\"AUTH.FORGOT-PASSWORD.EMAIL_ADRESS\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"form.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"AUTH.FORGOT-PASSWORD.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\">\n<span translate=\"AUTH.FORGOT-PASSWORD.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"RESET MY PASSWORD\" \nng-disabled=\"form.$invalid || form.$pristine\" translate=\"AUTH.FORGOT-PASSWORD.SEND_RESET_LINK\" \ntranslate-attr-aria-label=\"AUTH.FORGOT-PASSWORD.SEND_RESET_LINK\">SEND RESET LINK</md-button></form><div class=\"login\" \nlayout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"app.auth.signin\" \ntranslate=\"AUTH.FORGOT-PASSWORD.GO_BACK\">Go back to login</a></div></div></div></div>");
$templateCache.put("app/main/auth/signin/mobile.html","<md-dialog aria-label=\"Mango (Fruit)\"><form ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nGP Software - Versão Mobile</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"cancel()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><h2>\nVocê está acessando o software a partir de um celular ou tablet.</h2><p>\nPossuímos 2 versões do software, uma para funcionar em computadores e outra para funcionar em tablets e celulares. Como você está acessando através de um celular, recomendamos que baixe a versão android.\n</p></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nng-click=\"answer(\'ACCESS_WEB\')\">Quero acessar a versão web mesmo</md-button><md-button \nng-click=\"answer(\'REDIRECT_PAGE\')\">Quero baixar a versão adequada</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/auth/signin/signin.html","<div id=\"login-v2\" layout=\"row\" layout-align=\"start\"><div id=\"login-v2-intro\" flex hide show-gt-sm style=\"height:100%\">\n<img src=\"https://s3.amazonaws.com/gpsalao.gpsoftware.com.br/content/Ativo+176%4015x.png\" \nstyle=\"position: absolute;margin:20px;bottom:0;left: 0;width:400px\"></div><div id=\"login-v2-form-wrapper\" \nclass=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div id=\"login-v2-form\"><div class=\"logo md-accent-bg\" hide-gt-sm>\n<span>GP</span></div><div class=\"title\" translate=\"AUTH.SIGNIN.TITLE\" ng-if=\"(!vm.requestEmail)\"></div><div \nclass=\"title\" ng-if=\"(vm.requestEmail)\">Informe seu e-mail por favor</div><form name=\"loginForm\" novalidate \nng-submit=\"vm.login()\"><md-input-container class=\"md-block\" md-no-float ng-if=\"(!vm.requestEmail)\"><input type=\"text\" \nname=\"login\" ng-model=\"vm.user.login\" placeholder=\"Email\" translate translate-attr-placeholder=\"AUTH.SIGNIN.EMAIL\" \nrequired><div ng-messages=\"loginForm.login.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"AUTH.SIGNIN.ERRORS.EMAIL_REQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float ng-if=\"(!vm.requestEmail)\"><input type=\"password\" name=\"password\" \nng-model=\"vm.user.password\" placeholder=\"Password\" translate translate-attr-placeholder=\"AUTH.SIGNIN.PASSWORD\" \nrequired><div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"AUTH.SIGNIN.ERRORS.PASSWORD_REQUIRED\"></span></div></div><a class=\"link\" \nstyle=\"font-size:13px; cursor:pointer\" ui-sref=\"app.auth.forgot-password\">\nEsqueceu sua senha? &nbsp; Resgate aqui sua senha.</a></md-input-container><md-button type=\"submit\" \nstyle=\"margin-top:20px\" class=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine \" ng-if=\"(!vm.requestEmail)\" translate=\"AUTH.SIGNIN.LOG_IN\" \ntranslate-attr-aria-label=\"AUTH.SIGNIN.LOG_IN\"></md-button><div class=\"login\" layout=\"row\" layout-sm=\"column\" \nlayout-align=\"center center\" style=\"font-size:13px;margin-top:-10px\" \nng-if=\"vm.showButtonSignup() && (!vm.requestEmail);\"><a class=\"link\" ui-sref=\"app.auth.signup\">\nAinda não tem uma conta? &nbsp; Crie sua conta agora.</a></div><div class=\"separator\" \nng-if=\"vm.showButtonSignup() && (!vm.requestEmail)\"><span class=\"text\">OU</span></div><div layout=\"column\" \nlayout-align=\"start center\" ng-if=\"vm.showButtonSignup() && (!vm.requestEmail)\"><md-button class=\"md-raised facebook\" \nng-click=\"vm.facebookLogin()\"><div layout=\"row\" layout-align=\"center center\"><span><md-icon \nmd-font-icon=\"icon-facebook\" class=\"s16\"></md-icon><span>Log in com Facebook</span></span></div></md-button></div>\n<md-input-container class=\"md-block\" md-no-float ng-if=\"(vm.requestEmail)\"><input type=\"text\" name=\"login\" \nng-model=\"vm.user.email\" placeholder=\"Email\" translate translate-attr-placeholder=\"AUTH.SIGNIN.EMAIL\" required><div \nng-messages=\"loginForm.login.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"AUTH.SIGNIN.ERRORS.EMAIL_REQUIRED\"></span></div></div></md-input-container><div layout=\"column\" \nlayout-align=\"start center\" ng-if=\"vm.requestEmail\"><md-button class=\"md-raised facebook\" \nng-click=\"vm.registerEmailFBSignIn()\"><div layout=\"row\" layout-align=\"center center\"><span><span>\nRegistrar Email e Entrar</span></span></div></md-button></div></form></div></div></div>");
$templateCache.put("app/main/finance/extrato/createRPS.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Financeiro</span></div><div \nclass=\"title\">Gerar RPS</div></div><div layout=\"row\" layout-align=\"start center\"><span \nstyle=\"color:white;font-weight:bold;font-size:35px;cursor:pointer\" ng-click=\"vm.previousMonth();\"><md-tooltip>\nMês Anterior</md-tooltip>&nbsp;&#60;&nbsp;</span> <span style=\"color:white;font-size:20px\">\n{{vm.formattedSelectedMonth}}</span> <span style=\"color:white;font-weight:bold;font-size:35px;cursor:pointer\" \nng-click=\"vm.nextMonth();\"><md-tooltip>Próximo Anterior</md-tooltip>&nbsp;&#62;&nbsp;</span>\n &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<md-select name=\"professional\" ng-model=\"vm.professionalId\" \nstyle=\"color:white;font-weight:bold;font-size:16px\" ng-change=\"vm.refresh()\"><md-option ng-value=\"item._id\" \nng-repeat=\"item in vm.professionals\">{{item.name}}</md-option></md-select><md-button class=\"md-raised md-green-50-bg\" \nng-click=\"vm.createRPS();\">Gerar RPS</md-button></div></div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-40dp\" layout=\"row\" layout-align=\"center center\" height=\"100px\" ng-show=\"!vm.showTable\">\n<br><span style=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></div><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">&nbsp;</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Data</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Descrição</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Valor</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Num. RPS</span></div></th></tr></thead>\n<tbody compile=\"vm.html\" id=\"code\"></tbody></table></div></div><md-sidenav class=\"md-sidenav-right\" \nmd-component-id=\"filter\" md-is-locked-open=\"false\" md-whiteframe=\"4\"><md-toolbar class=\"md-hue-2\"><div \nclass=\"md-toolbar-tools\"><h2>Trocar conta</h2><span flex></span><md-button class=\"md-raised md-orange-500-bg\" \naria-label=\"Refresh\" ng-click=\"vm.refresh()\">{{\'GENERAL.REFRESH\'|translate}}</md-button></div></md-toolbar><md-content \nlayout-padding><md-subheader style=\"margin-left: -20px\">Conta Bancária</md-subheader><div layout=\"row\"><md-select \nname=\"bankAccount\" ng-model=\"vm.bankAccountId\" style=\"width:80%\"><md-option ng-value=\"item.BAAC_CD_BANK_ACCOUNT\" \nng-repeat=\"item in vm.bankAccounts\">{{item.BANK_TX_NAME}} ({{item.BAAC_TX_AGENCIA}} | {{item.BAAC_TX_CONTA}})\n</md-option></md-select></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/finance/extrato/extrato.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Financeiro</span></div><div \nclass=\"title\">Extrato</div></div><div layout=\"row\" layout-align=\"start center\"><span \nstyle=\"color:white;font-weight:bold;font-size:35px;cursor:pointer\" ng-click=\"vm.previousMonth();\"><md-tooltip>\nMês Anterior</md-tooltip>&nbsp;&#60;&nbsp;</span> <span style=\"color:white;font-size:20px\">\n{{vm.formattedSelectedMonth}}</span> <span style=\"color:white;font-weight:bold;font-size:35px;cursor:pointer\" \nng-click=\"vm.nextMonth();\"><md-tooltip>Próximo Anterior</md-tooltip>&nbsp;&#62;&nbsp; </span>\n&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<md-select name=\"bankAccount\" ng-model=\"vm.bankAccountId\" \nstyle=\"color:white;font-weight:bold;font-size:16px\" ng-change=\"vm.refresh()\"><md-option \nng-value=\"item.BAAC_CD_BANK_ACCOUNT\" ng-repeat=\"item in vm.bankAccounts\">{{item.BANK_TX_NAME}}<br>\n({{item.BAAC_TX_AGENCIA}} | {{item.BAAC_TX_CONTA}})</md-option></md-select><md-button class=\"md-raised\" \nui-sref=\"app.finance.newreceivable\">Novo Recebimento</md-button><md-button class=\"md-raised\" \nui-sref=\"app.finance.newpayment\">Novo Pagamento</md-button><md-button class=\"md-raised\" ui-sref=\"app.finance.transfer\">\nTransferência</md-button></div></div><div class=\"content\"><div class=\"white-bg md-whiteframe-40dp\" layout=\"row\" \nlayout-align=\"center center\" height=\"100px\" ng-show=\"!vm.showTable\"><br><span \nstyle=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></div><div class=\"white-bg md-whiteframe-4dp\" \nng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Data</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Nome</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Descrição</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Entrada</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Saída</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Saldo</span></div></th><th style=\"width: 50px\">&nbsp;</th></tr></thead>\n<tbody compile=\"vm.html\" id=\"code\"></tbody></table></div></div><md-sidenav class=\"md-sidenav-right\" \nmd-component-id=\"filter\" md-is-locked-open=\"false\" md-whiteframe=\"4\"><md-toolbar class=\"md-hue-2\"><div \nclass=\"md-toolbar-tools\"><h2>Trocar conta</h2><span flex></span><md-button class=\"md-raised md-orange-500-bg\" \naria-label=\"Refresh\" ng-click=\"vm.refresh()\">{{\'GENERAL.REFRESH\'|translate}}</md-button></div></md-toolbar><md-content \nlayout-padding><md-subheader style=\"margin-left: -20px\">Conta Bancária</md-subheader><div layout=\"row\"><md-select \nname=\"bankAccount\" ng-model=\"vm.bankAccountId\" style=\"width:80%\"><md-option ng-value=\"item.BAAC_CD_BANK_ACCOUNT\" \nng-repeat=\"item in vm.bankAccounts\">{{item.BANK_TX_NAME}} ({{item.BAAC_TX_AGENCIA}} | {{item.BAAC_TX_CONTA}})\n</md-option></md-select></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/finance/extrato/newprofessionalpayment.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">Financeiro</span></div><div class=\"title\">Pagamento/Vale de MEI</div></div></div><div \nclass=\"content\" layout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.saveTransaction()\" novalidate><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"margin-bottom: 5px\">Data:<md-datepicker ng-model=\"vm.when\" style=\"margin-top:-2px\"></md-datepicker></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Banco</label><md-select name=\"bank\" \nng-model=\"vm.bankAccountId\"><md-option ng-value=\"item.BAAC_CD_BANK_ACCOUNT\" ng-repeat=\"item in vm.bankAccounts\">\n{{item.BANK_TX_NAME}}({{item.BAAC_TX_AGENCIA}} | {{item.BAAC_TX_CONTA}})</md-option></md-select></md-input-container>\n<md-input-container flex><label>Profissional</label><md-select name=\"professional\" ng-model=\"vm.professionalId\">\n<md-option ng-value=\"item._id\" ng-repeat=\"item in vm.professionals\">{{item.name}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Valor</label><input \ntype=\"number\" name=\"value\" ng-model=\"vm.value\" required min=\"0.01\"><div ng-messages=\"basicForm.value.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>O valor é um campo obrigatório</span></div></div></md-input-container>\n<md-input-container flex><label>Observação</label><input type=\"text\" name=\"agencia\" ng-model=\"vm.observation\">\n</md-input-container></div><md-button type=\"submit\" class=\"md-raised\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid\">{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button><md-button type=\"button\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\" ui-sref=\"app.finance.professional\">\n{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/finance/extrato/pagamento.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">Financeiro</span></div><div class=\"title\">Novo Pagamento</div></div></div><div class=\"content\" \nlayout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" \nng-submit=\"vm.saveTransaction()\" novalidate><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-bottom: 5px\">Data:\n<md-datepicker ng-model=\"vm.when\" style=\"margin-top:-2px\"></md-datepicker></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label>Banco</label><md-select name=\"bank\" ng-model=\"vm.bankAccountId\">\n<md-option ng-value=\"item.BAAC_CD_BANK_ACCOUNT\" ng-repeat=\"item in vm.bankAccounts\">\n{{item.BANK_TX_NAME}}({{item.BAAC_TX_AGENCIA}} | {{item.BAAC_TX_CONTA}})</md-option></md-select></md-input-container>\n<md-input-container flex><md-radio-group ng-model=\"vm.type\" style=\"margin-left:20px\"><md-radio-button name=\"SUPPLIER\" \ndata-value=\"SUPPLIER\">Fornecedor</md-radio-button><md-radio-button name=\"PARTNER\" data-value=\"PARTNER\">\nRetirada de Capital</md-radio-button><md-radio-button name=\"PROFESSIONAL\" data-value=\"PROFESSIONAL\">\nPagamento de Profissional</md-radio-button></md-radio-group></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex ng-if=\"vm.type == \'SUPPLIER\'\"><label>Fornecedor</label><md-select \nname=\"bank\" ng-model=\"vm.supplierId\"><md-option ng-value=\"item.SUPP_CD_SUPPLIER\" ng-repeat=\"item in vm.suppliers\">\n{{item.SUPP_TX_NAME}}</md-option></md-select></md-input-container><md-input-container flex \nng-if=\"vm.type == \'PARTNER\'\"><label>Sócio</label><md-select name=\"bank\" ng-model=\"vm.partnerId\"><md-option \nng-value=\"item.PART_CD_PARTNER\" ng-repeat=\"item in vm.partners\">{{item.PART_TX_NAME}}</md-option></md-select>\n</md-input-container><md-input-container flex ng-if=\"vm.type==\'PROFESSIONAL\'\"><label>Profissional</label><md-select \nname=\"bank\" ng-model=\"vm.supplierId\"><md-option ng-value=\"item.SUPP_CD_SUPPLIER\" ng-repeat=\"item in vm.suppliers\">\n{{item.SUPP_TX_NAME}}</md-option></md-select></md-input-container><md-input-container flex><label>Categoria</label>\n<md-select name=\"bank\" ng-model=\"vm.categoryId\"><md-option ng-value=\"item.FICA_CD_FINANCE_CATEGORY\" \nng-repeat=\"item in vm.categories\">{{item.FICA_TX_NAME}}</md-option></md-select></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Valor</label><input type=\"number\" name=\"value\" \nng-model=\"vm.value\" required min=\"0.01\"><div ng-messages=\"basicForm.value.$error\" role=\"alert\"><div \nng-message=\"required\"><span>O valor é um campo obrigatório</span></div></div></md-input-container><md-input-container \nflex><label>Observação</label><input type=\"text\" name=\"agencia\" ng-model=\"vm.observation\"></md-input-container></div>\n<md-button type=\"submit\" class=\"md-raised\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">\n{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button><md-button type=\"button\" class=\"md-raised md-warn\" \naria-label=\"Cancel\" ui-sref=\"app.finance.extrato\">{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button></form></div>\n</div></div>");
$templateCache.put("app/main/finance/extrato/profissionais.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Financeiro</span></div><div \nclass=\"title\">Profissionais</div></div><div layout=\"row\" layout-align=\"start center\"><span \nstyle=\"color:white;font-weight:bold;font-size:35px;cursor:pointer\" ng-click=\"vm.previousMonth();\"><md-tooltip>\nMês Anterior</md-tooltip>&nbsp;&#60;&nbsp;</span> <span style=\"color:white;font-size:20px\">\n{{vm.formattedSelectedMonth}}</span> <span style=\"color:white;font-weight:bold;font-size:35px;cursor:pointer\" \nng-click=\"vm.nextMonth();\"><md-tooltip>Próximo Anterior</md-tooltip>&nbsp;&#62;&nbsp;</span>\n &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<md-select name=\"professional\" ng-model=\"vm.professionalId\" \nstyle=\"color:white;font-weight:bold;font-size:16px\" ng-change=\"vm.refresh()\"><md-option ng-value=\"item._id\" \nng-repeat=\"item in vm.professionals\">{{item.name}}</md-option></md-select><md-button class=\"md-raised md-green-50-bg\" \nui-sref=\"app.finance.newprofesisonalpayment\">Novo Pagamento</md-button></div></div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-40dp\" layout=\"row\" layout-align=\"center center\" height=\"100px\" ng-show=\"!vm.showTable\">\n<br><span style=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></div><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Data</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Descrição</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Entrada</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Saída</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Saldo</span></div></th></tr></thead><tbody \ncompile=\"vm.html\" id=\"code\"></tbody></table></div></div><md-sidenav class=\"md-sidenav-right\" md-component-id=\"filter\" \nmd-is-locked-open=\"false\" md-whiteframe=\"4\"><md-toolbar class=\"md-hue-2\"><div class=\"md-toolbar-tools\"><h2>Trocar conta\n</h2><span flex></span><md-button class=\"md-raised md-orange-500-bg\" aria-label=\"Refresh\" ng-click=\"vm.refresh()\">\n{{\'GENERAL.REFRESH\'|translate}}</md-button></div></md-toolbar><md-content layout-padding><md-subheader \nstyle=\"margin-left: -20px\">Conta Bancária</md-subheader><div layout=\"row\"><md-select name=\"bankAccount\" \nng-model=\"vm.bankAccountId\" style=\"width:80%\"><md-option ng-value=\"item.BAAC_CD_BANK_ACCOUNT\" \nng-repeat=\"item in vm.bankAccounts\">{{item.BANK_TX_NAME}} ({{item.BAAC_TX_AGENCIA}} | {{item.BAAC_TX_CONTA}})\n</md-option></md-select></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/finance/extrato/transaction.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">Financeiro</span></div><div class=\"title\">{{vm.title}}</div></div></div><div class=\"content\" \nlayout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" \nng-submit=\"vm.saveTransaction()\" novalidate><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-bottom: 5px\">Data:\n<md-datepicker ng-model=\"vm.when\" style=\"margin-top:-2px\"></md-datepicker></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label>Banco</label><md-select name=\"bank\" ng-model=\"vm.bankAccountId\">\n<md-option ng-value=\"item.BAAC_CD_BANK_ACCOUNT\" ng-repeat=\"item in vm.bankAccounts\">\n{{item.BANK_TX_NAME}}({{item.BAAC_TX_AGENCIA}} | {{item.BAAC_TX_CONTA}})</md-option></md-select></md-input-container>\n<md-input-container flex ng-if=\"vm.transactionType==\'PAYMENT\'\"><md-radio-group ng-model=\"vm.type\" \nstyle=\"margin-left:20px\"><md-radio-button name=\"SUPPLIER\" data-value=\"SUPPLIER\">Fornecedor</md-radio-button>\n<md-radio-button name=\"PARTNER\" data-value=\"PARTNER\">Retirada de Capital</md-radio-button></md-radio-group>\n</md-input-container><md-input-container flex ng-if=\"vm.transactionType==\'RECEIVABLE\'\"><md-radio-group \nng-model=\"vm.type\" style=\"margin-left:20px\"><md-radio-button name=\"PARTNER\" data-value=\"PARTNER\">Aporte de Capital\n</md-radio-button></md-radio-group></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex ng-if=\"vm.type == \'SUPPLIER\'\"><label>Fornecedor</label><md-select name=\"bank\" \nng-model=\"vm.supplierId\"><md-option ng-value=\"item.SUPP_CD_SUPPLIER\" ng-repeat=\"item in vm.suppliers\">\n{{item.SUPP_TX_NAME}}</md-option></md-select></md-input-container><md-input-container flex \nng-if=\"vm.type == \'PARTNER\'\"><label>Sócio</label><md-select name=\"bank\" ng-model=\"vm.partnerId\"><md-option \nng-value=\"item.PART_CD_PARTNER\" ng-repeat=\"item in vm.partners\">{{item.PART_TX_NAME}}</md-option></md-select>\n</md-input-container><md-input-container flex ng-if=\"vm.type==\'PROFESSIONAL\'\"><label>Profissional</label><md-select \nname=\"bank\" ng-model=\"vm.supplierId\"><md-option ng-value=\"item.SUPP_CD_SUPPLIER\" ng-repeat=\"item in vm.suppliers\">\n{{item.SUPP_TX_NAME}}</md-option></md-select></md-input-container><md-input-container flex><label>Categoria</label>\n<md-select name=\"bank\" ng-model=\"vm.categoryId\"><md-option ng-value=\"item.FICA_CD_FINANCE_CATEGORY\" \nng-repeat=\"item in vm.categories\">{{item.FICA_TX_NAME}}</md-option></md-select></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Valor</label><input type=\"number\" name=\"value\" \nng-model=\"vm.value\" required min=\"0.01\"><div ng-messages=\"basicForm.value.$error\" role=\"alert\"><div \nng-message=\"required\"><span>O valor é um campo obrigatório</span></div></div></md-input-container><md-input-container \nflex><label>Observação</label><input type=\"text\" name=\"agencia\" ng-model=\"vm.observation\"></md-input-container></div>\n<md-button type=\"submit\" class=\"md-raised\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">\n{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button><md-button type=\"button\" class=\"md-raised md-warn\" \naria-label=\"Cancel\" ui-sref=\"app.finance.extrato\">{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button></form></div>\n</div></div>");
$templateCache.put("app/main/finance/extrato/transferencia.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">Financeiro</span></div><div class=\"title\">Transferência</div></div></div><div class=\"content\" \nlayout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" \nng-submit=\"vm.saveTransaction()\" novalidate><div layout=\"column\" layout-gt-sm=\"row\" style=\"margin-bottom: 5px\">Data:\n<md-datepicker ng-model=\"vm.when\" style=\"margin-top:-2px\"></md-datepicker></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label>Da conta</label><md-select name=\"bank\" \nng-model=\"vm.bankAccountIdFrom\"><md-option ng-value=\"item.BAAC_CD_BANK_ACCOUNT\" ng-repeat=\"item in vm.bankAccounts\">\n{{item.BANK_TX_NAME}}({{item.BAAC_TX_AGENCIA}} | {{item.BAAC_TX_CONTA}})</md-option></md-select></md-input-container>\n<md-input-container flex><label>Para conta</label><md-select name=\"bank\" ng-model=\"vm.bankAccountIdTo\"><md-option \nng-value=\"item.BAAC_CD_BANK_ACCOUNT\" ng-repeat=\"item in vm.bankAccounts\">\n{{item.BANK_TX_NAME}}({{item.BAAC_TX_AGENCIA}} | {{item.BAAC_TX_CONTA}})</md-option></md-select></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Valor</label><input type=\"number\" \nname=\"value\" ng-model=\"vm.value\" required min=\"0.01\"><div ng-messages=\"basicForm.value.$error\" role=\"alert\"><div \nng-message=\"required\"><span>O valor é um campo obrigatório</span></div></div></md-input-container><md-input-container \nflex><label>Observação</label><input type=\"text\" name=\"agencia\" ng-model=\"vm.observation\"></md-input-container></div>\n<md-button type=\"submit\" class=\"md-raised\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">\n{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button><md-button type=\"button\" class=\"md-raised md-warn\" \naria-label=\"Cancel\" ui-sref=\"app.finance.extrato\">{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button></form></div>\n</div></div>");
$templateCache.put("app/main/marketing/configuration/birthday.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'MARKETING.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'MARKETING.CONFIGURATION.HEADER\' | translate }}</span></div><div class=\"title\">\n{{ \'MARKETING.CONFIGURATION.BIRTHDAY.HEADER\' | translate }}</div></div></div><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" \nng-submit=\"vm.saveBirthdayConfiguration()\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex>\n<md-switch ng-model=\"vm.configuration.sendSMS\" aria-label=\"Switch 1\">\n{{\"MARKETING.CONFIGURATION.BIRTHDAY.SEND_SMS\"| translate}}</md-switch></md-input-container><md-input-container flex>\n<label translate=\"MARKETING.CONFIGURATION.BIRTHDAY.SMS_MESSAGE\"></label><textarea \nng-model=\"vm.configuration.SMSMessage\" md-maxlength=\"140\"></textarea></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><md-switch ng-model=\"vm.configuration.sendEmail\" aria-label=\"Switch 1\">\n{{\'MARKETING.CONFIGURATION.BIRTHDAY.SEND_EMAIL\' | translate}}</md-switch></md-input-container><md-input-container flex>\n<label translate=\"MARKETING.CONFIGURATION.BIRTHDAY.EMAIL_MESSAGE\"></label><textarea \nng-model=\"vm.configuration.EmailMessage\" md-maxlength=\"140\"></textarea></md-input-container></div><md-button \ntype=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">\n{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/marketing/configuration/schedule.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'MARKETING.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'MARKETING.CONFIGURATION.HEADER\' | translate }}</span></div><div class=\"title\">\n{{ \'MARKETING.CONFIGURATION.SCHEDULE.HEADER\' | translate }}</div></div></div><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" \nng-submit=\"vm.saveScheduleConfiguration()\" novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex=\"50\" flex-gt-xs=\"50\" layout=\"column\" style=\"margin-top: -20px\"><md-checkbox \nng-model=\"vm.configuration.requestPassword\">{{\'SETTINGS.SCHEDULE.REQUEST_PASSWORD\' | translate}}</md-checkbox>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"50\" flex-gt-xs=\"50\" \nlayout=\"column\" style=\"margin-top: -20px\"><md-radio-group ng-model=\"vm.configuration.smsDeliveryMethod\">\n<md-radio-button value=\"SPFREE\" selected=\"selected\">\n{{\'MARKETING.SPOT.FIELDS.SMS_DELIVERY_STYLE_PLACE_FREE\' | translate}}</md-radio-button><md-radio-button value=\"SP\">\n{{\'MARKETING.SPOT.FIELDS.SMS_DELIVERY_STYLE_PLACE\' | translate}}</md-radio-button><md-radio-button value=\"android\">\n{{\'MARKETING.SPOT.FIELDS.SMS_DELIVERY_ANDROID\' | translate}}</md-radio-button></md-radio-group></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><md-switch \nng-model=\"vm.configuration.sendSMSSameTime\" aria-label=\"Switch 1\" \nng-disabled=\"vm.configuration.smsDeliveryMethod==\'SPFREE\'\">{{\"MARKETING.CONFIGURATION.SCHEDULE.SEND_SMS\"| translate}}\n</md-switch></md-input-container><md-input-container flex><label \ntranslate=\"MARKETING.CONFIGURATION.SCHEDULE.SEND_SMS_MESSAGE\"></label><textarea \nng-model=\"vm.configuration.SMSSameTimeMessage\" md-maxlength=\"160\" \nng-disabled=\"vm.configuration.smsDeliveryMethod==\'SPFREE\'\"></textarea></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><md-switch ng-model=\"vm.configuration.sendSMSOnDay\" aria-label=\"Switch 1\" \nng-disabled=\"vm.configuration.smsDeliveryMethod==\'SPFREE\'\">\n{{\'MARKETING.CONFIGURATION.SCHEDULE.SEND_SMS_ONDAY\' | translate}}</md-switch></md-input-container><md-input-container \nflex><label translate=\"MARKETING.CONFIGURATION.SCHEDULE.SEND_SMSONDAY_MESSAGE\"></label><textarea \nng-model=\"vm.configuration.SMSOnDayMessage\" md-maxlength=\"160\" \nng-disabled=\"vm.configuration.smsDeliveryMethod==\'SPFREE\'\"></textarea></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><md-switch ng-model=\"vm.configuration.sendEmailSameTime\" \naria-label=\"Switch 1\">{{\"MARKETING.CONFIGURATION.SCHEDULE.SEND_EMAIL\"| translate}}</md-switch></md-input-container>\n<md-input-container flex><label translate=\"MARKETING.CONFIGURATION.SCHEDULE.SEND_EMAIL_MESSAGE\"></label><textarea \nng-model=\"vm.configuration.EmailSameTimeMessage\" md-maxlength=\"140\"></textarea></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><md-switch ng-model=\"vm.configuration.sendEmailOnDay\" \naria-label=\"Switch 1\">{{\"MARKETING.CONFIGURATION.SCHEDULE.SEND_EMAIL_ONDAY\"| translate}}</md-switch>\n</md-input-container><md-input-container flex><label \ntranslate=\"MARKETING.CONFIGURATION.SCHEDULE.SEND_EMAILONDAY_MESSAGE\"></label><textarea \nng-model=\"vm.configuration.EmailOnDayMessage\" md-maxlength=\"140\"></textarea></md-input-container></div><md-button \ntype=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">\n{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/auth/signup/signup.html","<div id=\"register-v2\" layout=\"row\" layout-align=\"start\"><div id=\"login-v2-intro\" flex hide show-gt-sm><img \nsrc=\"https://s3.amazonaws.com/gpsalao.gpsoftware.com.br/content/Ativo+176%4015x.png\" \nstyle=\"position: absolute;margin:20px;bottom:0;left: 0;width:400px\"></div><div id=\"register-v2-form-wrapper\" \nclass=\"flex-scrollable md-whiteframe-8dp\" flex ms-scroll ng-show=\"!vm.showForm\"><div id=\"register-v2-form\"><div \nclass=\"title\" style=\"height:60px\">Verifique seu e-mail para confirmar seu cadastro.</div></div></div><div \nid=\"register-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" flex ms-scroll ng-show=\"vm.showForm\"><div \nid=\"register-v2-form\"><div class=\"title\" translate=\"AUTH.SIGNUP.TITLE\" style=\"height:60px\"></div><form \nname=\"registerForm\" novalidate ng-submit=\"vm.singupAction()\"><md-input-container class=\"md-block\" md-no-float \nstyle=\"height:30px\"><input type=\"email\" name=\"email\" ng-model=\"vm.signup.email\" placeholder=\"Email\" translate \ntranslate-attr-placeholder=\"AUTH.SIGNUP.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"registerForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"AUTH.SIGNUP.ERRORS.EMAIL_REQUIRED\"></span></div><div ng-message=\"pattern\"><span \ntranslate=\"AUTH.SIGNUP.ERRORS.EMAIL_MUST_VALID\"></span></div></div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float style=\"height:30px\"><input type=\"text\" name=\"name\" ng-model=\"vm.signup.name\" \nplaceholder=\"Name\" translate translate-attr-placeholder=\"AUTH.SIGNUP.NAME\" required><div \nng-messages=\"registerForm.name.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"AUTH.SIGNUP.ERRORS.NAME_REQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float style=\"height:30px\"><input type=\"password\" name=\"password\" ng-model=\"vm.signup.password\" \nplaceholder=\"Name\" translate translate-attr-placeholder=\"AUTH.SIGNUP.PASSWORD\" required><div \nng-messages=\"registerForm.password.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"AUTH.SIGNUP.ERRORS.PASSWORD_REQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float style=\"height:30px\"><input type=\"password\" name=\"passwordConfirmation\" \nng-model=\"vm.signup.passwordConfirmation\" placeholder=\"Name\" translate \ntranslate-attr-placeholder=\"AUTH.SIGNUP.PASSWORD_CONFIRMATION\" required ng-pattern=\"{{vm.signup.password}}\"><div \nng-messages=\"registerForm.passwordConfirmation.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\n<span translate=\"AUTH.SIGNUP.ERRORS.PASSWORD_CONFIRM_REQUIRED\"></span></div><div ng-message=\"pattern\"><span \ntranslate=\"AUTH.SIGNUP.ERRORS.DIFFERENT_PASSWORD\"></span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"CREATE MY ACCOUNT\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine || vm.processing\" translate=\"AUTH.SIGNUP.CREATE_ACCOUNT\" \ntranslate-attr-aria-label=\"AUTH.SIGNUP.CREATE_ACCOUNT\">CREATE MY ACCOUNT</md-button><div class=\"login\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\" style=\"margin-top:-10px\"><span class=\"text\" \ntranslate=\"AUTH.SIGNUP.ALREADY_HAVE\">Already have an account?</span> <a class=\"link\" ui-sref=\"app.auth.signin\" \ntranslate=\"AUTH.SIGNUP.LOGIN\">Log in</a></div><div class=\"separator\" ng-if=\"vm.showButtonSignup()\"><span class=\"text\">\nOU</span></div><div layout=\"column\" layout-align=\"start center\" ng-if=\"vm.showButtonSignup()\"><md-button \nclass=\"md-raised facebook\" ng-click=\"vm.facebookLogin()\"><div layout=\"row\" layout-align=\"center center\"><span><md-icon \nmd-font-icon=\"icon-facebook\" class=\"s16\"></md-icon><span>Log in com Facebook</span></span></div></md-button></div>\n</form></div></div></div>");
$templateCache.put("app/main/auth/signup/termsDialog.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\" style=\"width:600px;height:400px\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"title\">Termos de Uso</div></div></div><md-dialog-content><div class=\"md-dialog-content\"><p align=\"center\">\n<strong><u>CONTRATO DE PRESTAÇÃO DE SERVIÇOS</u></strong></p><p>\nPelo presente instrumento particular, nesta e na melhor forma de direito, de um lado:</p><p>I. <strong>\nGEOPUSH SISTEMAS DE INFORMAÇÃO LTDA</strong>\n, estabelecida na cidade do Rio de Janeiro, no Estado do Rio de Janeiro, na Av. das Américas, nº 700, bloco 8, loja 219, Barra da Tijuca, inscrita no CNPJ sob o número 25.050.663/0001-41, neste ato representada por seus representantes legais abaixo assinados, doravante denominada \n<strong>“CONTRATADA”,</strong> e de outro lado,</p><p>II. <strong>XXXXXXX,</strong>\n estabelecida na cidade XXXXXX, no Estado XXXXXX, na RuaXXXXXXX, bairro XXXXXX, inscrita no CNPJ sob o número XXXXXX, neste ato representada por seus representantes legais abaixo assinados, doravante denominada “\n<strong>CONTRATANTE</strong>”<strong>,</strong></p><p>\nTêm entre si justo o presente Contrato de Prestação de Serviços, nos termos, cláusulas e condições abaixo acordadas pelas Partes:\n</p><p><strong>1 </strong><strong><u>Do Objeto</u></strong></p><p>\n1.1 O presente Contrato tem como objeto a prestação de serviços, pela <strong>CONTRATADA</strong> à <strong>CONTRATANTE\n</strong>, de cessão de uso da ferramenta denominada “Style Place”<strong>.</strong></p><p>\n1.2 As funcionalidades da ferramenta “Style Place” estão descritas no anexo 1 a este contrato, que é parte integrante e indissociável do mesmo.\n</p><p><strong>2 </strong><strong><u>Do Prazo</u></strong></p><p><strong><u></u></strong></p><p>\n2.1 O presente contrato terá prazo indeterminado.</p><p><strong></strong></p><p><strong>3 </strong><strong><u>\nDas Obrigações da CONTRATADA</u></strong></p><p>3.1 A <strong>CONTRATADA</strong> obriga-se a<strong> </strong>prestar \n<strong></strong>os Serviços continuamente, a não ser em casos de problemas gerados pela infraestrutura e/ou provedo\n<strong>r </strong>de internet da <strong>CONTRATANTE</strong>.</p><p>3.2 <strong>CONTRATADA</strong> e <strong>\nCONTRATANTE</strong> entendem e concordam que poderão ocorrer falhas no sistema. Caso ocorram, a <strong>CONTRATADA \n</strong>fará seus melhores esforços para corrigi-los.</p><p>3.3 A <strong>CONTRATADA</strong>\n reserva o direito de efetuar modificações em seu sistema conforme sua conveniência e julgamento.</p><p>3.4 A <strong>\nCONTRATADA</strong> envidará seus melhores esforços para:</p><p>(a) Avisar a <strong>CONTRATANTE</strong>\n sobre qualquer interrupção do Serviço, sempre que tecnicamente viável, informando a duração da interrupção; e/ou</p>\n<p>\n(b) Tomar as medidas possíveis para abreviar o tempo de interrupção do Serviço imediatamente após tomar ciência de sua ocorrência.\n</p><p>3.5 A <strong>CONTRATADA</strong>\n ficará isenta de toda e qualquer responsabilidade quando ficar impedida de disponibilizar o Serviço.</p><p><strong>\n</strong></p><p>3.6 A responsabilidade da <strong>CONTRATADA</strong>\n limitar-se-á ao cumprimento das obrigações aqui assumidas não lhe cabendo qualquer outra, inclusive, mas não limitada, a danos emergentes, lucros cessantes, interrupção de negócios, mau funcionamento de qualquer outro \n<em>software </em>ou <em>hardware </em>da <strong>CONTRATANTE</strong>\n, perda de informações e/ou outros prejuízos decorrentes do uso ou da impossibilidade de usar o Serviço, exceto em caso de dolo ou má fé.\n</p><p>3.7 A <strong>CONTRATADA</strong>\n responsabiliza-se pelo trabalho realizado por seus empregados, prepostos ou qualquer outra pessoa indicada, durante a prestação dos Serviços.\n</p><p><em>3.8 </em>Visando a melhor orientação, informação e assessoramento da <strong>CONTRATANTE</strong>, a \n<strong>CONTRATADA</strong> compromete-se a empregar todo o seu conhecimento técnico na prestação dos Serviços. <em>\n</em></p><p><em></em></p><p><em>3.9 </em>A <strong>CONTRATADA</strong>\n pode deixar de fornecer o serviço a qualquer momento, mediante comunicação prévia de sete dias à <strong>CONTRATANTE\n</strong>.<em></em></p><p><em></em></p><p><em></em></p><p><strong><em>4 </em></strong><strong><em><u>\nDas Obrigações da CONTRATANTE</u></em></strong></p><p><strong><em><u></u></em></strong></p><p><em></em></p><p>4.1 A \n<strong>CONTRATANTE</strong>\n deverá utilizar o sistema exclusivamente para o fim a que se destina, sendo vedada a utilização para fins diversos ao previsto neste Contrato.\n</p><p>4.2 A <strong>CONTRATANTE</strong> se compromete a informar à <strong>CONTRATANTE</strong>\n sobre eventuais falhas que venham a ocorrer objetivando fornecer informações importantes para a evolução do sistema.\n</p><p><em></em></p><p><strong><em>5 </em></strong><strong><u>Do Preço do Pagamento e dos Reajustes</u></strong> <em>\n</em></p><p><em></em></p><p><em></em></p><p><em>5.1 </em>O pagamento pelos serviços pela <strong>CONTRATANTE</strong>\n à CONTRATADA se dará mensalmente através de boleto bancário ou débito em cartão de crédito.<em></em></p><p><em></em>\n</p><p><em>5.2 </em>\nO valor devido mensalmente será determinado de acordo com o plano contratado no e permanecerá inalterado por 12 meses. Os preços estão expostos em nosso website (\n<a href=\"http://www.styleplace.net)\">http://www.styleplace.net)</a>. <em></em></p><p><em></em></p><p><em></em></p><p>\n<em>5.3 </em>Os reajustes poderão ser feitos a cada 12 meses baseado no IGPM acumulado dos últimos 12 meses. <em></em>\n</p><p><em></em></p><p><em></em></p><p><strong><em>6 </em></strong><strong><u>Da Vigência e da Rescisão Contratual</u>\n</strong> <em></em></p><p><em></em></p><p><em>6.1 </em>\nO presente Contrato, como dito na clausula 2, tem prazo indeterminado. <em></em></p><p><em></em></p><p><em>6.2 </em>\nO presente Contrato poderá ser rescindido a qualquer tempo, por qualquer das Partes, mediante comunicação prévia de 7 dias por e-mail.\n<em></em></p><p><em></em></p><p><em>6.3 </em>Após a rescisão do contrato, a <strong>CONTRATADA</strong>\n cessará a prestação do Serviço à <strong>CONTRATANTE</strong>\n, que se obriga não mais utilizá-lo ou cedê-lo a terceiros, sob pena de ressarcir a<strong>CONTRATADA</strong>\n além de incorrer nas demais cominações legais. <em></em></p><p><em></em></p><p><em></em></p><p><strong><em>7 </em>\n</strong><strong><u>Perdas e Danos</u></strong> <em></em></p><p><em></em></p><p><em>7.1 </em>\nQuaisquer atrasos, falhas e faltas cometidas pelas Partes somente serão justificadas, e não serão consideradas como inadimplemento contratual, se provadas por fatos fora de seu controle ou alcance e que se enquadrem nos preceitos do artigo 393 do Código Civil.\n<em></em></p><p><em></em></p><p><em>7.2 </em>\nPara os fins da Cláusula 7.1 acima, considera-se caso fortuito ou força maior, com estrita observância da disposição contida no artigo 393 e seu parágrafo único do Código Civil, qualquer evento ou circunstância que reúna os seguintes pressupostos:\n<em></em></p><p><em></em></p><p>(a) Tenha ocorrido e permanecido fora do controle da Parte por ele afetada;</p><p>\n(b) A Parte afetada não tenha concorrido, direta ou indiretamente, para a ocorrência de tal evento ou circunstância, quer em virtude de um inadimplemento de qualquer das suas obrigações nos termos do presente Contrato, de descumprimento de lei, de atuação com negligência, erro ou omissão da parte afetada;\n</p><p>\n(c) A atuação da Parte afetada, apesar de diligente e tempestiva, tenha sido insuficiente para impedir ou atenuar os efeitos da ocorrência do evento ou circunstância e;\n</p><p>\n(d) A ocorrência de tal evento ou circunstância tenha afetado ou impedido o cumprimento, pela Parte afetada, de suas obrigações nos termos do presente Contrato.\n</p><p><em></em></p><p><em></em></p><p><em>7.3 </em>\nFica estabelecido que nenhum dos seguintes eventos autorizará a Parte alguma a alegar caso fortuito ou força maior, com fundamento em sua ocorrência:\n<em></em></p><p><em></em></p><p>\n(a) Incapacidade financeira, falta de fundos, ou a incapacidade de tomar fundos emprestados;</p><p>\n(b) Greve ou qualquer outra perturbação de natureza similar executada somente pelos empregados, agentes, contratados ou sub-contratados da parte afetada;\n</p><p>(c) Alteração das condições econômicas e financeiras da Parte afetada; ou</p><p>\n(d) Atraso no desempenho das obrigações assumidas por contratados ou sub-contratados da Parte afetada que afetem o cumprimento de quaisquer obrigações assumidas pela Parte afetada no presente Contrato, exceto se comprovado que o atraso por parte dos contratados ou sub-contratados decorreu diariamente da ocorrência de um evento de caso fortuito ou força maior.\n</p><p><em></em></p><p><em>7.4 </em>\nOs eventuais prejuízos causados por uma das Partes à outra serão pagos pela Parte responsável e calculados pela outra Parte. Não havendo acordo, terá a Parte inocente a faculdade de (i) rescindir o presente Contrato e cobrá-los diretamente da Parte responsável, através das medidas extrajudiciais e judiciais cabíveis, ou (ii) compensar tais prejuízos mediante desconto no pagamento dos valores mensais das faturas relativas à Prestação dos Serviços.\n<em></em></p><p><em></em></p><p><em>7.4.1 </em>\nUma vez atingido o ressarcimento do valor total dos prejuízos eventualmente sofridos, poderá ainda assim a parte inocente rescindir imediatamente o presente Contrato.\n<em></em></p><p><em></em></p><p><em></em></p><p><strong><em>8 </em></strong><strong><u>Sigilo</u></strong> <em></em>\n</p><p><em></em></p><p><em>8.1 </em>\nTodas e quaisquer informações, dados, referências, condições comerciais, questões de ordem interna e/ou externa de cada parte, aspectos societários, econômicos, de execução de trabalhos, de posição mercadológica, de estrutura organizacional e/ou demais informações que forem reveladas de uma parte à outra concernentes às suas próprias estruturas, ou da outra, serão tratadas por estas em caráter de mais absoluto sigilo e confidencialidade, abstendo-se qualquer parte de realizar a terceiros qualquer divulgação e/ou uso dessas informações, por menores que sejam, obrigando-se a não ceder, transferir, divulgar, fornecer, emprestar e/ou veicular, por quaisquer meios, todo o conteúdo que lhe seja disponibilizado.\n<em></em></p><p><em></em></p><p><em>8.2 </em>\nComprometem-se as Partes a manter e fazer com que seus representantes, sócios e empregados mantenham no mais absoluto sigilo, todos e quaisquer dados e informações, passados, presentes ou futuros, de qualquer natureza, sejam das Partes respectivamente, de seus clientes, seus representantes, seus empregados ou empresas coligadas.\n<em></em></p><p><em></em></p><p><em>8.3 </em>\nO sigilo a que se refere à Cláusula 8.1 deverá ser mantido em relação às informações ou dados que não sejam de domínio público, referentes aos negócios e às práticas comerciais, aos métodos e técnicas de operação, bem como qualquer informação ou dado que venham a ter acesso direta ou indiretamente, obrigando-se ainda as Partes a não divulgarem a terceiros os referidos dados e informações por prazo indeterminado, independente da rescisão do presente Contrato, respondendo civil e criminalmente pelo descumprimento do aqui estipulado.\n<em></em></p><p><em>8.4 </em>A <strong>CONTRATADA</strong> e a <strong>CONTRATANTE</strong>\n serão solidária e individualmente responsáveis pelo descumprimento, por seus agentes, empregados ou contratados, da obrigação de confidencialidade, sujeitando-se à indenização de todos os danos decorrentes para a outra parte, com a ressalva do disposto abaixo.\n<em></em></p><p><em>8.5 </em>A divulgação de informações confidenciais só não gerará a indenização prevista, quando:\n<em></em></p><p><em>8.5.1 </em>\nA parte comprovar que a informação já era do seu conhecimento, antes de ser recebida da outra parte, não tendo por isso a obrigatoriedade de mantê-la confidencial; informação tiver sido legalmente obtida de terceiros, sem infringência de qualquer das disposições deste Contrato; \n<em></em></p><p><em>8.5.2 </em>\ninformação está ou se tornou publicamente disponível de outra forma, que não em decorrência de qualquer ato ou omissão das partes ou seus prepostos. \n<em></em></p><p><em></em></p><p><em>8.6 </em>\nO dever do sigilo deverá ser observado por 5 (cinco) anos após o término do presente contrato.<em></em></p><p><em></em>\n</p><p><strong><em>9 </em></strong><strong><u>Das penalidades</u></strong> <em></em></p><p><em></em></p><p><em>9.1 \n</em>\nEm caso de violação ao disposto Cláusula 8 e seus parágrafos, a Parte responsável pagará à Parte inocente uma multa cujo valor será o produto de 12 (doze) multiplicado pela remuneração mensal média durante o período em que o Contrato foi devidamente cumprido, sem prejuízo do previsto no Código de Processo Civil (CPC) e Código Civil Brasileiro (CCB), em relação às perdas e danos.\n<em></em></p><p><em></em></p><p><strong><em>10 </em></strong><strong><u>Disposições Gerais</u></strong> <em></em></p>\n<p><em></em></p><p><em>10.1 </em>\nAs Partes garantem que o presente Contrato não viola quaisquer obrigações assumidas com terceiros, sob pena de responsabilizar-se inteira e exclusivamente por eventuais danos que venham a ocasionar a outrem. \n<em></em></p><p><em></em></p><p><em>10.2 </em>\nO presente Contrato constitui acordo integral entre as Partes relativamente a seu objeto, substituindo qualquer outro que tenha sido firmado anteriormente pelas signatárias. Qualquer alteração ao presente instrumento apenas será válida se efetuada por escrito e assinada pelas Partes\n<em></em></p><p><em></em></p><p><em>10.3 </em>\nEventual omissão ou liberdade de qualquer das Partes em exigir o cumprimento dos termos e condições deste Contrato, ou exceder prerrogativas dele decorrente, não constituirá renúncia, novação desistência, remissão, alteração ou modificação do Contrato, sendo o evento ou a omissão considerada e interpretada como mera liberdade da Parte que assim transigiu, anuiu ou não exigiu o cumprimento da obrigação, não afetando o exercício posterior do direito.\n<em></em></p><p><em></em></p><p><em>10.4 </em>\nCaso qualquer uma das Cláusulas do presente Contrato venha a ser declarada nula, no todo ou em parte, as demais cláusulas continuarão em pleno vigor a menos que o objeto do presente Contrato seja afetado. As Partes desde já acordam que, em tal hipótese, as condições estabelecidas no presente Contrato poderão ser modificadas, por meio de termo aditivo ao presente Contrato, a ser assinado pelas Partes.\n<em></em></p><p><em></em></p><p><em>10.5 </em>\nEste Contrato, ou qualquer dos direitos nele previstos, não poderá ser cedido por Parte alguma sem o consentimento prévio, por escrito, da outra Parte. Será considerada nula qualquer cessão que viole a presente disposição contratual.\n<em></em></p><p><em></em></p><p><em>10.6 </em>\nNão obstante qualquer outra disposição prevista neste Contrato, as Partes reconhecem e concordam que se qualquer das disposições deste Contrato não for cumprida de acordo com seus termos específicos ou for de outra forma violada, sobreviriam danos e perdas irreparáveis, para os quais indenização monetária não constituiria uma reparação adequada. Sendo assim, as Partes concordam que, além de quaisquer outros recursos disponíveis, terão o direito de exigir o cumprimento específico de qualquer obrigação prevista neste Contrato, nos termos do Artigo 461 do Código de Processo Civil Brasileiro.\n<em></em></p><p><em></em></p><p><em>10.7 </em>A <strong>CONTRATADA</strong>\n deverá conduzir suas atividades consoante os termos deste Contrato em cumprimento com toda legislação aplicável, regras e regulamentações.\n<em></em></p><p><em></em></p><p><em>10.8 </em>\nO presente Contrato é celebrado em caráter irrevogável e irretratável, obrigando as Partes e seus sucessores a qualquer título.\n<em></em></p><p><em></em></p><p>10.9 Fica vedada à <strong>CONTRATADA</strong>\n constituir qualquer espécie de garantia ou gravame sobre os créditos oriundos do presente Contrato nem cedê-los a qualquer título, sem prévia e expressa anuência da \n<strong>CONTRATANTE</strong>.</p><p><em></em></p><p><strong><em>11 </em></strong><strong><u>Lei Aplicável e Foro</u>\n</strong> <em></em></p><p><em></em></p><p><em>11.1 </em>\nEste Contrato será regido e interpretado de acordo com as leis vigentes da República Federativa do Brasil.<em></em></p>\n<p><em></em></p><p><em>11.2 </em>\nFica eleito o Foro Central da Comarca do Rio de Janeiro para dirimir eventuais disputa relacionadas às disposições e ao cumprimento do Contrato. \n<em></em></p><br clear=\"all\"><p>\nE, por estarem assim justas e contratadas, assinam as Partes o presente instrumento em duas (2) vias de igual forma e teor, para um só efeito, juntamente com as duas testemunhas abaixo assinadas.\n</p><strong><br clear=\"all\"></strong><p><strong></strong></p><p align=\"center\"><strong>ANEXO 1</strong></p><p \nalign=\"center\"><strong></strong></p><h1>1. Visão Geral</h1><p>\nO Style Place – SP System, sistema de agendamento online para salões de beleza, trabalha de forma integrada com um aplicativo para celulares que leva o mesmo nome. Os clientes reservam os horários via aplicativo e os serviços são automaticamente inseridos na agenda dos profissionais do salão.\n</p><p>Para usar o sistema, basta acessar o endereço <a href=\"http://crm.styleplace.net\">http://crm.styleplace.net</a>\n . Não há necessidade de instalação de software.</p><p><strong>2. </strong><strong>Características Funcionais</strong>\n</p><p>\nOs clientes do salão podem entrar no aplicativo Style Place e acessar a lista personalizada de serviços do salão, com preços e profissionais disponíveis. Em seguida, é possível solicitar o agendamento de serviços conforme o horário e o profissional desejado. O salão receberá uma notificação e poderá confirmar ou não o pedido.\n</p><p>\nA agenda poderá enviar automaticamente aos clientes lembretes dos horários e também quando chegar o momento de marcar um retorno (sujeito a cobrança separada).\n</p><p>\nO salão poderá enviar campanhas de marketing via e-mail, SMS ou mensagens via aplicativo para seus clientes (sujeito a cobrança separada). O envio de mensagens de SMS depende de operadora parceira e por isso, necessariamente, acarreta custos a serem pagos pelo salão contratante. A GEOPUSH SISTEMAS DE INFORMAÇÃO LTDA não arcará com esses custos.\n</p><p>\nAtravés de relatórios, será possível identificar momentos de baixa demanda com o objetivo de oferecer vantagens para clientes e reduzir a ociosidade de profissionais.\n</p><p>A agenda permite saber quais são os serviços e os profissionais mais reservados do salão diariamente.</p><p>\nA agenda permite saber quantas vezes cada cliente foi até o salão e quais serviços agendou.</p><p><strong>3. </strong>\n<strong>Características funcionais detalhadas</strong></p><p>1. Dashboard</p><p>\nAqui estão todas as informações importantes para a gestão do negócio. Todas as entradas na agenda são traduzidas em gráficos para que o gestor possa identificar eventuais melhorias a serem feitas na sua operação. São exibidas informações como o percentual de cancelamentos, profissionais mais ocupados, dia da semana com mais agendamentos, e muitas outras.\n</p><p>2. Agenda</p><p>\nDo ponto de vista operacional, esta é a parte mais importante. E o bom funcionamento do sistema como um todo depende da correta utilização da agenda.\n</p><p>Agenda por profissional</p><p>\n1. Para criar um novo agendamento, o usuário deverá clicar no horário desejado na coluna do profissional desejado e selecionar “novo agendamento”.\n</p><p>\n2. Preencher o nome do cliente. O cliente já deverá estar previamente cadastrado. Caso contrário, deverá ser cadastrado através do item de menu “Clientes”.\n</p><p>\n3. Preencher o serviço desejado. Da mesma forma, o serviço já deverá estar cadastrado através do item de menu “Configurações / serviços”.\n</p><p>4. O nome do profissional já estará preenchido. Basta conferir.</p><p>\n5. Selecionar qual o canal de entrada do cliente, (balcão, telefone ou whatsapp).</p><p>\n6. A data e o horário já estarão preenchidos. Basta conferir.</p><p>7. Salvar.</p><p>\n8. Quando o cliente chegar para realizar o serviço, clicar sobre o respectivo agendamento e selecionar a opção “check-in”. Caso o cliente cancele ou simplesmente não compareça no horário marcado, selecionar respectivamente as opções “cancelar” ou “no show”.\n</p><p>Agenda por disponibilidade</p><p>\nEsta é uma visão por disponibilidade de serviços. A agenda exibe todos os serviços oferecidos pelo salão e mostra quais profissionais estão disponíveis.\n</p><p>\n1. Para criar um novo agendamento, o usuário deverá clicar no campo correspondente ao serviço, horário e profissional desejados.\n</p><p>\n2. Preencher o nome do cliente. O cliente já deverá estar previamente cadastrado. Caso contrário, deverá ser cadastrado através do item de menu “Clientes”.\n</p><p>3. O nome do serviço já estará preenchido. Basta conferir.</p><p>\n4. O nome do profissional já estará preenchido. Basta conferir.</p><p>\n5. Selecionar qual o canal de entrada do cliente, (balcão, telefone ou whatsapp).</p><p>\n6. A data e o horário já estarão preenchidos. Basta conferir.</p><p>7. Salvar.</p><p>\n8. Quando o cliente chegar para realizar o serviço, clicar sobre o respectivo agendamento e selecionar a opção “check-in”. Caso o cliente cancele ou simplesmente não compareça no horário marcado, selecionar respectivamente as opções “cancelar” ou “no show”.\n</p><p>Agendamentos pendentes</p><p>\nEsta é uma visão de todos os agendamentos que ainda não foram realizados. A lista exibida pode ser ordenada por cliente, serviço, profissional e data.\n</p><p>\nEsta lista é muito útil quando houver a necessidade de se achar todos os agendamentos de um determinado cliente. Para isso, basta inserir o nome do cliente no campo “busca”. O sistema irá exibir todos os agendamentos ainda não realizados para esse cliente. Se desejar, o usuário do sistema poderá reagendar o cliente para outro horário.\n</p><p>3. Clientes</p><p>\nEsta aba mostra todos os clientes do seu salão cadastrados no Style Place. Para efetuar agendamentos, todos os seus clientes deverão ser cadastrados previamente.\n</p><p>1. Para cadastrar novos clientes, clique no botão “novo cliente”.</p><p>\n2. Preencha as informações solicitadas e clique em “salvar”. Não se esqueça de preencher o nome e o sobrenome de seus clientes.\n</p><p>4. Vendas</p><p>\nAo realizar o check-in do cliente através da agenda, automaticamente abre-se uma comanda. Aqui temos a visão de todas as comandas abertas.\n</p><p>\n1. No momento do pagamento dos serviços realizados, clicar em “check-out” (ícone $) na linha correspondente ao cliente em questão.\n</p><p>2. Clicar em “adicionar serviço”.</p><p>\n3. Adicionar o serviço e o profissional que o realizou e clicar em “salvar”.</p><p>\n4. Caso seja usado algum cupom de desconto, inserir o código do cupom.</p><p>\n5. Caso não seja usado nenhum cupom de desconto, preencher o campo “valor pago” manualmente, com o valor de fato praticado.\n</p><p>6. Salvar.</p><p>\nObs: Caso, por algum motivo, o check-out seja realizado sem que nenhum agendamento ou check-in tenha sido realizado para este cliente, pode-se clicar em “nova comanda” e iniciar o mesmo processo. No entanto, para o bom aproveitamento do sistema, recomendamos registrar todos os agendamentos e realizar seus respectivos check-ins.\n</p><p>5. Marketing</p><p>Esta é a parte do Style Place que gerencia todas as campanhas de marketing.</p><p>\nCampanhas pontuais</p><p>São aquelas enviadas apenas uma vez. São totalmente customizáveis.</p><p>\n1. Clicar em “nova campanha”.</p><p>2. Inserir o nome da campanha e a sua descrição.</p><p>3. Inserir a data de envio.\n</p><p>\n4. Optar pelo envio ou não de um cupom promocional. Caso opte pelo envio do cupom, selecionar se ele dará direito a um desconto percentual ou a um valor fixo. Clicar em “próximo”.\n</p><p>5. Inserir a mensagem desejada. No caso de SMS, as operadoras de telefonia limitam a mensagem a 160 caracteres.\n</p><p>\n6. Optar por disparar pelo Style Place (com custo) ou disparar pelo seu próprio celular Android (sem custo). Clicar em “próximo”.\n</p><p>\n7. Selecionar os destinatários da mensagem. Você pode enviar para todos os seus clientes ou selecionar apenas aqueles que são consumidores de determinados serviços. Você também pode selecionar apenas clientes de determinados profissionais.\n</p><p>8. Clicar em “enviar”.</p><p>Campanhas contínuas</p><p>\nSão campanhas padronizadas, criadas pelos administradores do Style Place.</p><p>\n1. Para iniciar uma campanha, basta selecionar a campanha desejada (por exemplo, “Aniversário”).</p><p>\n2. Selecionar se o envio deve ser feito por SMS ou por e-mail ou ambos.</p><p>3. Inserir as mensagens desejadas.</p><p>\n4. Salvar.</p><p>Cupons</p><p>\nEspaço que permite a criação de cupons promocionais. Cada cupom é único e perde a validade tão logo seja utilizado pelo cliente. O cupom tem um prazo de validade determinado pelo salão e perderá a validade após esse prazo.\n</p><p>Mensagens</p><p>Espaço que exibe todas as mensagens programadas ou já enviadas.</p><p>6. Relatórios</p><p>\nExibição de relatório de vendas e de comissões.</p><p>7. Configurações</p><p>\nEsta é a aba onde serão cadastradas todas as informações para a operação do salão, como o horário de funcionamento, serviços e profissionais. Caso tenha produtos à venda, o salão também poderá cadastrá-los.\n</p><p>\nAo cadastrar um novo profissional, o salão tem a possibilidade de selecionar o campo “permitir overbooking”. Neste caso, a agenda aceitará mais de um agendamento para um mesmo horário deste profissional.\n</p></div></md-dialog-content></div>");
$templateCache.put("app/main/auth/verifyAccount/register-v2.html","<div id=\"register-v2\" layout=\"row\" layout-align=\"start\"><div id=\"register-v2-intro\" flex hide show-gt-sm><div \nclass=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"REGISTER_V2.INTRO_TITLE\">\nWelcome to the FUSE!</div><div class=\"description\" translate=\"REGISTER_V2.INTRO_DESCRIPTION\">\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ullamcorper nisl erat, vel convallis elit fermentum pellentesque. Sed mollis velit facilisis facilisis viverra.\n</div></div><div id=\"register-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" layout=\"column\" flex \nms-scroll><div id=\"register-v2-form\"><div class=\"logo md-accent-bg\" hide-gt-sm><span>F</span></div><div class=\"title\" \ntranslate=\"REGISTER_V2.TITLE\">Create an account</div><div class=\"description\" translate=\"REGISTER_V2.DESCRIPTION\">\nSed mollis velit facilisis facilisis viverra</div><form name=\"registerForm\" novalidate><md-input-container \nclass=\"md-block\" md-no-float><input name=\"username\" ng-model=\"vm.form.username\" placeholder=\"Name\" translate \ntranslate-attr-placeholder=\"REGISTER_V2.NAME\" required><div ng-messages=\"registerForm.username.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.USERNAME_REQUIRED\">Username field is required</span>\n</div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" \nng-model=\"vm.form.email\" placeholder=\"Email\" translate translate-attr-placeholder=\"REGISTER_V2.EMAIL\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"registerForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div \nng-message=\"pattern\"><span translate=\"REGISTER_V2.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span>\n</div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"REGISTER_V2.PASSWORD\" required><div ng-messages=\"registerForm.password.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.PASSWORD_REQUIRED\">\nPassword field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float>\n<input type=\"password\" name=\"passwordConfirm\" ng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" \ntranslate translate-attr-placeholder=\"REGISTER_V2.PASSWORD_CONFIRM\" required><div \nng-messages=\"registerForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER_V2.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div>\n</md-input-container><div class=\"terms\" layout=\"row\" layout-align=\"center center\"><md-checkbox name=\"terms\" \nng-model=\"data.cb1\" aria-label=\"I read and accept\" required></md-checkbox><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"start center\"><span translate=\"REGISTER_V2.READ_ACCEPT\">I read and accept</span> <a href=\"#\" \nclass=\"md-accent-color\" translate=\"REGISTER_V2.TERMS_COND\">terms and conditions</a></div></div><md-button \ntype=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"CREATE MY ACCOUNT\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine\" translate=\"REGISTER_V2.CREATE_ACCOUNT\" \ntranslate-attr-aria-label=\"REGISTER_V2.CREATE_ACCOUNT\">CREATE MY ACCOUNT</md-button></form><div class=\"login\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"REGISTER_V2.ALREADY_HAVE\">\nAlready have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_login-v2\" translate=\"REGISTER_V2.LOGIN\">Log in\n</a></div></div></div></div>");
$templateCache.put("app/main/auth/verifyAccount/verifyAccount.html","<div id=\"register-v2\" layout=\"row\" layout-align=\"start\"><div id=\"register-v2-form-wrapper\" \nclass=\"flex-scrollable md-whiteframe-8dp\" layout=\"column\" flex ms-scroll ng-if=\"vm.invalidToken\"><div \nid=\"register-v2-form\"><div class=\"title\" style=\"height:60px\">Token Inválido</div></div></div><div \nid=\"register-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" layout=\"column\" flex ms-scroll \nng-if=\"!vm.processing && (vm.professionalStatus==\'ACTIVE\' && !vm.invalidToken)\"><div id=\"register-v2-form\"><div \nclass=\"title\" style=\"height:60px\">Aceitar Convite</div><center><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" ng-click=\"vm.acceptInvite();\" aria-label=\"CREATE MY ACCOUNT\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine || vm.processing\">Aceitar Convite</md-button></center>\n</div></div><div id=\"register-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" layout=\"column\" flex \nms-scroll ng-if=\"!vm.processing && (vm.professionalStatus==\'INACTIVE\' && !vm.invalidToken)\"><div id=\"register-v2-form\">\n<div class=\"title\" style=\"height:60px\">Criar conta e aceitar convite</div><form name=\"registerForm\" novalidate \nng-submit=\"vm.singupAction()\"><md-input-container class=\"md-block\" md-no-float style=\"height:30px\" ng-if=\"false\"><input\n name=\"account\" ng-model=\"vm.signup.userName\" placeholder=\"Username\" ng-pattern=\"/^[a-zA-Z0-9]*$/\" translate \ntranslate-attr-placeholder=\"AUTH.SIGNUP.ACCOUNT\" ng-minlength=\"3\" ng-maxlength=\"10\" required><div \nng-messages=\"registerForm.account.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"AUTH.SIGNUP.ERRORS.ACCOUNT_REQUIRED\"></span></div><div ng-message=\"pattern\"><span \ntranslate=\"AUTH.SIGNUP.ERRORS.ACCOUNT_PATTERN\"></span></div><div ng-message=\"minlength\"><span \ntranslate=\"AUTH.SIGNUP.ERRORS.ACCOUNT_MIN\"></span></div><div ng-message=\"maxlength\"><span \ntranslate=\"AUTH.SIGNUP.ERRORS.ACCOUNT_MAX\"></span></div></div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float style=\"height:30px\" ng-if=\"vm.showEmail\"><input type=\"email\" name=\"email\" \nng-model=\"vm.signup.email\" placeholder=\"Email\" translate translate-attr-placeholder=\"AUTH.SIGNUP.EMAIL\" \nreadonly=\"readonly\" disabled=\"disabled\"></md-input-container><md-input-container class=\"md-block\" md-no-float \nstyle=\"height:30px\" ng-if=\"vm.showTelephone\"><input type=\"text\" name=\"telephone\" ng-model=\"vm.signup.telephone\" \ndisabled=\"disabled\" placeholder=\"Telefone\" translate></md-input-container><md-input-container class=\"md-block\" \nmd-no-float style=\"height:30px\"><input type=\"text\" name=\"name\" ng-model=\"vm.signup.name\" placeholder=\"Name\" translate \ntranslate-attr-placeholder=\"AUTH.SIGNUP.NAME\" required><div ng-messages=\"registerForm.name.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span translate=\"AUTH.SIGNUP.ERRORS.NAME_REQUIRED\"></span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float style=\"height:30px\" ng-if=\"false\"><input \ntype=\"text\" name=\"salonName\" ng-model=\"vm.signup.salonName\" placeholder=\"Name\" translate \ntranslate-attr-placeholder=\"AUTH.SIGNUP.SALONNAME\" required><div ng-messages=\"registerForm.salonName.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span translate=\"AUTH.SIGNUP.ERRORS.SALON_NAME_REQUIRED\">\n</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float style=\"height:30px\"><input \ntype=\"password\" name=\"password\" ng-model=\"vm.signup.password\" placeholder=\"Name\" translate \ntranslate-attr-placeholder=\"AUTH.SIGNUP.PASSWORD\" required><div ng-messages=\"registerForm.password.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span translate=\"AUTH.SIGNUP.ERRORS.PASSWORD_REQUIRED\">\n</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float style=\"height:30px\"><input \ntype=\"password\" name=\"passwordConfirmation\" ng-model=\"vm.signup.passwordConfirmation\" placeholder=\"Name\" translate \ntranslate-attr-placeholder=\"AUTH.SIGNUP.PASSWORD_CONFIRMATION\" required ng-pattern=\"{{vm.signup.password}}\"><div \nng-messages=\"registerForm.passwordConfirmation.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\n<span translate=\"AUTH.SIGNUP.ERRORS.PASSWORD_CONFIRM_REQUIRED\"></span></div><div ng-message=\"pattern\"><span \ntranslate=\"AUTH.SIGNUP.ERRORS.DIFFERENT_PASSWORD\"></span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"CREATE MY ACCOUNT\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine || vm.processing\" ng-click=\"vm.acceptInviteWithSignup();\">\nCriar conta e aceitar Convite</md-button></form></div></div></div>");
$templateCache.put("app/main/auth/verifyEmail/register-v2.html","<div id=\"register-v2\" layout=\"row\" layout-align=\"start\"><div id=\"register-v2-intro\" flex hide show-gt-sm><div \nclass=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"REGISTER_V2.INTRO_TITLE\">\nWelcome to the FUSE!</div><div class=\"description\" translate=\"REGISTER_V2.INTRO_DESCRIPTION\">\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ullamcorper nisl erat, vel convallis elit fermentum pellentesque. Sed mollis velit facilisis facilisis viverra.\n</div></div><div id=\"register-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" layout=\"column\" flex \nms-scroll><div id=\"register-v2-form\"><div class=\"logo md-accent-bg\" hide-gt-sm><span>F</span></div><div class=\"title\" \ntranslate=\"REGISTER_V2.TITLE\">Create an account</div><div class=\"description\" translate=\"REGISTER_V2.DESCRIPTION\">\nSed mollis velit facilisis facilisis viverra</div><form name=\"registerForm\" novalidate><md-input-container \nclass=\"md-block\" md-no-float><input name=\"username\" ng-model=\"vm.form.username\" placeholder=\"Name\" translate \ntranslate-attr-placeholder=\"REGISTER_V2.NAME\" required><div ng-messages=\"registerForm.username.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.USERNAME_REQUIRED\">Username field is required</span>\n</div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" \nng-model=\"vm.form.email\" placeholder=\"Email\" translate translate-attr-placeholder=\"REGISTER_V2.EMAIL\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"registerForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div \nng-message=\"pattern\"><span translate=\"REGISTER_V2.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span>\n</div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"REGISTER_V2.PASSWORD\" required><div ng-messages=\"registerForm.password.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.PASSWORD_REQUIRED\">\nPassword field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float>\n<input type=\"password\" name=\"passwordConfirm\" ng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" \ntranslate translate-attr-placeholder=\"REGISTER_V2.PASSWORD_CONFIRM\" required><div \nng-messages=\"registerForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER_V2.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div>\n</md-input-container><div class=\"terms\" layout=\"row\" layout-align=\"center center\"><md-checkbox name=\"terms\" \nng-model=\"data.cb1\" aria-label=\"I read and accept\" required></md-checkbox><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"start center\"><span translate=\"REGISTER_V2.READ_ACCEPT\">I read and accept</span> <a href=\"#\" \nclass=\"md-accent-color\" translate=\"REGISTER_V2.TERMS_COND\">terms and conditions</a></div></div><md-button \ntype=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"CREATE MY ACCOUNT\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine\" translate=\"REGISTER_V2.CREATE_ACCOUNT\" \ntranslate-attr-aria-label=\"REGISTER_V2.CREATE_ACCOUNT\">CREATE MY ACCOUNT</md-button></form><div class=\"login\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"REGISTER_V2.ALREADY_HAVE\">\nAlready have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_login-v2\" translate=\"REGISTER_V2.LOGIN\">Log in\n</a></div></div></div></div>");
$templateCache.put("app/main/auth/verifyEmail/verifyEmail.html","<div id=\"register-v2\" layout=\"row\" layout-align=\"start\"><div id=\"register-v2-form-wrapper\" \nclass=\"flex-scrollable md-whiteframe-8dp\" layout=\"column\" flex ms-scroll ng-if=\"vm.invalidToken\"><div \nid=\"register-v2-form\"><div class=\"title\" style=\"height:60px\">Token Inválido</div></div></div><div \nid=\"register-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" layout=\"column\" flex ms-scroll><div \nid=\"register-v2-form\"><div class=\"title\" style=\"height:60px\">Verificação Concluida. Você já pode acessar o sistema!\n</div><center><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" ng-click=\"vm.login();\" \naria-label=\"CREATE MY ACCOUNT\">Clique para acessar</md-button></center></div></div></div>");
$templateCache.put("app/main/marketing/message/list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'MARKETING.HEADER\' | translate }}</span></div><div class=\"title\">{{ \'MARKETING.MESSAGE.HEADER\' | translate }}</div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised md-orange-500-bg\" \nng-click=\"vm.openFilter();\">{{ \'GENERAL.FILTER\' | translate }}</md-button></div></div><md-content flex layout-padding>\n<md-content class=\"content\" flex ng-if=\"!vm.showTable\"><br><span style=\"margin-left: 10px;margin-top: 10px\"><b>\nCarregando...</b></span></md-content><div class=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead>\n<tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'MARKETING.MESSAGE.FIELDS.CUSTOMER_NAME\' | translate }}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'MARKETING.MESSAGE.FIELDS.STATUS.HEADER\' | translate }}</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'MARKETING.MESSAGE.FIELDS.WHEN\' | translate }}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'MARKETING.MESSAGE.FIELDS.TYPE\' | translate }}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'MARKETING.MESSAGE.FIELDS.CAMPAIGN_TYPE\' | translate }}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'MARKETING.MESSAGE.FIELDS.DELIVERY_TYPE.HEADER\' | translate }}\n</span></div></th><th></th></tr></thead><tbody><tr ng-repeat=\"item in vm.messages\"><td>{{ item.customerName }}</td><td>\n{{ \'MARKETING.MESSAGE.FIELDS.STATUS.\' + item.status | translate }}</td><td>{{ item.when | date:\'dd/MM/yyyy HH:mm:ss\'}}\n</td><td>{{ item.type }}</td><td>{{ item.campaignType }}</td><td>\n{{ \'MARKETING.MESSAGE.FIELDS.DELIVERY_TYPE.\' + item.deliveryMethod | translate }}</td><td align=\"right\"></td></tr>\n</tbody></table></div></md-content></div><md-sidenav class=\"md-sidenav-right\" md-component-id=\"filter\" \nmd-is-locked-open=\"false\" md-whiteframe=\"4\"><md-toolbar class=\"md-hue-2\"><div class=\"md-toolbar-tools\"><h2>\n{{\'GENERAL.FILTER\' | translate}}</h2><span flex></span><md-button class=\"md-raised md-orange-500-bg\" \naria-label=\"Refresh\" ng-click=\"vm.refresh()\">{{\'GENERAL.REFRESH\'|translate}}</md-button></div></md-toolbar><md-content \nlayout-padding><md-subheader style=\"margin-left: -20px\">Período</md-subheader><div layout=\"row\"><span \nstyle=\"margin-left: 10px\">{{\'GENERAL.FROM\'|translate}}<md-datepicker ng-model=\"vm.filter.dtFrom\"></md-datepicker>\n</span></div><div layout=\"row\"><span style=\"margin-left: 10px\">{{\'GENERAL.TO\'|translate}}<md-datepicker \nng-model=\"vm.filter.dtTo\"></md-datepicker></span></div><md-subheader style=\"margin-left: -20px\">Status</md-subheader>\n<div layout=\"row\"><md-checkbox ng-model=\"vm.filter.fail\">Falha</md-checkbox><md-checkbox \nng-model=\"vm.filter.delivered\">Entregue</md-checkbox></div></md-content></md-sidenav>");
$templateCache.put("app/main/marketing/offer/list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-cloak><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\">\n</md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'MARKETING.HEADER\' | translate }}</span></div><div class=\"title\">{{ \'MARKETING.OFFER.HEADER\' | translate }}</div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised md-orange-500-bg\" \nui-sref=\"app.marketing.offer.new\">{{ \'MARKETING.OFFER.NEW\' | translate }}</md-button></div></div><div class=\"content\">\n<md-content class=\"content\" flex ng-if=\"!vm.showTable\"><br><span style=\"margin-left: 10px;margin-top: 10px\"><b>\nCarregando...</b></span></md-content><div class=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead>\n<tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'MARKETING.OFFER.FIELDS.NAME\' | translate }}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">{{ \'MARKETING.OFFER.FIELDS.PERCENTAGE\' | translate }}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'MARKETING.OFFER.FIELDS.CHANGE_COMISSION_PRICE\' | translate }}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'MARKETING.OFFER.FIELDS.ENABLED\' | translate }}</span></div></th>\n<th></th></tr></thead><tbody><tr ng-repeat=\"item in vm.offers\"><td>{{ item.name }}</td><td>{{ item.percentage }}</td>\n<td>{{ item.changeComissionPrice | yesNo }}</td><td>{{ item.enabled | yesNo }}</td><td align=\"right\"><md-button \naria-label=\"Pencil\" class=\"md-raised md-accent gp-mini\" ng-click=\"vm.editOffer(item._id)\"><md-tooltip \naria-label=\"Pencil\">{{ \'GENERAL.HINTS.EDIT\' | translate }}</md-tooltip><i class=\"icon-pencil\" layout=\"center\"></i>\n</md-button><md-button ng-if=\"item.enabled\" aria-label=\"Trash\" class=\"md-raised md-warn gp-mini\" \nng-click=\"vm.disableOffer(item._id)\"><md-tooltip aria-label=\"Pencil\">{{ \'GENERAL.HINTS.DISABLE\' | translate }}\n</md-tooltip><i class=\"icon-stop\" layout=\"center\"></i></md-button><md-button ng-if=\"!item.enabled\" aria-label=\"Trash\" \nclass=\"md-raised md-warn gp-mini\" ng-click=\"vm.enableOffer(item._id)\"><md-tooltip aria-label=\"Pencil\">\n{{ \'GENERAL.HINTS.ENABLE\' | translate }}</md-tooltip><i class=\"icon-play\" layout=\"center\"></i></md-button></td></tr>\n</tbody></table></div></div></div>");
$templateCache.put("app/main/marketing/offer/offer.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'MARKETING.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'MARKETING.OFFER.HEADER\' | translate }}</span></div><div class=\"title\">\n{{ \'MARKETING.OFFER.NEW\' | translate }}</div></div></div><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" ng-submit=\"vm.saveOffer()\" \nnovalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"MARKETING.OFFER.FIELDS.NAME\"></label><input type=\"text\" name=\"name\" ng-model=\"vm.name\" required><div \nng-messages=\"basicForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'MARKETING.OFFER.VALIDATION.NAME_REQUIRED\' | translate }}</span></div></div></md-input-container><md-input-container\n flex><label translate=\"MARKETING.OFFER.FIELDS.PERCENTAGE\"></label><input type=\"number\" name=\"percentage\" \nng-model=\"vm.percentage\" required><div ng-messages=\"basicForm.percentage.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{ \'MARKETING.OFFER.VALIDATION.PERCENTAGE_REQUIRED\' | translate }}</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><md-checkbox \nname=\"changeComissionPrice\" ng-model=\"vm.changeComissionPrice\">\n{{\"MARKETING.OFFER.FIELDS.CHANGE_COMISSION_PRICE\" | translate}}</md-checkbox></md-input-container><md-input-container \nflex><md-checkbox name=\"requireExplanation\" ng-model=\"vm.requireExplanation\">\n{{\"MARKETING.OFFER.FIELDS.REQUIRE_EXPLANATION\" | translate}}</md-checkbox></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex>Forma de arredondamento dos preços após oferta<br>\n<md-radio-group ng-model=\"vm.roundType\"><md-radio-button data-value=\"NONE\">Nao arredondar</md-radio-button><br>\n<md-radio-button data-value=\"UP\">Arredondar para cima</md-radio-button><br><md-radio-button data-value=\"DOWN\">\nArredondar para baixo</md-radio-button><br></md-radio-group></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"MARKETING.OFFER.FIELDS.RULES\"></label><textarea \ntype=\"text\" name=\"rules\" ng-model=\"vm.rules\"></textarea></md-input-container></div><md-button type=\"submit\" \nclass=\"md-accent\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">{{ \'GENERAL.BUTTON.SAVE\' | translate }}\n</md-button><md-button type=\"button\" class=\"md-warn\" aria-label=\"Cancel\" ui-sref=\"app.marketing.offer.list\">\n{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/marketing/cupom/list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'MARKETING.HEADER\' | translate }}</span></div><div class=\"title\">{{ \'MARKETING.CUPOM.HEADER\' | translate }}</div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised md-orange-500-bg\" \nng-click=\"vm.openFilter();\">{{ \'GENERAL.FILTER\' | translate }}</md-button></div></div><div class=\"content\"><md-content \nclass=\"content\" flex ng-if=\"!vm.showTable\"><br><span style=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b>\n</span></md-content><div class=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead>\n<tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'MARKETING.CUPOM.FIELDS.CUSTOMER_NAME\' | translate }}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'MARKETING.CUPOM.FIELDS.VALUE\' | translate }}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'MARKETING.CUPOM.FIELDS.STATUS.HEADER\' | translate }}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'MARKETING.CUPOM.FIELDS.VALID_UNTIL\' | translate }}</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'MARKETING.CUPOM.FIELDS.CODE\' | translate }}</span></div></th><th></th></tr></thead><tbody><tr \nng-repeat=\"item in vm.cupons\"><td>{{ item.customerName }}</td><td>{{ item.cupomValueStr }}</td><td>\n{{ \'MARKETING.CUPOM.FIELDS.STATUS.\' + item.status | translate }}</td><td>{{ item.cupomValidUntil | date:\'dd/MM/yyyy\'}}\n</td><td>{{ item.code }}</td><td align=\"right\"><md-button aria-label=\"Trash\" class=\"md-raised md-warn gp-mini\" \nng-disabled=\"item.status!=\'NOT_USED\'\" ng-click=\"vm.cancelCupom(item._id)\"><md-tooltip aria-label=\"Pencil\">\n{{ \'GENERAL.CANCEL\' | translate }}</md-tooltip><i class=\"icon-trash\" layout=\"center\"></i></md-button></td></tr></tbody>\n</table></div></div><md-sidenav class=\"md-sidenav-right\" md-component-id=\"filter\" md-is-locked-open=\"false\" \nmd-whiteframe=\"4\"><md-toolbar class=\"md-hue-2\"><div class=\"md-toolbar-tools\"><h2>{{\'GENERAL.FILTER\' | translate}}</h2>\n<span flex></span><md-button class=\"md-raised md-orange-500-bg\" aria-label=\"Refresh\" ng-click=\"vm.refresh()\">\n{{\'GENERAL.REFRESH\'|translate}}</md-button></div></md-toolbar><md-content layout-padding><md-subheader \nstyle=\"margin-left: -20px\">Período</md-subheader><div layout=\"row\"><span style=\"margin-left: 10px\">\n{{\'GENERAL.FROM\'|translate}}<md-datepicker ng-model=\"vm.filter.dtFrom\"></md-datepicker></span></div><div layout=\"row\">\n<span style=\"margin-left: 10px\">{{\'GENERAL.TO\'|translate}}<md-datepicker ng-model=\"vm.filter.dtTo\"></md-datepicker>\n</span></div><md-subheader style=\"margin-left: -10px\">{{ \'MARKETING.CUPOM.FIELDS.STATUS.HEADER\' | translate }}\n</md-subheader><div layout=\"row\" style=\"margin-top: 0px\"><md-checkbox ng-model=\"vm.filter.used\">\n{{ \'MARKETING.CUPOM.FIELDS.STATUS.USED\' | translate }}</md-checkbox></div><div layout=\"row\" style=\"margin-top: -20px\">\n<md-checkbox ng-model=\"vm.filter.notUsed\">{{ \'MARKETING.CUPOM.FIELDS.STATUS.NOT_USED\' | translate }}</md-checkbox>\n</div><div layout=\"row\" style=\"margin-top: -20px\"><md-checkbox ng-model=\"vm.filter.canceled\">\n{{ \'MARKETING.CUPOM.FIELDS.STATUS.CANCELED\' | translate }}</md-checkbox></div><div layout=\"row\" \nstyle=\"margin-top: -20px\"><md-checkbox ng-model=\"vm.filter.expired\">\n{{ \'MARKETING.CUPOM.FIELDS.STATUS.EXPIRED\' | translate }}</md-checkbox></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/marketing/marketplace/styleplace.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'MARKETING.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'MARKETING.MARKETPLACE.HEADER\' | translate }}</span></div><div class=\"title\">\n{{ \'MARKETING.MARKETPLACE.STYLEPLACE.HEADER\' | translate }}</div></div></div><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" \nng-submit=\"vm.saveStylePlaceConfiguration()\" novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex layout=\"column\"><textarea name=\"termosDeUso\" ng-model=\"vm.termsOfUse\"></textarea></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><md-switch ng-model=\"vm.accept\" aria-label=\"Switch 1\">\n{{\"MARKETING.MARKETPLACE.STYLEPLACE.ACCEPT\"| translate}}</md-switch></md-input-container></div><md-button \ntype=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\">{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button>\n</form></div></div></div>");
$templateCache.put("app/main/marketingv2/birthday/configuration.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'MARKETING.HEADER\' | translate }}</span></div><div class=\"title\">{{ \'MARKETING.BIRTHDAY.HEADER\' | translate }}</div>\n</div></div><div class=\"content\" layout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\"><div layout=\"column\">\n<strong>Como funciona?</strong><br>\nSe a campanha estiver habilitada o cliente receberá mensagens de acordo com a sua data de aniversário conforme especificado na ficha do cliente.\n<br>Ex. Parabéns Monica, que tal aproveitar o desconto de 10% no mês de seu aniversario no GP Salão?</div></div></div>\n<div class=\"content\" layout=\"column\" style=\"margin-top:-40px\"><div class=\"form-wrapper md-whiteframe-1dp\"><form \nname=\"basicForm\" class=\"md-inline-form\" ng-submit=\"vm.saveBirthdayConfiguration()\" novalidate><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex=\"50\" flex-gt-xs=\"50\" layout=\"column\" style=\"margin-top: 0px\"><md-checkbox \nng-model=\"vm.configuration.enableBirthdaySMS\">{{\'MARKETING.BIRTHDAY.ENABLESMS\' | translate}}</md-checkbox>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-if=\"vm.configuration.enableBirthdaySMS\">\n<md-input-container flex=\"50\" flex-gt-xs=\"50\" layout=\"column\" style=\"margin-top: 0px\"><md-checkbox \nng-model=\"vm.configuration.sendFirstSMS\">{{\'MARKETING.BIRTHDAY.SENDFIRST\' | translate}}</md-checkbox>\n</md-input-container><md-input-container flex=\"50\" flex-gt-xs=\"50\" layout=\"column\" style=\"margin-top: 0px\" \nng-show=\"vm.configuration.sendFirstSMS\"><label translate=\"MARKETING.BIRTHDAY.SENDFIRSTDAYS\"></label><input \ntype=\"number\" min=\"0\" ng-model=\"vm.configuration.firstSendNumberDaysSMS\" aria-label=\"first\"></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\" ng-show=\"vm.configuration.sendFirstSMS && vm.configuration.enableBirthdaySMS\">\n<md-input-container flex=\"100\" flex-gt-xs=\"100\"><label translate=\"MARKETING.BIRTHDAY.MESSAGE\"></label><textarea \nng-model=\"vm.configuration.messageFirstSMS\" aria-label=\"mensagemFirst\" md-maxlength=\"120\" rows=\"2\"></textarea>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-if=\"vm.configuration.enableBirthdaySMS\">\n<md-input-container flex=\"50\" flex-gt-xs=\"50\" layout=\"row\" style=\"margin-top: 0px\"><md-checkbox \nng-model=\"vm.configuration.sendSecondSMS\">{{\'MARKETING.BIRTHDAY.SENDSECOND\' | translate}}</md-checkbox>\n</md-input-container><md-input-container flex=\"50\" flex-gt-xs=\"50\" layout=\"row\" style=\"margin-top: 0px\" \nng-if=\"vm.configuration.sendSecondSMS\"><label translate=\"MARKETING.BIRTHDAY.SENDSECONDDAYS\"></label><input \ntype=\"number\" min=\"0\" ng-model=\"vm.configuration.secondSendNumberDaysSMS\" aria-label=\"second\"></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\" \nng-if=\"vm.configuration.sendSecondSMS && vm.configuration.enableBirthdaySMS\"><md-input-container flex=\"100\" \nflex-gt-xs=\"100\"><label translate=\"MARKETING.BIRTHDAY.MESSAGE\"></label><textarea \nng-model=\"vm.configuration.messageSecondSMS\" aria-label=\"mensagemSecond\" md-maxlength=\"120\" rows=\"2\" \nmd-select-on-focus></textarea></md-input-container></div><md-button type=\"submit\" class=\"md-raised\" \naria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button></form></div>\n</div></div>");
$templateCache.put("app/main/marketingv2/campaign/campaign.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'MARKETING.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'MARKETING.CAMPAIGN.HEADER\' | translate }}</span></div><div class=\"title\">\n{{ \'MARKETING.CAMPAIGN.NEW\' | translate }}</div></div></div><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" ng-submit=\"vm.saveCampaign()\" \nnovalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"MARKETING.CAMPAIGN.FIELDS.NAME\"></label><input type=\"text\" name=\"name\" ng-model=\"vm.campaign.name\" required>\n<div ng-messages=\"basicForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'MARKETING.CAMPAIGN.VALIDATION.NAME_REQUIRED\' | translate }}</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"MARKETING.CAMPAIGN.FIELDS.PRIORITY\"></label><input type=\"number\" \nname=\"priority\" ng-model=\"vm.campaign.priority\" required></md-input-container><md-input-container><md-button \nclass=\"md-icon-button\" aria-label=\"Help\" flex style=\"margin-left:-20px\"><md-icon class=\"icon-help-circle\"><md-tooltip>\n{{\'MARKETING.CAMPAIGN.HINTS.PRIORITY\' | translate}}</md-tooltip></md-icon></md-button></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"MARKETING.CAMPAIGN.FIELDS.TYPE\"></label>\n<md-select ng-model=\"vm.campaign.type\" ng-required=\"true\"><md-option ng-value=\"item.value\" \nng-repeat=\"item in vm.campaignTypes\">{{item.text}}</md-option></md-select></md-input-container><md-input-container \nflex><label translate=\"MARKETING.CAMPAIGN.FIELDS.PRICE_TABLE\"></label><md-select ng-model=\"vm.campaign.priceTableId\" \nng-required=\"true\"><md-option ng-value=\"item._id\" ng-repeat=\"item in vm.priceTables\">{{item.name}}</md-option>\n</md-select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.campaign.type == \'WEEKDAY\'\">\n<md-input-container flex>Selecione os dias da semana que essa campanha se aplica<br><md-checkbox \nng-model=\"vm.campaign.configuration.monday\">{{\'GENERAL.DAYOFWEEK.MONDAY\' | translate}}</md-checkbox>&nbsp;&nbsp;&nbsp;\n<md-checkbox ng-model=\"vm.campaign.configuration.tuesday\">{{\'GENERAL.DAYOFWEEK.TUESDAY\' | translate}}</md-checkbox>\n&nbsp;&nbsp;&nbsp;<md-checkbox ng-model=\"vm.campaign.configuration.wednesday\">\n{{\'GENERAL.DAYOFWEEK.WEDNESDAY\' | translate}}</md-checkbox>&nbsp;&nbsp;&nbsp;<md-checkbox \nng-model=\"vm.campaign.configuration.thursday\">{{\'GENERAL.DAYOFWEEK.THURSDAY\' | translate}}</md-checkbox>\n&nbsp;&nbsp;&nbsp;<md-checkbox ng-model=\"vm.campaign.configuration.friday\">{{\'GENERAL.DAYOFWEEK.FRIDAY\' | translate}}\n</md-checkbox>&nbsp;&nbsp;&nbsp;<md-checkbox ng-model=\"vm.campaign.configuration.saturday\">\n{{\'GENERAL.DAYOFWEEK.SATURDAY\' | translate}}</md-checkbox>&nbsp;&nbsp;&nbsp;<md-checkbox \nng-model=\"vm.campaign.configuration.sunday\">{{\'GENERAL.DAYOFWEEK.SUNDAY\' | translate}}</md-checkbox>\n</md-input-container></div><md-button type=\"submit\" class=\"md-raised\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid\">{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button><md-button type=\"button\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\" ui-sref=\"app.marketingv2.campaign.list\">\n{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/marketingv2/campaign/list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-cloak><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\">\n</md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'MARKETING.HEADER\' | translate }}</span></div><div class=\"title\">{{ \'MARKETING.CAMPAIGN.HEADER\' | translate }}</div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised\" \nui-sref=\"app.marketingv2.campaign.new\">{{ \'MARKETING.CAMPAIGN.NEW\' | translate }}</md-button></div></div><div \nclass=\"content\"><md-content class=\"content\" flex ng-if=\"!vm.showTable\"><br><span \nstyle=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></md-content><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'MARKETING.CAMPAIGN.FIELDS.NAME\' | translate }}</span></div></th><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'MARKETING.CAMPAIGN.FIELDS.TYPE\' | translate }}</span></div></th><th></th></tr></thead><tbody><tr \nng-repeat=\"item in vm.campaigns\"><td>{{ item.name }}</td><td>{{ item.type }}</td><td align=\"right\"><md-button \naria-label=\"Pencil\" class=\"md-raised gp-mini\" ng-click=\"vm.editCampaign(item._id)\"><md-tooltip aria-label=\"Pencil\">\n{{ \'GENERAL.HINTS.EDIT\' | translate }}</md-tooltip><i class=\"icon-pencil\" layout=\"center\"></i></md-button><md-button \naria-label=\"Trash\" class=\"md-raised md-warn gp-mini\" ng-click=\"vm.removeCampaign(item._id)\"><md-tooltip \naria-label=\"Pencil\">{{ \'GENERAL.HINT.DELETE\' | translate }}</md-tooltip><i class=\"icon-trash\" layout=\"center\"></i>\n</md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/marketingv2/loyalty/buzz.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" style=\"background-color: #0D47A1\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"center start\"><div class=\"title\">Olá Felipe</div></div></div><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\" \nstyle=\"margin:10px\"><div class=\"h3\">\nCompartilhando com seus amigos eles ganham 20% de desconto em qualquer tratamento e você ganha 20 pontos a cada cliente que contratar algum serviço nosso.\n</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"space-between center\"><md-button \nclass=\"md-fab\" style=\"background-color:green\" aria-label=\"Whatsapp\" ng-click=\"vm.whatsapp();\"><md-icon \nmd-font-icon=\"icon-whatsapp\"></md-icon></md-button><md-button class=\"md-fab\" style=\"background-color: #3b5998\" \naria-label=\"Facebook\" ng-click=\"vm.facebook();\"><md-icon md-font-icon=\"icon-facebook\"></md-icon></md-button><md-button \nclass=\"md-fab\" style=\"background-color: #00aced\" aria-label=\"Twitter\" ng-click=\"vm.twitter();\"><md-icon \nmd-font-icon=\"icon-twitter\"></md-icon></md-button><md-button class=\"md-fab\" style=\"background-color: #8a3ab9\" \naria-label=\"Instagram\" ng-click=\"vm.instagram();\"><md-icon md-font-icon=\"icon-instagram\"></md-icon></md-button></div>\n</ms-widget-front></ms-widget></div>");
$templateCache.put("app/main/marketingv2/loyalty/buzzRegister.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" style=\"background-color: #0D47A1\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"center start\"><div class=\"title\">Bem Vindo</div></div></div><div class=\"form-wrapper md-whiteframe-1dp\">\n<form name=\"basicForm\" class=\"md-inline-form\" novalidate><md-subheader>\nBem Vindo ao Beauty Style, se cadastre abaixo e ganhe 20% de desconto no primeiro serviço.</md-subheader>\n<md-input-container style=\"width:100%\"><label>Nome</label><input type=\"text\" name=\"name\" ng-model=\"vm.name\" required>\n<div ng-messages=\"basicForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Esse campo é obrigatório</span>\n</div></div></md-input-container><md-input-container style=\"width:100%\"><label>Telefone</label><input type=\"text\" \nname=\"telefone\" ng-model=\"vm.telefone\" required><div ng-messages=\"basicForm.telefone.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Esse campo é obrigatório</span></div></div></md-input-container><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-warn\" \nstyle=\"width:200px\" ui-sref=\"app.marketingv2.loyalty.buzz\">Cadastrar</md-button></div></form></div></div>");
$templateCache.put("app/main/marketingv2/loyalty/loyalty.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'MARKETING.HEADER\' | translate }}</span></div><div class=\"title\">{{ \'MARKETING.LOYALTY.HEADER\' | translate }}</div>\n</div></div><div class=\"content\" layout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.exchangePointsForService()\" novalidate><div layout=\"column\" layout-gt-sm=\"row\">\n<md-autocomplete flex required style=\"height:70px\" md-input-name=\"customerId\" md-input-id=\"customer-input\" \nmd-input-minlength=\"3\" md-no-cache=\"true\" md-selected-item=\"vm.customer\" \nmd-selected-item-change=\"vm.getCustomersPoints()\" md-autofocus=\"true\" md-search-text=\"vm.customerSearchText\" \nmd-items=\"item in vm.customerSearchTextChange(vm.customerSearchText)\" md-item-text=\"item.name\" ng-disabled=\"false\" \nplaceholder=\"Informe o nome ou telefone do cliente\" ng-attr-md-floating-label=\"Cliente\" md-require-match>\n<md-item-template><span md-highlight-text=\"vm.customerNameSearchText\">{{item.name + \' - \' + item.telephone}}</span>\n</md-item-template><div ng-messages=\"basicForm.customerId.$error\" ng-if=\"basicForm.customerId.$touched\"><div \nng-message=\"required\"><span translate=\"SCHEDULE.VALIDATION.CUSTOMER_REQUIRED\"></span></div><div \nng-message=\"md-require-match\"><span translate=\"SCHEDULE.VALIDATION.CUSTOMER_INVALID\">.</span></div></div>\n</md-autocomplete><p style=\"align-self:center;margin-left:20px;margin-right:5px;min-width:180px\">\n{{ \'MARKETING.LOYALTY.CLIENT_POINTS\' | translate }}: {{ vm.customerPoints }}</p></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-autocomplete flex required style=\"height:70px\" md-input-name=\"serviceId\" md-input-minlength=\"1\" \nmd-no-cache=\"true\" md-autofocus=\"true\" md-selected-item=\"vm.addServiceDialog.service\" \nmd-search-text=\"vm.serviceSearchText\" md-items=\"item in vm.serviceSearchTextChange(vm.serviceSearchText)\" \nmd-selected-item-change=\"vm.getServicePoints()\" md-item-text=\"item.name\" md-require-match \nng-attr-md-floating-label=\"{{vm.floatinglabel.service}}\"><md-item-template><span \nmd-highlight-text=\"vm.serviceSearchText\">{{item.name}}</span></md-item-template><div \nng-messages=\"basicForm.serviceId.$error\" ng-if=\"basicForm.serviceId.$touched\"><div ng-message=\"required\"><span \ntranslate=\"SCHEDULE.VALIDATION.SERVICE_REQUIRED\"></span></div><div ng-message=\"md-require-match\"><span \ntranslate=\"SCHEDULE.VALIDATION.SERVICE_INVALID\"></span></div></div></md-autocomplete><p \nstyle=\"align-self:center;margin-left:20px;margin-right:5px;min-width:180px\">\n{{ \'MARKETING.LOYALTY.SERVICE_POINTS\' | translate }}: {{vm.selectedService.loyaltyPoints}}</p></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"MARKETING.LOYALTY.OBS\"></label><input \ntype=\"text\" name=\"name\" ng-model=\"vm.obs\"></md-input-container></div><md-button type=\"submit\" class=\"md-raised\" \naria-label=\"Submit\" ng-disabled=\"!vm.canExchangePoints()\">{{ \'GENERAL.BUTTON.EXCHANGE\' | translate }}</md-button>\n</form></div></div></div>");
$templateCache.put("app/main/marketingv2/loyalty/site.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" style=\"background-color: #0D47A1\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"center start\"><div class=\"title\">Olá Felipe</div></div></div><md-tabs flex><md-tab label=\"Minha Conta\" \nflex><md-content flex><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">Meus Pontos</div></div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"font-size-72 line-height-72\">220</div>\n</div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 ml-8 secondary-text\">Pontue mais compartilhando com seus amigos.</span></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-warn\" \nstyle=\"width:200px\" ui-sref=\"app.marketingv2.loyalty.buzz\">Compartilhar</md-button></div></ms-widget-front></ms-widget>\n</md-content></md-tab><md-tab label=\"Extrato de Pontos\"><md-list><md-list-item class=\"md-2-line\" \nng-repeat=\"item in vm.customerTransactions\"><div class=\"md-list-item-text\"><h3>{{item.serviceName}} - {{item.when}}\n</h3><p>{{item.points}} Pontos</p></div></md-list-item></md-list></md-tab></md-tabs></div>");
$templateCache.put("app/main/marketing/spot/list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'MARKETING.HEADER\' | translate }}</span></div><div class=\"title\">{{ \'MARKETING.SPOT.HEADER\' | translate }}</div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised md-orange-500-bg\" \nui-sref=\"app.marketing.spot.new\">{{ \'MARKETING.SPOT.NEW\' | translate }}</md-button></div></div><div class=\"content\">\n<md-content class=\"content\" flex ng-if=\"!vm.showTable\"><br><span style=\"margin-left: 10px;margin-top: 10px\"><b>\nCarregando...</b></span></md-content><div class=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead>\n<tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'MARKETING.SPOT.FIELDS.NAME\' | translate }}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">{{ \'MARKETING.SPOT.FIELDS.STATUS\' | translate }}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'MARKETING.SPOT.FIELDS.WHEN\' | translate }}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">{{ \'MARKETING.SPOT.FIELDS.SMS_SENT\' | translate }}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'MARKETING.SPOT.FIELDS.EMAIL_SENT\' | translate }}</span></div></th><th></th></tr></thead><tbody><tr \nng-repeat=\"campaign in vm.spotCampaigns\"><td>{{ campaign.name }}</td><td>{{ campaign.status }}</td><td>\n{{ campaign.when | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{ campaign.smsSent }}</td><td>{{ campaign.emailSent }}</td><td \nalign=\"right\"><md-button aria-label=\"Pencil\" class=\"md-raised md-accent gp-mini\" \nng-disabled=\"campaign.status!=\'PENDING\' && campaign.status!=\'SAVED\'\" ng-click=\"vm.editSpotCampaign(campaign._id)\">\n<md-tooltip aria-label=\"Pencil\">{{ \'GENERAL.HINTS.EDIT\' | translate }}</md-tooltip><i class=\"icon-pencil\" \nlayout=\"center\"></i></md-button><md-button aria-label=\"Trash\" class=\"md-raised md-warn gp-mini\" \nng-disabled=\"campaign.status!=\'PENDING\' && campaign.status!=\'SAVED\'\" ng-click=\"vm.removeSpotCampaign(campaign._id)\">\n<md-tooltip aria-label=\"Pencil\">{{ \'GENERAL.HINTS.TRASH\' | translate }}</md-tooltip><i class=\"icon-trash\" \nlayout=\"center\"></i></md-button><md-button aria-label=\"Copy\" class=\"md-raised md-accent gp-mini\" \nng-click=\"vm.copySpotCampaign(campaign._id)\"><md-tooltip aria-label=\"Copy\">{{ \'GENERAL.HINTS.COPY\' | translate }}\n</md-tooltip><i class=\"icon-content-copy\" layout=\"center\"></i></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/marketing/spot/spot.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'MARKETING.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<a href=\"#\" ui-sref=\"app.marketing.spot.list\" style=\"color: black\"><span class=\"parent\">\n{{ \'MARKETING.SPOT.HEADER\' | translate }}</span></a></div><div class=\"title\">{{ \'MARKETING.SPOT.HEADER\' | translate }}\n</div></div></div><div layout=\"row\"><ms-form-wizard flex><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">{{\'GENERAL.GENERALINFO\' | translate}}</span></span></md-tab-label>\n<md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container flex=\"50\" flex-gt-xs=\"50\"><input type=\"text\" name=\"name\" \nng-model=\"vm.spot.name\" placeholder=\"{{\'MARKETING.SPOT.FIELDS.NAME\' | translate}}\" required><div \nng-messages=\"wizardStep1.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'MARKETING.SPOT.VALIDATION.NAME_REQUIRED\' | translate}}</span></div></div></md-input-container><md-input-container \nflex=\"50\" flex-gt-xs=\"50\"><input type=\"text\" name=\"description\" ng-model=\"vm.spot.description\" \nplaceholder=\"{{\'MARKETING.SPOT.FIELDS.DESCRIPTION\' | translate}}\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><div style=\"margin-top: 0px;margin-left: 0px\" flex=\"50\"><div style=\"margin-top: 0px\"><h3>\n{{\'MARKETING.SPOT.FIELDS.WHENHEADER\' | translate}}</h3><br></div><md-input-container style=\"margin-top: -50px\">\n<md-radio-group ng-model=\"vm.spot.scheduleType\"><md-radio-button value=\"NOW\">{{\'GENERAL.NOW\' | translate}}\n</md-radio-button><md-radio-button value=\"AFTER\">{{\'GENERAL.SCHEDULED\' | translate}}</md-radio-button></md-radio-group>\n<md-input-container style=\"margin-top: 49px\"><md-datepicker ng-model=\"vm.spot.whenDate\" \nng-disabled=\"vm.spot.scheduleType==\'NOW\'\" name=\"date\" md-placeholder=\"Date\" aria-label=\"Data\"></md-datepicker>\n</md-input-container><md-input-container><md-select name=\"time\" ng-model=\"vm.spot.whenTime\" aria-label=\"Horario\" \nng-disabled=\"vm.spot.scheduleType==\'NOW\'\"><md-option value=\"{{item.time}}\" ng-repeat=\"item in vm.timetable\">\n{{item.timeStr}}</md-option></md-select></md-input-container></md-input-container></div><div \nstyle=\"margin-top: 0px;margin-left: 0px\" flex=\"50\"><div style=\"margin-top: 0px\"><h3>\n{{\'MARKETING.SPOT.FIELDS.CUPOMHEADER\' | translate}}</h3><br></div><md-input-container style=\"margin-top: -20px\">\n<md-radio-group ng-model=\"vm.spot.discountCupom\"><md-radio-button value=\"N\">{{\'GENERAL.NO\' | translate}}\n</md-radio-button><md-radio-button value=\"Y\">{{\'GENERAL.YES\' | translate}}</md-radio-button></md-radio-group>\n</md-input-container><md-input-container style=\"margin-top: 0px;margin-left: 10px;width:60px\"><input type=\"number\" \naria-label=\"DiscountValue\" name=\"discountValue\" ng-model=\"vm.spot.discountCupomValue\" min=\"1\" \nng-required=\"vm.spot.discountCupom==\'N\'\" ng-disabled=\"vm.spot.discountCupom==\'N\'\"></md-input-container>\n<md-input-container style=\"margin-top: -25px\"><md-select aria-label=\"DiscountType\" \nng-model=\"vm.spot.discountCupomType\" ng-disabled=\"vm.spot.discountCupom==\'N\'\"><md-option aria-label=\"P\" value=\"P\">\n{{\'GENERAL.PERCENTAGE\' | translate}}</md-option><md-option aria-label=\"V\" value=\"V\">{{\'GENERAL.VALUE\' | translate}}\n</md-option></md-select></md-input-container><md-input-container style=\"margin-top: 0px\"><md-datepicker \nplaceholder=\"{{\'GENERAL.VALID_UNTIL\' | translate}}\" ng-model=\"vm.spot.discountCupomValidUntil\" \nng-disabled=\"vm.spot.discountCupom==\'N\'\" name=\"validUntil\" md-placeholder=\"Date\" aria-label=\"Data\"></md-datepicker>\n</md-input-container></div></div></form></md-tab-body></md-tab><md-tab><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">SMS</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" \nms-form-wizard-form novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>\n{{\'MARKETING.SPOT.FIELDS.SMSBODY\' | translate}}</label><textarea name=\"smsBody\" ng-model=\"vm.spot.SMSBody\" lines=\"2\" \nlength=\"120\" md-maxlength=\"120\" required>\n                                    <div \nng-messages=\"wizardStep2.smsBody.$error\" role=\"alert\">\n                                        <div \nng-message=\"required\"><span>{{\'MARKETING.SPOT.FIELDS.CUPOMHEADER\' | translate}}</span></div>\n                                    </div>\n                                    </textarea></md-input-container></div>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"50\" flex-gt-xs=\"50\" layout=\"column\" \nstyle=\"margin-top: -20px\"><md-subheader style=\"margin-left: -20px\">\n{{\'MARKETING.SPOT.FIELDS.SMS_DELIVERY_TYPE\' | translate}}</md-subheader><md-radio-group \nng-model=\"vm.spot.smsDeliveryMethod\"><md-radio-button value=\"SP\">\n{{\'MARKETING.SPOT.FIELDS.SMS_DELIVERY_STYLE_PLACE\' | translate}}</md-radio-button><md-radio-button value=\"android\">\n{{\'MARKETING.SPOT.FIELDS.SMS_DELIVERY_ANDROID\' | translate}}</md-radio-button></md-radio-group></md-input-container>\n</div></form></md-tab-body></md-tab><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\">{{\'MARKETING.SPOT.SEGMENTATION\' | translate}}</span></span></md-tab-label>\n<md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form novalidate><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex=\"50\" flex-gt-xs=\"50\" layout=\"column\" style=\"margin-top: -10px\">\n{{\'MARKETING.SPOT.SEGMENTBYCATEGORY\' | translate}}<md-radio-group ng-model=\"vm.spot.filterServiceCategory\" \nlayout=\"row\"><md-radio-button value=\"N\">{{\'GENERAL.NO\' | translate}}</md-radio-button><md-radio-button value=\"Y\">\n{{\'GENERAL.YES\' | translate}}</md-radio-button></md-radio-group><div style=\"margin-top: 30px;padding: 10px\" \nlayout=\"column\"><md-checkbox ng-model=\"vm.chkServiceCategory[service._id]\" \nng-disabled=\"vm.spot.filterServiceCategory==\'N\'\" style=\"font-size:12px\" ng-repeat=\"service in vm.serviceCategories\">\n{{service.name}}</md-checkbox></div></md-input-container><md-input-container flex=\"50\" flex-gt-xs=\"50\" \nstyle=\"margin-top: -10px\">{{\'MARKETING.SPOT.SEGMENTBYPROFESSIONAL\' | translate}}<md-radio-group \nng-model=\"vm.spot.filterProfessionalRelationship\" layout=\"row\"><md-radio-button value=\"N\">{{\'GENERAL.NO\' | translate}}\n</md-radio-button><md-radio-button value=\"Y\">{{\'GENERAL.YES\' | translate}}</md-radio-button></md-radio-group><div \nstyle=\"margin-top: 30px;padding: 10px\" layout=\"column\"><md-checkbox ng-model=\"vm.chkProfessional[professional._id]\" \nng-disabled=\"vm.spot.filterProfessionalRelationship==\'N\'\" style=\"font-size:12px\" \nng-repeat=\"professional in vm.professionals\">{{professional.name}}</md-checkbox></div></md-input-container></div>\n</form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\">\n<md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">\n{{\'GENERAL.PREVIOUS\' | translate}}</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\">{{\'GENERAL.NEXT\' | translate}}</md-button><md-button \nclass=\"md-raised md-warn\" ng-click=\"vm.saveSpotCampaign();\" ng-show=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.formsIncomplete()\">{{\'GENERAL.SEND\' | translate}}</md-button></div></ms-form-wizard></div></div>");
$templateCache.put("app/main/marketing/partnership/list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-cloak><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\">\n</md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'MARKETING.HEADER\' | translate }}</span></div><div class=\"title\">{{ \'MARKETING.PARTNERSHIP.HEADER\' | translate }}\n</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised md-orange-500-bg\" \nui-sref=\"app.marketing.partnership.new\">{{ \'MARKETING.PARTNERSHIP.NEW\' | translate }}</md-button></div></div><div \nclass=\"content\"><md-content class=\"content\" flex ng-if=\"!vm.showTable\"><br><span \nstyle=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></md-content><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'MARKETING.PARTNERSHIP.FIELDS.NAME\' | translate }}</span></div></th>\n<th></th></tr></thead><tbody><tr ng-repeat=\"item in vm.partnerships\"><td>{{ item.name }}</td><td align=\"right\">\n<md-button aria-label=\"Trash\" class=\"md-raised md-warn gp-mini\" ng-click=\"vm.removePartnership(item._id)\"><md-tooltip \naria-label=\"Pencil\">{{ \'GENERAL.HINT.REMOVE\' | translate }}</md-tooltip><i class=\"icon-trash\" layout=\"center\"></i>\n</md-button></td></tr></tbody></table></div></div><md-sidenav class=\"md-sidenav-right\" md-component-id=\"filter\" \nmd-is-locked-open=\"false\" md-whiteframe=\"4\"><md-toolbar class=\"md-hue-2\"><div class=\"md-toolbar-tools\"><h2>\n{{\'GENERAL.FILTER\' | translate}}</h2><span flex></span><md-button class=\"md-raised md-orange-500-bg\" \naria-label=\"Refresh\" ng-click=\"vm.refresh()\">{{\'GENERAL.REFRESH\'|translate}}</md-button></div></md-toolbar><md-content \nlayout-padding><md-subheader style=\"margin-left: -20px\">Período</md-subheader><div layout=\"row\"><span \nstyle=\"margin-left: 10px\">{{\'GENERAL.FROM\'|translate}}<md-datepicker ng-model=\"vm.filter.dtFrom\"></md-datepicker>\n</span></div><div layout=\"row\"><span style=\"margin-left: 10px\">{{\'GENERAL.TO\'|translate}}<md-datepicker \nng-model=\"vm.filter.dtTo\"></md-datepicker></span></div><md-subheader style=\"margin-left: -10px\">\n{{ \'MARKETING.CUPOM.FIELDS.STATUS.HEADER\' | translate }}</md-subheader><div layout=\"row\" style=\"margin-top: 0px\">\n<md-checkbox ng-model=\"vm.filter.used\">{{ \'MARKETING.CUPOM.FIELDS.STATUS.USED\' | translate }}</md-checkbox></div><div \nlayout=\"row\" style=\"margin-top: -20px\"><md-checkbox ng-model=\"vm.filter.notUsed\">\n{{ \'MARKETING.CUPOM.FIELDS.STATUS.NOT_USED\' | translate }}</md-checkbox></div><div layout=\"row\" \nstyle=\"margin-top: -20px\"><md-checkbox ng-model=\"vm.filter.canceled\">\n{{ \'MARKETING.CUPOM.FIELDS.STATUS.CANCELED\' | translate }}</md-checkbox></div><div layout=\"row\" \nstyle=\"margin-top: -20px\"><md-checkbox ng-model=\"vm.filter.expired\">\n{{ \'MARKETING.CUPOM.FIELDS.STATUS.EXPIRED\' | translate }}</md-checkbox></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/marketing/partnership/partnership.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'MARKETING.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'MARKETING.PARTNERSHIP.HEADER\' | translate }}</span></div><div class=\"title\">\n{{ \'MARKETING.PARTNERSHIP.NEW\' | translate }}</div></div></div><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" ng-submit=\"vm.savePartnership()\" \nnovalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"MARKETING.PARTNERSHIP.FIELDS.NAME\"></label><input type=\"text\" name=\"name\" ng-model=\"vm.name\" required><div \nng-messages=\"basicForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'MARKETING.PARTNERSHIP.VALIDATION.NAME_REQUIRED\' | translate }}</span></div></div></md-input-container></div>\n<md-button type=\"submit\" class=\"md-accent\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">\n{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button><md-button type=\"button\" class=\"md-warn\" aria-label=\"Cancel\" \nui-sref=\"app.marketing.partnership.list\">{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/marketingv2/noShowReschedule/configuration.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'MARKETING.HEADER\' | translate }}</span></div><div class=\"title\">\n{{ \'MARKETING.NOSHOWRESCHEDULE.HEADER\' | translate }}</div></div></div><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><div layout=\"column\"><strong>Como funciona?</strong><br>\nSe for marcado o seu cliente receberá uma mensagem de para que ele reagende sempre que por alguma razão ele não tiver comparecido a um apontamento.\n<br>\nEx. Se a cliente tinha marcado hoje a tarde, mas por alguma razao nao apareceu, o sistema manda uma mensagem para ela sugerindo que seja feito o reagendamento.\n</div></div></div><div class=\"content\" layout=\"column\" style=\"margin-top:-40px\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" \nng-submit=\"vm.saveConfiguration()\" novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"50\" \nflex-gt-xs=\"50\" layout=\"column\" style=\"margin-top: 0px\"><md-checkbox ng-model=\"vm.configuration.enableSMS\">\n{{\'MARKETING.NOSHOWRESCHEDULE.ENABLESMS\' | translate}}</md-checkbox></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" ng-if=\"vm.configuration.enableSMS\"><md-input-container flex=\"100\" flex-gt-xs=\"100\"><label \ntranslate=\"MARKETING.NOSHOWRESCHEDULE.MESSAGE\"></label><textarea ng-model=\"vm.configuration.messageSMS\" \naria-label=\"mensagem\" md-maxlength=\"120\" rows=\"2\" md-select-on-focus></textarea></md-input-container></div><md-button \ntype=\"submit\" class=\"md-raised\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">\n{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/marketingv2/loyalty2/config.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Encante seus Clientes</span>\n<md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Fidelidade</span></div>\n<div class=\"title\">Configuração</div></div></div><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex><b>Dica WoWee</b><br>\nProgramas de fidelidade são uma excelente ferramenta para ampliar o nível de fidelização de seu cliente. Mas lembre você deve oferecer uma recompensa que seja perceptível pelo cliente. Ex. após o cliente fazer a mão 10 vezes, ele ganha 1 mão de graça.\n<br><br></div><div class=\"form-wrapper md-whiteframe-1dp\" layout=\"row\"><form name=\"basicForm\" class=\"md-inline-form\" \nflex=\"70\" ng-submit=\"vm.saveConfiguration()\" novalidate><div layout=\"row\"><div layout=\"column\" layout-gt-sm=\"row\">\n<md-checkbox ng-model=\"vm.configuration.loyaltyConfiguration.active\">Ativar sistema de fidelidade</md-checkbox></div>\n</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>\nSMS enviado ao cliente quando ele ganhar o prêmio</label><textarea name=\"smsMessage\" \nng-model=\"vm.configuration.loyaltyConfiguration.SMSMessage\" lines=\"4\" maxlength=\"140\"></textarea><span \nstyle=\"font-size: 12px;color:red\">Tamanho máximo de 140 caracteres. Não pode conter acentos nem cedilha.</span><br>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>\nSMS enviado ao cliente para lembrar ele da pontuação que ele possui</label><textarea name=\"smsMessageRemember\" \nng-model=\"vm.configuration.loyaltyConfiguration.SMSMessageRemember\" lines=\"4\" maxlength=\"140\"></textarea><span \nstyle=\"font-size: 12px;color:red\">Tamanho máximo de 140 caracteres. Não pode conter acentos nem cedilha.<br>\n[PONTOS_GANHOS] - será substituido pelos pontos já ganhos pelo cliente<br>\n[TOTAL_PONTOS] - será substituido pelo número de pontos totais necessários<br>\n[PONTOS_FALTAM] - será substituído pelo número de pontos que faltam<br></span><br></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Serviço que será concedido</label><md-select \nname=\"prize\" ng-model=\"vm.configuration.loyaltyConfiguration.prizeServiceId\" required><md-option ng-value=\"item._id\" \nng-repeat=\"item in vm.services\">{{item.name}}</md-option></md-select></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label>Valor que será pago de comissão ao profissional</label><input \ntype=\"number\" name=\"valorComissao\" ng-model=\"vm.configuration.loyaltyConfiguration.serviceCost\" min=\"0\" required><div \nng-messages=\"basicForm.valorComissao.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nValor que será pago ao profissional quando uma gratuidade for concedida.</span></div></div></md-input-container>\n<md-input-container flex><label>Pontos necessários para ganhar o prêmio</label><input type=\"number\" name=\"points\" \nng-model=\"vm.configuration.loyaltyConfiguration.pointsToRedeem\" min=\"1\" required><div \nng-messages=\"basicForm.points.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nÉ necessário preencher o número de pontos necessários para se ganhar o prêmio.</span></div></div></md-input-container>\n</div><md-button type=\"submit\" class=\"md-raised\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">\n{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button><md-button type=\"button\" class=\"md-raised md-warn\" \naria-label=\"Cancel\" ui-sref=\"app.marketingv2.loyalty2.dashboard\">{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button>\n<md-button type=\"button\" class=\"md-raised md-warn\" aria-label=\"Reset\" ng-click=\"vm.resetEntireLoyalty();\">\nResetar TODOS os pontos</md-button></form><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"30\" \nstyle=\"margin-left: 10px\"><b>Explicação do plano fidelidade</b><br>\nA cada serviço executado o sistema irá creditar o número de pontos que foi configurado para o serviço <a href=\"#\" \nui-sref=\"app.settings.service.service.list\" style=\"color: blue\">(clique aqui para configrar)</a>\n. Quando o cliente somar pontos necessários para ganhar o serviço de cortesia, o sistema irá creditar automaticamente uma unidade desse serviço e colocar na conta do cliente. Nesse momento um SMS será enviado ao cliente, lhe parabenizando e informando que ele tem direito a uma cortesia. Na próxima visita esse cliente poderá fazer esse serviço e o sistema vai debitar desse crédito ao invés de gerar um custo para o cliente.\n<br><b>Ainda ficou com dúvidas de como fazer? Fale agora com o nosso suporte.</b></div></div></div></div>");
$templateCache.put("app/main/marketingv2/loyalty2/dashboard.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Encante seus Clientes</span>\n</div><div class=\"title\">Fidelidade</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised\" ui-sref=\"app.marketingv2.loyalty2.explorenow\" ng-if=\"vm.profileAdmin\">Explorar Funcionamento\n</md-button><md-button class=\"md-raised\" ui-sref=\"app.marketingv2.loyalty2.configuration\" ng-if=\"vm.profileAdmin\">\nConfiguração</md-button></div></div><div class=\"content\"><div class=\"white-bg md-whiteframe-40dp\" layout=\"row\" \nlayout-align=\"center center\" height=\"100px\" ng-show=\"!vm.showTable\"><br><span \nstyle=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></div><div class=\"white-bg md-whiteframe-4dp\" \nng-show=\"vm.showTable\"><table datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" \nclass=\"row-border hover\"></table></div></div></div>");
$templateCache.put("app/main/marketingv2/loyalty2/explore.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Encante seus Clientes</span>\n<md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Fidelidade</span></div>\n<div class=\"title\">Porque & Como</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised\" \nui-sref=\"app.marketingv2.loyalty2.dashboard\">Seguir para a Fidelidade</md-button></div></div><div class=\"content\"><h1>\nPor que devo ter um programa de fidelidade?</h1><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\"><ms-widget-front \nclass=\"white-bg\"><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"start center\"><div class=\"line-height-23\" \nstyle=\"margin:10px;font-size:15px\">\nProgramas de fidelidade irão te ajudar na difícil tarefa de encantar seu cliente. Somente encantando seu cliente ele irá voltar e passará a ser um promotor/divulgador do seu salão. &nbsp;Como recompensa você pode oferecer serviços do próprio salão.\n<br><i style=\"font-size:15px\">\nHá casos em que após 6 meses da aplicação do programa o crescimento na base de clientes chegou a 30% de forma consistente.\n</i> <a href=\"https://www.wowee.club/programa-para-salao-e-barbearia/blog/category/fidelize-clientes/\" target=\"_blank\" \nstyle=\"color: blue\">Confira outras dicas de encantamento dos nossos especialistas aqui.</a></div></div>\n</ms-widget-front></ms-widget></div><h1>Como configurar?</h1><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"start center\"><div class=\"h3\"><b>Passo 1</b>\n</div></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"start center\"><div class=\"line-height-23\" \nstyle=\"margin:10px;font-size:15px\">\nCadastre os pontos que cada serviço gera pro cliente. Caso somente alguns serviços gerem pontos, basta você configurar esses serviços. \n<a style=\"color: blue\" href=\"#\" ui-sref=\"app.settings.service.service.list\">Clique aqui para cadastrar.</a></div></div>\n</ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"h3\"><b>Passo 2</b></div></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"line-height-23\" style=\"margin:10px;font-size:15px\">\nDefinir e configurar a campanha de fidelidade. Um exemplo de campanha bastante comum é a cada 10 serviços de mão voce conceder 1 serviço de mão gratuito para a cliente. \n<a style=\"color: blue\" href=\"#\" ui-sref=\"app.marketingv2.loyalty2.configuration\">Clique aqui para configurar.</a></div>\n</div></ms-widget-front></ms-widget></div><h1>Como funciona?</h1><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\"><b>\nGanhando pontos</b></div></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"line-height-23\" style=\"margin:10px;font-size:15px\">\nO cliente ganhará pontos sempre que um serviço passível de pontos for registrado em sua comanda. Além disso o operador do sistema pode fazer lançamentos manuais no programa de fidelidade do cliente.\n</div></div></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\"><b>Resgatando pontos</b></div></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"line-height-23\" style=\"margin:10px;font-size:15px\">\nO cliente ganhará o serviço determinado como prêmio automaticamente, sempre que seus pontos ultrapassarem a quantidade minima necessária. Nesse momento será enviado um SMS ao cliente informando de seu brinde.\n<br>\nA qualquer momento você pode clicar no botão de mensagem e enviar uma mensagem para o cliente lhe informando de seu saldo no programa.\n</div></div></ms-widget-front></ms-widget></div><form><md-checkbox style=\"margin: 10px\" \nng-model=\"vm.showLoyaltyExplorer\">Não mostrar mais essa tela</md-checkbox></form></div></div>");
$templateCache.put("app/main/marketingv2/loyalty2/transactions.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Marketing</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Fidelidade</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Transações</span></div><div \nclass=\"title\">{{vm.customerName}}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised\" ng-click=\"vm.resetCustomerLoyalty();\">Resetar Pontos do Cliente</md-button></div></div><div \nclass=\"content\"><div class=\"white-bg md-whiteframe-40dp\" layout=\"row\" layout-align=\"center center\" height=\"100px\" \nng-show=\"!vm.showTable\"><br><span style=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></div><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Data</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Pontos</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Observação</span></div></th><th></th></tr></thead><tbody><tr \nng-repeat=\"transaction in ::vm.transactions\"><td>{{ transaction.date }}</td><td>{{ transaction.pontos }}</td><td>\n{{ transaction.observation }}</td><td align=\"right\"><md-button aria-label=\"Trash\" class=\"md-raised md-warn gp-mini\" \nng-click=\"vm.removeTransaction(transaction._id)\"><md-tooltip aria-label=\"Pencil\">\n{{ \'GENERAL.HINTS.TRASH\' | translate }}</md-tooltip><i class=\"icon-trash\" layout=\"center\"></i></md-button></td></tr>\n</tbody></table></div></div></div>");
$templateCache.put("app/main/marketingv2/partnership/list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" ng-cloak><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\">\n</md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'MARKETING.HEADER\' | translate }}</span></div><div class=\"title\">{{ \'MARKETING.PARTNERSHIP.HEADER\' | translate }}\n</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised\" \nui-sref=\"app.marketingv2.partnership.new\">{{ \'MARKETING.PARTNERSHIP.NEW\' | translate }}</md-button><md-button \nclass=\"md-raised gp-mini\" ng-click=\"showHelp(\'partnershipList\');\">?<md-tooltip aria-label=\"Pencil\">Vídeo Explicativo\n</md-tooltip></md-button></div></div><div class=\"content\"><md-content class=\"content\" flex ng-if=\"!vm.showTable\"><br>\n<span style=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></md-content><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'MARKETING.PARTNERSHIP.FIELDS.NAME\' | translate }}</span></div></th>\n<th></th></tr></thead><tbody><tr ng-repeat=\"item in vm.partnerships\"><td>{{ item.name }}</td><td align=\"right\">\n<md-button aria-label=\"Pencil\" class=\"md-raised md-accent gp-mini\" ng-click=\"vm.editPartnership(item._id)\"><md-tooltip \naria-label=\"Pencil\">{{ \'GENERAL.HINTS.EDIT\' | translate }}</md-tooltip><i class=\"icon-pencil\" layout=\"center\"></i>\n</md-button><md-button aria-label=\"Trash\" class=\"md-raised md-warn gp-mini\" ng-click=\"vm.removePartnership(item._id)\">\n<md-tooltip aria-label=\"Pencil\">{{ \'GENERAL.HINT.REMOVE\' | translate }}</md-tooltip><i class=\"icon-trash\" \nlayout=\"center\"></i></md-button></td></tr></tbody></table></div></div><md-sidenav class=\"md-sidenav-right\" \nmd-component-id=\"filter\" md-is-locked-open=\"false\" md-whiteframe=\"4\"><md-toolbar class=\"md-hue-2\"><div \nclass=\"md-toolbar-tools\"><h2>{{\'GENERAL.FILTER\' | translate}}</h2><span flex></span><md-button \nclass=\"md-raised md-orange-500-bg\" aria-label=\"Refresh\" ng-click=\"vm.refresh()\">{{\'GENERAL.REFRESH\'|translate}}\n</md-button></div></md-toolbar><md-content layout-padding><md-subheader style=\"margin-left: -20px\">Período\n</md-subheader><div layout=\"row\"><span style=\"margin-left: 10px\">{{\'GENERAL.FROM\'|translate}}<md-datepicker \nng-model=\"vm.filter.dtFrom\"></md-datepicker></span></div><div layout=\"row\"><span style=\"margin-left: 10px\">\n{{\'GENERAL.TO\'|translate}}<md-datepicker ng-model=\"vm.filter.dtTo\"></md-datepicker></span></div><md-subheader \nstyle=\"margin-left: -10px\">{{ \'MARKETING.CUPOM.FIELDS.STATUS.HEADER\' | translate }}</md-subheader><div layout=\"row\" \nstyle=\"margin-top: 0px\"><md-checkbox ng-model=\"vm.filter.used\">{{ \'MARKETING.CUPOM.FIELDS.STATUS.USED\' | translate }}\n</md-checkbox></div><div layout=\"row\" style=\"margin-top: -20px\"><md-checkbox ng-model=\"vm.filter.notUsed\">\n{{ \'MARKETING.CUPOM.FIELDS.STATUS.NOT_USED\' | translate }}</md-checkbox></div><div layout=\"row\" \nstyle=\"margin-top: -20px\"><md-checkbox ng-model=\"vm.filter.canceled\">\n{{ \'MARKETING.CUPOM.FIELDS.STATUS.CANCELED\' | translate }}</md-checkbox></div><div layout=\"row\" \nstyle=\"margin-top: -20px\"><md-checkbox ng-model=\"vm.filter.expired\">\n{{ \'MARKETING.CUPOM.FIELDS.STATUS.EXPIRED\' | translate }}</md-checkbox></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/marketingv2/partnership/partnership.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'MARKETING.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'MARKETING.PARTNERSHIP.HEADER\' | translate }}</span></div><div class=\"title\">\n{{ \'MARKETING.PARTNERSHIP.NEW\' | translate }}</div></div></div><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" ng-submit=\"vm.savePartnership()\" \nnovalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"MARKETING.PARTNERSHIP.FIELDS.NAME\"></label><input type=\"text\" name=\"name\" ng-model=\"vm.partnership.name\" \nrequired><div ng-messages=\"basicForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'MARKETING.PARTNERSHIP.VALIDATION.NAME_REQUIRED\' | translate }}</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"MARKETING.CAMPAIGN.FIELDS.PRIORITY\">\n</label><input type=\"number\" name=\"priority\" ng-model=\"vm.partnership.priority\" required></md-input-container>\n<md-input-container><md-button class=\"md-icon-button\" aria-label=\"Help\" flex style=\"margin-left:-20px\"><md-icon \nclass=\"icon-help-circle\"><md-tooltip>{{\'MARKETING.CAMPAIGN.HINTS.PRIORITY\' | translate}}</md-tooltip></md-icon>\n</md-button></md-input-container><md-input-container flex><label translate=\"MARKETING.CAMPAIGN.FIELDS.PRICE_TABLE\">\n</label><md-select ng-model=\"vm.partnership.priceTableId\" ng-required=\"true\"><md-option ng-value=\"item._id\" \nng-repeat=\"item in vm.priceTables\">{{item.name}}</md-option></md-select></md-input-container></div><md-button \ntype=\"submit\" class=\"md-raised\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">\n{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button><md-button type=\"button\" class=\"md-raised md-warn\" \naria-label=\"Cancel\" ui-sref=\"app.marketingv2.partnership.list\">{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button>\n</form></div></div></div>");
$templateCache.put("app/main/marketingv2/spot/configuration.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'MARKETING.HEADER\' | translate }}</span></div><div class=\"title\">Envio de Mensagens</div></div></div><div \nclass=\"content\" layout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\"><div layout=\"column\" style=\"width: 400px\">\n<strong>Quota</strong> <span>SMS: <b>{{vm.SMSQuota}}</b> <a href=\"#\" ui-sref=\"app.subscription.extras\">\n(Clique aqui para comprar mais)</a></span> Push: Ilimitado para quem possui App Próprio</div></div></div><div \nclass=\"content\" layout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" \nms-horizontal-stepper ng-submit=\"vm.sendMessage()\" novalidate><ms-horizontal-stepper-step ng-form=\"step1\" step=\"1\" \nstep-title=\"\'Informações Gerais\'\"><div layout=\"row\" flex><md-input-container flex=\"50\"><label>Tipo de Mensagem</label>\n<md-select ng-model=\"vm.messageType\"><md-option data-value=\"SMS\">SMS</md-option><md-option data-value=\"PUSH\" \nng-disabled=\"true\">PUSH</md-option></md-select></md-input-container><md-input-container flex=\"50\"><label>\nTipo de Campanha</label><md-select ng-model=\"vm.filterType\"><md-option data-value=\"TODOS\">Todos os clientes</md-option>\n<md-option data-value=\"ATIVOS\">Clientes ativos no período</md-option><md-option data-value=\"SERVICO\">\nClientes que fizeram tais serviços</md-option><md-option data-value=\"PROFISSIONAL\">Clientes que usam tais profissionais\n</md-option><md-option data-value=\"TAG\">Clientes marcados com alguma Tag especifica</md-option></md-select>\n</md-input-container></div><div layout=\"row\" flex><md-input-container flex=\"50\"><label>Limitar tamanho da campanha\n</label><input type=\"number\" ng-model=\"vm.limitNumber\"></md-input-container></div><div layout=\"column\" \nng-if=\"vm.messageType==\'SMS\'\"><md-input-container flex><label>Mensagem</label><textarea rows=\"2\" \nng-model=\"vm.messageSMS\" name=\"message\" maxlength=\"160\" required></textarea><span style=\"font-size: 12px;color:red\">\n{{vm.messageSMS.length}} de 160</span><div ng-messages=\"step1.message.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>A mensagem é obrigatória</span></div></div></md-input-container></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"step2\" step=\"2\" step-title=\"\'Filtro\'\"><md-content ng-if=\"vm.filterType==\'TODOS\'\">\nA mensagem informada será enviada para todos os clientes presente na sua base de dados.</md-content><div layout=\"row\" \nng-if=\"vm.filterType==\'ATIVOS\'\"><md-input-container flex=\"50\" layout=\"column\"><label style=\"margin-bottom: 10px\">\nPeríodo</label><md-select ng-model=\"vm.filterAtivos.period\"><md-option data-value=\"30\">Últimos 30 dias</md-option>\n<md-option data-value=\"60\">Últimos 60 dias</md-option><md-option data-value=\"90\">Últimos 90 dias</md-option><md-option \ndata-value=\"180\">Últimos 180 dias</md-option><md-option data-value=\"360\">Últimos 360 dias</md-option></md-select>\n</md-input-container></div><div layout=\"row\" ng-if=\"vm.filterType==\'TAG\'\"><md-input-container flex=\"50\" \nlayout=\"column\"><label style=\"margin-bottom: 10px\">Período desde a última compra</label><md-select \nng-model=\"vm.filterTags.period\"><md-option data-value=\"-1\">Ignorar período</md-option><md-option data-value=\"30\">\nÚltimos 30 dias</md-option><md-option data-value=\"60\">Últimos 60 dias</md-option><md-option data-value=\"90\">\nÚltimos 90 dias</md-option><md-option data-value=\"180\">Últimos 180 dias</md-option><md-option data-value=\"360\">\nÚltimos 360 dias</md-option></md-select></md-input-container></div><div layout=\"row\" ng-if=\"vm.filterType==\'TAG\'\">\n<md-chips ng-model=\"vm.filterTags.tags\" name=\"tags\" flex=\"50\" md-removable=\"true\" md-max-chips=\"20\" \nplaceholder=\"Incluir clientes com as tags\"><md-chip-template>{{$chip}}</md-chip-template></md-chips><md-input-container\n flex=\"50\" layout=\"column\"><label style=\"margin-bottom: 10px\">\nExcluir clientes que participaram das campanhas selecionadas</label><md-select multiple=\"true\" \nng-model=\"vm.filterTags.excludeCustomersFromOtherCampaign\"><md-option ng-value=\"item.MASP_CD_MARKETING_SPOT\" \nng-repeat=\"item in vm.spotCampaigns\">{{item.MASP_TX_NAME}}</md-option></md-select></md-input-container></div><div \nlayout=\"row\" ng-if=\"vm.filterType==\'SERVICO\'\"><md-input-container flex=\"50\" layout=\"column\"><label \nstyle=\"margin-bottom: 10px\">Período</label><md-select ng-model=\"vm.filterServico.period\"><md-option data-value=\"30\">\nÚltimos 30 dias</md-option><md-option data-value=\"60\">Últimos 60 dias</md-option><md-option data-value=\"90\">\nÚltimos 90 dias</md-option><md-option data-value=\"180\">Últimos 180 dias</md-option><md-option data-value=\"360\">\nÚltimos 360 dias</md-option></md-select></md-input-container><md-input-container flex=\"50\" layout=\"column\"><label \nstyle=\"margin-bottom: 10px\">Categoria</label><md-select ng-model=\"vm.filterServico.category\" required name=\"category\">\n<md-option ng-value=\"item._id\" ng-repeat=\"item in vm.serviceCategories\">{{item.name}}</md-option></md-select><div \nng-messages=\"step2.category.$error\" role=\"alert\"><div ng-message=\"required\"><span>A categoria de serviços é obrigatória\n</span></div></div></md-input-container></div><div layout=\"row\" ng-if=\"vm.filterType==\'PROFISSIONAL\'\">\n<md-input-container flex=\"50\" layout=\"column\"><label style=\"margin-bottom: 10px\">Período</label><md-select \nng-model=\"vm.filterProfissional.period\"><md-option data-value=\"30\">Últimos 30 dias</md-option><md-option \ndata-value=\"60\">Últimos 60 dias</md-option><md-option data-value=\"90\">Últimos 90 dias</md-option><md-option \ndata-value=\"180\">Últimos 180 dias</md-option><md-option data-value=\"360\">Últimos 360 dias</md-option></md-select>\n</md-input-container><md-input-container flex=\"50\" layout=\"column\"><label style=\"margin-bottom: 10px\">Profissional\n</label><md-select ng-model=\"vm.filterProfissional.profissional\" required><md-option ng-value=\"item._id\" \nng-repeat=\"item in vm.professionals\">{{item.name}}</md-option></md-select><div ng-messages=\"step2.category.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>O profissional é obrigatório</span></div></div></md-input-container>\n</div></ms-horizontal-stepper-step></form></div></div></div>");
$templateCache.put("app/main/marketingv2/spot/configurationDialog.html","<md-dialog aria-label=\"Dialog Message\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>Marketing</h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.close()\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_close_24px.svg\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><div class=\"content\" layout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\"><div \nlayout=\"column\" style=\"width: 400px\"><strong>Créditos</strong> <span>SMS: <b>{{vm.SMSQuota}}</b> <a href=\"#\" \nui-sref=\"app.subscription.extras\">(Clique aqui para comprar mais)</a></span>\n Push: Ilimitado para quem possui App Próprio</div></div></div><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" novalidate><div layout=\"row\" flex><md-input-container \nflex=\"50\"><label>Tipo de Mensagem</label><md-select ng-model=\"vm.messageType\"><md-option data-value=\"SMS\">SMS\n</md-option><md-option data-value=\"PUSH\" ng-disabled=\"true\">PUSH</md-option></md-select></md-input-container></div><div\n layout=\"column\" ng-if=\"vm.messageType==\'SMS\'\"><md-input-container flex><label>Mensagem</label><textarea rows=\"2\" \nng-model=\"vm.messageSMS\" name=\"message\" maxlength=\"145\" required></textarea><span style=\"font-size: 12px;color:red\">\n{{vm.messageSMS.length}} de 145</span><div ng-messages=\"step1.message.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>A mensagem é obrigatória</span></div></div></md-input-container></div><md-button type=\"submit\" class=\"md-raised\" \nng-click=\"vm.sendMessage()\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">Enviar</md-button></form></div></div>\n</md-dialog>");
$templateCache.put("app/main/marketingv2/reminder/configuration.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span></div><div class=\"title\">{{ \'SETTINGS.GENERAL.HEADER\' | translate }}</div>\n</div></div><div class=\"content\" layout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\"><div layout=\"column\">\n<strong>Como funciona?</strong><br>\nSe for marcado o seu cliente receberá uma mensagem de lembrete de agendamento. Mensagens de lembrete ajudam em muito a reduzir as faltas de suas clientes.\n</div></div></div><div class=\"content\" layout=\"column\" style=\"margin-top:-40px\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" \nng-submit=\"vm.saveReminderConfiguration()\" novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex=\"50\" flex-gt-xs=\"50\" layout=\"column\" style=\"margin-top: -20px\"><md-checkbox \nng-model=\"vm.configuration.sendReminderSMS\">{{\'SETTINGS.GENERAL.SCHEDULE.SMS_REMINDER\' | translate}}</md-checkbox>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-if=\"vm.configuration.sendReminderSMS\">\n<md-input-container flex=\"50\" flex-gt-xs=\"50\" layout=\"column\" style=\"margin-top: -20px\"><md-radio-group \nng-model=\"vm.configuration.whenType\"><md-radio-button data-value=\"sameDay\">\n{{\'SETTINGS.GENERAL.SCHEDULE.WHEN_OPTION1\' | translate}}</md-radio-button><br><br><md-radio-button \ndata-value=\"twoDays\">{{\'SETTINGS.GENERAL.SCHEDULE.WHEN_OPTION2\' | translate}}</md-radio-button></md-radio-group>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"50\" flex-gt-xs=\"50\" \nlayout=\"column\" style=\"margin-top: -20px\"><md-checkbox ng-model=\"vm.configuration.sendReminderEmail\">\n{{\'SETTINGS.GENERAL.SCHEDULE.EMAIL_REMINDER\' | translate}}</md-checkbox></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"50\" flex-gt-xs=\"50\" layout=\"column\" \nstyle=\"margin-top: -20px\"><md-checkbox ng-model=\"vm.configuration.sendReminderEmail2\">\n{{\'SETTINGS.GENERAL.SCHEDULE.EMAIL_REMINDER2\' | translate}}</md-checkbox></md-input-container></div><md-button \ntype=\"submit\" class=\"md-raised\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">\n{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/marketingv2/survey/configuration.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\" style=\"color: #FCB63A\">\n</md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\" style=\"color: #FCB63A\"></md-icon><span \nclass=\"parent\" style=\"color: #FCB63A\">Encante seus Clientes</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator\" style=\"color: #FCB63A\"></md-icon><span class=\"parent\" style=\"color: #FCB63A\">\nControle de Qualidade</span></div><div class=\"title\">Configuração</div></div></div><div class=\"content\" \nlayout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\"><div layout=\"column\"><strong>Como funciona?</strong><br>\nSe for marcado o seu cliente receberá uma mensagem para que ele avalie o serviço prestado pelo seu salão.</div></div>\n</div><div class=\"content\" layout=\"column\" style=\"margin-top:-40px\"><div class=\"form-wrapper md-whiteframe-1dp\"><form \nname=\"basicForm\" class=\"md-inline-form\" ng-submit=\"vm.saveSurveyConfiguration()\" novalidate><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex=\"50\" flex-gt-xs=\"50\" layout=\"column\" style=\"margin-top: 0px\"><md-checkbox \nng-model=\"vm.configuration.enableSurveySMS\">{{\'MARKETING.SURVEY.ENABLESMS\' | translate}}</md-checkbox>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-if=\"vm.configuration.enableSurveySMS\">\n<md-input-container flex=\"100\" flex-gt-xs=\"100\"><label translate=\"MARKETING.SURVEY.MESSAGE\"></label><textarea \nng-model=\"vm.configuration.messageSMS\" aria-label=\"mensagem\" md-maxlength=\"120\" maxlength=\"120\" rows=\"2\" \nmd-select-on-focus></textarea></md-input-container></div><md-button type=\"submit\" class=\"md-raised\" \naria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button><md-button \ntype=\"button\" class=\"md-raised md-warn\" aria-label=\"Cancel\" ui-sref=\"app.marketingv2.survey.dashboard\">\n{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/marketingv2/survey/dashboard.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\" style=\"color: #FCB63A\">\n</md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\" style=\"color: #FCB63A\"></md-icon><span \nclass=\"parent\"><span class=\"parent\" style=\"color: #FCB63A\">Encante seus Clientes</span></span><md-icon \nmd-font-icon=\"icon-chevron-right\" style=\"color: #FCB63A\" class=\"s16 separator\"></md-icon><span class=\"parent\"><span \nclass=\"parent\" style=\"color: #FCB63A\">Controle de Qualidade</span></span></div><div class=\"title\">Monitor de Qualidade\n</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised\" \nui-sref=\"app.marketingv2.survey.explorenow\">Como Funciona?</md-button><md-button class=\"md-raised\" \nui-sref=\"app.marketingv2.survey.configuration\">Configuração</md-button></div></div><md-tabs md-dynamic-height><md-tab \nlabel=\"Qualidade Geral\" id=\"teste3\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\" flex-gt-md=\"33\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">Média dos Últimos 30 dias\n</div></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"font-size-72 line-height-72\" ng-style=\"vm.npsStyle\">{{vm.MEDIA30}}</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span class=\"h4 ml-8\">\nNota de 1 a 10 respondidas por {{vm.QTD30}} clientes</span></div></ms-widget-front></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\" flex-gt-md=\"33\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">Média dos Últimos 60 dias\n</div></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"font-size-72 line-height-72\" ng-style=\"vm.npsStyle\">{{vm.MEDIA60}}</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span class=\"h4 ml-8\">\nNota de 1 a 10 respondidas por {{vm.QTD60}} clientes</span></div></ms-widget-front></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\" flex-gt-md=\"33\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">Média dos Últimos 90 dias\n</div></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"font-size-72 line-height-72\" ng-style=\"vm.npsStyle\">{{vm.MEDIA90}}</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span class=\"h4 ml-8\">\nNota de 1 a 10 respondidas por {{vm.QTD90}} clientes</span></div></ms-widget-front></ms-widget></div></md-tab><md-tab \nlabel=\"Qualidade por Categoria\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\" flex-gt-md=\"33\" ng-repeat=\"item in vm.serviceCategories\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"h3\">{{item.name}}</div></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"font-size-72 line-height-72\" ng-style=\"vm.npsStyle\">{{item.MEDIA}}</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span class=\"h4 ml-8\">\nNota de 1 a 10 respondidas por {{item.QTD}} clientes</span></div></ms-widget-front></ms-widget></div></md-tab><md-tab \nlabel=\"Qualidade por Profissional\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\" flex-gt-md=\"33\" ng-repeat=\"item in vm.professionals\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"h3\">{{item.name}} (Últimos 30 dias)</div></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"font-size-72 line-height-72\" ng-style=\"vm.npsStyle\">{{item.MEDIA}}</div></div>\n<div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span class=\"h4 ml-8\">\nNotas de 1 a 10 respondidas por {{item.QTD}} cliente(s)</span></div></ms-widget-front></ms-widget></div></md-tab>\n</md-tabs></div>");
$templateCache.put("app/main/marketingv2/survey/explore.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\" style=\"color: #FCB63A\">\n</md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\" style=\"color: #FCB63A\"></md-icon><span \nclass=\"parent\" style=\"color: #FCB63A\">Encantando Clientes</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator\" style=\"color: #FCB63A\"></md-icon><span class=\"parent\" style=\"color: #FCB63A\">\nControle de Qualidade</span></div><div class=\"title\">Porque & Como</div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-raised\" ui-sref=\"app.marketingv2.survey.dashboard\">\nSeguir para Painel de Monitoramento</md-button></div></div><div class=\"content\"><h1>\nPor que devo monitorar a qualidade do serviço prestado?</h1><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\"><ms-widget-front \nclass=\"white-bg\"><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"start center\"><div class=\"line-height-23\" \nstyle=\"margin:10px;font-size:15px\">\nApesar da razão parecer bastante óbvia, muitos salões não fazem qualquer tipo de acompanhamento da satisfação da cliente. Na maioria dos casos só vão descobrir que a cliente estava insatisfeita quando ela deixou de ir até o salão.\n<br>A regra de ouro aqui é <b>ouça seu cliente</b>\n. Infelizmente no Brasil a maoiria esmagadora de consumidores prefere largar um serviço do que reclamar a respeito, por isso é tão importante que você abra esse canal de comunicação.\n<br></div></div></ms-widget-front></ms-widget></div><h1>Como funciona?</h1><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"h3\"><b>Passo 1</b></div></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"start center\"><div \nclass=\"line-height-23\" style=\"margin:10px;font-size:15px\">Vá nas <a href=\"#\" \nui-sref=\"app.marketingv2.survey.configuration\" style=\"color: blue\">configurações do controle de qualidade</a>\n e ative o serviço.</div></div></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\"><b>Passo 2</b></div></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"line-height-23\" style=\"margin:10px;font-size:15px\">\nDepois de ativado, a cada fechamento de comanda, será enviada uma mensagem para o cliente pedindo que avalie o salão e os profissionais envolvidos individualmente.\n<br>Todos esses dados serão compilados e apresentados no painel <a href=\"#\" ui-sref=\"app.marketingv2.survey.dashboard\" \nstyle=\"color: blue\">Monitor de Qualidade.</a></div></div></ms-widget-front></ms-widget></div><form><md-checkbox \nstyle=\"margin: 10px\" ng-model=\"vm.showSurveyExplorer\">Não mostrar mais essa tela</md-checkbox></form></div></div>");
$templateCache.put("app/main/marketingv2/checkup/encante.html","<div id=\"preloader\"><div data-loader=\"circle-side\"></div></div><div id=\"loader_form\"><div data-loader=\"circle-side-2\">\n</div></div><header><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-3\"><div id=\"logo_home\"><h1><a \nhref=\"index.html\">WoWee Checkup | Multipurpose Working Wizard with Branches</a></h1></div></div><div class=\"col-9\"><div\n id=\"social\"><ul><li><a href=\"#0\"><i class=\"icon-facebook\"></i></a></li><li><a href=\"#0\"><i class=\"icon-twitter\"></i>\n</a></li><li><a href=\"#0\"><i class=\"icon-google\"></i></a></li><li><a href=\"#0\"><i class=\"icon-linkedin\"></i></a></li>\n</ul></div><nav><ul class=\"cd-primary-nav\"><li><a href=\"about.html\" class=\"animated_link\">Sobre</a></li><li><a \nhref=\"contacts.html\" class=\"animated_link\">Contato</a></li><li><a href=\"icon-pack-1.html\" class=\"animated_link\">\nWoWee Pro</a></li><li><a href=\"icon-pack-2.html\" class=\"animated_link\">Icon Pack Two</a></li><li><a \nhref=\"icon-pack-3.html\" class=\"animated_link\">Icon Pack Three</a></li></ul></nav></div></div></div></header><main><div \nclass=\"container\"><div id=\"wizard_container\"><form name=\"example-1\" id=\"wrapped\" method=\"POST\"><input id=\"website\" \nname=\"website\" type=\"text\" value=\"\"><div id=\"middle-wizard\"><div class=\"step\" data-state=\"branchtype\"><div \nclass=\"question_title\"><h3>WoWee Checkup</h3><p>Como podemos te ajudar hoje?</p></div><div class=\"row\"><div \nclass=\"col-lg-4\"><div class=\"item\"><input id=\"answer_1\" type=\"radio\" name=\"branch_group_1\" value=\"Seo-Optimization\" \nclass=\"required\"><label for=\"answer_1\"><img src=\"img/seo_icon_1.svg\" alt=\"\"><strong>Atrair mais Clientes</strong>\nCheque as melhores técnicas para atrair mais clientes e veja o que você pode fazer.</label></div></div><div \nclass=\"col-lg-4\"><div class=\"item\"><input id=\"answer_2\" name=\"branch_group_1\" type=\"radio\" value=\"Web-Development\" \nclass=\"required\"><label for=\"answer_2\"><img src=\"img/web_development_icon_1.svg\" alt=\"\"><strong>Encantar Clientes\n</strong>Verifique se você está encantando seus clientes para deixa-los fiéis ao seu salão.</label></div></div><div \nclass=\"col-lg-4\"><div class=\"item\"><input id=\"answer_3\" name=\"branch_group_1\" type=\"radio\" value=\"Design\" \nclass=\"required\"><label for=\"answer_3\"><img src=\"img/seo_icon_3.svg\" alt=\"\"><strong>Gestão Eficiente</strong>\nVerifique se sua gestão é eficiente e maximize seus resultados.</label></div></div></div></div><div class=\"branch\" \nid=\"Seo-Optimization\"><div class=\"step\" data-state=\"budget\"><div class=\"question_title\"><h3>\nWhat Type of Seo Optimization do you need?</h3><p>Multiple Selection (Checkbox based)</p></div><div class=\"row\"><div \nclass=\"col-lg-4\"><div class=\"item\"><input id=\"branch_1_answer_1\" type=\"checkbox\" name=\"branch_1_answers[]\" \nvalue=\"Page SEO Checker\" class=\"required\"><label for=\"branch_1_answer_1\"><img src=\"img/seo_icon_2.svg\" alt=\"\"><strong>\nOn Page SEO Checker</strong>Postea democritum mnesarchum ne nam, ad vim aperiri tractatos.</label></div></div><div \nclass=\"col-lg-4\"><div class=\"item\"><input id=\"branch_1_answer_2\" name=\"branch_1_answers[]\" type=\"checkbox\" \nvalue=\"Pay Per Click\" class=\"required\"><label for=\"branch_1_answer_2\"><img src=\"img/seo_icon_3.svg\" alt=\"\"><strong>\nPay Per Click</strong>Postea democritum mnesarchum ne nam, ad vim aperiri tractatos.</label></div></div><div \nclass=\"col-lg-4\"><div class=\"item\"><input id=\"branch_1_answer_3\" name=\"branch_1_answers[]\" type=\"checkbox\" \nvalue=\"Backlinks Checker\" class=\"required\"><label for=\"branch_1_answer_3\"><img src=\"img/seo_icon_4.svg\" alt=\"\"><strong>\nBacklinks Checker</strong>Postea democritum mnesarchum ne nam, ad vim aperiri tractatos.</label></div></div></div>\n</div></div><div class=\"branch\" id=\"Web-Development\"><div class=\"step\" data-state=\"budget\"><div class=\"question_title\">\n<h3>What Type of Web Development do you need?</h3><p>Multiple Selection (Checkbox based)</p></div><div class=\"row\"><div\n class=\"col-lg-4\"><div class=\"item\"><input id=\"branch_2_answer_1\" type=\"checkbox\" name=\"branch_2_answers[]\" \nvalue=\"HTML Development\" class=\"required\"><label for=\"branch_2_answer_1\"><img src=\"img/web_development_icon_2.svg\" \nalt=\"\"><strong>HTML Development</strong>Postea democritum mnesarchum ne nam, ad vim aperiri tractatos.</label></div>\n</div><div class=\"col-lg-4\"><div class=\"item\"><input id=\"branch_2_answer_2\" name=\"branch_2_answers[]\" type=\"checkbox\" \nvalue=\"CMS Development\" class=\"required\"><label for=\"branch_2_answer_2\"><img src=\"img/web_development_icon_3.svg\" \nalt=\"\"><strong>CMS Development</strong>Postea democritum mnesarchum ne nam, ad vim aperiri tractatos.</label></div>\n</div><div class=\"col-lg-4\"><div class=\"item\"><input id=\"branch_2_answer_3\" name=\"branch_2_answers[]\" type=\"checkbox\" \nvalue=\"FrontEnd Development\" class=\"required\"><label for=\"branch_2_answer_3\"><img src=\"img/web_development_icon_4.svg\" \nalt=\"\"><strong>FrontEnd Development</strong>Postea democritum mnesarchum ne nam, ad vim aperiri tractatos.</label>\n</div></div></div></div></div><div class=\"branch\" id=\"Design\"><div class=\"step\" data-state=\"budget\"><div \nclass=\"question_title\"><h3>What Type of Design do you need?</h3><p>Multiple Selection (Checkbox based)</p></div><div \nclass=\"row\"><div class=\"col-lg-4\"><div class=\"item\"><input id=\"branch_3_answer_1\" type=\"checkbox\" \nname=\"branch_3_answers[]\" value=\"Web Design\" class=\"required\"><label for=\"branch_3_answer_1\"><img \nsrc=\"img/design_icon_2.svg\" alt=\"\"><strong>Web Design</strong>\nPostea democritum mnesarchum ne nam, ad vim aperiri tractatos.</label></div></div><div class=\"col-lg-4\"><div \nclass=\"item\"><input id=\"branch_3_answer_2\" name=\"branch_3_answers[]\" type=\"checkbox\" value=\"Print Design\" \nclass=\"required\"><label for=\"branch_3_answer_2\"><img src=\"img/design_icon_3.svg\" alt=\"\"><strong>Print Design</strong>\nPostea democritum mnesarchum ne nam, ad vim aperiri tractatos.</label></div></div><div class=\"col-lg-4\"><div \nclass=\"item\"><input id=\"branch_3_answer_3\" name=\"branch_3_answers[]\" type=\"checkbox\" value=\"Logo Design\" \nclass=\"required\"><label for=\"branch_3_answer_3\"><img src=\"img/design_icon_4.svg\" alt=\"\"><strong>Logo Design</strong>\nPostea democritum mnesarchum ne nam, ad vim aperiri tractatos.</label></div></div></div></div><div class=\"step\" \nid=\"budget\" data-state=\"end\"><div class=\"question_title\"><h3>What is your buget?</h3><p>\nTouchscreen friendly Range Slider</p></div><div class=\"row justify-content-center\"><div class=\"col-lg-5\"><div \nclass=\"box_general\"><div class=\"rounded_slider\"><div id=\"budget_slider\" style=\"margin: 0 auto 20px\"></div><p>\nEu sed epicuri mentitum, ex mei hinc justo, no cum dictas deserunt gubergren. Ferri pericula sententiae eu pro.</p>\n</div></div></div></div></div><div class=\"submit step\" id=\"end\"><div class=\"question_title\"><h3>\nPlase fill with your details</h3><p>Ei duo homero postea dignissim.</p></div><div class=\"row justify-content-center\">\n<div class=\"col-lg-5\"><div class=\"box_general\"><div class=\"form-group\"><input type=\"text\" name=\"first_last_name\" \nclass=\"required form-control\" placeholder=\"First and Last name\"></div><div class=\"form-group\"><input type=\"email\" \nname=\"email\" class=\"required form-control\" placeholder=\"Your Email\"></div><div class=\"form-group\"><input type=\"text\" \nname=\"telephone\" class=\"form-control\" placeholder=\"Your Telephone\"></div><div class=\"form-group add_bottom_30\"><div \nclass=\"styled-select\"><select class=\"required\" name=\"country\"><option value=\"\" selected=\"selected\">Select your country\n</option><option value=\"Europe\">Europe</option><option value=\"Asia\">Asia</option><option value=\"North America\">\nNorth America</option><option value=\"South America\">South America</option></select></div></div><div \nclass=\"checkbox_questions\"><input name=\"terms\" type=\"checkbox\" class=\"icheck required\" value=\"yes\"><label>\nPlease accept <a href=\"#\" data-toggle=\"modal\" data-target=\"#terms-txt\">terms and conditions</a>.</label></div></div>\n</div></div></div></div></div><div id=\"bottom-wizard\"><button type=\"button\" name=\"backward\" class=\"backward\">Voltar\n</button> <button type=\"button\" name=\"forward\" class=\"forward\">Avançar</button> <button type=\"submit\" name=\"process\" \nclass=\"submit\">Submit</button></div></form></div></div></main><div class=\"cd-overlay-nav\"><span></span></div><div \nclass=\"cd-overlay-content\"><span></span></div><a href=\"#0\" class=\"cd-nav-trigger\">Menu<span class=\"cd-icon\"></span></a>\n<div class=\"modal fade\" id=\"terms-txt\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"termsLabel\" aria-hidden=\"true\"><div\n class=\"modal-dialog\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-header\"><h5 class=\"modal-title\" \nid=\"termsLabel\">Terms and conditions</h5><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n<span aria-hidden=\"true\">&times;</span></button></div><div class=\"modal-body\"><p>\nLorem ipsum dolor sit amet, in porro albucius qui, in <strong>nec quod novum accumsan</strong>\n, mei ludus tamquam dolores id. No sit debitis meliore postulant, per ex prompta alterum sanctus, pro ne quod dicunt sensibus.\n</p><p>\nLorem ipsum dolor sit amet, in porro albucius qui, in nec quod novum accumsan, mei ludus tamquam dolores id. No sit debitis meliore postulant, per ex prompta alterum sanctus, pro ne quod dicunt sensibus. Lorem ipsum dolor sit amet, \n<strong>in porro albucius qui</strong>\n, in nec quod novum accumsan, mei ludus tamquam dolores id. No sit debitis meliore postulant, per ex prompta alterum sanctus, pro ne quod dicunt sensibus.\n</p><p>\nLorem ipsum dolor sit amet, in porro albucius qui, in nec quod novum accumsan, mei ludus tamquam dolores id. No sit debitis meliore postulant, per ex prompta alterum sanctus, pro ne quod dicunt sensibus.\n</p></div></div></div></div>");
$templateCache.put("app/main/schedule/newSchedule/newSchedule.html","<md-dialog aria-label=\"New Message\"><form name=\"basicForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{ \'SCHEDULE.FIELDS.HEADER\' | translate }}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"GENERAL.DIALOG.CLOSE\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content layout=\"row\" \nstyle=\"width:1000px;height:340px\" flex><md-dialog-content flex=\"100\" layout=\"row\"><div style=\"width:399px\">\n<md-autocomplete flex required style=\"height:65px;margin-top:-30px;font-size:12px\" ng-disabled=\"vm.customerDisabled\" \nmd-input-name=\"customerId\" md-input-id=\"customer-input\" md-autofocus=\"vm.serviceSchedule.customer==undefined\" \nmd-input-minlength=\"1\" md-no-cache=\"true\" md-selected-item=\"vm.serviceSchedule.customer\" \nmd-search-text=\"vm.customerSearchText\" md-items=\"item in vm.customerSearchTextChange(vm.customerSearchText)\" \nmd-item-text=\"item.name\" placeholder=\"Informe o nome ou telefone do cliente\" \nng-attr-md-floating-label=\"{{vm.floatinglabel.customer}}\" md-require-match ng-blur=\"vm.checkCustomer();\" \nng-keydown=\"vm.submitNewSchedule($event);\"><md-item-template><span md-highlight-text=\"vm.customerNameSearchText\" \nstyle=\"font-size:12px\">{{item.name + \' - \' + item.telephone}}</span></md-item-template><br><a href=\"#\" \nng-click=\"vm.newCustomer()\">Clique para cadastrar novo cliente?</a><div ng-messages=\"basicForm.customerId.$error\" \nng-if=\"basicForm.customerId.$touched\"><div ng-message=\"required\"><span \ntranslate=\"SCHEDULE.VALIDATION.CUSTOMER_REQUIRED\"></span></div><div ng-message=\"md-require-match\"><span \ntranslate=\"SCHEDULE.VALIDATION.CUSTOMER_INVALID\"></span></div></div></md-autocomplete><md-autocomplete flex required \nstyle=\"height:65px;font-size:12px\" md-input-id=\"service-input\" md-input-name=\"serviceId\" md-input-minlength=\"1\" \nmd-no-cache=\"true\" md-autofocus=\"vm.serviceSchedule.customer!=undefined\" md-selected-item=\"vm.serviceSchedule.service\" \nmd-search-text=\"vm.serviceSearchText\" md-items=\"item in vm.serviceSearchTextChange(vm.serviceSearchText)\" \nmd-item-text=\"item.name\" md-require-match ng-attr-md-floating-label=\"{{vm.floatinglabel.service}}\" \nng-keydown=\"vm.submitNewSchedule($event);\"><md-item-template><span md-highlight-text=\"vm.serviceSearchText\" \nstyle=\"font-size:12px\">{{item.fastCode}} - {{item.name}} - {{item.price | currency : \'R$ \' : 2}}</span>\n</md-item-template><div ng-messages=\"basicForm.serviceId.$error\" ng-if=\"basicForm.serviceId.$touched\"><div \nng-message=\"required\"><span translate=\"SCHEDULE.VALIDATION.SERVICE_REQUIRED\"></span></div><div \nng-message=\"md-require-match\"><span translate=\"SCHEDULE.VALIDATION.SERVICE_INVALID\"></span></div></div>\n</md-autocomplete><md-input-container class=\"md-block\" style=\"height:15px;margin-top:0px\"><md-checkbox \nng-model=\"vm.serviceSchedule.chkPreference\" style=\"font-size:14px\">Cliente tem preferência</md-checkbox>\n</md-input-container><md-autocomplete flex required style=\"height:65px;margin-top:35px\" md-input-name=\"professionalId\" \nmd-input-minlength=\"1\" md-no-cache=\"true\" md-selected-item=\"vm.serviceSchedule.professional\" \nmd-search-text=\"vm.professionalSearchText\" \nmd-items=\"item in vm.professionalSearchTextChange(vm.professionalSearchText)\" md-item-text=\"item.name\" \nmd-require-match ng-attr-md-floating-label=\"{{vm.floatinglabel.professional}}\" \nng-keydown=\"vm.submitNewSchedule($event);\"><md-item-template><span md-highlight-text=\"vm.professionalSearchText\" \nstyle=\"font-size:11px\">{{item.name}}</span></md-item-template><div ng-messages=\"basicForm.professionalId.$error\" \nng-if=\"basicForm.professionalId.$touched\"><div ng-message=\"required\"><span \ntranslate=\"SCHEDULE.VALIDATION.PROFESSIONAL_REQUIRED\"></span></div><div ng-message=\"md-require-match\"><span \ntranslate=\"SCHEDULE.VALIDATION.PROFESSIONAL_INVALID\"></span></div></div></md-autocomplete><md-input-container \nclass=\"md-block\" style=\"height:10px\" ng-if=\"false\"><md-radio-group ng-model=\"vm.serviceSchedule.aquisitionChannel\" \nng-disabled=\"vm.customerDisabled\"><md-radio-button data-value=\"B\">{{ \'SCHEDULE.FIELDS.BENCH\' | translate }}\n</md-radio-button><md-radio-button data-value=\"T\">{{ \'SCHEDULE.FIELDS.TELEPHONE\' | translate }}</md-radio-button>\n<md-radio-button data-value=\"W\">{{ \'SCHEDULE.FIELDS.WHATSAPP\' | translate }}</md-radio-button></md-radio-group>\n</md-input-container><div layout=\"row\" class=\"date-row\" style=\"height: 10px;margin-left: 0px;margin-top:10px\">\n<md-input-container class=\"md-block\"><select ng-model=\"vm.whenDate\" name=\"date\" md-autofocus=\"vm.isReschedule\"><option \nvalue=\"{{date.value}}\" ng-repeat=\"date in vm.datetable\">{{date.dateStr}}</option></select></md-input-container>\n<md-input-container class=\"no-errors-spacer\" flex md-no-float><select ng-model=\"vm.whenTime\" aria-label=\"Horario\" \nng-keydown=\"vm.submitNewSchedule($event);\"><option value=\"{{item.time}}\" ng-repeat=\"item in vm.timetable\">\n{{item.timeStr}}</option></select></md-input-container></div></div><div \nstyle=\"width: 2px;background-color: lightblue;height:315px;margin-top:-31px\"></div><div \nstyle=\"width:599px;margin-top:-28px\"><md-tabs md-dynamic-height md-border-bottom style=\"tab-index:-1\"><md-tab \nlabel=\"Agendas\" style=\"tab-index:-1\"><md-content style=\"height:280px;margin-top: 0px\"><div \nstyle=\"overflow: auto; max-height: 213px\"><table style=\"width:100%\" cellspacing=\"0\" id=\"table_schedule\"><thead \nfix-head><tr style=\"background-color: lightblue\" height=\"50px\"><th \nstyle=\"max-width:50px;min-width:50px;width:20px;border-right: 1px solid darkgrey;border-bottom: 1px solid darkgrey\">\n</th><th align=\"center\" \nstyle=\"min-width:0px;border-right: 1px solid darkgrey;border-bottom: 1px solid darkgrey;text-align: center; font-size:10px; font-weight:light\" \nng-repeat=\"professional in vm.professionals\">{{::professional.name}}</th></tr></thead><tbody><tr style=\"height: 30px\" \nng-repeat=\"scheduleLine in vm.timetable\" ng-attr-id=\"{{ \'row_\' + scheduleLine.time }}\"><td \nstyle=\"max-width:50px;min-width:50px;width:50px;font-size:11px; border-right: 1px dashed darkgrey;border-bottom: 1px dashed darkgrey;text-align: center;background-color: lightblue\">\n{{::scheduleLine.timeStr}}</td><td \nstyle=\"min-width:0px;border-right: 1px dashed darkgrey;border-bottom: 1px dashed darkgrey\" \nng-click=\"vm.selectCell(scheduleLine.time,professional)\" \nng-class=\"{classRed : vm.statusCell(scheduleLine.time,professional._id)}\" \nng-attr-id=\"{{ \'row_\' + scheduleLine.time + \'_col_\' + professional._id }}\" \nng-repeat=\"professional in vm.professionals\">&nbsp;</td></tr></tbody></table></div></md-content></md-tab><md-tab \nlabel=\"Histórico\" style=\"tab-index:-1\"><md-content class=\"md-padding\" style=\"height:280px;margin-top: -15px\" ms-scroll>\n<md-list class=\"md-dense\" flex><md-list-item class=\"md-2-line\" ng-repeat=\"item in vm.customerHistory\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3><b>{{ item.name }}</b></h3><h4>{{ item.professionalName }}</h4><h4>\n{{ item.checkoutDate | date:\'dd-MM-yyyy HH:mm\'}}</h4><md-divider></md-divider></div></md-list-item></md-list>\n</md-content></md-tab></md-tabs></div></md-dialog-content></md-content><md-divider></md-divider><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between \"><md-button ng-click=\"vm.clickToNewServiceRequest(false)\" class=\"md-warn\" \naria-label=\"SAVE\" ng-disabled=\"basicForm.$invalid || basicForm.$pristine || vm.isSaving\" \ntranslate=\"GENERAL.BUTTON.SCHEDULE\" translate-attr-aria-label=\"CALENDAR.SAVE\"></md-button><md-button \nng-click=\"vm.clickToNewServiceRequest(true)\" class=\"md-accent\" sty aria-label=\"SAVE\" \nng-disabled=\"basicForm.$invalid || vm.isSaving\" translate=\"GENERAL.BUTTON.SCHEDULE_AND_CHECKIN\" \ntranslate-attr-aria-label=\"CALENDAR.SAVE\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/marketingv2/welcome/configuration.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'MARKETING.HEADER\' | translate }}</span></div><div class=\"title\">{{ \'MARKETING.WELCOME.HEADER\' | translate }}</div>\n</div></div><div class=\"content\" layout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\"><div layout=\"column\">\n<strong>Como funciona?</strong><br>\nSe a campanha estiver habilitada todo cliente novo (fizer o primeiro serviço no salão) receberá a mensagem de boas vindas especificada.\n<br>Ex. Obrigado por ter vindo conhecer os nossos serviços, esperamos que tenha ficado satisfeita.</div></div></div>\n<div class=\"content\" layout=\"column\" style=\"margin-top:-40px\"><div class=\"form-wrapper md-whiteframe-1dp\"><form \nname=\"basicForm\" class=\"md-inline-form\" ng-submit=\"vm.saveConfiguration()\" novalidate><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex=\"50\" flex-gt-xs=\"50\" layout=\"column\" style=\"margin-top: 0px\"><md-checkbox \nng-model=\"vm.configuration.enableSMS\">{{\'MARKETING.WELCOME.ENABLESMS\' | translate}}</md-checkbox></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\" ng-if=\"vm.configuration.enableSMS\"><md-input-container flex=\"100\" \nflex-gt-xs=\"100\"><label translate=\"MARKETING.WELCOME.MESSAGE\"></label><textarea ng-model=\"vm.configuration.messageSMS\" \naria-label=\"mensagem\" md-maxlength=\"120\" rows=\"2\" md-select-on-focus></textarea></md-input-container></div><md-button \ntype=\"submit\" class=\"md-raised\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">\n{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/marketingv2/wom/campaign.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Marketing</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Boca a Boca</span></div><div \nclass=\"title\">Nova Campanha</div></div></div><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" ng-submit=\"vm.saveCampaign()\" \nnovalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Nome da campanha</label><input \ntype=\"text\" name=\"name\" ng-model=\"vm.campaign.name\" required maxlength=\"100\"><div ng-messages=\"basicForm.name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Nome da campanha é obrigatório</span></div></div></md-input-container>\n<md-input-container flex><label>Título (será apresentado como título da página cliente)</label><input type=\"text\" \nname=\"title\" ng-model=\"vm.campaign.title\" required maxlength=\"100\"><div ng-messages=\"basicForm.title.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Título da campanha é obrigatório</span></div></div></md-input-container>\n<md-input-container flex><label>Número de conversões para receber premio</label><input type=\"number\" \nname=\"rewardConversionRule\" ng-model=\"vm.campaign.rewardConversionRule\" required min=\"1\" max=\"100\">\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>\nMensagem para promotor</label><textarea name=\"description\" ng-model=\"vm.campaign.promoterHeading\" lines=\"4\" \nmaxlength=\"5000\"></textarea></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container \nflex><label>Mensagem para o novo cliente</label><textarea name=\"description\" ng-model=\"vm.campaign.newCustomerHeading\" \nlines=\"4\" maxlength=\"5000\"></textarea></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label>Mensagem SMS no convite para promotor</label><textarea rows=\"2\" \nng-model=\"vm.campaign.smsInvitePromotor\" name=\"smsInvitePromotor\" maxlength=\"115\" required></textarea><span \nstyle=\"font-size: 12px;color:red\">{{vm.campaign.smsInvitePromotor.length}} de 115</span><div \nng-messages=\"smsInvitePromotor.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nA mensagem do convite do promotor é obrigatória</span></div></div></md-input-container><md-input-container flex><label>\nMensagem SMS de confirmação para o novo cliente</label><textarea rows=\"2\" \nng-model=\"vm.campaign.smsConfirmationNewCustomer\" name=\"smsConfirmationNewCustomer\" maxlength=\"115\" required>\n</textarea><span style=\"font-size: 12px;color:red\">{{vm.campaign.smsConfirmationNewCustomer.length}} de 115</span><div \nng-messages=\"smsConfirmationNewCustomer.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nA mensagem de confirmação para o novo cliente é obrigatória</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Regras gerais para o promotor</label><textarea \nrows=\"2\" ng-model=\"vm.campaign.promoterRules\" name=\"promoterRules\" required></textarea><div \nng-messages=\"promoterRules.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nAs regras gerais para o promotor são obrigatórias</span></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label>Regras gerais para o novo cliente</label><textarea rows=\"2\" \nng-model=\"vm.campaign.leadRules\" name=\"rulesLead\" required></textarea><div ng-messages=\"rulesLead.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>As regras gerais para o novo cliente são obrigatórias</span></div></div>\n</md-input-container></div><div id=\"product-image-uploader\" flow-init=\"vm.ngFlowOptions\" flow-name=\"vm.ngFlow.flow\" \nflow-files-submitted=\"\" flow-file-added=\"vm.fileAdded($file)\" flow-file-success=\"vm.fileSuccess($file, $message)\" \nflow-complete=\"vm.uploadComplete()\"><div ng-if=\"!vm.hasImage\"><div class=\"drop-text hint-text\" layout=\"row\" \nlayout-align=\"center center\"><span ng-if=\"!vm.loading\">Arraste para carregar imagem da campanha</span> <span \nng-if=\"vm.loading\">Carregando Imagem</span></div><div class=\"upload-button\" layout=\"column\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" flow-btn ng-if=\"!vm.loading\">Upload</md-button>\n</div></div><div ng-if=\"vm.hasImage\"><br><br><img flow-img=\"$flow.files[0]\" style=\"max-width: 50%\"><md-button \nclass=\"md-accent md-raised\" ng-click=\"vm.removeImage()\">Apagar</md-button></div></div><md-button type=\"submit\" \nclass=\"md-raised\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">{{ \'GENERAL.BUTTON.SAVE\' | translate }}\n</md-button><md-button type=\"button\" class=\"md-raised md-warn\" aria-label=\"Cancel\" ui-sref=\"app.marketingv2.wom\">\n{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/marketingv2/wom/campaigns.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Marketing</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Boca a Boca</span></div><div \nclass=\"title\">Boca a Boca</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised\" \nui-sref=\"app.marketingv2.wom.tutorial\">Tutorial</md-button><md-button class=\"md-raised\" \nui-sref=\"app.marketingv2.wom.new\">Nova Campanha</md-button></div></div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-40dp\" layout=\"row\" layout-align=\"center center\" height=\"100px\" ng-show=\"!vm.showTable\">\n<br><span style=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></div><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Nome</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Promoters</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Visualizações</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Compartilhamentos</span></div></th><th></th></tr></thead><tbody><tr \nng-repeat=\"campaign in ::vm.campaigns\"><td>{{ campaign.WOCA_TX_NAME }}</td><td>{{ campaign.WOCA_NR_PROMOTER }}</td><td>\n{{ campaign.WOCA_NR_VIEW }}</td><td>{{ campaign.WOCA_NR_SHARE }}</td><td align=\"right\"><md-button aria-label=\"Pencil\" \nclass=\"md-raised gp-mini\" ng-click=\"vm.editCampaign(campaign.WOCA_CD_WOM_CAMPAIGN)\"><md-tooltip aria-label=\"Pencil\">\n{{ \'GENERAL.HINTS.EDIT\' | translate }}</md-tooltip><i class=\"icon-pencil\" layout=\"center\"></i></md-button><md-button \naria-label=\"Pencil\" class=\"md-raised gp-mini\" ng-click=\"vm.showPromoters(campaign.WOCA_CD_WOM_CAMPAIGN)\"><md-tooltip \naria-label=\"Pencil\">Promotores</md-tooltip><i class=\"icon-people\" layout=\"center\"></i></md-button><md-button \naria-label=\"Pencil\" class=\"md-raised gp-mini\" ng-click=\"vm.showLeads(campaign.WOCA_CD_WOM_CAMPAIGN)\"><md-tooltip \naria-label=\"Pencil\">Leads</md-tooltip><i class=\"icon-people\" layout=\"center\"></i></md-button><md-button \naria-label=\"Trash\" class=\"md-raised md-warn gp-mini\" ng-click=\"vm.removeCampaign(campaign.WOCA_CD_WOM_CAMPAIGN)\">\n<md-tooltip aria-label=\"Pencil\">{{ \'GENERAL.HINTS.TRASH\' | translate }}</md-tooltip><i class=\"icon-trash\" \nlayout=\"center\"></i></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/marketingv2/wom/leads.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Marketing</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Boca a Boca</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">{{vm.campaignName}}</span></div>\n<div class=\"title\">Amigos Indicados</div></div><div layout=\"row\" layout-align=\"start center\"></div></div><div \nclass=\"content\"><div class=\"white-bg md-whiteframe-40dp\" layout=\"row\" layout-align=\"center center\" height=\"100px\" \nng-show=\"!vm.showTable\"><br><span style=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></div><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Cod. Cupom</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Telefone</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Convertido</span></div></th><th></th></tr></thead><tbody><tr \nng-repeat=\"lead in ::vm.leads\"><td>{{ lead.WOFR_TX_CUPOM }}</td><td>{{ lead.WOFR_TX_TELEPHONE }}</td><td>\n{{ lead.WOFR_IN_CONVERTED | yesNo }}</td><td align=\"right\"><md-button aria-label=\"Pencil\" class=\"md-raised gp-mini\" \nng-click=\"vm.convertLead(lead.WOFR_TX_CUPOM)\"><md-tooltip aria-label=\"Pencil\">Converter</md-tooltip><i \nclass=\"icon-check\" layout=\"center\"></i></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/marketingv2/wom/promoter.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Marketing</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Boca a Boca</span></div><div \nclass=\"title\">Nova Promotor</div></div></div><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" ng-submit=\"vm.invitePromoter()\" \nnovalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Nome</label><input type=\"text\" \nname=\"name\" ng-model=\"vm.promoter.name\" required maxlength=\"100\"><div ng-messages=\"basicForm.name.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Nome do promotor é obrigatório</span></div></div></md-input-container>\n<md-input-container flex><label>Telefone</label><input type=\"phone\" name=\"telephone\" ng-model=\"vm.promoter.telephone\" \nrequired><div ng-messages=\"basicForm.telephone.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTelefone do promotor é obrigatório</span></div></div></md-input-container></div><md-button type=\"submit\" \nclass=\"md-raised\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">Convidar</md-button><md-button type=\"button\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\" ui-sref=\"app.marketingv2.wom.promoters({campaignId:vm.campaignId})\">\n{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/marketingv2/wom/promoters.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Marketing</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Boca a Boca</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">{{vm.campaignName}}</span></div>\n<div class=\"title\">Promotores</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised\" \nui-sref=\"app.marketingv2.wom.promoters.new(vm.campaignId)\">Convidar Promotor</md-button></div></div><div \nclass=\"content\"><div class=\"white-bg md-whiteframe-40dp\" layout=\"row\" layout-align=\"center center\" height=\"100px\" \nng-show=\"!vm.showTable\"><br><span style=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></div><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Nome</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Telefone</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Link de compartilhamento</span></div></th><th></th></tr></thead><tbody>\n<tr ng-repeat=\"promoter in ::vm.promoters\"><td>{{ promoter.WOPR_TX_NAME }}</td><td>{{ promoter.WOPR_TX_TELEPHONE }}\n</td><td>https://b.wommify.io/p/{{ promoter.WOCP_TX_CODE }}</td><td align=\"right\"><md-button aria-label=\"Pencil\" \nclass=\"md-raised gp-mini\" ng-click=\"vm.showTransactions(promoter.WOPR_CD_WOM_PROMOTER)\"><md-tooltip \naria-label=\"Pencil\">Transações</md-tooltip><i class=\"icon-view-list\" layout=\"center\"></i></md-button><md-button \naria-label=\"Pencil\" class=\"md-raised gp-mini\" ng-click=\"vm.resendLink(promoter.WOPR_CD_WOM_PROMOTER)\"><md-tooltip \naria-label=\"Pencil\">Reenviar Link</md-tooltip><i class=\"icon-link\" layout=\"center\"></i></md-button></td></tr></tbody>\n</table></div></div></div>");
$templateCache.put("app/main/marketingv2/wom/transactions.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Marketing</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Boca a Boca</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">{{vm.campaignName}}</span>\n<md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">{{vm.promoterName}}\n</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\nSaldo de pontos: {{vm.promoterBalance}}</span></div><div class=\"title\">Transações</div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-raised\" ng-click=\"vm.redeemReward()\">Resgatar Premio</md-button></div>\n</div><div class=\"content\"><div class=\"white-bg md-whiteframe-40dp\" layout=\"row\" layout-align=\"center center\" \nheight=\"100px\" ng-show=\"!vm.showTable\"><br><span style=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span>\n</div><div class=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Data</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Tipo</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Pontos</span></div></th><th></th></tr></thead><tbody><tr \nng-repeat=\"transaction in ::vm.transactions\"><td>{{ transaction.WOPT_DT_CREATEDAT }}</td><td>\n{{ transaction.WOPT_TX_OBSERVATION }}</td><td>{{ transaction.WOPT_NR_POINT }}</td><td align=\"right\"></td></tr></tbody>\n</table></div></div></div>");
$templateCache.put("app/main/marketingv2/wom/tutorial.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Marketing</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Boca a Boca</span></div><div \nclass=\"title\">Tutorial</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised\" \nui-sref=\"app.marketingv2.wom.new\">Quero fazer minha primeira campanha</md-button><md-button class=\"md-raised\" \nui-sref=\"app.marketingv2.wom\" ng-if=\"!vm.firstTime\">Fechar</md-button></div></div><div class=\"content\"><center><iframe \nwidth=\"840\" height=\"473\" src=\"https://www.youtube.com/embed/yxThjWqCX2I\" frameborder=\"0\" \nallow=\"autoplay; encrypted-media\" allowfullscreen></iframe></center></div></div>");
$templateCache.put("app/main/report/finance/audit.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">\n{{ \'MENU.REPORTS.FINANCEAUDIT\' | translate }}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised\" ng-click=\"vm.print();\" ng-if=\"!vm.mobile\">{{ \'GENERAL.PRINT\' | translate }}</md-button><md-button \nclass=\"md-raised\" ng-click=\"vm.openFilter();\">{{ \'GENERAL.FILTER\' | translate }}</md-button></div></div><div \nclass=\"content\" id=\"printArea\" style=\"overflow-x:scroll\"><md-content class=\"content\" flex ng-if=\"!vm.showTable\"><br>\n<span style=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></md-content><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'REPORT.FINANCEANALYTICAL.DATE\' | translate }}</span></div></th><th class=\"secondary-text\" \nng-if=\"vm.showPdvLocation\"><div class=\"table-header\"><span class=\"column-title\">Local</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'REPORT.FINANCEANALYTICAL.WHO\' | translate }}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">{{ \'REPORT.FINANCEANALYTICAL.CUSTOMER\' | translate }}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Valor recebido</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Valor dos serviços</span></div></th></tr>\n</thead><tbody compile=\"vm.html\" id=\"code\"></tbody></table></div></div><md-sidenav class=\"md-sidenav-right\" \nmd-component-id=\"filter\" md-is-locked-open=\"false\" md-whiteframe=\"4\"><md-toolbar class=\"md-hue-2\"><div \nclass=\"md-toolbar-tools\"><h2>{{\'GENERAL.FILTER\' | translate}}</h2><span flex></span><md-button \nclass=\"md-raised md-orange-500-bg\" aria-label=\"Refresh\" ng-click=\"vm.refresh()\">{{\'GENERAL.REFRESH\'|translate}}\n</md-button></div></md-toolbar><md-content layout-padding><md-subheader style=\"margin-left: -20px\">Período\n</md-subheader><div layout=\"row\" style=\"margin-top: -20px\"><span style=\"margin-left: 10px\">{{\'GENERAL.FROM\'|translate}}\n<md-datepicker ng-model=\"vm.filter.dtFrom\"></md-datepicker></span></div><div layout=\"row\" style=\"margin-top: -10px\">\n<span style=\"margin-left: 10px\">{{\'GENERAL.TO\'|translate}}<md-datepicker ng-model=\"vm.filter.dtTo\"></md-datepicker>\n</span></div><md-subheader style=\"margin-left: -20px\" ng-if=\"vm.showPdvLocation\">Local</md-subheader><div \nlayout=\"column\" style=\"margin-top: -5px\" ng-if=\"vm.showPdvLocation\"><md-checkbox ng-repeat=\"local in vm.pdvLocations\" \nng-model=\"vm.filter.locations[local.locationId]\">{{ local.name }}</md-checkbox></div><md-subheader \nstyle=\"margin-left: -20px\">Operador (quem lançou no sistema)</md-subheader><div layout=\"column\" \nstyle=\"margin-top: -5px\"><md-checkbox ng-repeat=\"user in vm.users\" ng-model=\"vm.filter.users[user._id]\">{{ user.name }}\n</md-checkbox></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/report/finance/financeAnalytical.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">\n{{ \'REPORT.FINANCEANALYTICAL.HEADER\' | translate }}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button\n class=\"md-raised\" ng-click=\"vm.print();\" ng-if=\"!vm.mobile\">{{ \'GENERAL.PRINT\' | translate }}</md-button><md-button \nclass=\"md-raised\" ng-click=\"vm.openFilter();\">{{ \'GENERAL.FILTER\' | translate }}</md-button></div></div><div \nclass=\"content\" id=\"printArea\" style=\"overflow-x:scroll\"><md-content class=\"content\" flex ng-if=\"!vm.showTable\"><br>\n<span style=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></md-content><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'REPORT.FINANCEANALYTICAL.DATE\' | translate }}</span></div></th><th class=\"secondary-text\" \nng-if=\"vm.showPdvLocation\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'REPORT.FINANCEANALYTICAL.WHERE\' | translate }}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'REPORT.FINANCEANALYTICAL.WHO\' | translate }}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'REPORT.FINANCEANALYTICAL.CUSTOMER\' | translate }}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'REPORT.FINANCEANALYTICAL.PAYMENT_TYPE\' | translate }}</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'REPORT.FINANCEANALYTICAL.VALUE\' | translate }}</span></div></th></tr></thead><tbody compile=\"vm.html\" id=\"code\">\n</tbody></table></div></div><md-sidenav class=\"md-sidenav-right\" md-component-id=\"filter\" md-is-locked-open=\"false\" \nmd-whiteframe=\"4\"><md-toolbar class=\"md-hue-2\"><div class=\"md-toolbar-tools\"><h2>{{\'GENERAL.FILTER\' | translate}}</h2>\n<span flex></span><md-button class=\"md-raised md-orange-500-bg\" aria-label=\"Refresh\" ng-click=\"vm.refresh()\">\n{{\'GENERAL.REFRESH\'|translate}}</md-button></div></md-toolbar><md-content layout-padding><md-subheader \nstyle=\"margin-left: -20px\">Período</md-subheader><div layout=\"row\" style=\"margin-top: -20px\"><span \nstyle=\"margin-left: 10px\">{{\'GENERAL.FROM\'|translate}}<md-datepicker ng-model=\"vm.filter.dtFrom\"></md-datepicker>\n</span></div><div layout=\"row\" style=\"margin-top: -10px\"><span style=\"margin-left: 10px\">{{\'GENERAL.TO\'|translate}}\n<md-datepicker ng-model=\"vm.filter.dtTo\"></md-datepicker></span></div><md-subheader style=\"margin-left: -20px\" \nng-if=\"vm.showPdvLocation\">Local</md-subheader><div layout=\"column\" style=\"margin-top: -5px\" \nng-if=\"vm.showPdvLocation\"><md-checkbox ng-repeat=\"local in vm.pdvLocations\" \nng-model=\"vm.filter.locations[local.locationId]\">{{ local.name }}</md-checkbox></div><md-subheader \nstyle=\"margin-left: -20px\">Operador (quem lançou no sistema)</md-subheader><div layout=\"column\" \nstyle=\"margin-top: -5px\"><md-checkbox ng-repeat=\"user in vm.users\" ng-model=\"vm.filter.users[user._id]\">{{ user.name }}\n</md-checkbox></div><md-subheader style=\"margin-left: -20px; margin-top:-20px\">Meio de Pagamento</md-subheader><div \nlayout=\"column\" style=\"margin-top: -5px\"><md-checkbox ng-model=\"vm.filter.paymentType.CASH\">\n{{ \'GENERAL.PAYMENT_TYPE.CASH\' | translate }}</md-checkbox><md-checkbox ng-model=\"vm.filter.paymentType.CREDIT\">\n{{ \'GENERAL.PAYMENT_TYPE.CREDIT\' | translate }}</md-checkbox><md-checkbox ng-model=\"vm.filter.paymentType.DEBIT\">\n{{ \'GENERAL.PAYMENT_TYPE.DEBIT\' | translate }}</md-checkbox></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/report/finance/salesPerPaymentType.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">\n{{ \'REPORT.PAYMENT_TYPE.HEADER\' | translate }}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised\" ng-click=\"vm.print();\" ng-if=\"!vm.mobile\">{{ \'GENERAL.PRINT\' | translate }}</md-button><md-button \nclass=\"md-raised\" ng-click=\"vm.openFilter();\">{{ \'GENERAL.FILTER\' | translate }}</md-button></div></div><div \nclass=\"content\" id=\"printArea\" style=\"overflow-x:scroll\"><md-content class=\"content\" flex ng-if=\"!vm.showTable\"><br>\n<span style=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></md-content><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'REPORT.PAYMENT_TYPE.PAYMENT_TYPE\' | translate }}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'REPORT.PAYMENT_TYPE.TOTAL\' | translate }}</span></div></th></tr>\n</thead><tbody compile=\"vm.html\" id=\"code\"></tbody></table></div></div><md-sidenav class=\"md-sidenav-right\" \nmd-component-id=\"filter\" md-is-locked-open=\"false\" md-whiteframe=\"4\"><md-toolbar class=\"md-hue-2\"><div \nclass=\"md-toolbar-tools\"><h2>{{\'GENERAL.FILTER\' | translate}}</h2><span flex></span><md-button \nclass=\"md-raised md-orange-500-bg\" aria-label=\"Refresh\" ng-click=\"vm.refresh()\">{{\'GENERAL.REFRESH\'|translate}}\n</md-button></div></md-toolbar><md-content layout-padding><md-subheader style=\"margin-left: -20px\">Período\n</md-subheader><div layout=\"row\"><span style=\"margin-left: 10px\">{{\'GENERAL.FROM\'|translate}}<md-datepicker \nng-model=\"vm.filter.dtFrom\"></md-datepicker></span></div><div layout=\"row\"><span style=\"margin-left: 10px\">\n{{\'GENERAL.TO\'|translate}}<md-datepicker ng-model=\"vm.filter.dtTo\"></md-datepicker></span></div><md-subheader \nstyle=\"margin-left: -20px\" ng-if=\"vm.showPdvLocation\">Local</md-subheader><div layout=\"column\" \nstyle=\"margin-top: -5px\" ng-if=\"vm.showPdvLocation\"><md-checkbox ng-repeat=\"local in vm.pdvLocations\" \nng-model=\"vm.filter.locations[local.locationId]\">{{ local.name }}</md-checkbox></div><md-subheader \nstyle=\"margin-left: -20px\">Operador (quem lançou no sistema)</md-subheader><div layout=\"column\" \nstyle=\"margin-top: -5px\"><md-checkbox ng-repeat=\"user in vm.users\" ng-model=\"vm.filter.users[user._id]\">{{ user.name }}\n</md-checkbox></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/report/finance/salesWithCreditDebit.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">\n{{ \'REPORT.CREDITDEBIT.HEADER\' | translate }}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised\" ng-click=\"vm.print();\" ng-if=\"!vm.mobile\">{{ \'GENERAL.PRINT\' | translate }}</md-button><md-button \nclass=\"md-raised\" ng-click=\"vm.openFilter();\">{{ \'GENERAL.FILTER\' | translate }}</md-button></div></div><div \nclass=\"content\" id=\"printArea\" style=\"overflow-x:scroll\"><md-content class=\"content\" flex ng-if=\"!vm.showTable\"><br>\n<span style=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></md-content><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{ \'REPORT.CREDITDEBIT.DATE\' | translate }}\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'REPORT.CREDITDEBIT.WHO\' | translate }}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{ \'REPORT.CREDITDEBIT.CUSTOMER\' | translate }}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'REPORT.CREDITDEBIT.CREDITDEBIT\' | translate }}</span></div></th>\n</tr></thead><tbody compile=\"vm.html\" id=\"code\"></tbody></table></div></div><md-sidenav class=\"md-sidenav-right\" \nmd-component-id=\"filter\" md-is-locked-open=\"false\" md-whiteframe=\"4\"><md-toolbar class=\"md-hue-2\"><div \nclass=\"md-toolbar-tools\"><h2>{{\'GENERAL.FILTER\' | translate}}</h2><span flex></span><md-button \nclass=\"md-raised md-orange-500-bg\" aria-label=\"Refresh\" ng-click=\"vm.refresh()\">{{\'GENERAL.REFRESH\'|translate}}\n</md-button></div></md-toolbar><md-content layout-padding><md-subheader style=\"margin-left: -20px\">Período\n</md-subheader><div layout=\"row\" style=\"margin-top: -20px\"><span style=\"margin-left: 10px\">{{\'GENERAL.FROM\'|translate}}\n<md-datepicker ng-model=\"vm.filter.dtFrom\"></md-datepicker></span></div><div layout=\"row\" style=\"margin-top: -10px\">\n<span style=\"margin-left: 10px\">{{\'GENERAL.TO\'|translate}}<md-datepicker ng-model=\"vm.filter.dtTo\"></md-datepicker>\n</span></div><md-subheader style=\"margin-left: -20px\" ng-if=\"vm.showPdvLocation\">Local</md-subheader><div \nlayout=\"column\" style=\"margin-top: -5px\" ng-if=\"vm.showPdvLocation\"><md-checkbox ng-repeat=\"local in vm.pdvLocations\" \nng-model=\"vm.filter.locations[local.locationId]\">{{ local.name }}</md-checkbox></div><md-subheader \nstyle=\"margin-left: -20px\">Operador (quem lançou no sistema)</md-subheader><div layout=\"column\" \nstyle=\"margin-top: -5px\"><md-checkbox ng-repeat=\"user in vm.users\" ng-model=\"vm.filter.users[user._id]\">{{ user.name }}\n</md-checkbox></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/report/customer/birthday.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">\n{{ \'REPORT.CUSTOMER.BIRTHDAY\' | translate }}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised\" ng-click=\"vm.print();\" ng-if=\"!vm.mobile\">{{ \'GENERAL.PRINT\' | translate }}</md-button><md-button \nclass=\"md-raised\" ng-click=\"vm.openFilter();\">{{ \'GENERAL.FILTER\' | translate }}</md-button></div></div><div \nclass=\"content\" id=\"printArea\" style=\"overflow-x:scroll\"><md-content class=\"content\" flex ng-if=\"!vm.showTable\"><br>\n<span style=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></md-content><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{ \'REPORT.CUSTOMER.NAME\' | translate }}\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'REPORT.CUSTOMER.TELEPHONE\' | translate }}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">{{ \'REPORT.CUSTOMER.BIRTHDAYDATE\' | translate }}</span></div></th></tr></thead><tbody \ncompile=\"vm.html\" id=\"code\"></tbody></table></div></div><md-sidenav class=\"md-sidenav-right\" md-component-id=\"filter\" \nmd-is-locked-open=\"false\" md-whiteframe=\"4\"><md-toolbar class=\"md-hue-2\"><div class=\"md-toolbar-tools\"><h2>\n{{\'GENERAL.FILTER\' | translate}}</h2><span flex></span><md-button class=\"md-raised md-orange-500-bg\" \naria-label=\"Refresh\" ng-click=\"vm.refresh()\">{{\'GENERAL.REFRESH\'|translate}}</md-button></div></md-toolbar><md-content \nlayout-padding><md-subheader style=\"margin-left: -20px\">Filtro</md-subheader><md-select ng-model=\"vm.filterType\">\n<md-option data-value=\"THIS_MONTH\" selected=\"selected\">Este mês</md-option><md-option data-value=\"TODAY\">Hoje\n</md-option><md-option data-value=\"MONTH\">Esolha o mês</md-option></md-select><md-subheader style=\"margin-left: -20px\" \nng-if=\"vm.filterType==\'MONTH\'\">Mes</md-subheader><div layout=\"column\" style=\"margin-top: -5px\"><md-select \nng-model=\"vm.month\" ng-if=\"vm.filterType==\'MONTH\'\"><md-option ng-value=\"1\" selected=\"selected\">Janeiro</md-option>\n<md-option ng-value=\"2\">Fevereiro</md-option><md-option ng-value=\"3\">Março</md-option><md-option ng-value=\"4\">Abril\n</md-option><md-option ng-value=\"5\">Maio</md-option><md-option ng-value=\"6\">Junho</md-option><md-option ng-value=\"7\">\nJulho</md-option><md-option ng-value=\"8\">Agosto</md-option><md-option ng-value=\"9\">Setembro</md-option><md-option \nng-value=\"10\">Outubro</md-option><md-option ng-value=\"11\">Novembro</md-option><md-option ng-value=\"12\">Dezembro\n</md-option></md-select></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/report/customer/customersWithCreditDebit.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">\n{{ \'REPORT.CUSTOMER.CREDITDEBIT\' | translate }}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised\" ng-click=\"vm.print();\" ng-if=\"!vm.mobile\">{{ \'GENERAL.PRINT\' | translate }}</md-button></div></div>\n<div class=\"content\" id=\"printArea\" style=\"overflow-x:scroll\"><md-content class=\"content\" flex ng-if=\"!vm.showTable\">\n<br><span style=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></md-content><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{ \'REPORT.CUSTOMER.NAME\' | translate }}\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'REPORT.CUSTOMER.TELEPHONE\' | translate }}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">{{ \'REPORT.CUSTOMER.AMOUNT\' | translate }}</span></div></th></tr></thead><tbody \ncompile=\"vm.html\" id=\"code\"></tbody></table></div></div><md-sidenav class=\"md-sidenav-right\" md-component-id=\"filter\" \nmd-is-locked-open=\"false\" md-whiteframe=\"4\"><md-toolbar class=\"md-hue-2\"><div class=\"md-toolbar-tools\"><h2>\n{{\'GENERAL.FILTER\' | translate}}</h2><span flex></span><md-button class=\"md-raised md-orange-500-bg\" \naria-label=\"Refresh\" ng-click=\"vm.refresh()\">{{\'GENERAL.REFRESH\'|translate}}</md-button></div></md-toolbar><md-content \nlayout-padding><md-subheader style=\"margin-left: -20px\">Período</md-subheader><div layout=\"row\" \nstyle=\"margin-top: -20px\"><span style=\"margin-left: 10px\">{{\'GENERAL.FROM\'|translate}}<md-datepicker \nng-model=\"vm.filter.dtFrom\"></md-datepicker></span></div><div layout=\"row\" style=\"margin-top: -10px\"><span \nstyle=\"margin-left: 10px\">{{\'GENERAL.TO\'|translate}}<md-datepicker ng-model=\"vm.filter.dtTo\"></md-datepicker></span>\n</div><md-subheader style=\"margin-left: -20px\">Profissional (quem executou o serviço)</md-subheader><div \nlayout=\"column\" style=\"margin-top: -5px\"><md-checkbox ng-repeat=\"professional in vm.professionals\" \nng-model=\"vm.filter.professionals[professional._id]\">{{ professional.name }}</md-checkbox></div><md-subheader \nstyle=\"margin-left: -20px\">Operador (quem lançou no sistema)</md-subheader><div layout=\"column\" \nstyle=\"margin-top: -5px\"><md-checkbox ng-repeat=\"user in vm.users\" ng-model=\"vm.filter.users[user.id]\">{{ user.name }}\n</md-checkbox></div><md-subheader style=\"margin-left: -20px\">Categoria de Serviço</md-subheader><div layout=\"column\" \nstyle=\"margin-top: -5px\"><md-checkbox ng-repeat=\"category in vm.serviceCategories\" \nng-model=\"vm.filter.categories[category._id]\">{{ category.name }}</md-checkbox></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/report/customer/top.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">\n{{ \'REPORT.CUSTOMER.TOP\' | translate }}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised\" ng-click=\"vm.print();\" ng-if=\"!vm.mobile\">{{ \'GENERAL.PRINT\' | translate }}</md-button><md-button \nclass=\"md-raised\" ng-click=\"vm.openFilter();\">{{ \'GENERAL.FILTER\' | translate }}</md-button></div></div><div \nclass=\"content\" id=\"printArea\" style=\"overflow-x:scroll\"><md-content class=\"content\" flex ng-if=\"!vm.showTable\"><br>\n<span style=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></md-content><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{ \'REPORT.CUSTOMER.NAME\' | translate }}\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'REPORT.CUSTOMER.TELEPHONE\' | translate }}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">{{ \'REPORT.CUSTOMER.AMOUNT\' | translate }}</span></div></th></tr></thead><tbody \ncompile=\"vm.html\" id=\"code\"></tbody></table></div></div><md-sidenav class=\"md-sidenav-right\" md-component-id=\"filter\" \nmd-is-locked-open=\"false\" md-whiteframe=\"4\"><md-toolbar class=\"md-hue-2\"><div class=\"md-toolbar-tools\"><h2>\n{{\'GENERAL.FILTER\' | translate}}</h2><span flex></span><md-button class=\"md-raised md-orange-500-bg\" \naria-label=\"Refresh\" ng-click=\"vm.refresh()\">{{\'GENERAL.REFRESH\'|translate}}</md-button></div></md-toolbar><md-content \nlayout-padding><md-subheader style=\"margin-left: -20px\">Período</md-subheader><div layout=\"row\" \nstyle=\"margin-top: -20px\"><span style=\"margin-left: 10px\">{{\'GENERAL.FROM\'|translate}}<md-datepicker \nng-model=\"vm.filter.dtFrom\"></md-datepicker></span></div><div layout=\"row\" style=\"margin-top: -10px\"><span \nstyle=\"margin-left: 10px\">{{\'GENERAL.TO\'|translate}}<md-datepicker ng-model=\"vm.filter.dtTo\"></md-datepicker></span>\n</div><md-subheader style=\"margin-left: -20px\">Profissional (quem executou o serviço)</md-subheader><div \nlayout=\"column\" style=\"margin-top: -5px\"><md-checkbox ng-repeat=\"professional in vm.professionals\" \nng-model=\"vm.filter.professionals[professional._id]\">{{ professional.name }}</md-checkbox></div><md-subheader \nstyle=\"margin-left: -20px\">Categoria de Serviço</md-subheader><div layout=\"column\" style=\"margin-top: -5px\">\n<md-checkbox ng-repeat=\"category in vm.serviceCategories\" ng-model=\"vm.filter.categories[category._id]\">\n{{ category.name }}</md-checkbox></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/report/marketing/cancelationByUser.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'REPORT.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><div\n class=\"parent\">{{ \'REPORT.USEDGIFTCARDS.HEADER\' | translate }}</div></div><div class=\"title\">\n{{ \'REPORT.USEDGIFTCARDS.HEADER\' | translate }}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised\" ng-click=\"vm.print();\">{{ \'GENERAL.PRINT\' | translate }}</md-button><md-button class=\"md-raised\" \nng-click=\"vm.openFilter();\">{{ \'GENERAL.FILTER\' | translate }}</md-button></div></div><div class=\"content\" \nid=\"printArea\" style=\"overflow-x:scroll\"><md-content class=\"content\" flex ng-if=\"!vm.showTable\"><br><span \nstyle=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></md-content><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'REPORT.USEDGIFTCARDS.DATE\' | translate }}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">{{ \'REPORT.USEDGIFTCARDS.WHO\' | translate }}</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">{{ \'REPORT.USEDGIFTCARDS.CUSTOMER\' | translate }}</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'REPORT.USEDGIFTCARDS.VALUE\' | translate }}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">{{ \'REPORT.USEDGIFTCARDS.OBSERVATION\' | translate }}</span></div></th></tr></thead><tbody \ncompile=\"vm.html\" id=\"code\"></tbody></table></div></div><md-sidenav class=\"md-sidenav-right\" md-component-id=\"filter\" \nmd-is-locked-open=\"false\" md-whiteframe=\"4\"><md-toolbar class=\"md-hue-2\"><div class=\"md-toolbar-tools\"><h2>\n{{\'GENERAL.FILTER\' | translate}}</h2><span flex></span><md-button class=\"md-raised md-orange-500-bg\" \naria-label=\"Refresh\" ng-click=\"vm.refresh()\">{{\'GENERAL.REFRESH\'|translate}}</md-button></div></md-toolbar><md-content \nlayout-padding><md-subheader style=\"margin-left: -20px\">Período</md-subheader><div layout=\"row\" \nstyle=\"margin-top: -20px\"><span style=\"margin-left: 10px\">{{\'GENERAL.FROM\'|translate}}<md-datepicker \nng-model=\"vm.filter.dtFrom\"></md-datepicker></span></div><div layout=\"row\" style=\"margin-top: -10px\"><span \nstyle=\"margin-left: 10px\">{{\'GENERAL.TO\'|translate}}<md-datepicker ng-model=\"vm.filter.dtTo\"></md-datepicker></span>\n</div><md-subheader style=\"margin-left: -20px\">Operador (quem lançou no sistema)</md-subheader><div layout=\"column\" \nstyle=\"margin-top: -5px\"><md-checkbox ng-repeat=\"user in vm.users\" ng-model=\"vm.filter.users[user.id]\">{{ user.name }}\n</md-checkbox></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/report/marketing/canceled.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">\nAgendamentos cancelados</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised\" \nng-click=\"vm.print();\">{{ \'GENERAL.PRINT\' | translate }}</md-button><md-button class=\"md-raised\" \nng-click=\"vm.openFilter();\">{{ \'GENERAL.FILTER\' | translate }}</md-button></div></div><div class=\"content\" \nid=\"printArea\" style=\"overflow-x:scroll\"><md-content class=\"content\" flex ng-if=\"!vm.showTable\"><br><span \nstyle=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></md-content><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Cliente</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Telefone</span></div></th></tr></thead>\n<tbody compile=\"vm.html\" id=\"code\"></tbody></table></div></div><md-sidenav class=\"md-sidenav-right\" \nmd-component-id=\"filter\" md-is-locked-open=\"false\" md-whiteframe=\"4\"><md-toolbar class=\"md-hue-2\"><div \nclass=\"md-toolbar-tools\"><h2>{{\'GENERAL.FILTER\' | translate}}</h2><span flex></span><md-button class=\"md-raised\" \naria-label=\"Refresh\" ng-click=\"vm.refresh()\">{{\'GENERAL.REFRESH\'|translate}}</md-button></div></md-toolbar><md-content \nlayout-padding><md-subheader style=\"margin-left: -20px\">Período</md-subheader><div layout=\"row\" \nstyle=\"margin-top: -20px\"><span style=\"margin-left: 10px\">{{\'GENERAL.FROM\'|translate}}<md-datepicker \nng-model=\"vm.filter.dtFrom\"></md-datepicker></span></div><div layout=\"row\" style=\"margin-top: -10px\"><span \nstyle=\"margin-left: 10px\">{{\'GENERAL.TO\'|translate}}<md-datepicker ng-model=\"vm.filter.dtTo\"></md-datepicker></span>\n</div></md-content></md-sidenav></div>");
$templateCache.put("app/main/report/marketing/messages.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'REPORT.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><div\n class=\"parent\">{{ \'REPORT.MESSAGES.HEADER\' | translate }}</div></div><div class=\"title\">\n{{ \'REPORT.MESSAGES.HEADER\' | translate }}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised\" ng-click=\"vm.print();\">{{ \'GENERAL.PRINT\' | translate }}</md-button><md-button class=\"md-raised\" \nng-click=\"vm.openFilter();\">{{ \'GENERAL.FILTER\' | translate }}</md-button></div></div><div class=\"content\" \nid=\"printArea\"><md-content class=\"content\" flex ng-if=\"!vm.showTable\"><br><span \nstyle=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></md-content><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{ \'REPORT.MESSAGES.DATE\' | translate }}\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'REPORT.MESSAGES.CUSTOMER\' | translate }}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">{{ \'REPORT.MESSAGES.MESSAGE_TYPE\' | translate }}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{ \'REPORT.MESSAGES.TEXT\' | translate }}\n</span></div></th></tr></thead><tbody compile=\"vm.html\" id=\"code\"></tbody></table></div></div><md-sidenav \nclass=\"md-sidenav-right\" md-component-id=\"filter\" md-is-locked-open=\"false\" md-whiteframe=\"4\"><md-toolbar \nclass=\"md-hue-2\"><div class=\"md-toolbar-tools\"><h2>{{\'GENERAL.FILTER\' | translate}}</h2><span flex></span><md-button \nclass=\"md-raised md-orange-500-bg\" aria-label=\"Refresh\" ng-click=\"vm.refresh()\">{{\'GENERAL.REFRESH\'|translate}}\n</md-button></div></md-toolbar><md-content layout-padding><md-subheader style=\"margin-left: -20px\">Período\n</md-subheader><div layout=\"row\" style=\"margin-top: -20px\"><span style=\"margin-left: 10px\">{{\'GENERAL.FROM\'|translate}}\n<md-datepicker ng-model=\"vm.filter.dtFrom\"></md-datepicker></span></div><div layout=\"row\" style=\"margin-top: -10px\">\n<span style=\"margin-left: 10px\">{{\'GENERAL.TO\'|translate}}<md-datepicker ng-model=\"vm.filter.dtTo\"></md-datepicker>\n</span></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/report/marketing/salesWithGiftCards.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'REPORT.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><div\n class=\"parent\">{{ \'REPORT.USEDGIFTCARDS.HEADER\' | translate }}</div></div><div class=\"title\">\n{{ \'REPORT.USEDGIFTCARDS.HEADER\' | translate }}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised\" ng-click=\"vm.print();\">{{ \'GENERAL.PRINT\' | translate }}</md-button><md-button class=\"md-raised\" \nng-click=\"vm.openFilter();\">{{ \'GENERAL.FILTER\' | translate }}</md-button></div></div><div class=\"content\" \nid=\"printArea\" style=\"overflow-x:scroll\"><md-content class=\"content\" flex ng-if=\"!vm.showTable\"><br><span \nstyle=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></md-content><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'REPORT.USEDGIFTCARDS.DATE\' | translate }}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">Local</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{ \'REPORT.USEDGIFTCARDS.WHO\' | translate }}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'REPORT.USEDGIFTCARDS.CUSTOMER\' | translate }}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'REPORT.USEDGIFTCARDS.VALUE\' | translate }}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">{{ \'REPORT.USEDGIFTCARDS.OBSERVATION\' | translate }}</span></div></th></tr></thead><tbody \ncompile=\"vm.html\" id=\"code\"></tbody></table></div></div><md-sidenav class=\"md-sidenav-right\" md-component-id=\"filter\" \nmd-is-locked-open=\"false\" md-whiteframe=\"4\"><md-toolbar class=\"md-hue-2\"><div class=\"md-toolbar-tools\"><h2>\n{{\'GENERAL.FILTER\' | translate}}</h2><span flex></span><md-button class=\"md-raised md-orange-500-bg\" \naria-label=\"Refresh\" ng-click=\"vm.refresh()\">{{\'GENERAL.REFRESH\'|translate}}</md-button></div></md-toolbar><md-content \nlayout-padding><md-subheader style=\"margin-left: -20px\">Período</md-subheader><div layout=\"row\" \nstyle=\"margin-top: -20px\"><span style=\"margin-left: 10px\">{{\'GENERAL.FROM\'|translate}}<md-datepicker \nng-model=\"vm.filter.dtFrom\"></md-datepicker></span></div><div layout=\"row\" style=\"margin-top: -10px\"><span \nstyle=\"margin-left: 10px\">{{\'GENERAL.TO\'|translate}}<md-datepicker ng-model=\"vm.filter.dtTo\"></md-datepicker></span>\n</div><md-subheader style=\"margin-left: -20px\" ng-if=\"vm.showPdvLocation\">Local</md-subheader><div layout=\"column\" \nstyle=\"margin-top: -5px\" ng-if=\"vm.showPdvLocation\"><md-checkbox ng-repeat=\"local in vm.pdvLocations\" \nng-model=\"vm.filter.locations[local.locationId]\">{{ local.name }}</md-checkbox></div><md-subheader \nstyle=\"margin-left: -20px\">Operador (quem lançou no sistema)</md-subheader><div layout=\"column\" \nstyle=\"margin-top: -5px\"><md-checkbox ng-repeat=\"user in vm.users\" ng-model=\"vm.filter.users[user.id]\">{{ user.name }}\n</md-checkbox></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/report/marketing/survey.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'REPORT.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><div\n class=\"parent\">{{ \'REPORT.SURVEY.HEADER\' | translate }}</div></div><div class=\"title\">\n{{ \'REPORT.SURVEY.HEADER\' | translate }}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised\" ng-click=\"vm.print();\">{{ \'GENERAL.PRINT\' | translate }}</md-button><md-button class=\"md-raised\" \nng-click=\"vm.openFilter();\">{{ \'GENERAL.FILTER\' | translate }}</md-button></div></div><div class=\"content\" \nid=\"printArea\" style=\"overflow-x:scroll\"><md-content class=\"content\" flex ng-if=\"!vm.showTable\"><br><span \nstyle=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></md-content><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{ \'REPORT.SURVEY.DATE\' | translate }}\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'REPORT.SURVEY.CUSTOMER\' | translate }}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{ \'REPORT.SURVEY.PROFESSIONALS\' | translate }}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'REPORT.SURVEY.STARS\' | translate }}</span></div></th></tr></thead>\n<tbody compile=\"vm.html\" id=\"code\"></tbody></table></div></div><md-sidenav class=\"md-sidenav-right\" \nmd-component-id=\"filter\" md-is-locked-open=\"false\" md-whiteframe=\"4\"><md-toolbar class=\"md-hue-2\"><div \nclass=\"md-toolbar-tools\"><h2>{{\'GENERAL.FILTER\' | translate}}</h2><span flex></span><md-button class=\"md-raised\" \naria-label=\"Refresh\" ng-click=\"vm.refresh()\">{{\'GENERAL.REFRESH\'|translate}}</md-button></div></md-toolbar><md-content \nlayout-padding><md-subheader style=\"margin-left: -20px\">Período</md-subheader><div layout=\"row\" \nstyle=\"margin-top: -20px\"><span style=\"margin-left: 10px\">{{\'GENERAL.FROM\'|translate}}<md-datepicker \nng-model=\"vm.filter.dtFrom\"></md-datepicker></span></div><div layout=\"row\" style=\"margin-top: -10px\"><span \nstyle=\"margin-left: 10px\">{{\'GENERAL.TO\'|translate}}<md-datepicker ng-model=\"vm.filter.dtTo\"></md-datepicker></span>\n</div><md-subheader style=\"margin-left: -20px\">Profissional (quem executou o serviço)</md-subheader><div \nlayout=\"column\" style=\"margin-top: -30px\"><md-select ng-model=\"vm.filter.professional\" placeholder=\"Profissional\">\n<md-option ng-repeat=\"professional in vm.professionals\" ng-value=\"professional._id\">{{ professional.name }}</md-option>\n</md-select></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/sales/servicePack/checkoutDialog2.html","<md-dialog aria-label=\"New Message\"><form name=\"basicForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{ \'SALES.CHECKOUT.HEADER\' | translate }}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"GENERAL.DIALOG.CLOSE\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-content layout=\"row\" \nstyle=\"width:800px;height:340px\" flex><md-dialog-content flex=\"100\" layout=\"row\"><div style=\"width:399px\"><md-subheader\n style=\"margin-left:-20px\">Forma de pagamento</md-subheader><br><md-content style=\"height:250px;margin-top:-30px\"><div \nng-class=\"{selectedPaymentForm : vm.customerDebitPayment, notSelectedPaymentForm : !vm.customerDebitPayment}\">\n<md-checkbox ng-model=\"vm.customerDebitPayment\">{{ \'GENERAL.PAYMENT_TYPE.CUSTOMERDEBIT\' | translate }}</md-checkbox>\n<br><div style=\"margin-top:0px;margin-left:0px\" layout=\"row\" ng-if=\"vm.customerDebitPayment\"><md-input-container><input\n type=\"number\" min=\"0\" name=\"paidWithCUSTOMERDEBIT\" ng-model=\"vm.paidWithCUSTOMERDEBIT\" \nng-required=\"vm.customerDebitPayment\" placeholder=\"R$\"></md-input-container></div></div><div \nng-class=\"{selectedPaymentForm : vm.cashPayment, notSelectedPaymentForm : !vm.cashPayment}\"><md-checkbox \nng-model=\"vm.cashPayment\">{{ \'GENERAL.PAYMENT_TYPE.CASH\' | translate }}</md-checkbox><br><div \nstyle=\"margin-top:0px;margin-left:0px\" layout=\"row\" ng-if=\"vm.cashPayment\"><md-input-container><input type=\"number\" \nmin=\"0\" name=\"paidWithCASH\" ng-model=\"vm.paidWithCASH\" ng-required=\"vm.cashPayment\" placeholder=\"R$\">\n</md-input-container></div></div><div \nng-class=\"{selectedPaymentForm : vm.checkPayment, notSelectedPaymentForm : !vm.checkPayment}\"><md-checkbox \nng-model=\"vm.checkPayment\">{{ \'GENERAL.PAYMENT_TYPE.CHECK\' | translate }}</md-checkbox><br><div \nstyle=\"margin-top:0px;margin-left:0px\" layout=\"row\" ng-if=\"vm.checkPayment\"><md-input-container><input type=\"number\" \nname=\"paidWithCHECK\" ng-model=\"vm.paidWithCHECK\" ng-required=\"vm.checkPayment\" placeholder=\"R$\" min=\"0\">\n</md-input-container><md-input-container><input type=\"text\" ng-model=\"vm.informationCheck\" placeholder=\"Info.\">\n</md-input-container></div></div><div \nng-class=\"{selectedPaymentForm : vm.visaCreditPayment, notSelectedPaymentForm : !vm.visaCreditPayment}\"><md-checkbox \nng-model=\"vm.visaCreditPayment\">{{ \'GENERAL.PAYMENT_TYPE.VISA_CREDIT\' | translate }}</md-checkbox><br><div \nstyle=\"margin-top:-10px;margin-left:0px\" layout=\"row\" ng-if=\"vm.visaCreditPayment\"><md-input-container><input \ntype=\"number\" ng-model=\"vm.paidWithVisaCredit\" ng-required=\"vm.visaCreditPayment\" placeholder=\"R$\" min=\"0\">\n</md-input-container><md-input-container><input type=\"number\" ng-model=\"vm.authorizationCodeVisaCredit\" \nplaceholder=\"Cod. Autorização\" min=\"0\"></md-input-container></div></div><div \nng-class=\"{selectedPaymentForm : vm.visaDebitPayment, notSelectedPaymentForm : !vm.visaDebitPayment}\"><md-checkbox \nng-model=\"vm.visaDebitPayment\">{{ \'GENERAL.PAYMENT_TYPE.VISA_DEBIT\' | translate }}</md-checkbox><br><div \nstyle=\"margin-top:-10px;margin-left:0px\" layout=\"row\" ng-if=\"vm.visaDebitPayment\"><md-input-container><input \ntype=\"number\" ng-model=\"vm.paidWithVisaDebit\" ng-required=\"vm.visaDebitPayment\" placeholder=\"R$\" min=\"0\">\n</md-input-container><md-input-container><input type=\"number\" ng-model=\"vm.authorizationCodeVisaDebit\" \nplaceholder=\"Cod. Autorização\" min=\"0\"></md-input-container></div></div><div \nng-class=\"{selectedPaymentForm : vm.masterCreditPayment, notSelectedPaymentForm : !vm.masterCreditPayment}\">\n<md-checkbox ng-model=\"vm.masterCreditPayment\">{{ \'GENERAL.PAYMENT_TYPE.MASTER_CREDIT\' | translate }}</md-checkbox><br>\n<div style=\"margin-top:-10px;margin-left:0px\" layout=\"row\" ng-if=\"vm.masterCreditPayment\"><md-input-container><input \ntype=\"number\" ng-model=\"vm.paidWithMasterCredit\" ng-required=\"vm.masterCreditPayment\" placeholder=\"R$\" min=\"0\">\n</md-input-container><md-input-container><input type=\"number\" ng-model=\"vm.authorizationCodeMasterCredit\" \nplaceholder=\"Cod. Autorização\" min=\"0\"></md-input-container></div></div><div \nng-class=\"{selectedPaymentForm : vm.masterDebitPayment, notSelectedPaymentForm : !vm.masterDebitPayment}\"><md-checkbox \nng-model=\"vm.masterDebitPayment\">{{ \'GENERAL.PAYMENT_TYPE.MASTER_DEBIT\' | translate }}</md-checkbox><br><div \nstyle=\"margin-top:-10px;margin-left:0px\" layout=\"row\" ng-if=\"vm.masterDebitPayment\"><md-input-container><input \ntype=\"number\" ng-model=\"vm.paidWithMasterDebit\" ng-required=\"vm.masterDebitPayment\" placeholder=\"R$\" min=\"0\">\n</md-input-container><md-input-container><input type=\"number\" ng-model=\"vm.authorizationCodeMasterDebit\" \nplaceholder=\"Cod. Autorização\" min=\"0\"></md-input-container></div></div><div \nng-class=\"{selectedPaymentForm : vm.amexPayment, notSelectedPaymentForm : !vm.amexPayment}\"><md-checkbox \nng-model=\"vm.amexPayment\">{{ \'GENERAL.PAYMENT_TYPE.AMEX\' | translate }}</md-checkbox><br><div \nstyle=\"margin-top:-10px;margin-left:0px\" layout=\"row\" ng-if=\"vm.amexPayment\"><md-input-container><input type=\"number\" \nng-model=\"vm.paidWithAMEX\" ng-required=\"vm.amexPayment\" placeholder=\"R$\" min=\"0\"></md-input-container>\n<md-input-container><input type=\"number\" ng-model=\"vm.authorizationCodeAMEX\" placeholder=\"Cod. Autorização\" min=\"0\">\n</md-input-container></div></div><div \nng-class=\"{selectedPaymentForm : vm.dinersPayment, notSelectedPaymentForm : !vm.dinersPayment}\"><md-checkbox \nng-model=\"vm.dinersPayment\">{{ \'GENERAL.PAYMENT_TYPE.DINERS\' | translate }}</md-checkbox><br><div \nstyle=\"margin-top:-10px;margin-left:0px\" layout=\"row\" ng-if=\"vm.dinersPayment\"><md-input-container><input \ntype=\"number\" ng-model=\"vm.paidWithDINERS\" ng-required=\"vm.dinersPayment\" placeholder=\"R$\" min=\"0\">\n</md-input-container><md-input-container><input type=\"number\" ng-model=\"vm.authorizationCodeDINERS\" \nplaceholder=\"Cod. Autorização\" min=\"0\"></md-input-container></div></div><div \nng-class=\"{selectedPaymentForm : vm.eloCreditPayment, notSelectedPaymentForm : !vm.eloCreditPayment}\"><md-checkbox \nng-model=\"vm.eloCreditPayment\">{{ \'GENERAL.PAYMENT_TYPE.ELO_CREDIT\' | translate }}</md-checkbox><br><div \nstyle=\"margin-top:-10px;margin-left:0px\" layout=\"row\" ng-if=\"vm.eloCreditPayment\"><md-input-container><input \ntype=\"number\" ng-model=\"vm.paidWithELOCredit\" ng-required=\"vm.eloCreditPayment\" placeholder=\"R$\" min=\"0\">\n</md-input-container><md-input-container><input type=\"number\" ng-model=\"vm.authorizationCodeELOCredit\" \nplaceholder=\"Cod. Autorização\" min=\"0\"></md-input-container></div></div><div \nng-class=\"{selectedPaymentForm : vm.eloDebitPayment, notSelectedPaymentForm : !vm.eloDebitPayment}\"><md-checkbox \nng-model=\"vm.eloDebitPayment\">{{ \'GENERAL.PAYMENT_TYPE.ELO_DEBIT\' | translate }}</md-checkbox><br><div \nstyle=\"margin-top:-10px;margin-left:0px\" layout=\"row\" ng-if=\"vm.eloDebitPayment\"><md-input-container><input \ntype=\"number\" ng-model=\"vm.paidWithELODebit\" ng-required=\"vm.eloDebitPayment\" placeholder=\"R$\" min=\"0\">\n</md-input-container><md-input-container><input type=\"number\" ng-model=\"vm.authorizationCodeELODebit\" \nplaceholder=\"Cod. Autorização\" min=\"0\"></md-input-container></div></div><div \nng-class=\"{selectedPaymentForm : vm.otherCreditPayment, notSelectedPaymentForm : !vm.otherCreditPayment}\"><md-checkbox \nng-model=\"vm.otherCreditPayment\">{{ \'GENERAL.PAYMENT_TYPE.OTHER_CREDIT\' | translate }}</md-checkbox><br><div \nstyle=\"margin-top:-10px;margin-left:0px\" layout=\"row\" ng-if=\"vm.otherCreditPayment\"><md-input-container><input \ntype=\"number\" ng-model=\"vm.paidWithOtherCredit\" ng-required=\"vm.otherCreditPayment\" placeholder=\"R$\" min=\"0\">\n</md-input-container><md-input-container><input type=\"number\" ng-model=\"vm.authorizationCodeOtherCredit\" \nplaceholder=\"Cod. Autorização\" min=\"0\"></md-input-container></div></div><div \nng-class=\"{selectedPaymentForm : vm.otherDebitPayment, notSelectedPaymentForm : !vm.otherDebitPayment}\"><md-checkbox \nng-model=\"vm.otherDebitPayment\">{{ \'GENERAL.PAYMENT_TYPE.OTHER_DEBIT\' | translate }}</md-checkbox><br><div \nstyle=\"margin-top:-10px;margin-left:0px\" layout=\"row\" ng-if=\"vm.otherDebitPayment\"><md-input-container><input \ntype=\"number\" ng-model=\"vm.paidWithOtherDebit\" ng-required=\"vm.otherDebitPayment\" placeholder=\"R$\" min=\"0\">\n</md-input-container><md-input-container><input type=\"number\" ng-model=\"vm.authorizationCodeOtherDebit\" \nplaceholder=\"Cod. Autorização\" min=\"0\"></md-input-container></div></div></md-content></div><div \nstyle=\"width: 2px;background-color: lightblue;height:310px;margin-top:-31px\"></div><div style=\"width:399px\"><div \nlayout=\"row\" style=\"margin-top:20px\"><md-input-container style=\"margin-top:-20px;left-margin:0px;padding-left:15px\" \nflex><layout style=\"font-size:12px\">Total em Deb/Cred</layout><input type=\"number\" name=\"paid\" \nng-model=\"vm.totalValue\" ng-disabled=\"true\"></md-input-container><md-input-container \nstyle=\"margin-top:-20px;left-margin:0px;padding-left:15px\" flex><layout style=\"font-size:12px\">Total em din/che\n</layout><input type=\"number\" ng-model=\"vm.totalValueWithSpecialPaymentType\" ng-disabled=\"true\"></md-input-container>\n<md-input-container style=\"margin-top:-20px;left-margin:0px;padding-left:15px\" flex><layout style=\"font-size:12px\">\nCred/Deb Anterior</layout><input type=\"text\" name=\"customerCreditDebit\" ng-model=\"vm.customer.creditDebit\" \nng-disabled=\"true\"><br><span style=\"font-size:11px; color:Red\" ng-if=\"vm.customer.creditDebit < 0\">\n{{vm.customer.lastCreditDebitObservation}}</span> <span style=\"font-size:11px; color:Blue\" \nng-if=\"vm.customer.creditDebit > 0\">{{vm.customer.lastCreditDebitObservation}}</span></md-input-container></div><div \nlayout=\"row\"><md-input-container style=\"margin-top:-20px;left-margin:0px;padding-left:15px\" flex><layout \nstyle=\"font-size:12px\">Valor devido</layout><input type=\"text\" name=\"customerCreditDebit\" ng-model=\"vm.amountOwned\" \nng-disabled=\"true\"><br></md-input-container><md-input-container \nstyle=\"margin-top:-20px;left-margin:0px;padding-left:15px\" flex><layout style=\"font-size:12px\">Desconto Total (R$)\n</layout><input type=\"number\" name=\"giftCard\" ng-model=\"vm.giftCardValue\" min=\"0\"></md-input-container>\n<md-input-container style=\"margin-top:-20px;left-margin:0px;padding-left:15px\" flex><layout style=\"font-size:12px\">\nObservação</layout><input type=\"text\" name=\"giftCardOBS\" ng-model=\"vm.giftCardObservation\"><div \nng-messages=\"basicForm.giftCardOBS.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"SALES.CHECKOUT.VALIDATION.EXPLANATION_REQUIRED\"></span></div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container style=\"margin-top:-20px;left-margin:0px;padding-left:15px\" flex><layout \nstyle=\"font-size:12px\">Valor após desconto</layout><input type=\"text\" name=\"amountOwnedAfterDiscount\" \nng-model=\"vm.amountOwnedAfterDiscount\" ng-disabled=\"true\"><br></md-input-container><md-input-container \nstyle=\"margin-top:-20px;left-margin:0px\" flex><layout style=\"font-size:12px\">Valor Pago (R$)</layout><input \ntype=\"number\" name=\"paid\" ng-model=\"vm.paid\" required disabled=\"disabled\"><div ng-messages=\"basicForm.paid.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{ \'SALES.CHECKOUT.VALIDATION.PAID_REQUIRED\' | translate }}</span></div>\n</div></md-input-container></div></div></md-dialog-content></md-content><md-divider></md-divider><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between \"><md-button ng-click=\"vm.clickToSave()\" class=\"md-warn\" aria-label=\"SAVE\" \nng-disabled=\"vm.paidWithDiscount < vm.amountOwned\" translate=\"GENERAL.BUTTON.CHECKOUT\" \ntranslate-attr-aria-label=\"CALENDAR.SAVE\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sales/servicePack/list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">{{ \'SALES.HEADER\' | translate }}\n</span></div><div class=\"title\">{{ \'SETTINGS.SERVICE.SERVICE_PACK.HEADER\' | translate }}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-raised\" ui-sref=\"app.sales.servicePack.new\">\n{{ \'SALES.SERVICE_PACK.SELL\' | translate }}</md-button></div></div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-40dp\" layout=\"row\" layout-align=\"center center\" height=\"100px\" ng-show=\"!vm.showTable\">\n<br><span style=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></div><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'SALES.SERVICE_PACK.DATE\' | translate }}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'SALES.SERVICE_PACK.PACK_NAME\' | translate }}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">{{ \'SALES.SERVICE_PACK.CUSTOMER_NAME\' | translate }}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{ \'SALES.SERVICE_PACK.PAID\' | translate }}\n</span></div></th><th></th></tr></thead><tbody><tr ng-repeat=\"priceTable in ::vm.priceTables\"><td>\n{{ priceTable.checkoutDate | date:\'dd/MM/yyyy\' }}</td><td>{{ priceTable.servicePackName }}</td><td>\n{{ priceTable.customerName }}</td><td>{{ priceTable.paid }}</td><td align=\"right\"><md-button aria-label=\"Trash\" \nclass=\"md-raised md-warn gp-mini\" ng-click=\"vm.removeServicePack(priceTable._id)\"><md-tooltip aria-label=\"Pencil\">\n{{ \'GENERAL.HINTS.TRASH\' | translate }}</md-tooltip><i class=\"icon-trash\" layout=\"center\"></i></md-button></td></tr>\n</tbody></table></div></div></div>");
$templateCache.put("app/main/sales/servicePack/servicePack.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">{{ \'SALES.HEADER\' | translate }}\n</span></div><div class=\"title\">{{ \'SALES.SERVICE_PACK.HEADER\' | translate }}</div></div></div><div class=\"content\" \nlayout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" \nng-submit=\"vm.saveAndClose()\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-autocomplete flex required \nstyle=\"height:65px;font-size:12px\" md-input-name=\"customerId\" md-input-id=\"customer-input\" md-input-minlength=\"3\" \nmd-no-cache=\"true\" md-selected-item=\"vm.customer\" md-autofocus=\"true\" md-search-text=\"vm.customerSearchText\" \nmd-items=\"item in vm.customerSearchTextChange(vm.customerSearchText)\" md-item-text=\"item.name\" ng-disabled=\"false\" \nplaceholder=\"Informe o nome ou telefone do cliente\" ng-attr-md-floating-label=\"Cliente\" md-require-match>\n<md-item-template><span md-highlight-text=\"vm.customerNameSearchText\">{{item.name + \' - \' + item.telephone}}</span>\n</md-item-template><div ng-messages=\"basicForm.customerId.$error\" ng-if=\"basicForm.customerId.$touched\"><div \nng-message=\"required\"><span translate=\"SCHEDULE.VALIDATION.CUSTOMER_REQUIRED\"></span></div><div \nng-message=\"md-require-match\"><span translate=\"SCHEDULE.VALIDATION.CUSTOMER_INVALID\">.</span></div></div>\n</md-autocomplete><p style=\"align-self:center;margin-left:7px;margin-right:5px\">Pacote:</p><select \nng-model=\"vm.selectedPackName\" style=\"min-width:200px;height:35px;align-self:center\"><option \nng-repeat=\"pack in vm.servicePacks\">{{pack.name}}</option></select></div><div layout=\"column\" layout-gt-sm=\"row\" \nstyle=\"width:470px;margin-left:-10px;margin-top:0px\" ng-if=\"vm.showPdvLocation\"><md-input-container \nstyle=\"width:100%;margin-left:20px;margin-top:30px\"><label>Local de Atendimento</label><md-select \nng-model=\"vm.pdvLocation\" required><md-option ng-value=\"item.locationId\" ng-repeat=\"item in vm.pdvLocations\">\n{{item.name}}</md-option></md-select></md-input-container></div><md-button type=\"submit\" class=\"md-raised\" \naria-label=\"Submit\" ng-disabled=\"((basicForm.$invalid) || (vm.isServiceChecked()))\">\n{{ \'GENERAL.BUTTON.SELL\' | translate }}</md-button><md-button type=\"button\" class=\"md-raised md-warn\" \naria-label=\"Cancel\" ui-sref=\"app.sales.servicePack.list\">{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button></form>\n</div></div></div>");
$templateCache.put("app/main/report/other/priceTable.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'REPORT.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'REPORT.OTHER.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator\"></md-icon><span class=\"parent\">{{ \'REPORT.OTHER.PRICE_TABLE.HEADER\' | translate }}</span></div>\n<div class=\"title\">{{vm.priceTable.name}}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised\" ng-click=\"vm.print();\">{{ \'GENERAL.PRINT\' | translate }}</md-button></div></div><div class=\"content\" \nid=\"printArea\" style=\"overflow-x:scroll\"><md-content class=\"content\" flex ng-if=\"!vm.showTable\"><br><span \nstyle=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></md-content><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'REPORT.OTHER.PRICE_TABLE.PRICE\' | translate }}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'REPORT.OTHER.PRICE_TABLE.CASH_PRICE\' | translate }}</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'REPORT.OTHER.PRICE_TABLE.COMISSION_PRICE\' | translate }}</span></div></th></tr></thead><tbody compile=\"vm.html\" \nid=\"code\"></tbody></table></div></div></div>");
$templateCache.put("app/main/report/other/priceTableList.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'REPORT.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'REPORT.OTHER.HEADER\' | translate }}</span></div><div class=\"title\">\n{{ \'REPORT.OTHER.PRICE_TABLE.HEADER\' | translate }}</div></div><div layout=\"row\" layout-align=\"start center\"></div>\n</div><div class=\"content\" style=\"overflow-x:scroll\"><div class=\"white-bg md-whiteframe-40dp\" layout=\"row\" \nlayout-align=\"center center\" height=\"100px\" ng-show=\"!vm.showTable\"><br><span \nstyle=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></div><div class=\"white-bg md-whiteframe-4dp\" \nng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \ndt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{ \'SETTINGS.SERVICE.PRICE_TABLE.NAME\' | translate }}</span></div></th><th></th></tr></thead>\n<tbody><tr ng-repeat=\"priceTable in ::vm.priceTables\"><td>{{ priceTable.name }}</td><td align=\"right\"><md-button \naria-label=\"Report\" class=\"md-raised md-accent gp-mini\" ng-click=\"vm.showPriceTable(priceTable._id)\"><i \nclass=\"icon-view-list\" layout=\"center\"></i></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/report/woweepay/extrato.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">WoWee Pay\n</div><br>Extrato - Powered by Zoop</div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised\" \nng-click=\"vm.print();\" ng-if=\"!vm.mobile\">{{ \'GENERAL.PRINT\' | translate }}</md-button><md-button class=\"md-raised\" \nng-click=\"vm.openFilter();\">{{ \'GENERAL.FILTER\' | translate }}</md-button></div></div><div class=\"content\" \nid=\"printArea\" style=\"overflow-x:scroll\"><md-content class=\"content\" flex ng-if=\"!vm.showTable\"><br><span \nstyle=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></md-content><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Tipo de operação</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">NSU</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Cod. Autorização</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Descrição</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Valor Bruto</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Taxa</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Valor Líquido</span></div></th></tr>\n</thead><tbody compile=\"vm.html\" id=\"code\"></tbody></table></div></div><md-sidenav class=\"md-sidenav-right\" \nmd-component-id=\"filter\" md-is-locked-open=\"false\" md-whiteframe=\"4\"><md-toolbar class=\"md-hue-2\"><div \nclass=\"md-toolbar-tools\"><h2>{{\'GENERAL.FILTER\' | translate}}</h2><span flex></span><md-button \nclass=\"md-raised md-orange-500-bg\" aria-label=\"Refresh\" ng-click=\"vm.refresh()\">{{\'GENERAL.REFRESH\'|translate}}\n</md-button></div></md-toolbar><md-content layout-padding><md-subheader style=\"margin-left: -20px\">Período\n</md-subheader><div layout=\"row\" style=\"margin-top: -20px\"><span style=\"margin-left: 10px\">{{\'GENERAL.FROM\'|translate}}\n<md-datepicker ng-model=\"vm.filter.dtFrom\"></md-datepicker></span></div><div layout=\"row\" style=\"margin-top: -10px\">\n<span style=\"margin-left: 10px\">{{\'GENERAL.TO\'|translate}}<md-datepicker ng-model=\"vm.filter.dtTo\"></md-datepicker>\n</span></div><md-subheader style=\"margin-left: -20px\" ng-if=\"vm.showPdvLocation\">Local</md-subheader><div \nlayout=\"column\" style=\"margin-top: -5px\" ng-if=\"vm.showPdvLocation\"><md-checkbox ng-repeat=\"local in vm.pdvLocations\" \nng-model=\"vm.filter.locations[local.locationId]\">{{ local.name }}</md-checkbox></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/report/woweepay/lancamentosFuturos.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">WoWee Pay\n</div><br>Lançamentos Futuros - Powered by Zoop</div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised\" ng-click=\"vm.print();\" ng-if=\"!vm.mobile\">{{ \'GENERAL.PRINT\' | translate }}</md-button><md-button \nclass=\"md-raised\" ng-click=\"vm.openFilter();\" ng-if=\"false\">{{ \'GENERAL.FILTER\' | translate }}</md-button></div></div>\n<div class=\"content\" id=\"printArea\" style=\"overflow-x:scroll\"><md-content class=\"content\" flex ng-if=\"!vm.showTable\">\n<br><span style=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></md-content><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Id Transação</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Valor Bruto</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Taxa</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Valor Líquido</span></div></th></tr>\n</thead><tbody compile=\"vm.html\" id=\"code\"></tbody></table></div></div><md-sidenav class=\"md-sidenav-right\" \nmd-component-id=\"filter\" md-is-locked-open=\"false\" md-whiteframe=\"4\"><md-toolbar class=\"md-hue-2\"><div \nclass=\"md-toolbar-tools\"><h2>{{\'GENERAL.FILTER\' | translate}}</h2><span flex></span><md-button \nclass=\"md-raised md-orange-500-bg\" aria-label=\"Refresh\" ng-click=\"vm.refresh()\">{{\'GENERAL.REFRESH\'|translate}}\n</md-button></div></md-toolbar><md-content layout-padding><md-subheader style=\"margin-left: -20px\">Período\n</md-subheader><div layout=\"row\" style=\"margin-top: -20px\"><span style=\"margin-left: 10px\">{{\'GENERAL.FROM\'|translate}}\n<md-datepicker ng-model=\"vm.filter.dtFrom\"></md-datepicker></span></div><div layout=\"row\" style=\"margin-top: -10px\">\n<span style=\"margin-left: 10px\">{{\'GENERAL.TO\'|translate}}<md-datepicker ng-model=\"vm.filter.dtTo\"></md-datepicker>\n</span></div><md-subheader style=\"margin-left: -20px\" ng-if=\"vm.showPdvLocation\">Local</md-subheader><div \nlayout=\"column\" style=\"margin-top: -5px\" ng-if=\"vm.showPdvLocation\"><md-checkbox ng-repeat=\"local in vm.pdvLocations\" \nng-model=\"vm.filter.locations[local.locationId]\">{{ local.name }}</md-checkbox></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/report/woweepay/pagamentos.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">WoWee Pay\n</div><br>Pagamentos - Powered by Zoop</div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised\" \nng-click=\"vm.print();\" ng-if=\"!vm.mobile\">{{ \'GENERAL.PRINT\' | translate }}</md-button><md-button class=\"md-raised\" \nng-click=\"vm.openFilter();\">{{ \'GENERAL.FILTER\' | translate }}</md-button></div></div><div class=\"content\" \nid=\"printArea\" style=\"overflow-x:scroll\"><md-content class=\"content\" flex ng-if=\"!vm.showTable\"><br><span \nstyle=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></md-content><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Data</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Cod. Autorização</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Banco</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Agencia</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Conta</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Valor</span></div></th></tr></thead><tbody \ncompile=\"vm.html\" id=\"code\"></tbody></table></div></div><md-sidenav class=\"md-sidenav-right\" md-component-id=\"filter\" \nmd-is-locked-open=\"false\" md-whiteframe=\"4\"><md-toolbar class=\"md-hue-2\"><div class=\"md-toolbar-tools\"><h2>\n{{\'GENERAL.FILTER\' | translate}}</h2><span flex></span><md-button class=\"md-raised md-orange-500-bg\" \naria-label=\"Refresh\" ng-click=\"vm.refresh()\">{{\'GENERAL.REFRESH\'|translate}}</md-button></div></md-toolbar><md-content \nlayout-padding><md-subheader style=\"margin-left: -20px\">Período</md-subheader><div layout=\"row\" \nstyle=\"margin-top: -20px\"><span style=\"margin-left: 10px\">{{\'GENERAL.FROM\'|translate}}<md-datepicker \nng-model=\"vm.filter.dtFrom\"></md-datepicker></span></div><div layout=\"row\" style=\"margin-top: -10px\"><span \nstyle=\"margin-left: 10px\">{{\'GENERAL.TO\'|translate}}<md-datepicker ng-model=\"vm.filter.dtTo\"></md-datepicker></span>\n</div><md-subheader style=\"margin-left: -20px\" ng-if=\"vm.showPdvLocation\">Local</md-subheader><div layout=\"column\" \nstyle=\"margin-top: -5px\" ng-if=\"vm.showPdvLocation\"><md-checkbox ng-repeat=\"local in vm.pdvLocations\" \nng-model=\"vm.filter.locations[local.locationId]\">{{ local.name }}</md-checkbox></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/report/woweepay/vendas.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">WoWee Pay\n</div><br>Vendas - Powered by Zoop</div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised\" \nng-click=\"vm.print();\" ng-if=\"!vm.mobile\">{{ \'GENERAL.PRINT\' | translate }}</md-button><md-button class=\"md-raised\" \nng-click=\"vm.openFilter();\">{{ \'GENERAL.FILTER\' | translate }}</md-button></div></div><div class=\"content\" \nid=\"printArea\"><md-content class=\"content\" flex ng-if=\"!vm.showTable\"><br><span \nstyle=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></md-content><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Num. Comanda</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Id. Transação</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Dt. Venda</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Cliente</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Serviços</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Meio de Pagamento</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Valor</span></div></th></tr></thead><tbody \ncompile=\"vm.html\" id=\"code\"></tbody></table></div></div><md-sidenav class=\"md-sidenav-right\" md-component-id=\"filter\" \nmd-is-locked-open=\"false\" md-whiteframe=\"4\"><md-toolbar class=\"md-hue-2\"><div class=\"md-toolbar-tools\"><h2>\n{{\'GENERAL.FILTER\' | translate}}</h2><span flex></span><md-button class=\"md-raised md-orange-500-bg\" \naria-label=\"Refresh\" ng-click=\"vm.refresh()\">{{\'GENERAL.REFRESH\'|translate}}</md-button></div></md-toolbar><md-content \nlayout-padding style=\"overflow-x:scroll\"><md-subheader style=\"margin-left: -20px\">Período</md-subheader><div \nlayout=\"row\" style=\"margin-top: -20px\"><span style=\"margin-left: 10px\">{{\'GENERAL.FROM\'|translate}}<md-datepicker \nng-model=\"vm.filter.dtFrom\"></md-datepicker></span></div><div layout=\"row\" style=\"margin-top: -10px\"><span \nstyle=\"margin-left: 10px\">{{\'GENERAL.TO\'|translate}}<md-datepicker ng-model=\"vm.filter.dtTo\"></md-datepicker></span>\n</div></md-content></md-sidenav></div>");
$templateCache.put("app/main/report/sales/salesAnalytics.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">\n{{ \'REPORT.SALES.HEADER\' | translate }}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised\" ng-click=\"vm.print();\" ng-if=\"!vm.mobile\">{{ \'GENERAL.PRINT\' | translate }}</md-button><md-button \nclass=\"md-raised\" ng-click=\"vm.openFilter();\">{{ \'GENERAL.FILTER\' | translate }}</md-button></div></div><div \nclass=\"content\" style=\"overflow-x:scroll\"><md-content class=\"content\" flex ng-if=\"!vm.showTable\"><br><span \nstyle=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></md-content><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\" id=\"printArea\"><table class=\"dataTable row-border hover\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" style=\"font-size:13px\">\n{{ \'REPORT.SALES.DATE\' | translate }}</span></div></th><th class=\"secondary-text\" \nng-if=\"!vm.mobile && vm.showPdvLocation\"><div class=\"table-header\"><span class=\"column-title\" style=\"font-size:13px\">\n{{ \'REPORT.SALES.WHERE\' | translate }}</span></div></th><th class=\"secondary-text\" ng-if=\"!vm.mobile\"><div \nclass=\"table-header\"><span class=\"column-title\" style=\"font-size:13px\">{{ \'REPORT.SALES.WHO\' | translate }}</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" style=\"font-size:13px\">\n{{ \'REPORT.SALES.CUSTOMER\' | translate }}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\" style=\"font-size:13px\">{{ \'REPORT.SALES.PROFESSIONAL\' | translate }}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" style=\"font-size:13px\">Ajudante</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" style=\"font-size:13px\">\n{{ \'REPORT.SALES.SERVICE_PRODUCT\' | translate }}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" style=\"font-size:13px\">{{ \'REPORT.SALES.CUSTOMER_PRICE\' | translate }}</span></div></th><th \nclass=\"secondary-text\" ng-if=\"!vm.mobile\"><div class=\"table-header\"><span class=\"column-title\" style=\"font-size:13px\">\n{{ \'REPORT.SALES.COMISSION_PRICE\' | translate }}</span></div></th><th class=\"secondary-text\" ng-if=\"!vm.mobile\"><div \nclass=\"table-header\"><span class=\"column-title\" style=\"font-size:13px\">Comissão Profissional</span></div></th><th \nclass=\"secondary-text\" ng-if=\"!vm.mobile\"><div class=\"table-header\"><span class=\"column-title\" style=\"font-size:13px\">\nComissao Ajudante</span></div></th></tr></thead><tbody compile=\"vm.html\" id=\"code\"></tbody></table></div></div>\n<md-sidenav class=\"md-sidenav-right\" md-component-id=\"filter\" md-is-locked-open=\"false\" md-whiteframe=\"4\"><md-toolbar \nclass=\"md-hue-2\"><div class=\"md-toolbar-tools\"><h2>{{\'GENERAL.FILTER\' | translate}}</h2><span flex></span><md-button \nclass=\"md-raised md-orange-500-bg\" aria-label=\"Refresh\" ng-click=\"vm.refresh()\">{{\'GENERAL.REFRESH\'|translate}}\n</md-button></div></md-toolbar><md-content layout-padding><md-subheader style=\"margin-left: -20px\">Período\n</md-subheader><div layout=\"row\" style=\"margin-top: -20px\"><span style=\"margin-left: 10px\">{{\'GENERAL.FROM\'|translate}}\n<md-datepicker ng-model=\"vm.filter.dtFrom\"></md-datepicker></span></div><div layout=\"row\" style=\"margin-top: -10px\">\n<span style=\"margin-left: 10px\">{{\'GENERAL.TO\'|translate}}<md-datepicker ng-model=\"vm.filter.dtTo\"></md-datepicker>\n</span></div><md-subheader style=\"margin-left: -20px\" ng-if=\"vm.showPdvLocation\">Local</md-subheader><div \nlayout=\"column\" style=\"margin-top: -5px\" ng-if=\"vm.showPdvLocation\"><md-checkbox ng-repeat=\"local in vm.pdvLocations\" \nng-model=\"vm.filter.locations[local.locationId]\">{{ local.name }}</md-checkbox></div><md-subheader \nstyle=\"margin-left: -20px\">Profissional (quem executou o serviço)</md-subheader><div layout=\"column\" \nstyle=\"margin-top: -5px\"><md-checkbox ng-repeat=\"professional in vm.professionals\" \nng-model=\"vm.filter.professionals[professional._id]\">{{ professional.name }}</md-checkbox></div><md-subheader \nstyle=\"margin-left: -20px\">Operador (quem lançou no sistema)</md-subheader><div layout=\"column\" \nstyle=\"margin-top: -5px\"><md-checkbox ng-repeat=\"user in vm.users\" ng-model=\"vm.filter.users[user._id]\">{{ user.name }}\n</md-checkbox></div><md-subheader style=\"margin-left: -20px\">Categoria de Serviço</md-subheader><div layout=\"column\" \nstyle=\"margin-top: -5px\"><md-checkbox ng-repeat=\"category in vm.serviceCategories\" \nng-model=\"vm.filter.categories[category._id]\">{{ category.name }}</md-checkbox></div><md-subheader \nstyle=\"margin-left: -20px\">Categoria de Produto</md-subheader><div layout=\"column\" style=\"margin-top: -5px\">\n<md-checkbox ng-repeat=\"category in vm.productCategories\" ng-model=\"vm.filter.productCategories[category._id]\">\n{{ category.name }}</md-checkbox></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/report/sales/salesPerCategory.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">\n{{ \'REPORT.SALEPERCATEGORY.HEADER\' | translate }}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised\" ng-click=\"vm.print();\" ng-if=\"!vm.mobile\">{{ \'GENERAL.PRINT\' | translate }}</md-button><md-button \nclass=\"md-raised\" ng-click=\"vm.openFilter();\">{{ \'GENERAL.FILTER\' | translate }}</md-button></div></div><div \nclass=\"content\" style=\"overflow-x:scroll\"><md-content class=\"content\" flex ng-if=\"!vm.showTable\"><br><span \nstyle=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></md-content><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\" id=\"printArea\" layout=\"column\"><div layout=\"row\"><c3chart \nbindto-id=\"pie-plot1-chart\" ng-if=\"vm.showTable\"><chart-column ng-repeat=\"item in vm.categories\" \ncolumn-id=\"{{item.columnId}}\" column-values=\"{{item.total}}\" column-type=\"pie\"><chart-pie expand=\"true\"></c3chart>\n</div><div layout=\"row\"><table class=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'REPORT.SALEPERCATEGORY.CATEGORY\' | translate }}</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'REPORT.SALEPERCATEGORY.COUNT\' | translate }}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">{{ \'REPORT.SALEPERCATEGORY.TOTAL\' | translate }}</span></div></th></tr></thead><tbody \ncompile=\"vm.html\" id=\"code\"></tbody></table></div></div></div><md-sidenav class=\"md-sidenav-right\" \nmd-component-id=\"filter\" md-is-locked-open=\"false\" md-whiteframe=\"4\"><md-toolbar class=\"md-hue-2\"><div \nclass=\"md-toolbar-tools\"><h2>{{\'GENERAL.FILTER\' | translate}}</h2><span flex></span><md-button \nclass=\"md-raised md-orange-500-bg\" aria-label=\"Refresh\" ng-click=\"vm.refresh()\">{{\'GENERAL.REFRESH\'|translate}}\n</md-button></div></md-toolbar><md-content layout-padding><md-subheader style=\"margin-left: -20px\">Período\n</md-subheader><div layout=\"row\"><span style=\"margin-left: 10px\">{{\'GENERAL.FROM\'|translate}}<md-datepicker \nng-model=\"vm.filter.dtFrom\"></md-datepicker></span></div><div layout=\"row\"><span style=\"margin-left: 10px\">\n{{\'GENERAL.TO\'|translate}}<md-datepicker ng-model=\"vm.filter.dtTo\"></md-datepicker></span></div><md-subheader \nstyle=\"margin-left: -20px\" ng-if=\"vm.showPdvLocation\">Local</md-subheader><div layout=\"column\" \nstyle=\"margin-top: -5px\" ng-if=\"vm.showPdvLocation\"><md-checkbox ng-repeat=\"local in vm.pdvLocations\" \nng-model=\"vm.filter.locations[local.locationId]\">{{ local.name }}</md-checkbox></div><md-subheader \nstyle=\"margin-left: -20px\">Operador (quem lançou no sistema)</md-subheader><div layout=\"column\" \nstyle=\"margin-top: -5px\"><md-checkbox ng-repeat=\"user in vm.users\" ng-model=\"vm.filter.users[user._id]\">{{ user.name }}\n</md-checkbox></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/report/sales/salesPerProfessional.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">Comissão\n</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised\" ng-click=\"vm.print();\" \nng-if=\"!vm.mobile\">{{ \'GENERAL.PRINT\' | translate }}</md-button><md-button class=\"md-raised\" \nng-click=\"vm.openFilter();\">{{ \'GENERAL.FILTER\' | translate }}</md-button></div></div><div class=\"content\" \nstyle=\"overflow-x:scroll\"><md-content class=\"content\" flex ng-if=\"!vm.showTable\"><br><span \nstyle=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></md-content><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\" id=\"printArea\"><table class=\"dataTable row-border hover\" \nsytle=\"width:100%\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'REPORT.COMISSION.PROFESSIONAL\' | translate }}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Total Vendido (Preço Bruto)</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Total Vendido (Preço Liq.)</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Cota-parte Profissional</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Cota-parte Salão (Bruto)\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\nCota-parte Salão (Liq.)</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Margem Liq.</span></div></th></tr></thead><tbody compile=\"vm.html\" id=\"code\"></tbody></table>\n</div></div><md-sidenav class=\"md-sidenav-right\" md-component-id=\"filter\" md-is-locked-open=\"false\" md-whiteframe=\"4\">\n<md-toolbar class=\"md-hue-2\"><div class=\"md-toolbar-tools\"><h2>{{\'GENERAL.FILTER\' | translate}}</h2><span flex></span>\n<md-button class=\"md-raised md-orange-500-bg\" aria-label=\"Refresh\" ng-click=\"vm.refresh()\">\n{{\'GENERAL.REFRESH\'|translate}}</md-button></div></md-toolbar><md-content layout-padding><md-subheader \nstyle=\"margin-left: -20px\">Período</md-subheader><div layout=\"row\"><span style=\"margin-left: 10px\">\n{{\'GENERAL.FROM\'|translate}}<md-datepicker ng-model=\"vm.filter.dtFrom\"></md-datepicker></span></div><div layout=\"row\">\n<span style=\"margin-left: 10px\">{{\'GENERAL.TO\'|translate}}<md-datepicker ng-model=\"vm.filter.dtTo\"></md-datepicker>\n</span></div><md-subheader style=\"margin-left: -20px\" ng-if=\"vm.showPdvLocation\">Local</md-subheader><div \nlayout=\"column\" style=\"margin-top: -5px\" ng-if=\"vm.showPdvLocation\"><md-checkbox ng-repeat=\"local in vm.pdvLocations\" \nng-model=\"vm.filter.locations[local.locationId]\">{{ local.name }}</md-checkbox></div><md-subheader \nstyle=\"margin-left: -20px\">Operador (quem lançou no sistema)</md-subheader><div layout=\"column\" \nstyle=\"margin-top: -5px\"><md-checkbox ng-repeat=\"user in vm.users\" ng-model=\"vm.filter.users[user._id]\">{{ user.name }}\n</md-checkbox></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/report/sales/salesSynthethic.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"title\">\n{{ \'REPORT.SALES.HEADER\' | translate }}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised\" ng-click=\"vm.print();\" ng-if=\"!vm.mobile\">{{ \'GENERAL.PRINT\' | translate }}</md-button><md-button \nclass=\"md-raised\" ng-click=\"vm.openFilter();\">{{ \'GENERAL.FILTER\' | translate }}</md-button></div></div><div \nclass=\"content\" style=\"overflow-x:scroll\"><md-content class=\"content\" flex ng-if=\"!vm.showTable\"><br><span \nstyle=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></md-content><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\" id=\"printArea\"><table class=\"dataTable row-border hover\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">&nbsp;</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">&nbsp;</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{ \'REPORT.SALES.COUNT\' | translate }}\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'REPORT.SALES.SUM\' | translate }}</span></div></th></tr></thead><tbody compile=\"vm.html\" id=\"code\"></tbody></table>\n</div></div><md-sidenav class=\"md-sidenav-right\" md-component-id=\"filter\" md-is-locked-open=\"false\" md-whiteframe=\"4\">\n<md-toolbar class=\"md-hue-2\"><div class=\"md-toolbar-tools\"><h2>{{\'GENERAL.FILTER\' | translate}}</h2><span flex></span>\n<md-button class=\"md-raised md-orange-500-bg\" aria-label=\"Refresh\" ng-click=\"vm.refresh()\">\n{{\'GENERAL.REFRESH\'|translate}}</md-button></div></md-toolbar><md-content layout-padding><md-subheader \nstyle=\"margin-left: -20px\">Período</md-subheader><div layout=\"row\" style=\"margin-top: -20px\"><span \nstyle=\"margin-left: 10px\">{{\'GENERAL.FROM\'|translate}}<md-datepicker ng-model=\"vm.filter.dtFrom\"></md-datepicker>\n</span></div><div layout=\"row\" style=\"margin-top: -10px\"><span style=\"margin-left: 10px\">{{\'GENERAL.TO\'|translate}}\n<md-datepicker ng-model=\"vm.filter.dtTo\"></md-datepicker></span></div><md-subheader style=\"margin-left: -20px\" \nng-if=\"vm.showPdvLocation\">Local</md-subheader><div layout=\"column\" style=\"margin-top: -5px\" \nng-if=\"vm.showPdvLocation\"><md-checkbox ng-repeat=\"local in vm.pdvLocations\" \nng-model=\"vm.filter.locations[local.locationId]\">{{ local.name }}</md-checkbox></div><md-subheader \nstyle=\"margin-left: -20px\">Profissional (quem executou o serviço)</md-subheader><div layout=\"column\" \nstyle=\"margin-top: -5px\"><md-checkbox ng-repeat=\"professional in vm.professionals\" \nng-model=\"vm.filter.professionals[professional._id]\">{{ professional.name }}</md-checkbox></div><md-subheader \nstyle=\"margin-left: -20px\">Operador (quem lançou no sistema)</md-subheader><div layout=\"column\" \nstyle=\"margin-top: -5px\"><md-checkbox ng-repeat=\"user in vm.users\" ng-model=\"vm.filter.users[user._id]\">{{ user.name }}\n</md-checkbox></div><md-subheader style=\"margin-left: -20px\">Categoria de Serviço</md-subheader><div layout=\"column\" \nstyle=\"margin-top: -5px\"><md-checkbox ng-repeat=\"category in vm.serviceCategories\" \nng-model=\"vm.filter.categories[category._id]\">{{ category.name }}</md-checkbox></div><md-subheader \nstyle=\"margin-left: -20px\">Categoria de Produto</md-subheader><div layout=\"column\" style=\"margin-top: -5px\">\n<md-checkbox ng-repeat=\"category in vm.productCategories\" ng-model=\"vm.filter.productCategories[category._id]\">\n{{ category.name }}</md-checkbox></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/settings/general/general.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span></div><div class=\"title\">{{ \'SETTINGS.GENERAL.HEADER\' | translate }}</div>\n</div></div><div class=\"content\" layout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.saveConfiguration()\" novalidate><md-subheader style=\"\">Localidade</md-subheader>\n<div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"50\" flex-gt-xs=\"50\" layout=\"column\" \nstyle=\"margin-left: 20px\"><label>Código DDD padrão</label><input type=\"text\" name=\"dddCode\" \nng-model=\"vm.configuration.dddCode\" ng-required=\"true\"><div ng-messages=\"basicForm.dddCode.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Código DDD é obrigatório</span></div></div></md-input-container></div><md-subheader \nstyle=\"\">Configurações dos profissionais</md-subheader><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex=\"50\" flex-gt-xs=\"50\" layout=\"column\" style=\"margin-top: -20px;margin-left: 20px\"><md-checkbox \nng-model=\"vm.configuration.allowProfessionalCheckin\">Permitir que o profissional registre o checkin da cliente?\n</md-checkbox></md-input-container><md-input-container flex=\"50\" flex-gt-xs=\"50\" layout=\"column\" \nstyle=\"margin-top: -20px;margin-left: 20px\"><md-checkbox ng-model=\"vm.configuration.allowUndoProfessionalCheckin\">\nPermitir que o profissional desfaça o checkin da cliente?</md-checkbox></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex=\"50\" flex-gt-xs=\"50\" layout=\"column\" \nstyle=\"margin-top: -20px;margin-left: 20px\"><md-checkbox ng-model=\"vm.configuration.allowProfessionalCancelSchedule\">\nPermitir que o profissional possa cancelar o agendamento?</md-checkbox></md-input-container><md-input-container \nflex=\"50\" flex-gt-xs=\"50\" layout=\"column\" style=\"margin-top: -20px;margin-left: 20px\"><md-checkbox \nng-model=\"vm.configuration.allowUndoProfessionalReschedule\">Permitir que o profissional possa reagendar o agendamento?\n</md-checkbox></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"50\" \nflex-gt-xs=\"50\" layout=\"column\" style=\"margin-top: -20px;margin-left: 20px\"><md-checkbox \nng-model=\"vm.configuration.allowScheduleByProfessional\">Permitir que o profissional crie um agendamento?</md-checkbox>\n</md-input-container><md-input-container flex=\"50\" flex-gt-xs=\"50\" layout=\"column\" \nstyle=\"margin-top: -20px;margin-left: 20px\"><md-checkbox ng-model=\"vm.configuration.allowProfessionalSendReminderSMS\">\nPermitir que o profissional envie lembrete via SMS?</md-checkbox></md-input-container></div><md-subheader style=\"\">\nPermissões da Recepcionista</md-subheader><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"50\" \nflex-gt-xs=\"50\" layout=\"column\" style=\"margin-top: -20px;margin-left: 20px\"><md-checkbox \nng-model=\"vm.configuration.allowRecepcionistAddService\">Permitir que a recepcionista adicione serviços na comanda?\n</md-checkbox></md-input-container><md-input-container flex=\"50\" flex-gt-xs=\"50\" layout=\"column\" \nstyle=\"margin-top: -20px;margin-left: 20px\"><md-checkbox ng-model=\"vm.configuration.allowRecepcionistAddProduct\">\nPermitir que a recepcionista adicione produtos na comanda?</md-checkbox></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"50\" flex-gt-xs=\"50\" layout=\"column\" \nstyle=\"margin-top: -20px;margin-left: 20px\"><md-checkbox \nng-model=\"vm.configuration.allowRecepcionistSeeComandaFechada\">\nPermitir que a recepcionista veja e opere as comandas fechadas?</md-checkbox></md-input-container><md-input-container \nflex=\"50\" flex-gt-xs=\"50\" layout=\"column\" style=\"margin-top: -20px;margin-left: 20px\"><md-checkbox \nng-model=\"vm.configuration.allowRecepcionistCreditCustomer\">\nPermitir que a recepcionista opere creditos/debitos direto na ficha do cliente?</md-checkbox></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"50\" flex-gt-xs=\"50\" layout=\"column\" \nstyle=\"margin-top: -20px;margin-left: 20px\"><md-checkbox ng-model=\"vm.configuration.allowRecepcionistDeleteCustomer\">\nPermitir que a recepcionista exclua clientes?</md-checkbox></md-input-container><md-input-container flex=\"50\" \nflex-gt-xs=\"50\" layout=\"column\" style=\"margin-top: -20px;margin-left: 20px\"><md-checkbox \nng-model=\"vm.configuration.allowRecepcionistDeleteSale\">Permitir que a recepcionista exclua comandas?</md-checkbox>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"50\" flex-gt-xs=\"50\" \nlayout=\"column\" style=\"margin-top: -20px;margin-left: 20px\"><md-checkbox \nng-model=\"vm.configuration.allowRecepcionistOpenComandaAntiga\">\nPermitir que a recepcionista receba comandas com datas anteriores?</md-checkbox></md-input-container>\n<md-input-container flex=\"50\" flex-gt-xs=\"50\" layout=\"column\" ng-if=\"false\" \nstyle=\"margin-top: -20px;margin-left: 20px\"><md-checkbox \nng-model=\"vm.configuration.allowRecepcionistOpenComandaCaixaFechado\">\nPermitir que a recepcionista reabra comandas que fazem parte de caixas fechados?</md-checkbox></md-input-container>\n</div><md-subheader style=\"\">{{\'SETTINGS.GENERAL.CUSTOMER.HEADER\' | translate}}</md-subheader><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex=\"50\" flex-gt-xs=\"50\" layout=\"column\" \nstyle=\"margin-top: -20px;margin-left: 20px\"><md-checkbox ng-model=\"vm.configuration.allowCustomerEditByProfessional\">\n{{\'SETTINGS.GENERAL.CUSTOMER.PROFESSIONAL_CAN_EDIT\' | translate}}</md-checkbox></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"50\" flex-gt-xs=\"50\" layout=\"column\" \nstyle=\"margin-top: -20px;margin-left: 20px\"><md-checkbox ng-model=\"vm.configuration.showTelephoneToProfessionals\">\nExibir número de telefone dos clientes para os profissionais no App</md-checkbox></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"50\" flex-gt-xs=\"50\" layout=\"column\" \nstyle=\"margin-top: -20px;margin-left: 20px\"><md-checkbox ng-model=\"vm.configuration.defaultCustomerSMS\">\nEnvio de SMS para clientes deve vir marcado</md-checkbox></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex=\"50\" flex-gt-xs=\"50\" layout=\"column\" \nstyle=\"margin-top: -20px;margin-left: 20px\"><md-checkbox ng-model=\"vm.configuration.defaultCustomerEmail\">\nEnvio de Email para clientes deve vir marcado</md-checkbox></md-input-container></div><md-subheader style=\"\">\n{{\'SETTINGS.GENERAL.SCHEDULE.HEADER\' | translate}}</md-subheader><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex=\"50\" flex-gt-xs=\"50\" layout=\"column\" style=\"margin-top: -20px;margin-left: 20px\"><md-checkbox \nng-model=\"vm.configuration.requestPasswordSchedule\">{{\'SETTINGS.GENERAL.SCHEDULE.REQUEST_PASSWORD\' | translate}}\n</md-checkbox></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"50\" \nflex-gt-xs=\"50\" layout=\"column\" style=\"margin-top: -20px;margin-left: 20px\"><md-checkbox \nng-model=\"vm.configuration.showCanceled\">{{\'SETTINGS.GENERAL.SCHEDULE.SHOW_CANCELED\' | translate}}</md-checkbox>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"50\" flex-gt-xs=\"50\" \nlayout=\"column\" style=\"margin-top: -20px;margin-left: 20px\"><md-checkbox ng-model=\"vm.configuration.showNoShow\">\n{{\'SETTINGS.GENERAL.SCHEDULE.SHOW_NOSHOW\' | translate}}</md-checkbox></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex=\"50\" flex-gt-xs=\"50\" layout=\"column\" \nstyle=\"margin-top: -20px;margin-left: 20px\"><md-checkbox ng-model=\"vm.configuration.transferServiceFromScheduleToSale\">\n{{\'SETTINGS.GENERAL.SCHEDULE.TRANSFER_SERVICE_FROM_SCHEDULE_TO_SALE\' | translate}}</md-checkbox></md-input-container>\n</div><md-subheader>Configurações Financeiras</md-subheader><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container\n flex=\"50\" flex-gt-xs=\"50\" layout=\"column\" style=\"margin-top: -20px;margin-left: 20px\"><md-checkbox \nng-model=\"vm.configuration.allowNewSaleWithDebt\">Permitir fechamento de comanda com divida</md-checkbox>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"50\" flex-gt-xs=\"50\" \nlayout=\"column\" style=\"margin-top: -20px;margin-left: 20px\"><md-checkbox \nng-model=\"vm.configuration.allowNewSaleWithoutCashier\">Permitir fechamento de comandas com caixa fechado</md-checkbox>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"50\" flex-gt-xs=\"50\" \nlayout=\"column\" style=\"margin-top: -20px;margin-left: 20px\">Quem é responsável por pagar o ajudante?<md-radio-group \nng-model=\"vm.configuration.whoPaysAuxiliar\"><md-radio-button data-value=\"PROFESSIONAL\">Profissional</md-radio-button>\n<md-radio-button data-value=\"PDV\" ng-disabled=\"true\">Salão</md-radio-button></md-radio-group></md-input-container>\n</div><md-subheader>{{\'SETTINGS.GENERAL.NOTIFICATIONS.HEADER\' | translate}}</md-subheader><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex=\"50\" flex-gt-xs=\"50\" layout=\"column\" style=\"margin-left: 20px\"><input \ntype=\"text\" name=\"notificationEmail\" ng-model=\"vm.configuration.notification.email\" placeholder=\"Email\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"50\" flex-gt-xs=\"50\" \nlayout=\"column\" style=\"margin-top: -20px;margin-left: 20px\"><md-checkbox \nng-model=\"vm.configuration.notification.scheduleCancel\">\n{{\'SETTINGS.GENERAL.NOTIFICATIONS.SCHEDULE_CANCEL\' | translate}}</md-checkbox></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"50\" flex-gt-xs=\"50\" layout=\"column\" \nstyle=\"margin-top: -20px;margin-left: 20px\"><md-checkbox ng-model=\"vm.configuration.notification.scheduleNoShow\">\n{{\'SETTINGS.GENERAL.NOTIFICATIONS.SCHEDULE_NOSHOW\' | translate}}</md-checkbox></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"50\" flex-gt-xs=\"50\" layout=\"column\" \nstyle=\"margin-top: -20px;margin-left: 20px\"><md-checkbox ng-model=\"vm.configuration.notification.saleWithGiftCard\">\n{{\'SETTINGS.GENERAL.NOTIFICATIONS.SALE_WITH_GIFT_CARD\' | translate}}</md-checkbox></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"50\" flex-gt-xs=\"50\" layout=\"column\" \nstyle=\"margin-top: -20px;margin-left: 20px\"><md-checkbox ng-model=\"vm.configuration.notification.saleWithDebit\">\n{{\'SETTINGS.GENERAL.NOTIFICATIONS.SALE_WITH_DEBIT\' | translate}}</md-checkbox></md-input-container></div><md-subheader>\n{{\'SETTINGS.GENERAL.BLOCK.HEADER\' | translate}}</md-subheader><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex=\"50\" flex-gt-xs=\"50\" layout=\"column\" style=\"margin-top: -20px;margin-left: 20px\"><md-checkbox \nng-model=\"vm.configuration.requestPasswordBlock\">{{\'SETTINGS.GENERAL.BLOCK.REQUEST_PASSWORD\' | translate}}\n</md-checkbox></md-input-container></div><md-subheader>Financeiro & Impostos</md-subheader><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex=\"50\" flex-gt-xs=\"50\" layout=\"column\" style=\"margin-left: 20px\"><label>\nImposto sobre faturamento</label><input type=\"number\" name=\"taxes\" ng-model=\"vm.configuration.taxes\" \nng-required=\"true\"><div ng-messages=\"basicForm.taxes.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nImposto sobre faturamento é obrigatório</span></div></div></md-input-container><md-input-container flex=\"50\" \nflex-gt-xs=\"50\" layout=\"column\" style=\"margin-left: 20px\"><label>Custos Fixos</label><input type=\"number\" \nname=\"fixedCost\" ng-model=\"vm.configuration.fixedCost\" ng-required=\"true\"><div \nng-messages=\"basicForm.fixedCost.$error\" role=\"alert\"><div ng-message=\"required\"><span>Custo fixo é obrigatório</span>\n</div></div></md-input-container></div><md-button type=\"submit\" class=\"md-raised\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid\">{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form>\n</div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>\n{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>\n{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\">\n<span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 \ntranslate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" \naria-label=\"Notifications\" translate translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\">\n</md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch \nclass=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/navigation/layouts/content-with-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\" style=\"background: transparent\"><img \nsrc=\"assets/logo.png\" style=\"margin-top:8px;width: 40px\"></span><span class=\"logo-text\">WoWee Pro</span></div><md-icon \nclass=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\">\n</md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\">\n</ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/toolbar/layouts/content-with-navigation/toolbar.html","<div layout=\"column\" layout-align=\"space-between end\"><div layout=\"row\" layout-align=\"end \"><md-menu-bar \nid=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/content-with-navigation/toolbar3.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex></div><div \nlayout=\"row\" layout-align=\"start center\"><div ng-controller=\"ScheduleController as scheduleController\"><md-button \nclass=\"md-accent md-raised md-hue-1\" ng-click=\"scheduleController.openNewScheduleDialog()\">Novo Agendamento</md-button>\n</div><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\">\n<md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"username\" hide show-gt-sm>{{vm.userName}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" \nhide-xs></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><img style=\"height:30px\" \nsrc=\"https://s3.amazonaws.com/gpsalao.gpsoftware.com.br/images/logos/logo_wowee.png\"></div></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"content\" layout=\"row\" style=\"margin-top: 50px;width:400px;height:50px\" \nng-if=\"false\"><div class=\"form-wrapper md-whiteframe-1dp\"><div layout=\"column\"><strong style=\"color: black\" \nng-if=\"showMessageTrial\">Sua assinatura expira em: {{validUntil | date:\'dd-MM-yyyy\'}}</strong> <strong \nstyle=\"color: red\" ng-if=\"showMessageVencimento\">Sua assinatura encerrou em: {{validUntil | date:\'dd-MM-yyyy\'}}\n</strong></div></div></div><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"username\" hide show-gt-sm>{{vm.pdvName}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" \nhide-xs></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item ng-repeat=\"item in vm.pdvs\"><md-button \nng-click=\"vm.changePDV(item)\">{{item.pdvName}}</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"username\" hide show-gt-sm>{{vm.userName}}</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button ng-click=\"vm.gotoChangeInfo()\">Minhas Informações</md-button></md-menu-item><md-divider>\n</md-divider><md-menu-item><md-button ng-click=\"vm.goToChangeRelatedPDVS()\">Salões Vinculados</md-button>\n</md-menu-item><md-divider></md-divider><md-menu-item><md-button ng-click=\"vm.goToChangePassword()\">Segurança\n</md-button></md-menu-item><md-divider></md-divider><md-menu-item><md-button>{{version}}</md-button></md-menu-item>\n<md-divider></md-divider><md-menu-item><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"vm.gotoSubscription()\" aria-label=\"User settings\" style=\"background: #4AA02C;color:white;border-radius: 8px\" \ntranslate-attr-aria-label=\"Assinatura\"><div layout=\"row\" layout-align=\"space-between center\"><span hide show-gt-sm>\nAssinatura</span></div></md-button><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\" \nng-if=\"false\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin \nmd-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu></md-menu></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar3.html","<div layout=\"row\" layout-align=\"start center\"><div ng-controller=\"ScheduleController as scheduleController\"><md-button \nclass=\"md-accent md-raised md-hue-1\" ng-click=\"scheduleController.openNewScheduleDialog()\">Novo Agendamento</md-button>\n</div><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\">\n<md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"username\" hide show-gt-sm>{{vm.userName}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" \nhide-xs></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu></div>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar3.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex></div><div \nlayout=\"row\" layout-align=\"start center\"><div ng-controller=\"ScheduleController as scheduleController\"><md-button \nclass=\"md-accent md-raised md-hue-1\" ng-click=\"scheduleController.openNewScheduleDialog()\">Novo Agendamento</md-button>\n</div><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\">\n<md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"username\" hide show-gt-sm>{{vm.userName}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" \nhide-xs></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" \nflex><md-button id=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"content\" layout=\"row\" style=\"margin-top: 50px;width:400px;height:50px\" ng-if=\"false\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><div layout=\"column\"><strong style=\"color: black\" ng-if=\"showMessageTrial\">\nSua assinatura expira em: {{validUntil | date:\'dd-MM-yyyy\'}}</strong> <strong style=\"color: red\" \nng-if=\"showMessageVencimento\">Sua assinatura encerrou em: {{validUntil | date:\'dd-MM-yyyy\'}}</strong></div></div></div>\n<md-menu-bar id=\"user-menu6\"><md-button class=\"user-button\" ng-click=\"vm.showPPT()\" aria-label=\"User settings\" \nstyle=\"background: #FCB63A; color:#000000;border-radius: 8px\" \ntranslate-attr-aria-label=\"O que WoWee pode fazer pelo seu salão?\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span hide show-gt-sm>O que WoWee pode fazer pelo seu salão?</span></div>\n</md-button><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"username\" hide show-gt-sm>{{vm.pdvName}}</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item ng-repeat=\"item in vm.pdvs\"><md-button ng-click=\"vm.changePDV(item)\">{{item.pdvName}}</md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-bar><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><span\n class=\"username\" hide show-gt-sm>{{vm.userName}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" \nhide-xs></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.gotoChangeInfo()\">\nMinhas Informa&#231;&#245;es</md-button></md-menu-item><md-divider></md-divider><md-menu-item><md-button \nng-click=\"vm.goToChangeRelatedPDVS()\">Sal&#245;es Vinculados</md-button></md-menu-item><md-divider></md-divider>\n<md-menu-item><md-button ng-click=\"vm.goToChangePassword()\">Seguran&#231;a</md-button></md-menu-item><md-divider>\n</md-divider><md-menu-item><md-button>{{version}}</md-button></md-menu-item><md-divider></md-divider><md-menu-item>\n<md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><md-menu \nmd-position-mode=\"left bottom\"><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\" \nng-if=\"false\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin \nmd-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu></md-menu></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" \nmd-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/main/subscription/extras/extras.html","<div id=\"price-tables\" class=\"page-layout simple fullwidth doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Assinaturas</span></div><div \nclass=\"title\">Extras</div></div></div><div class=\"content\"><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><div layout=\"column\"><strong>Quota Atual</strong><br>SMS: {{vm.SMSQuota}}<br>\n</div></div></div><div class=\"price-tables\" flex layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"price-table style-3 md-whiteframe-1dp\" layout=\"column\"><div class=\"package-type\"><div class=\"title\">200 SMS\n</div><div class=\"subtitle\">Para envio de lembretes, pesquisas, campanhas de marketing</div></div><div \nclass=\"price md-primary-bg md-hue-3\" layout=\"row\" layout-align=\"center start\" style=\"background-color:green\"><div \nclass=\"currency\" style=\"color:white\">R$</div><div layout=\"row\" layout-align=\"center end\"><div class=\"value\" \nstyle=\"color:white\">40</div></div></div><md-button class=\"cta-button md-raised md-accent\" \nstyle=\"background-color:green\" ng-click=\"vm.buy200()\">COMPRAR</md-button></div><div \nclass=\"price-table style-3 md-whiteframe-8dp\" layout=\"column\"><div class=\"package-type\"><div class=\"title\">500 SMS\n</div><div class=\"subtitle\">Para envio de lembretes, pesquisas, campanhas de marketing</div></div><div \nclass=\"price md-primary-bg\" layout=\"row\" layout-align=\"center start\" style=\"background-color:green\"><div \nclass=\"currency\" style=\"color:white\">R$</div><div layout=\"row\" layout-align=\"center end\"><div class=\"value\" \nstyle=\"color:white\">90</div></div></div><md-button class=\"cta-button md-raised md-accent\" ng-click=\"vm.buy500()\" \nstyle=\"background-color:green\">COMPRAR</md-button></div><div class=\"price-table style-3 md-whiteframe-1dp\" \nlayout=\"column\"><div class=\"package-type\"><div class=\"title\">1000 SMS</div><div class=\"subtitle\">\nPara envio de lembretes, pesquisas, campanhas de marketing</div></div><div class=\"price md-primary-bg md-hue-3\" \nlayout=\"row\" layout-align=\"center start\" style=\"background-color:green\"><div class=\"currency\" style=\"color:white\">R$\n</div><div layout=\"row\" layout-align=\"center end\"><div class=\"value\" style=\"color:white\">150</div></div></div>\n<md-button class=\"cta-button md-raised md-accent\" ng-click=\"vm.buy1000()\" style=\"background-color:green\">COMPRAR\n</md-button></div></div></div></div>");
$templateCache.put("app/main/subscription/price-table/congratulations.html","<div id=\"price-tables\" class=\"page-layout simple fullwidth doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Assinaturas</span></div><div \nclass=\"title\">Pagamento</div></div></div><div class=\"content\"><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><div layout=\"column\"><strong>\nVocê está quase lá. Para realizar o pagamento, clique agora no link abaixo.</strong><br><a ng-href=\"{{paymentLink}}\" \ntarget=\"_blank\" style=\"color: blue;fontWeight:\'bold\'\">Clique aqui para concluir sua assinatura</a><br></div></div>\n</div></div></div>");
$templateCache.put("app/main/subscription/price-table/price-tables.html","<div id=\"price-tables\" class=\"page-layout simple fullwidth doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Assinaturas</span></div><div \nclass=\"title\">Planos</div></div></div><div class=\"content\"><div class=\"content\" layout=\"column\" ng-if=\"false\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><div layout=\"column\"><strong>Plano Contratado Atualmente</strong><br>\nNome do Plano: {{plan}}<br>Válido até: {{validUntil | date:\'dd-MM-yyyy\'}}</div></div></div><div class=\"price-tables\" \nflex layout=\"row\" layout-align=\"start start\" layout-wrap><div class=\"price-table style-3 md-whiteframe-8dp\" \nlayout=\"column\"><div class=\"package-type\"><div class=\"title\">Web + App</div><div class=\"subtitle\">\nPara salões de todos os portes</div></div><div class=\"price md-primary-bg\" layout=\"row\" layout-align=\"center start\" \nstyle=\"background-color:green\"><div class=\"currency\" style=\"color:white\">R$</div><div layout=\"row\" \nlayout-align=\"center end\"><div class=\"value\" style=\"color:white\">119/mes</div><div class=\"period\" style=\"color:white\">\nplano mensal<br></div></div></div><div class=\"terms\" layout=\"column\" layout-align=\"start center\"><div class=\"term\">\nProfissionais ilimitados</div><div class=\"term\">Clientes ilimitados</div><div class=\"term\"><b>Agendamentos Ilimitados\n</b></div><div class=\"term\">Gestão de comandas/vendas</div><div class=\"term\">Campanhas de marketing</div><div \nclass=\"term\">Integração com App android</div><div class=\"term\">Marketing Boca a Boca</div><div class=\"term\">\nControle de Fidelidade</div><div class=\"term\">Parcerias</div><div class=\"term\">Controle de conta corrente</div><div \nclass=\"term\">Conta corrente do profissional</div><div class=\"term\">100% compatível com a lei do salão parceiro</div>\n<div class=\"term\">Relatórios</div></div><md-button class=\"cta-button md-raised md-accent\" ng-click=\"vm.buyMensal()\" \nstyle=\"background-color:green\" ng-disabled=\"vm.disableSubscriptionButton\">ASSINAR</md-button></div><div \nclass=\"price-table style-3 md-whiteframe-8dp\" layout=\"column\"><div class=\"package-type\"><div class=\"title\">Web + App\n</div><div class=\"subtitle\">Para salões de todos os portes</div></div><div class=\"price md-primary-bg\" layout=\"row\" \nlayout-align=\"center start\" style=\"background-color:green\"><div class=\"currency\" style=\"color:white\">R$</div><div \nlayout=\"row\" layout-align=\"center end\"><div class=\"value\" style=\"color:white\">99/mes</div><div class=\"period\" \nstyle=\"color:white\">plano semestral<br></div></div></div><div class=\"terms\" layout=\"column\" \nlayout-align=\"start center\"><div class=\"term\">Profissionais ilimitados</div><div class=\"term\">Clientes ilimitados</div>\n<div class=\"term\"><b>Agendamentos Ilimitados</b></div><div class=\"term\">Gestão de comandas/vendas</div><div \nclass=\"term\">Campanhas de marketing</div><div class=\"term\">Integração com App android</div><div class=\"term\">\nMarketing Boca a Boca</div><div class=\"term\">Controle de Fidelidade</div><div class=\"term\">Parcerias</div><div \nclass=\"term\">Controle de conta corrente</div><div class=\"term\">Conta corrente do profissional</div><div class=\"term\">\n100% compatível com a lei do salão parceiro</div><div class=\"term\">Relatórios</div></div><md-button \nclass=\"cta-button md-raised md-accent\" ng-click=\"vm.buySemestral()\" style=\"background-color:green\" \nng-disabled=\"vm.disableSubscriptionButton\">ASSINAR</md-button></div></div></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/marketing/content/photo/list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'MARKETING.HEADER\' | translate }}</span></div><div class=\"title\">{{ \'MARKETING.CONTENT.PHOTOS.HEADER\' | translate }}\n</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised md-orange-500-bg\" ngf-select \nng-model=\"vm.image\" name=\"file\" ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" ngf-max-size=\"3MB\" ngf-min-height=\"100\">\n{{ \'MARKETING.CONTENT.PHOTOS.NEW\' | translate }}</md-button></div></div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-4dp\"><div compile=\"vm.html\"></div></div></div></div>");
$templateCache.put("app/main/marketing/content/photo/slideshow.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\" ui-sref=\"app.dashboard\">\n</md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'ABOUT.SLIDESHOW\' | translate }}</span></div><div class=\"title\">{{vm.head}} {{ \'ABOUT.SLIDESHOW\' | translate }}\n</div></div></div><div class=\"content\" layout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\"><form \nname=\"basicForm\" class=\"md-inline-form\" ng-submit=\"vm.saveImage()\" novalidate><div layout=\"column\" layout-gt-sm=\"row\">\n<div class=\"button\" ngf-select ng-model=\"vm.image\" name=\"file\" ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" \nngf-max-size=\"1MB\" ngf-min-height=\"100\" ng-required=\"vm.eventId==undefined\">Click here to select image</div></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><div id=\"img_preview\" style=\"width: 250px\"></div></div><br><br><md-button \ntype=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\"><md-tooltip>\n{{\'APP.SAVE\'|translate}}</md-tooltip>{{ \'ABOUT.SAVE\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/marketing/content/about/about.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\" ui-sref=\"app.dashboard\">\n</md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'MARKETING.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'MARKETING.CONTENT.HEADER\' | translate }}</span></div><div class=\"title\">\n{{ \'MARKETING.CONTENT.ABOUT.HEADER\' | translate }}</div></div></div><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" ng-submit=\"vm.saveApp()\" \nnovalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"MARKETING.CONTENT.ABOUT.FIELDS.NAME\"></label><input type=\"text\" name=\"name\" ng-model=\"vm.name\" required><div\n ng-messages=\"basicForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'MARKETING.CONTENT.ABOUT.VALIDATION.NAME_REQUIRED\' | translate }}</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"MARKETING.CONTENT.ABOUT.FIELDS.ADDRESS\">\n</label><input type=\"text\" name=\"address\" ng-model=\"vm.address\" required><div ng-messages=\"basicForm.address.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{ \'MARKETING.CONTENT.ABOUT.VALIDATION.ADDRESS_REQUIRED\' | translate }}\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"MARKETING.CONTENT.ABOUT.FIELDS.TELEPHONE1\"></label><input type=\"text\" name=\"telephone1\" \nng-model=\"vm.telephone1\" required ng-pattern=\"/^[1-9]{2}[1-9][0-9]{7,8}$/\"><div \nng-messages=\"basicForm.telephone1.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'MARKETING.CONTENT.ABOUT.VALIDATION.TELEPHONE_REQUIRED\' | translate }}</span></div><div ng-message=\"pattern\"><span>\n{{ \'CUSTOMER.VALIDATION.TELEPHONE_INVALID\' | translate }}</span></div></div></md-input-container><md-input-container \nflex><label translate=\"MARKETING.CONTENT.ABOUT.FIELDS.TELEPHONE2\"></label><input type=\"text\" name=\"telephone2\" \nng-model=\"vm.telephone2\" ng-pattern=\"/^[1-9]{2}[1-9][0-9]{7,8}$/\"><div ng-messages=\"basicForm.telephone2.$error\" \nrole=\"alert\"><div ng-message=\"pattern\"><span>{{ \'CUSTOMER.VALIDATION.TELEPHONE_INVALID\' | translate }}</span></div>\n</div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"MARKETING.CONTENT.ABOUT.FIELDS.FACEBOOK\"></label><input type=\"text\" name=\"facebook\" ng-model=\"vm.facebook\">\n</md-input-container><md-input-container flex><label translate=\"MARKETING.CONTENT.ABOUT.FIELDS.INSTAGRAM\"></label>\n<input type=\"text\" name=\"instagram\" ng-model=\"vm.instagram\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"MARKETING.CONTENT.ABOUT.FIELDS.ABOUT\"></label><textarea \nname=\"about\" ng-model=\"vm.about\" required rows=\"5\" \nplaceholder=\"{{ \'MARKETING.CONTENT.ABOUT.HINT.ABOUT\' | translate }}\"></textarea><div \nng-messages=\"basicForm.about.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'MARKETING.CONTENT.ABOUT.VALIDATION.ABOUT_REQUIRED\' | translate }}</span></div></div></md-input-container></div>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">\n{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/marketing/content/location/location.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\" ui-sref=\"app.dashboard\">\n</md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'MARKETING.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'MARKETING.CONTENT.HEADER\' | translate }}</span></div><div class=\"title\">\n{{ \'MARKETING.CONTENT.LOCATION.HEADER\' | translate }}</div></div></div><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" ng-submit=\"vm.saveLocation()\" \nnovalidate><ui-gmap-google-map center=\"vm.map.center\" zoom=\"vm.map.zoom\" dragging=\"vm.map.dragging\" \nbounds=\"vm.map.bounds\" events=\"vm.map.events\" options=\"vm.map.options\" pan=\"true\" control=\"vm.googlemap\">\n<ui-gmap-marker coords=\"vm.map.marker.coords\" idkey=\"vm.map.marker.id\"></ui-gmap-marker></ui-gmap-google-map><md-button\n type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">\n{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/settings/account/businessinfo/businesshours.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'SETTINGS.ACCOUNT.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator\"></md-icon><span class=\"parent\">{{ \'SETTINGS.ACCOUNT.BUSINESSINFORMATION.HEADER\' | translate }}\n</span></div><div class=\"title\">{{ \'SETTINGS.ACCOUNT.BUSINESSINFORMATION.BUSINESSHOURS.HEADER\' | translate }}</div>\n</div></div><div class=\"content\" layout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.saveBusinessHours()\" novalidate><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"GENERAL.DAYOFWEEK.MONDAY\"></label></md-input-container><md-input-container \nflex><md-radio-group ng-model=\"vm.businessinfo.openMonday\"><md-radio-button data-value=\"OPEN\" aria-label=\"OPEN\"><span \ntranslate=\"GENERAL.OPEN\"></span></md-radio-button><md-radio-button data-value=\"CLOSED\" aria-label=\"CLOSED\"><span \ntranslate=\"GENERAL.CLOSED\"></span></md-radio-button></md-radio-group></md-input-container><md-input-container flex>\n<label translate=\"GENERAL.OPENTIME\"></label><md-select name=\"openTimeMonday\" ng-model=\"vm.businessinfo.openTimeMonday\" \nng-disabled=\"vm.businessinfo.openMonday!=\'OPEN\'\"><md-option ng-repeat=\"item in vm.timetable\" \ndata-value=\"{{item.value}}\">{{item.text}}</md-option></md-select></md-input-container><md-input-container flex><label \ntranslate=\"GENERAL.CLOSETIME\"></label><md-select name=\"closeTimeMonday\" ng-model=\"vm.businessinfo.closeTimeMonday\" \nng-disabled=\"vm.businessinfo.openMonday!=\'OPEN\'\"><md-option ng-repeat=\"item in vm.timetable\" \ndata-value=\"{{item.value}}\">{{item.text}}</md-option></md-select></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"GENERAL.DAYOFWEEK.TUESDAY\"></label></md-input-container>\n<md-input-container flex><md-radio-group ng-model=\"vm.businessinfo.openTuesday\"><md-radio-button data-value=\"OPEN\" \naria-label=\"OPEN\"><span translate=\"GENERAL.OPEN\"></span></md-radio-button><md-radio-button data-value=\"CLOSED\" \naria-label=\"CLOSED\"><span translate=\"GENERAL.CLOSED\"></span></md-radio-button></md-radio-group></md-input-container>\n<md-input-container flex><label translate=\"GENERAL.OPENTIME\"></label><md-select \nng-model=\"vm.businessinfo.openTimeTuesday\" ng-disabled=\"vm.businessinfo.openTuesday!=\'OPEN\'\"><md-option \nng-repeat=\"item in vm.timetable\" data-value=\"{{item.value}}\">{{item.text}}</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"GENERAL.CLOSETIME\"></label><md-select \nng-model=\"vm.businessinfo.closeTimeTuesday\" ng-disabled=\"vm.businessinfo.openTuesday!=\'OPEN\'\"><md-option \nng-repeat=\"item in vm.timetable\" data-value=\"{{item.value}}\">{{item.text}}</md-option></md-select></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"GENERAL.DAYOFWEEK.WEDNESDAY\">\n</label></md-input-container><md-input-container flex><md-radio-group ng-model=\"vm.businessinfo.openWednesday\">\n<md-radio-button data-value=\"OPEN\" aria-label=\"OPEN\"><span translate=\"GENERAL.OPEN\"></span></md-radio-button>\n<md-radio-button data-value=\"CLOSED\" aria-label=\"CLOSED\"><span translate=\"GENERAL.CLOSED\"></span></md-radio-button>\n</md-radio-group></md-input-container><md-input-container flex><label translate=\"GENERAL.OPENTIME\"></label><md-select \nng-model=\"vm.businessinfo.openTimeWednesday\" ng-disabled=\"vm.businessinfo.openWednesday!=\'OPEN\'\"><md-option \nng-repeat=\"item in vm.timetable\" data-value=\"{{item.value}}\">{{item.text}}</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"GENERAL.CLOSETIME\"></label><md-select \nng-model=\"vm.businessinfo.closeTimeWednesday\" ng-disabled=\"vm.businessinfo.openWednesday!=\'OPEN\'\"><md-option \nng-repeat=\"item in vm.timetable\" data-value=\"{{item.value}}\">{{item.text}}</md-option></md-select></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"GENERAL.DAYOFWEEK.THURSDAY\">\n</label></md-input-container><md-input-container flex><md-radio-group ng-model=\"vm.businessinfo.openThursday\">\n<md-radio-button data-value=\"OPEN\" aria-label=\"OPEN\"><span translate=\"GENERAL.OPEN\"></span></md-radio-button>\n<md-radio-button data-value=\"CLOSED\" aria-label=\"CLOSED\"><span translate=\"GENERAL.CLOSED\"></span></md-radio-button>\n</md-radio-group></md-input-container><md-input-container flex><label translate=\"GENERAL.OPENTIME\"></label><md-select \nng-model=\"vm.businessinfo.openTimeThursday\" ng-disabled=\"vm.businessinfo.openThursday!=\'OPEN\'\"><md-option \nng-repeat=\"item in vm.timetable\" data-value=\"{{item.value}}\">{{item.text}}</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"GENERAL.CLOSETIME\"></label><md-select \nng-model=\"vm.businessinfo.closeTimeThursday\" ng-disabled=\"vm.businessinfo.openThursday!=\'OPEN\'\"><md-option \nng-repeat=\"item in vm.timetable\" data-value=\"{{item.value}}\">{{item.text}}</md-option></md-select></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"GENERAL.DAYOFWEEK.FRIDAY\">\n</label></md-input-container><md-input-container flex><md-radio-group ng-model=\"vm.businessinfo.openFriday\">\n<md-radio-button data-value=\"OPEN\" aria-label=\"OPEN\"><span translate=\"GENERAL.OPEN\"></span></md-radio-button>\n<md-radio-button data-value=\"CLOSED\" aria-label=\"CLOSED\"><span translate=\"GENERAL.CLOSED\"></span></md-radio-button>\n</md-radio-group></md-input-container><md-input-container flex><label translate=\"GENERAL.OPENTIME\"></label><md-select \nng-model=\"vm.businessinfo.openTimeFriday\" ng-disabled=\"vm.businessinfo.openFriday!=\'OPEN\'\"><md-option \nng-repeat=\"item in vm.timetable\" data-value=\"{{item.value}}\">{{item.text}}</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"GENERAL.CLOSETIME\"></label><md-select \nng-model=\"vm.businessinfo.closeTimeFriday\" ng-disabled=\"vm.businessinfo.openFriday!=\'OPEN\'\"><md-option \nng-repeat=\"item in vm.timetable\" data-value=\"{{item.value}}\">{{item.text}}</md-option></md-select></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"GENERAL.DAYOFWEEK.SATURDAY\">\n</label></md-input-container><md-input-container flex><md-radio-group ng-model=\"vm.businessinfo.openSaturday\">\n<md-radio-button data-value=\"OPEN\" aria-label=\"OPEN\"><span translate=\"GENERAL.OPEN\"></span></md-radio-button>\n<md-radio-button data-value=\"CLOSED\" aria-label=\"CLOSED\"><span translate=\"GENERAL.CLOSED\"></span></md-radio-button>\n</md-radio-group></md-input-container><md-input-container flex><label translate=\"GENERAL.OPENTIME\"></label><md-select \nng-model=\"vm.businessinfo.openTimeSaturday\" ng-disabled=\"vm.businessinfo.openSaturday!=\'OPEN\'\"><md-option \nng-repeat=\"item in vm.timetable\" data-value=\"{{item.value}}\">{{item.text}}</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"GENERAL.CLOSETIME\"></label><md-select \nng-model=\"vm.businessinfo.closeTimeSaturday\" ng-disabled=\"vm.businessinfo.openSaturday!=\'OPEN\'\"><md-option \nng-repeat=\"item in vm.timetable\" data-value=\"{{item.value}}\">{{item.text}}</md-option></md-select></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"GENERAL.DAYOFWEEK.SUNDAY\">\n</label></md-input-container><md-input-container flex><md-radio-group ng-model=\"vm.businessinfo.openSunday\">\n<md-radio-button data-value=\"OPEN\" aria-label=\"OPEN\"><span translate=\"GENERAL.OPEN\"></span></md-radio-button>\n<md-radio-button data-value=\"CLOSED\" aria-label=\"CLOSED\"><span translate=\"GENERAL.CLOSED\"></span></md-radio-button>\n</md-radio-group></md-input-container><md-input-container flex><label translate=\"GENERAL.OPENTIME\"></label><md-select \nng-model=\"vm.businessinfo.openTimeSunday\" ng-disabled=\"vm.businessinfo.openSunday!=\'OPEN\'\"><md-option \nng-repeat=\"item in vm.timetable\" data-value=\"{{item.value}}\">{{item.text}}</md-option></md-select></md-input-container>\n<md-input-container flex><label translate=\"GENERAL.CLOSETIME\"></label><md-select \nng-model=\"vm.businessinfo.closeTimeSunday\" ng-disabled=\"vm.businessinfo.openSunday!=\'OPEN\'\"><md-option \nng-repeat=\"item in vm.timetable\" data-value=\"{{item.value}}\">{{item.text}}</md-option></md-select></md-input-container>\n</div><md-button type=\"submit\" class=\"md-raised\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">\n{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/settings/account/user/changeMyInfo.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'SETTINGS.ACCOUNT.HEADER\' | translate }}</span></div><div class=\"title\">\n{{ \'SETTINGS.ACCOUNT.CHANGEPASSWORD.HEADER\' | translate }}</div></div></div><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" ng-submit=\"vm.changeMyInfo()\" \nnovalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"SETTINGS.ACCOUNT.USER.FIELDS.NAME\"></label><input type=\"text\" name=\"name\" ng-model=\"vm.user.name\" required>\n<div ng-messages=\"basicForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'SETTINGS.ACCOUNT.USER.VALIDATION.NAME_REQUIRED\' | translate }}</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"SETTINGS.ACCOUNT.USER.FIELDS.PASSWORD\">\n</label><input type=\"password\" name=\"password\" ng-model=\"vm.user.password\" required><div \nng-messages=\"basicForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'SETTINGS.ACCOUNT.USER.VALIDATION.PASSWORD_REQUIRED\' | translate }}</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"SETTINGS.ACCOUNT.USER.FIELDS.PASSWORD2\"></label><input type=\"password\" \nname=\"password2\" ng-model=\"vm.user.password2\" required ng-pattern=\"{{vm.user.password}}\"><div \nng-messages=\"basicForm.password2.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'SETTINGS.ACCOUNT.USER.VALIDATION.PASSWORD2_REQUIRED\' | translate }}</span></div><div ng-message=\"pattern\"><span>\n{{ \'SETTINGS.ACCOUNT.USER.VALIDATION.PASSWORD2_INVALID\' | translate }}</span></div></div></md-input-container></div>\n<md-button type=\"submit\" class=\"md-raised\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">\n{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button><md-button type=\"button\" class=\"md-raised md-warn\" \naria-label=\"Cancel\" ui-sref=\"app.settings.account.user.list\">{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button>\n</form></div></div></div>");
$templateCache.put("app/main/settings/account/user/editUser.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'SETTINGS.ACCOUNT.HEADER\' | translate }}</span></div><div class=\"title\">\n{{ \'SETTINGS.ACCOUNT.USER.HEADER\' | translate }}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised\" ui-sref=\"app.settings.account.user.new\">{{ \'SETTINGS.ACCOUNT.USER.NEW\' | translate }}</md-button>\n<md-button class=\"md-raised gp-mini\" ng-click=\"showHelp(\'user\');\">?<md-tooltip aria-label=\"Pencil\">Vídeo Explicativo\n</md-tooltip></md-button></div></div><div class=\"content\" layout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\">\n<form name=\"basicForm\" class=\"md-inline-form\" ng-submit=\"vm.saveUser()\" novalidate><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"SETTINGS.ACCOUNT.USER.FIELDS.TYPE\"></label><md-select \nname=\"type\" ng-model=\"vm.user.type\" required=\"\" ng-disabled=\"vm.user.id!=undefined || vm.user.type ==\'MASTER\'\">\n<md-option data-value=\"ADMIN\">{{ \'GENERAL.USERTYPES.ADMIN\' | translate }}</md-option><md-option \ndata-value=\"RECEPCIONIST\">{{ \'GENERAL.USERTYPES.RECEPCIONIST\' | translate }}</md-option><md-option \ndata-value=\"PROFESSIONAL\">{{ \'GENERAL.USERTYPES.PROFESSIONAL\' | translate }}</md-option></md-select><div \nng-messages=\"basicForm.type.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'SETTINGS.ACCOUNT.USER.VALIDATION.TYPE_REQUIRED\' | translate }}</span></div></div></md-input-container>\n<md-input-container flex ng-if=\"vm.user.type == \'PROFESSIONAL\'\"><label \ntranslate=\"SETTINGS.ACCOUNT.USER.FIELDS.PROFESSIONAL\"></label><md-select name=\"professional\" \nng-model=\"vm.user.professionalId\" ng-required=\"vm.user.type == \'PROFESSIONAL\'\" ng-disabled=\"vm.user.id!=undefined\">\n<md-option ng-value=\"item._id\" ng-repeat=\"item in vm.professionals\">{{item.name}}</md-option></md-select>\n</md-input-container></div><md-button type=\"submit\" class=\"md-raised\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid\">{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button><md-button type=\"button\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\" ui-sref=\"app.settings.account.user.list\">\n{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/settings/account/user/inviteUser.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'SETTINGS.ACCOUNT.HEADER\' | translate }}</span></div><div class=\"title\">\n{{ \'SETTINGS.ACCOUNT.USER.HEADER\' | translate }}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised\" ui-sref=\"app.settings.account.user.new\">{{ \'SETTINGS.ACCOUNT.USER.NEW\' | translate }}</md-button>\n<md-button class=\"md-raised gp-mini\" ng-click=\"showHelp(\'user\');\">?<md-tooltip aria-label=\"Pencil\">Vídeo Explicativo\n</md-tooltip></md-button></div></div><div class=\"content\" layout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\">\n<form name=\"basicForm\" class=\"md-inline-form\" ng-submit=\"vm.saveUser()\" novalidate><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"SETTINGS.ACCOUNT.USER.FIELDS.EMAIL\"></label><input \ntype=\"text\" name=\"login\" ng-model=\"vm.user.login\" required ng-disabled=\"vm.user.id!=undefined\"><div \nng-messages=\"basicForm.login.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'SETTINGS.ACCOUNT.USER.VALIDATION.EMAIL_REQUIRED\' | translate }}</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"SETTINGS.ACCOUNT.USER.FIELDS.TYPE\"></label><md-select name=\"type\" \nng-model=\"vm.user.type\" required=\"\" ng-disabled=\"vm.user.id!=undefined || vm.user.type ==\'MASTER\'\"><md-option \ndata-value=\"ADMIN\">{{ \'GENERAL.USERTYPES.ADMIN\' | translate }}</md-option><md-option data-value=\"RECEPCIONIST\">\n{{ \'GENERAL.USERTYPES.RECEPCIONIST\' | translate }}</md-option><md-option data-value=\"PROFESSIONAL\">\n{{ \'GENERAL.USERTYPES.PROFESSIONAL\' | translate }}</md-option></md-select><div ng-messages=\"basicForm.type.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{ \'SETTINGS.ACCOUNT.USER.VALIDATION.TYPE_REQUIRED\' | translate }}</span>\n</div></div></md-input-container><md-input-container flex ng-if=\"vm.user.type == \'PROFESSIONAL\'\"><label \ntranslate=\"SETTINGS.ACCOUNT.USER.FIELDS.PROFESSIONAL\"></label><md-select name=\"professional\" \nng-model=\"vm.user.professionalId\" ng-required=\"vm.user.type == \'PROFESSIONAL\'\" ng-disabled=\"vm.user.id!=undefined\">\n<md-option ng-value=\"item._id\" ng-repeat=\"item in vm.professionals\">{{item.name}}</md-option></md-select>\n</md-input-container></div><md-button type=\"submit\" class=\"md-raised\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid\">{{ \'GENERAL.BUTTON.INVITE\' | translate }}</md-button><md-button type=\"button\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\" ui-sref=\"app.settings.account.user.list\">\n{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/settings/account/user/list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'SETTINGS.ACCOUNT.HEADER\' | translate }}</span></div><div class=\"title\">\n{{ \'SETTINGS.ACCOUNT.USER.HEADER\' | translate }}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised\" ui-sref=\"app.settings.account.user.new\">{{ \'SETTINGS.ACCOUNT.USER.NEW\' | translate }}</md-button>\n<md-button class=\"md-raised gp-mini\" ng-click=\"showHelp(\'user\');\">?<md-tooltip aria-label=\"Pencil\">Vídeo Explicativo\n</md-tooltip></md-button></div></div><div class=\"content\"><div class=\"white-bg md-whiteframe-40dp\" layout=\"row\" \nlayout-align=\"center center\" height=\"100px\" ng-show=\"!vm.showTable\"><br><span \nstyle=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></div><div class=\"white-bg md-whiteframe-4dp\" \nng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \ndt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{ \'SETTINGS.ACCOUNT.USER.LOGIN\' | translate }}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'SETTINGS.ACCOUNT.USER.TYPE\' | translate }}</span></div></th><th>\n</th></tr></thead><tbody><tr ng-repeat=\"user in ::vm.users\"><td>{{ user.login }}</td><td>{{ user.typeStr }}</td><td \nalign=\"right\"><md-button aria-label=\"Pencil\" class=\"md-raised gp-mini\" ng-click=\"vm.editUser(user.id)\"><md-tooltip \naria-label=\"Pencil\">{{ \'GENERAL.HINTS.EDIT\' | translate }}</md-tooltip><i class=\"icon-pencil\" layout=\"center\"></i>\n</md-button><md-button aria-label=\"Trash\" class=\"md-raised md-warn gp-mini\" ng-click=\"vm.removeUser(user.id)\" \nng-show=\"user.type!=\'MASTER\'\"><md-tooltip aria-label=\"Pencil\">{{ \'GENERAL.HINTS.TRASH\' | translate }}</md-tooltip><i \nclass=\"icon-trash\" layout=\"center\"></i></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/settings/account/user/user.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'SETTINGS.ACCOUNT.HEADER\' | translate }}</span></div><div class=\"title\">\n{{ \'SETTINGS.ACCOUNT.USER.HEADER\' | translate }}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised gp-mini\" ng-click=\"showHelp(\'user\');\">?<md-tooltip aria-label=\"Pencil\">Vídeo Explicativo</md-tooltip>\n</md-button></div></div><div class=\"content\" layout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\"><form \nname=\"basicForm\" class=\"md-inline-form\" ng-submit=\"vm.saveUser()\" novalidate><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"SETTINGS.ACCOUNT.USER.FIELDS.LOGIN\"></label><input type=\"text\" name=\"login\" \nng-model=\"vm.user.login\" ng-blur=\"vm.checkUserName()\" required ng-disabled=\"vm.user.id!=undefined\"><div \nng-messages=\"basicForm.login.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'SETTINGS.ACCOUNT.USER.VALIDATION.EMAIL_REQUIRED\' | translate }}</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"SETTINGS.ACCOUNT.USER.FIELDS.TYPE\"></label><md-select name=\"type\" \nng-model=\"vm.user.type\" required=\"\" ng-disabled=\"vm.user.id!=undefined || vm.user.type ==\'MASTER\'\"><md-option \ndata-value=\"ADMIN\">{{ \'GENERAL.USERTYPES.ADMIN\' | translate }}</md-option><md-option data-value=\"RECEPCIONIST\">\n{{ \'GENERAL.USERTYPES.RECEPCIONIST\' | translate }}</md-option><md-option data-value=\"PROFESSIONAL\">\n{{ \'GENERAL.USERTYPES.PROFESSIONAL\' | translate }}</md-option></md-select><div ng-messages=\"basicForm.type.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{ \'SETTINGS.ACCOUNT.USER.VALIDATION.TYPE_REQUIRED\' | translate }}</span>\n</div></div></md-input-container><md-input-container flex ng-if=\"vm.user.type == \'PROFESSIONAL\'\"><label \ntranslate=\"SETTINGS.ACCOUNT.USER.FIELDS.PROFESSIONAL\"></label><md-select name=\"professional\" \nng-model=\"vm.user.professionalId\" ng-required=\"vm.user.type == \'PROFESSIONAL\'\" ng-disabled=\"vm.user.id!=undefined\">\n<md-option ng-value=\"item._id\" ng-repeat=\"item in vm.professionals\">{{item.name}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"SETTINGS.ACCOUNT.USER.FIELDS.NAME\"></label><input type=\"text\" name=\"name\" ng-model=\"vm.user.name\" required \nng-readonly=\"vm.userExist\" ng-disabled=\"vm.userExist\"><div ng-messages=\"basicForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{ \'SETTINGS.ACCOUNT.USER.VALIDATION.NAME_REQUIRED\' | translate }}</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"!vm.userExist\"><md-input-container flex>\n<label translate=\"SETTINGS.ACCOUNT.USER.FIELDS.PASSWORD\"></label><input type=\"password\" name=\"password\" \nng-model=\"vm.user.password\" required><div ng-messages=\"basicForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{ \'SETTINGS.ACCOUNT.USER.VALIDATION.PASSWORD_REQUIRED\' | translate }}</span></div></div>\n</md-input-container><md-input-container flex><label translate=\"SETTINGS.ACCOUNT.USER.FIELDS.PASSWORD2\"></label><input \ntype=\"password\" name=\"password2\" ng-model=\"vm.user.password2\" required ng-pattern=\"{{vm.user.password}}\"><div \nng-messages=\"basicForm.password2.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'SETTINGS.ACCOUNT.USER.VALIDATION.PASSWORD2_REQUIRED\' | translate }}</span></div><div ng-message=\"pattern\"><span>\n{{ \'SETTINGS.ACCOUNT.USER.VALIDATION.PASSWORD2_INVALID\' | translate }}</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"SETTINGS.ACCOUNT.USER.FIELDS.ACCESS_CODE\"></label><input type=\"password\" \nname=\"accessCode\" ng-model=\"vm.user.accessCode\"></md-input-container></div><md-button type=\"submit\" class=\"md-raised\" \naria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button><md-button \ntype=\"button\" class=\"md-raised md-warn\" aria-label=\"Cancel\" ui-sref=\"app.settings.account.user.list\">\n{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/settings/content/photo/list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'MARKETING.HEADER\' | translate }}</span></div><div class=\"title\">{{ \'MARKETING.CONTENT.PHOTOS.HEADER\' | translate }}\n</div></div><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised md-orange-500-bg\" ngf-select \nng-model=\"vm.image\" name=\"file\" ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" ngf-max-size=\"3MB\" ngf-min-height=\"100\">\n{{ \'MARKETING.CONTENT.PHOTOS.NEW\' | translate }}</md-button></div></div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-4dp\"><div compile=\"vm.html\"></div></div></div></div>");
$templateCache.put("app/main/settings/content/photo/slideshow.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\" ui-sref=\"app.dashboard\">\n</md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'ABOUT.SLIDESHOW\' | translate }}</span></div><div class=\"title\">{{vm.head}} {{ \'ABOUT.SLIDESHOW\' | translate }}\n</div></div></div><div class=\"content\" layout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\"><form \nname=\"basicForm\" class=\"md-inline-form\" ng-submit=\"vm.saveImage()\" novalidate><div layout=\"column\" layout-gt-sm=\"row\">\n<div class=\"button\" ngf-select ng-model=\"vm.image\" name=\"file\" ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" \nngf-max-size=\"1MB\" ngf-min-height=\"100\" ng-required=\"vm.eventId==undefined\">Click here to select image</div></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><div id=\"img_preview\" style=\"width: 250px\"></div></div><br><br><md-button \ntype=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\"><md-tooltip>\n{{\'APP.SAVE\'|translate}}</md-tooltip>{{ \'ABOUT.SAVE\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/settings/content/location/location.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\" ui-sref=\"app.dashboard\">\n</md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'MARKETING.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'MARKETING.CONTENT.HEADER\' | translate }}</span></div><div class=\"title\">\n{{ \'MARKETING.CONTENT.LOCATION.HEADER\' | translate }}</div></div></div><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" ng-submit=\"vm.saveLocation()\" \nnovalidate><ui-gmap-google-map center=\"vm.map.center\" zoom=\"vm.map.zoom\" dragging=\"vm.map.dragging\" \nbounds=\"vm.map.bounds\" events=\"vm.map.events\" options=\"vm.map.options\" pan=\"true\" control=\"vm.googlemap\">\n<ui-gmap-marker coords=\"vm.map.marker.coords\" idkey=\"vm.map.marker.id\"></ui-gmap-marker></ui-gmap-google-map><md-button\n type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">\n{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/settings/content/about/about.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\" ui-sref=\"app.dashboard\">\n</md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'MARKETING.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'MARKETING.CONTENT.HEADER\' | translate }}</span></div><div class=\"title\">\n{{ \'MARKETING.CONTENT.ABOUT.HEADER\' | translate }}</div></div></div><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" ng-submit=\"vm.saveApp()\" \nnovalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"MARKETING.CONTENT.ABOUT.FIELDS.NAME\"></label><input type=\"text\" name=\"name\" ng-model=\"vm.name\" required><div\n ng-messages=\"basicForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'MARKETING.CONTENT.ABOUT.VALIDATION.NAME_REQUIRED\' | translate }}</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"MARKETING.CONTENT.ABOUT.FIELDS.ADDRESS\">\n</label><input type=\"text\" name=\"address\" ng-model=\"vm.address\" required><div ng-messages=\"basicForm.address.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{ \'MARKETING.CONTENT.ABOUT.VALIDATION.ADDRESS_REQUIRED\' | translate }}\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"MARKETING.CONTENT.ABOUT.FIELDS.TELEPHONE1\"></label><input type=\"text\" name=\"telephone1\" \nng-model=\"vm.telephone1\" required ng-pattern=\"/^[1-9]{2}[1-9][0-9]{7,8}$/\"><div \nng-messages=\"basicForm.telephone1.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'MARKETING.CONTENT.ABOUT.VALIDATION.TELEPHONE_REQUIRED\' | translate }}</span></div><div ng-message=\"pattern\"><span>\n{{ \'CUSTOMER.VALIDATION.TELEPHONE_INVALID\' | translate }}</span></div></div></md-input-container><md-input-container \nflex><label translate=\"MARKETING.CONTENT.ABOUT.FIELDS.TELEPHONE2\"></label><input type=\"text\" name=\"telephone2\" \nng-model=\"vm.telephone2\" ng-pattern=\"/^[1-9]{2}[1-9][0-9]{7,8}$/\"><div ng-messages=\"basicForm.telephone2.$error\" \nrole=\"alert\"><div ng-message=\"pattern\"><span>{{ \'CUSTOMER.VALIDATION.TELEPHONE_INVALID\' | translate }}</span></div>\n</div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"MARKETING.CONTENT.ABOUT.FIELDS.FACEBOOK\"></label><input type=\"text\" name=\"facebook\" ng-model=\"vm.facebook\">\n</md-input-container><md-input-container flex><label translate=\"MARKETING.CONTENT.ABOUT.FIELDS.INSTAGRAM\"></label>\n<input type=\"text\" name=\"instagram\" ng-model=\"vm.instagram\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"MARKETING.CONTENT.ABOUT.FIELDS.ABOUT\"></label><textarea \nname=\"about\" ng-model=\"vm.about\" required rows=\"5\" \nplaceholder=\"{{ \'MARKETING.CONTENT.ABOUT.HINT.ABOUT\' | translate }}\"></textarea><div \nng-messages=\"basicForm.about.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'MARKETING.CONTENT.ABOUT.VALIDATION.ABOUT_REQUIRED\' | translate }}</span></div></div></md-input-container></div>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">\n{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/settings/product/product/list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'SETTINGS.PRODUCT.HEADER\' | translate }}</span></div><div class=\"title\">\n{{ \'SETTINGS.PRODUCT.PRODUCT.HEADER\' | translate }}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button\n class=\"md-raised\" ui-sref=\"app.settings.product.product.new\">{{ \'SETTINGS.PRODUCT.PRODUCT.NEW\' | translate }}\n</md-button></div></div><div class=\"content\"><div class=\"white-bg md-whiteframe-40dp\" layout=\"row\" \nlayout-align=\"center center\" height=\"100px\" ng-show=\"!vm.showTable\"><br><span \nstyle=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></div><div class=\"white-bg md-whiteframe-4dp\" \nng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'SETTINGS.PRODUCT.PRODUCT.NAME\' | translate }}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'SETTINGS.PRODUCT.PRODUCT.CATEGORY\' | translate }}</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'SETTINGS.PRODUCT.PRODUCT.PRICE\' | translate }}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'SETTINGS.PRODUCT.PRODUCT.COST\' | translate }}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'SETTINGS.PRODUCT.PRODUCT.COMISSION\' | translate }}</span></div></th><th></th></tr></thead><tbody><tr \nng-repeat=\"product in ::vm.products\"><td>{{ product.name }}</td><td>{{ product.category.name }}</td><td>\n{{ product.price }}</td><td>{{ product.cost }}</td><td>{{ product.comission }}</td><td align=\"right\"><md-button \naria-label=\"Pencil\" class=\"md-raised gp-mini\" ng-click=\"vm.editProduct(product._id)\"><md-tooltip aria-label=\"Pencil\">\n{{ \'GENERAL.HINTS.EDIT\' | translate }}</md-tooltip><i class=\"icon-pencil\" layout=\"center\"></i></md-button><md-button \naria-label=\"Trash\" class=\"md-raised md-warn gp-mini\" ng-click=\"vm.removeProduct(product._id)\"><md-tooltip \naria-label=\"Pencil\">{{ \'GENERAL.HINTS.TRASH\' | translate }}</md-tooltip><i class=\"icon-trash\" layout=\"center\"></i>\n</md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/settings/product/product/product.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><a\n href=\"#\" ui-sref=\"app.settings.product.product.list\" style=\"color:black\"><span class=\"parent\">\n{{ \'SETTINGS.PRODUCT.HEADER\' | translate }}</span></a></div><div class=\"title\">\n{{ \'SETTINGS.PRODUCT.PRODUCT.HEADER\' | translate }}</div></div></div><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" ng-submit=\"vm.saveProduct()\" \nnovalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"SETTINGS.PRODUCT.PRODUCT.FIELDS.NAME\"></label><input type=\"text\" name=\"name\" ng-model=\"vm.product.name\" \nrequired><div ng-messages=\"basicForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'SETTINGS.PRODUCT.PRODUCT.VALIDATION.NAME_REQUIRED\' | translate }}</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"SETTINGS.PRODUCT.PRODUCT.FIELDS.CATEGORY\"></label><md-select \nname=\"category\" ng-model=\"vm.product.categoryId\" required=\"\"><md-option ng-value=\"item._id\" \nng-repeat=\"item in vm.categories\">{{item.name}}</md-option></md-select><div ng-messages=\"basicForm.category.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{ \'SETTINGS.PRODUCT.PRODUCT.VALIDATION.CATEGORY_REQUIRED\' | translate }}\n</span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"SETTINGS.PRODUCT.PRODUCT.FIELDS.COST\"></label><input type=\"number\" name=\"cost\" ng-model=\"vm.product.cost\" \nmin=\"0\" required><div ng-messages=\"basicForm.cost.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'SETTINGS.PRODUCT.PRODUCT.VALIDATION.COST_REQUIRED\' | translate }}</span></div></div></md-input-container></div><div\n layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"SETTINGS.PRODUCT.PRODUCT.FIELDS.PRICE\">\n</label><input type=\"number\" name=\"price\" ng-model=\"vm.product.price\" min=\"0\" required><div \nng-messages=\"basicForm.price.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'SETTINGS.PRODUCT.PRODUCT.VALIDATION.PRICE_REQUIRED\' | translate }}</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"SETTINGS.PRODUCT.PRODUCT.FIELDS.CASH_PRICE\"></label><input type=\"number\" \nname=\"price\" ng-model=\"vm.product.cashPrice\" min=\"0\" required><div ng-messages=\"basicForm.price.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>{{ \'SETTINGS.PRODUCT.PRODUCT.VALIDATION.CASH_PRICE_REQUIRED\' | translate }}</span>\n</div></div></md-input-container><md-input-container flex><label \ntranslate=\"SETTINGS.PRODUCT.PRODUCT.FIELDS.COMISSION_PRICE\"></label><input type=\"number\" name=\"price\" \nng-model=\"vm.product.comissionPrice\" min=\"0\" required><div ng-messages=\"basicForm.price.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{ \'SETTINGS.PRODUCT.PRODUCT.VALIDATION.COMISSION_PRICE_REQUIRED\' | translate }}</span>\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"SETTINGS.PRODUCT.PRODUCT.FIELDS.COMISSION\"></label><input type=\"number\" name=\"comission\" \nng-model=\"vm.product.comission\" min=\"0\" required><div ng-messages=\"basicForm.comission.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{ \'SETTINGS.PRODUCT.PRODUCT.VALIDATION.COMISSION_REQUIRED\' | translate }}</span></div>\n</div></md-input-container><md-input-container flex><label translate=\"SETTINGS.PRODUCT.PRODUCT.FIELDS.MINQTY\"></label>\n<input type=\"number\" name=\"minQty\" ng-model=\"vm.product.minQty\" min=\"0\" required><div \nng-messages=\"basicForm.minQty.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'SETTINGS.PRODUCT.PRODUCT.VALIDATION.MINQTY_REQUIRED\' | translate }}</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"SETTINGS.PRODUCT.PRODUCT.FIELDS.MAXQTY\"></label><input type=\"number\" \nname=\"maxQty\" ng-model=\"vm.product.maxQty\" min=\"0\" required><div ng-messages=\"basicForm.maxQty.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>{{ \'SETTINGS.PRODUCT.PRODUCT.VALIDATION.MAXQTY_REQUIRED\' | translate }}</span></div>\n</div></md-input-container></div><md-button type=\"submit\" class=\"md-raised\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid\">{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button><md-button type=\"button\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\" ui-sref=\"app.settings.product.product.list\">\n{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/settings/product/category/category.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'SETTINGS.PRODUCT.HEADER\' | translate }}</span></div><div class=\"title\">\n{{ \'SETTINGS.PRODUCT.CATEGORY.HEADER\' | translate }}</div></div></div><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" ng-submit=\"vm.saveCategory()\" \nnovalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"SETTINGS.PRODUCT.CATEGORY.FIELDS.NAME\"></label><input type=\"text\" name=\"name\" ng-model=\"vm.category.name\" \nrequired><div ng-messages=\"basicForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'SETTINGS.PRODUCT.CATEGORY.VALIDATION.NAME_REQUIRED\' | translate }}</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"SETTINGS.PRODUCT.CATEGORY.FIELDS.ORDER\"></label><input type=\"number\" \nname=\"order\" ng-model=\"vm.category.order\"> <span style=\"font-size: 11px\">\n{{ \'SETTINGS.PRODUCT.CATEGORY.HINTS.ORDER\' | translate }}</span></md-input-container></div><md-button type=\"submit\" \nclass=\"md-raised\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">{{ \'GENERAL.BUTTON.SAVE\' | translate }}\n</md-button><md-button type=\"button\" class=\"md-raised md-warn\" aria-label=\"Cancel\" \nui-sref=\"app.settings.product.category.list\">{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button></form></div></div>\n</div>");
$templateCache.put("app/main/settings/product/category/list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'SETTINGS.PRODUCT.HEADER\' | translate }}</span></div><div class=\"title\">\n{{ \'SETTINGS.PRODUCT.CATEGORY.HEADER\' | translate }}</div></div><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-raised\" ui-sref=\"app.settings.product.category.new\">\n{{ \'SETTINGS.PRODUCT.CATEGORY.NEW\' | translate }}</md-button></div></div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-40dp\" layout=\"row\" layout-align=\"center center\" height=\"100px\" ng-show=\"!vm.showTable\">\n<br><span style=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></div><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'SETTINGS.PRODUCT.CATEGORY.NAME\' | translate }}</span></div></th>\n<th></th></tr></thead><tbody><tr ng-repeat=\"category in ::vm.categories\"><td>{{ category.name }}</td><td align=\"right\">\n<md-button aria-label=\"Pencil\" class=\"md-raised gp-mini\" ng-click=\"vm.editCategory(category._id)\"><md-tooltip \naria-label=\"Pencil\">{{ \'GENERAL.HINTS.EDIT\' | translate }}</md-tooltip><i class=\"icon-pencil\" layout=\"center\"></i>\n</md-button><md-button aria-label=\"Trash\" class=\"md-raised md-warn gp-mini\" ng-click=\"vm.removeCategory(category._id)\">\n<md-tooltip aria-label=\"Pencil\">{{ \'GENERAL.HINTS.TRASH\' | translate }}</md-tooltip><i class=\"icon-trash\" \nlayout=\"center\"></i></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Anterior</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Próximo\n</md-button><md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" \nng-if=\"MsStepper.isLastStep()\" ng-disabled=\"!MsStepper.isFormValid()\">Salvar</md-button></div></div>");
$templateCache.put("app/main/settings/finance/card/card.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">Financeiro</span></div><div class=\"title\">Cartão de crédito/débito</div></div></div><div \nclass=\"content\" layout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" \nclass=\"md-inline-form\" ng-submit=\"vm.saveCard()\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container\n flex><md-checkbox name=\"active\" ng-model=\"vm.card.active\">Ativo</md-checkbox></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Adquirente</label><md-select name=\"adquirente\" \nng-model=\"vm.card.adquirenteId\" disabled=\"\"><md-option ng-value=\"item.ADQU_CD_ADQUIRENTE\" \nng-repeat=\"item in vm.adquirentes\">{{item.ADQU_TX_NAME}}</md-option></md-select></md-input-container>\n<md-input-container flex><label>Bandeira</label><md-select name=\"bandeira\" ng-model=\"vm.card.bandeiraId\" disabled=\"\">\n<md-option ng-value=\"item.BAND_CD_BANDEIRA\" ng-repeat=\"item in vm.bandeiras\">{{item.BAND_TX_BANDEIRA}}</md-option>\n</md-select></md-input-container><md-input-container flex><label>Conta corrente</label><md-select name=\"bankAccount\" \nng-model=\"vm.card.bankAccountId\"><md-option ng-value=\"item.BAAC_CD_BANK_ACCOUNT\" ng-repeat=\"item in vm.bankAccounts\">\n{{item.BANK_TX_NAME}} ({{item.BAAC_TX_AGENCIA}} | {{item.BAAC_TX_CONTA}})</md-option></md-select></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Tx. de crédito</label><input \ntype=\"number\" name=\"txCredito\" ng-model=\"vm.card.txCredito\" required min=\"0.01\" max=\"100\" step=\"0.01\"><div \nng-messages=\"basicForm.txCredito.$error\" role=\"alert\"><div ng-message=\"required\"><span>Taxa de crédito é obrigatória\n</span></div></div></md-input-container><md-input-container flex><label>Liquidação de crédito</label><input \ntype=\"number\" name=\"diasCredito\" ng-model=\"vm.card.diasCredito\" required min=\"0\" max=\"100\" step=\"1\"><div \nng-messages=\"basicForm.diasCredito.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nNúmero de dias para liquidação é obrigatório</span></div></div></md-input-container><md-input-container flex><label>\nTx. de debito</label><input type=\"number\" name=\"txDebito\" ng-model=\"vm.card.txDebito\" required min=\"0.01\" max=\"100\" \nstep=\"0.01\"><div ng-messages=\"basicForm.txDebito.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nTaxa de débito é obrigatória</span></div></div></md-input-container><md-input-container flex><label>\nLiquidação de débito</label><input type=\"number\" name=\"diasDebito\" ng-model=\"vm.card.diasDebito\" required min=\"0\" \nmax=\"100\" step=\"1\"><div ng-messages=\"basicForm.diasDebito.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nNúmero de dias para liquidação é obrigatório</span></div></div></md-input-container></div><md-button type=\"submit\" \nclass=\"md-raised\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">{{ \'GENERAL.BUTTON.SAVE\' | translate }}\n</md-button><md-button type=\"button\" class=\"md-raised md-warn\" aria-label=\"Cancel\" \nui-sref=\"app.settings.finance.card.list\">{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/settings/finance/card/list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">Financeiro</span></div><div class=\"title\">Cartões de Crédito e Débito</div></div><div \nlayout=\"row\" layout-align=\"start center\"></div></div><div class=\"content\"><div class=\"white-bg md-whiteframe-40dp\" \nlayout=\"row\" layout-align=\"center center\" height=\"100px\" ng-show=\"!vm.showTable\"><br><span \nstyle=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></div><div class=\"white-bg md-whiteframe-4dp\" \nng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \ndt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Ativo</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Operadora</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Bandeira</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">TX Credito</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Liq crédito</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">TX Debito</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Liq debito</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Conta bancária</span></div></th><th></th></tr></thead><tbody><tr ng-repeat=\"card in ::vm.cards\">\n<td ng-if=\"card.PDVA_BL_ACTIVE==1\">Ativo</td><td ng-if=\"card.PDVA_BL_ACTIVE==0\">Inativo</td><td>{{ card.ADQU_TX_NAME }}\n</td><td>{{ card.BAND_TX_BANDEIRA }}</td><td>{{ card.PDVA_NR_CREDIT_TAX }}%</td><td>{{ card.PDVA_NR_CREDIT_TIME }} dias\n</td><td>{{ card.PDVA_NR_DEBIT_TAX }}%</td><td>{{ card.PDVA_NR_DEBIT_TIME }} dias</td><td>{{ card.BANK_TX_NAME }}</td>\n<td align=\"right\"><md-button aria-label=\"Pencil\" class=\"md-raised gp-mini\" \nng-click=\"vm.editCard(card.PDVA_CD_PDV_ADQUIRENTE)\"><md-tooltip aria-label=\"Pencil\">\n{{ \'GENERAL.HINTS.EDIT\' | translate }}</md-tooltip><i class=\"icon-pencil\" layout=\"center\"></i></md-button></td></tr>\n</tbody></table></div></div></div>");
$templateCache.put("app/main/settings/finance/supplier/list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">Financeiro</span></div><div class=\"title\">Fornecedores</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised\" \nui-sref=\"app.settings.finance.supplier.new\">Novo Fornecedor</md-button></div></div></div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-40dp\" layout=\"row\" layout-align=\"center center\" height=\"100px\" ng-show=\"!vm.showTable\">\n<br><span style=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></div><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Nome</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">CNPJ</span></div></th><th></th></tr></thead><tbody><tr \nng-repeat=\"supplier in ::vm.suppliers\"><td>{{ supplier.SUPP_TX_NAME }}</td><td>{{ supplier.SUPP_TX_CNPJ }}</td><td \nalign=\"right\"><md-button aria-label=\"Pencil\" class=\"md-raised gp-mini\" \nng-click=\"vm.editSupplier(supplier.SUPP_CD_SUPPLIER)\"><md-tooltip aria-label=\"Pencil\">\n{{ \'GENERAL.HINTS.EDIT\' | translate }}</md-tooltip><i class=\"icon-pencil\" layout=\"center\"></i></md-button><md-button \naria-label=\"Trash\" class=\"md-raised md-warn gp-mini\" ng-if=\"vm.allowRemove\" \nng-click=\"vm.removeSupplier(supplier.SUPP_CD_SUPPLIER)\"><md-tooltip aria-label=\"Pencil\">\n{{ \'GENERAL.HINTS.TRASH\' | translate }}</md-tooltip><i class=\"icon-trash\" layout=\"center\"></i></md-button></td></tr>\n</tbody></table></div></div></div>");
$templateCache.put("app/main/settings/finance/supplier/supplier.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">Financeiro</span></div><div class=\"title\">Fornecedor</div></div></div><div class=\"content\" \nlayout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" \nng-submit=\"vm.saveSupplier()\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Nome\n</label><input type=\"text\" name=\"name\" ng-model=\"vm.supplier.name\" required><div ng-messages=\"basicForm.name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Nome do fornecedor é obrigatório</span></div></div></md-input-container>\n<md-input-container flex><label>CNPJ</label><input type=\"text\" name=\"cnpj\" ng-model=\"vm.supplier.cnpj\">\n</md-input-container></div><md-button type=\"submit\" class=\"md-raised\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid\">{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button><md-button type=\"button\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\" ui-sref=\"app.settings.finance.supplier.list\">\n{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/settings/service/category/category.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'SETTINGS.SERVICE.HEADER\' | translate }}</span></div><div class=\"title\">\n{{ \'SETTINGS.SERVICE.CATEGORY.HEADER\' | translate }}</div></div></div><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" \nng-submit=\"vm.saveCategory(false)\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"SETTINGS.SERVICE.CATEGORY.FIELDS.NAME\"></label><input type=\"text\" name=\"name\" ng-model=\"vm.category.name\" \nrequired><div ng-messages=\"basicForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'SETTINGS.SERVICE.CATEGORY.VALIDATION.NAME_REQUIRED\' | translate }}</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"SETTINGS.SERVICE.CATEGORY.FIELDS.ORDER\"></label><input type=\"number\" \nname=\"order\" ng-model=\"vm.category.order\"> <span style=\"font-size: 11px\">\n{{ \'SETTINGS.SERVICE.CATEGORY.HINTS.ORDER\' | translate }}</span></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"SETTINGS.SERVICE.CATEGORY.FIELDS.FIXEDCOST\"></label>\n<input type=\"number\" name=\"order\" ng-model=\"vm.category.fixedCost\"> <span style=\"font-size: 11px\">\n{{ \'SETTINGS.SERVICE.CATEGORY.HINTS.FIXEDCOST\' | translate }}</span></md-input-container></div><md-button \ntype=\"submit\" class=\"md-raised\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">\n{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button><md-button type=\"button\" class=\"md-raised md-warn\" \naria-label=\"Cancel\" ui-sref=\"app.settings.service.category.list\">{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button>\n</form></div></div></div>");
$templateCache.put("app/main/settings/service/category/categoryDialog.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"content\" layout=\"column\"><div\n class=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" \nng-submit=\"vm.saveCategory(true)\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"SETTINGS.SERVICE.CATEGORY.FIELDS.NAME\"></label><input type=\"text\" name=\"name\" ng-model=\"vm.category.name\" \nrequired><div ng-messages=\"basicForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'SETTINGS.SERVICE.CATEGORY.VALIDATION.NAME_REQUIRED\' | translate }}</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"SETTINGS.SERVICE.CATEGORY.FIELDS.ORDER\"></label><input type=\"number\" \nname=\"order\" ng-model=\"vm.category.order\"> <span style=\"font-size: 11px\">\n{{ \'SETTINGS.SERVICE.CATEGORY.HINTS.ORDER\' | translate }}</span></md-input-container></div><md-button type=\"submit\" \nclass=\"md-accent\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">{{ \'GENERAL.BUTTON.SAVE\' | translate }}\n</md-button><md-button type=\"button\" class=\"md-warn\" aria-label=\"Cancel\" ng-click=\"vm.closeDialog();\">\n{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/settings/service/category/list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'SETTINGS.SERVICE.HEADER\' | translate }}</span></div><div class=\"title\">\n{{ \'SETTINGS.SERVICE.CATEGORY.HEADER\' | translate }}</div></div><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-raised\" ui-sref=\"app.settings.service.category.new\">\n{{ \'SETTINGS.SERVICE.CATEGORY.NEW\' | translate }}</md-button></div></div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-40dp\" layout=\"row\" layout-align=\"center center\" height=\"100px\" ng-show=\"!vm.showTable\">\n<br><span style=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></div><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'SETTINGS.SERVICE.CATEGORY.NAME\' | translate }}</span></div></th>\n<th></th></tr></thead><tbody><tr ng-repeat=\"category in ::vm.categories\"><td>{{ category.name }}</td><td align=\"right\">\n<md-button aria-label=\"Pencil\" class=\"md-raised gp-mini\" ng-click=\"vm.editCategory(category._id)\"><md-tooltip \naria-label=\"Pencil\">{{ \'GENERAL.HINTS.EDIT\' | translate }}</md-tooltip><i class=\"icon-pencil\" layout=\"center\"></i>\n</md-button><md-button aria-label=\"Trash\" class=\"md-raised md-warn gp-mini\" ng-click=\"vm.removeCategory(category._id)\">\n<md-tooltip aria-label=\"Pencil\">{{ \'GENERAL.HINTS.TRASH\' | translate }}</md-tooltip><i class=\"icon-trash\" \nlayout=\"center\"></i></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/settings/finance/bankaccount/bankaccount.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">Financeiro</span></div><div class=\"title\">Conta Bancária</div></div></div><div class=\"content\" \nlayout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" \nng-submit=\"vm.saveBankAccount()\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>\nBanco</label><md-select name=\"bank\" ng-model=\"vm.bankaccount.bankId\" ng-disabled=\"!vm.allowEdit\"><md-option \nng-value=\"item.BANK_CD_BANK\" ng-repeat=\"item in vm.banks\">{{item.BANK_TX_NAME}}</md-option></md-select>\n</md-input-container><md-input-container flex><label>Saldo Inicial</label><input type=\"number\" name=\"balance\" \nng-model=\"vm.bankaccount.balance\" required><div ng-messages=\"basicForm.balance.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Saldo inicial é obrigatório</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Agencia</label><input type=\"text\" name=\"agencia\" \nng-model=\"vm.bankaccount.agencia\" required ng-disabled=\"!vm.allowEdit\"><div ng-messages=\"basicForm.agencia.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Númmero de agência é obrigatório</span></div></div></md-input-container>\n<md-input-container flex><label>Digito</label><input type=\"text\" name=\"digitoAgencia\" \nng-model=\"vm.bankaccount.digitoAgencia\" ng-disabled=\"!vm.allowEdit\"></md-input-container><md-input-container flex>\n<label>Conta corrente</label><input type=\"text\" name=\"contaCorrente\" ng-model=\"vm.bankaccount.contaCorrente\" required \nng-disabled=\"!vm.allowEdit\"><div ng-messages=\"basicForm.contaCorrente.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Conta corrente é obrigatória</span></div></div></md-input-container><md-input-container flex><label>Digito\n</label><input type=\"text\" name=\"digitoContaCorrente\" ng-model=\"vm.bankaccount.digitoContaCorrente\" \nng-disabled=\"!vm.allowEdit\"></md-input-container></div><md-button type=\"submit\" class=\"md-raised\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid\">{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button><md-button type=\"button\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\" ui-sref=\"app.settings.finance.bankaccount.list\">\n{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/settings/finance/bankaccount/list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">Financeiro</span></div><div class=\"title\">Contas Bancárias</div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-raised\" ui-sref=\"app.settings.finance.bankaccount.new\">\nNova conta bancária</md-button></div></div><div class=\"content\"><div class=\"white-bg md-whiteframe-40dp\" layout=\"row\" \nlayout-align=\"center center\" height=\"100px\" ng-show=\"!vm.showTable\"><br><span \nstyle=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></div><div class=\"white-bg md-whiteframe-4dp\" \nng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \ndt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Banco</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Agencia</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Conta</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Saldo Inicial</span></div></th><th></th></tr></thead><tbody><tr \nng-repeat=\"bankaccount in ::vm.bankAccounts\"><td>{{ bankaccount.BANK_TX_NAME }}</td><td \nng-if=\"bankaccount.BANK_CD_BANK != 0\">{{ bankaccount.BAAC_TX_AGENCIA }}</td><td ng-if=\"bankaccount.BANK_CD_BANK == 0\">-\n</td><td ng-if=\"bankaccount.BANK_CD_BANK != 0\">{{ bankaccount.BAAC_TX_CONTA }}</td><td \nng-if=\"bankaccount.BANK_CD_BANK == 0\">-</td><td>{{bankaccount.BAAC_NR_INITIAL_BALANCE | currency:\"R$ \"}}</td><td \nalign=\"right\"><md-button aria-label=\"Pencil\" class=\"md-raised gp-mini\" \nng-click=\"vm.editBankAccount(bankaccount.BAAC_CD_BANK_ACCOUNT)\"><md-tooltip aria-label=\"Pencil\">\n{{ \'GENERAL.HINTS.EDIT\' | translate }}</md-tooltip><i class=\"icon-pencil\" layout=\"center\"></i></md-button><md-button \naria-label=\"Trash\" ng-if=\"bankaccount.BANK_CD_BANK != 0  && vm.allowEdit\" class=\"md-raised md-warn gp-mini\" \nng-click=\"vm.removeBankAccount(bankaccount.BAAC_CD_BANK_ACCOUNT)\"><md-tooltip aria-label=\"Pencil\">\n{{ \'GENERAL.HINTS.TRASH\' | translate }}</md-tooltip><i class=\"icon-trash\" layout=\"center\"></i></md-button></td></tr>\n</tbody></table></div></div></div>");
$templateCache.put("app/main/settings/finance/category/list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">Financeiro</span></div><div class=\"title\">Categorias (Plano de conta)</div></div><div \nlayout=\"row\" layout-align=\"start center\"></div></div><div class=\"content\"><div class=\"white-bg md-whiteframe-40dp\" \nlayout=\"row\" layout-align=\"center center\" height=\"100px\" ng-show=\"!vm.showTable\"><br><span \nstyle=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></div><div class=\"white-bg md-whiteframe-4dp\" \nng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" \ndt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Grupo</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Nome</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Entrada/Saída</span></div></th><th></th></tr></thead><tbody><tr \nng-repeat=\"category in ::vm.categories\"><td>{{ category.FICA_IN_GRUPO }}</td><td>{{ category.FICA_TX_NAME }}</td><td \nng-if=\"category.FICA_IN_ENTRADASAIDA == 1\">Entrada</td><td ng-if=\"category.FICA_IN_ENTRADASAIDA == -1\">Saída</td><td \nalign=\"right\"></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/settings/finance/partner/list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">Financeiro</span></div><div class=\"title\">Sócios</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-raised\" \nui-sref=\"app.settings.finance.partner.new\">Novo Sócio</md-button></div></div></div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-40dp\" layout=\"row\" layout-align=\"center center\" height=\"100px\" ng-show=\"!vm.showTable\">\n<br><span style=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></div><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Nome</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">CPF</span></div></th><th></th></tr></thead><tbody><tr \nng-repeat=\"partner in ::vm.partners\"><td>{{ partner.PART_TX_NAME }}</td><td>{{ partner.PART_TX_CPF }}</td><td \nalign=\"right\"><md-button aria-label=\"Pencil\" class=\"md-raised gp-mini\" \nng-click=\"vm.editPartner(partner.PART_CD_PARTNER)\"><md-tooltip aria-label=\"Pencil\">\n{{ \'GENERAL.HINTS.EDIT\' | translate }}</md-tooltip><i class=\"icon-pencil\" layout=\"center\"></i></md-button><md-button \naria-label=\"Trash\" class=\"md-raised md-warn gp-mini\" ng-if=\"vm.allowRemove\" \nng-click=\"vm.removePartner(partner.PART_CD_PARTNER)\"><md-tooltip aria-label=\"Pencil\">\n{{ \'GENERAL.HINTS.TRASH\' | translate }}</md-tooltip><i class=\"icon-trash\" layout=\"center\"></i></md-button></td></tr>\n</tbody></table></div></div></div>");
$templateCache.put("app/main/settings/finance/partner/partner.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">Financeiro</span></div><div class=\"title\">Sócio</div></div></div><div class=\"content\" \nlayout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" \nng-submit=\"vm.savePartner()\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Nome\n</label><input type=\"text\" name=\"name\" ng-model=\"vm.partner.name\" required><div ng-messages=\"basicForm.name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Nome do sócio é obrigatório</span></div></div></md-input-container>\n<md-input-container flex><label>CPF</label><input type=\"text\" name=\"cpf\" ng-model=\"vm.partner.cpf\">\n</md-input-container></div><md-button type=\"submit\" class=\"md-raised\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid\">{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button><md-button type=\"button\" \nclass=\"md-raised md-warn\" aria-label=\"Cancel\" ui-sref=\"app.settings.finance.partner.list\">\n{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/settings/service/priceTable/list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'SETTINGS.SERVICE.HEADER\' | translate }}</span></div><div class=\"title\">\n{{ \'SETTINGS.SERVICE.PRICE_TABLE.HEADER\' | translate }}</div></div><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-raised\" ui-sref=\"app.settings.service.priceTable.new\">\n{{ \'SETTINGS.SERVICE.PRICE_TABLE.NEW\' | translate }}</md-button></div></div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-40dp\" layout=\"row\" layout-align=\"center center\" height=\"100px\" ng-show=\"!vm.showTable\">\n<br><span style=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></div><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'SETTINGS.SERVICE.PRICE_TABLE.NAME\' | translate }}</span></div></th>\n<th></th></tr></thead><tbody><tr ng-repeat=\"priceTable in ::vm.priceTables\"><td>{{ priceTable.name }}</td><td \nalign=\"right\"><md-button aria-label=\"Pencil\" class=\"md-raised gp-mini\" ng-click=\"vm.editPriceTable(priceTable._id)\">\n<md-tooltip aria-label=\"Pencil\">{{ \'GENERAL.HINTS.EDIT\' | translate }}</md-tooltip><i class=\"icon-pencil\" \nlayout=\"center\"></i></md-button><md-button aria-label=\"Duplicate\" class=\"md-raised gp-mini\" \nng-click=\"vm.duplicatePriceTable(priceTable._id, priceTable.name)\"><md-tooltip aria-label=\"Pencil\">\n{{ \'GENERAL.HINTS.COPY\' | translate }}</md-tooltip><i class=\"icon-content-copy\" layout=\"center\"></i></md-button>\n<md-button aria-label=\"Trash\" class=\"md-raised md-warn gp-mini\" ng-click=\"vm.removePriceTable(priceTable._id)\" \nng-if=\"priceTable.isDefault == 0\"><md-tooltip aria-label=\"Pencil\">{{ \'GENERAL.HINTS.TRASH\' | translate }}</md-tooltip>\n<i class=\"icon-trash\" layout=\"center\"></i></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/settings/service/priceTable/priceTable.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'SETTINGS.SERVICE.HEADER\' | translate }}</span></div><div class=\"title\">\n{{ \'SETTINGS.SERVICE.PRICE_TABLE.HEADER\' | translate }}</div></div></div><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" \nng-submit=\"vm.savePriceTable(false)\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label\n translate=\"SETTINGS.SERVICE.PRICE_TABLE.FIELDS.NAME\"></label><input type=\"text\" name=\"name\" \nng-model=\"vm.priceTable.name\" ng-readonly=\"vm.priceTable.isDefault == 1\"><div ng-messages=\"basicForm.name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{ \'SETTINGS.SERVICE.TABLE_PRICE.VALIDATION.NAME_REQUIRED\' | translate }}\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" ng-repeat=\"item in vm.services\">\n<md-input-container flex><span style=\"font-size:12px\">{{item.fastCode}} - {{item.name}}</span></md-input-container>\n<md-input-container flex><label translate=\"SETTINGS.SERVICE.SERVICE.FIELDS.PRICE\"></label><input type=\"number\" \nname=\"price\" ng-model=\"vm.serviceRows[item._id].price\"></md-input-container><md-input-container flex><label \ntranslate=\"SETTINGS.SERVICE.SERVICE.FIELDS.CASH_PRICE\"></label><input type=\"number\" name=\"cashPrice\" \nng-model=\"vm.serviceRows[item._id].cashPrice\"></md-input-container><md-input-container flex><label \ntranslate=\"SETTINGS.SERVICE.SERVICE.FIELDS.COMISSION_PRICE\"></label><input type=\"number\" name=\"comissionPrice\" \nng-model=\"vm.serviceRows[item._id].comissionPrice\"></md-input-container></div><md-button type=\"submit\" \nclass=\"md-raised\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">{{ \'GENERAL.BUTTON.SAVE\' | translate }}\n</md-button><md-button type=\"button\" class=\"md-raised md-warn\" aria-label=\"Cancel\" \nui-sref=\"app.settings.service.priceTable.list\">{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button></form></div></div>\n</div>");
$templateCache.put("app/main/settings/service/servicePack/list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'SETTINGS.SERVICE.HEADER\' | translate }}</span></div><div class=\"title\">\n{{ \'SETTINGS.SERVICE.SERVICE_PACK.HEADER\' | translate }}</div></div><div layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-raised\" ui-sref=\"app.settings.service.servicePack.new\">\n{{ \'SETTINGS.SERVICE.SERVICE_PACK.NEW\' | translate }}</md-button></div></div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-40dp\" layout=\"row\" layout-align=\"center center\" height=\"100px\" ng-show=\"!vm.showTable\">\n<br><span style=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></div><div \nclass=\"white-bg md-whiteframe-4dp\" ng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptions\" dt-column-defs=\"vm.dtColumnDefs\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'SETTINGS.SERVICE.SERVICE_PACK.NAME\' | translate }}</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'SETTINGS.SERVICE.SERVICE_PACK.PRICE\' | translate }}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'SETTINGS.SERVICE.SERVICE_PACK.CASH_PRICE\' | translate }}</span>\n</div></th><th></th></tr></thead><tbody><tr ng-repeat=\"priceTable in ::vm.priceTables\"><td>{{ priceTable.name }}</td>\n<td>{{ priceTable.price }}</td><td>{{ priceTable.cashPrice }}</td><td align=\"right\"><md-button aria-label=\"Pencil\" \nclass=\"md-raised gp-mini\" ng-click=\"vm.editServicePack(priceTable._id)\"><md-tooltip aria-label=\"Pencil\">\n{{ \'GENERAL.HINTS.EDIT\' | translate }}</md-tooltip><i class=\"icon-pencil\" layout=\"center\"></i></md-button><md-button \naria-label=\"Trash\" class=\"md-raised md-warn gp-mini\" ng-click=\"vm.removeServicePack(priceTable._id)\"><md-tooltip \naria-label=\"Pencil\">{{ \'GENERAL.HINTS.TRASH\' | translate }}</md-tooltip><i class=\"icon-trash\" layout=\"center\"></i>\n</md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/settings/service/servicePack/servicePack.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'SETTINGS.SERVICE.HEADER\' | translate }}</span></div><div class=\"title\">\n{{ \'SETTINGS.SERVICE.SERVICE_PACK.HEADER\' | translate }}</div></div></div><div class=\"content\" layout=\"column\"><div \nclass=\"form-wrapper md-whiteframe-1dp\"><form name=\"basicForm\" class=\"md-inline-form\" \nng-submit=\"vm.saveServicePack(false)\" novalidate><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex>\n<label translate=\"SETTINGS.SERVICE.SERVICE_PACK.FIELDS.NAME\"></label><input type=\"text\" name=\"name\" \nng-model=\"vm.priceTable.name\" required><div ng-messages=\"basicForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{ \'SETTINGS.SERVICE.SERVICE_PACK.VALIDATION.NAME_REQUIRED\' | translate }}</span></div>\n</div></md-input-container><md-input-container flex><label translate=\"SETTINGS.SERVICE.SERVICE_PACK.PRICE\"></label>\n<input type=\"number\" name=\"name\" ng-model=\"vm.priceTable.price\" min=\"0\" required><div \nng-messages=\"basicForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'SETTINGS.SERVICE.SERVICE_PACK.VALIDATION.PRICE_REQUIRED\' | translate }}</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"SETTINGS.SERVICE.SERVICE_PACK.CASH_PRICE\"></label><input type=\"number\" \nname=\"name\" ng-model=\"vm.priceTable.cashPrice\" min=\"0\" required><div ng-messages=\"basicForm.name.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>{{ \'SETTINGS.SERVICE.SERVICE_PACK.VALIDATION.CASH_PRICE_REQUIRED\' | translate }}\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"center center\" \nng-repeat=\"item in vm.services\"><md-checkbox ng-model=\"vm.serviceRows[item._id].enabled\" aria-label=\"Checkbox 1\">\n</md-checkbox><md-input-container flex><span style=\"font-size:12px\">{{item.name}}</span></md-input-container>\n<md-input-container flex><label translate=\"SETTINGS.SERVICE.SERVICE.FIELDS.QUANTITY\"></label><input type=\"number\" \nname=\"quantity\" ng-model=\"vm.serviceRows[item._id].quantity\" min=\"1\" ng-pattern=\"/^[0-9]+$/\" \nng-disabled=\"!vm.serviceRows[item._id].enabled\"></md-input-container><md-input-container flex><label \ntranslate=\"SETTINGS.SERVICE.SERVICE.FIELDS.COMISSION_PRICE\"></label><input type=\"number\" name=\"comissionPrice\" \nng-model=\"vm.serviceRows[item._id].comissionPrice\" min=\"0\" ng-disabled=\"!vm.serviceRows[item._id].enabled\">\n</md-input-container></div><md-button type=\"submit\" class=\"md-raised\" aria-label=\"Submit\" \nng-disabled=\"((basicForm.$invalid) || (vm.isServiceChecked()))\">{{ \'GENERAL.BUTTON.SAVE\' | translate }}</md-button>\n<md-button type=\"button\" class=\"md-raised md-warn\" aria-label=\"Cancel\" ui-sref=\"app.settings.service.servicePack.list\">\n{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/main/settings/service/service/list.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'SETTINGS.SERVICE.HEADER\' | translate }}</span></div><div class=\"title\">\n{{ \'SETTINGS.SERVICE.SERVICE.HEADER\' | translate }}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button\n class=\"md-raised\" ui-sref=\"app.settings.service.service.new\">{{ \'SETTINGS.SERVICE.SERVICE.NEW\' | translate }}\n</md-button><md-button class=\"md-raised gp-mini\" ng-click=\"showHelp(\'service\');\">?<md-tooltip aria-label=\"Pencil\">\nVídeo Explicativo</md-tooltip></md-button></div></div><div class=\"content\"><div class=\"white-bg md-whiteframe-40dp\" \nlayout=\"row\" layout-align=\"center center\" height=\"100px\" ng-show=\"!vm.showTable\"><br><span \nstyle=\"margin-left: 10px;margin-top: 10px\"><b>Carregando...</b></span></div><div class=\"white-bg md-whiteframe-4dp\" \nng-show=\"vm.showTable\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{ \'SETTINGS.SERVICE.SERVICE.NAME\' | translate }}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{ \'SETTINGS.SERVICE.SERVICE.PRICE\' | translate }}</span></div></th>\n<th></th></tr></thead><tbody><tr ng-repeat=\"service in ::vm.services\"><td>{{ service.name }}</td><td>\n{{ service.price }}</td><td align=\"right\"><md-button aria-label=\"Duplicate\" class=\"md-raised gp-mini\" \nng-click=\"vm.duplicateService(service._id)\"><md-tooltip aria-label=\"Duplicate\">\n{{ \'GENERAL.HINTS.DUPLICATE\' | translate }}</md-tooltip><i class=\"icon-content-duplicate\" layout=\"center\"></i>\n</md-button><md-button aria-label=\"Pencil\" class=\"md-raised gp-mini\" ng-click=\"vm.editService(service._id)\"><md-tooltip\n aria-label=\"Pencil\">{{ \'GENERAL.HINTS.EDIT\' | translate }}</md-tooltip><i class=\"icon-pencil\" layout=\"center\"></i>\n</md-button><md-button aria-label=\"Trash\" class=\"md-raised md-warn gp-mini\" ng-click=\"vm.removeService(service._id)\">\n<md-tooltip aria-label=\"Pencil\">{{ \'GENERAL.HINTS.TRASH\' | translate }}</md-tooltip><i class=\"icon-trash\" \nlayout=\"center\"></i></md-button></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/settings/service/service/service.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{ \'SETTINGS.HEADER\' | translate }}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon>\n<span class=\"parent\">{{ \'SETTINGS.SERVICE.HEADER\' | translate }}</span></div><div class=\"title\">\n{{ \'SETTINGS.SERVICE.SERVICE.HEADER\' | translate }}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button\n class=\"md-raised gp-mini\" ng-click=\"showHelp(\'service\');\">?<md-tooltip aria-label=\"Pencil\">Vídeo Explicativo\n</md-tooltip></md-button></div></div><div class=\"content\" layout=\"column\"><div class=\"form-wrapper md-whiteframe-1dp\">\n<form name=\"basicForm\" class=\"md-inline-form\" ng-submit=\"vm.saveService()\" novalidate><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"SETTINGS.SERVICE.SERVICE.FIELDS.NAME\"></label><input \ntype=\"text\" name=\"name\" ng-model=\"vm.service.name\" required><div ng-messages=\"basicForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{ \'SETTINGS.SERVICE.SERVICE.VALIDATION.NAME_REQUIRED\' | translate }}</span></div></div>\n</md-input-container><md-input-container flex><label translate=\"SETTINGS.SERVICE.SERVICE.FIELDS.FAST_CODE\"></label>\n<input type=\"text\" name=\"name\" ng-model=\"vm.service.fastCode\"></md-input-container><md-input-container flex \nclass=\"md-icon-float\"><label translate=\"SETTINGS.SERVICE.SERVICE.FIELDS.CATEGORY\"></label><md-select name=\"category\" \nng-model=\"vm.service.categoryId\" required=\"\"><md-option ng-value=\"item._id\" ng-repeat=\"item in vm.categories\">\n{{item.name}}</md-option></md-select><md-icon class=\"icon-plus-box\" ng-click=\"vm.newCategory()\"><md-tooltip>\nNova categoria</md-tooltip></md-icon><div ng-messages=\"basicForm.category.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{ \'SETTINGS.SERVICE.SERVICE.VALIDATION.CATEGORY_REQUIRED\' | translate }}</span></div>\n</div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"SETTINGS.SERVICE.SERVICE.FIELDS.PRICE\"></label><input type=\"number\" name=\"price\" \nng-model=\"vm.service.price\" required><div ng-messages=\"basicForm.price.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>{{ \'SETTINGS.SERVICE.SERVICE.VALIDATION.PRICE_REQUIRED\' | translate }}</span></div></div></md-input-container>\n<md-input-container><md-button class=\"md-icon-button\" aria-label=\"Help\" flex style=\"margin-left:-20px\"><md-icon \nclass=\"icon-help-circle\"><md-tooltip>{{\'SETTINGS.SERVICE.SERVICE.HINTS.PRICE\' | translate}}</md-tooltip></md-icon>\n</md-button></md-input-container><md-input-container flex><label \ntranslate=\"SETTINGS.SERVICE.SERVICE.FIELDS.CASH_PRICE\"></label><input type=\"number\" name=\"cashPrice\" \nng-model=\"vm.service.cashPrice\"></md-input-container><md-input-container><md-button class=\"md-icon-button\" \naria-label=\"Help\" flex style=\"margin-left:-20px\"><md-icon class=\"icon-help-circle\"><md-tooltip>\n{{\'SETTINGS.SERVICE.SERVICE.HINTS.CASH_PRICE\' | translate}}</md-tooltip></md-icon></md-button></md-input-container>\n<md-input-container flex><label translate=\"SETTINGS.SERVICE.SERVICE.FIELDS.COMISSION_PRICE\"></label><input \ntype=\"number\" name=\"comissionPrice\" ng-model=\"vm.service.comissionPrice\" required><div \nng-messages=\"basicForm.comissionPrice.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'SETTINGS.SERVICE.SERVICE.VALIDATION.COMISSION_PRICE_REQUIRED\' | translate }}</span></div></div>\n</md-input-container><md-input-container><md-button class=\"md-icon-button\" aria-label=\"Help\" flex \nstyle=\"margin-left:-20px\"><md-icon class=\"icon-help-circle\"><md-tooltip>\n{{ \'SETTINGS.SERVICE.SERVICE.HINTS.COMISSIONPRICE\' | translate }}</md-tooltip></md-icon></md-button>\n</md-input-container><md-input-container flex><label>Custo de Insumos</label><input type=\"number\" name=\"costInsumo\" \nng-model=\"vm.service.costInsumo\" required><div ng-messages=\"basicForm.costInsumo.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Custo de insumo é obrigatório</span></div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\" ng-if=\"true\"><md-input-container flex><label \ntranslate=\"SETTINGS.SERVICE.SERVICE.FIELDS.LOYALTY_POINTS_EARNED\"></label><input type=\"number\" \nname=\"loyaltyPointsEarned\" ng-model=\"vm.service.loyaltyPointsEarned\" min=\"0\" ng-pattern=\"/^[0-9]+$/\">\n</md-input-container><md-input-container><md-button class=\"md-icon-button\" aria-label=\"Help\" flex \nstyle=\"margin-left:-20px\"><md-icon class=\"icon-help-circle\"><md-tooltip>\n{{ \'SETTINGS.SERVICE.SERVICE.HINTS.LOYALTY_POINTS\' | translate }}</md-tooltip></md-icon></md-button>\n</md-input-container><md-input-container flex><label translate=\"SETTINGS.SERVICE.SERVICE.FIELDS.TIME\"></label>\n<md-select name=\"time\" ng-model=\"vm.service.duration\" required=\"\"><md-option data-value=\"15\">15 minutos</md-option>\n<md-option data-value=\"30\">30 minutos</md-option><md-option data-value=\"45\">45 minutos</md-option><md-option \ndata-value=\"60\">1 hora</md-option><md-option data-value=\"75\">1 hora e 15 minutos</md-option><md-option data-value=\"90\">\n1 hora e 30 minutos</md-option><md-option data-value=\"105\">1 hora e 45 minutos</md-option><md-option data-value=\"120\">\n2 horas</md-option><md-option data-value=\"135\">2 horas e 15 minutos</md-option><md-option data-value=\"150\">\n2 horas e 30 minutos</md-option><md-option data-value=\"165\">2 horas e 45 minutos</md-option><md-option \ndata-value=\"180\">3 horas</md-option><md-option data-value=\"195\">3 horas e 15 minutos</md-option><md-option \ndata-value=\"210\">3 horas e 30 minutos</md-option><md-option data-value=\"225\">3 horas e 45 minutos</md-option><md-option\n data-value=\"240\">4 horas</md-option><md-option data-value=\"255\">4 horas e 15 minutos</md-option><md-option \ndata-value=\"270\">4 horas e 30 minutos</md-option><md-option data-value=\"285\">4 horas e 45 minutos</md-option>\n</md-select><div ng-messages=\"basicForm.time.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'SETTINGS.SERVICE.SERVICE.VALIDATION.TIME_REQUIRED\' | translate }}</span></div></div></md-input-container>\n<md-input-container><md-button class=\"md-icon-button\" aria-label=\"Help\" flex style=\"margin-left:-20px\"><md-icon \nclass=\"icon-help-circle\"><md-tooltip>{{ \'SETTINGS.SERVICE.SERVICE.HINTS.DURATION\' | translate }}</md-tooltip></md-icon>\n</md-button></md-input-container><md-input-container flex><label translate=\"SETTINGS.SERVICE.SERVICE.FIELDS.RETURN\">\n</label><input type=\"number\" name=\"return\" ng-model=\"vm.service.return\" required><div \nng-messages=\"basicForm.return.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'SETTINGS.SERVICE.SERVICE.VALIDATION.RETURN_REQUIRED\' | translate }}</span></div></div></md-input-container>\n<md-input-container><md-button class=\"md-icon-button\" aria-label=\"Help\" style=\"margin-left:-20px\"><md-icon \nclass=\"icon-help-circle\"><md-tooltip>{{ \'SETTINGS.SERVICE.SERVICE.HINTS.RETURN\' | translate }}</md-tooltip></md-icon>\n</md-button></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"true\"><md-input-container flex>\n<md-checkbox name=\"showAtStylePlace\" ng-model=\"vm.service.showAtMobile\"><span style=\"font-size: 11px\">\n{{ \'SETTINGS.SERVICE.SERVICE.FIELDS.SHOW_AT_MOBILE\' | translate }}</span></md-checkbox></md-input-container>\n<md-input-container flex><label translate=\"SETTINGS.SERVICE.SERVICE.FIELDS.MOBILE_NAME\"></label><input type=\"text\" \nmax=\"50\" name=\"mobileServiceName\" ng-model=\"vm.service.mobileServiceName\"> <span style=\"font-size: 11px\">\n{{ \'SETTINGS.SERVICE.SERVICE.HINTS.MOBILE_NAME\' | translate }}</span></md-input-container><md-input-container flex>\n<label>Wowee Venda Mais</label><md-select name=\"woweeVendaMais\" ng-model=\"vm.service.vendaMais\"><md-option \ndata-value=\"MAO\">MAO</md-option><md-option data-value=\"PE\">PE</md-option><md-option data-value=\"ESCOVA\">ESCOVA\n</md-option><md-option data-value=\"CORTE\">CORTE</md-option><md-option data-value=\"COLORACAO\">COLORACAO</md-option>\n<md-option data-value=\"CAUTERIZACAO\">CAUTERIZACAO</md-option><md-option data-value=\"MAQUIAGEM\">MAQUIAGEM</md-option>\n<md-option data-value=\"PROGRESSIVA\">PROGRESSIVA</md-option><md-option data-value=\"DEFINITIVA\">DEFINITIVA</md-option>\n<md-option data-value=\"RECONSTRUCAO\">RECONSTRUCAO</md-option><md-option data-value=\"BOTOX\">BOTOX</md-option><md-option \ndata-value=\"SOBRANCELHA\">SOBRANCELHA</md-option><md-option data-value=\"DEPILACAO\">DEPILACAO</md-option><md-option \ndata-value=\"MASSAGEM\">MASSAGEM</md-option></md-select></md-input-container></div><md-button type=\"submit\" \nclass=\"md-raised\" aria-label=\"Submit\" ng-disabled=\"basicForm.$invalid\">{{ \'GENERAL.BUTTON.SAVE\' | translate }}\n</md-button><md-button ng-if=\"!vm.wizard\" type=\"button\" class=\"md-raised md-warn\" aria-label=\"Cancel\" \nui-sref=\"app.settings.service.service.list\">{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button><md-button \nng-if=\"vm.wizard\" type=\"button\" class=\"md-raised md-warn\" aria-label=\"Cancel\" ui-sref=\"app.wizard\">\n{{ \'GENERAL.BUTTON.CANCEL\' | translate }}</md-button></form></div></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");}]);